/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * Lotus Health
 * OpenAPI spec version: 0.0.0
 */
import * as zod from "zod";

/**
 * @summary Fetch Server Status
 */
export const fetchServerStatusResponse = zod.object({
  available: zod.boolean(),
  note: zod.string(),
});

/**
 * Fetches the default customization block for the user.
 * @summary Fetch Customization Block
 */
export const fetchCustomizationBlockBody = zod.object({});

export const fetchCustomizationBlockResponse = zod.object({
  customization_block: zod.object({}),
});

/**
 * Updates the default customization block for the user.
 * @summary Update Customization Block
 */
export const updateCustomizationBlockBody = zod.object({
  customization_block: zod.object({}),
});

export const updateCustomizationBlockResponse = zod.object({
  customization_block: zod.object({}),
});

/**
 * Resets the default customization block for the user.
 * @summary Reset Customization Block
 */
export const resetCustomizationBlockBody = zod.object({});

export const resetCustomizationBlockResponse = zod.object({});

/**
 * @summary Add Additional Access
 */
export const addAdditionalAccessBody = zod.object({
  token: zod.string(),
});

export const addAdditionalAccessResponse = zod.object({
  message: zod.string(),
});

/**
 * @summary Create Additional Access Token
 */
export const createAdditionalAccessTokenBody = zod.object({
  uses: zod.union([zod.number(), zod.null()]).optional(),
  expiresAt: zod.union([zod.iso.datetime({}), zod.null()]).optional(),
  action: zod.object({
    message: zod.string(),
    add_groups: zod.array(
      zod.enum([
        "lotus_admin",
        "lotus_developer",
        "lotus_test_user",
        "doctor",
        "practitioners",
        "evaluator_bot",
        "banned",
        "any_user",
        "anonymous_user",
        "partially_gated_user",
        "limited_access_user",
        "app_reviewer",
        "full_access_user",
        "invite_loop_group_1",
        "invite_loop_group_2",
        "invite_loop_group_3",
        "skip_service_area_check",
      ]),
    ),
  }),
});

export const createAdditionalAccessTokenResponse = zod.object({
  token: zod.string(),
});

/**
 * @summary Fetch Admin Analytics Summary
 */
export const fetchAdminAnalyticsSummaryQueryParams = zod.object({
  start_time: zod.union([zod.iso.datetime({}), zod.null()]).optional(),
  end_time: zod.union([zod.iso.datetime({}), zod.null()]).optional(),
});

export const fetchAdminAnalyticsSummaryResponse = zod.object({
  startTime: zod.union([zod.iso.datetime({}), zod.null()]),
  endTime: zod.union([zod.iso.datetime({}), zod.null()]),
  totalUsers: zod.number(),
  newUsers: zod.number(),
  onboardedUsers: zod.number(),
  usersWithCompletedInsurance: zod.number(),
  patientsWithOpenRequests: zod.number(),
  openRequests: zod.number(),
  urgentOpenRequests: zod.number(),
  routineOpenRequests: zod.number(),
  requestsResolved: zod.number(),
  careActionsTaken: zod.number(),
  activeClinicians: zod.number(),
  totalKarmaEarned: zod.number(),
});

/**
 * @summary Fetch Cortex Live Operations Summary
 */
export const fetchCortexLiveOperationsSummaryQueryParams = zod.object({
  clinician_id: zod.union([zod.uuid(), zod.null()]).optional(),
  urgency: zod.union([zod.enum(["Routine", "Urgent"]), zod.null()]).optional(),
  practice_area: zod
    .union([zod.enum(["Primary Care", "Psychiatry"]), zod.null()])
    .optional(),
  state: zod.union([zod.string(), zod.null()]).optional(),
  start_time: zod.union([zod.iso.datetime({}), zod.null()]).optional(),
  end_time: zod.union([zod.iso.datetime({}), zod.null()]).optional(),
});

export const fetchCortexLiveOperationsSummaryResponse = zod.object({
  patientsWaiting: zod.number(),
  requestsPendingClinicianAction: zod.number(),
  requestsPendingPatientAction: zod.number(),
  requestsResolved: zod.number(),
  openCareActions: zod.number(),
  averageResolutionSeconds: zod.union([zod.number(), zod.null()]),
  averagePatientsSeenPerClinician: zod.union([zod.number(), zod.null()]),
});

/**
 * @summary Fetch Cortex Live Operations Queue
 */
export const fetchCortexLiveOperationsQueueQueryLimitDefault = 50;
export const fetchCortexLiveOperationsQueueQueryLimitMax = 200;

export const fetchCortexLiveOperationsQueueQueryParams = zod.object({
  limit: zod
    .number()
    .min(1)
    .max(fetchCortexLiveOperationsQueueQueryLimitMax)
    .default(fetchCortexLiveOperationsQueueQueryLimitDefault),
  cursor: zod.union([zod.string(), zod.null()]).optional(),
  urgency: zod.union([zod.enum(["Routine", "Urgent"]), zod.null()]).optional(),
  practice_area: zod
    .union([zod.enum(["Primary Care", "Psychiatry"]), zod.null()])
    .optional(),
  state: zod.union([zod.string(), zod.null()]).optional(),
});

export const fetchCortexLiveOperationsQueueResponse = zod.object({
  rows: zod.array(
    zod.object({
      userId: zod.uuid(),
      patientName: zod.union([zod.string(), zod.null()]),
      state: zod.union([zod.string(), zod.null()]),
      urgentRequests: zod.number(),
      routineRequests: zod.number(),
      followUpsAwaitingResponse: zod.number(),
      oldestOpenRequestCreatedAt: zod.union([zod.iso.datetime({}), zod.null()]),
      lastRequestCreatedAt: zod.union([zod.iso.datetime({}), zod.null()]),
      practiceAreas: zod.array(zod.enum(["Primary Care", "Psychiatry"])),
      originPractices: zod.array(zod.string()),
      lastActivityAt: zod.union([zod.iso.datetime({}), zod.null()]),
    }),
  ),
  nextCursor: zod.union([zod.string(), zod.null()]),
});

/**
 * @summary Fetch Cortex Live Operations Clinicians
 */
export const fetchCortexLiveOperationsCliniciansQueryParams = zod.object({
  clinician_id: zod.union([zod.uuid(), zod.null()]).optional(),
  start_time: zod.union([zod.iso.datetime({}), zod.null()]).optional(),
  end_time: zod.union([zod.iso.datetime({}), zod.null()]).optional(),
});

export const fetchCortexLiveOperationsCliniciansResponse = zod.object({
  rows: zod.array(
    zod.object({
      clinicianId: zod.uuid(),
      displayName: zod.union([zod.string(), zod.null()]),
      email: zod.union([zod.string(), zod.null()]),
      licensedStates: zod.array(zod.string()),
      licensedPracticeAreas: zod.array(zod.string()),
      patientsSeen: zod.number(),
      requestsResolved: zod.number(),
      careActionsTaken: zod.number(),
      lastActivityAt: zod.union([zod.iso.datetime({}), zod.null()]),
    }),
  ),
});

/**
 * @summary Fetch Cortex Economics Summary
 */
export const fetchCortexEconomicsSummaryQueryParams = zod.object({
  clinician_id: zod.union([zod.uuid(), zod.null()]).optional(),
  start_time: zod.union([zod.iso.datetime({}), zod.null()]).optional(),
  end_time: zod.union([zod.iso.datetime({}), zod.null()]).optional(),
});

export const fetchCortexEconomicsSummaryResponse = zod.object({
  activeClinicians: zod.number(),
  totalKarmaEarned: zod.number(),
  totalDollarsEarned: zod.number(),
  totalKarmaPaidOut: zod.number(),
  totalDollarsPaidOut: zod.number(),
  totalKarmaPendingPayout: zod.number(),
  totalDollarsPendingPayout: zod.number(),
  requestsResolved: zod.number(),
  uniquePatientsTreated: zod.number(),
  careActionsTaken: zod.number(),
});

/**
 * @summary Fetch Cortex Economics Clinicians
 */
export const fetchCortexEconomicsCliniciansQueryParams = zod.object({
  clinician_id: zod.union([zod.uuid(), zod.null()]).optional(),
  start_time: zod.union([zod.iso.datetime({}), zod.null()]).optional(),
  end_time: zod.union([zod.iso.datetime({}), zod.null()]).optional(),
});

export const fetchCortexEconomicsCliniciansResponse = zod.object({
  rows: zod.array(
    zod.object({
      clinicianId: zod.uuid(),
      displayName: zod.union([zod.string(), zod.null()]),
      email: zod.union([zod.string(), zod.null()]),
      licensedStates: zod.array(zod.string()),
      licensedPracticeAreas: zod.array(zod.string()),
      karmaEarned: zod.number(),
      dollarsEarned: zod.number(),
      karmaPaidOut: zod.number(),
      dollarsPaidOut: zod.number(),
      karmaPendingPayout: zod.number(),
      dollarsPendingPayout: zod.number(),
      requestsResolved: zod.number(),
      uniquePatientsTreated: zod.number(),
      careActionsTaken: zod.number(),
    }),
  ),
});

/**
 * @summary Fetch Admin Insurance Submissions
 */
export const fetchAdminInsuranceSubmissionsQueryLimitDefault = 50;
export const fetchAdminInsuranceSubmissionsQueryLimitMax = 200;

export const fetchAdminInsuranceSubmissionsQueryParams = zod.object({
  limit: zod
    .number()
    .min(1)
    .max(fetchAdminInsuranceSubmissionsQueryLimitMax)
    .default(fetchAdminInsuranceSubmissionsQueryLimitDefault),
  cursor: zod.union([zod.string(), zod.null()]).optional(),
  completed: zod.union([zod.boolean(), zod.null()]).optional(),
});

export const fetchAdminInsuranceSubmissionsResponse = zod.object({
  rows: zod.array(
    zod.object({
      userId: zod.uuid(),
      createdAt: zod.union([zod.iso.datetime({}), zod.null()]),
      updatedAt: zod.union([zod.iso.datetime({}), zod.null()]),
      patientName: zod.union([zod.string(), zod.null()]),
      completed: zod.boolean(),
      payerName: zod.union([zod.string(), zod.null()]),
      payerCode: zod.union([zod.string(), zod.null()]),
      payerOrigin: zod.union([zod.string(), zod.null()]),
      hasMemberId: zod.boolean(),
      hasGroupId: zod.boolean(),
      memberIdLast4: zod.union([zod.string(), zod.null()]),
      complaints: zod.array(zod.string()),
    }),
  ),
  nextCursor: zod.union([zod.string(), zod.null()]),
});

/**
 * Run insurance discovery against the posted insurance and dossier.

Junction payor lookup skips the Redis/S3 cache so tester results match
live Junction, not a previous name or ID hit for the same code.
 * @summary Discover Insurance
 */
export const discoverInsuranceBodyDossierLogsDefault = [];

export const discoverInsuranceBody = zod.object({
  insurance: zod
    .object({
      payer_code: zod.string(),
      payer_name: zod.string(),
      payer_origin: zod.string(),
      member_id: zod.string(),
      group_id: zod.union([zod.string(), zod.null()]).optional(),
      relationship: zod.enum(["Self", "Spouse", "Other"]).optional(),
      subscriber_first_name: zod.union([zod.string(), zod.null()]).optional(),
      subscriber_last_name: zod.union([zod.string(), zod.null()]).optional(),
      coverage_status: zod
        .union([zod.enum(["active", "inactive"]), zod.null()])
        .optional(),
      coverage_order: zod.union([zod.number(), zod.null()]).optional(),
    })
    .describe(
      "Insurance plan information discovered for a patient.\n\nA single plan is identified by its payer code + member ID.  The\n``payer_origin`` records which system the payer code belongs to\n(stedi, junction, flexpa, …) so we can distinguish them during mapping.\n\n``coverage_status`` is active vs inactive. ``coverage_order`` is the FHIR\nCoverage.order integer (1 = primary, 2 = secondary).\n\nWhen the patient is a dependent on someone else's plan,\n``relationship`` will be ``Spouse`` or ``Other`` and the\n``subscriber_\*`` fields carry the policyholder's identity so we\ncan supply them to Junction as the \*insured\* \/ \*guarantor\*.",
    ),
  dossier: zod
    .union([
      zod.object({
        deductions: zod.array(
          zod.object({
            marker: zod.string(),
            raw_deduction: zod.object({
              detail: zod.unknown(),
              attesters: zod.array(zod.string()),
              certainty: zod
                .enum(["proposed", "historical", "current"])
                .describe(
                  "Certainty level of a deduction.\n\nOrdered from least certain to most certain: Proposed < Historical < Current.",
                ),
            }),
          }),
        ),
        logs: zod
          .array(zod.string())
          .default(discoverInsuranceBodyDossierLogsDefault),
      }),
      zod.null(),
    ])
    .optional(),
});

export const discoverInsuranceResponse = zod.object({
  insured: zod
    .union([
      zod
        .object({
          junction_payor_code: zod.string(),
          original_payor_code: zod
            .union([
              zod
                .object({
                  origin: zod.union([
                    zod
                      .enum(["pverify", "stedi", "junction", "flexpa"])
                      .describe("Which system a payer code originates from."),
                    zod.string(),
                  ]),
                  code: zod.string(),
                  name: zod.string(),
                })
                .describe(
                  "A payer identifier: origin system, code, and human-readable name.",
                ),
              zod.null(),
            ])
            .optional(),
          member_id: zod.string(),
          group_id: zod.union([zod.string(), zod.null()]).optional(),
          insured: zod
            .object({
              first_name: zod.string(),
              last_name: zod.string(),
              dob: zod.iso.date(),
              gender: zod.enum(["Male", "Female", "Unknown"]),
              address: zod
                .object({
                  first_line: zod.string(),
                  second_line: zod.union([zod.string(), zod.null()]).optional(),
                  zip_code: zod.string(),
                  state: zod.string(),
                  city: zod.string(),
                })
                .describe("Address of the insured person."),
              phone_number: zod.union([zod.string(), zod.null()]).optional(),
              email: zod.union([zod.string(), zod.null()]).optional(),
            })
            .describe(
              "Demographic details of the insured person (subscriber).",
            ),
          payor_name: zod.union([zod.string(), zod.null()]).optional(),
          relationship: zod.enum(["Self", "Spouse", "Other"]).optional(),
          subscriber: zod
            .union([
              zod
                .object({
                  first_name: zod.string(),
                  last_name: zod.string(),
                  dob: zod.iso.date(),
                  gender: zod.enum(["Male", "Female", "Unknown"]),
                  address: zod
                    .object({
                      first_line: zod.string(),
                      second_line: zod
                        .union([zod.string(), zod.null()])
                        .optional(),
                      zip_code: zod.string(),
                      state: zod.string(),
                      city: zod.string(),
                    })
                    .describe("Address of the insured person."),
                  phone_number: zod
                    .union([zod.string(), zod.null()])
                    .optional(),
                  email: zod.union([zod.string(), zod.null()]).optional(),
                })
                .describe(
                  "Demographic details of the insured person (subscriber).",
                ),
              zod.null(),
            ])
            .optional(),
        })
        .describe(
          "Full insurance information discovered for a patient.\n\nFor self-insured plans ``relationship`` is ``SELF`` and ``subscriber``\nis ``None`` – the patient \*is\* the policyholder.\n\nFor dependent plans (Spouse \/ Other) ``subscriber`` carries the\npolicyholder's demographics so we can send them to Junction as the\n\*insured\* and \*guarantor\*.",
        ),
      zod.null(),
    ])
    .optional(),
  error: zod.union([zod.string(), zod.null()]).optional(),
});

/**
 * Get the PHR v2 materialized tables (semantics and consolidation stages) for a patient.
 * @summary Get Admin Phr V2
 */
export const getAdminPhrV2Params = zod.object({
  user_id: zod.uuid(),
});

export const getAdminPhrV2Response = zod.object({
  consolidation: zod.union([
    zod.array(
      zod.object({
        tableId: zod.string(),
        rows: zod.array(zod.record(zod.string(), zod.unknown())),
      }),
    ),
    zod.null(),
  ]),
  semantics: zod.union([
    zod.array(
      zod.object({
        tableId: zod.string(),
        rows: zod.array(zod.record(zod.string(), zod.unknown())),
      }),
    ),
    zod.null(),
  ]),
});

/**
 * Force a real Metriport network query for the requested patient.

Schedules a Sync V2 Metriport flight that will run a network query rather
than an abridged refresh, even for a patient inside the freshness window.
The reply reports what was observed at scheduling time only.
 * @summary Force Metriport Network Query
 */
export const forceMetriportNetworkQueryBody = zod.object({
  userId: zod.uuid(),
  triggeredBy: zod
    .enum([
      "signup",
      "profile_change",
      "verification_completed",
      "adt_webhook",
      "manual_retry",
      "automatic_retry",
      "backfill",
      "developer_initial_sync",
    ])
    .optional()
    .describe("Durable reason a provider flight was requested."),
});

export const forceMetriportNetworkQueryResponse = zod.object({
  scheduledProvider: zod
    .enum(["metriport", "flexpa", "smart_on_fhir"])
    .describe("External provider families supported by Sync V2 flights."),
  scheduledTriggeredBy: zod.union([
    zod
      .enum([
        "signup",
        "profile_change",
        "verification_completed",
        "adt_webhook",
        "manual_retry",
        "automatic_retry",
        "backfill",
        "developer_initial_sync",
      ])
      .describe("Durable reason a provider flight was requested."),
    zod.null(),
  ]),
  networkQueryAlreadyInFlight: zod.boolean(),
  flightAlreadyQueued: zod.boolean(),
});

/**
 * @summary Submit Native Application
 */
export const submitNativeApplicationBody = zod.object({
  display_name: zod.string(),
  email: zod.string(),
  phone_number: zod.union([zod.string(), zod.null()]).optional(),
  referral_source: zod.union([zod.string(), zod.null()]).optional(),
  referral_person_name: zod.union([zod.string(), zod.null()]).optional(),
  resume_file_id: zod.union([zod.uuid(), zod.null()]).optional(),
  medical_school: zod.union([zod.string(), zod.null()]).optional(),
  degree: zod.union([zod.string(), zod.null()]).optional(),
  residency: zod.union([zod.string(), zod.null()]).optional(),
  fellowships: zod.union([zod.string(), zod.null()]).optional(),
  specialty: zod.union([zod.string(), zod.null()]).optional(),
  npi_number: zod.union([zod.string(), zod.null()]).optional(),
  licensed_states: zod.union([zod.array(zod.string()), zod.null()]).optional(),
  board_certified: zod.union([zod.boolean(), zod.null()]).optional(),
});

export const submitNativeApplicationResponseTypeDefault = "success";
export const submitNativeApplicationResponseTypeDefaultOne = "failure";

export const submitNativeApplicationResponse = zod.union([
  zod.object({
    type: zod
      .literal("success")
      .default(submitNativeApplicationResponseTypeDefault),
    status: zod.enum([
      "pending",
      "screening_passed",
      "credentialing_pending",
      "hired",
      "rejected",
      "archived",
    ]),
  }),
  zod.object({
    type: zod
      .literal("failure")
      .default(submitNativeApplicationResponseTypeDefaultOne),
    reason: zod.string(),
    details: zod.string(),
  }),
]);

/**
 * @summary Submit Credentialing
 */
export const submitCredentialingBody = zod.object({
  mailing_address_street: zod.string(),
  mailing_address_city: zod.string(),
  mailing_address_state: zod.string(),
  mailing_address_zip: zod.string(),
  date_of_birth: zod.iso.date(),
  headshot_file_id: zod.union([zod.uuid(), zod.null()]).optional(),
  application_data: zod
    .object({
      attestation_professional_liability: zod
        .union([
          zod.object({
            answers: zod.array(zod.boolean()),
            explanation: zod.union([zod.string(), zod.null()]).optional(),
          }),
          zod.null(),
        ])
        .optional(),
      attestation_physical_mental_health: zod
        .union([
          zod.object({
            answers: zod.array(zod.boolean()),
            explanation: zod.union([zod.string(), zod.null()]).optional(),
          }),
          zod.null(),
        ])
        .optional(),
      attestation_disciplinary_license_dea: zod
        .union([
          zod.object({
            answers: zod.array(zod.boolean()),
            explanation: zod.union([zod.string(), zod.null()]).optional(),
          }),
          zod.null(),
        ])
        .optional(),
      attestation_disciplinary_membership: zod
        .union([
          zod.object({
            answers: zod.array(zod.boolean()),
            explanation: zod.union([zod.string(), zod.null()]).optional(),
          }),
          zod.null(),
        ])
        .optional(),
      attestation_compliance_with_laws: zod
        .union([
          zod.object({
            answers: zod.array(zod.boolean()),
            explanation: zod.union([zod.string(), zod.null()]).optional(),
          }),
          zod.null(),
        ])
        .optional(),
    })
    .describe(
      "Screening attestation data stored in JSONB — not promoted to employee_records.",
    ),
});

export const submitCredentialingResponseTypeDefault = "success";
export const submitCredentialingResponseTypeDefaultOne = "failure";

export const submitCredentialingResponse = zod.union([
  zod.object({
    type: zod
      .literal("success")
      .default(submitCredentialingResponseTypeDefault),
    status: zod.enum([
      "pending",
      "screening_passed",
      "credentialing_pending",
      "hired",
      "rejected",
      "archived",
    ]),
  }),
  zod.object({
    type: zod
      .literal("failure")
      .default(submitCredentialingResponseTypeDefaultOne),
    reason: zod.string(),
    details: zod.string(),
  }),
]);

/**
 * @summary Fetch Clinician Applications Admin
 */
export const fetchClinicianApplicationsAdminResponse = zod.object({
  applications: zod.array(
    zod.object({
      id: zod.uuid(),
      user_id: zod.uuid(),
      ashby_application_id: zod.union([zod.string(), zod.null()]),
      ashby_candidate_id: zod.union([zod.string(), zod.null()]),
      job_posting_id: zod.string(),
      status: zod.enum([
        "pending",
        "screening_passed",
        "credentialing_pending",
        "hired",
        "rejected",
        "archived",
      ]),
      display_name: zod.union([zod.string(), zod.null()]).optional(),
      email: zod.union([zod.string(), zod.null()]).optional(),
      phone_number: zod.union([zod.string(), zod.null()]).optional(),
      referral_source: zod.union([zod.string(), zod.null()]).optional(),
      referral_person_name: zod.union([zod.string(), zod.null()]).optional(),
      resume_file_id: zod.union([zod.uuid(), zod.null()]).optional(),
      medical_school: zod.union([zod.string(), zod.null()]).optional(),
      degree: zod.union([zod.string(), zod.null()]).optional(),
      residency: zod.union([zod.string(), zod.null()]).optional(),
      fellowships: zod.union([zod.string(), zod.null()]).optional(),
      specialty: zod.union([zod.string(), zod.null()]).optional(),
      npi_number: zod.union([zod.string(), zod.null()]).optional(),
      licensed_states: zod
        .union([zod.array(zod.string()), zod.null()])
        .optional(),
      board_certified: zod.union([zod.boolean(), zod.null()]).optional(),
      mailing_address_street: zod.union([zod.string(), zod.null()]).optional(),
      mailing_address_city: zod.union([zod.string(), zod.null()]).optional(),
      mailing_address_state: zod.union([zod.string(), zod.null()]).optional(),
      mailing_address_zip: zod.union([zod.string(), zod.null()]).optional(),
      date_of_birth: zod.union([zod.iso.date(), zod.null()]).optional(),
      headshot_file_id: zod.union([zod.uuid(), zod.null()]).optional(),
      application_data: zod
        .union([
          zod
            .object({
              attestation_professional_liability: zod
                .union([
                  zod.object({
                    answers: zod.array(zod.boolean()),
                    explanation: zod
                      .union([zod.string(), zod.null()])
                      .optional(),
                  }),
                  zod.null(),
                ])
                .optional(),
              attestation_physical_mental_health: zod
                .union([
                  zod.object({
                    answers: zod.array(zod.boolean()),
                    explanation: zod
                      .union([zod.string(), zod.null()])
                      .optional(),
                  }),
                  zod.null(),
                ])
                .optional(),
              attestation_disciplinary_license_dea: zod
                .union([
                  zod.object({
                    answers: zod.array(zod.boolean()),
                    explanation: zod
                      .union([zod.string(), zod.null()])
                      .optional(),
                  }),
                  zod.null(),
                ])
                .optional(),
              attestation_disciplinary_membership: zod
                .union([
                  zod.object({
                    answers: zod.array(zod.boolean()),
                    explanation: zod
                      .union([zod.string(), zod.null()])
                      .optional(),
                  }),
                  zod.null(),
                ])
                .optional(),
              attestation_compliance_with_laws: zod
                .union([
                  zod.object({
                    answers: zod.array(zod.boolean()),
                    explanation: zod
                      .union([zod.string(), zod.null()])
                      .optional(),
                  }),
                  zod.null(),
                ])
                .optional(),
            })
            .describe(
              "Screening attestation data stored in JSONB — not promoted to employee_records.",
            ),
          zod.null(),
        ])
        .optional(),
      created_at: zod.iso.datetime({}),
      updated_at: zod.iso.datetime({}),
    }),
  ),
});

/**
 * @summary Update Clinician Application Admin
 */
export const updateClinicianApplicationAdminParams = zod.object({
  application_id: zod.uuid(),
});

export const updateClinicianApplicationAdminBody = zod.object({
  id: zod.uuid(),
  user_id: zod.uuid(),
  ashby_application_id: zod.union([zod.string(), zod.null()]),
  ashby_candidate_id: zod.union([zod.string(), zod.null()]),
  job_posting_id: zod.string(),
  status: zod.enum([
    "pending",
    "screening_passed",
    "credentialing_pending",
    "hired",
    "rejected",
    "archived",
  ]),
  display_name: zod.union([zod.string(), zod.null()]).optional(),
  email: zod.union([zod.string(), zod.null()]).optional(),
  phone_number: zod.union([zod.string(), zod.null()]).optional(),
  referral_source: zod.union([zod.string(), zod.null()]).optional(),
  referral_person_name: zod.union([zod.string(), zod.null()]).optional(),
  resume_file_id: zod.union([zod.uuid(), zod.null()]).optional(),
  medical_school: zod.union([zod.string(), zod.null()]).optional(),
  degree: zod.union([zod.string(), zod.null()]).optional(),
  residency: zod.union([zod.string(), zod.null()]).optional(),
  fellowships: zod.union([zod.string(), zod.null()]).optional(),
  specialty: zod.union([zod.string(), zod.null()]).optional(),
  npi_number: zod.union([zod.string(), zod.null()]).optional(),
  licensed_states: zod.union([zod.array(zod.string()), zod.null()]).optional(),
  board_certified: zod.union([zod.boolean(), zod.null()]).optional(),
  mailing_address_street: zod.union([zod.string(), zod.null()]).optional(),
  mailing_address_city: zod.union([zod.string(), zod.null()]).optional(),
  mailing_address_state: zod.union([zod.string(), zod.null()]).optional(),
  mailing_address_zip: zod.union([zod.string(), zod.null()]).optional(),
  date_of_birth: zod.union([zod.iso.date(), zod.null()]).optional(),
  headshot_file_id: zod.union([zod.uuid(), zod.null()]).optional(),
  application_data: zod
    .union([
      zod
        .object({
          attestation_professional_liability: zod
            .union([
              zod.object({
                answers: zod.array(zod.boolean()),
                explanation: zod.union([zod.string(), zod.null()]).optional(),
              }),
              zod.null(),
            ])
            .optional(),
          attestation_physical_mental_health: zod
            .union([
              zod.object({
                answers: zod.array(zod.boolean()),
                explanation: zod.union([zod.string(), zod.null()]).optional(),
              }),
              zod.null(),
            ])
            .optional(),
          attestation_disciplinary_license_dea: zod
            .union([
              zod.object({
                answers: zod.array(zod.boolean()),
                explanation: zod.union([zod.string(), zod.null()]).optional(),
              }),
              zod.null(),
            ])
            .optional(),
          attestation_disciplinary_membership: zod
            .union([
              zod.object({
                answers: zod.array(zod.boolean()),
                explanation: zod.union([zod.string(), zod.null()]).optional(),
              }),
              zod.null(),
            ])
            .optional(),
          attestation_compliance_with_laws: zod
            .union([
              zod.object({
                answers: zod.array(zod.boolean()),
                explanation: zod.union([zod.string(), zod.null()]).optional(),
              }),
              zod.null(),
            ])
            .optional(),
        })
        .describe(
          "Screening attestation data stored in JSONB — not promoted to employee_records.",
        ),
      zod.null(),
    ])
    .optional(),
  created_at: zod.iso.datetime({}),
  updated_at: zod.iso.datetime({}),
});

export const updateClinicianApplicationAdminResponse = zod.object({
  id: zod.uuid(),
  user_id: zod.uuid(),
  ashby_application_id: zod.union([zod.string(), zod.null()]),
  ashby_candidate_id: zod.union([zod.string(), zod.null()]),
  job_posting_id: zod.string(),
  status: zod.enum([
    "pending",
    "screening_passed",
    "credentialing_pending",
    "hired",
    "rejected",
    "archived",
  ]),
  display_name: zod.union([zod.string(), zod.null()]).optional(),
  email: zod.union([zod.string(), zod.null()]).optional(),
  phone_number: zod.union([zod.string(), zod.null()]).optional(),
  referral_source: zod.union([zod.string(), zod.null()]).optional(),
  referral_person_name: zod.union([zod.string(), zod.null()]).optional(),
  resume_file_id: zod.union([zod.uuid(), zod.null()]).optional(),
  medical_school: zod.union([zod.string(), zod.null()]).optional(),
  degree: zod.union([zod.string(), zod.null()]).optional(),
  residency: zod.union([zod.string(), zod.null()]).optional(),
  fellowships: zod.union([zod.string(), zod.null()]).optional(),
  specialty: zod.union([zod.string(), zod.null()]).optional(),
  npi_number: zod.union([zod.string(), zod.null()]).optional(),
  licensed_states: zod.union([zod.array(zod.string()), zod.null()]).optional(),
  board_certified: zod.union([zod.boolean(), zod.null()]).optional(),
  mailing_address_street: zod.union([zod.string(), zod.null()]).optional(),
  mailing_address_city: zod.union([zod.string(), zod.null()]).optional(),
  mailing_address_state: zod.union([zod.string(), zod.null()]).optional(),
  mailing_address_zip: zod.union([zod.string(), zod.null()]).optional(),
  date_of_birth: zod.union([zod.iso.date(), zod.null()]).optional(),
  headshot_file_id: zod.union([zod.uuid(), zod.null()]).optional(),
  application_data: zod
    .union([
      zod
        .object({
          attestation_professional_liability: zod
            .union([
              zod.object({
                answers: zod.array(zod.boolean()),
                explanation: zod.union([zod.string(), zod.null()]).optional(),
              }),
              zod.null(),
            ])
            .optional(),
          attestation_physical_mental_health: zod
            .union([
              zod.object({
                answers: zod.array(zod.boolean()),
                explanation: zod.union([zod.string(), zod.null()]).optional(),
              }),
              zod.null(),
            ])
            .optional(),
          attestation_disciplinary_license_dea: zod
            .union([
              zod.object({
                answers: zod.array(zod.boolean()),
                explanation: zod.union([zod.string(), zod.null()]).optional(),
              }),
              zod.null(),
            ])
            .optional(),
          attestation_disciplinary_membership: zod
            .union([
              zod.object({
                answers: zod.array(zod.boolean()),
                explanation: zod.union([zod.string(), zod.null()]).optional(),
              }),
              zod.null(),
            ])
            .optional(),
          attestation_compliance_with_laws: zod
            .union([
              zod.object({
                answers: zod.array(zod.boolean()),
                explanation: zod.union([zod.string(), zod.null()]).optional(),
              }),
              zod.null(),
            ])
            .optional(),
        })
        .describe(
          "Screening attestation data stored in JSONB — not promoted to employee_records.",
        ),
      zod.null(),
    ])
    .optional(),
  created_at: zod.iso.datetime({}),
  updated_at: zod.iso.datetime({}),
});

/**
 * @summary Fetch Current Clinician Onboarding Step
 */
export const fetchCurrentClinicianOnboardingStepResponseDataPrefillNADEANumbersItemNADEANumberRegExp =
  new RegExp("^[a-zA-Z0-9]{9}$");

export const fetchCurrentClinicianOnboardingStepResponse = zod.object({
  step: zod.enum([
    "submit_application",
    "application_pending",
    "application_rejected",
    "fill_credentialing_form",
    "credentialing_pending",
    "fill_employee_record",
    "enter_prescriber_details",
    "awaiting_dosespot",
    "start_idp",
    "sign_disclaimer",
    "sign_legal_agreements",
    "submit_demographics",
    "answer_questions",
    "submit_otp",
    "link_bank_account",
    "complete",
  ]),
  data: zod
    .union([
      zod.object({
        missingFields: zod.array(
          zod.enum([
            "displayName",
            "email",
            "licensedStates",
            "licensedPracticeAreas",
          ]),
        ),
        currentValues: zod.object({
          displayName: zod.union([zod.string(), zod.null()]),
          phoneNumber: zod.union([zod.string(), zod.null()]),
          email: zod.union([zod.string(), zod.null()]),
          licensedStates: zod.union([zod.array(zod.string()), zod.null()]),
          licensedPracticeAreas: zod.union([
            zod.array(zod.string()),
            zod.null(),
          ]),
          originPractices: zod.union([zod.array(zod.string()), zod.null()]),
          mailingAddressStreet: zod
            .union([zod.string(), zod.null()])
            .optional(),
          mailingAddressCity: zod.union([zod.string(), zod.null()]).optional(),
          mailingAddressState: zod.union([zod.string(), zod.null()]).optional(),
          mailingAddressZip: zod.union([zod.string(), zod.null()]).optional(),
          dateOfBirth: zod.union([zod.iso.date(), zod.null()]).optional(),
          npiNumber: zod.union([zod.string(), zod.null()]).optional(),
          headshotFileId: zod.union([zod.uuid(), zod.null()]).optional(),
        }),
      }),
      zod.object({
        prefill: zod.union([
          zod
            .object({
              FirstName: zod.string(),
              LastName: zod.string(),
              DateOfBirth: zod.string(),
              Address1: zod.string(),
              City: zod.string(),
              State: zod.string(),
              ZipCode: zod.string(),
              PrimaryPhone: zod.string(),
              PrimaryFax: zod.string(),
              ClinicianId: zod.union([zod.number(), zod.null()]).optional(),
              Prefix: zod.union([zod.string(), zod.null()]).optional(),
              MiddleName: zod.union([zod.string(), zod.null()]).optional(),
              Suffix: zod.union([zod.string(), zod.null()]).optional(),
              Email: zod.union([zod.string(), zod.null()]).optional(),
              Address2: zod.union([zod.string(), zod.null()]).optional(),
              PrimaryPhoneType: zod
                .union([
                  zod.enum([
                    "Undefined",
                    "Beeper",
                    "Cell",
                    "Fax",
                    "Home",
                    "Work",
                    "Night",
                    "Primary",
                  ]),
                  zod.null(),
                ])
                .optional(),
              PhoneAdditional1: zod
                .union([zod.string(), zod.null()])
                .optional(),
              PhoneAdditionalType1: zod
                .union([
                  zod.enum([
                    "Undefined",
                    "Beeper",
                    "Cell",
                    "Fax",
                    "Home",
                    "Work",
                    "Night",
                    "Primary",
                  ]),
                  zod.null(),
                ])
                .optional(),
              PhoneAdditional2: zod
                .union([zod.string(), zod.null()])
                .optional(),
              PhoneAdditionalType2: zod
                .union([
                  zod.enum([
                    "Undefined",
                    "Beeper",
                    "Cell",
                    "Fax",
                    "Home",
                    "Work",
                    "Night",
                    "Primary",
                  ]),
                  zod.null(),
                ])
                .optional(),
              PhoneAdditional3: zod
                .union([zod.string(), zod.null()])
                .optional(),
              PhoneAdditionalType3: zod
                .union([
                  zod.enum([
                    "Undefined",
                    "Beeper",
                    "Cell",
                    "Fax",
                    "Home",
                    "Work",
                    "Night",
                    "Primary",
                  ]),
                  zod.null(),
                ])
                .optional(),
              DEANumbers: zod
                .union([
                  zod.array(
                    zod.object({
                      DEANumber: zod.string(),
                      State: zod.union([zod.string(), zod.null()]).optional(),
                      ClinicId: zod
                        .union([zod.string(), zod.null()])
                        .optional(),
                    }),
                  ),
                  zod.null(),
                ])
                .optional(),
              DEANumber: zod.union([zod.string(), zod.null()]).optional(),
              NADEANumbers: zod
                .union([
                  zod.array(
                    zod.object({
                      NADEANumber: zod
                        .string()
                        .regex(
                          fetchCurrentClinicianOnboardingStepResponseDataPrefillNADEANumbersItemNADEANumberRegExp,
                        ),
                      State: zod.union([zod.string(), zod.null()]).optional(),
                      ClinicId: zod
                        .union([zod.string(), zod.null()])
                        .optional(),
                    }),
                  ),
                  zod.null(),
                ])
                .optional(),
              MedicalLicenseNumbers: zod
                .union([
                  zod.array(
                    zod.object({
                      LicenseNumber: zod.string(),
                      State: zod.union([zod.string(), zod.null()]).optional(),
                      ClinicId: zod
                        .union([zod.string(), zod.null()])
                        .optional(),
                    }),
                  ),
                  zod.null(),
                ])
                .optional(),
              NPINumber: zod.union([zod.string(), zod.null()]).optional(),
              Roles: zod
                .union([zod.array(zod.string()), zod.null()])
                .optional(),
              PDMPRoleType: zod
                .union([
                  zod.enum([
                    "Physician",
                    "Dentist",
                    "NursePractioner",
                    "PhysiciansAssistant",
                    "Resident",
                    "Intern",
                    "Psychologist",
                    "Optometrist",
                    "NaturopathicPhysician",
                  ]),
                  zod.null(),
                ])
                .optional(),
              SpecialtyTypeId: zod.union([zod.number(), zod.null()]).optional(),
              Confirmed: zod.union([zod.boolean(), zod.null()]).optional(),
              Active: zod.union([zod.boolean(), zod.null()]).optional(),
              AccountLocked: zod.union([zod.boolean(), zod.null()]).optional(),
              EpcsRequested: zod.union([zod.boolean(), zod.null()]).optional(),
              ClinicInfo: zod
                .union([
                  zod.array(
                    zod
                      .object({
                        ClinicId: zod
                          .union([zod.number(), zod.null()])
                          .optional(),
                        HasNewRx: zod
                          .union([zod.boolean(), zod.null()])
                          .optional(),
                        HasRefills: zod
                          .union([zod.boolean(), zod.null()])
                          .optional(),
                        HasRxChange: zod
                          .union([zod.boolean(), zod.null()])
                          .optional(),
                        HasCancel: zod
                          .union([zod.boolean(), zod.null()])
                          .optional(),
                        HasRxFill: zod
                          .union([zod.boolean(), zod.null()])
                          .optional(),
                        HasEpcs: zod
                          .union([zod.boolean(), zod.null()])
                          .optional(),
                        HasEpa: zod
                          .union([zod.boolean(), zod.null()])
                          .optional(),
                      })
                      .describe(
                        "Summary of e-prescribing capabilities for a clinician at a specific clinic.",
                      ),
                  ),
                  zod.null(),
                ])
                .optional(),
            })
            .describe("Complete clinician information from DoseSpot API."),
          zod.null(),
        ]),
        registrationError: zod
          .union([
            zod.enum([
              "Pending",
              "RegistrationSuccess",
              "RegistrationError",
              "IDPSuccess",
              "IDPError",
              "TFAActivateInit",
              "TFAActivatedSuccess",
              "TFAActivatedError",
              "TFADeactivateInit",
              "TFADeactivatedSuccess",
              "TFADeactivatedError",
              "IDPInitializeSuccess",
              "NotApplicable",
            ]),
            zod.null(),
          ])
          .optional(),
      }),
      zod.object({
        message: zod.string(),
      }),
      zod.object({
        pendingAgreementIds: zod.array(zod.number()),
      }),
      zod.object({
        questions: zod.array(zod.string()),
        answerChoices: zod.array(zod.array(zod.string())),
      }),
      zod.null(),
    ])
    .optional(),
});

/**
 * Create a new DoseSpot clinician record for a user.

This endpoint creates a DoseSpot clinician account for the specified user,
validates that they are an employee, and ensures no duplicate records.

Raises:
    AuthException: If the user lacks required privileges
    ValueError: If the target user is not an employee or already has a record
 * @summary Create Dosespot Clinician
 */
export const createDosespotClinicianBodyClinicianInfoNADEANumbersItemNADEANumberRegExp =
  new RegExp("^[a-zA-Z0-9]{9}$");

export const createDosespotClinicianBody = zod.object({
  userId: zod.uuid(),
  clinicianInfo: zod.object({
    FirstName: zod.string(),
    LastName: zod.string(),
    DateOfBirth: zod.string(),
    Address1: zod.string(),
    City: zod.string(),
    State: zod.string(),
    ZipCode: zod.string(),
    PrimaryPhone: zod.string(),
    PrimaryFax: zod.string(),
    ClinicianRoleType: zod.array(
      zod
        .enum(["1", "2", "3", "4", "5", "6"])
        .describe("Valid clinician role types for DoseSpot."),
    ),
    NPINumber: zod.string(),
    Prefix: zod.union([zod.string(), zod.null()]).optional(),
    MiddleName: zod.union([zod.string(), zod.null()]).optional(),
    Suffix: zod.union([zod.string(), zod.null()]).optional(),
    Email: zod.union([zod.string(), zod.null()]).optional(),
    Address2: zod.union([zod.string(), zod.null()]).optional(),
    PrimaryPhoneType: zod
      .union([
        zod.enum([
          "Undefined",
          "Beeper",
          "Cell",
          "Fax",
          "Home",
          "Work",
          "Night",
          "Primary",
        ]),
        zod.null(),
      ])
      .optional(),
    PhoneAdditional1: zod.union([zod.string(), zod.null()]).optional(),
    PhoneAdditionalType1: zod
      .union([
        zod.enum([
          "Undefined",
          "Beeper",
          "Cell",
          "Fax",
          "Home",
          "Work",
          "Night",
          "Primary",
        ]),
        zod.null(),
      ])
      .optional(),
    PhoneAdditional2: zod.union([zod.string(), zod.null()]).optional(),
    PhoneAdditionalType2: zod
      .union([
        zod.enum([
          "Undefined",
          "Beeper",
          "Cell",
          "Fax",
          "Home",
          "Work",
          "Night",
          "Primary",
        ]),
        zod.null(),
      ])
      .optional(),
    PhoneAdditional3: zod.union([zod.string(), zod.null()]).optional(),
    PhoneAdditionalType3: zod
      .union([
        zod.enum([
          "Undefined",
          "Beeper",
          "Cell",
          "Fax",
          "Home",
          "Work",
          "Night",
          "Primary",
        ]),
        zod.null(),
      ])
      .optional(),
    DEANumber: zod.union([zod.string(), zod.null()]).optional(),
    DEANumbers: zod
      .union([
        zod.array(
          zod.object({
            DEANumber: zod.string(),
            State: zod.union([zod.string(), zod.null()]).optional(),
            ClinicId: zod.union([zod.string(), zod.null()]).optional(),
          }),
        ),
        zod.null(),
      ])
      .optional(),
    NADEANumbers: zod
      .union([
        zod.array(
          zod.object({
            NADEANumber: zod
              .string()
              .regex(
                createDosespotClinicianBodyClinicianInfoNADEANumbersItemNADEANumberRegExp,
              ),
            State: zod.union([zod.string(), zod.null()]).optional(),
            ClinicId: zod.union([zod.string(), zod.null()]).optional(),
          }),
        ),
        zod.null(),
      ])
      .optional(),
    MedicalLicenseNumbers: zod
      .union([
        zod.array(
          zod.object({
            LicenseNumber: zod.string(),
            State: zod.union([zod.string(), zod.null()]).optional(),
            ClinicId: zod.union([zod.string(), zod.null()]).optional(),
          }),
        ),
        zod.null(),
      ])
      .optional(),
    EPCSRequested: zod.union([zod.boolean(), zod.null()]).optional(),
    Active: zod.union([zod.boolean(), zod.null()]).optional(),
    PDMPRoleType: zod
      .union([
        zod.enum([
          "Physician",
          "Dentist",
          "NursePractioner",
          "PhysiciansAssistant",
          "Resident",
          "Intern",
          "Psychologist",
          "Optometrist",
          "NaturopathicPhysician",
        ]),
        zod.null(),
      ])
      .optional(),
    ClinicianSpecialtyType: zod
      .union([
        zod.enum([
          "AllergyAndImmunology",
          "Dermatology",
          "Dentistry",
          "BehavioralHealth",
          "FamilyMedicine",
          "InternalMedicine",
          "ObstetricsAndGynecology",
          "Orthopedics",
          "Pediatrics",
          "PhysicalMedicine",
          "Psychiatry",
          "Urology",
        ]),
        zod.null(),
      ])
      .optional(),
  }),
});

export const createDosespotClinicianResponseCurrentDosespotInfoNADEANumbersItemNADEANumberRegExp =
  new RegExp("^[a-zA-Z0-9]{9}$");

export const createDosespotClinicianResponse = zod
  .object({
    id: zod.uuid(),
    user_id: zod.uuid(),
    dosespot_clinician_id: zod.string(),
    current_dosespot_info: zod
      .object({
        FirstName: zod.string(),
        LastName: zod.string(),
        DateOfBirth: zod.string(),
        Address1: zod.string(),
        City: zod.string(),
        State: zod.string(),
        ZipCode: zod.string(),
        PrimaryPhone: zod.string(),
        PrimaryFax: zod.string(),
        ClinicianId: zod.union([zod.number(), zod.null()]).optional(),
        Prefix: zod.union([zod.string(), zod.null()]).optional(),
        MiddleName: zod.union([zod.string(), zod.null()]).optional(),
        Suffix: zod.union([zod.string(), zod.null()]).optional(),
        Email: zod.union([zod.string(), zod.null()]).optional(),
        Address2: zod.union([zod.string(), zod.null()]).optional(),
        PrimaryPhoneType: zod
          .union([
            zod.enum([
              "Undefined",
              "Beeper",
              "Cell",
              "Fax",
              "Home",
              "Work",
              "Night",
              "Primary",
            ]),
            zod.null(),
          ])
          .optional(),
        PhoneAdditional1: zod.union([zod.string(), zod.null()]).optional(),
        PhoneAdditionalType1: zod
          .union([
            zod.enum([
              "Undefined",
              "Beeper",
              "Cell",
              "Fax",
              "Home",
              "Work",
              "Night",
              "Primary",
            ]),
            zod.null(),
          ])
          .optional(),
        PhoneAdditional2: zod.union([zod.string(), zod.null()]).optional(),
        PhoneAdditionalType2: zod
          .union([
            zod.enum([
              "Undefined",
              "Beeper",
              "Cell",
              "Fax",
              "Home",
              "Work",
              "Night",
              "Primary",
            ]),
            zod.null(),
          ])
          .optional(),
        PhoneAdditional3: zod.union([zod.string(), zod.null()]).optional(),
        PhoneAdditionalType3: zod
          .union([
            zod.enum([
              "Undefined",
              "Beeper",
              "Cell",
              "Fax",
              "Home",
              "Work",
              "Night",
              "Primary",
            ]),
            zod.null(),
          ])
          .optional(),
        DEANumbers: zod
          .union([
            zod.array(
              zod.object({
                DEANumber: zod.string(),
                State: zod.union([zod.string(), zod.null()]).optional(),
                ClinicId: zod.union([zod.string(), zod.null()]).optional(),
              }),
            ),
            zod.null(),
          ])
          .optional(),
        DEANumber: zod.union([zod.string(), zod.null()]).optional(),
        NADEANumbers: zod
          .union([
            zod.array(
              zod.object({
                NADEANumber: zod
                  .string()
                  .regex(
                    createDosespotClinicianResponseCurrentDosespotInfoNADEANumbersItemNADEANumberRegExp,
                  ),
                State: zod.union([zod.string(), zod.null()]).optional(),
                ClinicId: zod.union([zod.string(), zod.null()]).optional(),
              }),
            ),
            zod.null(),
          ])
          .optional(),
        MedicalLicenseNumbers: zod
          .union([
            zod.array(
              zod.object({
                LicenseNumber: zod.string(),
                State: zod.union([zod.string(), zod.null()]).optional(),
                ClinicId: zod.union([zod.string(), zod.null()]).optional(),
              }),
            ),
            zod.null(),
          ])
          .optional(),
        NPINumber: zod.union([zod.string(), zod.null()]).optional(),
        Roles: zod.union([zod.array(zod.string()), zod.null()]).optional(),
        PDMPRoleType: zod
          .union([
            zod.enum([
              "Physician",
              "Dentist",
              "NursePractioner",
              "PhysiciansAssistant",
              "Resident",
              "Intern",
              "Psychologist",
              "Optometrist",
              "NaturopathicPhysician",
            ]),
            zod.null(),
          ])
          .optional(),
        SpecialtyTypeId: zod.union([zod.number(), zod.null()]).optional(),
        Confirmed: zod.union([zod.boolean(), zod.null()]).optional(),
        Active: zod.union([zod.boolean(), zod.null()]).optional(),
        AccountLocked: zod.union([zod.boolean(), zod.null()]).optional(),
        EpcsRequested: zod.union([zod.boolean(), zod.null()]).optional(),
        ClinicInfo: zod
          .union([
            zod.array(
              zod
                .object({
                  ClinicId: zod.union([zod.number(), zod.null()]).optional(),
                  HasNewRx: zod.union([zod.boolean(), zod.null()]).optional(),
                  HasRefills: zod.union([zod.boolean(), zod.null()]).optional(),
                  HasRxChange: zod
                    .union([zod.boolean(), zod.null()])
                    .optional(),
                  HasCancel: zod.union([zod.boolean(), zod.null()]).optional(),
                  HasRxFill: zod.union([zod.boolean(), zod.null()]).optional(),
                  HasEpcs: zod.union([zod.boolean(), zod.null()]).optional(),
                  HasEpa: zod.union([zod.boolean(), zod.null()]).optional(),
                })
                .describe(
                  "Summary of e-prescribing capabilities for a clinician at a specific clinic.",
                ),
            ),
            zod.null(),
          ])
          .optional(),
      })
      .describe("Complete clinician information from DoseSpot API."),
    created_at: zod.iso.datetime({}),
    updated_at: zod.iso.datetime({}),
    mercury_recipient_id: zod.union([zod.string(), zod.null()]).optional(),
  })
  .describe("Record type for DoseSpot clinician information.");

/**
 * List all employee users who don't have DoseSpot clinician records.

This endpoint returns all users who have employee records but no associated
DoseSpot clinician records, useful for identifying who can be onboarded.

Raises:
    AuthException: If the user lacks required privileges
 * @summary List Users Without Dosespot Records
 */
export const listUsersWithoutDosespotRecordsResponseItem = zod
  .object({
    id: zod.uuid(),
    display_name: zod.union([zod.string(), zod.null()]).optional(),
    phone_number: zod.union([zod.string(), zod.null()]).optional(),
    email: zod.union([zod.string(), zod.null()]).optional(),
  })
  .describe("User information for users without DoseSpot records.");
export const listUsersWithoutDosespotRecordsResponse = zod.array(
  listUsersWithoutDosespotRecordsResponseItem,
);

/**
 * List all users who have DoseSpot clinician records.

This endpoint returns all existing DoseSpot clinician records,
useful for administrative oversight.

Raises:
    AuthException: If the user lacks required privileges
 * @summary List Users With Dosespot Records
 */
export const listUsersWithDosespotRecordsResponseCurrentDosespotInfoNADEANumbersItemNADEANumberRegExp =
  new RegExp("^[a-zA-Z0-9]{9}$");

export const listUsersWithDosespotRecordsResponseItem = zod
  .object({
    id: zod.uuid(),
    user_id: zod.uuid(),
    dosespot_clinician_id: zod.string(),
    current_dosespot_info: zod
      .object({
        FirstName: zod.string(),
        LastName: zod.string(),
        DateOfBirth: zod.string(),
        Address1: zod.string(),
        City: zod.string(),
        State: zod.string(),
        ZipCode: zod.string(),
        PrimaryPhone: zod.string(),
        PrimaryFax: zod.string(),
        ClinicianId: zod.union([zod.number(), zod.null()]).optional(),
        Prefix: zod.union([zod.string(), zod.null()]).optional(),
        MiddleName: zod.union([zod.string(), zod.null()]).optional(),
        Suffix: zod.union([zod.string(), zod.null()]).optional(),
        Email: zod.union([zod.string(), zod.null()]).optional(),
        Address2: zod.union([zod.string(), zod.null()]).optional(),
        PrimaryPhoneType: zod
          .union([
            zod.enum([
              "Undefined",
              "Beeper",
              "Cell",
              "Fax",
              "Home",
              "Work",
              "Night",
              "Primary",
            ]),
            zod.null(),
          ])
          .optional(),
        PhoneAdditional1: zod.union([zod.string(), zod.null()]).optional(),
        PhoneAdditionalType1: zod
          .union([
            zod.enum([
              "Undefined",
              "Beeper",
              "Cell",
              "Fax",
              "Home",
              "Work",
              "Night",
              "Primary",
            ]),
            zod.null(),
          ])
          .optional(),
        PhoneAdditional2: zod.union([zod.string(), zod.null()]).optional(),
        PhoneAdditionalType2: zod
          .union([
            zod.enum([
              "Undefined",
              "Beeper",
              "Cell",
              "Fax",
              "Home",
              "Work",
              "Night",
              "Primary",
            ]),
            zod.null(),
          ])
          .optional(),
        PhoneAdditional3: zod.union([zod.string(), zod.null()]).optional(),
        PhoneAdditionalType3: zod
          .union([
            zod.enum([
              "Undefined",
              "Beeper",
              "Cell",
              "Fax",
              "Home",
              "Work",
              "Night",
              "Primary",
            ]),
            zod.null(),
          ])
          .optional(),
        DEANumbers: zod
          .union([
            zod.array(
              zod.object({
                DEANumber: zod.string(),
                State: zod.union([zod.string(), zod.null()]).optional(),
                ClinicId: zod.union([zod.string(), zod.null()]).optional(),
              }),
            ),
            zod.null(),
          ])
          .optional(),
        DEANumber: zod.union([zod.string(), zod.null()]).optional(),
        NADEANumbers: zod
          .union([
            zod.array(
              zod.object({
                NADEANumber: zod
                  .string()
                  .regex(
                    listUsersWithDosespotRecordsResponseCurrentDosespotInfoNADEANumbersItemNADEANumberRegExp,
                  ),
                State: zod.union([zod.string(), zod.null()]).optional(),
                ClinicId: zod.union([zod.string(), zod.null()]).optional(),
              }),
            ),
            zod.null(),
          ])
          .optional(),
        MedicalLicenseNumbers: zod
          .union([
            zod.array(
              zod.object({
                LicenseNumber: zod.string(),
                State: zod.union([zod.string(), zod.null()]).optional(),
                ClinicId: zod.union([zod.string(), zod.null()]).optional(),
              }),
            ),
            zod.null(),
          ])
          .optional(),
        NPINumber: zod.union([zod.string(), zod.null()]).optional(),
        Roles: zod.union([zod.array(zod.string()), zod.null()]).optional(),
        PDMPRoleType: zod
          .union([
            zod.enum([
              "Physician",
              "Dentist",
              "NursePractioner",
              "PhysiciansAssistant",
              "Resident",
              "Intern",
              "Psychologist",
              "Optometrist",
              "NaturopathicPhysician",
            ]),
            zod.null(),
          ])
          .optional(),
        SpecialtyTypeId: zod.union([zod.number(), zod.null()]).optional(),
        Confirmed: zod.union([zod.boolean(), zod.null()]).optional(),
        Active: zod.union([zod.boolean(), zod.null()]).optional(),
        AccountLocked: zod.union([zod.boolean(), zod.null()]).optional(),
        EpcsRequested: zod.union([zod.boolean(), zod.null()]).optional(),
        ClinicInfo: zod
          .union([
            zod.array(
              zod
                .object({
                  ClinicId: zod.union([zod.number(), zod.null()]).optional(),
                  HasNewRx: zod.union([zod.boolean(), zod.null()]).optional(),
                  HasRefills: zod.union([zod.boolean(), zod.null()]).optional(),
                  HasRxChange: zod
                    .union([zod.boolean(), zod.null()])
                    .optional(),
                  HasCancel: zod.union([zod.boolean(), zod.null()]).optional(),
                  HasRxFill: zod.union([zod.boolean(), zod.null()]).optional(),
                  HasEpcs: zod.union([zod.boolean(), zod.null()]).optional(),
                  HasEpa: zod.union([zod.boolean(), zod.null()]).optional(),
                })
                .describe(
                  "Summary of e-prescribing capabilities for a clinician at a specific clinic.",
                ),
            ),
            zod.null(),
          ])
          .optional(),
      })
      .describe("Complete clinician information from DoseSpot API."),
    created_at: zod.iso.datetime({}),
    updated_at: zod.iso.datetime({}),
    mercury_recipient_id: zod.union([zod.string(), zod.null()]).optional(),
  })
  .describe("Record type for DoseSpot clinician information.");
export const listUsersWithDosespotRecordsResponse = zod.array(
  listUsersWithDosespotRecordsResponseItem,
);

/**
 * Get current DoseSpot clinician information for a specific user.

This endpoint retrieves the stored clinician information for the specified user.

Args:
    user_id: The user ID to fetch clinician info for

Returns:
    Current DoseSpot clinician information, or None if no record exists

Raises:
    AuthException: If the user lacks required privileges
 * @summary Get Dosespot Clinician Info By User Id
 */
export const getDosespotClinicianInfoByUserIdParams = zod.object({
  user_id: zod.uuid(),
});

export const getDosespotClinicianInfoByUserIdResponseNADEANumbersItemNADEANumberRegExp =
  new RegExp("^[a-zA-Z0-9]{9}$");

export const getDosespotClinicianInfoByUserIdResponse = zod.union([
  zod
    .object({
      FirstName: zod.string(),
      LastName: zod.string(),
      DateOfBirth: zod.string(),
      Address1: zod.string(),
      City: zod.string(),
      State: zod.string(),
      ZipCode: zod.string(),
      PrimaryPhone: zod.string(),
      PrimaryFax: zod.string(),
      ClinicianId: zod.union([zod.number(), zod.null()]).optional(),
      Prefix: zod.union([zod.string(), zod.null()]).optional(),
      MiddleName: zod.union([zod.string(), zod.null()]).optional(),
      Suffix: zod.union([zod.string(), zod.null()]).optional(),
      Email: zod.union([zod.string(), zod.null()]).optional(),
      Address2: zod.union([zod.string(), zod.null()]).optional(),
      PrimaryPhoneType: zod
        .union([
          zod.enum([
            "Undefined",
            "Beeper",
            "Cell",
            "Fax",
            "Home",
            "Work",
            "Night",
            "Primary",
          ]),
          zod.null(),
        ])
        .optional(),
      PhoneAdditional1: zod.union([zod.string(), zod.null()]).optional(),
      PhoneAdditionalType1: zod
        .union([
          zod.enum([
            "Undefined",
            "Beeper",
            "Cell",
            "Fax",
            "Home",
            "Work",
            "Night",
            "Primary",
          ]),
          zod.null(),
        ])
        .optional(),
      PhoneAdditional2: zod.union([zod.string(), zod.null()]).optional(),
      PhoneAdditionalType2: zod
        .union([
          zod.enum([
            "Undefined",
            "Beeper",
            "Cell",
            "Fax",
            "Home",
            "Work",
            "Night",
            "Primary",
          ]),
          zod.null(),
        ])
        .optional(),
      PhoneAdditional3: zod.union([zod.string(), zod.null()]).optional(),
      PhoneAdditionalType3: zod
        .union([
          zod.enum([
            "Undefined",
            "Beeper",
            "Cell",
            "Fax",
            "Home",
            "Work",
            "Night",
            "Primary",
          ]),
          zod.null(),
        ])
        .optional(),
      DEANumbers: zod
        .union([
          zod.array(
            zod.object({
              DEANumber: zod.string(),
              State: zod.union([zod.string(), zod.null()]).optional(),
              ClinicId: zod.union([zod.string(), zod.null()]).optional(),
            }),
          ),
          zod.null(),
        ])
        .optional(),
      DEANumber: zod.union([zod.string(), zod.null()]).optional(),
      NADEANumbers: zod
        .union([
          zod.array(
            zod.object({
              NADEANumber: zod
                .string()
                .regex(
                  getDosespotClinicianInfoByUserIdResponseNADEANumbersItemNADEANumberRegExp,
                ),
              State: zod.union([zod.string(), zod.null()]).optional(),
              ClinicId: zod.union([zod.string(), zod.null()]).optional(),
            }),
          ),
          zod.null(),
        ])
        .optional(),
      MedicalLicenseNumbers: zod
        .union([
          zod.array(
            zod.object({
              LicenseNumber: zod.string(),
              State: zod.union([zod.string(), zod.null()]).optional(),
              ClinicId: zod.union([zod.string(), zod.null()]).optional(),
            }),
          ),
          zod.null(),
        ])
        .optional(),
      NPINumber: zod.union([zod.string(), zod.null()]).optional(),
      Roles: zod.union([zod.array(zod.string()), zod.null()]).optional(),
      PDMPRoleType: zod
        .union([
          zod.enum([
            "Physician",
            "Dentist",
            "NursePractioner",
            "PhysiciansAssistant",
            "Resident",
            "Intern",
            "Psychologist",
            "Optometrist",
            "NaturopathicPhysician",
          ]),
          zod.null(),
        ])
        .optional(),
      SpecialtyTypeId: zod.union([zod.number(), zod.null()]).optional(),
      Confirmed: zod.union([zod.boolean(), zod.null()]).optional(),
      Active: zod.union([zod.boolean(), zod.null()]).optional(),
      AccountLocked: zod.union([zod.boolean(), zod.null()]).optional(),
      EpcsRequested: zod.union([zod.boolean(), zod.null()]).optional(),
      ClinicInfo: zod
        .union([
          zod.array(
            zod
              .object({
                ClinicId: zod.union([zod.number(), zod.null()]).optional(),
                HasNewRx: zod.union([zod.boolean(), zod.null()]).optional(),
                HasRefills: zod.union([zod.boolean(), zod.null()]).optional(),
                HasRxChange: zod.union([zod.boolean(), zod.null()]).optional(),
                HasCancel: zod.union([zod.boolean(), zod.null()]).optional(),
                HasRxFill: zod.union([zod.boolean(), zod.null()]).optional(),
                HasEpcs: zod.union([zod.boolean(), zod.null()]).optional(),
                HasEpa: zod.union([zod.boolean(), zod.null()]).optional(),
              })
              .describe(
                "Summary of e-prescribing capabilities for a clinician at a specific clinic.",
              ),
          ),
          zod.null(),
        ])
        .optional(),
    })
    .describe("Complete clinician information from DoseSpot API."),
  zod.null(),
]);

/**
 * Get current DoseSpot clinician information for the authenticated user.

This endpoint retrieves the stored clinician information for the authenticated user.

Returns:
    Current DoseSpot clinician information, or None if no record exists

Raises:
    AuthException: If the user lacks required privileges
 * @summary Get My Dosespot Clinician Info
 */
export const getMyDosespotClinicianInfoResponseNADEANumbersItemNADEANumberRegExp =
  new RegExp("^[a-zA-Z0-9]{9}$");

export const getMyDosespotClinicianInfoResponse = zod.union([
  zod
    .object({
      FirstName: zod.string(),
      LastName: zod.string(),
      DateOfBirth: zod.string(),
      Address1: zod.string(),
      City: zod.string(),
      State: zod.string(),
      ZipCode: zod.string(),
      PrimaryPhone: zod.string(),
      PrimaryFax: zod.string(),
      ClinicianId: zod.union([zod.number(), zod.null()]).optional(),
      Prefix: zod.union([zod.string(), zod.null()]).optional(),
      MiddleName: zod.union([zod.string(), zod.null()]).optional(),
      Suffix: zod.union([zod.string(), zod.null()]).optional(),
      Email: zod.union([zod.string(), zod.null()]).optional(),
      Address2: zod.union([zod.string(), zod.null()]).optional(),
      PrimaryPhoneType: zod
        .union([
          zod.enum([
            "Undefined",
            "Beeper",
            "Cell",
            "Fax",
            "Home",
            "Work",
            "Night",
            "Primary",
          ]),
          zod.null(),
        ])
        .optional(),
      PhoneAdditional1: zod.union([zod.string(), zod.null()]).optional(),
      PhoneAdditionalType1: zod
        .union([
          zod.enum([
            "Undefined",
            "Beeper",
            "Cell",
            "Fax",
            "Home",
            "Work",
            "Night",
            "Primary",
          ]),
          zod.null(),
        ])
        .optional(),
      PhoneAdditional2: zod.union([zod.string(), zod.null()]).optional(),
      PhoneAdditionalType2: zod
        .union([
          zod.enum([
            "Undefined",
            "Beeper",
            "Cell",
            "Fax",
            "Home",
            "Work",
            "Night",
            "Primary",
          ]),
          zod.null(),
        ])
        .optional(),
      PhoneAdditional3: zod.union([zod.string(), zod.null()]).optional(),
      PhoneAdditionalType3: zod
        .union([
          zod.enum([
            "Undefined",
            "Beeper",
            "Cell",
            "Fax",
            "Home",
            "Work",
            "Night",
            "Primary",
          ]),
          zod.null(),
        ])
        .optional(),
      DEANumbers: zod
        .union([
          zod.array(
            zod.object({
              DEANumber: zod.string(),
              State: zod.union([zod.string(), zod.null()]).optional(),
              ClinicId: zod.union([zod.string(), zod.null()]).optional(),
            }),
          ),
          zod.null(),
        ])
        .optional(),
      DEANumber: zod.union([zod.string(), zod.null()]).optional(),
      NADEANumbers: zod
        .union([
          zod.array(
            zod.object({
              NADEANumber: zod
                .string()
                .regex(
                  getMyDosespotClinicianInfoResponseNADEANumbersItemNADEANumberRegExp,
                ),
              State: zod.union([zod.string(), zod.null()]).optional(),
              ClinicId: zod.union([zod.string(), zod.null()]).optional(),
            }),
          ),
          zod.null(),
        ])
        .optional(),
      MedicalLicenseNumbers: zod
        .union([
          zod.array(
            zod.object({
              LicenseNumber: zod.string(),
              State: zod.union([zod.string(), zod.null()]).optional(),
              ClinicId: zod.union([zod.string(), zod.null()]).optional(),
            }),
          ),
          zod.null(),
        ])
        .optional(),
      NPINumber: zod.union([zod.string(), zod.null()]).optional(),
      Roles: zod.union([zod.array(zod.string()), zod.null()]).optional(),
      PDMPRoleType: zod
        .union([
          zod.enum([
            "Physician",
            "Dentist",
            "NursePractioner",
            "PhysiciansAssistant",
            "Resident",
            "Intern",
            "Psychologist",
            "Optometrist",
            "NaturopathicPhysician",
          ]),
          zod.null(),
        ])
        .optional(),
      SpecialtyTypeId: zod.union([zod.number(), zod.null()]).optional(),
      Confirmed: zod.union([zod.boolean(), zod.null()]).optional(),
      Active: zod.union([zod.boolean(), zod.null()]).optional(),
      AccountLocked: zod.union([zod.boolean(), zod.null()]).optional(),
      EpcsRequested: zod.union([zod.boolean(), zod.null()]).optional(),
      ClinicInfo: zod
        .union([
          zod.array(
            zod
              .object({
                ClinicId: zod.union([zod.number(), zod.null()]).optional(),
                HasNewRx: zod.union([zod.boolean(), zod.null()]).optional(),
                HasRefills: zod.union([zod.boolean(), zod.null()]).optional(),
                HasRxChange: zod.union([zod.boolean(), zod.null()]).optional(),
                HasCancel: zod.union([zod.boolean(), zod.null()]).optional(),
                HasRxFill: zod.union([zod.boolean(), zod.null()]).optional(),
                HasEpcs: zod.union([zod.boolean(), zod.null()]).optional(),
                HasEpa: zod.union([zod.boolean(), zod.null()]).optional(),
              })
              .describe(
                "Summary of e-prescribing capabilities for a clinician at a specific clinic.",
              ),
          ),
          zod.null(),
        ])
        .optional(),
    })
    .describe("Complete clinician information from DoseSpot API."),
  zod.null(),
]);

/**
 * Update an existing DoseSpot clinician record.

This endpoint updates the DoseSpot clinician information for the specified user.

Args:
    user_id: The user ID of the clinician to update
    request: The updated clinician information

Returns:
    The updated DoseSpot clinician record

Raises:
    AuthException: If the user lacks required privileges
    ValueError: If no clinician record exists for the user
 * @summary Update Dosespot Clinician
 */
export const updateDosespotClinicianParams = zod.object({
  user_id: zod.uuid(),
});

export const updateDosespotClinicianBodyClinicianInfoNADEANumbersItemNADEANumberRegExp =
  new RegExp("^[a-zA-Z0-9]{9}$");

export const updateDosespotClinicianBody = zod.object({
  clinicianInfo: zod.object({
    FirstName: zod.string(),
    LastName: zod.string(),
    DateOfBirth: zod.string(),
    Address1: zod.string(),
    City: zod.string(),
    State: zod.string(),
    ZipCode: zod.string(),
    PrimaryPhone: zod.string(),
    PrimaryFax: zod.string(),
    ClinicianRoleType: zod.array(
      zod
        .enum(["1", "2", "3", "4", "5", "6"])
        .describe("Valid clinician role types for DoseSpot."),
    ),
    NPINumber: zod.string(),
    Prefix: zod.union([zod.string(), zod.null()]).optional(),
    MiddleName: zod.union([zod.string(), zod.null()]).optional(),
    Suffix: zod.union([zod.string(), zod.null()]).optional(),
    Email: zod.union([zod.string(), zod.null()]).optional(),
    Address2: zod.union([zod.string(), zod.null()]).optional(),
    PrimaryPhoneType: zod
      .union([
        zod.enum([
          "Undefined",
          "Beeper",
          "Cell",
          "Fax",
          "Home",
          "Work",
          "Night",
          "Primary",
        ]),
        zod.null(),
      ])
      .optional(),
    PhoneAdditional1: zod.union([zod.string(), zod.null()]).optional(),
    PhoneAdditionalType1: zod
      .union([
        zod.enum([
          "Undefined",
          "Beeper",
          "Cell",
          "Fax",
          "Home",
          "Work",
          "Night",
          "Primary",
        ]),
        zod.null(),
      ])
      .optional(),
    PhoneAdditional2: zod.union([zod.string(), zod.null()]).optional(),
    PhoneAdditionalType2: zod
      .union([
        zod.enum([
          "Undefined",
          "Beeper",
          "Cell",
          "Fax",
          "Home",
          "Work",
          "Night",
          "Primary",
        ]),
        zod.null(),
      ])
      .optional(),
    PhoneAdditional3: zod.union([zod.string(), zod.null()]).optional(),
    PhoneAdditionalType3: zod
      .union([
        zod.enum([
          "Undefined",
          "Beeper",
          "Cell",
          "Fax",
          "Home",
          "Work",
          "Night",
          "Primary",
        ]),
        zod.null(),
      ])
      .optional(),
    DEANumber: zod.union([zod.string(), zod.null()]).optional(),
    DEANumbers: zod
      .union([
        zod.array(
          zod.object({
            DEANumber: zod.string(),
            State: zod.union([zod.string(), zod.null()]).optional(),
            ClinicId: zod.union([zod.string(), zod.null()]).optional(),
          }),
        ),
        zod.null(),
      ])
      .optional(),
    NADEANumbers: zod
      .union([
        zod.array(
          zod.object({
            NADEANumber: zod
              .string()
              .regex(
                updateDosespotClinicianBodyClinicianInfoNADEANumbersItemNADEANumberRegExp,
              ),
            State: zod.union([zod.string(), zod.null()]).optional(),
            ClinicId: zod.union([zod.string(), zod.null()]).optional(),
          }),
        ),
        zod.null(),
      ])
      .optional(),
    MedicalLicenseNumbers: zod
      .union([
        zod.array(
          zod.object({
            LicenseNumber: zod.string(),
            State: zod.union([zod.string(), zod.null()]).optional(),
            ClinicId: zod.union([zod.string(), zod.null()]).optional(),
          }),
        ),
        zod.null(),
      ])
      .optional(),
    EPCSRequested: zod.union([zod.boolean(), zod.null()]).optional(),
    Active: zod.union([zod.boolean(), zod.null()]).optional(),
    PDMPRoleType: zod
      .union([
        zod.enum([
          "Physician",
          "Dentist",
          "NursePractioner",
          "PhysiciansAssistant",
          "Resident",
          "Intern",
          "Psychologist",
          "Optometrist",
          "NaturopathicPhysician",
        ]),
        zod.null(),
      ])
      .optional(),
    ClinicianSpecialtyType: zod
      .union([
        zod.enum([
          "AllergyAndImmunology",
          "Dermatology",
          "Dentistry",
          "BehavioralHealth",
          "FamilyMedicine",
          "InternalMedicine",
          "ObstetricsAndGynecology",
          "Orthopedics",
          "Pediatrics",
          "PhysicalMedicine",
          "Psychiatry",
          "Urology",
        ]),
        zod.null(),
      ])
      .optional(),
  }),
});

export const updateDosespotClinicianResponseCurrentDosespotInfoNADEANumbersItemNADEANumberRegExp =
  new RegExp("^[a-zA-Z0-9]{9}$");

export const updateDosespotClinicianResponse = zod
  .object({
    id: zod.uuid(),
    user_id: zod.uuid(),
    dosespot_clinician_id: zod.string(),
    current_dosespot_info: zod
      .object({
        FirstName: zod.string(),
        LastName: zod.string(),
        DateOfBirth: zod.string(),
        Address1: zod.string(),
        City: zod.string(),
        State: zod.string(),
        ZipCode: zod.string(),
        PrimaryPhone: zod.string(),
        PrimaryFax: zod.string(),
        ClinicianId: zod.union([zod.number(), zod.null()]).optional(),
        Prefix: zod.union([zod.string(), zod.null()]).optional(),
        MiddleName: zod.union([zod.string(), zod.null()]).optional(),
        Suffix: zod.union([zod.string(), zod.null()]).optional(),
        Email: zod.union([zod.string(), zod.null()]).optional(),
        Address2: zod.union([zod.string(), zod.null()]).optional(),
        PrimaryPhoneType: zod
          .union([
            zod.enum([
              "Undefined",
              "Beeper",
              "Cell",
              "Fax",
              "Home",
              "Work",
              "Night",
              "Primary",
            ]),
            zod.null(),
          ])
          .optional(),
        PhoneAdditional1: zod.union([zod.string(), zod.null()]).optional(),
        PhoneAdditionalType1: zod
          .union([
            zod.enum([
              "Undefined",
              "Beeper",
              "Cell",
              "Fax",
              "Home",
              "Work",
              "Night",
              "Primary",
            ]),
            zod.null(),
          ])
          .optional(),
        PhoneAdditional2: zod.union([zod.string(), zod.null()]).optional(),
        PhoneAdditionalType2: zod
          .union([
            zod.enum([
              "Undefined",
              "Beeper",
              "Cell",
              "Fax",
              "Home",
              "Work",
              "Night",
              "Primary",
            ]),
            zod.null(),
          ])
          .optional(),
        PhoneAdditional3: zod.union([zod.string(), zod.null()]).optional(),
        PhoneAdditionalType3: zod
          .union([
            zod.enum([
              "Undefined",
              "Beeper",
              "Cell",
              "Fax",
              "Home",
              "Work",
              "Night",
              "Primary",
            ]),
            zod.null(),
          ])
          .optional(),
        DEANumbers: zod
          .union([
            zod.array(
              zod.object({
                DEANumber: zod.string(),
                State: zod.union([zod.string(), zod.null()]).optional(),
                ClinicId: zod.union([zod.string(), zod.null()]).optional(),
              }),
            ),
            zod.null(),
          ])
          .optional(),
        DEANumber: zod.union([zod.string(), zod.null()]).optional(),
        NADEANumbers: zod
          .union([
            zod.array(
              zod.object({
                NADEANumber: zod
                  .string()
                  .regex(
                    updateDosespotClinicianResponseCurrentDosespotInfoNADEANumbersItemNADEANumberRegExp,
                  ),
                State: zod.union([zod.string(), zod.null()]).optional(),
                ClinicId: zod.union([zod.string(), zod.null()]).optional(),
              }),
            ),
            zod.null(),
          ])
          .optional(),
        MedicalLicenseNumbers: zod
          .union([
            zod.array(
              zod.object({
                LicenseNumber: zod.string(),
                State: zod.union([zod.string(), zod.null()]).optional(),
                ClinicId: zod.union([zod.string(), zod.null()]).optional(),
              }),
            ),
            zod.null(),
          ])
          .optional(),
        NPINumber: zod.union([zod.string(), zod.null()]).optional(),
        Roles: zod.union([zod.array(zod.string()), zod.null()]).optional(),
        PDMPRoleType: zod
          .union([
            zod.enum([
              "Physician",
              "Dentist",
              "NursePractioner",
              "PhysiciansAssistant",
              "Resident",
              "Intern",
              "Psychologist",
              "Optometrist",
              "NaturopathicPhysician",
            ]),
            zod.null(),
          ])
          .optional(),
        SpecialtyTypeId: zod.union([zod.number(), zod.null()]).optional(),
        Confirmed: zod.union([zod.boolean(), zod.null()]).optional(),
        Active: zod.union([zod.boolean(), zod.null()]).optional(),
        AccountLocked: zod.union([zod.boolean(), zod.null()]).optional(),
        EpcsRequested: zod.union([zod.boolean(), zod.null()]).optional(),
        ClinicInfo: zod
          .union([
            zod.array(
              zod
                .object({
                  ClinicId: zod.union([zod.number(), zod.null()]).optional(),
                  HasNewRx: zod.union([zod.boolean(), zod.null()]).optional(),
                  HasRefills: zod.union([zod.boolean(), zod.null()]).optional(),
                  HasRxChange: zod
                    .union([zod.boolean(), zod.null()])
                    .optional(),
                  HasCancel: zod.union([zod.boolean(), zod.null()]).optional(),
                  HasRxFill: zod.union([zod.boolean(), zod.null()]).optional(),
                  HasEpcs: zod.union([zod.boolean(), zod.null()]).optional(),
                  HasEpa: zod.union([zod.boolean(), zod.null()]).optional(),
                })
                .describe(
                  "Summary of e-prescribing capabilities for a clinician at a specific clinic.",
                ),
            ),
            zod.null(),
          ])
          .optional(),
      })
      .describe("Complete clinician information from DoseSpot API."),
    created_at: zod.iso.datetime({}),
    updated_at: zod.iso.datetime({}),
    mercury_recipient_id: zod.union([zod.string(), zod.null()]).optional(),
  })
  .describe("Record type for DoseSpot clinician information.");

/**
 * Update the authenticated user's DoseSpot clinician record.

This endpoint updates the DoseSpot clinician information for the authenticated user.

Args:
    request: The updated clinician information

Returns:
    The updated DoseSpot clinician record

Raises:
    AuthException: If the user lacks required privileges
    ValueError: If no clinician record exists for the authenticated user
 * @summary Update My Dosespot Clinician
 */
export const updateMyDosespotClinicianBodyClinicianInfoNADEANumbersItemNADEANumberRegExp =
  new RegExp("^[a-zA-Z0-9]{9}$");

export const updateMyDosespotClinicianBody = zod.object({
  clinicianInfo: zod.object({
    FirstName: zod.string(),
    LastName: zod.string(),
    DateOfBirth: zod.string(),
    Address1: zod.string(),
    City: zod.string(),
    State: zod.string(),
    ZipCode: zod.string(),
    PrimaryPhone: zod.string(),
    PrimaryFax: zod.string(),
    ClinicianRoleType: zod.array(
      zod
        .enum(["1", "2", "3", "4", "5", "6"])
        .describe("Valid clinician role types for DoseSpot."),
    ),
    NPINumber: zod.string(),
    Prefix: zod.union([zod.string(), zod.null()]).optional(),
    MiddleName: zod.union([zod.string(), zod.null()]).optional(),
    Suffix: zod.union([zod.string(), zod.null()]).optional(),
    Email: zod.union([zod.string(), zod.null()]).optional(),
    Address2: zod.union([zod.string(), zod.null()]).optional(),
    PrimaryPhoneType: zod
      .union([
        zod.enum([
          "Undefined",
          "Beeper",
          "Cell",
          "Fax",
          "Home",
          "Work",
          "Night",
          "Primary",
        ]),
        zod.null(),
      ])
      .optional(),
    PhoneAdditional1: zod.union([zod.string(), zod.null()]).optional(),
    PhoneAdditionalType1: zod
      .union([
        zod.enum([
          "Undefined",
          "Beeper",
          "Cell",
          "Fax",
          "Home",
          "Work",
          "Night",
          "Primary",
        ]),
        zod.null(),
      ])
      .optional(),
    PhoneAdditional2: zod.union([zod.string(), zod.null()]).optional(),
    PhoneAdditionalType2: zod
      .union([
        zod.enum([
          "Undefined",
          "Beeper",
          "Cell",
          "Fax",
          "Home",
          "Work",
          "Night",
          "Primary",
        ]),
        zod.null(),
      ])
      .optional(),
    PhoneAdditional3: zod.union([zod.string(), zod.null()]).optional(),
    PhoneAdditionalType3: zod
      .union([
        zod.enum([
          "Undefined",
          "Beeper",
          "Cell",
          "Fax",
          "Home",
          "Work",
          "Night",
          "Primary",
        ]),
        zod.null(),
      ])
      .optional(),
    DEANumber: zod.union([zod.string(), zod.null()]).optional(),
    DEANumbers: zod
      .union([
        zod.array(
          zod.object({
            DEANumber: zod.string(),
            State: zod.union([zod.string(), zod.null()]).optional(),
            ClinicId: zod.union([zod.string(), zod.null()]).optional(),
          }),
        ),
        zod.null(),
      ])
      .optional(),
    NADEANumbers: zod
      .union([
        zod.array(
          zod.object({
            NADEANumber: zod
              .string()
              .regex(
                updateMyDosespotClinicianBodyClinicianInfoNADEANumbersItemNADEANumberRegExp,
              ),
            State: zod.union([zod.string(), zod.null()]).optional(),
            ClinicId: zod.union([zod.string(), zod.null()]).optional(),
          }),
        ),
        zod.null(),
      ])
      .optional(),
    MedicalLicenseNumbers: zod
      .union([
        zod.array(
          zod.object({
            LicenseNumber: zod.string(),
            State: zod.union([zod.string(), zod.null()]).optional(),
            ClinicId: zod.union([zod.string(), zod.null()]).optional(),
          }),
        ),
        zod.null(),
      ])
      .optional(),
    EPCSRequested: zod.union([zod.boolean(), zod.null()]).optional(),
    Active: zod.union([zod.boolean(), zod.null()]).optional(),
    PDMPRoleType: zod
      .union([
        zod.enum([
          "Physician",
          "Dentist",
          "NursePractioner",
          "PhysiciansAssistant",
          "Resident",
          "Intern",
          "Psychologist",
          "Optometrist",
          "NaturopathicPhysician",
        ]),
        zod.null(),
      ])
      .optional(),
    ClinicianSpecialtyType: zod
      .union([
        zod.enum([
          "AllergyAndImmunology",
          "Dermatology",
          "Dentistry",
          "BehavioralHealth",
          "FamilyMedicine",
          "InternalMedicine",
          "ObstetricsAndGynecology",
          "Orthopedics",
          "Pediatrics",
          "PhysicalMedicine",
          "Psychiatry",
          "Urology",
        ]),
        zod.null(),
      ])
      .optional(),
  }),
});

export const updateMyDosespotClinicianResponseCurrentDosespotInfoNADEANumbersItemNADEANumberRegExp =
  new RegExp("^[a-zA-Z0-9]{9}$");

export const updateMyDosespotClinicianResponse = zod
  .object({
    id: zod.uuid(),
    user_id: zod.uuid(),
    dosespot_clinician_id: zod.string(),
    current_dosespot_info: zod
      .object({
        FirstName: zod.string(),
        LastName: zod.string(),
        DateOfBirth: zod.string(),
        Address1: zod.string(),
        City: zod.string(),
        State: zod.string(),
        ZipCode: zod.string(),
        PrimaryPhone: zod.string(),
        PrimaryFax: zod.string(),
        ClinicianId: zod.union([zod.number(), zod.null()]).optional(),
        Prefix: zod.union([zod.string(), zod.null()]).optional(),
        MiddleName: zod.union([zod.string(), zod.null()]).optional(),
        Suffix: zod.union([zod.string(), zod.null()]).optional(),
        Email: zod.union([zod.string(), zod.null()]).optional(),
        Address2: zod.union([zod.string(), zod.null()]).optional(),
        PrimaryPhoneType: zod
          .union([
            zod.enum([
              "Undefined",
              "Beeper",
              "Cell",
              "Fax",
              "Home",
              "Work",
              "Night",
              "Primary",
            ]),
            zod.null(),
          ])
          .optional(),
        PhoneAdditional1: zod.union([zod.string(), zod.null()]).optional(),
        PhoneAdditionalType1: zod
          .union([
            zod.enum([
              "Undefined",
              "Beeper",
              "Cell",
              "Fax",
              "Home",
              "Work",
              "Night",
              "Primary",
            ]),
            zod.null(),
          ])
          .optional(),
        PhoneAdditional2: zod.union([zod.string(), zod.null()]).optional(),
        PhoneAdditionalType2: zod
          .union([
            zod.enum([
              "Undefined",
              "Beeper",
              "Cell",
              "Fax",
              "Home",
              "Work",
              "Night",
              "Primary",
            ]),
            zod.null(),
          ])
          .optional(),
        PhoneAdditional3: zod.union([zod.string(), zod.null()]).optional(),
        PhoneAdditionalType3: zod
          .union([
            zod.enum([
              "Undefined",
              "Beeper",
              "Cell",
              "Fax",
              "Home",
              "Work",
              "Night",
              "Primary",
            ]),
            zod.null(),
          ])
          .optional(),
        DEANumbers: zod
          .union([
            zod.array(
              zod.object({
                DEANumber: zod.string(),
                State: zod.union([zod.string(), zod.null()]).optional(),
                ClinicId: zod.union([zod.string(), zod.null()]).optional(),
              }),
            ),
            zod.null(),
          ])
          .optional(),
        DEANumber: zod.union([zod.string(), zod.null()]).optional(),
        NADEANumbers: zod
          .union([
            zod.array(
              zod.object({
                NADEANumber: zod
                  .string()
                  .regex(
                    updateMyDosespotClinicianResponseCurrentDosespotInfoNADEANumbersItemNADEANumberRegExp,
                  ),
                State: zod.union([zod.string(), zod.null()]).optional(),
                ClinicId: zod.union([zod.string(), zod.null()]).optional(),
              }),
            ),
            zod.null(),
          ])
          .optional(),
        MedicalLicenseNumbers: zod
          .union([
            zod.array(
              zod.object({
                LicenseNumber: zod.string(),
                State: zod.union([zod.string(), zod.null()]).optional(),
                ClinicId: zod.union([zod.string(), zod.null()]).optional(),
              }),
            ),
            zod.null(),
          ])
          .optional(),
        NPINumber: zod.union([zod.string(), zod.null()]).optional(),
        Roles: zod.union([zod.array(zod.string()), zod.null()]).optional(),
        PDMPRoleType: zod
          .union([
            zod.enum([
              "Physician",
              "Dentist",
              "NursePractioner",
              "PhysiciansAssistant",
              "Resident",
              "Intern",
              "Psychologist",
              "Optometrist",
              "NaturopathicPhysician",
            ]),
            zod.null(),
          ])
          .optional(),
        SpecialtyTypeId: zod.union([zod.number(), zod.null()]).optional(),
        Confirmed: zod.union([zod.boolean(), zod.null()]).optional(),
        Active: zod.union([zod.boolean(), zod.null()]).optional(),
        AccountLocked: zod.union([zod.boolean(), zod.null()]).optional(),
        EpcsRequested: zod.union([zod.boolean(), zod.null()]).optional(),
        ClinicInfo: zod
          .union([
            zod.array(
              zod
                .object({
                  ClinicId: zod.union([zod.number(), zod.null()]).optional(),
                  HasNewRx: zod.union([zod.boolean(), zod.null()]).optional(),
                  HasRefills: zod.union([zod.boolean(), zod.null()]).optional(),
                  HasRxChange: zod
                    .union([zod.boolean(), zod.null()])
                    .optional(),
                  HasCancel: zod.union([zod.boolean(), zod.null()]).optional(),
                  HasRxFill: zod.union([zod.boolean(), zod.null()]).optional(),
                  HasEpcs: zod.union([zod.boolean(), zod.null()]).optional(),
                  HasEpa: zod.union([zod.boolean(), zod.null()]).optional(),
                })
                .describe(
                  "Summary of e-prescribing capabilities for a clinician at a specific clinic.",
                ),
            ),
            zod.null(),
          ])
          .optional(),
      })
      .describe("Complete clinician information from DoseSpot API."),
    created_at: zod.iso.datetime({}),
    updated_at: zod.iso.datetime({}),
    mercury_recipient_id: zod.union([zod.string(), zod.null()]).optional(),
  })
  .describe("Record type for DoseSpot clinician information.");

/**
 * Get registration status for the authenticated user.

Returns:
    ErxRegistrationStatusTypeT: The current registration status

Raises:
    AuthException: If the user lacks required privileges
    ValueError: If user doesn't have a DoseSpot clinician record
 * @summary Get My Registration Status
 */
export const getMyRegistrationStatusResponse = zod.enum([
  "Pending",
  "RegistrationSuccess",
  "RegistrationError",
  "IDPSuccess",
  "IDPError",
  "TFAActivateInit",
  "TFAActivatedSuccess",
  "TFAActivatedError",
  "TFADeactivateInit",
  "TFADeactivatedSuccess",
  "TFADeactivatedError",
  "IDPInitializeSuccess",
  "NotApplicable",
]);

/**
 * Get registration status for a specific user.

Args:
    user_id: The user ID to get registration status for

Returns:
    ErxRegistrationStatusTypeT: The current registration status

Raises:
    AuthException: If the user lacks required privileges
    ValueError: If user doesn't have a DoseSpot clinician record
 * @summary Get Registration Status By User Id
 */
export const getRegistrationStatusByUserIdParams = zod.object({
  user_id: zod.uuid(),
});

export const getRegistrationStatusByUserIdResponse = zod.enum([
  "Pending",
  "RegistrationSuccess",
  "RegistrationError",
  "IDPSuccess",
  "IDPError",
  "TFAActivateInit",
  "TFAActivatedSuccess",
  "TFAActivatedError",
  "TFADeactivateInit",
  "TFADeactivatedSuccess",
  "TFADeactivatedError",
  "IDPInitializeSuccess",
  "NotApplicable",
]);

/**
 * Refresh the authenticated user's DoseSpot clinician information from the API.

This endpoint fetches the latest clinician information from DoseSpot API
and updates the stored record with the current data for the authenticated user.

Returns:
    The updated DoseSpot clinician information

Raises:
    AuthException: If the user lacks required privileges
    ValueError: If no clinician record exists for the authenticated user
 * @summary Refresh My Dosespot Clinician Info
 */
export const refreshMyDosespotClinicianInfoResponseNADEANumbersItemNADEANumberRegExp =
  new RegExp("^[a-zA-Z0-9]{9}$");

export const refreshMyDosespotClinicianInfoResponse = zod
  .object({
    FirstName: zod.string(),
    LastName: zod.string(),
    DateOfBirth: zod.string(),
    Address1: zod.string(),
    City: zod.string(),
    State: zod.string(),
    ZipCode: zod.string(),
    PrimaryPhone: zod.string(),
    PrimaryFax: zod.string(),
    ClinicianId: zod.union([zod.number(), zod.null()]).optional(),
    Prefix: zod.union([zod.string(), zod.null()]).optional(),
    MiddleName: zod.union([zod.string(), zod.null()]).optional(),
    Suffix: zod.union([zod.string(), zod.null()]).optional(),
    Email: zod.union([zod.string(), zod.null()]).optional(),
    Address2: zod.union([zod.string(), zod.null()]).optional(),
    PrimaryPhoneType: zod
      .union([
        zod.enum([
          "Undefined",
          "Beeper",
          "Cell",
          "Fax",
          "Home",
          "Work",
          "Night",
          "Primary",
        ]),
        zod.null(),
      ])
      .optional(),
    PhoneAdditional1: zod.union([zod.string(), zod.null()]).optional(),
    PhoneAdditionalType1: zod
      .union([
        zod.enum([
          "Undefined",
          "Beeper",
          "Cell",
          "Fax",
          "Home",
          "Work",
          "Night",
          "Primary",
        ]),
        zod.null(),
      ])
      .optional(),
    PhoneAdditional2: zod.union([zod.string(), zod.null()]).optional(),
    PhoneAdditionalType2: zod
      .union([
        zod.enum([
          "Undefined",
          "Beeper",
          "Cell",
          "Fax",
          "Home",
          "Work",
          "Night",
          "Primary",
        ]),
        zod.null(),
      ])
      .optional(),
    PhoneAdditional3: zod.union([zod.string(), zod.null()]).optional(),
    PhoneAdditionalType3: zod
      .union([
        zod.enum([
          "Undefined",
          "Beeper",
          "Cell",
          "Fax",
          "Home",
          "Work",
          "Night",
          "Primary",
        ]),
        zod.null(),
      ])
      .optional(),
    DEANumbers: zod
      .union([
        zod.array(
          zod.object({
            DEANumber: zod.string(),
            State: zod.union([zod.string(), zod.null()]).optional(),
            ClinicId: zod.union([zod.string(), zod.null()]).optional(),
          }),
        ),
        zod.null(),
      ])
      .optional(),
    DEANumber: zod.union([zod.string(), zod.null()]).optional(),
    NADEANumbers: zod
      .union([
        zod.array(
          zod.object({
            NADEANumber: zod
              .string()
              .regex(
                refreshMyDosespotClinicianInfoResponseNADEANumbersItemNADEANumberRegExp,
              ),
            State: zod.union([zod.string(), zod.null()]).optional(),
            ClinicId: zod.union([zod.string(), zod.null()]).optional(),
          }),
        ),
        zod.null(),
      ])
      .optional(),
    MedicalLicenseNumbers: zod
      .union([
        zod.array(
          zod.object({
            LicenseNumber: zod.string(),
            State: zod.union([zod.string(), zod.null()]).optional(),
            ClinicId: zod.union([zod.string(), zod.null()]).optional(),
          }),
        ),
        zod.null(),
      ])
      .optional(),
    NPINumber: zod.union([zod.string(), zod.null()]).optional(),
    Roles: zod.union([zod.array(zod.string()), zod.null()]).optional(),
    PDMPRoleType: zod
      .union([
        zod.enum([
          "Physician",
          "Dentist",
          "NursePractioner",
          "PhysiciansAssistant",
          "Resident",
          "Intern",
          "Psychologist",
          "Optometrist",
          "NaturopathicPhysician",
        ]),
        zod.null(),
      ])
      .optional(),
    SpecialtyTypeId: zod.union([zod.number(), zod.null()]).optional(),
    Confirmed: zod.union([zod.boolean(), zod.null()]).optional(),
    Active: zod.union([zod.boolean(), zod.null()]).optional(),
    AccountLocked: zod.union([zod.boolean(), zod.null()]).optional(),
    EpcsRequested: zod.union([zod.boolean(), zod.null()]).optional(),
    ClinicInfo: zod
      .union([
        zod.array(
          zod
            .object({
              ClinicId: zod.union([zod.number(), zod.null()]).optional(),
              HasNewRx: zod.union([zod.boolean(), zod.null()]).optional(),
              HasRefills: zod.union([zod.boolean(), zod.null()]).optional(),
              HasRxChange: zod.union([zod.boolean(), zod.null()]).optional(),
              HasCancel: zod.union([zod.boolean(), zod.null()]).optional(),
              HasRxFill: zod.union([zod.boolean(), zod.null()]).optional(),
              HasEpcs: zod.union([zod.boolean(), zod.null()]).optional(),
              HasEpa: zod.union([zod.boolean(), zod.null()]).optional(),
            })
            .describe(
              "Summary of e-prescribing capabilities for a clinician at a specific clinic.",
            ),
        ),
        zod.null(),
      ])
      .optional(),
  })
  .describe("Complete clinician information from DoseSpot API.");

/**
 * Refresh DoseSpot clinician information from the API.

This endpoint fetches the latest clinician information from DoseSpot API
and updates the stored record with the current data.

Args:
    user_id: The user ID of the clinician to refresh

Returns:
    The updated DoseSpot clinician information

Raises:
    AuthException: If the user lacks required privileges
    ValueError: If no clinician record exists for the user
 * @summary Refresh Dosespot Clinician Info
 */
export const refreshDosespotClinicianInfoParams = zod.object({
  user_id: zod.uuid(),
});

export const refreshDosespotClinicianInfoResponseNADEANumbersItemNADEANumberRegExp =
  new RegExp("^[a-zA-Z0-9]{9}$");

export const refreshDosespotClinicianInfoResponse = zod
  .object({
    FirstName: zod.string(),
    LastName: zod.string(),
    DateOfBirth: zod.string(),
    Address1: zod.string(),
    City: zod.string(),
    State: zod.string(),
    ZipCode: zod.string(),
    PrimaryPhone: zod.string(),
    PrimaryFax: zod.string(),
    ClinicianId: zod.union([zod.number(), zod.null()]).optional(),
    Prefix: zod.union([zod.string(), zod.null()]).optional(),
    MiddleName: zod.union([zod.string(), zod.null()]).optional(),
    Suffix: zod.union([zod.string(), zod.null()]).optional(),
    Email: zod.union([zod.string(), zod.null()]).optional(),
    Address2: zod.union([zod.string(), zod.null()]).optional(),
    PrimaryPhoneType: zod
      .union([
        zod.enum([
          "Undefined",
          "Beeper",
          "Cell",
          "Fax",
          "Home",
          "Work",
          "Night",
          "Primary",
        ]),
        zod.null(),
      ])
      .optional(),
    PhoneAdditional1: zod.union([zod.string(), zod.null()]).optional(),
    PhoneAdditionalType1: zod
      .union([
        zod.enum([
          "Undefined",
          "Beeper",
          "Cell",
          "Fax",
          "Home",
          "Work",
          "Night",
          "Primary",
        ]),
        zod.null(),
      ])
      .optional(),
    PhoneAdditional2: zod.union([zod.string(), zod.null()]).optional(),
    PhoneAdditionalType2: zod
      .union([
        zod.enum([
          "Undefined",
          "Beeper",
          "Cell",
          "Fax",
          "Home",
          "Work",
          "Night",
          "Primary",
        ]),
        zod.null(),
      ])
      .optional(),
    PhoneAdditional3: zod.union([zod.string(), zod.null()]).optional(),
    PhoneAdditionalType3: zod
      .union([
        zod.enum([
          "Undefined",
          "Beeper",
          "Cell",
          "Fax",
          "Home",
          "Work",
          "Night",
          "Primary",
        ]),
        zod.null(),
      ])
      .optional(),
    DEANumbers: zod
      .union([
        zod.array(
          zod.object({
            DEANumber: zod.string(),
            State: zod.union([zod.string(), zod.null()]).optional(),
            ClinicId: zod.union([zod.string(), zod.null()]).optional(),
          }),
        ),
        zod.null(),
      ])
      .optional(),
    DEANumber: zod.union([zod.string(), zod.null()]).optional(),
    NADEANumbers: zod
      .union([
        zod.array(
          zod.object({
            NADEANumber: zod
              .string()
              .regex(
                refreshDosespotClinicianInfoResponseNADEANumbersItemNADEANumberRegExp,
              ),
            State: zod.union([zod.string(), zod.null()]).optional(),
            ClinicId: zod.union([zod.string(), zod.null()]).optional(),
          }),
        ),
        zod.null(),
      ])
      .optional(),
    MedicalLicenseNumbers: zod
      .union([
        zod.array(
          zod.object({
            LicenseNumber: zod.string(),
            State: zod.union([zod.string(), zod.null()]).optional(),
            ClinicId: zod.union([zod.string(), zod.null()]).optional(),
          }),
        ),
        zod.null(),
      ])
      .optional(),
    NPINumber: zod.union([zod.string(), zod.null()]).optional(),
    Roles: zod.union([zod.array(zod.string()), zod.null()]).optional(),
    PDMPRoleType: zod
      .union([
        zod.enum([
          "Physician",
          "Dentist",
          "NursePractioner",
          "PhysiciansAssistant",
          "Resident",
          "Intern",
          "Psychologist",
          "Optometrist",
          "NaturopathicPhysician",
        ]),
        zod.null(),
      ])
      .optional(),
    SpecialtyTypeId: zod.union([zod.number(), zod.null()]).optional(),
    Confirmed: zod.union([zod.boolean(), zod.null()]).optional(),
    Active: zod.union([zod.boolean(), zod.null()]).optional(),
    AccountLocked: zod.union([zod.boolean(), zod.null()]).optional(),
    EpcsRequested: zod.union([zod.boolean(), zod.null()]).optional(),
    ClinicInfo: zod
      .union([
        zod.array(
          zod
            .object({
              ClinicId: zod.union([zod.number(), zod.null()]).optional(),
              HasNewRx: zod.union([zod.boolean(), zod.null()]).optional(),
              HasRefills: zod.union([zod.boolean(), zod.null()]).optional(),
              HasRxChange: zod.union([zod.boolean(), zod.null()]).optional(),
              HasCancel: zod.union([zod.boolean(), zod.null()]).optional(),
              HasRxFill: zod.union([zod.boolean(), zod.null()]).optional(),
              HasEpcs: zod.union([zod.boolean(), zod.null()]).optional(),
              HasEpa: zod.union([zod.boolean(), zod.null()]).optional(),
            })
            .describe(
              "Summary of e-prescribing capabilities for a clinician at a specific clinic.",
            ),
        ),
        zod.null(),
      ])
      .optional(),
  })
  .describe("Complete clinician information from DoseSpot API.");

/**
 * Get IDP status for the authenticated user.

Returns:
    DosespotIDPRecordT: Current IDP record, or None if no IDP process started

Raises:
    AuthException: If the user lacks required privileges
 * @summary Get My Idp Status
 */
export const getMyIdpStatusResponse = zod.union([
  zod
    .object({
      id: zod.uuid(),
      user_id: zod.uuid(),
      current_state: zod
        .enum([
          "NEEDS_TO_SIGN_DISCLAIMER",
          "NEEDS_TO_SIGN_LEGAL_AGREEMENTS",
          "NEEDS_TO_SUBMIT_DEMOGRAPHIC_INFO",
          "NEEDS_TO_SUBMIT_ANSWERS",
          "NEEDS_TO_SUBMIT_OTP",
          "COMPLETED",
          "ERROR",
        ])
        .describe("IDP process states."),
      session_id: zod.union([zod.string(), zod.null()]).optional(),
      is_otp_sent: zod.union([zod.boolean(), zod.null()]).optional(),
      idp_questions_and_choices: zod
        .union([
          zod
            .object({
              questions: zod.array(zod.string()),
              answer_choices: zod.array(zod.array(zod.string())),
            })
            .describe(
              "Structured type for IDP questions and their answer choices.",
            ),
          zod.null(),
        ])
        .optional(),
      error_message: zod.union([zod.string(), zod.null()]).optional(),
      pending_legal_agreements: zod
        .union([
          zod
            .object({
              pending_agreements: zod.array(zod.number()),
            })
            .describe("Structured type for pending legal agreements."),
          zod.null(),
        ])
        .optional(),
      created_at: zod.iso.datetime({}),
      updated_at: zod.iso.datetime({}),
    })
    .describe("Record type for DoseSpot IDP process tracking."),
  zod.null(),
]);

/**
 * Get the IDP disclaimer for the authenticated user.

Returns:
    IdpDisclaimerT: The IDP disclaimer information

Raises:
    AuthException: If the user lacks required privileges
    ValueError: If user doesn't have a DoseSpot clinician record
 * @summary Get Idp Disclaimer
 */
export const getIdpDisclaimerResponse = zod
  .object({
    IdpDisclaimerDate: zod.union([zod.string(), zod.null()]).optional(),
    IdpDisclaimerId: zod.union([zod.number(), zod.null()]).optional(),
    IdpDisclaimerText: zod.union([zod.string(), zod.null()]).optional(),
  })
  .describe("Identity proofing disclaimer information.");

/**
 * Get the legal agreements for the authenticated user.

Returns:
    List[DoseSpotClinicianAgreementT]: The legal agreements that need to be accepted

Raises:
    AuthException: If the user lacks required privileges
    ValueError: If user doesn't have a DoseSpot clinician record
 * @summary Get Idp Legal Agreements
 */
export const getIdpLegalAgreementsResponseItem = zod
  .object({
    AgreementId: zod.union([zod.number(), zod.null()]).optional(),
    AgreementDate: zod.union([zod.string(), zod.null()]).optional(),
    AgreementText: zod.union([zod.string(), zod.null()]).optional(),
  })
  .describe("DoseSpot clinician legal agreement information.");
export const getIdpLegalAgreementsResponse = zod.array(
  getIdpLegalAgreementsResponseItem,
);

/**
 * Start the IDP process for the authenticated user.

Returns:
    DosespotIDPRecordT: The created/updated IDP record

Raises:
    AuthException: If the user lacks required privileges
    ValueError: If user doesn't have a DoseSpot clinician record
 * @summary Start Idp Process
 */
export const startIdpProcessResponse = zod
  .object({
    id: zod.uuid(),
    user_id: zod.uuid(),
    current_state: zod
      .enum([
        "NEEDS_TO_SIGN_DISCLAIMER",
        "NEEDS_TO_SIGN_LEGAL_AGREEMENTS",
        "NEEDS_TO_SUBMIT_DEMOGRAPHIC_INFO",
        "NEEDS_TO_SUBMIT_ANSWERS",
        "NEEDS_TO_SUBMIT_OTP",
        "COMPLETED",
        "ERROR",
      ])
      .describe("IDP process states."),
    session_id: zod.union([zod.string(), zod.null()]).optional(),
    is_otp_sent: zod.union([zod.boolean(), zod.null()]).optional(),
    idp_questions_and_choices: zod
      .union([
        zod
          .object({
            questions: zod.array(zod.string()),
            answer_choices: zod.array(zod.array(zod.string())),
          })
          .describe(
            "Structured type for IDP questions and their answer choices.",
          ),
        zod.null(),
      ])
      .optional(),
    error_message: zod.union([zod.string(), zod.null()]).optional(),
    pending_legal_agreements: zod
      .union([
        zod
          .object({
            pending_agreements: zod.array(zod.number()),
          })
          .describe("Structured type for pending legal agreements."),
        zod.null(),
      ])
      .optional(),
    created_at: zod.iso.datetime({}),
    updated_at: zod.iso.datetime({}),
  })
  .describe("Record type for DoseSpot IDP process tracking.");

/**
 * Accept the IDP disclaimer for the authenticated user.

Returns:
    DosespotIDPRecordT: The updated IDP record

Raises:
    AuthException: If the user lacks required privileges
    ValueError: If no active IDP process or disclaimer already accepted
 * @summary Accept Idp Disclaimer
 */
export const acceptIdpDisclaimerResponse = zod
  .object({
    id: zod.uuid(),
    user_id: zod.uuid(),
    current_state: zod
      .enum([
        "NEEDS_TO_SIGN_DISCLAIMER",
        "NEEDS_TO_SIGN_LEGAL_AGREEMENTS",
        "NEEDS_TO_SUBMIT_DEMOGRAPHIC_INFO",
        "NEEDS_TO_SUBMIT_ANSWERS",
        "NEEDS_TO_SUBMIT_OTP",
        "COMPLETED",
        "ERROR",
      ])
      .describe("IDP process states."),
    session_id: zod.union([zod.string(), zod.null()]).optional(),
    is_otp_sent: zod.union([zod.boolean(), zod.null()]).optional(),
    idp_questions_and_choices: zod
      .union([
        zod
          .object({
            questions: zod.array(zod.string()),
            answer_choices: zod.array(zod.array(zod.string())),
          })
          .describe(
            "Structured type for IDP questions and their answer choices.",
          ),
        zod.null(),
      ])
      .optional(),
    error_message: zod.union([zod.string(), zod.null()]).optional(),
    pending_legal_agreements: zod
      .union([
        zod
          .object({
            pending_agreements: zod.array(zod.number()),
          })
          .describe("Structured type for pending legal agreements."),
        zod.null(),
      ])
      .optional(),
    created_at: zod.iso.datetime({}),
    updated_at: zod.iso.datetime({}),
  })
  .describe("Record type for DoseSpot IDP process tracking.");

/**
 * Accept all pending legal agreements for the authenticated user.

Args:
    request: The signature name to use for accepting agreements

Returns:
    DosespotIDPRecordT: The updated IDP record

Raises:
    AuthException: If the user lacks required privileges
    ValueError: If no active IDP process or agreements already accepted
 * @summary Accept Legal Agreements
 */
export const acceptLegalAgreementsBody = zod.object({
  nameSigned: zod.string(),
});

export const acceptLegalAgreementsResponse = zod
  .object({
    id: zod.uuid(),
    user_id: zod.uuid(),
    current_state: zod
      .enum([
        "NEEDS_TO_SIGN_DISCLAIMER",
        "NEEDS_TO_SIGN_LEGAL_AGREEMENTS",
        "NEEDS_TO_SUBMIT_DEMOGRAPHIC_INFO",
        "NEEDS_TO_SUBMIT_ANSWERS",
        "NEEDS_TO_SUBMIT_OTP",
        "COMPLETED",
        "ERROR",
      ])
      .describe("IDP process states."),
    session_id: zod.union([zod.string(), zod.null()]).optional(),
    is_otp_sent: zod.union([zod.boolean(), zod.null()]).optional(),
    idp_questions_and_choices: zod
      .union([
        zod
          .object({
            questions: zod.array(zod.string()),
            answer_choices: zod.array(zod.array(zod.string())),
          })
          .describe(
            "Structured type for IDP questions and their answer choices.",
          ),
        zod.null(),
      ])
      .optional(),
    error_message: zod.union([zod.string(), zod.null()]).optional(),
    pending_legal_agreements: zod
      .union([
        zod
          .object({
            pending_agreements: zod.array(zod.number()),
          })
          .describe("Structured type for pending legal agreements."),
        zod.null(),
      ])
      .optional(),
    created_at: zod.iso.datetime({}),
    updated_at: zod.iso.datetime({}),
  })
  .describe("Record type for DoseSpot IDP process tracking.");

/**
 * Submit demographic information for IDP.

Args:
    request: The demographic information to submit

Returns:
    DosespotIDPRecordT: The updated IDP record

Raises:
    AuthException: If the user lacks required privileges
    ValueError: If no active IDP process or demographic info already submitted
 * @summary Submit Demographic Info
 */
export const submitDemographicInfoBody = zod.object({
  demographicInfo: zod
    .object({
      FirstName: zod.string(),
      MiddleName: zod.union([zod.string(), zod.null()]).optional(),
      LastName: zod.string(),
      HomeAddress: zod.string(),
      City: zod.string(),
      State: zod.string(),
      ZipCode: zod.string(),
      DateOfBirth: zod.iso.datetime({}),
      SocialSecurityNumber: zod.string(),
      CreditCardNumber: zod.string(),
      DrivingLicenseNumber: zod.union([zod.string(), zod.null()]).optional(),
      DrivingLicenseNumberState: zod
        .union([zod.string(), zod.null()])
        .optional(),
      PhoneNumber: zod.string(),
      IsMobileNumber: zod.boolean(),
    })
    .describe(
      "Request for clinician identity proofing.\n\n`PhoneNumber` is normalized to a bare 10-digit NANP string before it is\nsent to DoseSpot. DoseSpot's IDP endpoint forwards the number to Experian\nfor SMS-based identity capture, and Experian rejects (or, in the wild,\nsilently hangs on) numbers that contain `+`, country-code prefixes, or\nformatting characters. We rely on the shared `validate_phone_number`\nhelper so this contract is enforced regardless of which client sends the\nrequest -- the frontend already calls `stripPhone()` before submit, but\nthe backend should not trust that.",
    ),
});

export const submitDemographicInfoResponse = zod
  .object({
    id: zod.uuid(),
    user_id: zod.uuid(),
    current_state: zod
      .enum([
        "NEEDS_TO_SIGN_DISCLAIMER",
        "NEEDS_TO_SIGN_LEGAL_AGREEMENTS",
        "NEEDS_TO_SUBMIT_DEMOGRAPHIC_INFO",
        "NEEDS_TO_SUBMIT_ANSWERS",
        "NEEDS_TO_SUBMIT_OTP",
        "COMPLETED",
        "ERROR",
      ])
      .describe("IDP process states."),
    session_id: zod.union([zod.string(), zod.null()]).optional(),
    is_otp_sent: zod.union([zod.boolean(), zod.null()]).optional(),
    idp_questions_and_choices: zod
      .union([
        zod
          .object({
            questions: zod.array(zod.string()),
            answer_choices: zod.array(zod.array(zod.string())),
          })
          .describe(
            "Structured type for IDP questions and their answer choices.",
          ),
        zod.null(),
      ])
      .optional(),
    error_message: zod.union([zod.string(), zod.null()]).optional(),
    pending_legal_agreements: zod
      .union([
        zod
          .object({
            pending_agreements: zod.array(zod.number()),
          })
          .describe("Structured type for pending legal agreements."),
        zod.null(),
      ])
      .optional(),
    created_at: zod.iso.datetime({}),
    updated_at: zod.iso.datetime({}),
  })
  .describe("Record type for DoseSpot IDP process tracking.");

/**
 * Submit answers to IDP questions.

Args:
    request: The answers to IDP questions

Returns:
    DosespotIDPRecordT: The updated IDP record

Raises:
    AuthException: If the user lacks required privileges
    fastapi.HTTPException: 422 when the request is client-correctable
        (e.g. no active IDP session, or DoseSpot's own structured
        rejection of the call). 500 for unexpected errors.
 * @summary Submit Idp Answers
 */
export const submitIdpAnswersBody = zod.object({
  answers: zod.array(zod.string()),
});

export const submitIdpAnswersResponse = zod
  .object({
    id: zod.uuid(),
    user_id: zod.uuid(),
    current_state: zod
      .enum([
        "NEEDS_TO_SIGN_DISCLAIMER",
        "NEEDS_TO_SIGN_LEGAL_AGREEMENTS",
        "NEEDS_TO_SUBMIT_DEMOGRAPHIC_INFO",
        "NEEDS_TO_SUBMIT_ANSWERS",
        "NEEDS_TO_SUBMIT_OTP",
        "COMPLETED",
        "ERROR",
      ])
      .describe("IDP process states."),
    session_id: zod.union([zod.string(), zod.null()]).optional(),
    is_otp_sent: zod.union([zod.boolean(), zod.null()]).optional(),
    idp_questions_and_choices: zod
      .union([
        zod
          .object({
            questions: zod.array(zod.string()),
            answer_choices: zod.array(zod.array(zod.string())),
          })
          .describe(
            "Structured type for IDP questions and their answer choices.",
          ),
        zod.null(),
      ])
      .optional(),
    error_message: zod.union([zod.string(), zod.null()]).optional(),
    pending_legal_agreements: zod
      .union([
        zod
          .object({
            pending_agreements: zod.array(zod.number()),
          })
          .describe("Structured type for pending legal agreements."),
        zod.null(),
      ])
      .optional(),
    created_at: zod.iso.datetime({}),
    updated_at: zod.iso.datetime({}),
  })
  .describe("Record type for DoseSpot IDP process tracking.");

/**
 * Deprecated no-op: identity verification no longer uses an OTP code.

DoseSpot has marked the upstream `idpOtp` endpoint obsolete. Identity
capture now completes out-of-band via the SMS link Experian sends
after `POST /idp` (or `POST /idpAnswers`) returns `IDCapture = true`.
The frontend renders an Experian-wait view for the `submit_otp` state
and polls `registrationStatus` until the upstream `IDPSuccess` is
observed -- no manual code entry exists in our UI anymore.

The response is whatever IDP record we already have on file. Clients
should rely on `GET /dosespot/idp/me` polling for state advancement.

Returns:
    DosespotIDPRecordT: The current persisted IDP record for the user.

Raises:
    AuthException: If the user lacks required privileges.
    fastapi.HTTPException: 404 when no IDP record exists for the user
        (i.e. they are calling this before any IDP step has run).
 * @summary Submit Idp Otp
 */
export const submitIdpOtpBody = zod.object({
  otp: zod.string(),
});

export const submitIdpOtpResponse = zod
  .object({
    id: zod.uuid(),
    user_id: zod.uuid(),
    current_state: zod
      .enum([
        "NEEDS_TO_SIGN_DISCLAIMER",
        "NEEDS_TO_SIGN_LEGAL_AGREEMENTS",
        "NEEDS_TO_SUBMIT_DEMOGRAPHIC_INFO",
        "NEEDS_TO_SUBMIT_ANSWERS",
        "NEEDS_TO_SUBMIT_OTP",
        "COMPLETED",
        "ERROR",
      ])
      .describe("IDP process states."),
    session_id: zod.union([zod.string(), zod.null()]).optional(),
    is_otp_sent: zod.union([zod.boolean(), zod.null()]).optional(),
    idp_questions_and_choices: zod
      .union([
        zod
          .object({
            questions: zod.array(zod.string()),
            answer_choices: zod.array(zod.array(zod.string())),
          })
          .describe(
            "Structured type for IDP questions and their answer choices.",
          ),
        zod.null(),
      ])
      .optional(),
    error_message: zod.union([zod.string(), zod.null()]).optional(),
    pending_legal_agreements: zod
      .union([
        zod
          .object({
            pending_agreements: zod.array(zod.number()),
          })
          .describe("Structured type for pending legal agreements."),
        zod.null(),
      ])
      .optional(),
    created_at: zod.iso.datetime({}),
    updated_at: zod.iso.datetime({}),
  })
  .describe("Record type for DoseSpot IDP process tracking.");

/**
 * Sync the authenticated user's patient information to DoseSpot.

This endpoint creates or updates a DoseSpot patient record for the authenticated user
by calling the sync_and_fetch method from the patient model.

Returns:
    DoseSpotPatientSyncResultT: The sync result with patient record and info

Raises:
    AuthException: If the user lacks required privileges
    ValueError: If user info is insufficient for sync
 * @summary Sync My Dosespot Patient
 */
export const syncMyDosespotPatientResponse = zod
  .object({
    patient_record: zod
      .object({
        id: zod.uuid(),
        user_id: zod.uuid(),
        dosespot_patient_id: zod.union([zod.string(), zod.null()]).optional(),
        associated_clinician_id: zod
          .union([zod.string(), zod.null()])
          .optional(),
        last_sync_status: zod
          .union([
            zod
              .enum(["success", "failed", "pending", "unknown"])
              .describe("Enum for DoseSpot patient sync status values."),
            zod.null(),
          ])
          .optional(),
        last_sync_error: zod.union([zod.string(), zod.null()]).optional(),
        created_at: zod.iso.datetime({}),
        updated_at: zod.iso.datetime({}),
      })
      .describe("Record type for DoseSpot patient information."),
    patient_info: zod
      .union([
        zod
          .object({
            FirstName: zod.string(),
            LastName: zod.string(),
            DateOfBirth: zod.string(),
            Gender: zod.enum(["Male", "Female", "Unknown"]),
            Address1: zod.string(),
            City: zod.string(),
            State: zod.string(),
            ZipCode: zod.string(),
            PrimaryPhone: zod.union([zod.string(), zod.null()]).optional(),
            Active: zod.boolean(),
            PatientId: zod.union([zod.number(), zod.null()]).optional(),
            Prefix: zod.union([zod.string(), zod.null()]).optional(),
            MiddleName: zod.union([zod.string(), zod.null()]).optional(),
            Suffix: zod.union([zod.string(), zod.null()]).optional(),
            Email: zod.union([zod.string(), zod.null()]).optional(),
            Address2: zod.union([zod.string(), zod.null()]).optional(),
            PhoneAdditional1: zod.union([zod.string(), zod.null()]).optional(),
            PhoneAdditional2: zod.union([zod.string(), zod.null()]).optional(),
            PhoneAdditionalType1: zod
              .union([
                zod.enum([
                  "Undefined",
                  "Beeper",
                  "Cell",
                  "Fax",
                  "Home",
                  "Work",
                  "Night",
                  "Primary",
                ]),
                zod.null(),
              ])
              .optional(),
            PhoneAdditionalType2: zod
              .union([
                zod.enum([
                  "Undefined",
                  "Beeper",
                  "Cell",
                  "Fax",
                  "Home",
                  "Work",
                  "Night",
                  "Primary",
                ]),
                zod.null(),
              ])
              .optional(),
            PrimaryPhoneType: zod
              .union([
                zod.enum([
                  "Undefined",
                  "Beeper",
                  "Cell",
                  "Fax",
                  "Home",
                  "Work",
                  "Night",
                  "Primary",
                ]),
                zod.null(),
              ])
              .optional(),
            Weight: zod.union([zod.number(), zod.null()]).optional(),
            WeightMetric: zod
              .union([
                zod
                  .enum(["lb", "kg"])
                  .describe("Valid weight metrics for DoseSpot patients."),
                zod.null(),
              ])
              .optional(),
            Height: zod.union([zod.number(), zod.null()]).optional(),
            HeightMetric: zod
              .union([
                zod
                  .enum(["inch", "cm"])
                  .describe("Valid height metrics for DoseSpot patients."),
                zod.null(),
              ])
              .optional(),
            NonDoseSpotMedicalRecordNumber: zod
              .union([zod.string(), zod.null()])
              .optional(),
            Encounter: zod.union([zod.string(), zod.null()]).optional(),
            IsHospice: zod.union([zod.boolean(), zod.null()]).optional(),
            Last4SSN: zod.union([zod.string(), zod.null()]).optional(),
          })
          .describe("Patient demographic information from DoseSpot API."),
        zod.null(),
      ])
      .optional(),
    sync_successful: zod.boolean(),
    error_message: zod.union([zod.string(), zod.null()]).optional(),
  })
  .describe("Response type for DoseSpot patient sync operations.");

/**
 * Sync a user's patient information to DoseSpot.

This endpoint creates or updates a DoseSpot patient record for the specified user
by calling the sync_and_fetch method from the patient model.

Args:
    user_id: The user ID to sync to DoseSpot

Returns:
    DoseSpotPatientSyncResultT: The sync result with patient record and info

Raises:
    AuthException: If the user lacks required privileges
    ValueError: If user info is insufficient for sync
 * @summary Sync Dosespot Patient
 */
export const syncDosespotPatientParams = zod.object({
  user_id: zod.uuid(),
});

export const syncDosespotPatientResponse = zod
  .object({
    patient_record: zod
      .object({
        id: zod.uuid(),
        user_id: zod.uuid(),
        dosespot_patient_id: zod.union([zod.string(), zod.null()]).optional(),
        associated_clinician_id: zod
          .union([zod.string(), zod.null()])
          .optional(),
        last_sync_status: zod
          .union([
            zod
              .enum(["success", "failed", "pending", "unknown"])
              .describe("Enum for DoseSpot patient sync status values."),
            zod.null(),
          ])
          .optional(),
        last_sync_error: zod.union([zod.string(), zod.null()]).optional(),
        created_at: zod.iso.datetime({}),
        updated_at: zod.iso.datetime({}),
      })
      .describe("Record type for DoseSpot patient information."),
    patient_info: zod
      .union([
        zod
          .object({
            FirstName: zod.string(),
            LastName: zod.string(),
            DateOfBirth: zod.string(),
            Gender: zod.enum(["Male", "Female", "Unknown"]),
            Address1: zod.string(),
            City: zod.string(),
            State: zod.string(),
            ZipCode: zod.string(),
            PrimaryPhone: zod.union([zod.string(), zod.null()]).optional(),
            Active: zod.boolean(),
            PatientId: zod.union([zod.number(), zod.null()]).optional(),
            Prefix: zod.union([zod.string(), zod.null()]).optional(),
            MiddleName: zod.union([zod.string(), zod.null()]).optional(),
            Suffix: zod.union([zod.string(), zod.null()]).optional(),
            Email: zod.union([zod.string(), zod.null()]).optional(),
            Address2: zod.union([zod.string(), zod.null()]).optional(),
            PhoneAdditional1: zod.union([zod.string(), zod.null()]).optional(),
            PhoneAdditional2: zod.union([zod.string(), zod.null()]).optional(),
            PhoneAdditionalType1: zod
              .union([
                zod.enum([
                  "Undefined",
                  "Beeper",
                  "Cell",
                  "Fax",
                  "Home",
                  "Work",
                  "Night",
                  "Primary",
                ]),
                zod.null(),
              ])
              .optional(),
            PhoneAdditionalType2: zod
              .union([
                zod.enum([
                  "Undefined",
                  "Beeper",
                  "Cell",
                  "Fax",
                  "Home",
                  "Work",
                  "Night",
                  "Primary",
                ]),
                zod.null(),
              ])
              .optional(),
            PrimaryPhoneType: zod
              .union([
                zod.enum([
                  "Undefined",
                  "Beeper",
                  "Cell",
                  "Fax",
                  "Home",
                  "Work",
                  "Night",
                  "Primary",
                ]),
                zod.null(),
              ])
              .optional(),
            Weight: zod.union([zod.number(), zod.null()]).optional(),
            WeightMetric: zod
              .union([
                zod
                  .enum(["lb", "kg"])
                  .describe("Valid weight metrics for DoseSpot patients."),
                zod.null(),
              ])
              .optional(),
            Height: zod.union([zod.number(), zod.null()]).optional(),
            HeightMetric: zod
              .union([
                zod
                  .enum(["inch", "cm"])
                  .describe("Valid height metrics for DoseSpot patients."),
                zod.null(),
              ])
              .optional(),
            NonDoseSpotMedicalRecordNumber: zod
              .union([zod.string(), zod.null()])
              .optional(),
            Encounter: zod.union([zod.string(), zod.null()]).optional(),
            IsHospice: zod.union([zod.boolean(), zod.null()]).optional(),
            Last4SSN: zod.union([zod.string(), zod.null()]).optional(),
          })
          .describe("Patient demographic information from DoseSpot API."),
        zod.null(),
      ])
      .optional(),
    sync_successful: zod.boolean(),
    error_message: zod.union([zod.string(), zod.null()]).optional(),
  })
  .describe("Response type for DoseSpot patient sync operations.");

/**
 * Get the authenticated user's DoseSpot patient information.

This endpoint fetches the current patient information from DoseSpot API
for the authenticated user.

Returns:
    PatientT or None: The patient information if available

Raises:
    AuthException: If the user lacks required privileges
    ValueError: If no patient record exists for the user
 * @summary Get My Dosespot Patient Info
 */
export const getMyDosespotPatientInfoResponse = zod.union([
  zod
    .object({
      FirstName: zod.string(),
      LastName: zod.string(),
      DateOfBirth: zod.string(),
      Gender: zod.enum(["Male", "Female", "Unknown"]),
      Address1: zod.string(),
      City: zod.string(),
      State: zod.string(),
      ZipCode: zod.string(),
      PrimaryPhone: zod.union([zod.string(), zod.null()]).optional(),
      Active: zod.boolean(),
      PatientId: zod.union([zod.number(), zod.null()]).optional(),
      Prefix: zod.union([zod.string(), zod.null()]).optional(),
      MiddleName: zod.union([zod.string(), zod.null()]).optional(),
      Suffix: zod.union([zod.string(), zod.null()]).optional(),
      Email: zod.union([zod.string(), zod.null()]).optional(),
      Address2: zod.union([zod.string(), zod.null()]).optional(),
      PhoneAdditional1: zod.union([zod.string(), zod.null()]).optional(),
      PhoneAdditional2: zod.union([zod.string(), zod.null()]).optional(),
      PhoneAdditionalType1: zod
        .union([
          zod.enum([
            "Undefined",
            "Beeper",
            "Cell",
            "Fax",
            "Home",
            "Work",
            "Night",
            "Primary",
          ]),
          zod.null(),
        ])
        .optional(),
      PhoneAdditionalType2: zod
        .union([
          zod.enum([
            "Undefined",
            "Beeper",
            "Cell",
            "Fax",
            "Home",
            "Work",
            "Night",
            "Primary",
          ]),
          zod.null(),
        ])
        .optional(),
      PrimaryPhoneType: zod
        .union([
          zod.enum([
            "Undefined",
            "Beeper",
            "Cell",
            "Fax",
            "Home",
            "Work",
            "Night",
            "Primary",
          ]),
          zod.null(),
        ])
        .optional(),
      Weight: zod.union([zod.number(), zod.null()]).optional(),
      WeightMetric: zod
        .union([
          zod
            .enum(["lb", "kg"])
            .describe("Valid weight metrics for DoseSpot patients."),
          zod.null(),
        ])
        .optional(),
      Height: zod.union([zod.number(), zod.null()]).optional(),
      HeightMetric: zod
        .union([
          zod
            .enum(["inch", "cm"])
            .describe("Valid height metrics for DoseSpot patients."),
          zod.null(),
        ])
        .optional(),
      NonDoseSpotMedicalRecordNumber: zod
        .union([zod.string(), zod.null()])
        .optional(),
      Encounter: zod.union([zod.string(), zod.null()]).optional(),
      IsHospice: zod.union([zod.boolean(), zod.null()]).optional(),
      Last4SSN: zod.union([zod.string(), zod.null()]).optional(),
    })
    .describe("Patient demographic information from DoseSpot API."),
  zod.null(),
]);

/**
 * Get DoseSpot patient information for a specific user.

This endpoint fetches the current patient information from DoseSpot API
for the specified user.

Args:
    user_id: The user ID to fetch patient info for

Returns:
    PatientT or None: The patient information if available

Raises:
    AuthException: If the user lacks required privileges
    ValueError: If no patient record exists for the user
 * @summary Get Dosespot Patient Info
 */
export const getDosespotPatientInfoParams = zod.object({
  user_id: zod.uuid(),
});

export const getDosespotPatientInfoResponse = zod.union([
  zod
    .object({
      FirstName: zod.string(),
      LastName: zod.string(),
      DateOfBirth: zod.string(),
      Gender: zod.enum(["Male", "Female", "Unknown"]),
      Address1: zod.string(),
      City: zod.string(),
      State: zod.string(),
      ZipCode: zod.string(),
      PrimaryPhone: zod.union([zod.string(), zod.null()]).optional(),
      Active: zod.boolean(),
      PatientId: zod.union([zod.number(), zod.null()]).optional(),
      Prefix: zod.union([zod.string(), zod.null()]).optional(),
      MiddleName: zod.union([zod.string(), zod.null()]).optional(),
      Suffix: zod.union([zod.string(), zod.null()]).optional(),
      Email: zod.union([zod.string(), zod.null()]).optional(),
      Address2: zod.union([zod.string(), zod.null()]).optional(),
      PhoneAdditional1: zod.union([zod.string(), zod.null()]).optional(),
      PhoneAdditional2: zod.union([zod.string(), zod.null()]).optional(),
      PhoneAdditionalType1: zod
        .union([
          zod.enum([
            "Undefined",
            "Beeper",
            "Cell",
            "Fax",
            "Home",
            "Work",
            "Night",
            "Primary",
          ]),
          zod.null(),
        ])
        .optional(),
      PhoneAdditionalType2: zod
        .union([
          zod.enum([
            "Undefined",
            "Beeper",
            "Cell",
            "Fax",
            "Home",
            "Work",
            "Night",
            "Primary",
          ]),
          zod.null(),
        ])
        .optional(),
      PrimaryPhoneType: zod
        .union([
          zod.enum([
            "Undefined",
            "Beeper",
            "Cell",
            "Fax",
            "Home",
            "Work",
            "Night",
            "Primary",
          ]),
          zod.null(),
        ])
        .optional(),
      Weight: zod.union([zod.number(), zod.null()]).optional(),
      WeightMetric: zod
        .union([
          zod
            .enum(["lb", "kg"])
            .describe("Valid weight metrics for DoseSpot patients."),
          zod.null(),
        ])
        .optional(),
      Height: zod.union([zod.number(), zod.null()]).optional(),
      HeightMetric: zod
        .union([
          zod
            .enum(["inch", "cm"])
            .describe("Valid height metrics for DoseSpot patients."),
          zod.null(),
        ])
        .optional(),
      NonDoseSpotMedicalRecordNumber: zod
        .union([zod.string(), zod.null()])
        .optional(),
      Encounter: zod.union([zod.string(), zod.null()]).optional(),
      IsHospice: zod.union([zod.boolean(), zod.null()]).optional(),
      Last4SSN: zod.union([zod.string(), zod.null()]).optional(),
    })
    .describe("Patient demographic information from DoseSpot API."),
  zod.null(),
]);

/**
 * Get DoseSpot patient information for a specific user.

This endpoint fetches the current patient information from DoseSpot API
for the specified user.

Args:
    dosespot_patient_id: The DoseSpot patient ID to fetch patient info for

Returns:
    PatientT or None: The patient information if available

Raises:
    AuthException: If the user lacks required privileges
    ValueError: If no patient record exists for the user
 * @summary Exchange Dosespot Patient Info For Rxchange Rxrenewalrequest
 */
export const exchangeDosespotPatientInfoForRxchangeRxrenewalrequestParams =
  zod.object({
    dosespot_patient_id: zod.string(),
  });

export const exchangeDosespotPatientInfoForRxchangeRxrenewalrequestResponse =
  zod.union([zod.uuid(), zod.null()]);

/**
 * Search for pharmacies using various criteria.

This endpoint searches the DoseSpot pharmacy database using the provided criteria
and returns a paginated list of matching pharmacies.

Args:
    name: Pharmacy name to search for
    city: Pharmacy city
    state: Pharmacy state (2-letter code)
    zip: Pharmacy ZIP code
    address: Pharmacy street address
    phoneOrFax: Pharmacy phone or fax number
    specialty: List of pharmacy specialties to filter by
    ncpdpID: Pharmacy NCPDP ID
    pageNumber: Page number for pagination (default: 1)

Returns:
    PharmacyPagedListResponseT: Paginated list of pharmacies matching criteria

Raises:
    AuthException: If the user lacks required privileges
    ValueError: If the search fails
 * @summary Search Pharmacies
 */
export const searchPharmaciesQueryPageNumberDefault = 1;

export const searchPharmaciesQueryParams = zod.object({
  name: zod.union([zod.string(), zod.null()]).optional(),
  city: zod.union([zod.string(), zod.null()]).optional(),
  state: zod.union([zod.string(), zod.null()]).optional(),
  zip: zod.union([zod.string(), zod.null()]).optional(),
  address: zod.union([zod.string(), zod.null()]).optional(),
  phoneOrFax: zod.union([zod.string(), zod.null()]).optional(),
  ncpdpID: zod.union([zod.string(), zod.null()]).optional(),
  pageNumber: zod.number().default(searchPharmaciesQueryPageNumberDefault),
});

export const searchPharmaciesBody = zod.union([
  zod.array(zod.string()),
  zod.null(),
]);

export const searchPharmaciesResponse = zod
  .object({
    Items: zod
      .union([
        zod.array(
          zod
            .object({
              PharmacyId: zod.union([zod.number(), zod.null()]).optional(),
              StoreName: zod.union([zod.string(), zod.null()]).optional(),
              Address1: zod.union([zod.string(), zod.null()]).optional(),
              Address2: zod.union([zod.string(), zod.null()]).optional(),
              City: zod.union([zod.string(), zod.null()]).optional(),
              State: zod.union([zod.string(), zod.null()]).optional(),
              ZipCode: zod.union([zod.string(), zod.null()]).optional(),
              PrimaryPhone: zod.union([zod.string(), zod.null()]).optional(),
              PrimaryPhoneType: zod
                .union([
                  zod.enum([
                    "Undefined",
                    "Beeper",
                    "Cell",
                    "Fax",
                    "Home",
                    "Work",
                    "Night",
                    "Primary",
                  ]),
                  zod.null(),
                ])
                .optional(),
              PrimaryFax: zod.union([zod.string(), zod.null()]).optional(),
              PhoneAdditional1: zod
                .union([zod.string(), zod.null()])
                .optional(),
              PhoneAdditionalType1: zod
                .union([
                  zod.enum([
                    "Undefined",
                    "Beeper",
                    "Cell",
                    "Fax",
                    "Home",
                    "Work",
                    "Night",
                    "Primary",
                  ]),
                  zod.null(),
                ])
                .optional(),
              PhoneAdditional2: zod
                .union([zod.string(), zod.null()])
                .optional(),
              PhoneAdditionalType2: zod
                .union([
                  zod.enum([
                    "Undefined",
                    "Beeper",
                    "Cell",
                    "Fax",
                    "Home",
                    "Work",
                    "Night",
                    "Primary",
                  ]),
                  zod.null(),
                ])
                .optional(),
              PhoneAdditional3: zod
                .union([zod.string(), zod.null()])
                .optional(),
              PhoneAdditionalType3: zod
                .union([
                  zod.enum([
                    "Undefined",
                    "Beeper",
                    "Cell",
                    "Fax",
                    "Home",
                    "Work",
                    "Night",
                    "Primary",
                  ]),
                  zod.null(),
                ])
                .optional(),
              PharmacySpecialties: zod
                .union([zod.array(zod.string()), zod.null()])
                .optional(),
              ServiceLevel: zod.union([zod.number(), zod.null()]).optional(),
              Latitude: zod.union([zod.number(), zod.null()]).optional(),
              Longitude: zod.union([zod.number(), zod.null()]).optional(),
              NCPDPID: zod.union([zod.string(), zod.null()]).optional(),
            })
            .describe("DoseSpot Pharmacy model."),
        ),
        zod.null(),
      ])
      .optional(),
    PageResult: zod
      .union([
        zod
          .object({
            CurrentPage: zod.union([zod.number(), zod.null()]).optional(),
            TotalPages: zod.union([zod.number(), zod.null()]).optional(),
            PageSize: zod.union([zod.number(), zod.null()]).optional(),
            TotalCount: zod.union([zod.number(), zod.null()]).optional(),
            HasPrevious: zod.union([zod.boolean(), zod.null()]).optional(),
            HasNext: zod.union([zod.boolean(), zod.null()]).optional(),
          })
          .describe("DoseSpot page result information."),
        zod.null(),
      ])
      .optional(),
    Result: zod
      .union([
        zod
          .object({
            ResultCode: zod.string(),
            ResultDescription: zod.union([zod.string(), zod.null()]).optional(),
          })
          .describe("Standard DoseSpot API result object."),
        zod.null(),
      ])
      .optional(),
  })
  .describe("PagedListResponse wrapper for paged pharmacy lists.");

/**
 * Get pharmacy details by ID.

This endpoint retrieves detailed information about a specific pharmacy
from the DoseSpot database.

Args:
    pharmacy_id: The pharmacy ID to retrieve

Returns:
    PharmacyT: Detailed pharmacy information

Raises:
    AuthException: If the user lacks required privileges
    ValueError: If the pharmacy is not found or request fails
 * @summary Get Pharmacy By Id
 */
export const getPharmacyByIdParams = zod.object({
  pharmacy_id: zod.string(),
});

export const getPharmacyByIdResponse = zod
  .object({
    PharmacyId: zod.union([zod.number(), zod.null()]).optional(),
    StoreName: zod.union([zod.string(), zod.null()]).optional(),
    Address1: zod.union([zod.string(), zod.null()]).optional(),
    Address2: zod.union([zod.string(), zod.null()]).optional(),
    City: zod.union([zod.string(), zod.null()]).optional(),
    State: zod.union([zod.string(), zod.null()]).optional(),
    ZipCode: zod.union([zod.string(), zod.null()]).optional(),
    PrimaryPhone: zod.union([zod.string(), zod.null()]).optional(),
    PrimaryPhoneType: zod
      .union([
        zod.enum([
          "Undefined",
          "Beeper",
          "Cell",
          "Fax",
          "Home",
          "Work",
          "Night",
          "Primary",
        ]),
        zod.null(),
      ])
      .optional(),
    PrimaryFax: zod.union([zod.string(), zod.null()]).optional(),
    PhoneAdditional1: zod.union([zod.string(), zod.null()]).optional(),
    PhoneAdditionalType1: zod
      .union([
        zod.enum([
          "Undefined",
          "Beeper",
          "Cell",
          "Fax",
          "Home",
          "Work",
          "Night",
          "Primary",
        ]),
        zod.null(),
      ])
      .optional(),
    PhoneAdditional2: zod.union([zod.string(), zod.null()]).optional(),
    PhoneAdditionalType2: zod
      .union([
        zod.enum([
          "Undefined",
          "Beeper",
          "Cell",
          "Fax",
          "Home",
          "Work",
          "Night",
          "Primary",
        ]),
        zod.null(),
      ])
      .optional(),
    PhoneAdditional3: zod.union([zod.string(), zod.null()]).optional(),
    PhoneAdditionalType3: zod
      .union([
        zod.enum([
          "Undefined",
          "Beeper",
          "Cell",
          "Fax",
          "Home",
          "Work",
          "Night",
          "Primary",
        ]),
        zod.null(),
      ])
      .optional(),
    PharmacySpecialties: zod
      .union([zod.array(zod.string()), zod.null()])
      .optional(),
    ServiceLevel: zod.union([zod.number(), zod.null()]).optional(),
    Latitude: zod.union([zod.number(), zod.null()]).optional(),
    Longitude: zod.union([zod.number(), zod.null()]).optional(),
    NCPDPID: zod.union([zod.string(), zod.null()]).optional(),
  })
  .describe("DoseSpot Pharmacy model.");

/**
 * Get the authenticated user's preferred pharmacies.

This endpoint retrieves all pharmacies assigned to the authenticated user's
DoseSpot patient record.

Returns:
    List[PatientPharmacyT]: List of patient's preferred pharmacies

Raises:
    AuthException: If the user lacks required privileges
    ValueError: If no patient record exists or request fails
 * @summary Get My Patient Pharmacies
 */
export const getMyPatientPharmaciesResponseItem = zod
  .object({
    PharmacyId: zod.union([zod.number(), zod.null()]).optional(),
    StoreName: zod.union([zod.string(), zod.null()]).optional(),
    Address1: zod.union([zod.string(), zod.null()]).optional(),
    Address2: zod.union([zod.string(), zod.null()]).optional(),
    City: zod.union([zod.string(), zod.null()]).optional(),
    State: zod.union([zod.string(), zod.null()]).optional(),
    ZipCode: zod.union([zod.string(), zod.null()]).optional(),
    PrimaryPhone: zod.union([zod.string(), zod.null()]).optional(),
    PrimaryPhoneType: zod
      .union([
        zod.enum([
          "Undefined",
          "Beeper",
          "Cell",
          "Fax",
          "Home",
          "Work",
          "Night",
          "Primary",
        ]),
        zod.null(),
      ])
      .optional(),
    PrimaryFax: zod.union([zod.string(), zod.null()]).optional(),
    PhoneAdditional1: zod.union([zod.string(), zod.null()]).optional(),
    PhoneAdditionalType1: zod
      .union([
        zod.enum([
          "Undefined",
          "Beeper",
          "Cell",
          "Fax",
          "Home",
          "Work",
          "Night",
          "Primary",
        ]),
        zod.null(),
      ])
      .optional(),
    PhoneAdditional2: zod.union([zod.string(), zod.null()]).optional(),
    PhoneAdditionalType2: zod
      .union([
        zod.enum([
          "Undefined",
          "Beeper",
          "Cell",
          "Fax",
          "Home",
          "Work",
          "Night",
          "Primary",
        ]),
        zod.null(),
      ])
      .optional(),
    PhoneAdditional3: zod.union([zod.string(), zod.null()]).optional(),
    PhoneAdditionalType3: zod
      .union([
        zod.enum([
          "Undefined",
          "Beeper",
          "Cell",
          "Fax",
          "Home",
          "Work",
          "Night",
          "Primary",
        ]),
        zod.null(),
      ])
      .optional(),
    PharmacySpecialties: zod
      .union([zod.array(zod.string()), zod.null()])
      .optional(),
    ServiceLevel: zod.union([zod.number(), zod.null()]).optional(),
    Latitude: zod.union([zod.number(), zod.null()]).optional(),
    Longitude: zod.union([zod.number(), zod.null()]).optional(),
    NCPDPID: zod.union([zod.string(), zod.null()]).optional(),
    IsDefault: zod.union([zod.boolean(), zod.null()]).optional(),
  })
  .describe(
    "DoseSpot Patient Pharmacy model - extends PharmacyT with patient-specific fields.",
  );
export const getMyPatientPharmaciesResponse = zod.array(
  getMyPatientPharmaciesResponseItem,
);

/**
 * Add a pharmacy to the authenticated user's preferred pharmacies.

This endpoint adds a pharmacy to the authenticated user's DoseSpot patient record
and optionally sets it as the primary pharmacy.

Args:
    request: The pharmacy ID and primary setting

Raises:
    AuthException: If the user lacks required privileges
    ValueError: If the pharmacy cannot be added or request fails
 * @summary Add Pharmacy To My Patient
 */
export const addPharmacyToMyPatientBodySetAsPrimaryDefault = false;

export const addPharmacyToMyPatientBody = zod.object({
  pharmacyId: zod.number(),
  setAsPrimary: zod.boolean().optional(),
});

export const addPharmacyToMyPatientResponse = zod.unknown();

/**
 * Get a specific user's preferred pharmacies.

This endpoint retrieves all pharmacies assigned to the specified user's
DoseSpot patient record.

Args:
    user_id: The user ID to get pharmacies for

Returns:
    List[PatientPharmacyT]: List of patient's preferred pharmacies

Raises:
    AuthException: If the user lacks required privileges
    ValueError: If no patient record exists or request fails
 * @summary Get Patient Pharmacies By User Id
 */
export const getPatientPharmaciesByUserIdParams = zod.object({
  user_id: zod.uuid(),
});

export const getPatientPharmaciesByUserIdResponseItem = zod
  .object({
    PharmacyId: zod.union([zod.number(), zod.null()]).optional(),
    StoreName: zod.union([zod.string(), zod.null()]).optional(),
    Address1: zod.union([zod.string(), zod.null()]).optional(),
    Address2: zod.union([zod.string(), zod.null()]).optional(),
    City: zod.union([zod.string(), zod.null()]).optional(),
    State: zod.union([zod.string(), zod.null()]).optional(),
    ZipCode: zod.union([zod.string(), zod.null()]).optional(),
    PrimaryPhone: zod.union([zod.string(), zod.null()]).optional(),
    PrimaryPhoneType: zod
      .union([
        zod.enum([
          "Undefined",
          "Beeper",
          "Cell",
          "Fax",
          "Home",
          "Work",
          "Night",
          "Primary",
        ]),
        zod.null(),
      ])
      .optional(),
    PrimaryFax: zod.union([zod.string(), zod.null()]).optional(),
    PhoneAdditional1: zod.union([zod.string(), zod.null()]).optional(),
    PhoneAdditionalType1: zod
      .union([
        zod.enum([
          "Undefined",
          "Beeper",
          "Cell",
          "Fax",
          "Home",
          "Work",
          "Night",
          "Primary",
        ]),
        zod.null(),
      ])
      .optional(),
    PhoneAdditional2: zod.union([zod.string(), zod.null()]).optional(),
    PhoneAdditionalType2: zod
      .union([
        zod.enum([
          "Undefined",
          "Beeper",
          "Cell",
          "Fax",
          "Home",
          "Work",
          "Night",
          "Primary",
        ]),
        zod.null(),
      ])
      .optional(),
    PhoneAdditional3: zod.union([zod.string(), zod.null()]).optional(),
    PhoneAdditionalType3: zod
      .union([
        zod.enum([
          "Undefined",
          "Beeper",
          "Cell",
          "Fax",
          "Home",
          "Work",
          "Night",
          "Primary",
        ]),
        zod.null(),
      ])
      .optional(),
    PharmacySpecialties: zod
      .union([zod.array(zod.string()), zod.null()])
      .optional(),
    ServiceLevel: zod.union([zod.number(), zod.null()]).optional(),
    Latitude: zod.union([zod.number(), zod.null()]).optional(),
    Longitude: zod.union([zod.number(), zod.null()]).optional(),
    NCPDPID: zod.union([zod.string(), zod.null()]).optional(),
    IsDefault: zod.union([zod.boolean(), zod.null()]).optional(),
  })
  .describe(
    "DoseSpot Patient Pharmacy model - extends PharmacyT with patient-specific fields.",
  );
export const getPatientPharmaciesByUserIdResponse = zod.array(
  getPatientPharmaciesByUserIdResponseItem,
);

/**
 * Add a pharmacy to a specific user's preferred pharmacies.

This endpoint adds a pharmacy to the specified user's DoseSpot patient record
and optionally sets it as the primary pharmacy.

Args:
    user_id: The user ID to add the pharmacy to
    request: The pharmacy ID and primary setting

Raises:
    AuthException: If the user lacks required privileges
    ValueError: If the pharmacy cannot be added or request fails
 * @summary Add Pharmacy To Patient By User Id
 */
export const addPharmacyToPatientByUserIdParams = zod.object({
  user_id: zod.uuid(),
});

export const addPharmacyToPatientByUserIdBodySetAsPrimaryDefault = false;

export const addPharmacyToPatientByUserIdBody = zod.object({
  pharmacyId: zod.number(),
  setAsPrimary: zod.boolean().optional(),
});

export const addPharmacyToPatientByUserIdResponse = zod.unknown();

/**
 * Remove a pharmacy from the authenticated user's preferred pharmacies.

This endpoint removes a pharmacy from the authenticated user's DoseSpot patient record.

Args:
    pharmacy_id: The pharmacy ID to remove

Raises:
    AuthException: If the user lacks required privileges
    ValueError: If the pharmacy cannot be removed or request fails
 * @summary Remove Pharmacy From My Patient
 */
export const removePharmacyFromMyPatientParams = zod.object({
  pharmacy_id: zod.string(),
});

export const removePharmacyFromMyPatientResponse = zod.unknown();

/**
 * Remove a pharmacy from a specific user's preferred pharmacies.

This endpoint removes a pharmacy from the specified user's DoseSpot patient record.

Args:
    user_id: The user ID to remove the pharmacy from
    pharmacy_id: The pharmacy ID to remove

Raises:
    AuthException: If the user lacks required privileges
    ValueError: If the pharmacy cannot be removed or request fails
 * @summary Remove Pharmacy From Patient By User Id
 */
export const removePharmacyFromPatientByUserIdParams = zod.object({
  user_id: zod.uuid(),
  pharmacy_id: zod.string(),
});

export const removePharmacyFromPatientByUserIdResponse = zod.unknown();

/**
 * Get a specific user's allergies.

This endpoint retrieves all allergies recorded for the specified user's
DoseSpot patient record.

Args:
    user_id: The user ID to get allergies for

Returns:
    List[PatientAllergyT]: List of patient's allergies

Raises:
    AuthException: If the user lacks required privileges
    ValueError: If no patient record exists or request fails
 * @summary Get Patient Allergies By User Id
 */
export const getPatientAllergiesByUserIdParams = zod.object({
  user_id: zod.uuid(),
});

export const getPatientAllergiesByUserIdResponseItem = zod
  .object({
    PatientAllergyId: zod.union([zod.number(), zod.null()]).optional(),
    DisplayName: zod.union([zod.string(), zod.null()]).optional(),
    AllergenId: zod.union([zod.number(), zod.null()]).optional(),
    AllergenType: zod
      .union([
        zod
          .enum([
            "AllergenClass",
            "ScreenableIngredient",
            "FoodAndEnvironmentalAllergens",
            "RoutedDoseFormDrugs",
          ])
          .describe("Valid allergen types for DoseSpot."),
        zod.null(),
      ])
      .optional(),
    Reaction: zod.union([zod.string(), zod.null()]).optional(),
    ReactionType: zod
      .union([
        zod
          .enum(["Allergy", "AdverseReaction"])
          .describe("Valid reaction types for allergies."),
        zod.null(),
      ])
      .optional(),
    StatusType: zod
      .union([
        zod
          .enum(["Active", "Inactive", "Deleted"])
          .describe("Valid status types for allergies."),
        zod.null(),
      ])
      .optional(),
    OnsetDate: zod.union([zod.string(), zod.null()]).optional(),
    LastUpdatedUserId: zod.union([zod.number(), zod.null()]).optional(),
  })
  .describe("Patient allergy information from DoseSpot API.");
export const getPatientAllergiesByUserIdResponse = zod.array(
  getPatientAllergiesByUserIdResponseItem,
);

/**
 * Add an allergy to a specific user's patient record.

This endpoint adds an allergy to the specified user's DoseSpot patient record.
The allergy can be either coded (with AllergenId) or freetext.

Args:
    user_id: The user ID to add the allergy to
    request: The allergy information (coded or freetext)

Raises:
    AuthException: If the user lacks required privileges
    ValueError: If the allergy cannot be added or request fails
 * @summary Add Allergy To Patient By User Id
 */
export const addAllergyToPatientByUserIdParams = zod.object({
  user_id: zod.uuid(),
});

export const addAllergyToPatientByUserIdBody = zod.union([
  zod
    .object({
      AllergenId: zod.number(),
      Reaction: zod.union([zod.string(), zod.null()]).optional(),
      ReactionType: zod
        .enum(["Allergy", "AdverseReaction"])
        .describe("Valid reaction types for allergies."),
      StatusType: zod
        .enum(["Active", "Inactive", "Deleted"])
        .describe("Valid status types for allergies."),
      OnsetDate: zod.union([zod.string(), zod.null()]).optional(),
    })
    .describe("Request for adding a coded patient allergy."),
  zod
    .object({
      FreeTextDisplayName: zod.string(),
      Reaction: zod.union([zod.string(), zod.null()]).optional(),
      ReactionType: zod
        .enum(["Allergy", "AdverseReaction"])
        .describe("Valid reaction types for allergies."),
      StatusType: zod
        .enum(["Active", "Inactive", "Deleted"])
        .describe("Valid status types for allergies."),
      OnsetDate: zod.union([zod.string(), zod.null()]).optional(),
    })
    .describe("Request for adding a freetext patient allergy."),
]);

export const addAllergyToPatientByUserIdResponse = zod.unknown();

/**
 * Edit an allergy in a specific user's patient record.

This endpoint updates an existing allergy in the specified user's DoseSpot patient record.

Args:
    user_id: The user ID to edit the allergy for
    allergy_id: The allergy ID to edit
    request: The updated allergy information

Raises:
    AuthException: If the user lacks required privileges
    ValueError: If the allergy cannot be edited or request fails
 * @summary Edit Patient Allergy By User Id
 */
export const editPatientAllergyByUserIdParams = zod.object({
  user_id: zod.uuid(),
  allergy_id: zod.string(),
});

export const editPatientAllergyByUserIdBody = zod
  .object({
    Reaction: zod.union([zod.string(), zod.null()]).optional(),
    ReactionType: zod
      .enum(["Allergy", "AdverseReaction"])
      .describe("Valid reaction types for allergies."),
    StatusType: zod
      .enum(["Active", "Inactive", "Deleted"])
      .describe("Valid status types for allergies."),
    OnsetDate: zod.union([zod.string(), zod.null()]).optional(),
  })
  .describe("Request for editing a patient allergy.");

export const editPatientAllergyByUserIdResponse = zod.unknown();

/**
 * Search for allergens by name.

This endpoint searches the DoseSpot allergen database for matching allergens.
Requires at least 3 characters in the search term.

Args:
    name: Allergen name to search for (minimum 3 characters)
    page_number: Page number for pagination (optional)

Returns:
    AllergyPagedListResponseT: Paginated list of allergens matching the search criteria

Raises:
    AuthException: If the user lacks required privileges
    ValueError: If the search fails or name is too short
 * @summary Search Allergens
 */
export const searchAllergensQueryParams = zod.object({
  name: zod.string(),
  page_number: zod.union([zod.number(), zod.null()]).optional(),
});

export const searchAllergensResponse = zod
  .object({
    Items: zod
      .union([
        zod.array(
          zod
            .object({
              Name: zod.union([zod.string(), zod.null()]).optional(),
              BrandName: zod.union([zod.string(), zod.null()]).optional(),
              AllergenId: zod.union([zod.number(), zod.null()]).optional(),
              AllergenType: zod
                .union([
                  zod
                    .enum([
                      "AllergenClass",
                      "ScreenableIngredient",
                      "FoodAndEnvironmentalAllergens",
                      "RoutedDoseFormDrugs",
                    ])
                    .describe("Valid allergen types for DoseSpot."),
                  zod.null(),
                ])
                .optional(),
              IsActive: zod.union([zod.boolean(), zod.null()]).optional(),
              AllergenCategory: zod
                .union([
                  zod
                    .enum([
                      "CommonAllergens",
                      "UncommonAllergens",
                      "OtherBrandDrugs",
                    ])
                    .describe("Valid allergen category types for DoseSpot."),
                  zod.null(),
                ])
                .optional(),
            })
            .describe("Allergen search result from DoseSpot API."),
        ),
        zod.null(),
      ])
      .optional(),
    PageResult: zod
      .union([
        zod
          .object({
            CurrentPage: zod.union([zod.number(), zod.null()]).optional(),
            TotalPages: zod.union([zod.number(), zod.null()]).optional(),
            PageSize: zod.union([zod.number(), zod.null()]).optional(),
            TotalCount: zod.union([zod.number(), zod.null()]).optional(),
            HasPrevious: zod.union([zod.boolean(), zod.null()]).optional(),
            HasNext: zod.union([zod.boolean(), zod.null()]).optional(),
          })
          .describe("DoseSpot page result information."),
        zod.null(),
      ])
      .optional(),
    Result: zod
      .union([
        zod
          .object({
            ResultCode: zod.string(),
            ResultDescription: zod.union([zod.string(), zod.null()]).optional(),
          })
          .describe("Standard DoseSpot API result object."),
        zod.null(),
      ])
      .optional(),
  })
  .describe("PagedListResponse wrapper for allergen search results.");

/**
 * Get allergen details by ID.

This endpoint retrieves detailed information about a specific allergen
from the DoseSpot database.

Args:
    allergen_id: The allergen ID to retrieve

Returns:
    AllergySearchResultT: Detailed allergen information

Raises:
    AuthException: If the user lacks required privileges
    ValueError: If the allergen is not found or request fails
 * @summary Get Allergen By Id
 */
export const getAllergenByIdParams = zod.object({
  allergen_id: zod.string(),
});

export const getAllergenByIdResponse = zod
  .object({
    Name: zod.union([zod.string(), zod.null()]).optional(),
    BrandName: zod.union([zod.string(), zod.null()]).optional(),
    AllergenId: zod.union([zod.number(), zod.null()]).optional(),
    AllergenType: zod
      .union([
        zod
          .enum([
            "AllergenClass",
            "ScreenableIngredient",
            "FoodAndEnvironmentalAllergens",
            "RoutedDoseFormDrugs",
          ])
          .describe("Valid allergen types for DoseSpot."),
        zod.null(),
      ])
      .optional(),
    IsActive: zod.union([zod.boolean(), zod.null()]).optional(),
    AllergenCategory: zod
      .union([
        zod
          .enum(["CommonAllergens", "UncommonAllergens", "OtherBrandDrugs"])
          .describe("Valid allergen category types for DoseSpot."),
        zod.null(),
      ])
      .optional(),
  })
  .describe("Allergen search result from DoseSpot API.");

/**
 * Search for medications by name.

This endpoint searches the DoseSpot medication database for drugs matching the provided name.
Requires at least 3 characters in the search term.

Args:
    name: Medication name to search for (minimum 3 characters)
    page_number: Page number for pagination (optional)
    drug_status: Filter by drug status (optional)

Returns:
    List[MedicationSearchResultT]: List of medications matching the search criteria

Raises:
    AuthException: If the user lacks required privileges
    ValueError: If the search fails or name is too short
 * @summary Search Medications
 */
export const searchMedicationsQueryParams = zod.object({
  name: zod.string(),
  page_number: zod.union([zod.number(), zod.null()]).optional(),
  drug_status: zod.union([zod.string(), zod.null()]).optional(),
});

export const searchMedicationsResponseItem = zod
  .object({
    DispensableDrugId: zod.union([zod.number(), zod.null()]).optional(),
    RoutedDoseFormDrugId: zod.union([zod.number(), zod.null()]).optional(),
    NDC: zod.union([zod.string(), zod.null()]).optional(),
    RXCUI: zod.union([zod.number(), zod.null()]).optional(),
    NameWithRouteDoseForm: zod.union([zod.string(), zod.null()]).optional(),
    Strength: zod.union([zod.string(), zod.null()]).optional(),
    IsObsolete: zod.union([zod.boolean(), zod.null()]).optional(),
  })
  .describe("Result model for medication search operations.");
export const searchMedicationsResponse = zod.array(
  searchMedicationsResponseItem,
);

/**
 * Search for medications by rxCUI.

This endpoint searches for dispensable drugs by rxCUI identifier.

Args:
    rxcui: The rxCUI identifier to search by

Returns:
    List[MedicationSelectResultT]: List of medications matching the rxCUI

Raises:
    AuthException: If the user lacks required privileges
    ValueError: If the search fails
 * @summary Search Medications By Rxcui
 */
export const searchMedicationsByRxcuiParams = zod.object({
  rxcui: zod.string(),
});

export const searchMedicationsByRxcuiResponseItem = zod
  .object({
    DispensableDrugId: zod.union([zod.number(), zod.null()]).optional(),
    NDC: zod.union([zod.string(), zod.null()]).optional(),
    RXCUI: zod.union([zod.number(), zod.null()]).optional(),
    DisplayName: zod.union([zod.string(), zod.null()]).optional(),
    DrugName: zod.union([zod.string(), zod.null()]).optional(),
    Route: zod.union([zod.string(), zod.null()]).optional(),
    DoseForm: zod.union([zod.string(), zod.null()]).optional(),
    Strength: zod.union([zod.string(), zod.null()]).optional(),
    DispenseUnitId: zod.union([zod.number(), zod.null()]).optional(),
    Brand: zod.union([zod.boolean(), zod.null()]).optional(),
    GenericDrugName: zod.union([zod.string(), zod.null()]).optional(),
    OTC: zod.union([zod.boolean(), zod.null()]).optional(),
    IsObsolete: zod.union([zod.boolean(), zod.null()]).optional(),
    DrugClassification: zod.union([zod.string(), zod.null()]).optional(),
    Schedule: zod.union([zod.number(), zod.null()]).optional(),
    StateSchedule: zod
      .union([
        zod.array(
          zod
            .object({
              StateName: zod.union([zod.string(), zod.null()]).optional(),
              Schedule: zod.union([zod.number(), zod.null()]).optional(),
            })
            .describe("State-specific drug scheduling information."),
        ),
        zod.null(),
      ])
      .optional(),
  })
  .describe("Result model for medication selection and detail operations.");
export const searchMedicationsByRxcuiResponse = zod.array(
  searchMedicationsByRxcuiResponseItem,
);

/**
 * Search for diagnoses by ICD code or description.

Args:
    search_term: ICD code or text to search
    page_number: Page number for pagination (optional)

Returns:
    List of matching diagnoses with DiagnosisId, DiagnosisCode, DiagnosisName
 * @summary Search Diagnoses
 */
export const searchDiagnosesQueryParams = zod.object({
  search_term: zod.string(),
  page_number: zod.union([zod.number(), zod.null()]).optional(),
});

export const searchDiagnosesResponseItem = zod
  .object({
    DiagnosisId: zod.union([zod.number(), zod.null()]).optional(),
    DiagnosisCode: zod.union([zod.string(), zod.null()]).optional(),
    DiagnosisName: zod.union([zod.string(), zod.null()]).optional(),
  })
  .describe("DoseSpot diagnosis search result (GET \/api\/diagnoses\/search).");
export const searchDiagnosesResponse = zod.array(searchDiagnosesResponseItem);

/**
 * Get detailed medication information by ID, NDC, or rxCUI.

This endpoint retrieves detailed information about a specific medication.
At least one identifier parameter must be provided.

Args:
    dispensable_drug_id: The dispensable drug ID (optional)
    ndc: The NDC number (optional)
    rxcui: The rxCUI identifier (optional)

Returns:
    MedicationSelectResultT: Detailed medication information

Raises:
    AuthException: If the user lacks required privileges
    ValueError: If no identifier is provided or medication not found
 * @summary Select Medication
 */
export const selectMedicationQueryParams = zod.object({
  dispensable_drug_id: zod.union([zod.number(), zod.null()]).optional(),
  ndc: zod.union([zod.string(), zod.null()]).optional(),
  rxcui: zod.union([zod.number(), zod.null()]).optional(),
});

export const selectMedicationResponse = zod
  .object({
    DispensableDrugId: zod.union([zod.number(), zod.null()]).optional(),
    NDC: zod.union([zod.string(), zod.null()]).optional(),
    RXCUI: zod.union([zod.number(), zod.null()]).optional(),
    DisplayName: zod.union([zod.string(), zod.null()]).optional(),
    DrugName: zod.union([zod.string(), zod.null()]).optional(),
    Route: zod.union([zod.string(), zod.null()]).optional(),
    DoseForm: zod.union([zod.string(), zod.null()]).optional(),
    Strength: zod.union([zod.string(), zod.null()]).optional(),
    DispenseUnitId: zod.union([zod.number(), zod.null()]).optional(),
    Brand: zod.union([zod.boolean(), zod.null()]).optional(),
    GenericDrugName: zod.union([zod.string(), zod.null()]).optional(),
    OTC: zod.union([zod.boolean(), zod.null()]).optional(),
    IsObsolete: zod.union([zod.boolean(), zod.null()]).optional(),
    DrugClassification: zod.union([zod.string(), zod.null()]).optional(),
    Schedule: zod.union([zod.number(), zod.null()]).optional(),
    StateSchedule: zod
      .union([
        zod.array(
          zod
            .object({
              StateName: zod.union([zod.string(), zod.null()]).optional(),
              Schedule: zod.union([zod.number(), zod.null()]).optional(),
            })
            .describe("State-specific drug scheduling information."),
        ),
        zod.null(),
      ])
      .optional(),
  })
  .describe("Result model for medication selection and detail operations.");

/**
 * Get medication monograph by ID or NDC.

This endpoint retrieves the drug monograph information for patient education.

Args:
    dispensable_drug_id: The dispensable drug ID (optional)
    ndc: The NDC number (optional)
    monograph_format: Format for monograph ("HTML" or "XML"), defaults to "HTML"

Returns:
    str: HTML or XML content of the drug monograph

Raises:
    AuthException: If the user lacks required privileges
    ValueError: If no identifier is provided or monograph not found
 * @summary Get Medication Monograph
 */
export const getMedicationMonographQueryMonographFormatDefault = "HTML";

export const getMedicationMonographQueryParams = zod.object({
  dispensable_drug_id: zod.union([zod.number(), zod.null()]).optional(),
  ndc: zod.union([zod.string(), zod.null()]).optional(),
  monograph_format: zod
    .string()
    .default(getMedicationMonographQueryMonographFormatDefault),
});

export const getMedicationMonographResponse = zod.string();

/**
 * Get all available dispense units.

This endpoint returns all available dispense unit types for use in prescriptions.

Returns:
    List[StandardDispenseUnitTypeT]: List of all dispense unit types

Raises:
    AuthException: If the user lacks required privileges
    ValueError: If the request fails
 * @summary Get Dispense Units
 */
export const getDispenseUnitsResponseItem = zod
  .object({
    StandardDispenseUnitTypeID: zod
      .union([zod.number(), zod.null()])
      .optional(),
    Name: zod.union([zod.string(), zod.null()]).optional(),
    Abbreviation: zod.union([zod.string(), zod.null()]).optional(),
    Singular: zod.union([zod.string(), zod.null()]).optional(),
    Plural: zod.union([zod.string(), zod.null()]).optional(),
    SingularOrPlural: zod.union([zod.string(), zod.null()]).optional(),
    PotencyUnitCode: zod.union([zod.string(), zod.null()]).optional(),
    IsActive: zod.union([zod.boolean(), zod.null()]).optional(),
  })
  .describe("Model for dispense unit type information.");
export const getDispenseUnitsResponse = zod.array(getDispenseUnitsResponseItem);

/**
 * Get dispense unit details by ID.

This endpoint retrieves detailed information about a specific dispense unit.

Args:
    unit_id: The dispense unit ID

Returns:
    StandardDispenseUnitTypeT: Dispense unit details

Raises:
    AuthException: If the user lacks required privileges
    ValueError: If the dispense unit is not found
 * @summary Get Dispense Unit By Id
 */
export const getDispenseUnitByIdParams = zod.object({
  unit_id: zod.number(),
});

export const getDispenseUnitByIdResponse = zod
  .object({
    StandardDispenseUnitTypeID: zod
      .union([zod.number(), zod.null()])
      .optional(),
    Name: zod.union([zod.string(), zod.null()]).optional(),
    Abbreviation: zod.union([zod.string(), zod.null()]).optional(),
    Singular: zod.union([zod.string(), zod.null()]).optional(),
    Plural: zod.union([zod.string(), zod.null()]).optional(),
    SingularOrPlural: zod.union([zod.string(), zod.null()]).optional(),
    PotencyUnitCode: zod.union([zod.string(), zod.null()]).optional(),
    IsActive: zod.union([zod.boolean(), zod.null()]).optional(),
  })
  .describe("Model for dispense unit type information.");

/**
 * Search for supplies by name, NDC, or UPC.

This endpoint searches the DoseSpot supply database. You can search by:
- Supply name (minimum 3 characters)
- Exact NDC (National Drug Code)
- Exact UPC (Universal Packaging Code)

At least one search parameter must be provided.

Args:
    name: Supply name to search for (minimum 3 characters, optional)
    ndc: National Drug Code (exact match, optional)
    upc: Universal Packaging Code (exact match, optional)
    page_number: Page number for pagination (optional)
    supply_status: Filter by supply status (optional)

Returns:
    List[SupplySearchResultT]: List of supplies matching the search criteria

Raises:
    AuthException: If the user lacks required privileges
    ValueError: If the search fails or no search parameters provided
 * @summary Search Supplies
 */
export const searchSuppliesQueryParams = zod.object({
  name: zod.union([zod.string(), zod.null()]).optional(),
  ndc: zod.union([zod.string(), zod.null()]).optional(),
  upc: zod.union([zod.string(), zod.null()]).optional(),
  page_number: zod.union([zod.number(), zod.null()]).optional(),
  supply_status: zod.union([zod.string(), zod.null()]).optional(),
});

export const searchSuppliesResponseItem = zod
  .object({
    SupplyId: zod.union([zod.number(), zod.null()]).optional(),
    NDC: zod.union([zod.string(), zod.null()]).optional(),
    UPC: zod.union([zod.string(), zod.null()]).optional(),
    Name: zod.union([zod.string(), zod.null()]).optional(),
    OTC: zod.union([zod.boolean(), zod.null()]).optional(),
    IsObsolete: zod.union([zod.boolean(), zod.null()]).optional(),
  })
  .describe("Result model for supply search operations.");
export const searchSuppliesResponse = zod.array(searchSuppliesResponseItem);

/**
 * Get supply details by ID.

This endpoint retrieves detailed information about a specific supply
from the DoseSpot database.

Args:
    supply_id: The supply ID to retrieve

Returns:
    SupplySearchResultT: Detailed supply information

Raises:
    AuthException: If the user lacks required privileges
    ValueError: If the supply is not found or request fails
 * @summary Get Supply By Id
 */
export const getSupplyByIdParams = zod.object({
  supply_id: zod.number(),
});

export const getSupplyByIdResponse = zod
  .object({
    SupplyId: zod.union([zod.number(), zod.null()]).optional(),
    NDC: zod.union([zod.string(), zod.null()]).optional(),
    UPC: zod.union([zod.string(), zod.null()]).optional(),
    Name: zod.union([zod.string(), zod.null()]).optional(),
    OTC: zod.union([zod.boolean(), zod.null()]).optional(),
    IsObsolete: zod.union([zod.boolean(), zod.null()]).optional(),
  })
  .describe("Result model for supply search operations.");

/**
 * Create a new prescription for a patient.

This endpoint creates a new prescription in DoseSpot for the specified patient.
The prescription type is automatically determined from the request data structure.

Args:
    user_id: The patient's user ID
    request: The prescription data (coded, freetext, supply, or compound) and optional clinician request ticket

Returns:
    PrescriptionT: The newly created prescription information

Raises:
    AuthException: If the user lacks required privileges
    ValueError: If the patient has no DoseSpot record or prescription creation fails
 * @summary Create Prescription
 */
export const createPrescriptionParams = zod.object({
  user_id: zod.uuid(),
});

export const createPrescriptionBody = zod.object({
  prescriptionData: zod.union([
    zod
      .object({
        DispensableDrugId: zod.number(),
        PatientFormularyId: zod.union([zod.number(), zod.null()]).optional(),
        Refills: zod.number(),
        DaysSupply: zod.union([zod.number(), zod.null()]).optional(),
        DispenseUnitId: zod.number(),
        Quantity: zod.number(),
        Directions: zod.string(),
        PharmacyId: zod.number(),
        PharmacyNotes: zod.union([zod.string(), zod.null()]).optional(),
        NoSubstitutions: zod.union([zod.boolean(), zod.null()]).optional(),
        EffectiveDate: zod.string(),
        RxReferenceNumber: zod.union([zod.string(), zod.null()]).optional(),
        EligibilityId: zod.union([zod.number(), zod.null()]).optional(),
        NonDoseSpotPrescriptionId: zod
          .union([zod.string(), zod.null()])
          .optional(),
        FirstPrescriptionDiagnosis: zod
          .union([
            zod
              .object({
                PrimaryDiagnosisId: zod
                  .union([zod.number(), zod.null()])
                  .optional(),
                SecondaryDiagnosisId: zod
                  .union([zod.number(), zod.null()])
                  .optional(),
              })
              .describe("DoseSpot prescription diagnosis IDs for requests."),
            zod.null(),
          ])
          .optional(),
        SecondPrescriptionDiagnosis: zod
          .union([
            zod
              .object({
                PrimaryDiagnosisId: zod
                  .union([zod.number(), zod.null()])
                  .optional(),
                SecondaryDiagnosisId: zod
                  .union([zod.number(), zod.null()])
                  .optional(),
              })
              .describe("DoseSpot prescription diagnosis IDs for requests."),
            zod.null(),
          ])
          .optional(),
        IsRefillReplace: zod.union([zod.boolean(), zod.null()]).optional(),
        IsUrgent: zod.union([zod.boolean(), zod.null()]).optional(),
        SupervisorId: zod.union([zod.number(), zod.null()]).optional(),
        RetailPharmacyToMailToPatient: zod
          .union([zod.boolean(), zod.null()])
          .optional(),
        Status: zod
          .enum([
            "Unknown",
            "Active",
            "Inactive",
            "Discontinued",
            "Deleted",
            "Completed",
            "CancelRequested",
            "CancelPending",
            "Cancelled",
            "CancelDenied",
            "Changed",
            "FullFill",
            "PartialFill",
            "NoFill",
          ])
          .describe("Valid medication status types for DoseSpot."),
        InactiveDate: zod.union([zod.string(), zod.null()]).optional(),
        Comment: zod.union([zod.string(), zod.null()]).optional(),
        Encounter: zod.union([zod.string(), zod.null()]).optional(),
      })
      .describe("Request for coded prescription creation\/editing."),
    zod
      .object({
        DisplayName: zod.string(),
        NotControlled: zod.boolean(),
        Refills: zod.number(),
        DaysSupply: zod.union([zod.number(), zod.null()]).optional(),
        DispenseUnitId: zod.number(),
        Quantity: zod.number(),
        Directions: zod.string(),
        PharmacyId: zod.number(),
        PharmacyNotes: zod.union([zod.string(), zod.null()]).optional(),
        NoSubstitutions: zod.union([zod.boolean(), zod.null()]).optional(),
        EffectiveDate: zod.string(),
        RxReferenceNumber: zod.union([zod.string(), zod.null()]).optional(),
        EligibilityId: zod.union([zod.number(), zod.null()]).optional(),
        NonDoseSpotPrescriptionId: zod
          .union([zod.string(), zod.null()])
          .optional(),
        FirstPrescriptionDiagnosis: zod
          .union([
            zod
              .object({
                PrimaryDiagnosisId: zod
                  .union([zod.number(), zod.null()])
                  .optional(),
                SecondaryDiagnosisId: zod
                  .union([zod.number(), zod.null()])
                  .optional(),
              })
              .describe("DoseSpot prescription diagnosis IDs for requests."),
            zod.null(),
          ])
          .optional(),
        SecondPrescriptionDiagnosis: zod
          .union([
            zod
              .object({
                PrimaryDiagnosisId: zod
                  .union([zod.number(), zod.null()])
                  .optional(),
                SecondaryDiagnosisId: zod
                  .union([zod.number(), zod.null()])
                  .optional(),
              })
              .describe("DoseSpot prescription diagnosis IDs for requests."),
            zod.null(),
          ])
          .optional(),
        IsRefillReplace: zod.union([zod.boolean(), zod.null()]).optional(),
        IsUrgent: zod.union([zod.boolean(), zod.null()]).optional(),
        SupervisorId: zod.union([zod.number(), zod.null()]).optional(),
        RetailPharmacyToMailToPatient: zod
          .union([zod.boolean(), zod.null()])
          .optional(),
        Status: zod
          .enum([
            "Unknown",
            "Active",
            "Inactive",
            "Discontinued",
            "Deleted",
            "Completed",
            "CancelRequested",
            "CancelPending",
            "Cancelled",
            "CancelDenied",
            "Changed",
            "FullFill",
            "PartialFill",
            "NoFill",
          ])
          .describe("Valid medication status types for DoseSpot."),
        InactiveDate: zod.union([zod.string(), zod.null()]).optional(),
        Comment: zod.union([zod.string(), zod.null()]).optional(),
        Encounter: zod.union([zod.string(), zod.null()]).optional(),
      })
      .describe("Request for free text supply prescription creation\/editing."),
    zod
      .object({
        SupplyId: zod.number(),
        Refills: zod.number(),
        DaysSupply: zod.union([zod.number(), zod.null()]).optional(),
        DispenseUnitId: zod.number(),
        Quantity: zod.number(),
        Directions: zod.string(),
        PharmacyId: zod.number(),
        PharmacyNotes: zod.union([zod.string(), zod.null()]).optional(),
        NoSubstitutions: zod.union([zod.boolean(), zod.null()]).optional(),
        EffectiveDate: zod.string(),
        RxReferenceNumber: zod.union([zod.string(), zod.null()]).optional(),
        EligibilityId: zod.union([zod.number(), zod.null()]).optional(),
        NonDoseSpotPrescriptionId: zod
          .union([zod.string(), zod.null()])
          .optional(),
        FirstPrescriptionDiagnosis: zod
          .union([
            zod
              .object({
                PrimaryDiagnosisId: zod
                  .union([zod.number(), zod.null()])
                  .optional(),
                SecondaryDiagnosisId: zod
                  .union([zod.number(), zod.null()])
                  .optional(),
              })
              .describe("DoseSpot prescription diagnosis IDs for requests."),
            zod.null(),
          ])
          .optional(),
        SecondPrescriptionDiagnosis: zod
          .union([
            zod
              .object({
                PrimaryDiagnosisId: zod
                  .union([zod.number(), zod.null()])
                  .optional(),
                SecondaryDiagnosisId: zod
                  .union([zod.number(), zod.null()])
                  .optional(),
              })
              .describe("DoseSpot prescription diagnosis IDs for requests."),
            zod.null(),
          ])
          .optional(),
        IsRefillReplace: zod.union([zod.boolean(), zod.null()]).optional(),
        IsUrgent: zod.union([zod.boolean(), zod.null()]).optional(),
        SupervisorId: zod.union([zod.number(), zod.null()]).optional(),
        RetailPharmacyToMailToPatient: zod
          .union([zod.boolean(), zod.null()])
          .optional(),
        Status: zod
          .enum([
            "Unknown",
            "Active",
            "Inactive",
            "Discontinued",
            "Deleted",
            "Completed",
            "CancelRequested",
            "CancelPending",
            "Cancelled",
            "CancelDenied",
            "Changed",
            "FullFill",
            "PartialFill",
            "NoFill",
          ])
          .describe("Valid medication status types for DoseSpot."),
        InactiveDate: zod.union([zod.string(), zod.null()]).optional(),
        Comment: zod.union([zod.string(), zod.null()]).optional(),
        Encounter: zod.union([zod.string(), zod.null()]).optional(),
      })
      .describe("Request for coded supply prescription creation\/editing."),
    zod
      .object({
        CompoundDescription: zod.string(),
        CompoundIngredients: zod.array(
          zod
            .object({
              DispensableDrugId: zod
                .union([zod.number(), zod.null()])
                .optional(),
              FreeText: zod.union([zod.string(), zod.null()]).optional(),
              DispenseUnitId: zod.union([zod.number(), zod.null()]).optional(),
              Quantity: zod.string(),
              IsFreeTextEPCS: zod.union([zod.boolean(), zod.null()]).optional(),
            })
            .describe("DoseSpot compound ingredient information."),
        ),
        Refills: zod.number(),
        DaysSupply: zod.union([zod.number(), zod.null()]).optional(),
        DispenseUnitId: zod.number(),
        Quantity: zod.number(),
        Directions: zod.string(),
        PharmacyId: zod.number(),
        PharmacyNotes: zod.union([zod.string(), zod.null()]).optional(),
        NoSubstitutions: zod.union([zod.boolean(), zod.null()]).optional(),
        EffectiveDate: zod.string(),
        RxReferenceNumber: zod.union([zod.string(), zod.null()]).optional(),
        EligibilityId: zod.union([zod.number(), zod.null()]).optional(),
        NonDoseSpotPrescriptionId: zod
          .union([zod.string(), zod.null()])
          .optional(),
        FirstPrescriptionDiagnosis: zod
          .union([
            zod
              .object({
                PrimaryDiagnosisId: zod
                  .union([zod.number(), zod.null()])
                  .optional(),
                SecondaryDiagnosisId: zod
                  .union([zod.number(), zod.null()])
                  .optional(),
              })
              .describe("DoseSpot prescription diagnosis IDs for requests."),
            zod.null(),
          ])
          .optional(),
        SecondPrescriptionDiagnosis: zod
          .union([
            zod
              .object({
                PrimaryDiagnosisId: zod
                  .union([zod.number(), zod.null()])
                  .optional(),
                SecondaryDiagnosisId: zod
                  .union([zod.number(), zod.null()])
                  .optional(),
              })
              .describe("DoseSpot prescription diagnosis IDs for requests."),
            zod.null(),
          ])
          .optional(),
        IsRefillReplace: zod.union([zod.boolean(), zod.null()]).optional(),
        IsUrgent: zod.union([zod.boolean(), zod.null()]).optional(),
        SupervisorId: zod.union([zod.number(), zod.null()]).optional(),
        RetailPharmacyToMailToPatient: zod
          .union([zod.boolean(), zod.null()])
          .optional(),
        Status: zod
          .enum([
            "Unknown",
            "Active",
            "Inactive",
            "Discontinued",
            "Deleted",
            "Completed",
            "CancelRequested",
            "CancelPending",
            "Cancelled",
            "CancelDenied",
            "Changed",
            "FullFill",
            "PartialFill",
            "NoFill",
          ])
          .describe("Valid medication status types for DoseSpot."),
        InactiveDate: zod.union([zod.string(), zod.null()]).optional(),
        Comment: zod.union([zod.string(), zod.null()]).optional(),
        Encounter: zod.union([zod.string(), zod.null()]).optional(),
      })
      .describe("Request for compound prescription creation\/editing."),
  ]),
  clinicianRequestTicket: zod.union([zod.uuid(), zod.null()]).optional(),
  diagnosis: zod
    .union([
      zod
        .object({
          diagnosis_id: zod.union([zod.number(), zod.null()]).optional(),
          diagnosis_code: zod.union([zod.string(), zod.null()]).optional(),
          diagnosis_description: zod
            .union([zod.string(), zod.null()])
            .optional(),
        })
        .describe(
          "Optional diagnosis hint passed into :meth:`add_prescription`.",
        ),
      zod.null(),
    ])
    .optional(),
  sourceProposedActionExternalId: zod
    .union([zod.string(), zod.null()])
    .optional(),
  sourceActionId: zod.union([zod.uuid(), zod.null()]).optional(),
});

export const createPrescriptionResponse = zod
  .object({
    prescription: zod
      .object({
        PrescriptionId: zod.union([zod.number(), zod.null()]).optional(),
        PriorAuthorizationCaseId: zod
          .union([zod.number(), zod.null()])
          .optional(),
        WrittenDate: zod.union([zod.string(), zod.null()]).optional(),
        Directions: zod.union([zod.string(), zod.null()]).optional(),
        Quantity: zod.union([zod.string(), zod.null()]).optional(),
        DispenseUnitId: zod.union([zod.number(), zod.null()]).optional(),
        Refills: zod.union([zod.string(), zod.null()]).optional(),
        DaysSupply: zod.union([zod.number(), zod.null()]).optional(),
        PharmacyId: zod.union([zod.number(), zod.null()]).optional(),
        PharmacyNotes: zod.union([zod.string(), zod.null()]).optional(),
        NoSubstitutions: zod.union([zod.boolean(), zod.null()]).optional(),
        EffectiveDate: zod.union([zod.string(), zod.null()]).optional(),
        LastFillDate: zod.union([zod.string(), zod.null()]).optional(),
        PrescriberId: zod.union([zod.number(), zod.null()]).optional(),
        PrescriberAgentId: zod.union([zod.number(), zod.null()]).optional(),
        RxReferenceNumber: zod.union([zod.string(), zod.null()]).optional(),
        Status: zod
          .union([
            zod
              .enum([
                "Unknown",
                "Entered",
                "Printed",
                "Sending",
                "eRxSent",
                "FaxSent",
                "Error",
                "Deleted",
                "Requested",
                "Edited",
                "EpcsError",
                "EpcsSigned",
                "ReadyToSign",
                "PharmacyVerified",
                "PharmacySelect",
              ])
              .describe("Valid prescription status types for DoseSpot."),
            zod.null(),
          ])
          .optional(),
        Formulary: zod.union([zod.boolean(), zod.null()]).optional(),
        EligibilityId: zod.union([zod.number(), zod.null()]).optional(),
        Type: zod
          .union([
            zod
              .enum(["Coded", "FreeText", "NDC", "Supply", "Compound"])
              .describe("Valid prescription types for DoseSpot."),
            zod.null(),
          ])
          .optional(),
        NonDoseSpotPrescriptionId: zod
          .union([zod.string(), zod.null()])
          .optional(),
        ErrorIgnored: zod.union([zod.boolean(), zod.null()]).optional(),
        SupplyId: zod.union([zod.number(), zod.null()]).optional(),
        FreeTextType: zod
          .union([
            zod
              .enum(["Medication", "Supply", "Compound"])
              .describe("Valid free text types for DoseSpot prescriptions."),
            zod.null(),
          ])
          .optional(),
        ClinicId: zod.union([zod.number(), zod.null()]).optional(),
        SupervisorId: zod.union([zod.number(), zod.null()]).optional(),
        IsUrgent: zod.union([zod.boolean(), zod.null()]).optional(),
        IsRxRenewal: zod.union([zod.boolean(), zod.null()]).optional(),
        RxRenewalNote: zod.union([zod.string(), zod.null()]).optional(),
        FirstPrescriptionDiagnosis: zod
          .union([
            zod
              .object({
                PrimaryDiagnosis: zod
                  .union([
                    zod
                      .object({
                        DiagnosisId: zod
                          .union([zod.number(), zod.null()])
                          .optional(),
                        DiagnosisCode: zod
                          .union([zod.string(), zod.null()])
                          .optional(),
                        DiagnosisDescription: zod
                          .union([zod.string(), zod.null()])
                          .optional(),
                      })
                      .describe("DoseSpot diagnosis information."),
                    zod.null(),
                  ])
                  .optional(),
                SecondaryDiagnosis: zod
                  .union([
                    zod
                      .object({
                        DiagnosisId: zod
                          .union([zod.number(), zod.null()])
                          .optional(),
                        DiagnosisCode: zod
                          .union([zod.string(), zod.null()])
                          .optional(),
                        DiagnosisDescription: zod
                          .union([zod.string(), zod.null()])
                          .optional(),
                      })
                      .describe("DoseSpot diagnosis information."),
                    zod.null(),
                  ])
                  .optional(),
              })
              .describe("DoseSpot prescription diagnosis information."),
            zod.null(),
          ])
          .optional(),
        SecondPrescriptionDiagnosis: zod
          .union([
            zod
              .object({
                PrimaryDiagnosis: zod
                  .union([
                    zod
                      .object({
                        DiagnosisId: zod
                          .union([zod.number(), zod.null()])
                          .optional(),
                        DiagnosisCode: zod
                          .union([zod.string(), zod.null()])
                          .optional(),
                        DiagnosisDescription: zod
                          .union([zod.string(), zod.null()])
                          .optional(),
                      })
                      .describe("DoseSpot diagnosis information."),
                    zod.null(),
                  ])
                  .optional(),
                SecondaryDiagnosis: zod
                  .union([
                    zod
                      .object({
                        DiagnosisId: zod
                          .union([zod.number(), zod.null()])
                          .optional(),
                        DiagnosisCode: zod
                          .union([zod.string(), zod.null()])
                          .optional(),
                        DiagnosisDescription: zod
                          .union([zod.string(), zod.null()])
                          .optional(),
                      })
                      .describe("DoseSpot diagnosis information."),
                    zod.null(),
                  ])
                  .optional(),
              })
              .describe("DoseSpot prescription diagnosis information."),
            zod.null(),
          ])
          .optional(),
        Strength: zod.union([zod.string(), zod.null()]).optional(),
        PatientMedicationId: zod.union([zod.number(), zod.null()]).optional(),
        MedicationStatus: zod
          .union([
            zod
              .enum([
                "Unknown",
                "Active",
                "Inactive",
                "Discontinued",
                "Deleted",
                "Completed",
                "CancelRequested",
                "CancelPending",
                "Cancelled",
                "CancelDenied",
                "Changed",
                "FullFill",
                "PartialFill",
                "NoFill",
              ])
              .describe("Valid medication status types for DoseSpot."),
            zod.null(),
          ])
          .optional(),
        Comment: zod.union([zod.string(), zod.null()]).optional(),
        DateInactive: zod.union([zod.string(), zod.null()]).optional(),
        Encounter: zod.union([zod.string(), zod.null()]).optional(),
        DisplayName: zod.union([zod.string(), zod.null()]).optional(),
        DispensableDrugId: zod.union([zod.number(), zod.null()]).optional(),
        Schedule: zod.union([zod.number(), zod.null()]).optional(),
        CompoundIngredients: zod
          .union([
            zod.array(
              zod
                .object({
                  DispensableDrugId: zod
                    .union([zod.number(), zod.null()])
                    .optional(),
                  FreeText: zod.union([zod.string(), zod.null()]).optional(),
                  DispenseUnitId: zod
                    .union([zod.number(), zod.null()])
                    .optional(),
                  Quantity: zod.string(),
                  IsFreeTextEPCS: zod
                    .union([zod.boolean(), zod.null()])
                    .optional(),
                })
                .describe("DoseSpot compound ingredient information."),
            ),
            zod.null(),
          ])
          .optional(),
      })
      .describe("Complete prescription information from DoseSpot API."),
    prescriptionRecordId: zod.uuid(),
    dosespotPrescriptionId: zod.string(),
  })
  .describe(
    "A DoseSpot prescription and the Lotus record that owns its workflow.",
  );

/**
 * Edit an existing prescription.

This endpoint updates an existing prescription in DoseSpot.

Args:
    dosespot_prescription_id: The DoseSpot prescription ID to edit
    request: The updated prescription data

Returns:
    PrescriptionT: The updated prescription information

Raises:
    AuthException: If the user lacks required privileges
    ValueError: If the prescription record is not found or update fails
 * @summary Edit Prescription
 */
export const editPrescriptionParams = zod.object({
  dosespot_prescription_id: zod.string(),
});

export const editPrescriptionBody = zod.object({
  prescriptionData: zod.union([
    zod
      .object({
        DispensableDrugId: zod.number(),
        PatientFormularyId: zod.union([zod.number(), zod.null()]).optional(),
        Refills: zod.number(),
        DaysSupply: zod.union([zod.number(), zod.null()]).optional(),
        DispenseUnitId: zod.number(),
        Quantity: zod.number(),
        Directions: zod.string(),
        PharmacyId: zod.number(),
        PharmacyNotes: zod.union([zod.string(), zod.null()]).optional(),
        NoSubstitutions: zod.union([zod.boolean(), zod.null()]).optional(),
        EffectiveDate: zod.string(),
        RxReferenceNumber: zod.union([zod.string(), zod.null()]).optional(),
        EligibilityId: zod.union([zod.number(), zod.null()]).optional(),
        NonDoseSpotPrescriptionId: zod
          .union([zod.string(), zod.null()])
          .optional(),
        FirstPrescriptionDiagnosis: zod
          .union([
            zod
              .object({
                PrimaryDiagnosisId: zod
                  .union([zod.number(), zod.null()])
                  .optional(),
                SecondaryDiagnosisId: zod
                  .union([zod.number(), zod.null()])
                  .optional(),
              })
              .describe("DoseSpot prescription diagnosis IDs for requests."),
            zod.null(),
          ])
          .optional(),
        SecondPrescriptionDiagnosis: zod
          .union([
            zod
              .object({
                PrimaryDiagnosisId: zod
                  .union([zod.number(), zod.null()])
                  .optional(),
                SecondaryDiagnosisId: zod
                  .union([zod.number(), zod.null()])
                  .optional(),
              })
              .describe("DoseSpot prescription diagnosis IDs for requests."),
            zod.null(),
          ])
          .optional(),
        IsRefillReplace: zod.union([zod.boolean(), zod.null()]).optional(),
        IsUrgent: zod.union([zod.boolean(), zod.null()]).optional(),
        SupervisorId: zod.union([zod.number(), zod.null()]).optional(),
        RetailPharmacyToMailToPatient: zod
          .union([zod.boolean(), zod.null()])
          .optional(),
        Status: zod
          .enum([
            "Unknown",
            "Active",
            "Inactive",
            "Discontinued",
            "Deleted",
            "Completed",
            "CancelRequested",
            "CancelPending",
            "Cancelled",
            "CancelDenied",
            "Changed",
            "FullFill",
            "PartialFill",
            "NoFill",
          ])
          .describe("Valid medication status types for DoseSpot."),
        InactiveDate: zod.union([zod.string(), zod.null()]).optional(),
        Comment: zod.union([zod.string(), zod.null()]).optional(),
        Encounter: zod.union([zod.string(), zod.null()]).optional(),
      })
      .describe("Request for coded prescription creation\/editing."),
    zod
      .object({
        DisplayName: zod.string(),
        NotControlled: zod.boolean(),
        Refills: zod.number(),
        DaysSupply: zod.union([zod.number(), zod.null()]).optional(),
        DispenseUnitId: zod.number(),
        Quantity: zod.number(),
        Directions: zod.string(),
        PharmacyId: zod.number(),
        PharmacyNotes: zod.union([zod.string(), zod.null()]).optional(),
        NoSubstitutions: zod.union([zod.boolean(), zod.null()]).optional(),
        EffectiveDate: zod.string(),
        RxReferenceNumber: zod.union([zod.string(), zod.null()]).optional(),
        EligibilityId: zod.union([zod.number(), zod.null()]).optional(),
        NonDoseSpotPrescriptionId: zod
          .union([zod.string(), zod.null()])
          .optional(),
        FirstPrescriptionDiagnosis: zod
          .union([
            zod
              .object({
                PrimaryDiagnosisId: zod
                  .union([zod.number(), zod.null()])
                  .optional(),
                SecondaryDiagnosisId: zod
                  .union([zod.number(), zod.null()])
                  .optional(),
              })
              .describe("DoseSpot prescription diagnosis IDs for requests."),
            zod.null(),
          ])
          .optional(),
        SecondPrescriptionDiagnosis: zod
          .union([
            zod
              .object({
                PrimaryDiagnosisId: zod
                  .union([zod.number(), zod.null()])
                  .optional(),
                SecondaryDiagnosisId: zod
                  .union([zod.number(), zod.null()])
                  .optional(),
              })
              .describe("DoseSpot prescription diagnosis IDs for requests."),
            zod.null(),
          ])
          .optional(),
        IsRefillReplace: zod.union([zod.boolean(), zod.null()]).optional(),
        IsUrgent: zod.union([zod.boolean(), zod.null()]).optional(),
        SupervisorId: zod.union([zod.number(), zod.null()]).optional(),
        RetailPharmacyToMailToPatient: zod
          .union([zod.boolean(), zod.null()])
          .optional(),
        Status: zod
          .enum([
            "Unknown",
            "Active",
            "Inactive",
            "Discontinued",
            "Deleted",
            "Completed",
            "CancelRequested",
            "CancelPending",
            "Cancelled",
            "CancelDenied",
            "Changed",
            "FullFill",
            "PartialFill",
            "NoFill",
          ])
          .describe("Valid medication status types for DoseSpot."),
        InactiveDate: zod.union([zod.string(), zod.null()]).optional(),
        Comment: zod.union([zod.string(), zod.null()]).optional(),
        Encounter: zod.union([zod.string(), zod.null()]).optional(),
      })
      .describe("Request for free text supply prescription creation\/editing."),
    zod
      .object({
        SupplyId: zod.number(),
        Refills: zod.number(),
        DaysSupply: zod.union([zod.number(), zod.null()]).optional(),
        DispenseUnitId: zod.number(),
        Quantity: zod.number(),
        Directions: zod.string(),
        PharmacyId: zod.number(),
        PharmacyNotes: zod.union([zod.string(), zod.null()]).optional(),
        NoSubstitutions: zod.union([zod.boolean(), zod.null()]).optional(),
        EffectiveDate: zod.string(),
        RxReferenceNumber: zod.union([zod.string(), zod.null()]).optional(),
        EligibilityId: zod.union([zod.number(), zod.null()]).optional(),
        NonDoseSpotPrescriptionId: zod
          .union([zod.string(), zod.null()])
          .optional(),
        FirstPrescriptionDiagnosis: zod
          .union([
            zod
              .object({
                PrimaryDiagnosisId: zod
                  .union([zod.number(), zod.null()])
                  .optional(),
                SecondaryDiagnosisId: zod
                  .union([zod.number(), zod.null()])
                  .optional(),
              })
              .describe("DoseSpot prescription diagnosis IDs for requests."),
            zod.null(),
          ])
          .optional(),
        SecondPrescriptionDiagnosis: zod
          .union([
            zod
              .object({
                PrimaryDiagnosisId: zod
                  .union([zod.number(), zod.null()])
                  .optional(),
                SecondaryDiagnosisId: zod
                  .union([zod.number(), zod.null()])
                  .optional(),
              })
              .describe("DoseSpot prescription diagnosis IDs for requests."),
            zod.null(),
          ])
          .optional(),
        IsRefillReplace: zod.union([zod.boolean(), zod.null()]).optional(),
        IsUrgent: zod.union([zod.boolean(), zod.null()]).optional(),
        SupervisorId: zod.union([zod.number(), zod.null()]).optional(),
        RetailPharmacyToMailToPatient: zod
          .union([zod.boolean(), zod.null()])
          .optional(),
        Status: zod
          .enum([
            "Unknown",
            "Active",
            "Inactive",
            "Discontinued",
            "Deleted",
            "Completed",
            "CancelRequested",
            "CancelPending",
            "Cancelled",
            "CancelDenied",
            "Changed",
            "FullFill",
            "PartialFill",
            "NoFill",
          ])
          .describe("Valid medication status types for DoseSpot."),
        InactiveDate: zod.union([zod.string(), zod.null()]).optional(),
        Comment: zod.union([zod.string(), zod.null()]).optional(),
        Encounter: zod.union([zod.string(), zod.null()]).optional(),
      })
      .describe("Request for coded supply prescription creation\/editing."),
    zod
      .object({
        CompoundDescription: zod.string(),
        CompoundIngredients: zod.array(
          zod
            .object({
              DispensableDrugId: zod
                .union([zod.number(), zod.null()])
                .optional(),
              FreeText: zod.union([zod.string(), zod.null()]).optional(),
              DispenseUnitId: zod.union([zod.number(), zod.null()]).optional(),
              Quantity: zod.string(),
              IsFreeTextEPCS: zod.union([zod.boolean(), zod.null()]).optional(),
            })
            .describe("DoseSpot compound ingredient information."),
        ),
        Refills: zod.number(),
        DaysSupply: zod.union([zod.number(), zod.null()]).optional(),
        DispenseUnitId: zod.number(),
        Quantity: zod.number(),
        Directions: zod.string(),
        PharmacyId: zod.number(),
        PharmacyNotes: zod.union([zod.string(), zod.null()]).optional(),
        NoSubstitutions: zod.union([zod.boolean(), zod.null()]).optional(),
        EffectiveDate: zod.string(),
        RxReferenceNumber: zod.union([zod.string(), zod.null()]).optional(),
        EligibilityId: zod.union([zod.number(), zod.null()]).optional(),
        NonDoseSpotPrescriptionId: zod
          .union([zod.string(), zod.null()])
          .optional(),
        FirstPrescriptionDiagnosis: zod
          .union([
            zod
              .object({
                PrimaryDiagnosisId: zod
                  .union([zod.number(), zod.null()])
                  .optional(),
                SecondaryDiagnosisId: zod
                  .union([zod.number(), zod.null()])
                  .optional(),
              })
              .describe("DoseSpot prescription diagnosis IDs for requests."),
            zod.null(),
          ])
          .optional(),
        SecondPrescriptionDiagnosis: zod
          .union([
            zod
              .object({
                PrimaryDiagnosisId: zod
                  .union([zod.number(), zod.null()])
                  .optional(),
                SecondaryDiagnosisId: zod
                  .union([zod.number(), zod.null()])
                  .optional(),
              })
              .describe("DoseSpot prescription diagnosis IDs for requests."),
            zod.null(),
          ])
          .optional(),
        IsRefillReplace: zod.union([zod.boolean(), zod.null()]).optional(),
        IsUrgent: zod.union([zod.boolean(), zod.null()]).optional(),
        SupervisorId: zod.union([zod.number(), zod.null()]).optional(),
        RetailPharmacyToMailToPatient: zod
          .union([zod.boolean(), zod.null()])
          .optional(),
        Status: zod
          .enum([
            "Unknown",
            "Active",
            "Inactive",
            "Discontinued",
            "Deleted",
            "Completed",
            "CancelRequested",
            "CancelPending",
            "Cancelled",
            "CancelDenied",
            "Changed",
            "FullFill",
            "PartialFill",
            "NoFill",
          ])
          .describe("Valid medication status types for DoseSpot."),
        InactiveDate: zod.union([zod.string(), zod.null()]).optional(),
        Comment: zod.union([zod.string(), zod.null()]).optional(),
        Encounter: zod.union([zod.string(), zod.null()]).optional(),
      })
      .describe("Request for compound prescription creation\/editing."),
  ]),
});

export const editPrescriptionResponse = zod
  .object({
    PrescriptionId: zod.union([zod.number(), zod.null()]).optional(),
    PriorAuthorizationCaseId: zod.union([zod.number(), zod.null()]).optional(),
    WrittenDate: zod.union([zod.string(), zod.null()]).optional(),
    Directions: zod.union([zod.string(), zod.null()]).optional(),
    Quantity: zod.union([zod.string(), zod.null()]).optional(),
    DispenseUnitId: zod.union([zod.number(), zod.null()]).optional(),
    Refills: zod.union([zod.string(), zod.null()]).optional(),
    DaysSupply: zod.union([zod.number(), zod.null()]).optional(),
    PharmacyId: zod.union([zod.number(), zod.null()]).optional(),
    PharmacyNotes: zod.union([zod.string(), zod.null()]).optional(),
    NoSubstitutions: zod.union([zod.boolean(), zod.null()]).optional(),
    EffectiveDate: zod.union([zod.string(), zod.null()]).optional(),
    LastFillDate: zod.union([zod.string(), zod.null()]).optional(),
    PrescriberId: zod.union([zod.number(), zod.null()]).optional(),
    PrescriberAgentId: zod.union([zod.number(), zod.null()]).optional(),
    RxReferenceNumber: zod.union([zod.string(), zod.null()]).optional(),
    Status: zod
      .union([
        zod
          .enum([
            "Unknown",
            "Entered",
            "Printed",
            "Sending",
            "eRxSent",
            "FaxSent",
            "Error",
            "Deleted",
            "Requested",
            "Edited",
            "EpcsError",
            "EpcsSigned",
            "ReadyToSign",
            "PharmacyVerified",
            "PharmacySelect",
          ])
          .describe("Valid prescription status types for DoseSpot."),
        zod.null(),
      ])
      .optional(),
    Formulary: zod.union([zod.boolean(), zod.null()]).optional(),
    EligibilityId: zod.union([zod.number(), zod.null()]).optional(),
    Type: zod
      .union([
        zod
          .enum(["Coded", "FreeText", "NDC", "Supply", "Compound"])
          .describe("Valid prescription types for DoseSpot."),
        zod.null(),
      ])
      .optional(),
    NonDoseSpotPrescriptionId: zod.union([zod.string(), zod.null()]).optional(),
    ErrorIgnored: zod.union([zod.boolean(), zod.null()]).optional(),
    SupplyId: zod.union([zod.number(), zod.null()]).optional(),
    FreeTextType: zod
      .union([
        zod
          .enum(["Medication", "Supply", "Compound"])
          .describe("Valid free text types for DoseSpot prescriptions."),
        zod.null(),
      ])
      .optional(),
    ClinicId: zod.union([zod.number(), zod.null()]).optional(),
    SupervisorId: zod.union([zod.number(), zod.null()]).optional(),
    IsUrgent: zod.union([zod.boolean(), zod.null()]).optional(),
    IsRxRenewal: zod.union([zod.boolean(), zod.null()]).optional(),
    RxRenewalNote: zod.union([zod.string(), zod.null()]).optional(),
    FirstPrescriptionDiagnosis: zod
      .union([
        zod
          .object({
            PrimaryDiagnosis: zod
              .union([
                zod
                  .object({
                    DiagnosisId: zod
                      .union([zod.number(), zod.null()])
                      .optional(),
                    DiagnosisCode: zod
                      .union([zod.string(), zod.null()])
                      .optional(),
                    DiagnosisDescription: zod
                      .union([zod.string(), zod.null()])
                      .optional(),
                  })
                  .describe("DoseSpot diagnosis information."),
                zod.null(),
              ])
              .optional(),
            SecondaryDiagnosis: zod
              .union([
                zod
                  .object({
                    DiagnosisId: zod
                      .union([zod.number(), zod.null()])
                      .optional(),
                    DiagnosisCode: zod
                      .union([zod.string(), zod.null()])
                      .optional(),
                    DiagnosisDescription: zod
                      .union([zod.string(), zod.null()])
                      .optional(),
                  })
                  .describe("DoseSpot diagnosis information."),
                zod.null(),
              ])
              .optional(),
          })
          .describe("DoseSpot prescription diagnosis information."),
        zod.null(),
      ])
      .optional(),
    SecondPrescriptionDiagnosis: zod
      .union([
        zod
          .object({
            PrimaryDiagnosis: zod
              .union([
                zod
                  .object({
                    DiagnosisId: zod
                      .union([zod.number(), zod.null()])
                      .optional(),
                    DiagnosisCode: zod
                      .union([zod.string(), zod.null()])
                      .optional(),
                    DiagnosisDescription: zod
                      .union([zod.string(), zod.null()])
                      .optional(),
                  })
                  .describe("DoseSpot diagnosis information."),
                zod.null(),
              ])
              .optional(),
            SecondaryDiagnosis: zod
              .union([
                zod
                  .object({
                    DiagnosisId: zod
                      .union([zod.number(), zod.null()])
                      .optional(),
                    DiagnosisCode: zod
                      .union([zod.string(), zod.null()])
                      .optional(),
                    DiagnosisDescription: zod
                      .union([zod.string(), zod.null()])
                      .optional(),
                  })
                  .describe("DoseSpot diagnosis information."),
                zod.null(),
              ])
              .optional(),
          })
          .describe("DoseSpot prescription diagnosis information."),
        zod.null(),
      ])
      .optional(),
    Strength: zod.union([zod.string(), zod.null()]).optional(),
    PatientMedicationId: zod.union([zod.number(), zod.null()]).optional(),
    MedicationStatus: zod
      .union([
        zod
          .enum([
            "Unknown",
            "Active",
            "Inactive",
            "Discontinued",
            "Deleted",
            "Completed",
            "CancelRequested",
            "CancelPending",
            "Cancelled",
            "CancelDenied",
            "Changed",
            "FullFill",
            "PartialFill",
            "NoFill",
          ])
          .describe("Valid medication status types for DoseSpot."),
        zod.null(),
      ])
      .optional(),
    Comment: zod.union([zod.string(), zod.null()]).optional(),
    DateInactive: zod.union([zod.string(), zod.null()]).optional(),
    Encounter: zod.union([zod.string(), zod.null()]).optional(),
    DisplayName: zod.union([zod.string(), zod.null()]).optional(),
    DispensableDrugId: zod.union([zod.number(), zod.null()]).optional(),
    Schedule: zod.union([zod.number(), zod.null()]).optional(),
    CompoundIngredients: zod
      .union([
        zod.array(
          zod
            .object({
              DispensableDrugId: zod
                .union([zod.number(), zod.null()])
                .optional(),
              FreeText: zod.union([zod.string(), zod.null()]).optional(),
              DispenseUnitId: zod.union([zod.number(), zod.null()]).optional(),
              Quantity: zod.string(),
              IsFreeTextEPCS: zod.union([zod.boolean(), zod.null()]).optional(),
            })
            .describe("DoseSpot compound ingredient information."),
        ),
        zod.null(),
      ])
      .optional(),
  })
  .describe("Complete prescription information from DoseSpot API.");

/**
 * Request prescription cancellation, preserving the record and its history.

The legacy DELETE route returns success only when DoseSpot confirms cancellation.

Args:
    dosespot_prescription_id: The DoseSpot prescription ID to delete

Returns:
    PrescriptionMessageT: Message indicating success or failure with error details

Raises:
    AuthException: If the user lacks required privileges
    ValueError: If the prescription record is not found
 * @summary Delete Prescription
 */
export const deletePrescriptionParams = zod.object({
  dosespot_prescription_id: zod.string(),
});

export const deletePrescriptionResponse = zod
  .object({
    success: zod.boolean(),
    message: zod.union([zod.string(), zod.null()]).optional(),
  })
  .describe(
    "Message response for prescription operations that may have errors.",
  );

/**
 * @summary Cancel Prescription And Pa
 */
export const cancelPrescriptionAndPaParams = zod.object({
  prescription_record_id: zod.uuid(),
});

export const cancelPrescriptionAndPaResponsePrescriptionOutcomeDefault =
  "unconfirmed";
export const cancelPrescriptionAndPaResponsePrescriptionCommandAttemptedDefault = false;
export const cancelPrescriptionAndPaResponsePriorAuthOutcomeDefault =
  "unconfirmed";
export const cancelPrescriptionAndPaResponsePriorAuthCommandAttemptedDefault = false;

export const cancelPrescriptionAndPaResponse = zod.object({
  requested_by: zod.uuid(),
  requested_at: zod.iso.datetime({}),
  prior_auth_id: zod.union([zod.number(), zod.null()]).optional(),
  prescription: zod
    .object({
      outcome: zod
        .enum(["unconfirmed", "pending", "confirmed", "refused", "not_needed"])
        .default(cancelPrescriptionAndPaResponsePrescriptionOutcomeDefault),
      status: zod.union([zod.string(), zod.null()]).optional(),
      command_attempted: zod.union([zod.boolean(), zod.null()]).optional(),
      error: zod.union([zod.string(), zod.null()]).optional(),
    })
    .optional(),
  prior_auth: zod
    .object({
      outcome: zod
        .enum(["unconfirmed", "pending", "confirmed", "refused", "not_needed"])
        .default(cancelPrescriptionAndPaResponsePriorAuthOutcomeDefault),
      status: zod.union([zod.string(), zod.null()]).optional(),
      command_attempted: zod.union([zod.boolean(), zod.null()]).optional(),
      error: zod.union([zod.string(), zod.null()]).optional(),
    })
    .optional(),
});

/**
 * Get prescriptions for a patient with optional pagination.

This endpoint retrieves prescriptions for the specified patient with optional pagination support.

Args:
    user_id: The patient's user ID
    limit: Maximum number of prescriptions to return (None for no limit)
    offset: Number of prescriptions to skip
    synchronize: Whether to synchronize with DoseSpot before answering
Returns:
    PaginatedPrescriptionsResponseT: Paginated list of prescriptions for the patient

Raises:
    AuthException: If the user lacks required privileges
    ValueError: If the patient has no DoseSpot record
 * @summary Get Prescriptions For Patient
 */
export const getPrescriptionsForPatientParams = zod.object({
  user_id: zod.uuid(),
});

export const getPrescriptionsForPatientQueryOffsetDefault = 0;
export const getPrescriptionsForPatientQuerySynchronizeDefault = false;

export const getPrescriptionsForPatientQueryParams = zod.object({
  limit: zod.union([zod.number(), zod.null()]).optional(),
  offset: zod.number().optional(),
  synchronize: zod.boolean().optional(),
});

export const getPrescriptionsForPatientResponseOffsetDefault = 0;
export const getPrescriptionsForPatientResponseHasNextDefault = false;
export const getPrescriptionsForPatientResponseHasPreviousDefault = false;

export const getPrescriptionsForPatientResponse = zod.object({
  prescriptions: zod.array(
    zod
      .object({
        PrescriptionId: zod.union([zod.number(), zod.null()]).optional(),
        PriorAuthorizationCaseId: zod
          .union([zod.number(), zod.null()])
          .optional(),
        WrittenDate: zod.union([zod.string(), zod.null()]).optional(),
        Directions: zod.union([zod.string(), zod.null()]).optional(),
        Quantity: zod.union([zod.string(), zod.null()]).optional(),
        DispenseUnitId: zod.union([zod.number(), zod.null()]).optional(),
        Refills: zod.union([zod.string(), zod.null()]).optional(),
        DaysSupply: zod.union([zod.number(), zod.null()]).optional(),
        PharmacyId: zod.union([zod.number(), zod.null()]).optional(),
        PharmacyNotes: zod.union([zod.string(), zod.null()]).optional(),
        NoSubstitutions: zod.union([zod.boolean(), zod.null()]).optional(),
        EffectiveDate: zod.union([zod.string(), zod.null()]).optional(),
        LastFillDate: zod.union([zod.string(), zod.null()]).optional(),
        PrescriberId: zod.union([zod.number(), zod.null()]).optional(),
        PrescriberAgentId: zod.union([zod.number(), zod.null()]).optional(),
        RxReferenceNumber: zod.union([zod.string(), zod.null()]).optional(),
        Status: zod
          .union([
            zod
              .enum([
                "Unknown",
                "Entered",
                "Printed",
                "Sending",
                "eRxSent",
                "FaxSent",
                "Error",
                "Deleted",
                "Requested",
                "Edited",
                "EpcsError",
                "EpcsSigned",
                "ReadyToSign",
                "PharmacyVerified",
                "PharmacySelect",
              ])
              .describe("Valid prescription status types for DoseSpot."),
            zod.null(),
          ])
          .optional(),
        Formulary: zod.union([zod.boolean(), zod.null()]).optional(),
        EligibilityId: zod.union([zod.number(), zod.null()]).optional(),
        Type: zod
          .union([
            zod
              .enum(["Coded", "FreeText", "NDC", "Supply", "Compound"])
              .describe("Valid prescription types for DoseSpot."),
            zod.null(),
          ])
          .optional(),
        NonDoseSpotPrescriptionId: zod
          .union([zod.string(), zod.null()])
          .optional(),
        ErrorIgnored: zod.union([zod.boolean(), zod.null()]).optional(),
        SupplyId: zod.union([zod.number(), zod.null()]).optional(),
        FreeTextType: zod
          .union([
            zod
              .enum(["Medication", "Supply", "Compound"])
              .describe("Valid free text types for DoseSpot prescriptions."),
            zod.null(),
          ])
          .optional(),
        ClinicId: zod.union([zod.number(), zod.null()]).optional(),
        SupervisorId: zod.union([zod.number(), zod.null()]).optional(),
        IsUrgent: zod.union([zod.boolean(), zod.null()]).optional(),
        IsRxRenewal: zod.union([zod.boolean(), zod.null()]).optional(),
        RxRenewalNote: zod.union([zod.string(), zod.null()]).optional(),
        FirstPrescriptionDiagnosis: zod
          .union([
            zod
              .object({
                PrimaryDiagnosis: zod
                  .union([
                    zod
                      .object({
                        DiagnosisId: zod
                          .union([zod.number(), zod.null()])
                          .optional(),
                        DiagnosisCode: zod
                          .union([zod.string(), zod.null()])
                          .optional(),
                        DiagnosisDescription: zod
                          .union([zod.string(), zod.null()])
                          .optional(),
                      })
                      .describe("DoseSpot diagnosis information."),
                    zod.null(),
                  ])
                  .optional(),
                SecondaryDiagnosis: zod
                  .union([
                    zod
                      .object({
                        DiagnosisId: zod
                          .union([zod.number(), zod.null()])
                          .optional(),
                        DiagnosisCode: zod
                          .union([zod.string(), zod.null()])
                          .optional(),
                        DiagnosisDescription: zod
                          .union([zod.string(), zod.null()])
                          .optional(),
                      })
                      .describe("DoseSpot diagnosis information."),
                    zod.null(),
                  ])
                  .optional(),
              })
              .describe("DoseSpot prescription diagnosis information."),
            zod.null(),
          ])
          .optional(),
        SecondPrescriptionDiagnosis: zod
          .union([
            zod
              .object({
                PrimaryDiagnosis: zod
                  .union([
                    zod
                      .object({
                        DiagnosisId: zod
                          .union([zod.number(), zod.null()])
                          .optional(),
                        DiagnosisCode: zod
                          .union([zod.string(), zod.null()])
                          .optional(),
                        DiagnosisDescription: zod
                          .union([zod.string(), zod.null()])
                          .optional(),
                      })
                      .describe("DoseSpot diagnosis information."),
                    zod.null(),
                  ])
                  .optional(),
                SecondaryDiagnosis: zod
                  .union([
                    zod
                      .object({
                        DiagnosisId: zod
                          .union([zod.number(), zod.null()])
                          .optional(),
                        DiagnosisCode: zod
                          .union([zod.string(), zod.null()])
                          .optional(),
                        DiagnosisDescription: zod
                          .union([zod.string(), zod.null()])
                          .optional(),
                      })
                      .describe("DoseSpot diagnosis information."),
                    zod.null(),
                  ])
                  .optional(),
              })
              .describe("DoseSpot prescription diagnosis information."),
            zod.null(),
          ])
          .optional(),
        Strength: zod.union([zod.string(), zod.null()]).optional(),
        PatientMedicationId: zod.union([zod.number(), zod.null()]).optional(),
        MedicationStatus: zod
          .union([
            zod
              .enum([
                "Unknown",
                "Active",
                "Inactive",
                "Discontinued",
                "Deleted",
                "Completed",
                "CancelRequested",
                "CancelPending",
                "Cancelled",
                "CancelDenied",
                "Changed",
                "FullFill",
                "PartialFill",
                "NoFill",
              ])
              .describe("Valid medication status types for DoseSpot."),
            zod.null(),
          ])
          .optional(),
        Comment: zod.union([zod.string(), zod.null()]).optional(),
        DateInactive: zod.union([zod.string(), zod.null()]).optional(),
        Encounter: zod.union([zod.string(), zod.null()]).optional(),
        DisplayName: zod.union([zod.string(), zod.null()]).optional(),
        DispensableDrugId: zod.union([zod.number(), zod.null()]).optional(),
        Schedule: zod.union([zod.number(), zod.null()]).optional(),
        CompoundIngredients: zod
          .union([
            zod.array(
              zod
                .object({
                  DispensableDrugId: zod
                    .union([zod.number(), zod.null()])
                    .optional(),
                  FreeText: zod.union([zod.string(), zod.null()]).optional(),
                  DispenseUnitId: zod
                    .union([zod.number(), zod.null()])
                    .optional(),
                  Quantity: zod.string(),
                  IsFreeTextEPCS: zod
                    .union([zod.boolean(), zod.null()])
                    .optional(),
                })
                .describe("DoseSpot compound ingredient information."),
            ),
            zod.null(),
          ])
          .optional(),
      })
      .describe("Complete prescription information from DoseSpot API."),
  ),
  totalCount: zod.number(),
  limit: zod.union([zod.number(), zod.null()]).optional(),
  offset: zod.number().optional(),
  hasNext: zod.boolean().optional(),
  hasPrevious: zod.boolean().optional(),
});

/**
 * Get a specific prescription for a patient.

This endpoint retrieves a specific prescription for the specified patient.

Args:
    user_id: The patient's user ID
    dosespot_prescription_id: The DoseSpot prescription ID

Returns:
    PrescriptionT or None: The prescription information if found

Raises:
    AuthException: If the user lacks required privileges
    ValueError: If the patient has no DoseSpot record
 * @summary Get Prescription
 */
export const getPrescriptionParams = zod.object({
  user_id: zod.uuid(),
  dosespot_prescription_id: zod.string(),
});

export const getPrescriptionResponse = zod.union([
  zod
    .object({
      PrescriptionId: zod.union([zod.number(), zod.null()]).optional(),
      PriorAuthorizationCaseId: zod
        .union([zod.number(), zod.null()])
        .optional(),
      WrittenDate: zod.union([zod.string(), zod.null()]).optional(),
      Directions: zod.union([zod.string(), zod.null()]).optional(),
      Quantity: zod.union([zod.string(), zod.null()]).optional(),
      DispenseUnitId: zod.union([zod.number(), zod.null()]).optional(),
      Refills: zod.union([zod.string(), zod.null()]).optional(),
      DaysSupply: zod.union([zod.number(), zod.null()]).optional(),
      PharmacyId: zod.union([zod.number(), zod.null()]).optional(),
      PharmacyNotes: zod.union([zod.string(), zod.null()]).optional(),
      NoSubstitutions: zod.union([zod.boolean(), zod.null()]).optional(),
      EffectiveDate: zod.union([zod.string(), zod.null()]).optional(),
      LastFillDate: zod.union([zod.string(), zod.null()]).optional(),
      PrescriberId: zod.union([zod.number(), zod.null()]).optional(),
      PrescriberAgentId: zod.union([zod.number(), zod.null()]).optional(),
      RxReferenceNumber: zod.union([zod.string(), zod.null()]).optional(),
      Status: zod
        .union([
          zod
            .enum([
              "Unknown",
              "Entered",
              "Printed",
              "Sending",
              "eRxSent",
              "FaxSent",
              "Error",
              "Deleted",
              "Requested",
              "Edited",
              "EpcsError",
              "EpcsSigned",
              "ReadyToSign",
              "PharmacyVerified",
              "PharmacySelect",
            ])
            .describe("Valid prescription status types for DoseSpot."),
          zod.null(),
        ])
        .optional(),
      Formulary: zod.union([zod.boolean(), zod.null()]).optional(),
      EligibilityId: zod.union([zod.number(), zod.null()]).optional(),
      Type: zod
        .union([
          zod
            .enum(["Coded", "FreeText", "NDC", "Supply", "Compound"])
            .describe("Valid prescription types for DoseSpot."),
          zod.null(),
        ])
        .optional(),
      NonDoseSpotPrescriptionId: zod
        .union([zod.string(), zod.null()])
        .optional(),
      ErrorIgnored: zod.union([zod.boolean(), zod.null()]).optional(),
      SupplyId: zod.union([zod.number(), zod.null()]).optional(),
      FreeTextType: zod
        .union([
          zod
            .enum(["Medication", "Supply", "Compound"])
            .describe("Valid free text types for DoseSpot prescriptions."),
          zod.null(),
        ])
        .optional(),
      ClinicId: zod.union([zod.number(), zod.null()]).optional(),
      SupervisorId: zod.union([zod.number(), zod.null()]).optional(),
      IsUrgent: zod.union([zod.boolean(), zod.null()]).optional(),
      IsRxRenewal: zod.union([zod.boolean(), zod.null()]).optional(),
      RxRenewalNote: zod.union([zod.string(), zod.null()]).optional(),
      FirstPrescriptionDiagnosis: zod
        .union([
          zod
            .object({
              PrimaryDiagnosis: zod
                .union([
                  zod
                    .object({
                      DiagnosisId: zod
                        .union([zod.number(), zod.null()])
                        .optional(),
                      DiagnosisCode: zod
                        .union([zod.string(), zod.null()])
                        .optional(),
                      DiagnosisDescription: zod
                        .union([zod.string(), zod.null()])
                        .optional(),
                    })
                    .describe("DoseSpot diagnosis information."),
                  zod.null(),
                ])
                .optional(),
              SecondaryDiagnosis: zod
                .union([
                  zod
                    .object({
                      DiagnosisId: zod
                        .union([zod.number(), zod.null()])
                        .optional(),
                      DiagnosisCode: zod
                        .union([zod.string(), zod.null()])
                        .optional(),
                      DiagnosisDescription: zod
                        .union([zod.string(), zod.null()])
                        .optional(),
                    })
                    .describe("DoseSpot diagnosis information."),
                  zod.null(),
                ])
                .optional(),
            })
            .describe("DoseSpot prescription diagnosis information."),
          zod.null(),
        ])
        .optional(),
      SecondPrescriptionDiagnosis: zod
        .union([
          zod
            .object({
              PrimaryDiagnosis: zod
                .union([
                  zod
                    .object({
                      DiagnosisId: zod
                        .union([zod.number(), zod.null()])
                        .optional(),
                      DiagnosisCode: zod
                        .union([zod.string(), zod.null()])
                        .optional(),
                      DiagnosisDescription: zod
                        .union([zod.string(), zod.null()])
                        .optional(),
                    })
                    .describe("DoseSpot diagnosis information."),
                  zod.null(),
                ])
                .optional(),
              SecondaryDiagnosis: zod
                .union([
                  zod
                    .object({
                      DiagnosisId: zod
                        .union([zod.number(), zod.null()])
                        .optional(),
                      DiagnosisCode: zod
                        .union([zod.string(), zod.null()])
                        .optional(),
                      DiagnosisDescription: zod
                        .union([zod.string(), zod.null()])
                        .optional(),
                    })
                    .describe("DoseSpot diagnosis information."),
                  zod.null(),
                ])
                .optional(),
            })
            .describe("DoseSpot prescription diagnosis information."),
          zod.null(),
        ])
        .optional(),
      Strength: zod.union([zod.string(), zod.null()]).optional(),
      PatientMedicationId: zod.union([zod.number(), zod.null()]).optional(),
      MedicationStatus: zod
        .union([
          zod
            .enum([
              "Unknown",
              "Active",
              "Inactive",
              "Discontinued",
              "Deleted",
              "Completed",
              "CancelRequested",
              "CancelPending",
              "Cancelled",
              "CancelDenied",
              "Changed",
              "FullFill",
              "PartialFill",
              "NoFill",
            ])
            .describe("Valid medication status types for DoseSpot."),
          zod.null(),
        ])
        .optional(),
      Comment: zod.union([zod.string(), zod.null()]).optional(),
      DateInactive: zod.union([zod.string(), zod.null()]).optional(),
      Encounter: zod.union([zod.string(), zod.null()]).optional(),
      DisplayName: zod.union([zod.string(), zod.null()]).optional(),
      DispensableDrugId: zod.union([zod.number(), zod.null()]).optional(),
      Schedule: zod.union([zod.number(), zod.null()]).optional(),
      CompoundIngredients: zod
        .union([
          zod.array(
            zod
              .object({
                DispensableDrugId: zod
                  .union([zod.number(), zod.null()])
                  .optional(),
                FreeText: zod.union([zod.string(), zod.null()]).optional(),
                DispenseUnitId: zod
                  .union([zod.number(), zod.null()])
                  .optional(),
                Quantity: zod.string(),
                IsFreeTextEPCS: zod
                  .union([zod.boolean(), zod.null()])
                  .optional(),
              })
              .describe("DoseSpot compound ingredient information."),
          ),
          zod.null(),
        ])
        .optional(),
    })
    .describe("Complete prescription information from DoseSpot API."),
  zod.null(),
]);

/**
 * Change the pharmacy for an existing prescription.

This endpoint updates the pharmacy for a specific prescription in DoseSpot.

Args:
    dosespot_prescription_id: The DoseSpot prescription ID to update
    request: The new pharmacy information

Returns:
    PrescriptionT: The updated prescription information

Raises:
    AuthException: If the user lacks required privileges
    ValueError: If the prescription record is not found or pharmacy change fails
 * @summary Change Prescription Pharmacy
 */
export const changePrescriptionPharmacyParams = zod.object({
  dosespot_prescription_id: zod.string(),
});

export const changePrescriptionPharmacyBody = zod.object({
  pharmacyId: zod.number(),
});

export const changePrescriptionPharmacyResponse = zod
  .object({
    PrescriptionId: zod.union([zod.number(), zod.null()]).optional(),
    PriorAuthorizationCaseId: zod.union([zod.number(), zod.null()]).optional(),
    WrittenDate: zod.union([zod.string(), zod.null()]).optional(),
    Directions: zod.union([zod.string(), zod.null()]).optional(),
    Quantity: zod.union([zod.string(), zod.null()]).optional(),
    DispenseUnitId: zod.union([zod.number(), zod.null()]).optional(),
    Refills: zod.union([zod.string(), zod.null()]).optional(),
    DaysSupply: zod.union([zod.number(), zod.null()]).optional(),
    PharmacyId: zod.union([zod.number(), zod.null()]).optional(),
    PharmacyNotes: zod.union([zod.string(), zod.null()]).optional(),
    NoSubstitutions: zod.union([zod.boolean(), zod.null()]).optional(),
    EffectiveDate: zod.union([zod.string(), zod.null()]).optional(),
    LastFillDate: zod.union([zod.string(), zod.null()]).optional(),
    PrescriberId: zod.union([zod.number(), zod.null()]).optional(),
    PrescriberAgentId: zod.union([zod.number(), zod.null()]).optional(),
    RxReferenceNumber: zod.union([zod.string(), zod.null()]).optional(),
    Status: zod
      .union([
        zod
          .enum([
            "Unknown",
            "Entered",
            "Printed",
            "Sending",
            "eRxSent",
            "FaxSent",
            "Error",
            "Deleted",
            "Requested",
            "Edited",
            "EpcsError",
            "EpcsSigned",
            "ReadyToSign",
            "PharmacyVerified",
            "PharmacySelect",
          ])
          .describe("Valid prescription status types for DoseSpot."),
        zod.null(),
      ])
      .optional(),
    Formulary: zod.union([zod.boolean(), zod.null()]).optional(),
    EligibilityId: zod.union([zod.number(), zod.null()]).optional(),
    Type: zod
      .union([
        zod
          .enum(["Coded", "FreeText", "NDC", "Supply", "Compound"])
          .describe("Valid prescription types for DoseSpot."),
        zod.null(),
      ])
      .optional(),
    NonDoseSpotPrescriptionId: zod.union([zod.string(), zod.null()]).optional(),
    ErrorIgnored: zod.union([zod.boolean(), zod.null()]).optional(),
    SupplyId: zod.union([zod.number(), zod.null()]).optional(),
    FreeTextType: zod
      .union([
        zod
          .enum(["Medication", "Supply", "Compound"])
          .describe("Valid free text types for DoseSpot prescriptions."),
        zod.null(),
      ])
      .optional(),
    ClinicId: zod.union([zod.number(), zod.null()]).optional(),
    SupervisorId: zod.union([zod.number(), zod.null()]).optional(),
    IsUrgent: zod.union([zod.boolean(), zod.null()]).optional(),
    IsRxRenewal: zod.union([zod.boolean(), zod.null()]).optional(),
    RxRenewalNote: zod.union([zod.string(), zod.null()]).optional(),
    FirstPrescriptionDiagnosis: zod
      .union([
        zod
          .object({
            PrimaryDiagnosis: zod
              .union([
                zod
                  .object({
                    DiagnosisId: zod
                      .union([zod.number(), zod.null()])
                      .optional(),
                    DiagnosisCode: zod
                      .union([zod.string(), zod.null()])
                      .optional(),
                    DiagnosisDescription: zod
                      .union([zod.string(), zod.null()])
                      .optional(),
                  })
                  .describe("DoseSpot diagnosis information."),
                zod.null(),
              ])
              .optional(),
            SecondaryDiagnosis: zod
              .union([
                zod
                  .object({
                    DiagnosisId: zod
                      .union([zod.number(), zod.null()])
                      .optional(),
                    DiagnosisCode: zod
                      .union([zod.string(), zod.null()])
                      .optional(),
                    DiagnosisDescription: zod
                      .union([zod.string(), zod.null()])
                      .optional(),
                  })
                  .describe("DoseSpot diagnosis information."),
                zod.null(),
              ])
              .optional(),
          })
          .describe("DoseSpot prescription diagnosis information."),
        zod.null(),
      ])
      .optional(),
    SecondPrescriptionDiagnosis: zod
      .union([
        zod
          .object({
            PrimaryDiagnosis: zod
              .union([
                zod
                  .object({
                    DiagnosisId: zod
                      .union([zod.number(), zod.null()])
                      .optional(),
                    DiagnosisCode: zod
                      .union([zod.string(), zod.null()])
                      .optional(),
                    DiagnosisDescription: zod
                      .union([zod.string(), zod.null()])
                      .optional(),
                  })
                  .describe("DoseSpot diagnosis information."),
                zod.null(),
              ])
              .optional(),
            SecondaryDiagnosis: zod
              .union([
                zod
                  .object({
                    DiagnosisId: zod
                      .union([zod.number(), zod.null()])
                      .optional(),
                    DiagnosisCode: zod
                      .union([zod.string(), zod.null()])
                      .optional(),
                    DiagnosisDescription: zod
                      .union([zod.string(), zod.null()])
                      .optional(),
                  })
                  .describe("DoseSpot diagnosis information."),
                zod.null(),
              ])
              .optional(),
          })
          .describe("DoseSpot prescription diagnosis information."),
        zod.null(),
      ])
      .optional(),
    Strength: zod.union([zod.string(), zod.null()]).optional(),
    PatientMedicationId: zod.union([zod.number(), zod.null()]).optional(),
    MedicationStatus: zod
      .union([
        zod
          .enum([
            "Unknown",
            "Active",
            "Inactive",
            "Discontinued",
            "Deleted",
            "Completed",
            "CancelRequested",
            "CancelPending",
            "Cancelled",
            "CancelDenied",
            "Changed",
            "FullFill",
            "PartialFill",
            "NoFill",
          ])
          .describe("Valid medication status types for DoseSpot."),
        zod.null(),
      ])
      .optional(),
    Comment: zod.union([zod.string(), zod.null()]).optional(),
    DateInactive: zod.union([zod.string(), zod.null()]).optional(),
    Encounter: zod.union([zod.string(), zod.null()]).optional(),
    DisplayName: zod.union([zod.string(), zod.null()]).optional(),
    DispensableDrugId: zod.union([zod.number(), zod.null()]).optional(),
    Schedule: zod.union([zod.number(), zod.null()]).optional(),
    CompoundIngredients: zod
      .union([
        zod.array(
          zod
            .object({
              DispensableDrugId: zod
                .union([zod.number(), zod.null()])
                .optional(),
              FreeText: zod.union([zod.string(), zod.null()]).optional(),
              DispenseUnitId: zod.union([zod.number(), zod.null()]).optional(),
              Quantity: zod.string(),
              IsFreeTextEPCS: zod.union([zod.boolean(), zod.null()]).optional(),
            })
            .describe("DoseSpot compound ingredient information."),
        ),
        zod.null(),
      ])
      .optional(),
  })
  .describe("Complete prescription information from DoseSpot API.");

/**
 * Set one or more prescriptions as ready to sign.

This endpoint marks prescriptions as ready to sign in DoseSpot for the specified patient.

Args:
    user_id: The patient's user ID
    request: The prescriptions to set ready to sign with optional DEA overrides

Raises:
    AuthException: If the user lacks required privileges
    ValueError: If any prescription record is not found or operation fails
 * @summary Set Prescriptions Ready To Sign
 */
export const setPrescriptionsReadyToSignParams = zod.object({
  user_id: zod.uuid(),
});

export const setPrescriptionsReadyToSignBody = zod.object({
  dosespotPrescriptionIds: zod.array(zod.string()),
  deaOverrides: zod
    .union([zod.record(zod.string(), zod.unknown()), zod.null()])
    .optional(),
});

export const setPrescriptionsReadyToSignResponse = zod.unknown();

/**
 * Live ``GET /api/patients/{id}/formulary`` against DoseSpot.

Lookup is scoped to one NDC under one coverage. Drives the formulary
section of the Rx wizard so the clinician can see formulary status,
copay tiers, payer-preferred alternatives, and therapeutic alternatives
*before* settling on a final draft.

Inputs are deliberately permissive so the wizard can fire as soon as a
medication is selected:

- ``dispensable_drug_id`` xor ``ndc`` — at least one must be provided.
  When only ``dispensable_drug_id`` is given, the NDC is resolved via
  ``select_medication``.
- ``pharmacy_id`` is optional. When provided, the eligibility channel
  (Retail / MailOrder / Specialty / LTC) is derived from the pharmacy's
  specialties; otherwise we default to Retail (the most common channel
  and the one the patient's primary coverage typically backs).
- ``patient_eligibility_id`` is optional. When omitted, we resolve the
  first active coverage that covers the channel — same selection logic
  the gate uses.

Returns ``formulary=None`` (rather than 4xx-ing) when DoseSpot returns
no data or the patient has no coverage for the channel; the UI shows a
"no formulary data available" message in that case.
 * @summary Get Patient Formulary For Drug
 */
export const getPatientFormularyForDrugParams = zod.object({
  user_id: zod.uuid(),
});

export const getPatientFormularyForDrugQueryParams = zod.object({
  dispensable_drug_id: zod.union([zod.number(), zod.null()]).optional(),
  ndc: zod.union([zod.string(), zod.null()]).optional(),
  pharmacy_id: zod.union([zod.number(), zod.null()]).optional(),
  patient_eligibility_id: zod.union([zod.number(), zod.null()]).optional(),
});

export const getPatientFormularyForDrugResponse = zod
  .object({
    formulary: zod
      .union([
        zod
          .object({
            FormularyStatus: zod.union([zod.string(), zod.null()]).optional(),
            Brand: zod.union([zod.boolean(), zod.null()]).optional(),
            Otc: zod.union([zod.boolean(), zod.null()]).optional(),
            Copays: zod
              .union([
                zod.array(
                  zod
                    .object({
                      IsDrugSpecific: zod
                        .union([zod.boolean(), zod.null()])
                        .optional(),
                      PharmacyType: zod
                        .union([
                          zod
                            .enum([
                              "Any",
                              "FaxPharmacy",
                              "EPCS",
                              "TwentyFourHourPharmacy",
                              "LongTermCarePharmacy",
                              "MailOrder",
                              "Retail",
                              "SpecialtyPharmacy",
                            ])
                            .describe(
                              "Valid pharmacy specialty types for DoseSpot.",
                            ),
                          zod.null(),
                        ])
                        .optional(),
                      FlatCopayAmount: zod
                        .union([zod.number(), zod.null()])
                        .optional(),
                      PercentCopayAmount: zod
                        .union([zod.number(), zod.null()])
                        .optional(),
                      FlatCopayAmountFirst: zod
                        .union([zod.boolean(), zod.null()])
                        .optional(),
                      MinimumCopayAmount: zod
                        .union([zod.number(), zod.null()])
                        .optional(),
                      MaximumCopayAmount: zod
                        .union([zod.number(), zod.null()])
                        .optional(),
                      DaysSupply: zod
                        .union([zod.number(), zod.null()])
                        .optional(),
                      CopayTier: zod
                        .union([zod.number(), zod.null()])
                        .optional(),
                      MaximumCopayTier: zod
                        .union([zod.number(), zod.null()])
                        .optional(),
                      OutOfPocketMinimum: zod
                        .union([zod.number(), zod.null()])
                        .optional(),
                      OutOfPocketMaximum: zod
                        .union([zod.number(), zod.null()])
                        .optional(),
                    })
                    .describe(
                      "Single copay tier (`PayerCopay`).\n\nPer-channel pricing rule returned on formulary responses and on the\n``RepresentitiveFormularyCoverage`` slice of each alternative. The\ngate doesn't consult any of these fields directly — they're carried\nthrough for UI display next to an ``EXCLUDED`` \/ ``PA_REQUIRED``\nbanner.",
                    ),
                ),
                zod.null(),
              ])
              .optional(),
            Alternatives: zod
              .union([
                zod.array(
                  zod
                    .object({
                      Ndc: zod.union([zod.string(), zod.null()]).optional(),
                      DisplayName: zod
                        .union([zod.string(), zod.null()])
                        .optional(),
                      RxCUI: zod.union([zod.number(), zod.null()]).optional(),
                      DispensableDrugId: zod
                        .union([zod.number(), zod.null()])
                        .optional(),
                      Brand: zod.union([zod.boolean(), zod.null()]).optional(),
                      Otc: zod.union([zod.boolean(), zod.null()]).optional(),
                      Details: zod
                        .union([
                          zod.array(
                            zod
                              .object({
                                PatientSpecificPricingCoverages: zod
                                  .union([
                                    zod.array(
                                      zod
                                        .object({
                                          Pharmacy: zod
                                            .union([
                                              zod
                                                .object({
                                                  PharmacyType: zod
                                                    .union([
                                                      zod
                                                        .enum([
                                                          "Retail",
                                                          "Mail",
                                                          "Item90DayAtRetail",
                                                          "Specialty",
                                                          "LongTermCare",
                                                        ])
                                                        .describe(
                                                          "`PrescriptionBenefitsPharmacy.PharmacyType` values.\n\nDistinct from :class:`PharmacySpecialtyTypeT` — DoseSpot uses a\ndifferent (smaller) vocabulary for the pharmacy slice returned on\nrealtime-benefits responses than for channel-level eligibility.",
                                                        ),
                                                      zod.null(),
                                                    ])
                                                    .optional(),
                                                  Identifications: zod
                                                    .union([
                                                      zod.record(
                                                        zod.string(),
                                                        zod.unknown(),
                                                      ),
                                                      zod.null(),
                                                    ])
                                                    .optional(),
                                                  PharmacistLastName: zod
                                                    .union([
                                                      zod.string(),
                                                      zod.null(),
                                                    ])
                                                    .optional(),
                                                  PharmacistFirstName: zod
                                                    .union([
                                                      zod.string(),
                                                      zod.null(),
                                                    ])
                                                    .optional(),
                                                  PharmacistMiddleName: zod
                                                    .union([
                                                      zod.string(),
                                                      zod.null(),
                                                    ])
                                                    .optional(),
                                                  PharmacistSuffix: zod
                                                    .union([
                                                      zod.string(),
                                                      zod.null(),
                                                    ])
                                                    .optional(),
                                                  PharmacistPrefix: zod
                                                    .union([
                                                      zod.string(),
                                                      zod.null(),
                                                    ])
                                                    .optional(),
                                                  Email: zod
                                                    .union([
                                                      zod.string(),
                                                      zod.null(),
                                                    ])
                                                    .optional(),
                                                  DistanceFromRequestedPharmacy:
                                                    zod
                                                      .union([
                                                        zod.number(),
                                                        zod.null(),
                                                      ])
                                                      .optional(),
                                                  PharmacyId: zod
                                                    .union([
                                                      zod.number(),
                                                      zod.null(),
                                                    ])
                                                    .optional(),
                                                  StoreName: zod
                                                    .union([
                                                      zod.string(),
                                                      zod.null(),
                                                    ])
                                                    .optional(),
                                                  Address1: zod
                                                    .union([
                                                      zod.string(),
                                                      zod.null(),
                                                    ])
                                                    .optional(),
                                                  Address2: zod
                                                    .union([
                                                      zod.string(),
                                                      zod.null(),
                                                    ])
                                                    .optional(),
                                                  City: zod
                                                    .union([
                                                      zod.string(),
                                                      zod.null(),
                                                    ])
                                                    .optional(),
                                                  State: zod
                                                    .union([
                                                      zod.string(),
                                                      zod.null(),
                                                    ])
                                                    .optional(),
                                                  ZipCode: zod
                                                    .union([
                                                      zod.string(),
                                                      zod.null(),
                                                    ])
                                                    .optional(),
                                                  PrimaryPhone: zod
                                                    .union([
                                                      zod.string(),
                                                      zod.null(),
                                                    ])
                                                    .optional(),
                                                  PrimaryPhoneType: zod
                                                    .union([
                                                      zod
                                                        .enum([
                                                          "Undefined",
                                                          "Beeper",
                                                          "Cell",
                                                          "Fax",
                                                          "Home",
                                                          "Work",
                                                          "Night",
                                                          "Primary",
                                                        ])
                                                        .describe(
                                                          "`PrescriptionBenefitsPharmacy.PrimaryPhoneType` \/ `PhoneAdditionalType\*` values.",
                                                        ),
                                                      zod.null(),
                                                    ])
                                                    .optional(),
                                                  PrimaryFax: zod
                                                    .union([
                                                      zod.string(),
                                                      zod.null(),
                                                    ])
                                                    .optional(),
                                                  PhoneAdditional1: zod
                                                    .union([
                                                      zod.string(),
                                                      zod.null(),
                                                    ])
                                                    .optional(),
                                                  PhoneAdditionalType1: zod
                                                    .union([
                                                      zod
                                                        .enum([
                                                          "Undefined",
                                                          "Beeper",
                                                          "Cell",
                                                          "Fax",
                                                          "Home",
                                                          "Work",
                                                          "Night",
                                                          "Primary",
                                                        ])
                                                        .describe(
                                                          "`PrescriptionBenefitsPharmacy.PrimaryPhoneType` \/ `PhoneAdditionalType\*` values.",
                                                        ),
                                                      zod.null(),
                                                    ])
                                                    .optional(),
                                                  PhoneAdditional2: zod
                                                    .union([
                                                      zod.string(),
                                                      zod.null(),
                                                    ])
                                                    .optional(),
                                                  PhoneAdditionalType2: zod
                                                    .union([
                                                      zod
                                                        .enum([
                                                          "Undefined",
                                                          "Beeper",
                                                          "Cell",
                                                          "Fax",
                                                          "Home",
                                                          "Work",
                                                          "Night",
                                                          "Primary",
                                                        ])
                                                        .describe(
                                                          "`PrescriptionBenefitsPharmacy.PrimaryPhoneType` \/ `PhoneAdditionalType\*` values.",
                                                        ),
                                                      zod.null(),
                                                    ])
                                                    .optional(),
                                                  PhoneAdditional3: zod
                                                    .union([
                                                      zod.string(),
                                                      zod.null(),
                                                    ])
                                                    .optional(),
                                                  PhoneAdditionalType3: zod
                                                    .union([
                                                      zod
                                                        .enum([
                                                          "Undefined",
                                                          "Beeper",
                                                          "Cell",
                                                          "Fax",
                                                          "Home",
                                                          "Work",
                                                          "Night",
                                                          "Primary",
                                                        ])
                                                        .describe(
                                                          "`PrescriptionBenefitsPharmacy.PrimaryPhoneType` \/ `PhoneAdditionalType\*` values.",
                                                        ),
                                                      zod.null(),
                                                    ])
                                                    .optional(),
                                                  PharmacySpecialties: zod
                                                    .union([
                                                      zod.array(zod.string()),
                                                      zod.null(),
                                                    ])
                                                    .optional(),
                                                  ServiceLevel: zod
                                                    .union([
                                                      zod.number(),
                                                      zod.null(),
                                                    ])
                                                    .optional(),
                                                  Latitude: zod
                                                    .union([
                                                      zod.number(),
                                                      zod.null(),
                                                    ])
                                                    .optional(),
                                                  Longitude: zod
                                                    .union([
                                                      zod.number(),
                                                      zod.null(),
                                                    ])
                                                    .optional(),
                                                  NCPDPID: zod
                                                    .union([
                                                      zod.string(),
                                                      zod.null(),
                                                    ])
                                                    .optional(),
                                                })
                                                .describe(
                                                  "`PrescriptionBenefitsPharmacy` — pharmacy slice on RTPB responses.\n\nNarrower-use than :class:`PharmacyT`; mirrors the full swagger shape\nso callers can surface dispensing-pharmacy details (name, address,\nNCPDPID) alongside pricing \/ PA signals from a\n``PatientSpecificPricingCoverage`` entry.",
                                                ),
                                              zod.null(),
                                            ])
                                            .optional(),
                                          PricingCoverage: zod
                                            .union([
                                              zod
                                                .object({
                                                  DrugStatusCode: zod
                                                    .union([
                                                      zod.string(),
                                                      zod.null(),
                                                    ])
                                                    .optional(),
                                                  DrugStatus: zod
                                                    .union([
                                                      zod.string(),
                                                      zod.null(),
                                                    ])
                                                    .optional(),
                                                  QuantityPricedValue: zod
                                                    .union([
                                                      zod.string(),
                                                      zod.null(),
                                                    ])
                                                    .optional(),
                                                  QuantityPricedCodeListQualifier:
                                                    zod
                                                      .union([
                                                        zod
                                                          .enum([
                                                            "Item38",
                                                            "Item40",
                                                            "Item87",
                                                            "QS",
                                                            "CF",
                                                            "UQ",
                                                          ])
                                                          .describe(
                                                            "`PricingCoverageFactors.QuantityPricedCodeListQualifier` values.",
                                                          ),
                                                        zod.null(),
                                                      ])
                                                      .optional(),
                                                  QuantityPricedUnitOfMeasureType:
                                                    zod
                                                      .union([
                                                        zod.string(),
                                                        zod.null(),
                                                      ])
                                                      .optional(),
                                                  QuantityPricedUnitOfMeasureTypeId:
                                                    zod
                                                      .union([
                                                        zod.number(),
                                                        zod.null(),
                                                      ])
                                                      .optional(),
                                                  DaysSupplyPriced: zod
                                                    .union([
                                                      zod.string(),
                                                      zod.null(),
                                                    ])
                                                    .optional(),
                                                  PlanPayAmount: zod
                                                    .union([
                                                      zod.string(),
                                                      zod.null(),
                                                    ])
                                                    .optional(),
                                                  EstimatedPatientPayAmount: zod
                                                    .union([
                                                      zod.string(),
                                                      zod.null(),
                                                    ])
                                                    .optional(),
                                                  OOPAppliedAmount: zod
                                                    .union([
                                                      zod.string(),
                                                      zod.null(),
                                                    ])
                                                    .optional(),
                                                  OOPRemainingAmount: zod
                                                    .union([
                                                      zod.string(),
                                                      zod.null(),
                                                    ])
                                                    .optional(),
                                                  DeductibleAppliedAmount: zod
                                                    .union([
                                                      zod.string(),
                                                      zod.null(),
                                                    ])
                                                    .optional(),
                                                  DeductibleRemainingAmount: zod
                                                    .union([
                                                      zod.string(),
                                                      zod.null(),
                                                    ])
                                                    .optional(),
                                                  CoverageAlerts: zod
                                                    .union([
                                                      zod.array(
                                                        zod
                                                          .object({
                                                            ReferenceCode: zod
                                                              .union([
                                                                zod
                                                                  .enum([
                                                                    "AgeLimits",
                                                                    "DaysSupplyExceeded",
                                                                    "DrugExclusion",
                                                                    "ExcessiveUtilization",
                                                                    "FullCostNotCovered",
                                                                    "GenderLimits",
                                                                    "MandatoryGeneric",
                                                                    "MedicalNecessity",
                                                                    "NotOnFormulary",
                                                                    "PharmacyOutOfNetwork",
                                                                    "PlanLimitExclusion",
                                                                    "QuantityLimits",
                                                                    "QuantityLimitExceeded",
                                                                    "QuantityNotValid",
                                                                    "ResourceLink",
                                                                    "StepTherapy",
                                                                    "TextMessage",
                                                                  ])
                                                                  .describe(
                                                                    "`PricingCoverageFactorsCoverageAlerts.ReferenceCode` values.",
                                                                  ),
                                                                zod.null(),
                                                              ])
                                                              .optional(),
                                                            ReferenceText: zod
                                                              .union([
                                                                zod.string(),
                                                                zod.null(),
                                                              ])
                                                              .optional(),
                                                          })
                                                          .describe(
                                                            "`PricingCoverageFactorsCoverageAlerts` entry on :class:`PricingCoverageFactorsT`.\n\nDoseSpot returns coverage-alert \*objects\* here (not plain strings):\na ``ReferenceCode`` enum plus a human-readable ``ReferenceText``.",
                                                          ),
                                                      ),
                                                      zod.null(),
                                                    ])
                                                    .optional(),
                                                  FormularyStatus: zod
                                                    .union([
                                                      zod.string(),
                                                      zod.null(),
                                                    ])
                                                    .optional(),
                                                  PriorAuthRequired: zod
                                                    .union([
                                                      zod.boolean(),
                                                      zod.null(),
                                                    ])
                                                    .optional(),
                                                })
                                                .describe(
                                                  "`PricingCoverageFactors` — `PricingCoverage` sub-object on RTPB.\n\nThe realtime gate's authoritative PA source: ``PriorAuthRequired=true``\non any pharmacy-specific pricing coverage flips the gate to\n:attr:`PA_REQUIRED`. Pricing fields are kept for downstream UI — they\nare not consulted by the gate but are cheap to carry.",
                                                ),
                                              zod.null(),
                                            ])
                                            .optional(),
                                        })
                                        .describe(
                                          "`PatientSpecificPricingCoverage` — one (pharmacy × coverage) pricing row.\n\nA coverage can yield multiple entries — one per pharmacy the payer\npriced against — so the gate has to OR the ``PriorAuthRequired`` bits\nacross the list to get a conservative answer.",
                                        ),
                                    ),
                                    zod.null(),
                                  ])
                                  .optional(),
                                Ndc: zod
                                  .union([zod.string(), zod.null()])
                                  .optional(),
                                DisplayName: zod
                                  .union([zod.string(), zod.null()])
                                  .optional(),
                                RxCUI: zod
                                  .union([zod.number(), zod.null()])
                                  .optional(),
                                DispensableDrugId: zod
                                  .union([zod.number(), zod.null()])
                                  .optional(),
                                Coverage: zod
                                  .union([
                                    zod
                                      .object({
                                        FormularyStatus: zod
                                          .union([zod.string(), zod.null()])
                                          .optional(),
                                        Copays: zod
                                          .union([
                                            zod.array(
                                              zod
                                                .object({
                                                  IsDrugSpecific: zod
                                                    .union([
                                                      zod.boolean(),
                                                      zod.null(),
                                                    ])
                                                    .optional(),
                                                  PharmacyType: zod
                                                    .union([
                                                      zod
                                                        .enum([
                                                          "Any",
                                                          "FaxPharmacy",
                                                          "EPCS",
                                                          "TwentyFourHourPharmacy",
                                                          "LongTermCarePharmacy",
                                                          "MailOrder",
                                                          "Retail",
                                                          "SpecialtyPharmacy",
                                                        ])
                                                        .describe(
                                                          "Valid pharmacy specialty types for DoseSpot.",
                                                        ),
                                                      zod.null(),
                                                    ])
                                                    .optional(),
                                                  FlatCopayAmount: zod
                                                    .union([
                                                      zod.number(),
                                                      zod.null(),
                                                    ])
                                                    .optional(),
                                                  PercentCopayAmount: zod
                                                    .union([
                                                      zod.number(),
                                                      zod.null(),
                                                    ])
                                                    .optional(),
                                                  FlatCopayAmountFirst: zod
                                                    .union([
                                                      zod.boolean(),
                                                      zod.null(),
                                                    ])
                                                    .optional(),
                                                  MinimumCopayAmount: zod
                                                    .union([
                                                      zod.number(),
                                                      zod.null(),
                                                    ])
                                                    .optional(),
                                                  MaximumCopayAmount: zod
                                                    .union([
                                                      zod.number(),
                                                      zod.null(),
                                                    ])
                                                    .optional(),
                                                  DaysSupply: zod
                                                    .union([
                                                      zod.number(),
                                                      zod.null(),
                                                    ])
                                                    .optional(),
                                                  CopayTier: zod
                                                    .union([
                                                      zod.number(),
                                                      zod.null(),
                                                    ])
                                                    .optional(),
                                                  MaximumCopayTier: zod
                                                    .union([
                                                      zod.number(),
                                                      zod.null(),
                                                    ])
                                                    .optional(),
                                                  OutOfPocketMinimum: zod
                                                    .union([
                                                      zod.number(),
                                                      zod.null(),
                                                    ])
                                                    .optional(),
                                                  OutOfPocketMaximum: zod
                                                    .union([
                                                      zod.number(),
                                                      zod.null(),
                                                    ])
                                                    .optional(),
                                                })
                                                .describe(
                                                  "Single copay tier (`PayerCopay`).\n\nPer-channel pricing rule returned on formulary responses and on the\n``RepresentitiveFormularyCoverage`` slice of each alternative. The\ngate doesn't consult any of these fields directly — they're carried\nthrough for UI display next to an ``EXCLUDED`` \/ ``PA_REQUIRED``\nbanner.",
                                                ),
                                            ),
                                            zod.null(),
                                          ])
                                          .optional(),
                                        Alternatives: zod
                                          .union([
                                            zod.array(
                                              zod
                                                .object({
                                                  Ndc: zod
                                                    .union([
                                                      zod.string(),
                                                      zod.null(),
                                                    ])
                                                    .optional(),
                                                  Details: zod
                                                    .union([
                                                      zod.array(
                                                        zod
                                                          .object({
                                                            Ndc: zod
                                                              .union([
                                                                zod.string(),
                                                                zod.null(),
                                                              ])
                                                              .optional(),
                                                            Coverage: zod
                                                              .union([
                                                                zod.unknown(),
                                                                zod.null(),
                                                              ])
                                                              .optional(),
                                                          })
                                                          .describe(
                                                            "`PayerAlternativeDetail` — one detail under :class:`PayerAlternativeSimpleT`.",
                                                          ),
                                                      ),
                                                      zod.null(),
                                                    ])
                                                    .optional(),
                                                })
                                                .describe(
                                                  "`PayerAlternative` — the narrower alternative shape nested in :class:`MedicationCoverageT`.\n\nPer v2 swagger, nested alternatives (alternatives of alternatives) only\ncarry ``Ndc`` and a ``Details`` list, not the full\n:class:`PayerAlternativeT` payload.",
                                                ),
                                            ),
                                            zod.null(),
                                          ])
                                          .optional(),
                                        Restrictions: zod
                                          .union([
                                            zod
                                              .object({
                                                IsExcluded: zod
                                                  .union([
                                                    zod.boolean(),
                                                    zod.null(),
                                                  ])
                                                  .optional(),
                                                HasMedicalNecessity: zod
                                                  .union([
                                                    zod.boolean(),
                                                    zod.null(),
                                                  ])
                                                  .optional(),
                                                HasPriorAuthorization: zod
                                                  .union([
                                                    zod.boolean(),
                                                    zod.null(),
                                                  ])
                                                  .optional(),
                                                HasStepTherapy: zod
                                                  .union([
                                                    zod.boolean(),
                                                    zod.null(),
                                                  ])
                                                  .optional(),
                                                HasQuantityLimit: zod
                                                  .union([
                                                    zod.boolean(),
                                                    zod.null(),
                                                  ])
                                                  .optional(),
                                                HasAgeLimit: zod
                                                  .union([
                                                    zod.boolean(),
                                                    zod.null(),
                                                  ])
                                                  .optional(),
                                                AgeLimitRestrictions: zod
                                                  .union([
                                                    zod.array(
                                                      zod
                                                        .object({
                                                          MinimumAge: zod
                                                            .union([
                                                              zod.number(),
                                                              zod.null(),
                                                            ])
                                                            .optional(),
                                                          MinimumAgeUnit: zod
                                                            .union([
                                                              zod
                                                                .enum([
                                                                  "Days",
                                                                  "Years",
                                                                ])
                                                                .describe(
                                                                  "Unit on :class:`AgeLimitRestrictionT` bounds.",
                                                                ),
                                                              zod.null(),
                                                            ])
                                                            .optional(),
                                                          MaximumAge: zod
                                                            .union([
                                                              zod.number(),
                                                              zod.null(),
                                                            ])
                                                            .optional(),
                                                          MaximumAgeUnit: zod
                                                            .union([
                                                              zod
                                                                .enum([
                                                                  "Days",
                                                                  "Years",
                                                                ])
                                                                .describe(
                                                                  "Unit on :class:`AgeLimitRestrictionT` bounds.",
                                                                ),
                                                              zod.null(),
                                                            ])
                                                            .optional(),
                                                        })
                                                        .describe(
                                                          "`AgeLimitRestriction` entry on a `CoverageRestrictions`.",
                                                        ),
                                                    ),
                                                    zod.null(),
                                                  ])
                                                  .optional(),
                                                GenderRestriction: zod
                                                  .union([
                                                    zod
                                                      .enum([
                                                        "Male",
                                                        "Female",
                                                        "Unknown",
                                                      ])
                                                      .describe(
                                                        "`PayerDemographics.Gender` and `CoverageRestrictions.GenderRestriction` values.",
                                                      ),
                                                    zod.null(),
                                                  ])
                                                  .optional(),
                                                QuantityLimitRestrictions: zod
                                                  .union([
                                                    zod.array(
                                                      zod
                                                        .object({
                                                          MaximumAmount: zod
                                                            .union([
                                                              zod.number(),
                                                              zod.null(),
                                                            ])
                                                            .optional(),
                                                          AmountUnit: zod
                                                            .union([
                                                              zod
                                                                .enum([
                                                                  "DollarAmount",
                                                                  "DaysSupply",
                                                                  "Fills",
                                                                  "Quantity",
                                                                ])
                                                                .describe(
                                                                  "`QuantityLimitRestriction.AmountUnit` values.",
                                                                ),
                                                              zod.null(),
                                                            ])
                                                            .optional(),
                                                          TimePeriodUnit: zod
                                                            .union([
                                                              zod
                                                                .enum([
                                                                  "Days",
                                                                  "Lifetime",
                                                                  "PerDispensing",
                                                                  "SpecificDateRange",
                                                                  "CalendarYear",
                                                                  "CalendarQuarter",
                                                                  "CalendarMonth",
                                                                ])
                                                                .describe(
                                                                  "`QuantityLimitRestriction.TimePeriodUnit` values.",
                                                                ),
                                                              zod.null(),
                                                            ])
                                                            .optional(),
                                                          StartDate: zod
                                                            .union([
                                                              zod.string(),
                                                              zod.null(),
                                                            ])
                                                            .optional(),
                                                          EndDate: zod
                                                            .union([
                                                              zod.string(),
                                                              zod.null(),
                                                            ])
                                                            .optional(),
                                                          MaximumTimePeriodUnits:
                                                            zod
                                                              .union([
                                                                zod.number(),
                                                                zod.null(),
                                                              ])
                                                              .optional(),
                                                        })
                                                        .describe(
                                                          "`QuantityLimitRestriction` entry on a `CoverageRestrictions`.",
                                                        ),
                                                    ),
                                                    zod.null(),
                                                  ])
                                                  .optional(),
                                                StepMedicationRestrictions: zod
                                                  .union([
                                                    zod.array(
                                                      zod
                                                        .object({
                                                          Ndc: zod
                                                            .union([
                                                              zod.string(),
                                                              zod.null(),
                                                            ])
                                                            .optional(),
                                                          StepDrugType: zod
                                                            .union([
                                                              zod
                                                                .enum([
                                                                  "Unknown",
                                                                  "SpecificMedication",
                                                                  "PharmacologicalClass",
                                                                ])
                                                                .describe(
                                                                  "`StepMedicationRestriction.StepDrugType` values.",
                                                                ),
                                                              zod.null(),
                                                            ])
                                                            .optional(),
                                                          StepOrder: zod
                                                            .union([
                                                              zod.number(),
                                                              zod.null(),
                                                            ])
                                                            .optional(),
                                                          DisplayName: zod
                                                            .union([
                                                              zod.string(),
                                                              zod.null(),
                                                            ])
                                                            .optional(),
                                                          RxCUI: zod
                                                            .union([
                                                              zod.number(),
                                                              zod.null(),
                                                            ])
                                                            .optional(),
                                                          DispensableDrugId: zod
                                                            .union([
                                                              zod.number(),
                                                              zod.null(),
                                                            ])
                                                            .optional(),
                                                        })
                                                        .describe(
                                                          "`StepMedicationRestriction` entry on a `CoverageRestrictions`.",
                                                        ),
                                                    ),
                                                    zod.null(),
                                                  ])
                                                  .optional(),
                                                Messages: zod
                                                  .union([
                                                    zod.array(
                                                      zod
                                                        .object({
                                                          Message: zod
                                                            .union([
                                                              zod.string(),
                                                              zod.null(),
                                                            ])
                                                            .optional(),
                                                          LongMessage: zod
                                                            .union([
                                                              zod.string(),
                                                              zod.null(),
                                                            ])
                                                            .optional(),
                                                        })
                                                        .describe(
                                                          "`CoverageMessage` entry on a `CoverageRestrictions`.",
                                                        ),
                                                    ),
                                                    zod.null(),
                                                  ])
                                                  .optional(),
                                                DrugResources: zod
                                                  .union([
                                                    zod.array(
                                                      zod
                                                        .object({
                                                          Url: zod
                                                            .union([
                                                              zod.string(),
                                                              zod.null(),
                                                            ])
                                                            .optional(),
                                                          ResourceType: zod
                                                            .union([
                                                              zod
                                                                .enum([
                                                                  "AgeLimits",
                                                                  "ProductCoverageExclusion",
                                                                  "GenderLimits",
                                                                  "MedicalNecessity",
                                                                  "PriorAuthorization",
                                                                  "QuantityLimits",
                                                                  "StepTherapy",
                                                                  "General",
                                                                  "Copay",
                                                                  "Formulary",
                                                                ])
                                                                .describe(
                                                                  "`CoverageResource.ResourceType` values.",
                                                                ),
                                                              zod.null(),
                                                            ])
                                                            .optional(),
                                                        })
                                                        .describe(
                                                          "`CoverageResource` entry on a `CoverageRestrictions`.",
                                                        ),
                                                    ),
                                                    zod.null(),
                                                  ])
                                                  .optional(),
                                                SummaryResources: zod
                                                  .union([
                                                    zod.array(
                                                      zod
                                                        .object({
                                                          Url: zod
                                                            .union([
                                                              zod.string(),
                                                              zod.null(),
                                                            ])
                                                            .optional(),
                                                          ResourceType: zod
                                                            .union([
                                                              zod
                                                                .enum([
                                                                  "AgeLimits",
                                                                  "ProductCoverageExclusion",
                                                                  "GenderLimits",
                                                                  "MedicalNecessity",
                                                                  "PriorAuthorization",
                                                                  "QuantityLimits",
                                                                  "StepTherapy",
                                                                  "General",
                                                                  "Copay",
                                                                  "Formulary",
                                                                ])
                                                                .describe(
                                                                  "`CoverageResource.ResourceType` values.",
                                                                ),
                                                              zod.null(),
                                                            ])
                                                            .optional(),
                                                        })
                                                        .describe(
                                                          "`CoverageResource` entry on a `CoverageRestrictions`.",
                                                        ),
                                                    ),
                                                    zod.null(),
                                                  ])
                                                  .optional(),
                                              })
                                              .describe(
                                                "Coverage restrictions on the primary drug (`CoverageRestrictions`).\n\n``HasPriorAuthorization`` is the primary bit the gate consults when\n`\/prescriptionbenefits` is unavailable. ``IsExcluded`` shortcuts to\nthe `EXCLUDED` gate outcome: no point initiating a PA for a drug the\npayer will never cover.\n\nField-name alignment with the v2 swagger: ``HasAgeLimit`` \/\n``HasQuantityLimit`` are singular here (not plural as on\n:class:`RealTimeFormularyCoverageRestrictionsT`); there is no\n``HasGenderLimit`` — use ``GenderRestriction`` for that.",
                                              ),
                                            zod.null(),
                                          ])
                                          .optional(),
                                      })
                                      .describe(
                                        "`MedicationCoverage` — coverage slice nested under `PayerAlternativeDetail`.\n\nDistinct from :class:`MedicationCoverageResponseT` (the\n``\/formulary`` response body): no ``Otc`` \/ ``Brand`` \/\n``TherapeuticAlternatives`` \/ ``RealTimeFormularyRequestStatus``\nfields here.",
                                      ),
                                    zod.null(),
                                  ])
                                  .optional(),
                              })
                              .describe(
                                "`PrescriptionBenefitPayerAlternativeDetail` — one detail under :class:`PayerAlternativeT`.\n\nEach detail describes an NDC-level variant of the alternative drug\nalong with its patient-specific pricing.",
                              ),
                          ),
                          zod.null(),
                        ])
                        .optional(),
                      RepresentativeFormularyCoverage: zod
                        .union([
                          zod
                            .object({
                              CopayFactors: zod
                                .union([
                                  zod.array(
                                    zod
                                      .object({
                                        IsDrugSpecific: zod
                                          .union([zod.boolean(), zod.null()])
                                          .optional(),
                                        PharmacyType: zod
                                          .union([
                                            zod
                                              .enum([
                                                "Any",
                                                "FaxPharmacy",
                                                "EPCS",
                                                "TwentyFourHourPharmacy",
                                                "LongTermCarePharmacy",
                                                "MailOrder",
                                                "Retail",
                                                "SpecialtyPharmacy",
                                              ])
                                              .describe(
                                                "Valid pharmacy specialty types for DoseSpot.",
                                              ),
                                            zod.null(),
                                          ])
                                          .optional(),
                                        FlatCopayAmount: zod
                                          .union([zod.number(), zod.null()])
                                          .optional(),
                                        PercentCopayAmount: zod
                                          .union([zod.number(), zod.null()])
                                          .optional(),
                                        FlatCopayAmountFirst: zod
                                          .union([zod.boolean(), zod.null()])
                                          .optional(),
                                        MinimumCopayAmount: zod
                                          .union([zod.number(), zod.null()])
                                          .optional(),
                                        MaximumCopayAmount: zod
                                          .union([zod.number(), zod.null()])
                                          .optional(),
                                        DaysSupply: zod
                                          .union([zod.number(), zod.null()])
                                          .optional(),
                                        CopayTier: zod
                                          .union([zod.number(), zod.null()])
                                          .optional(),
                                        MaximumCopayTier: zod
                                          .union([zod.number(), zod.null()])
                                          .optional(),
                                        OutOfPocketMinimum: zod
                                          .union([zod.number(), zod.null()])
                                          .optional(),
                                        OutOfPocketMaximum: zod
                                          .union([zod.number(), zod.null()])
                                          .optional(),
                                      })
                                      .describe(
                                        "Single copay tier (`PayerCopay`).\n\nPer-channel pricing rule returned on formulary responses and on the\n``RepresentitiveFormularyCoverage`` slice of each alternative. The\ngate doesn't consult any of these fields directly — they're carried\nthrough for UI display next to an ``EXCLUDED`` \/ ``PA_REQUIRED``\nbanner.",
                                      ),
                                  ),
                                  zod.null(),
                                ])
                                .optional(),
                              FormularyStatus: zod
                                .union([zod.string(), zod.null()])
                                .optional(),
                              FormularyStatusText: zod
                                .union([zod.string(), zod.null()])
                                .optional(),
                              RealTimeFormularyCoverageRestrictions: zod
                                .union([
                                  zod
                                    .object({
                                      HasCoverageRestrictions: zod
                                        .union([zod.boolean(), zod.null()])
                                        .optional(),
                                      IsExcluded: zod
                                        .union([zod.boolean(), zod.null()])
                                        .optional(),
                                      HasMedicalNecessity: zod
                                        .union([zod.boolean(), zod.null()])
                                        .optional(),
                                      HasPriorAuthorization: zod
                                        .union([zod.boolean(), zod.null()])
                                        .optional(),
                                      HasStepTherapy: zod
                                        .union([zod.boolean(), zod.null()])
                                        .optional(),
                                      AgeLimitRestrictions: zod
                                        .union([
                                          zod.array(
                                            zod
                                              .object({
                                                MinimumAge: zod
                                                  .union([
                                                    zod.number(),
                                                    zod.null(),
                                                  ])
                                                  .optional(),
                                                MinimumAgeUnit: zod
                                                  .union([
                                                    zod
                                                      .enum(["Days", "Years"])
                                                      .describe(
                                                        "Unit on :class:`AgeLimitRestrictionT` bounds.",
                                                      ),
                                                    zod.null(),
                                                  ])
                                                  .optional(),
                                                MaximumAge: zod
                                                  .union([
                                                    zod.number(),
                                                    zod.null(),
                                                  ])
                                                  .optional(),
                                                MaximumAgeUnit: zod
                                                  .union([
                                                    zod
                                                      .enum(["Days", "Years"])
                                                      .describe(
                                                        "Unit on :class:`AgeLimitRestrictionT` bounds.",
                                                      ),
                                                    zod.null(),
                                                  ])
                                                  .optional(),
                                              })
                                              .describe(
                                                "`AgeLimitRestriction` entry on a `CoverageRestrictions`.",
                                              ),
                                          ),
                                          zod.null(),
                                        ])
                                        .optional(),
                                      GenderLimitRestrictions: zod
                                        .union([
                                          zod.array(
                                            zod
                                              .object({
                                                GenderAbbreviation: zod
                                                  .union([
                                                    zod.string(),
                                                    zod.null(),
                                                  ])
                                                  .optional(),
                                                GenderDescription: zod
                                                  .union([
                                                    zod.string(),
                                                    zod.null(),
                                                  ])
                                                  .optional(),
                                              })
                                              .describe(
                                                "`GenderLimitRestriction` entry on a `RealTimeFormularyCoverageRestrictions`.",
                                              ),
                                          ),
                                          zod.null(),
                                        ])
                                        .optional(),
                                      QuantityLimitRestrictions: zod
                                        .union([
                                          zod.array(
                                            zod
                                              .object({
                                                MaximumAmount: zod
                                                  .union([
                                                    zod.number(),
                                                    zod.null(),
                                                  ])
                                                  .optional(),
                                                AmountUnit: zod
                                                  .union([
                                                    zod
                                                      .enum([
                                                        "DollarAmount",
                                                        "DaysSupply",
                                                        "Fills",
                                                        "Quantity",
                                                      ])
                                                      .describe(
                                                        "`QuantityLimitRestriction.AmountUnit` values.",
                                                      ),
                                                    zod.null(),
                                                  ])
                                                  .optional(),
                                                TimePeriodUnit: zod
                                                  .union([
                                                    zod
                                                      .enum([
                                                        "Days",
                                                        "Lifetime",
                                                        "PerDispensing",
                                                        "SpecificDateRange",
                                                        "CalendarYear",
                                                        "CalendarQuarter",
                                                        "CalendarMonth",
                                                      ])
                                                      .describe(
                                                        "`QuantityLimitRestriction.TimePeriodUnit` values.",
                                                      ),
                                                    zod.null(),
                                                  ])
                                                  .optional(),
                                                StartDate: zod
                                                  .union([
                                                    zod.string(),
                                                    zod.null(),
                                                  ])
                                                  .optional(),
                                                EndDate: zod
                                                  .union([
                                                    zod.string(),
                                                    zod.null(),
                                                  ])
                                                  .optional(),
                                                MaximumTimePeriodUnits: zod
                                                  .union([
                                                    zod.number(),
                                                    zod.null(),
                                                  ])
                                                  .optional(),
                                              })
                                              .describe(
                                                "`QuantityLimitRestriction` entry on a `CoverageRestrictions`.",
                                              ),
                                          ),
                                          zod.null(),
                                        ])
                                        .optional(),
                                      StepMedicationRestrictions: zod
                                        .union([
                                          zod.array(
                                            zod
                                              .object({
                                                Ndc: zod
                                                  .union([
                                                    zod.string(),
                                                    zod.null(),
                                                  ])
                                                  .optional(),
                                                StepDrugType: zod
                                                  .union([
                                                    zod
                                                      .enum([
                                                        "Unknown",
                                                        "SpecificMedication",
                                                        "PharmacologicalClass",
                                                      ])
                                                      .describe(
                                                        "`StepMedicationRestriction.StepDrugType` values.",
                                                      ),
                                                    zod.null(),
                                                  ])
                                                  .optional(),
                                                StepOrder: zod
                                                  .union([
                                                    zod.number(),
                                                    zod.null(),
                                                  ])
                                                  .optional(),
                                                DisplayName: zod
                                                  .union([
                                                    zod.string(),
                                                    zod.null(),
                                                  ])
                                                  .optional(),
                                                RxCUI: zod
                                                  .union([
                                                    zod.number(),
                                                    zod.null(),
                                                  ])
                                                  .optional(),
                                                DispensableDrugId: zod
                                                  .union([
                                                    zod.number(),
                                                    zod.null(),
                                                  ])
                                                  .optional(),
                                              })
                                              .describe(
                                                "`StepMedicationRestriction` entry on a `CoverageRestrictions`.",
                                              ),
                                          ),
                                          zod.null(),
                                        ])
                                        .optional(),
                                      Messages: zod
                                        .union([
                                          zod.array(
                                            zod
                                              .object({
                                                Message: zod
                                                  .union([
                                                    zod.string(),
                                                    zod.null(),
                                                  ])
                                                  .optional(),
                                                LongMessage: zod
                                                  .union([
                                                    zod.string(),
                                                    zod.null(),
                                                  ])
                                                  .optional(),
                                              })
                                              .describe(
                                                "`CoverageMessage` entry on a `CoverageRestrictions`.",
                                              ),
                                          ),
                                          zod.null(),
                                        ])
                                        .optional(),
                                      DrugResources: zod
                                        .union([
                                          zod.array(
                                            zod
                                              .object({
                                                Url: zod
                                                  .union([
                                                    zod.string(),
                                                    zod.null(),
                                                  ])
                                                  .optional(),
                                                ResourceType: zod
                                                  .union([
                                                    zod
                                                      .enum([
                                                        "AgeLimits",
                                                        "ProductCoverageExclusion",
                                                        "GenderLimits",
                                                        "MedicalNecessity",
                                                        "PriorAuthorization",
                                                        "QuantityLimits",
                                                        "StepTherapy",
                                                        "General",
                                                        "Copay",
                                                        "Formulary",
                                                      ])
                                                      .describe(
                                                        "`CoverageResource.ResourceType` values.",
                                                      ),
                                                    zod.null(),
                                                  ])
                                                  .optional(),
                                              })
                                              .describe(
                                                "`CoverageResource` entry on a `CoverageRestrictions`.",
                                              ),
                                          ),
                                          zod.null(),
                                        ])
                                        .optional(),
                                      SummaryResources: zod
                                        .union([
                                          zod.array(
                                            zod
                                              .object({
                                                Url: zod
                                                  .union([
                                                    zod.string(),
                                                    zod.null(),
                                                  ])
                                                  .optional(),
                                                ResourceType: zod
                                                  .union([
                                                    zod
                                                      .enum([
                                                        "AgeLimits",
                                                        "ProductCoverageExclusion",
                                                        "GenderLimits",
                                                        "MedicalNecessity",
                                                        "PriorAuthorization",
                                                        "QuantityLimits",
                                                        "StepTherapy",
                                                        "General",
                                                        "Copay",
                                                        "Formulary",
                                                      ])
                                                      .describe(
                                                        "`CoverageResource.ResourceType` values.",
                                                      ),
                                                    zod.null(),
                                                  ])
                                                  .optional(),
                                              })
                                              .describe(
                                                "`CoverageResource` entry on a `CoverageRestrictions`.",
                                              ),
                                          ),
                                          zod.null(),
                                        ])
                                        .optional(),
                                    })
                                    .describe(
                                      "Realtime-only restriction slice (`RealTimeFormularyCoverageRestrictions`).\n\nAppears only on :class:`RepresentitiveFormularyCoverageT` (i.e. on each\nalternative drug), \*\*not\*\* on the primary drug's ``CoverageRestrictions``.\nThat asymmetry is per the v2 swagger: the primary drug's realtime PA\nbit is conveyed by ``\/prescriptionbenefits`` (``PriorAuthRequired``)\nand its cached bit by ``CoverageRestrictions.HasPriorAuthorization``.\n\nField names match the swagger exactly — note ``HasMedicalNecessity``\n(not the legacy ``RequiresMedicalNecessity``) and ``HasAge`` \/\n``HasQuantity`` rather than the plural ``…Limits`` spellings used on\n:class:`CoverageRestrictionsT`.",
                                    ),
                                  zod.null(),
                                ])
                                .optional(),
                            })
                            .describe(
                              "`RepresentitiveFormularyCoverage` on a :class:`PayerAlternativeT`.\n\nThe typo (``Representitive`` rather than ``Representative``) is\nDoseSpot's, not ours — the field name is verbatim from the v2 swagger\ndefinition so pydantic's ``model_validate`` of a raw DoseSpot\nresponse lines up.",
                            ),
                          zod.null(),
                        ])
                        .optional(),
                      PatientSpecificPricingCoverages: zod
                        .union([
                          zod.array(
                            zod
                              .object({
                                Pharmacy: zod
                                  .union([
                                    zod
                                      .object({
                                        PharmacyType: zod
                                          .union([
                                            zod
                                              .enum([
                                                "Retail",
                                                "Mail",
                                                "Item90DayAtRetail",
                                                "Specialty",
                                                "LongTermCare",
                                              ])
                                              .describe(
                                                "`PrescriptionBenefitsPharmacy.PharmacyType` values.\n\nDistinct from :class:`PharmacySpecialtyTypeT` — DoseSpot uses a\ndifferent (smaller) vocabulary for the pharmacy slice returned on\nrealtime-benefits responses than for channel-level eligibility.",
                                              ),
                                            zod.null(),
                                          ])
                                          .optional(),
                                        Identifications: zod
                                          .union([
                                            zod.record(
                                              zod.string(),
                                              zod.unknown(),
                                            ),
                                            zod.null(),
                                          ])
                                          .optional(),
                                        PharmacistLastName: zod
                                          .union([zod.string(), zod.null()])
                                          .optional(),
                                        PharmacistFirstName: zod
                                          .union([zod.string(), zod.null()])
                                          .optional(),
                                        PharmacistMiddleName: zod
                                          .union([zod.string(), zod.null()])
                                          .optional(),
                                        PharmacistSuffix: zod
                                          .union([zod.string(), zod.null()])
                                          .optional(),
                                        PharmacistPrefix: zod
                                          .union([zod.string(), zod.null()])
                                          .optional(),
                                        Email: zod
                                          .union([zod.string(), zod.null()])
                                          .optional(),
                                        DistanceFromRequestedPharmacy: zod
                                          .union([zod.number(), zod.null()])
                                          .optional(),
                                        PharmacyId: zod
                                          .union([zod.number(), zod.null()])
                                          .optional(),
                                        StoreName: zod
                                          .union([zod.string(), zod.null()])
                                          .optional(),
                                        Address1: zod
                                          .union([zod.string(), zod.null()])
                                          .optional(),
                                        Address2: zod
                                          .union([zod.string(), zod.null()])
                                          .optional(),
                                        City: zod
                                          .union([zod.string(), zod.null()])
                                          .optional(),
                                        State: zod
                                          .union([zod.string(), zod.null()])
                                          .optional(),
                                        ZipCode: zod
                                          .union([zod.string(), zod.null()])
                                          .optional(),
                                        PrimaryPhone: zod
                                          .union([zod.string(), zod.null()])
                                          .optional(),
                                        PrimaryPhoneType: zod
                                          .union([
                                            zod
                                              .enum([
                                                "Undefined",
                                                "Beeper",
                                                "Cell",
                                                "Fax",
                                                "Home",
                                                "Work",
                                                "Night",
                                                "Primary",
                                              ])
                                              .describe(
                                                "`PrescriptionBenefitsPharmacy.PrimaryPhoneType` \/ `PhoneAdditionalType\*` values.",
                                              ),
                                            zod.null(),
                                          ])
                                          .optional(),
                                        PrimaryFax: zod
                                          .union([zod.string(), zod.null()])
                                          .optional(),
                                        PhoneAdditional1: zod
                                          .union([zod.string(), zod.null()])
                                          .optional(),
                                        PhoneAdditionalType1: zod
                                          .union([
                                            zod
                                              .enum([
                                                "Undefined",
                                                "Beeper",
                                                "Cell",
                                                "Fax",
                                                "Home",
                                                "Work",
                                                "Night",
                                                "Primary",
                                              ])
                                              .describe(
                                                "`PrescriptionBenefitsPharmacy.PrimaryPhoneType` \/ `PhoneAdditionalType\*` values.",
                                              ),
                                            zod.null(),
                                          ])
                                          .optional(),
                                        PhoneAdditional2: zod
                                          .union([zod.string(), zod.null()])
                                          .optional(),
                                        PhoneAdditionalType2: zod
                                          .union([
                                            zod
                                              .enum([
                                                "Undefined",
                                                "Beeper",
                                                "Cell",
                                                "Fax",
                                                "Home",
                                                "Work",
                                                "Night",
                                                "Primary",
                                              ])
                                              .describe(
                                                "`PrescriptionBenefitsPharmacy.PrimaryPhoneType` \/ `PhoneAdditionalType\*` values.",
                                              ),
                                            zod.null(),
                                          ])
                                          .optional(),
                                        PhoneAdditional3: zod
                                          .union([zod.string(), zod.null()])
                                          .optional(),
                                        PhoneAdditionalType3: zod
                                          .union([
                                            zod
                                              .enum([
                                                "Undefined",
                                                "Beeper",
                                                "Cell",
                                                "Fax",
                                                "Home",
                                                "Work",
                                                "Night",
                                                "Primary",
                                              ])
                                              .describe(
                                                "`PrescriptionBenefitsPharmacy.PrimaryPhoneType` \/ `PhoneAdditionalType\*` values.",
                                              ),
                                            zod.null(),
                                          ])
                                          .optional(),
                                        PharmacySpecialties: zod
                                          .union([
                                            zod.array(zod.string()),
                                            zod.null(),
                                          ])
                                          .optional(),
                                        ServiceLevel: zod
                                          .union([zod.number(), zod.null()])
                                          .optional(),
                                        Latitude: zod
                                          .union([zod.number(), zod.null()])
                                          .optional(),
                                        Longitude: zod
                                          .union([zod.number(), zod.null()])
                                          .optional(),
                                        NCPDPID: zod
                                          .union([zod.string(), zod.null()])
                                          .optional(),
                                      })
                                      .describe(
                                        "`PrescriptionBenefitsPharmacy` — pharmacy slice on RTPB responses.\n\nNarrower-use than :class:`PharmacyT`; mirrors the full swagger shape\nso callers can surface dispensing-pharmacy details (name, address,\nNCPDPID) alongside pricing \/ PA signals from a\n``PatientSpecificPricingCoverage`` entry.",
                                      ),
                                    zod.null(),
                                  ])
                                  .optional(),
                                PricingCoverage: zod
                                  .union([
                                    zod
                                      .object({
                                        DrugStatusCode: zod
                                          .union([zod.string(), zod.null()])
                                          .optional(),
                                        DrugStatus: zod
                                          .union([zod.string(), zod.null()])
                                          .optional(),
                                        QuantityPricedValue: zod
                                          .union([zod.string(), zod.null()])
                                          .optional(),
                                        QuantityPricedCodeListQualifier: zod
                                          .union([
                                            zod
                                              .enum([
                                                "Item38",
                                                "Item40",
                                                "Item87",
                                                "QS",
                                                "CF",
                                                "UQ",
                                              ])
                                              .describe(
                                                "`PricingCoverageFactors.QuantityPricedCodeListQualifier` values.",
                                              ),
                                            zod.null(),
                                          ])
                                          .optional(),
                                        QuantityPricedUnitOfMeasureType: zod
                                          .union([zod.string(), zod.null()])
                                          .optional(),
                                        QuantityPricedUnitOfMeasureTypeId: zod
                                          .union([zod.number(), zod.null()])
                                          .optional(),
                                        DaysSupplyPriced: zod
                                          .union([zod.string(), zod.null()])
                                          .optional(),
                                        PlanPayAmount: zod
                                          .union([zod.string(), zod.null()])
                                          .optional(),
                                        EstimatedPatientPayAmount: zod
                                          .union([zod.string(), zod.null()])
                                          .optional(),
                                        OOPAppliedAmount: zod
                                          .union([zod.string(), zod.null()])
                                          .optional(),
                                        OOPRemainingAmount: zod
                                          .union([zod.string(), zod.null()])
                                          .optional(),
                                        DeductibleAppliedAmount: zod
                                          .union([zod.string(), zod.null()])
                                          .optional(),
                                        DeductibleRemainingAmount: zod
                                          .union([zod.string(), zod.null()])
                                          .optional(),
                                        CoverageAlerts: zod
                                          .union([
                                            zod.array(
                                              zod
                                                .object({
                                                  ReferenceCode: zod
                                                    .union([
                                                      zod
                                                        .enum([
                                                          "AgeLimits",
                                                          "DaysSupplyExceeded",
                                                          "DrugExclusion",
                                                          "ExcessiveUtilization",
                                                          "FullCostNotCovered",
                                                          "GenderLimits",
                                                          "MandatoryGeneric",
                                                          "MedicalNecessity",
                                                          "NotOnFormulary",
                                                          "PharmacyOutOfNetwork",
                                                          "PlanLimitExclusion",
                                                          "QuantityLimits",
                                                          "QuantityLimitExceeded",
                                                          "QuantityNotValid",
                                                          "ResourceLink",
                                                          "StepTherapy",
                                                          "TextMessage",
                                                        ])
                                                        .describe(
                                                          "`PricingCoverageFactorsCoverageAlerts.ReferenceCode` values.",
                                                        ),
                                                      zod.null(),
                                                    ])
                                                    .optional(),
                                                  ReferenceText: zod
                                                    .union([
                                                      zod.string(),
                                                      zod.null(),
                                                    ])
                                                    .optional(),
                                                })
                                                .describe(
                                                  "`PricingCoverageFactorsCoverageAlerts` entry on :class:`PricingCoverageFactorsT`.\n\nDoseSpot returns coverage-alert \*objects\* here (not plain strings):\na ``ReferenceCode`` enum plus a human-readable ``ReferenceText``.",
                                                ),
                                            ),
                                            zod.null(),
                                          ])
                                          .optional(),
                                        FormularyStatus: zod
                                          .union([zod.string(), zod.null()])
                                          .optional(),
                                        PriorAuthRequired: zod
                                          .union([zod.boolean(), zod.null()])
                                          .optional(),
                                      })
                                      .describe(
                                        "`PricingCoverageFactors` — `PricingCoverage` sub-object on RTPB.\n\nThe realtime gate's authoritative PA source: ``PriorAuthRequired=true``\non any pharmacy-specific pricing coverage flips the gate to\n:attr:`PA_REQUIRED`. Pricing fields are kept for downstream UI — they\nare not consulted by the gate but are cheap to carry.",
                                      ),
                                    zod.null(),
                                  ])
                                  .optional(),
                              })
                              .describe(
                                "`PatientSpecificPricingCoverage` — one (pharmacy × coverage) pricing row.\n\nA coverage can yield multiple entries — one per pharmacy the payer\npriced against — so the gate has to OR the ``PriorAuthRequired`` bits\nacross the list to get a conservative answer.",
                              ),
                          ),
                          zod.null(),
                        ])
                        .optional(),
                    })
                    .describe(
                      "`PayerAlternativeAPI` — payer-preferred alternative for an NDC.\n\nSurfaced alongside a gate decision of :attr:`EXCLUDED` or\n:attr:`PA_REQUIRED` so the clinician can rewrite to a preferred drug\ninstead of fighting a PA. Returned both on the formulary response\n(``MedicationCoverageResponse.Alternatives``) and on the RTPB\nresponse (``GetPrescriptionBenefitResponse.Alternatives``).",
                    ),
                ),
                zod.null(),
              ])
              .optional(),
            TherapeuticAlternatives: zod
              .union([
                zod.array(
                  zod
                    .object({
                      Ndc: zod.union([zod.string(), zod.null()]).optional(),
                      FormularyStatus: zod
                        .union([zod.string(), zod.null()])
                        .optional(),
                      Copay: zod
                        .union([
                          zod
                            .object({
                              IsDrugSpecific: zod
                                .union([zod.boolean(), zod.null()])
                                .optional(),
                              PharmacyType: zod
                                .union([
                                  zod
                                    .enum([
                                      "Any",
                                      "FaxPharmacy",
                                      "EPCS",
                                      "TwentyFourHourPharmacy",
                                      "LongTermCarePharmacy",
                                      "MailOrder",
                                      "Retail",
                                      "SpecialtyPharmacy",
                                    ])
                                    .describe(
                                      "Valid pharmacy specialty types for DoseSpot.",
                                    ),
                                  zod.null(),
                                ])
                                .optional(),
                              FlatCopayAmount: zod
                                .union([zod.number(), zod.null()])
                                .optional(),
                              PercentCopayAmount: zod
                                .union([zod.number(), zod.null()])
                                .optional(),
                              FlatCopayAmountFirst: zod
                                .union([zod.boolean(), zod.null()])
                                .optional(),
                              MinimumCopayAmount: zod
                                .union([zod.number(), zod.null()])
                                .optional(),
                              MaximumCopayAmount: zod
                                .union([zod.number(), zod.null()])
                                .optional(),
                              DaysSupply: zod
                                .union([zod.number(), zod.null()])
                                .optional(),
                              CopayTier: zod
                                .union([zod.number(), zod.null()])
                                .optional(),
                              MaximumCopayTier: zod
                                .union([zod.number(), zod.null()])
                                .optional(),
                              OutOfPocketMinimum: zod
                                .union([zod.number(), zod.null()])
                                .optional(),
                              OutOfPocketMaximum: zod
                                .union([zod.number(), zod.null()])
                                .optional(),
                            })
                            .describe(
                              "Single copay tier (`PayerCopay`).\n\nPer-channel pricing rule returned on formulary responses and on the\n``RepresentitiveFormularyCoverage`` slice of each alternative. The\ngate doesn't consult any of these fields directly — they're carried\nthrough for UI display next to an ``EXCLUDED`` \/ ``PA_REQUIRED``\nbanner.",
                            ),
                          zod.null(),
                        ])
                        .optional(),
                      DisplayName: zod
                        .union([zod.string(), zod.null()])
                        .optional(),
                      FormularyInfo: zod
                        .union([
                          zod
                            .object({
                              ProductId: zod
                                .union([zod.number(), zod.null()])
                                .optional(),
                              Ndc: zod
                                .union([zod.string(), zod.null()])
                                .optional(),
                              FormularyStatusId: zod
                                .union([zod.number(), zod.null()])
                                .optional(),
                              FormularyAbbreviation: zod
                                .union([zod.string(), zod.null()])
                                .optional(),
                              FormularyStatusMessage: zod
                                .union([zod.string(), zod.null()])
                                .optional(),
                              OrderRank: zod
                                .union([zod.number(), zod.null()])
                                .optional(),
                              IsGeneric: zod
                                .union([zod.boolean(), zod.null()])
                                .optional(),
                              IsRx: zod
                                .union([zod.boolean(), zod.null()])
                                .optional(),
                            })
                            .describe(
                              "`FormularyInfo` nested on :class:`TherapeuticAlternativesT`.",
                            ),
                          zod.null(),
                        ])
                        .optional(),
                      FullDisplayString: zod
                        .union([zod.string(), zod.null()])
                        .optional(),
                      DisplayStrength: zod
                        .union([zod.string(), zod.null()])
                        .optional(),
                      DefaultDispenseUnitID: zod
                        .union([zod.number(), zod.null()])
                        .optional(),
                      DispensableDrugId: zod
                        .union([zod.number(), zod.null()])
                        .optional(),
                      Schedule: zod
                        .union([zod.number(), zod.null()])
                        .optional(),
                      IsDetox: zod
                        .union([zod.boolean(), zod.null()])
                        .optional(),
                      HasGHB: zod.union([zod.boolean(), zod.null()]).optional(),
                      RxCUI: zod.union([zod.number(), zod.null()]).optional(),
                    })
                    .describe(
                      "`TherapeuticAlternatives` entry on a formulary response.\n\nV2 replaces the v1 ``\/therapeuticAlternatives`` endpoint with a\n``TherapeuticAlternatives`` list returned inline on the formulary\nresponse. Surfaced alongside :attr:`EXCLUDED` \/ :attr:`PA_REQUIRED`\noutcomes so the clinician can rewrite to a preferred drug without a\nsecond round trip.",
                    ),
                ),
                zod.null(),
              ])
              .optional(),
            Restrictions: zod
              .union([
                zod
                  .object({
                    IsExcluded: zod
                      .union([zod.boolean(), zod.null()])
                      .optional(),
                    HasMedicalNecessity: zod
                      .union([zod.boolean(), zod.null()])
                      .optional(),
                    HasPriorAuthorization: zod
                      .union([zod.boolean(), zod.null()])
                      .optional(),
                    HasStepTherapy: zod
                      .union([zod.boolean(), zod.null()])
                      .optional(),
                    HasQuantityLimit: zod
                      .union([zod.boolean(), zod.null()])
                      .optional(),
                    HasAgeLimit: zod
                      .union([zod.boolean(), zod.null()])
                      .optional(),
                    AgeLimitRestrictions: zod
                      .union([
                        zod.array(
                          zod
                            .object({
                              MinimumAge: zod
                                .union([zod.number(), zod.null()])
                                .optional(),
                              MinimumAgeUnit: zod
                                .union([
                                  zod
                                    .enum(["Days", "Years"])
                                    .describe(
                                      "Unit on :class:`AgeLimitRestrictionT` bounds.",
                                    ),
                                  zod.null(),
                                ])
                                .optional(),
                              MaximumAge: zod
                                .union([zod.number(), zod.null()])
                                .optional(),
                              MaximumAgeUnit: zod
                                .union([
                                  zod
                                    .enum(["Days", "Years"])
                                    .describe(
                                      "Unit on :class:`AgeLimitRestrictionT` bounds.",
                                    ),
                                  zod.null(),
                                ])
                                .optional(),
                            })
                            .describe(
                              "`AgeLimitRestriction` entry on a `CoverageRestrictions`.",
                            ),
                        ),
                        zod.null(),
                      ])
                      .optional(),
                    GenderRestriction: zod
                      .union([
                        zod
                          .enum(["Male", "Female", "Unknown"])
                          .describe(
                            "`PayerDemographics.Gender` and `CoverageRestrictions.GenderRestriction` values.",
                          ),
                        zod.null(),
                      ])
                      .optional(),
                    QuantityLimitRestrictions: zod
                      .union([
                        zod.array(
                          zod
                            .object({
                              MaximumAmount: zod
                                .union([zod.number(), zod.null()])
                                .optional(),
                              AmountUnit: zod
                                .union([
                                  zod
                                    .enum([
                                      "DollarAmount",
                                      "DaysSupply",
                                      "Fills",
                                      "Quantity",
                                    ])
                                    .describe(
                                      "`QuantityLimitRestriction.AmountUnit` values.",
                                    ),
                                  zod.null(),
                                ])
                                .optional(),
                              TimePeriodUnit: zod
                                .union([
                                  zod
                                    .enum([
                                      "Days",
                                      "Lifetime",
                                      "PerDispensing",
                                      "SpecificDateRange",
                                      "CalendarYear",
                                      "CalendarQuarter",
                                      "CalendarMonth",
                                    ])
                                    .describe(
                                      "`QuantityLimitRestriction.TimePeriodUnit` values.",
                                    ),
                                  zod.null(),
                                ])
                                .optional(),
                              StartDate: zod
                                .union([zod.string(), zod.null()])
                                .optional(),
                              EndDate: zod
                                .union([zod.string(), zod.null()])
                                .optional(),
                              MaximumTimePeriodUnits: zod
                                .union([zod.number(), zod.null()])
                                .optional(),
                            })
                            .describe(
                              "`QuantityLimitRestriction` entry on a `CoverageRestrictions`.",
                            ),
                        ),
                        zod.null(),
                      ])
                      .optional(),
                    StepMedicationRestrictions: zod
                      .union([
                        zod.array(
                          zod
                            .object({
                              Ndc: zod
                                .union([zod.string(), zod.null()])
                                .optional(),
                              StepDrugType: zod
                                .union([
                                  zod
                                    .enum([
                                      "Unknown",
                                      "SpecificMedication",
                                      "PharmacologicalClass",
                                    ])
                                    .describe(
                                      "`StepMedicationRestriction.StepDrugType` values.",
                                    ),
                                  zod.null(),
                                ])
                                .optional(),
                              StepOrder: zod
                                .union([zod.number(), zod.null()])
                                .optional(),
                              DisplayName: zod
                                .union([zod.string(), zod.null()])
                                .optional(),
                              RxCUI: zod
                                .union([zod.number(), zod.null()])
                                .optional(),
                              DispensableDrugId: zod
                                .union([zod.number(), zod.null()])
                                .optional(),
                            })
                            .describe(
                              "`StepMedicationRestriction` entry on a `CoverageRestrictions`.",
                            ),
                        ),
                        zod.null(),
                      ])
                      .optional(),
                    Messages: zod
                      .union([
                        zod.array(
                          zod
                            .object({
                              Message: zod
                                .union([zod.string(), zod.null()])
                                .optional(),
                              LongMessage: zod
                                .union([zod.string(), zod.null()])
                                .optional(),
                            })
                            .describe(
                              "`CoverageMessage` entry on a `CoverageRestrictions`.",
                            ),
                        ),
                        zod.null(),
                      ])
                      .optional(),
                    DrugResources: zod
                      .union([
                        zod.array(
                          zod
                            .object({
                              Url: zod
                                .union([zod.string(), zod.null()])
                                .optional(),
                              ResourceType: zod
                                .union([
                                  zod
                                    .enum([
                                      "AgeLimits",
                                      "ProductCoverageExclusion",
                                      "GenderLimits",
                                      "MedicalNecessity",
                                      "PriorAuthorization",
                                      "QuantityLimits",
                                      "StepTherapy",
                                      "General",
                                      "Copay",
                                      "Formulary",
                                    ])
                                    .describe(
                                      "`CoverageResource.ResourceType` values.",
                                    ),
                                  zod.null(),
                                ])
                                .optional(),
                            })
                            .describe(
                              "`CoverageResource` entry on a `CoverageRestrictions`.",
                            ),
                        ),
                        zod.null(),
                      ])
                      .optional(),
                    SummaryResources: zod
                      .union([
                        zod.array(
                          zod
                            .object({
                              Url: zod
                                .union([zod.string(), zod.null()])
                                .optional(),
                              ResourceType: zod
                                .union([
                                  zod
                                    .enum([
                                      "AgeLimits",
                                      "ProductCoverageExclusion",
                                      "GenderLimits",
                                      "MedicalNecessity",
                                      "PriorAuthorization",
                                      "QuantityLimits",
                                      "StepTherapy",
                                      "General",
                                      "Copay",
                                      "Formulary",
                                    ])
                                    .describe(
                                      "`CoverageResource.ResourceType` values.",
                                    ),
                                  zod.null(),
                                ])
                                .optional(),
                            })
                            .describe(
                              "`CoverageResource` entry on a `CoverageRestrictions`.",
                            ),
                        ),
                        zod.null(),
                      ])
                      .optional(),
                  })
                  .describe(
                    "Coverage restrictions on the primary drug (`CoverageRestrictions`).\n\n``HasPriorAuthorization`` is the primary bit the gate consults when\n`\/prescriptionbenefits` is unavailable. ``IsExcluded`` shortcuts to\nthe `EXCLUDED` gate outcome: no point initiating a PA for a drug the\npayer will never cover.\n\nField-name alignment with the v2 swagger: ``HasAgeLimit`` \/\n``HasQuantityLimit`` are singular here (not plural as on\n:class:`RealTimeFormularyCoverageRestrictionsT`); there is no\n``HasGenderLimit`` — use ``GenderRestriction`` for that.",
                  ),
                zod.null(),
              ])
              .optional(),
            RealTimeFormularyRequestStatus: zod
              .union([zod.number(), zod.null()])
              .optional(),
          })
          .describe(
            "`MedicationCoverageResponse` — inner item of ``ItemResponse[…]`` on\n``GET \/api\/patients\/{patient_id}\/formulary``.\n\nRetained under the historical ``FormularyResponseT`` name so in-repo\ncallers don't need to rename types; the shape is now the v2 swagger's\nunwrapped `Item` (see :class:`FormularyItemResponseT` for the wire-\nlevel wrapper).\n\nKey fields for the gate:\n\n- ``Restrictions.HasPriorAuthorization`` — cached-formulary PA bit.\n- ``Restrictions.IsExcluded`` — drug is flatly not covered; maps to\n  the :attr:`EXCLUDED` gate outcome.\n- ``RealTimeFormularyRequestStatus`` — non-OK here means \"realtime\n  call didn't land\"; the gate falls back to the cached slice before\n  declaring :attr:`UNKNOWN`.\n\nNotably absent: ``PatientEligibilityId`` \/ ``NDC`` \/ ``DrugName``.\nV2's `MedicationCoverageResponse` does not echo the request context\nback; the gate tracks that out-of-band.",
          ),
        zod.null(),
      ])
      .optional(),
    payerInformation: zod
      .union([
        zod
          .object({
            PatientEligibilityId: zod
              .union([zod.number(), zod.null()])
              .optional(),
            PayerName: zod.union([zod.string(), zod.null()]).optional(),
            PharmacyEligibilities: zod
              .union([
                zod.array(
                  zod
                    .object({
                      PharmacyType: zod
                        .union([
                          zod
                            .enum([
                              "Any",
                              "FaxPharmacy",
                              "EPCS",
                              "TwentyFourHourPharmacy",
                              "LongTermCarePharmacy",
                              "MailOrder",
                              "Retail",
                              "SpecialtyPharmacy",
                            ])
                            .describe(
                              "Valid pharmacy specialty types for DoseSpot.",
                            ),
                          zod.null(),
                        ])
                        .optional(),
                      EligibilityStatus: zod
                        .union([
                          zod
                            .enum([
                              "Covered",
                              "NotCovered",
                              "OutOfPocket",
                              "Unknown",
                              "UnableToProcess",
                            ])
                            .describe(
                              "`EligibilityStatus` on a `PharmacyEligibility` entry.",
                            ),
                          zod.null(),
                        ])
                        .optional(),
                      Name: zod.union([zod.string(), zod.null()]).optional(),
                    })
                    .describe(
                      "Per-channel eligibility entry on a `PayerInformationResponse`.\n\nEach coverage reports one of these per pharmacy type so the Rx-time\ngate can pick the coverage that actually covers the channel the\nprescription is routed to (e.g. Retail vs MailOrder).",
                    ),
                ),
                zod.null(),
              ])
              .optional(),
            PlanName: zod.union([zod.string(), zod.null()]).optional(),
            CoverageId: zod.union([zod.string(), zod.null()]).optional(),
            PayerId: zod.union([zod.string(), zod.null()]).optional(),
            BIN: zod.union([zod.string(), zod.null()]).optional(),
            PCN: zod.union([zod.string(), zod.null()]).optional(),
            FormularyId: zod.union([zod.string(), zod.null()]).optional(),
            AlternativesId: zod.union([zod.string(), zod.null()]).optional(),
            CopayId: zod.union([zod.string(), zod.null()]).optional(),
            DemographicChanges: zod
              .union([zod.boolean(), zod.null()])
              .optional(),
            Demographics: zod
              .union([
                zod
                  .object({
                    LastName: zod.union([zod.string(), zod.null()]).optional(),
                    FirstName: zod.union([zod.string(), zod.null()]).optional(),
                    MiddleName: zod
                      .union([zod.string(), zod.null()])
                      .optional(),
                    Suffix: zod.union([zod.string(), zod.null()]).optional(),
                    DateOfBirth: zod
                      .union([zod.string(), zod.null()])
                      .optional(),
                    Gender: zod
                      .union([
                        zod
                          .enum(["Male", "Female", "Unknown"])
                          .describe(
                            "`PayerDemographics.Gender` and `CoverageRestrictions.GenderRestriction` values.",
                          ),
                        zod.null(),
                      ])
                      .optional(),
                    Address: zod
                      .union([
                        zod
                          .object({
                            AddressLine1: zod
                              .union([zod.string(), zod.null()])
                              .optional(),
                            AddressLine2: zod
                              .union([zod.string(), zod.null()])
                              .optional(),
                            City: zod
                              .union([zod.string(), zod.null()])
                              .optional(),
                            State: zod
                              .union([zod.string(), zod.null()])
                              .optional(),
                            ZipCode: zod
                              .union([zod.string(), zod.null()])
                              .optional(),
                          })
                          .describe(
                            "`PayerAddress` sub-object on :class:`PayerDemographicsT`.",
                          ),
                        zod.null(),
                      ])
                      .optional(),
                  })
                  .describe(
                    "`PayerDemographics` block on :class:`PayerInformationT`.\n\nSurfaced when the payer returns updated member demographics on an\neligibility response (combined with ``DemographicChanges=true``).",
                  ),
                zod.null(),
              ])
              .optional(),
            ErrorMessage: zod.union([zod.string(), zod.null()]).optional(),
            InfoMessage: zod.union([zod.string(), zod.null()]).optional(),
            MemberId: zod.union([zod.string(), zod.null()]).optional(),
          })
          .describe(
            "One active coverage for a patient (`PayerInformationResponse`).\n\nReturned by `GET \/api\/patients\/{patient_id}\/eligibilities`. The gate\nkeys subsequent `\/formulary` and `\/prescriptionbenefits` calls on\n``PatientEligibilityId``; the other ids (`CoverageId`, `FormularyId`,\n...) are carried through for audit but not otherwise consulted.\n\nFields match the DoseSpot v2 swagger `PayerInformationResponse`\ndefinition exactly. No `GroupId` here — that's a legacy field from\nthe v1 shape and was dropped when v2 consolidated onto `MemberId` +\n``Demographics``.",
          ),
        zod.null(),
      ])
      .optional(),
    patientEligibilityId: zod.union([zod.number(), zod.null()]).optional(),
    ndc: zod.union([zod.string(), zod.null()]).optional(),
  })
  .describe(
    "Wrapper around DoseSpot's ``\/formulary`` payload for the Rx form.\n\nSurfaces the medication-coverage slice (formulary status, drug-specific\ncopay tiers, payer alternatives, therapeutic alternatives, restrictions)\nthat the clinician needs \*before\* finalising quantity \/ pharmacy in the\nRx wizard. Distinct from :class:`PreviewPriorAuthResponseT`: that one\ndrives the post-sign PA gate preview (and therefore needs every\nper-fill input); this one is the lightweight \"what does the patient's\nplan say about this drug?\" lookup that fires the moment a medication\nis selected.\n\n``payer_information`` carries the resolved coverage's BenefitsCoordination\ndetails (PayerName, PayerId, BIN, PCN, MemberId, FormularyId, ...) so\nthe caller can show which plan answered.",
  );

/**
 * Predict the post-sign prior-auth gate outcome for an in-flight Rx draft.

Shares its full decision path with
:mod:`lotushealth.dosespot.prescription_pa_gate` — the same NDC
resolution, pharmacy-channel mapping, coverage lookup, and
realtime-benefits / formulary classifier that run after
``set_prescriptions_ready_to_sign`` runs here too. That shared path
is why a pre-sign preview matches the post-sign decision
deterministically: there is no second "likely PA?" classifier to
keep in sync.

Missing or unresolved inputs collapse to ``UNKNOWN`` /
``NO_COVERAGE`` rather than 4xx'ing, so the client can safely poll
this endpoint as the wizard fills and only render an indicator once
the outcome firms up.
 * @summary Preview Prior Auth For Rx Draft
 */
export const previewPriorAuthForRxDraftParams = zod.object({
  user_id: zod.uuid(),
});

export const previewPriorAuthForRxDraftBody = zod
  .object({
    dispensableDrugId: zod.union([zod.number(), zod.null()]).optional(),
    pharmacyId: zod.union([zod.number(), zod.null()]).optional(),
    quantity: zod.union([zod.number(), zod.null()]).optional(),
    daysSupply: zod.union([zod.number(), zod.null()]).optional(),
    dispenseUnitTypeId: zod.union([zod.number(), zod.null()]).optional(),
    patientEligibilityId: zod.union([zod.number(), zod.null()]).optional(),
  })
  .describe(
    "Rx-form inputs needed to preview the post-sign PA gate outcome.\n\nThese are the same inputs the gate reads off a\n``DosespotPrescriptionRecord.cached_info`` after sign — see\n:func:`lotushealth.dosespot.prescription_pa_gate.evaluate_inputs`.\nAll fields are optional so the client can call this endpoint as the\nclinician fills the wizard and watch the outcome sharpen from\n``UNKNOWN`` to ``NO_PA`` \/ ``PA_REQUIRED`` \/ ``EXCLUDED``.",
  );

export const previewPriorAuthForRxDraftResponse = zod
  .object({
    outcome: zod
      .enum(["NO_COVERAGE", "NO_PA", "PA_REQUIRED", "EXCLUDED", "UNKNOWN"])
      .describe(
        'Five-way classification of a prescription\'s PA posture at write time.\n\nConsumed by :class:`PrescriptionModel` to split a batch into sendable\nvs. PA-gated prescriptions. See ``PRIOR_AUTH.md`` § \"Decision logic\"\nfor the source-of-truth description.',
      ),
    reason: zod.string(),
    patientEligibilityId: zod.union([zod.number(), zod.null()]).optional(),
    realtimeStatus: zod.union([zod.number(), zod.null()]).optional(),
    formulary: zod
      .union([
        zod
          .object({
            FormularyStatus: zod.union([zod.string(), zod.null()]).optional(),
            Brand: zod.union([zod.boolean(), zod.null()]).optional(),
            Otc: zod.union([zod.boolean(), zod.null()]).optional(),
            Copays: zod
              .union([
                zod.array(
                  zod
                    .object({
                      IsDrugSpecific: zod
                        .union([zod.boolean(), zod.null()])
                        .optional(),
                      PharmacyType: zod
                        .union([
                          zod
                            .enum([
                              "Any",
                              "FaxPharmacy",
                              "EPCS",
                              "TwentyFourHourPharmacy",
                              "LongTermCarePharmacy",
                              "MailOrder",
                              "Retail",
                              "SpecialtyPharmacy",
                            ])
                            .describe(
                              "Valid pharmacy specialty types for DoseSpot.",
                            ),
                          zod.null(),
                        ])
                        .optional(),
                      FlatCopayAmount: zod
                        .union([zod.number(), zod.null()])
                        .optional(),
                      PercentCopayAmount: zod
                        .union([zod.number(), zod.null()])
                        .optional(),
                      FlatCopayAmountFirst: zod
                        .union([zod.boolean(), zod.null()])
                        .optional(),
                      MinimumCopayAmount: zod
                        .union([zod.number(), zod.null()])
                        .optional(),
                      MaximumCopayAmount: zod
                        .union([zod.number(), zod.null()])
                        .optional(),
                      DaysSupply: zod
                        .union([zod.number(), zod.null()])
                        .optional(),
                      CopayTier: zod
                        .union([zod.number(), zod.null()])
                        .optional(),
                      MaximumCopayTier: zod
                        .union([zod.number(), zod.null()])
                        .optional(),
                      OutOfPocketMinimum: zod
                        .union([zod.number(), zod.null()])
                        .optional(),
                      OutOfPocketMaximum: zod
                        .union([zod.number(), zod.null()])
                        .optional(),
                    })
                    .describe(
                      "Single copay tier (`PayerCopay`).\n\nPer-channel pricing rule returned on formulary responses and on the\n``RepresentitiveFormularyCoverage`` slice of each alternative. The\ngate doesn't consult any of these fields directly — they're carried\nthrough for UI display next to an ``EXCLUDED`` \/ ``PA_REQUIRED``\nbanner.",
                    ),
                ),
                zod.null(),
              ])
              .optional(),
            Alternatives: zod
              .union([
                zod.array(
                  zod
                    .object({
                      Ndc: zod.union([zod.string(), zod.null()]).optional(),
                      DisplayName: zod
                        .union([zod.string(), zod.null()])
                        .optional(),
                      RxCUI: zod.union([zod.number(), zod.null()]).optional(),
                      DispensableDrugId: zod
                        .union([zod.number(), zod.null()])
                        .optional(),
                      Brand: zod.union([zod.boolean(), zod.null()]).optional(),
                      Otc: zod.union([zod.boolean(), zod.null()]).optional(),
                      Details: zod
                        .union([
                          zod.array(
                            zod
                              .object({
                                PatientSpecificPricingCoverages: zod
                                  .union([
                                    zod.array(
                                      zod
                                        .object({
                                          Pharmacy: zod
                                            .union([
                                              zod
                                                .object({
                                                  PharmacyType: zod
                                                    .union([
                                                      zod
                                                        .enum([
                                                          "Retail",
                                                          "Mail",
                                                          "Item90DayAtRetail",
                                                          "Specialty",
                                                          "LongTermCare",
                                                        ])
                                                        .describe(
                                                          "`PrescriptionBenefitsPharmacy.PharmacyType` values.\n\nDistinct from :class:`PharmacySpecialtyTypeT` — DoseSpot uses a\ndifferent (smaller) vocabulary for the pharmacy slice returned on\nrealtime-benefits responses than for channel-level eligibility.",
                                                        ),
                                                      zod.null(),
                                                    ])
                                                    .optional(),
                                                  Identifications: zod
                                                    .union([
                                                      zod.record(
                                                        zod.string(),
                                                        zod.unknown(),
                                                      ),
                                                      zod.null(),
                                                    ])
                                                    .optional(),
                                                  PharmacistLastName: zod
                                                    .union([
                                                      zod.string(),
                                                      zod.null(),
                                                    ])
                                                    .optional(),
                                                  PharmacistFirstName: zod
                                                    .union([
                                                      zod.string(),
                                                      zod.null(),
                                                    ])
                                                    .optional(),
                                                  PharmacistMiddleName: zod
                                                    .union([
                                                      zod.string(),
                                                      zod.null(),
                                                    ])
                                                    .optional(),
                                                  PharmacistSuffix: zod
                                                    .union([
                                                      zod.string(),
                                                      zod.null(),
                                                    ])
                                                    .optional(),
                                                  PharmacistPrefix: zod
                                                    .union([
                                                      zod.string(),
                                                      zod.null(),
                                                    ])
                                                    .optional(),
                                                  Email: zod
                                                    .union([
                                                      zod.string(),
                                                      zod.null(),
                                                    ])
                                                    .optional(),
                                                  DistanceFromRequestedPharmacy:
                                                    zod
                                                      .union([
                                                        zod.number(),
                                                        zod.null(),
                                                      ])
                                                      .optional(),
                                                  PharmacyId: zod
                                                    .union([
                                                      zod.number(),
                                                      zod.null(),
                                                    ])
                                                    .optional(),
                                                  StoreName: zod
                                                    .union([
                                                      zod.string(),
                                                      zod.null(),
                                                    ])
                                                    .optional(),
                                                  Address1: zod
                                                    .union([
                                                      zod.string(),
                                                      zod.null(),
                                                    ])
                                                    .optional(),
                                                  Address2: zod
                                                    .union([
                                                      zod.string(),
                                                      zod.null(),
                                                    ])
                                                    .optional(),
                                                  City: zod
                                                    .union([
                                                      zod.string(),
                                                      zod.null(),
                                                    ])
                                                    .optional(),
                                                  State: zod
                                                    .union([
                                                      zod.string(),
                                                      zod.null(),
                                                    ])
                                                    .optional(),
                                                  ZipCode: zod
                                                    .union([
                                                      zod.string(),
                                                      zod.null(),
                                                    ])
                                                    .optional(),
                                                  PrimaryPhone: zod
                                                    .union([
                                                      zod.string(),
                                                      zod.null(),
                                                    ])
                                                    .optional(),
                                                  PrimaryPhoneType: zod
                                                    .union([
                                                      zod
                                                        .enum([
                                                          "Undefined",
                                                          "Beeper",
                                                          "Cell",
                                                          "Fax",
                                                          "Home",
                                                          "Work",
                                                          "Night",
                                                          "Primary",
                                                        ])
                                                        .describe(
                                                          "`PrescriptionBenefitsPharmacy.PrimaryPhoneType` \/ `PhoneAdditionalType\*` values.",
                                                        ),
                                                      zod.null(),
                                                    ])
                                                    .optional(),
                                                  PrimaryFax: zod
                                                    .union([
                                                      zod.string(),
                                                      zod.null(),
                                                    ])
                                                    .optional(),
                                                  PhoneAdditional1: zod
                                                    .union([
                                                      zod.string(),
                                                      zod.null(),
                                                    ])
                                                    .optional(),
                                                  PhoneAdditionalType1: zod
                                                    .union([
                                                      zod
                                                        .enum([
                                                          "Undefined",
                                                          "Beeper",
                                                          "Cell",
                                                          "Fax",
                                                          "Home",
                                                          "Work",
                                                          "Night",
                                                          "Primary",
                                                        ])
                                                        .describe(
                                                          "`PrescriptionBenefitsPharmacy.PrimaryPhoneType` \/ `PhoneAdditionalType\*` values.",
                                                        ),
                                                      zod.null(),
                                                    ])
                                                    .optional(),
                                                  PhoneAdditional2: zod
                                                    .union([
                                                      zod.string(),
                                                      zod.null(),
                                                    ])
                                                    .optional(),
                                                  PhoneAdditionalType2: zod
                                                    .union([
                                                      zod
                                                        .enum([
                                                          "Undefined",
                                                          "Beeper",
                                                          "Cell",
                                                          "Fax",
                                                          "Home",
                                                          "Work",
                                                          "Night",
                                                          "Primary",
                                                        ])
                                                        .describe(
                                                          "`PrescriptionBenefitsPharmacy.PrimaryPhoneType` \/ `PhoneAdditionalType\*` values.",
                                                        ),
                                                      zod.null(),
                                                    ])
                                                    .optional(),
                                                  PhoneAdditional3: zod
                                                    .union([
                                                      zod.string(),
                                                      zod.null(),
                                                    ])
                                                    .optional(),
                                                  PhoneAdditionalType3: zod
                                                    .union([
                                                      zod
                                                        .enum([
                                                          "Undefined",
                                                          "Beeper",
                                                          "Cell",
                                                          "Fax",
                                                          "Home",
                                                          "Work",
                                                          "Night",
                                                          "Primary",
                                                        ])
                                                        .describe(
                                                          "`PrescriptionBenefitsPharmacy.PrimaryPhoneType` \/ `PhoneAdditionalType\*` values.",
                                                        ),
                                                      zod.null(),
                                                    ])
                                                    .optional(),
                                                  PharmacySpecialties: zod
                                                    .union([
                                                      zod.array(zod.string()),
                                                      zod.null(),
                                                    ])
                                                    .optional(),
                                                  ServiceLevel: zod
                                                    .union([
                                                      zod.number(),
                                                      zod.null(),
                                                    ])
                                                    .optional(),
                                                  Latitude: zod
                                                    .union([
                                                      zod.number(),
                                                      zod.null(),
                                                    ])
                                                    .optional(),
                                                  Longitude: zod
                                                    .union([
                                                      zod.number(),
                                                      zod.null(),
                                                    ])
                                                    .optional(),
                                                  NCPDPID: zod
                                                    .union([
                                                      zod.string(),
                                                      zod.null(),
                                                    ])
                                                    .optional(),
                                                })
                                                .describe(
                                                  "`PrescriptionBenefitsPharmacy` — pharmacy slice on RTPB responses.\n\nNarrower-use than :class:`PharmacyT`; mirrors the full swagger shape\nso callers can surface dispensing-pharmacy details (name, address,\nNCPDPID) alongside pricing \/ PA signals from a\n``PatientSpecificPricingCoverage`` entry.",
                                                ),
                                              zod.null(),
                                            ])
                                            .optional(),
                                          PricingCoverage: zod
                                            .union([
                                              zod
                                                .object({
                                                  DrugStatusCode: zod
                                                    .union([
                                                      zod.string(),
                                                      zod.null(),
                                                    ])
                                                    .optional(),
                                                  DrugStatus: zod
                                                    .union([
                                                      zod.string(),
                                                      zod.null(),
                                                    ])
                                                    .optional(),
                                                  QuantityPricedValue: zod
                                                    .union([
                                                      zod.string(),
                                                      zod.null(),
                                                    ])
                                                    .optional(),
                                                  QuantityPricedCodeListQualifier:
                                                    zod
                                                      .union([
                                                        zod
                                                          .enum([
                                                            "Item38",
                                                            "Item40",
                                                            "Item87",
                                                            "QS",
                                                            "CF",
                                                            "UQ",
                                                          ])
                                                          .describe(
                                                            "`PricingCoverageFactors.QuantityPricedCodeListQualifier` values.",
                                                          ),
                                                        zod.null(),
                                                      ])
                                                      .optional(),
                                                  QuantityPricedUnitOfMeasureType:
                                                    zod
                                                      .union([
                                                        zod.string(),
                                                        zod.null(),
                                                      ])
                                                      .optional(),
                                                  QuantityPricedUnitOfMeasureTypeId:
                                                    zod
                                                      .union([
                                                        zod.number(),
                                                        zod.null(),
                                                      ])
                                                      .optional(),
                                                  DaysSupplyPriced: zod
                                                    .union([
                                                      zod.string(),
                                                      zod.null(),
                                                    ])
                                                    .optional(),
                                                  PlanPayAmount: zod
                                                    .union([
                                                      zod.string(),
                                                      zod.null(),
                                                    ])
                                                    .optional(),
                                                  EstimatedPatientPayAmount: zod
                                                    .union([
                                                      zod.string(),
                                                      zod.null(),
                                                    ])
                                                    .optional(),
                                                  OOPAppliedAmount: zod
                                                    .union([
                                                      zod.string(),
                                                      zod.null(),
                                                    ])
                                                    .optional(),
                                                  OOPRemainingAmount: zod
                                                    .union([
                                                      zod.string(),
                                                      zod.null(),
                                                    ])
                                                    .optional(),
                                                  DeductibleAppliedAmount: zod
                                                    .union([
                                                      zod.string(),
                                                      zod.null(),
                                                    ])
                                                    .optional(),
                                                  DeductibleRemainingAmount: zod
                                                    .union([
                                                      zod.string(),
                                                      zod.null(),
                                                    ])
                                                    .optional(),
                                                  CoverageAlerts: zod
                                                    .union([
                                                      zod.array(
                                                        zod
                                                          .object({
                                                            ReferenceCode: zod
                                                              .union([
                                                                zod
                                                                  .enum([
                                                                    "AgeLimits",
                                                                    "DaysSupplyExceeded",
                                                                    "DrugExclusion",
                                                                    "ExcessiveUtilization",
                                                                    "FullCostNotCovered",
                                                                    "GenderLimits",
                                                                    "MandatoryGeneric",
                                                                    "MedicalNecessity",
                                                                    "NotOnFormulary",
                                                                    "PharmacyOutOfNetwork",
                                                                    "PlanLimitExclusion",
                                                                    "QuantityLimits",
                                                                    "QuantityLimitExceeded",
                                                                    "QuantityNotValid",
                                                                    "ResourceLink",
                                                                    "StepTherapy",
                                                                    "TextMessage",
                                                                  ])
                                                                  .describe(
                                                                    "`PricingCoverageFactorsCoverageAlerts.ReferenceCode` values.",
                                                                  ),
                                                                zod.null(),
                                                              ])
                                                              .optional(),
                                                            ReferenceText: zod
                                                              .union([
                                                                zod.string(),
                                                                zod.null(),
                                                              ])
                                                              .optional(),
                                                          })
                                                          .describe(
                                                            "`PricingCoverageFactorsCoverageAlerts` entry on :class:`PricingCoverageFactorsT`.\n\nDoseSpot returns coverage-alert \*objects\* here (not plain strings):\na ``ReferenceCode`` enum plus a human-readable ``ReferenceText``.",
                                                          ),
                                                      ),
                                                      zod.null(),
                                                    ])
                                                    .optional(),
                                                  FormularyStatus: zod
                                                    .union([
                                                      zod.string(),
                                                      zod.null(),
                                                    ])
                                                    .optional(),
                                                  PriorAuthRequired: zod
                                                    .union([
                                                      zod.boolean(),
                                                      zod.null(),
                                                    ])
                                                    .optional(),
                                                })
                                                .describe(
                                                  "`PricingCoverageFactors` — `PricingCoverage` sub-object on RTPB.\n\nThe realtime gate's authoritative PA source: ``PriorAuthRequired=true``\non any pharmacy-specific pricing coverage flips the gate to\n:attr:`PA_REQUIRED`. Pricing fields are kept for downstream UI — they\nare not consulted by the gate but are cheap to carry.",
                                                ),
                                              zod.null(),
                                            ])
                                            .optional(),
                                        })
                                        .describe(
                                          "`PatientSpecificPricingCoverage` — one (pharmacy × coverage) pricing row.\n\nA coverage can yield multiple entries — one per pharmacy the payer\npriced against — so the gate has to OR the ``PriorAuthRequired`` bits\nacross the list to get a conservative answer.",
                                        ),
                                    ),
                                    zod.null(),
                                  ])
                                  .optional(),
                                Ndc: zod
                                  .union([zod.string(), zod.null()])
                                  .optional(),
                                DisplayName: zod
                                  .union([zod.string(), zod.null()])
                                  .optional(),
                                RxCUI: zod
                                  .union([zod.number(), zod.null()])
                                  .optional(),
                                DispensableDrugId: zod
                                  .union([zod.number(), zod.null()])
                                  .optional(),
                                Coverage: zod
                                  .union([
                                    zod
                                      .object({
                                        FormularyStatus: zod
                                          .union([zod.string(), zod.null()])
                                          .optional(),
                                        Copays: zod
                                          .union([
                                            zod.array(
                                              zod
                                                .object({
                                                  IsDrugSpecific: zod
                                                    .union([
                                                      zod.boolean(),
                                                      zod.null(),
                                                    ])
                                                    .optional(),
                                                  PharmacyType: zod
                                                    .union([
                                                      zod
                                                        .enum([
                                                          "Any",
                                                          "FaxPharmacy",
                                                          "EPCS",
                                                          "TwentyFourHourPharmacy",
                                                          "LongTermCarePharmacy",
                                                          "MailOrder",
                                                          "Retail",
                                                          "SpecialtyPharmacy",
                                                        ])
                                                        .describe(
                                                          "Valid pharmacy specialty types for DoseSpot.",
                                                        ),
                                                      zod.null(),
                                                    ])
                                                    .optional(),
                                                  FlatCopayAmount: zod
                                                    .union([
                                                      zod.number(),
                                                      zod.null(),
                                                    ])
                                                    .optional(),
                                                  PercentCopayAmount: zod
                                                    .union([
                                                      zod.number(),
                                                      zod.null(),
                                                    ])
                                                    .optional(),
                                                  FlatCopayAmountFirst: zod
                                                    .union([
                                                      zod.boolean(),
                                                      zod.null(),
                                                    ])
                                                    .optional(),
                                                  MinimumCopayAmount: zod
                                                    .union([
                                                      zod.number(),
                                                      zod.null(),
                                                    ])
                                                    .optional(),
                                                  MaximumCopayAmount: zod
                                                    .union([
                                                      zod.number(),
                                                      zod.null(),
                                                    ])
                                                    .optional(),
                                                  DaysSupply: zod
                                                    .union([
                                                      zod.number(),
                                                      zod.null(),
                                                    ])
                                                    .optional(),
                                                  CopayTier: zod
                                                    .union([
                                                      zod.number(),
                                                      zod.null(),
                                                    ])
                                                    .optional(),
                                                  MaximumCopayTier: zod
                                                    .union([
                                                      zod.number(),
                                                      zod.null(),
                                                    ])
                                                    .optional(),
                                                  OutOfPocketMinimum: zod
                                                    .union([
                                                      zod.number(),
                                                      zod.null(),
                                                    ])
                                                    .optional(),
                                                  OutOfPocketMaximum: zod
                                                    .union([
                                                      zod.number(),
                                                      zod.null(),
                                                    ])
                                                    .optional(),
                                                })
                                                .describe(
                                                  "Single copay tier (`PayerCopay`).\n\nPer-channel pricing rule returned on formulary responses and on the\n``RepresentitiveFormularyCoverage`` slice of each alternative. The\ngate doesn't consult any of these fields directly — they're carried\nthrough for UI display next to an ``EXCLUDED`` \/ ``PA_REQUIRED``\nbanner.",
                                                ),
                                            ),
                                            zod.null(),
                                          ])
                                          .optional(),
                                        Alternatives: zod
                                          .union([
                                            zod.array(
                                              zod
                                                .object({
                                                  Ndc: zod
                                                    .union([
                                                      zod.string(),
                                                      zod.null(),
                                                    ])
                                                    .optional(),
                                                  Details: zod
                                                    .union([
                                                      zod.array(
                                                        zod
                                                          .object({
                                                            Ndc: zod
                                                              .union([
                                                                zod.string(),
                                                                zod.null(),
                                                              ])
                                                              .optional(),
                                                            Coverage: zod
                                                              .union([
                                                                zod.unknown(),
                                                                zod.null(),
                                                              ])
                                                              .optional(),
                                                          })
                                                          .describe(
                                                            "`PayerAlternativeDetail` — one detail under :class:`PayerAlternativeSimpleT`.",
                                                          ),
                                                      ),
                                                      zod.null(),
                                                    ])
                                                    .optional(),
                                                })
                                                .describe(
                                                  "`PayerAlternative` — the narrower alternative shape nested in :class:`MedicationCoverageT`.\n\nPer v2 swagger, nested alternatives (alternatives of alternatives) only\ncarry ``Ndc`` and a ``Details`` list, not the full\n:class:`PayerAlternativeT` payload.",
                                                ),
                                            ),
                                            zod.null(),
                                          ])
                                          .optional(),
                                        Restrictions: zod
                                          .union([
                                            zod
                                              .object({
                                                IsExcluded: zod
                                                  .union([
                                                    zod.boolean(),
                                                    zod.null(),
                                                  ])
                                                  .optional(),
                                                HasMedicalNecessity: zod
                                                  .union([
                                                    zod.boolean(),
                                                    zod.null(),
                                                  ])
                                                  .optional(),
                                                HasPriorAuthorization: zod
                                                  .union([
                                                    zod.boolean(),
                                                    zod.null(),
                                                  ])
                                                  .optional(),
                                                HasStepTherapy: zod
                                                  .union([
                                                    zod.boolean(),
                                                    zod.null(),
                                                  ])
                                                  .optional(),
                                                HasQuantityLimit: zod
                                                  .union([
                                                    zod.boolean(),
                                                    zod.null(),
                                                  ])
                                                  .optional(),
                                                HasAgeLimit: zod
                                                  .union([
                                                    zod.boolean(),
                                                    zod.null(),
                                                  ])
                                                  .optional(),
                                                AgeLimitRestrictions: zod
                                                  .union([
                                                    zod.array(
                                                      zod
                                                        .object({
                                                          MinimumAge: zod
                                                            .union([
                                                              zod.number(),
                                                              zod.null(),
                                                            ])
                                                            .optional(),
                                                          MinimumAgeUnit: zod
                                                            .union([
                                                              zod
                                                                .enum([
                                                                  "Days",
                                                                  "Years",
                                                                ])
                                                                .describe(
                                                                  "Unit on :class:`AgeLimitRestrictionT` bounds.",
                                                                ),
                                                              zod.null(),
                                                            ])
                                                            .optional(),
                                                          MaximumAge: zod
                                                            .union([
                                                              zod.number(),
                                                              zod.null(),
                                                            ])
                                                            .optional(),
                                                          MaximumAgeUnit: zod
                                                            .union([
                                                              zod
                                                                .enum([
                                                                  "Days",
                                                                  "Years",
                                                                ])
                                                                .describe(
                                                                  "Unit on :class:`AgeLimitRestrictionT` bounds.",
                                                                ),
                                                              zod.null(),
                                                            ])
                                                            .optional(),
                                                        })
                                                        .describe(
                                                          "`AgeLimitRestriction` entry on a `CoverageRestrictions`.",
                                                        ),
                                                    ),
                                                    zod.null(),
                                                  ])
                                                  .optional(),
                                                GenderRestriction: zod
                                                  .union([
                                                    zod
                                                      .enum([
                                                        "Male",
                                                        "Female",
                                                        "Unknown",
                                                      ])
                                                      .describe(
                                                        "`PayerDemographics.Gender` and `CoverageRestrictions.GenderRestriction` values.",
                                                      ),
                                                    zod.null(),
                                                  ])
                                                  .optional(),
                                                QuantityLimitRestrictions: zod
                                                  .union([
                                                    zod.array(
                                                      zod
                                                        .object({
                                                          MaximumAmount: zod
                                                            .union([
                                                              zod.number(),
                                                              zod.null(),
                                                            ])
                                                            .optional(),
                                                          AmountUnit: zod
                                                            .union([
                                                              zod
                                                                .enum([
                                                                  "DollarAmount",
                                                                  "DaysSupply",
                                                                  "Fills",
                                                                  "Quantity",
                                                                ])
                                                                .describe(
                                                                  "`QuantityLimitRestriction.AmountUnit` values.",
                                                                ),
                                                              zod.null(),
                                                            ])
                                                            .optional(),
                                                          TimePeriodUnit: zod
                                                            .union([
                                                              zod
                                                                .enum([
                                                                  "Days",
                                                                  "Lifetime",
                                                                  "PerDispensing",
                                                                  "SpecificDateRange",
                                                                  "CalendarYear",
                                                                  "CalendarQuarter",
                                                                  "CalendarMonth",
                                                                ])
                                                                .describe(
                                                                  "`QuantityLimitRestriction.TimePeriodUnit` values.",
                                                                ),
                                                              zod.null(),
                                                            ])
                                                            .optional(),
                                                          StartDate: zod
                                                            .union([
                                                              zod.string(),
                                                              zod.null(),
                                                            ])
                                                            .optional(),
                                                          EndDate: zod
                                                            .union([
                                                              zod.string(),
                                                              zod.null(),
                                                            ])
                                                            .optional(),
                                                          MaximumTimePeriodUnits:
                                                            zod
                                                              .union([
                                                                zod.number(),
                                                                zod.null(),
                                                              ])
                                                              .optional(),
                                                        })
                                                        .describe(
                                                          "`QuantityLimitRestriction` entry on a `CoverageRestrictions`.",
                                                        ),
                                                    ),
                                                    zod.null(),
                                                  ])
                                                  .optional(),
                                                StepMedicationRestrictions: zod
                                                  .union([
                                                    zod.array(
                                                      zod
                                                        .object({
                                                          Ndc: zod
                                                            .union([
                                                              zod.string(),
                                                              zod.null(),
                                                            ])
                                                            .optional(),
                                                          StepDrugType: zod
                                                            .union([
                                                              zod
                                                                .enum([
                                                                  "Unknown",
                                                                  "SpecificMedication",
                                                                  "PharmacologicalClass",
                                                                ])
                                                                .describe(
                                                                  "`StepMedicationRestriction.StepDrugType` values.",
                                                                ),
                                                              zod.null(),
                                                            ])
                                                            .optional(),
                                                          StepOrder: zod
                                                            .union([
                                                              zod.number(),
                                                              zod.null(),
                                                            ])
                                                            .optional(),
                                                          DisplayName: zod
                                                            .union([
                                                              zod.string(),
                                                              zod.null(),
                                                            ])
                                                            .optional(),
                                                          RxCUI: zod
                                                            .union([
                                                              zod.number(),
                                                              zod.null(),
                                                            ])
                                                            .optional(),
                                                          DispensableDrugId: zod
                                                            .union([
                                                              zod.number(),
                                                              zod.null(),
                                                            ])
                                                            .optional(),
                                                        })
                                                        .describe(
                                                          "`StepMedicationRestriction` entry on a `CoverageRestrictions`.",
                                                        ),
                                                    ),
                                                    zod.null(),
                                                  ])
                                                  .optional(),
                                                Messages: zod
                                                  .union([
                                                    zod.array(
                                                      zod
                                                        .object({
                                                          Message: zod
                                                            .union([
                                                              zod.string(),
                                                              zod.null(),
                                                            ])
                                                            .optional(),
                                                          LongMessage: zod
                                                            .union([
                                                              zod.string(),
                                                              zod.null(),
                                                            ])
                                                            .optional(),
                                                        })
                                                        .describe(
                                                          "`CoverageMessage` entry on a `CoverageRestrictions`.",
                                                        ),
                                                    ),
                                                    zod.null(),
                                                  ])
                                                  .optional(),
                                                DrugResources: zod
                                                  .union([
                                                    zod.array(
                                                      zod
                                                        .object({
                                                          Url: zod
                                                            .union([
                                                              zod.string(),
                                                              zod.null(),
                                                            ])
                                                            .optional(),
                                                          ResourceType: zod
                                                            .union([
                                                              zod
                                                                .enum([
                                                                  "AgeLimits",
                                                                  "ProductCoverageExclusion",
                                                                  "GenderLimits",
                                                                  "MedicalNecessity",
                                                                  "PriorAuthorization",
                                                                  "QuantityLimits",
                                                                  "StepTherapy",
                                                                  "General",
                                                                  "Copay",
                                                                  "Formulary",
                                                                ])
                                                                .describe(
                                                                  "`CoverageResource.ResourceType` values.",
                                                                ),
                                                              zod.null(),
                                                            ])
                                                            .optional(),
                                                        })
                                                        .describe(
                                                          "`CoverageResource` entry on a `CoverageRestrictions`.",
                                                        ),
                                                    ),
                                                    zod.null(),
                                                  ])
                                                  .optional(),
                                                SummaryResources: zod
                                                  .union([
                                                    zod.array(
                                                      zod
                                                        .object({
                                                          Url: zod
                                                            .union([
                                                              zod.string(),
                                                              zod.null(),
                                                            ])
                                                            .optional(),
                                                          ResourceType: zod
                                                            .union([
                                                              zod
                                                                .enum([
                                                                  "AgeLimits",
                                                                  "ProductCoverageExclusion",
                                                                  "GenderLimits",
                                                                  "MedicalNecessity",
                                                                  "PriorAuthorization",
                                                                  "QuantityLimits",
                                                                  "StepTherapy",
                                                                  "General",
                                                                  "Copay",
                                                                  "Formulary",
                                                                ])
                                                                .describe(
                                                                  "`CoverageResource.ResourceType` values.",
                                                                ),
                                                              zod.null(),
                                                            ])
                                                            .optional(),
                                                        })
                                                        .describe(
                                                          "`CoverageResource` entry on a `CoverageRestrictions`.",
                                                        ),
                                                    ),
                                                    zod.null(),
                                                  ])
                                                  .optional(),
                                              })
                                              .describe(
                                                "Coverage restrictions on the primary drug (`CoverageRestrictions`).\n\n``HasPriorAuthorization`` is the primary bit the gate consults when\n`\/prescriptionbenefits` is unavailable. ``IsExcluded`` shortcuts to\nthe `EXCLUDED` gate outcome: no point initiating a PA for a drug the\npayer will never cover.\n\nField-name alignment with the v2 swagger: ``HasAgeLimit`` \/\n``HasQuantityLimit`` are singular here (not plural as on\n:class:`RealTimeFormularyCoverageRestrictionsT`); there is no\n``HasGenderLimit`` — use ``GenderRestriction`` for that.",
                                              ),
                                            zod.null(),
                                          ])
                                          .optional(),
                                      })
                                      .describe(
                                        "`MedicationCoverage` — coverage slice nested under `PayerAlternativeDetail`.\n\nDistinct from :class:`MedicationCoverageResponseT` (the\n``\/formulary`` response body): no ``Otc`` \/ ``Brand`` \/\n``TherapeuticAlternatives`` \/ ``RealTimeFormularyRequestStatus``\nfields here.",
                                      ),
                                    zod.null(),
                                  ])
                                  .optional(),
                              })
                              .describe(
                                "`PrescriptionBenefitPayerAlternativeDetail` — one detail under :class:`PayerAlternativeT`.\n\nEach detail describes an NDC-level variant of the alternative drug\nalong with its patient-specific pricing.",
                              ),
                          ),
                          zod.null(),
                        ])
                        .optional(),
                      RepresentativeFormularyCoverage: zod
                        .union([
                          zod
                            .object({
                              CopayFactors: zod
                                .union([
                                  zod.array(
                                    zod
                                      .object({
                                        IsDrugSpecific: zod
                                          .union([zod.boolean(), zod.null()])
                                          .optional(),
                                        PharmacyType: zod
                                          .union([
                                            zod
                                              .enum([
                                                "Any",
                                                "FaxPharmacy",
                                                "EPCS",
                                                "TwentyFourHourPharmacy",
                                                "LongTermCarePharmacy",
                                                "MailOrder",
                                                "Retail",
                                                "SpecialtyPharmacy",
                                              ])
                                              .describe(
                                                "Valid pharmacy specialty types for DoseSpot.",
                                              ),
                                            zod.null(),
                                          ])
                                          .optional(),
                                        FlatCopayAmount: zod
                                          .union([zod.number(), zod.null()])
                                          .optional(),
                                        PercentCopayAmount: zod
                                          .union([zod.number(), zod.null()])
                                          .optional(),
                                        FlatCopayAmountFirst: zod
                                          .union([zod.boolean(), zod.null()])
                                          .optional(),
                                        MinimumCopayAmount: zod
                                          .union([zod.number(), zod.null()])
                                          .optional(),
                                        MaximumCopayAmount: zod
                                          .union([zod.number(), zod.null()])
                                          .optional(),
                                        DaysSupply: zod
                                          .union([zod.number(), zod.null()])
                                          .optional(),
                                        CopayTier: zod
                                          .union([zod.number(), zod.null()])
                                          .optional(),
                                        MaximumCopayTier: zod
                                          .union([zod.number(), zod.null()])
                                          .optional(),
                                        OutOfPocketMinimum: zod
                                          .union([zod.number(), zod.null()])
                                          .optional(),
                                        OutOfPocketMaximum: zod
                                          .union([zod.number(), zod.null()])
                                          .optional(),
                                      })
                                      .describe(
                                        "Single copay tier (`PayerCopay`).\n\nPer-channel pricing rule returned on formulary responses and on the\n``RepresentitiveFormularyCoverage`` slice of each alternative. The\ngate doesn't consult any of these fields directly — they're carried\nthrough for UI display next to an ``EXCLUDED`` \/ ``PA_REQUIRED``\nbanner.",
                                      ),
                                  ),
                                  zod.null(),
                                ])
                                .optional(),
                              FormularyStatus: zod
                                .union([zod.string(), zod.null()])
                                .optional(),
                              FormularyStatusText: zod
                                .union([zod.string(), zod.null()])
                                .optional(),
                              RealTimeFormularyCoverageRestrictions: zod
                                .union([
                                  zod
                                    .object({
                                      HasCoverageRestrictions: zod
                                        .union([zod.boolean(), zod.null()])
                                        .optional(),
                                      IsExcluded: zod
                                        .union([zod.boolean(), zod.null()])
                                        .optional(),
                                      HasMedicalNecessity: zod
                                        .union([zod.boolean(), zod.null()])
                                        .optional(),
                                      HasPriorAuthorization: zod
                                        .union([zod.boolean(), zod.null()])
                                        .optional(),
                                      HasStepTherapy: zod
                                        .union([zod.boolean(), zod.null()])
                                        .optional(),
                                      AgeLimitRestrictions: zod
                                        .union([
                                          zod.array(
                                            zod
                                              .object({
                                                MinimumAge: zod
                                                  .union([
                                                    zod.number(),
                                                    zod.null(),
                                                  ])
                                                  .optional(),
                                                MinimumAgeUnit: zod
                                                  .union([
                                                    zod
                                                      .enum(["Days", "Years"])
                                                      .describe(
                                                        "Unit on :class:`AgeLimitRestrictionT` bounds.",
                                                      ),
                                                    zod.null(),
                                                  ])
                                                  .optional(),
                                                MaximumAge: zod
                                                  .union([
                                                    zod.number(),
                                                    zod.null(),
                                                  ])
                                                  .optional(),
                                                MaximumAgeUnit: zod
                                                  .union([
                                                    zod
                                                      .enum(["Days", "Years"])
                                                      .describe(
                                                        "Unit on :class:`AgeLimitRestrictionT` bounds.",
                                                      ),
                                                    zod.null(),
                                                  ])
                                                  .optional(),
                                              })
                                              .describe(
                                                "`AgeLimitRestriction` entry on a `CoverageRestrictions`.",
                                              ),
                                          ),
                                          zod.null(),
                                        ])
                                        .optional(),
                                      GenderLimitRestrictions: zod
                                        .union([
                                          zod.array(
                                            zod
                                              .object({
                                                GenderAbbreviation: zod
                                                  .union([
                                                    zod.string(),
                                                    zod.null(),
                                                  ])
                                                  .optional(),
                                                GenderDescription: zod
                                                  .union([
                                                    zod.string(),
                                                    zod.null(),
                                                  ])
                                                  .optional(),
                                              })
                                              .describe(
                                                "`GenderLimitRestriction` entry on a `RealTimeFormularyCoverageRestrictions`.",
                                              ),
                                          ),
                                          zod.null(),
                                        ])
                                        .optional(),
                                      QuantityLimitRestrictions: zod
                                        .union([
                                          zod.array(
                                            zod
                                              .object({
                                                MaximumAmount: zod
                                                  .union([
                                                    zod.number(),
                                                    zod.null(),
                                                  ])
                                                  .optional(),
                                                AmountUnit: zod
                                                  .union([
                                                    zod
                                                      .enum([
                                                        "DollarAmount",
                                                        "DaysSupply",
                                                        "Fills",
                                                        "Quantity",
                                                      ])
                                                      .describe(
                                                        "`QuantityLimitRestriction.AmountUnit` values.",
                                                      ),
                                                    zod.null(),
                                                  ])
                                                  .optional(),
                                                TimePeriodUnit: zod
                                                  .union([
                                                    zod
                                                      .enum([
                                                        "Days",
                                                        "Lifetime",
                                                        "PerDispensing",
                                                        "SpecificDateRange",
                                                        "CalendarYear",
                                                        "CalendarQuarter",
                                                        "CalendarMonth",
                                                      ])
                                                      .describe(
                                                        "`QuantityLimitRestriction.TimePeriodUnit` values.",
                                                      ),
                                                    zod.null(),
                                                  ])
                                                  .optional(),
                                                StartDate: zod
                                                  .union([
                                                    zod.string(),
                                                    zod.null(),
                                                  ])
                                                  .optional(),
                                                EndDate: zod
                                                  .union([
                                                    zod.string(),
                                                    zod.null(),
                                                  ])
                                                  .optional(),
                                                MaximumTimePeriodUnits: zod
                                                  .union([
                                                    zod.number(),
                                                    zod.null(),
                                                  ])
                                                  .optional(),
                                              })
                                              .describe(
                                                "`QuantityLimitRestriction` entry on a `CoverageRestrictions`.",
                                              ),
                                          ),
                                          zod.null(),
                                        ])
                                        .optional(),
                                      StepMedicationRestrictions: zod
                                        .union([
                                          zod.array(
                                            zod
                                              .object({
                                                Ndc: zod
                                                  .union([
                                                    zod.string(),
                                                    zod.null(),
                                                  ])
                                                  .optional(),
                                                StepDrugType: zod
                                                  .union([
                                                    zod
                                                      .enum([
                                                        "Unknown",
                                                        "SpecificMedication",
                                                        "PharmacologicalClass",
                                                      ])
                                                      .describe(
                                                        "`StepMedicationRestriction.StepDrugType` values.",
                                                      ),
                                                    zod.null(),
                                                  ])
                                                  .optional(),
                                                StepOrder: zod
                                                  .union([
                                                    zod.number(),
                                                    zod.null(),
                                                  ])
                                                  .optional(),
                                                DisplayName: zod
                                                  .union([
                                                    zod.string(),
                                                    zod.null(),
                                                  ])
                                                  .optional(),
                                                RxCUI: zod
                                                  .union([
                                                    zod.number(),
                                                    zod.null(),
                                                  ])
                                                  .optional(),
                                                DispensableDrugId: zod
                                                  .union([
                                                    zod.number(),
                                                    zod.null(),
                                                  ])
                                                  .optional(),
                                              })
                                              .describe(
                                                "`StepMedicationRestriction` entry on a `CoverageRestrictions`.",
                                              ),
                                          ),
                                          zod.null(),
                                        ])
                                        .optional(),
                                      Messages: zod
                                        .union([
                                          zod.array(
                                            zod
                                              .object({
                                                Message: zod
                                                  .union([
                                                    zod.string(),
                                                    zod.null(),
                                                  ])
                                                  .optional(),
                                                LongMessage: zod
                                                  .union([
                                                    zod.string(),
                                                    zod.null(),
                                                  ])
                                                  .optional(),
                                              })
                                              .describe(
                                                "`CoverageMessage` entry on a `CoverageRestrictions`.",
                                              ),
                                          ),
                                          zod.null(),
                                        ])
                                        .optional(),
                                      DrugResources: zod
                                        .union([
                                          zod.array(
                                            zod
                                              .object({
                                                Url: zod
                                                  .union([
                                                    zod.string(),
                                                    zod.null(),
                                                  ])
                                                  .optional(),
                                                ResourceType: zod
                                                  .union([
                                                    zod
                                                      .enum([
                                                        "AgeLimits",
                                                        "ProductCoverageExclusion",
                                                        "GenderLimits",
                                                        "MedicalNecessity",
                                                        "PriorAuthorization",
                                                        "QuantityLimits",
                                                        "StepTherapy",
                                                        "General",
                                                        "Copay",
                                                        "Formulary",
                                                      ])
                                                      .describe(
                                                        "`CoverageResource.ResourceType` values.",
                                                      ),
                                                    zod.null(),
                                                  ])
                                                  .optional(),
                                              })
                                              .describe(
                                                "`CoverageResource` entry on a `CoverageRestrictions`.",
                                              ),
                                          ),
                                          zod.null(),
                                        ])
                                        .optional(),
                                      SummaryResources: zod
                                        .union([
                                          zod.array(
                                            zod
                                              .object({
                                                Url: zod
                                                  .union([
                                                    zod.string(),
                                                    zod.null(),
                                                  ])
                                                  .optional(),
                                                ResourceType: zod
                                                  .union([
                                                    zod
                                                      .enum([
                                                        "AgeLimits",
                                                        "ProductCoverageExclusion",
                                                        "GenderLimits",
                                                        "MedicalNecessity",
                                                        "PriorAuthorization",
                                                        "QuantityLimits",
                                                        "StepTherapy",
                                                        "General",
                                                        "Copay",
                                                        "Formulary",
                                                      ])
                                                      .describe(
                                                        "`CoverageResource.ResourceType` values.",
                                                      ),
                                                    zod.null(),
                                                  ])
                                                  .optional(),
                                              })
                                              .describe(
                                                "`CoverageResource` entry on a `CoverageRestrictions`.",
                                              ),
                                          ),
                                          zod.null(),
                                        ])
                                        .optional(),
                                    })
                                    .describe(
                                      "Realtime-only restriction slice (`RealTimeFormularyCoverageRestrictions`).\n\nAppears only on :class:`RepresentitiveFormularyCoverageT` (i.e. on each\nalternative drug), \*\*not\*\* on the primary drug's ``CoverageRestrictions``.\nThat asymmetry is per the v2 swagger: the primary drug's realtime PA\nbit is conveyed by ``\/prescriptionbenefits`` (``PriorAuthRequired``)\nand its cached bit by ``CoverageRestrictions.HasPriorAuthorization``.\n\nField names match the swagger exactly — note ``HasMedicalNecessity``\n(not the legacy ``RequiresMedicalNecessity``) and ``HasAge`` \/\n``HasQuantity`` rather than the plural ``…Limits`` spellings used on\n:class:`CoverageRestrictionsT`.",
                                    ),
                                  zod.null(),
                                ])
                                .optional(),
                            })
                            .describe(
                              "`RepresentitiveFormularyCoverage` on a :class:`PayerAlternativeT`.\n\nThe typo (``Representitive`` rather than ``Representative``) is\nDoseSpot's, not ours — the field name is verbatim from the v2 swagger\ndefinition so pydantic's ``model_validate`` of a raw DoseSpot\nresponse lines up.",
                            ),
                          zod.null(),
                        ])
                        .optional(),
                      PatientSpecificPricingCoverages: zod
                        .union([
                          zod.array(
                            zod
                              .object({
                                Pharmacy: zod
                                  .union([
                                    zod
                                      .object({
                                        PharmacyType: zod
                                          .union([
                                            zod
                                              .enum([
                                                "Retail",
                                                "Mail",
                                                "Item90DayAtRetail",
                                                "Specialty",
                                                "LongTermCare",
                                              ])
                                              .describe(
                                                "`PrescriptionBenefitsPharmacy.PharmacyType` values.\n\nDistinct from :class:`PharmacySpecialtyTypeT` — DoseSpot uses a\ndifferent (smaller) vocabulary for the pharmacy slice returned on\nrealtime-benefits responses than for channel-level eligibility.",
                                              ),
                                            zod.null(),
                                          ])
                                          .optional(),
                                        Identifications: zod
                                          .union([
                                            zod.record(
                                              zod.string(),
                                              zod.unknown(),
                                            ),
                                            zod.null(),
                                          ])
                                          .optional(),
                                        PharmacistLastName: zod
                                          .union([zod.string(), zod.null()])
                                          .optional(),
                                        PharmacistFirstName: zod
                                          .union([zod.string(), zod.null()])
                                          .optional(),
                                        PharmacistMiddleName: zod
                                          .union([zod.string(), zod.null()])
                                          .optional(),
                                        PharmacistSuffix: zod
                                          .union([zod.string(), zod.null()])
                                          .optional(),
                                        PharmacistPrefix: zod
                                          .union([zod.string(), zod.null()])
                                          .optional(),
                                        Email: zod
                                          .union([zod.string(), zod.null()])
                                          .optional(),
                                        DistanceFromRequestedPharmacy: zod
                                          .union([zod.number(), zod.null()])
                                          .optional(),
                                        PharmacyId: zod
                                          .union([zod.number(), zod.null()])
                                          .optional(),
                                        StoreName: zod
                                          .union([zod.string(), zod.null()])
                                          .optional(),
                                        Address1: zod
                                          .union([zod.string(), zod.null()])
                                          .optional(),
                                        Address2: zod
                                          .union([zod.string(), zod.null()])
                                          .optional(),
                                        City: zod
                                          .union([zod.string(), zod.null()])
                                          .optional(),
                                        State: zod
                                          .union([zod.string(), zod.null()])
                                          .optional(),
                                        ZipCode: zod
                                          .union([zod.string(), zod.null()])
                                          .optional(),
                                        PrimaryPhone: zod
                                          .union([zod.string(), zod.null()])
                                          .optional(),
                                        PrimaryPhoneType: zod
                                          .union([
                                            zod
                                              .enum([
                                                "Undefined",
                                                "Beeper",
                                                "Cell",
                                                "Fax",
                                                "Home",
                                                "Work",
                                                "Night",
                                                "Primary",
                                              ])
                                              .describe(
                                                "`PrescriptionBenefitsPharmacy.PrimaryPhoneType` \/ `PhoneAdditionalType\*` values.",
                                              ),
                                            zod.null(),
                                          ])
                                          .optional(),
                                        PrimaryFax: zod
                                          .union([zod.string(), zod.null()])
                                          .optional(),
                                        PhoneAdditional1: zod
                                          .union([zod.string(), zod.null()])
                                          .optional(),
                                        PhoneAdditionalType1: zod
                                          .union([
                                            zod
                                              .enum([
                                                "Undefined",
                                                "Beeper",
                                                "Cell",
                                                "Fax",
                                                "Home",
                                                "Work",
                                                "Night",
                                                "Primary",
                                              ])
                                              .describe(
                                                "`PrescriptionBenefitsPharmacy.PrimaryPhoneType` \/ `PhoneAdditionalType\*` values.",
                                              ),
                                            zod.null(),
                                          ])
                                          .optional(),
                                        PhoneAdditional2: zod
                                          .union([zod.string(), zod.null()])
                                          .optional(),
                                        PhoneAdditionalType2: zod
                                          .union([
                                            zod
                                              .enum([
                                                "Undefined",
                                                "Beeper",
                                                "Cell",
                                                "Fax",
                                                "Home",
                                                "Work",
                                                "Night",
                                                "Primary",
                                              ])
                                              .describe(
                                                "`PrescriptionBenefitsPharmacy.PrimaryPhoneType` \/ `PhoneAdditionalType\*` values.",
                                              ),
                                            zod.null(),
                                          ])
                                          .optional(),
                                        PhoneAdditional3: zod
                                          .union([zod.string(), zod.null()])
                                          .optional(),
                                        PhoneAdditionalType3: zod
                                          .union([
                                            zod
                                              .enum([
                                                "Undefined",
                                                "Beeper",
                                                "Cell",
                                                "Fax",
                                                "Home",
                                                "Work",
                                                "Night",
                                                "Primary",
                                              ])
                                              .describe(
                                                "`PrescriptionBenefitsPharmacy.PrimaryPhoneType` \/ `PhoneAdditionalType\*` values.",
                                              ),
                                            zod.null(),
                                          ])
                                          .optional(),
                                        PharmacySpecialties: zod
                                          .union([
                                            zod.array(zod.string()),
                                            zod.null(),
                                          ])
                                          .optional(),
                                        ServiceLevel: zod
                                          .union([zod.number(), zod.null()])
                                          .optional(),
                                        Latitude: zod
                                          .union([zod.number(), zod.null()])
                                          .optional(),
                                        Longitude: zod
                                          .union([zod.number(), zod.null()])
                                          .optional(),
                                        NCPDPID: zod
                                          .union([zod.string(), zod.null()])
                                          .optional(),
                                      })
                                      .describe(
                                        "`PrescriptionBenefitsPharmacy` — pharmacy slice on RTPB responses.\n\nNarrower-use than :class:`PharmacyT`; mirrors the full swagger shape\nso callers can surface dispensing-pharmacy details (name, address,\nNCPDPID) alongside pricing \/ PA signals from a\n``PatientSpecificPricingCoverage`` entry.",
                                      ),
                                    zod.null(),
                                  ])
                                  .optional(),
                                PricingCoverage: zod
                                  .union([
                                    zod
                                      .object({
                                        DrugStatusCode: zod
                                          .union([zod.string(), zod.null()])
                                          .optional(),
                                        DrugStatus: zod
                                          .union([zod.string(), zod.null()])
                                          .optional(),
                                        QuantityPricedValue: zod
                                          .union([zod.string(), zod.null()])
                                          .optional(),
                                        QuantityPricedCodeListQualifier: zod
                                          .union([
                                            zod
                                              .enum([
                                                "Item38",
                                                "Item40",
                                                "Item87",
                                                "QS",
                                                "CF",
                                                "UQ",
                                              ])
                                              .describe(
                                                "`PricingCoverageFactors.QuantityPricedCodeListQualifier` values.",
                                              ),
                                            zod.null(),
                                          ])
                                          .optional(),
                                        QuantityPricedUnitOfMeasureType: zod
                                          .union([zod.string(), zod.null()])
                                          .optional(),
                                        QuantityPricedUnitOfMeasureTypeId: zod
                                          .union([zod.number(), zod.null()])
                                          .optional(),
                                        DaysSupplyPriced: zod
                                          .union([zod.string(), zod.null()])
                                          .optional(),
                                        PlanPayAmount: zod
                                          .union([zod.string(), zod.null()])
                                          .optional(),
                                        EstimatedPatientPayAmount: zod
                                          .union([zod.string(), zod.null()])
                                          .optional(),
                                        OOPAppliedAmount: zod
                                          .union([zod.string(), zod.null()])
                                          .optional(),
                                        OOPRemainingAmount: zod
                                          .union([zod.string(), zod.null()])
                                          .optional(),
                                        DeductibleAppliedAmount: zod
                                          .union([zod.string(), zod.null()])
                                          .optional(),
                                        DeductibleRemainingAmount: zod
                                          .union([zod.string(), zod.null()])
                                          .optional(),
                                        CoverageAlerts: zod
                                          .union([
                                            zod.array(
                                              zod
                                                .object({
                                                  ReferenceCode: zod
                                                    .union([
                                                      zod
                                                        .enum([
                                                          "AgeLimits",
                                                          "DaysSupplyExceeded",
                                                          "DrugExclusion",
                                                          "ExcessiveUtilization",
                                                          "FullCostNotCovered",
                                                          "GenderLimits",
                                                          "MandatoryGeneric",
                                                          "MedicalNecessity",
                                                          "NotOnFormulary",
                                                          "PharmacyOutOfNetwork",
                                                          "PlanLimitExclusion",
                                                          "QuantityLimits",
                                                          "QuantityLimitExceeded",
                                                          "QuantityNotValid",
                                                          "ResourceLink",
                                                          "StepTherapy",
                                                          "TextMessage",
                                                        ])
                                                        .describe(
                                                          "`PricingCoverageFactorsCoverageAlerts.ReferenceCode` values.",
                                                        ),
                                                      zod.null(),
                                                    ])
                                                    .optional(),
                                                  ReferenceText: zod
                                                    .union([
                                                      zod.string(),
                                                      zod.null(),
                                                    ])
                                                    .optional(),
                                                })
                                                .describe(
                                                  "`PricingCoverageFactorsCoverageAlerts` entry on :class:`PricingCoverageFactorsT`.\n\nDoseSpot returns coverage-alert \*objects\* here (not plain strings):\na ``ReferenceCode`` enum plus a human-readable ``ReferenceText``.",
                                                ),
                                            ),
                                            zod.null(),
                                          ])
                                          .optional(),
                                        FormularyStatus: zod
                                          .union([zod.string(), zod.null()])
                                          .optional(),
                                        PriorAuthRequired: zod
                                          .union([zod.boolean(), zod.null()])
                                          .optional(),
                                      })
                                      .describe(
                                        "`PricingCoverageFactors` — `PricingCoverage` sub-object on RTPB.\n\nThe realtime gate's authoritative PA source: ``PriorAuthRequired=true``\non any pharmacy-specific pricing coverage flips the gate to\n:attr:`PA_REQUIRED`. Pricing fields are kept for downstream UI — they\nare not consulted by the gate but are cheap to carry.",
                                      ),
                                    zod.null(),
                                  ])
                                  .optional(),
                              })
                              .describe(
                                "`PatientSpecificPricingCoverage` — one (pharmacy × coverage) pricing row.\n\nA coverage can yield multiple entries — one per pharmacy the payer\npriced against — so the gate has to OR the ``PriorAuthRequired`` bits\nacross the list to get a conservative answer.",
                              ),
                          ),
                          zod.null(),
                        ])
                        .optional(),
                    })
                    .describe(
                      "`PayerAlternativeAPI` — payer-preferred alternative for an NDC.\n\nSurfaced alongside a gate decision of :attr:`EXCLUDED` or\n:attr:`PA_REQUIRED` so the clinician can rewrite to a preferred drug\ninstead of fighting a PA. Returned both on the formulary response\n(``MedicationCoverageResponse.Alternatives``) and on the RTPB\nresponse (``GetPrescriptionBenefitResponse.Alternatives``).",
                    ),
                ),
                zod.null(),
              ])
              .optional(),
            TherapeuticAlternatives: zod
              .union([
                zod.array(
                  zod
                    .object({
                      Ndc: zod.union([zod.string(), zod.null()]).optional(),
                      FormularyStatus: zod
                        .union([zod.string(), zod.null()])
                        .optional(),
                      Copay: zod
                        .union([
                          zod
                            .object({
                              IsDrugSpecific: zod
                                .union([zod.boolean(), zod.null()])
                                .optional(),
                              PharmacyType: zod
                                .union([
                                  zod
                                    .enum([
                                      "Any",
                                      "FaxPharmacy",
                                      "EPCS",
                                      "TwentyFourHourPharmacy",
                                      "LongTermCarePharmacy",
                                      "MailOrder",
                                      "Retail",
                                      "SpecialtyPharmacy",
                                    ])
                                    .describe(
                                      "Valid pharmacy specialty types for DoseSpot.",
                                    ),
                                  zod.null(),
                                ])
                                .optional(),
                              FlatCopayAmount: zod
                                .union([zod.number(), zod.null()])
                                .optional(),
                              PercentCopayAmount: zod
                                .union([zod.number(), zod.null()])
                                .optional(),
                              FlatCopayAmountFirst: zod
                                .union([zod.boolean(), zod.null()])
                                .optional(),
                              MinimumCopayAmount: zod
                                .union([zod.number(), zod.null()])
                                .optional(),
                              MaximumCopayAmount: zod
                                .union([zod.number(), zod.null()])
                                .optional(),
                              DaysSupply: zod
                                .union([zod.number(), zod.null()])
                                .optional(),
                              CopayTier: zod
                                .union([zod.number(), zod.null()])
                                .optional(),
                              MaximumCopayTier: zod
                                .union([zod.number(), zod.null()])
                                .optional(),
                              OutOfPocketMinimum: zod
                                .union([zod.number(), zod.null()])
                                .optional(),
                              OutOfPocketMaximum: zod
                                .union([zod.number(), zod.null()])
                                .optional(),
                            })
                            .describe(
                              "Single copay tier (`PayerCopay`).\n\nPer-channel pricing rule returned on formulary responses and on the\n``RepresentitiveFormularyCoverage`` slice of each alternative. The\ngate doesn't consult any of these fields directly — they're carried\nthrough for UI display next to an ``EXCLUDED`` \/ ``PA_REQUIRED``\nbanner.",
                            ),
                          zod.null(),
                        ])
                        .optional(),
                      DisplayName: zod
                        .union([zod.string(), zod.null()])
                        .optional(),
                      FormularyInfo: zod
                        .union([
                          zod
                            .object({
                              ProductId: zod
                                .union([zod.number(), zod.null()])
                                .optional(),
                              Ndc: zod
                                .union([zod.string(), zod.null()])
                                .optional(),
                              FormularyStatusId: zod
                                .union([zod.number(), zod.null()])
                                .optional(),
                              FormularyAbbreviation: zod
                                .union([zod.string(), zod.null()])
                                .optional(),
                              FormularyStatusMessage: zod
                                .union([zod.string(), zod.null()])
                                .optional(),
                              OrderRank: zod
                                .union([zod.number(), zod.null()])
                                .optional(),
                              IsGeneric: zod
                                .union([zod.boolean(), zod.null()])
                                .optional(),
                              IsRx: zod
                                .union([zod.boolean(), zod.null()])
                                .optional(),
                            })
                            .describe(
                              "`FormularyInfo` nested on :class:`TherapeuticAlternativesT`.",
                            ),
                          zod.null(),
                        ])
                        .optional(),
                      FullDisplayString: zod
                        .union([zod.string(), zod.null()])
                        .optional(),
                      DisplayStrength: zod
                        .union([zod.string(), zod.null()])
                        .optional(),
                      DefaultDispenseUnitID: zod
                        .union([zod.number(), zod.null()])
                        .optional(),
                      DispensableDrugId: zod
                        .union([zod.number(), zod.null()])
                        .optional(),
                      Schedule: zod
                        .union([zod.number(), zod.null()])
                        .optional(),
                      IsDetox: zod
                        .union([zod.boolean(), zod.null()])
                        .optional(),
                      HasGHB: zod.union([zod.boolean(), zod.null()]).optional(),
                      RxCUI: zod.union([zod.number(), zod.null()]).optional(),
                    })
                    .describe(
                      "`TherapeuticAlternatives` entry on a formulary response.\n\nV2 replaces the v1 ``\/therapeuticAlternatives`` endpoint with a\n``TherapeuticAlternatives`` list returned inline on the formulary\nresponse. Surfaced alongside :attr:`EXCLUDED` \/ :attr:`PA_REQUIRED`\noutcomes so the clinician can rewrite to a preferred drug without a\nsecond round trip.",
                    ),
                ),
                zod.null(),
              ])
              .optional(),
            Restrictions: zod
              .union([
                zod
                  .object({
                    IsExcluded: zod
                      .union([zod.boolean(), zod.null()])
                      .optional(),
                    HasMedicalNecessity: zod
                      .union([zod.boolean(), zod.null()])
                      .optional(),
                    HasPriorAuthorization: zod
                      .union([zod.boolean(), zod.null()])
                      .optional(),
                    HasStepTherapy: zod
                      .union([zod.boolean(), zod.null()])
                      .optional(),
                    HasQuantityLimit: zod
                      .union([zod.boolean(), zod.null()])
                      .optional(),
                    HasAgeLimit: zod
                      .union([zod.boolean(), zod.null()])
                      .optional(),
                    AgeLimitRestrictions: zod
                      .union([
                        zod.array(
                          zod
                            .object({
                              MinimumAge: zod
                                .union([zod.number(), zod.null()])
                                .optional(),
                              MinimumAgeUnit: zod
                                .union([
                                  zod
                                    .enum(["Days", "Years"])
                                    .describe(
                                      "Unit on :class:`AgeLimitRestrictionT` bounds.",
                                    ),
                                  zod.null(),
                                ])
                                .optional(),
                              MaximumAge: zod
                                .union([zod.number(), zod.null()])
                                .optional(),
                              MaximumAgeUnit: zod
                                .union([
                                  zod
                                    .enum(["Days", "Years"])
                                    .describe(
                                      "Unit on :class:`AgeLimitRestrictionT` bounds.",
                                    ),
                                  zod.null(),
                                ])
                                .optional(),
                            })
                            .describe(
                              "`AgeLimitRestriction` entry on a `CoverageRestrictions`.",
                            ),
                        ),
                        zod.null(),
                      ])
                      .optional(),
                    GenderRestriction: zod
                      .union([
                        zod
                          .enum(["Male", "Female", "Unknown"])
                          .describe(
                            "`PayerDemographics.Gender` and `CoverageRestrictions.GenderRestriction` values.",
                          ),
                        zod.null(),
                      ])
                      .optional(),
                    QuantityLimitRestrictions: zod
                      .union([
                        zod.array(
                          zod
                            .object({
                              MaximumAmount: zod
                                .union([zod.number(), zod.null()])
                                .optional(),
                              AmountUnit: zod
                                .union([
                                  zod
                                    .enum([
                                      "DollarAmount",
                                      "DaysSupply",
                                      "Fills",
                                      "Quantity",
                                    ])
                                    .describe(
                                      "`QuantityLimitRestriction.AmountUnit` values.",
                                    ),
                                  zod.null(),
                                ])
                                .optional(),
                              TimePeriodUnit: zod
                                .union([
                                  zod
                                    .enum([
                                      "Days",
                                      "Lifetime",
                                      "PerDispensing",
                                      "SpecificDateRange",
                                      "CalendarYear",
                                      "CalendarQuarter",
                                      "CalendarMonth",
                                    ])
                                    .describe(
                                      "`QuantityLimitRestriction.TimePeriodUnit` values.",
                                    ),
                                  zod.null(),
                                ])
                                .optional(),
                              StartDate: zod
                                .union([zod.string(), zod.null()])
                                .optional(),
                              EndDate: zod
                                .union([zod.string(), zod.null()])
                                .optional(),
                              MaximumTimePeriodUnits: zod
                                .union([zod.number(), zod.null()])
                                .optional(),
                            })
                            .describe(
                              "`QuantityLimitRestriction` entry on a `CoverageRestrictions`.",
                            ),
                        ),
                        zod.null(),
                      ])
                      .optional(),
                    StepMedicationRestrictions: zod
                      .union([
                        zod.array(
                          zod
                            .object({
                              Ndc: zod
                                .union([zod.string(), zod.null()])
                                .optional(),
                              StepDrugType: zod
                                .union([
                                  zod
                                    .enum([
                                      "Unknown",
                                      "SpecificMedication",
                                      "PharmacologicalClass",
                                    ])
                                    .describe(
                                      "`StepMedicationRestriction.StepDrugType` values.",
                                    ),
                                  zod.null(),
                                ])
                                .optional(),
                              StepOrder: zod
                                .union([zod.number(), zod.null()])
                                .optional(),
                              DisplayName: zod
                                .union([zod.string(), zod.null()])
                                .optional(),
                              RxCUI: zod
                                .union([zod.number(), zod.null()])
                                .optional(),
                              DispensableDrugId: zod
                                .union([zod.number(), zod.null()])
                                .optional(),
                            })
                            .describe(
                              "`StepMedicationRestriction` entry on a `CoverageRestrictions`.",
                            ),
                        ),
                        zod.null(),
                      ])
                      .optional(),
                    Messages: zod
                      .union([
                        zod.array(
                          zod
                            .object({
                              Message: zod
                                .union([zod.string(), zod.null()])
                                .optional(),
                              LongMessage: zod
                                .union([zod.string(), zod.null()])
                                .optional(),
                            })
                            .describe(
                              "`CoverageMessage` entry on a `CoverageRestrictions`.",
                            ),
                        ),
                        zod.null(),
                      ])
                      .optional(),
                    DrugResources: zod
                      .union([
                        zod.array(
                          zod
                            .object({
                              Url: zod
                                .union([zod.string(), zod.null()])
                                .optional(),
                              ResourceType: zod
                                .union([
                                  zod
                                    .enum([
                                      "AgeLimits",
                                      "ProductCoverageExclusion",
                                      "GenderLimits",
                                      "MedicalNecessity",
                                      "PriorAuthorization",
                                      "QuantityLimits",
                                      "StepTherapy",
                                      "General",
                                      "Copay",
                                      "Formulary",
                                    ])
                                    .describe(
                                      "`CoverageResource.ResourceType` values.",
                                    ),
                                  zod.null(),
                                ])
                                .optional(),
                            })
                            .describe(
                              "`CoverageResource` entry on a `CoverageRestrictions`.",
                            ),
                        ),
                        zod.null(),
                      ])
                      .optional(),
                    SummaryResources: zod
                      .union([
                        zod.array(
                          zod
                            .object({
                              Url: zod
                                .union([zod.string(), zod.null()])
                                .optional(),
                              ResourceType: zod
                                .union([
                                  zod
                                    .enum([
                                      "AgeLimits",
                                      "ProductCoverageExclusion",
                                      "GenderLimits",
                                      "MedicalNecessity",
                                      "PriorAuthorization",
                                      "QuantityLimits",
                                      "StepTherapy",
                                      "General",
                                      "Copay",
                                      "Formulary",
                                    ])
                                    .describe(
                                      "`CoverageResource.ResourceType` values.",
                                    ),
                                  zod.null(),
                                ])
                                .optional(),
                            })
                            .describe(
                              "`CoverageResource` entry on a `CoverageRestrictions`.",
                            ),
                        ),
                        zod.null(),
                      ])
                      .optional(),
                  })
                  .describe(
                    "Coverage restrictions on the primary drug (`CoverageRestrictions`).\n\n``HasPriorAuthorization`` is the primary bit the gate consults when\n`\/prescriptionbenefits` is unavailable. ``IsExcluded`` shortcuts to\nthe `EXCLUDED` gate outcome: no point initiating a PA for a drug the\npayer will never cover.\n\nField-name alignment with the v2 swagger: ``HasAgeLimit`` \/\n``HasQuantityLimit`` are singular here (not plural as on\n:class:`RealTimeFormularyCoverageRestrictionsT`); there is no\n``HasGenderLimit`` — use ``GenderRestriction`` for that.",
                  ),
                zod.null(),
              ])
              .optional(),
            RealTimeFormularyRequestStatus: zod
              .union([zod.number(), zod.null()])
              .optional(),
          })
          .describe(
            "`MedicationCoverageResponse` — inner item of ``ItemResponse[…]`` on\n``GET \/api\/patients\/{patient_id}\/formulary``.\n\nRetained under the historical ``FormularyResponseT`` name so in-repo\ncallers don't need to rename types; the shape is now the v2 swagger's\nunwrapped `Item` (see :class:`FormularyItemResponseT` for the wire-\nlevel wrapper).\n\nKey fields for the gate:\n\n- ``Restrictions.HasPriorAuthorization`` — cached-formulary PA bit.\n- ``Restrictions.IsExcluded`` — drug is flatly not covered; maps to\n  the :attr:`EXCLUDED` gate outcome.\n- ``RealTimeFormularyRequestStatus`` — non-OK here means \"realtime\n  call didn't land\"; the gate falls back to the cached slice before\n  declaring :attr:`UNKNOWN`.\n\nNotably absent: ``PatientEligibilityId`` \/ ``NDC`` \/ ``DrugName``.\nV2's `MedicationCoverageResponse` does not echo the request context\nback; the gate tracks that out-of-band.",
          ),
        zod.null(),
      ])
      .optional(),
    benefits: zod
      .union([
        zod
          .object({
            PatientFormularyId: zod
              .union([zod.number(), zod.null()])
              .optional(),
            Brand: zod.union([zod.boolean(), zod.null()]).optional(),
            Otc: zod.union([zod.boolean(), zod.null()]).optional(),
            Alternatives: zod
              .union([
                zod.array(
                  zod
                    .object({
                      Ndc: zod.union([zod.string(), zod.null()]).optional(),
                      DisplayName: zod
                        .union([zod.string(), zod.null()])
                        .optional(),
                      RxCUI: zod.union([zod.number(), zod.null()]).optional(),
                      DispensableDrugId: zod
                        .union([zod.number(), zod.null()])
                        .optional(),
                      Brand: zod.union([zod.boolean(), zod.null()]).optional(),
                      Otc: zod.union([zod.boolean(), zod.null()]).optional(),
                      Details: zod
                        .union([
                          zod.array(
                            zod
                              .object({
                                PatientSpecificPricingCoverages: zod
                                  .union([
                                    zod.array(
                                      zod
                                        .object({
                                          Pharmacy: zod
                                            .union([
                                              zod
                                                .object({
                                                  PharmacyType: zod
                                                    .union([
                                                      zod
                                                        .enum([
                                                          "Retail",
                                                          "Mail",
                                                          "Item90DayAtRetail",
                                                          "Specialty",
                                                          "LongTermCare",
                                                        ])
                                                        .describe(
                                                          "`PrescriptionBenefitsPharmacy.PharmacyType` values.\n\nDistinct from :class:`PharmacySpecialtyTypeT` — DoseSpot uses a\ndifferent (smaller) vocabulary for the pharmacy slice returned on\nrealtime-benefits responses than for channel-level eligibility.",
                                                        ),
                                                      zod.null(),
                                                    ])
                                                    .optional(),
                                                  Identifications: zod
                                                    .union([
                                                      zod.record(
                                                        zod.string(),
                                                        zod.unknown(),
                                                      ),
                                                      zod.null(),
                                                    ])
                                                    .optional(),
                                                  PharmacistLastName: zod
                                                    .union([
                                                      zod.string(),
                                                      zod.null(),
                                                    ])
                                                    .optional(),
                                                  PharmacistFirstName: zod
                                                    .union([
                                                      zod.string(),
                                                      zod.null(),
                                                    ])
                                                    .optional(),
                                                  PharmacistMiddleName: zod
                                                    .union([
                                                      zod.string(),
                                                      zod.null(),
                                                    ])
                                                    .optional(),
                                                  PharmacistSuffix: zod
                                                    .union([
                                                      zod.string(),
                                                      zod.null(),
                                                    ])
                                                    .optional(),
                                                  PharmacistPrefix: zod
                                                    .union([
                                                      zod.string(),
                                                      zod.null(),
                                                    ])
                                                    .optional(),
                                                  Email: zod
                                                    .union([
                                                      zod.string(),
                                                      zod.null(),
                                                    ])
                                                    .optional(),
                                                  DistanceFromRequestedPharmacy:
                                                    zod
                                                      .union([
                                                        zod.number(),
                                                        zod.null(),
                                                      ])
                                                      .optional(),
                                                  PharmacyId: zod
                                                    .union([
                                                      zod.number(),
                                                      zod.null(),
                                                    ])
                                                    .optional(),
                                                  StoreName: zod
                                                    .union([
                                                      zod.string(),
                                                      zod.null(),
                                                    ])
                                                    .optional(),
                                                  Address1: zod
                                                    .union([
                                                      zod.string(),
                                                      zod.null(),
                                                    ])
                                                    .optional(),
                                                  Address2: zod
                                                    .union([
                                                      zod.string(),
                                                      zod.null(),
                                                    ])
                                                    .optional(),
                                                  City: zod
                                                    .union([
                                                      zod.string(),
                                                      zod.null(),
                                                    ])
                                                    .optional(),
                                                  State: zod
                                                    .union([
                                                      zod.string(),
                                                      zod.null(),
                                                    ])
                                                    .optional(),
                                                  ZipCode: zod
                                                    .union([
                                                      zod.string(),
                                                      zod.null(),
                                                    ])
                                                    .optional(),
                                                  PrimaryPhone: zod
                                                    .union([
                                                      zod.string(),
                                                      zod.null(),
                                                    ])
                                                    .optional(),
                                                  PrimaryPhoneType: zod
                                                    .union([
                                                      zod
                                                        .enum([
                                                          "Undefined",
                                                          "Beeper",
                                                          "Cell",
                                                          "Fax",
                                                          "Home",
                                                          "Work",
                                                          "Night",
                                                          "Primary",
                                                        ])
                                                        .describe(
                                                          "`PrescriptionBenefitsPharmacy.PrimaryPhoneType` \/ `PhoneAdditionalType\*` values.",
                                                        ),
                                                      zod.null(),
                                                    ])
                                                    .optional(),
                                                  PrimaryFax: zod
                                                    .union([
                                                      zod.string(),
                                                      zod.null(),
                                                    ])
                                                    .optional(),
                                                  PhoneAdditional1: zod
                                                    .union([
                                                      zod.string(),
                                                      zod.null(),
                                                    ])
                                                    .optional(),
                                                  PhoneAdditionalType1: zod
                                                    .union([
                                                      zod
                                                        .enum([
                                                          "Undefined",
                                                          "Beeper",
                                                          "Cell",
                                                          "Fax",
                                                          "Home",
                                                          "Work",
                                                          "Night",
                                                          "Primary",
                                                        ])
                                                        .describe(
                                                          "`PrescriptionBenefitsPharmacy.PrimaryPhoneType` \/ `PhoneAdditionalType\*` values.",
                                                        ),
                                                      zod.null(),
                                                    ])
                                                    .optional(),
                                                  PhoneAdditional2: zod
                                                    .union([
                                                      zod.string(),
                                                      zod.null(),
                                                    ])
                                                    .optional(),
                                                  PhoneAdditionalType2: zod
                                                    .union([
                                                      zod
                                                        .enum([
                                                          "Undefined",
                                                          "Beeper",
                                                          "Cell",
                                                          "Fax",
                                                          "Home",
                                                          "Work",
                                                          "Night",
                                                          "Primary",
                                                        ])
                                                        .describe(
                                                          "`PrescriptionBenefitsPharmacy.PrimaryPhoneType` \/ `PhoneAdditionalType\*` values.",
                                                        ),
                                                      zod.null(),
                                                    ])
                                                    .optional(),
                                                  PhoneAdditional3: zod
                                                    .union([
                                                      zod.string(),
                                                      zod.null(),
                                                    ])
                                                    .optional(),
                                                  PhoneAdditionalType3: zod
                                                    .union([
                                                      zod
                                                        .enum([
                                                          "Undefined",
                                                          "Beeper",
                                                          "Cell",
                                                          "Fax",
                                                          "Home",
                                                          "Work",
                                                          "Night",
                                                          "Primary",
                                                        ])
                                                        .describe(
                                                          "`PrescriptionBenefitsPharmacy.PrimaryPhoneType` \/ `PhoneAdditionalType\*` values.",
                                                        ),
                                                      zod.null(),
                                                    ])
                                                    .optional(),
                                                  PharmacySpecialties: zod
                                                    .union([
                                                      zod.array(zod.string()),
                                                      zod.null(),
                                                    ])
                                                    .optional(),
                                                  ServiceLevel: zod
                                                    .union([
                                                      zod.number(),
                                                      zod.null(),
                                                    ])
                                                    .optional(),
                                                  Latitude: zod
                                                    .union([
                                                      zod.number(),
                                                      zod.null(),
                                                    ])
                                                    .optional(),
                                                  Longitude: zod
                                                    .union([
                                                      zod.number(),
                                                      zod.null(),
                                                    ])
                                                    .optional(),
                                                  NCPDPID: zod
                                                    .union([
                                                      zod.string(),
                                                      zod.null(),
                                                    ])
                                                    .optional(),
                                                })
                                                .describe(
                                                  "`PrescriptionBenefitsPharmacy` — pharmacy slice on RTPB responses.\n\nNarrower-use than :class:`PharmacyT`; mirrors the full swagger shape\nso callers can surface dispensing-pharmacy details (name, address,\nNCPDPID) alongside pricing \/ PA signals from a\n``PatientSpecificPricingCoverage`` entry.",
                                                ),
                                              zod.null(),
                                            ])
                                            .optional(),
                                          PricingCoverage: zod
                                            .union([
                                              zod
                                                .object({
                                                  DrugStatusCode: zod
                                                    .union([
                                                      zod.string(),
                                                      zod.null(),
                                                    ])
                                                    .optional(),
                                                  DrugStatus: zod
                                                    .union([
                                                      zod.string(),
                                                      zod.null(),
                                                    ])
                                                    .optional(),
                                                  QuantityPricedValue: zod
                                                    .union([
                                                      zod.string(),
                                                      zod.null(),
                                                    ])
                                                    .optional(),
                                                  QuantityPricedCodeListQualifier:
                                                    zod
                                                      .union([
                                                        zod
                                                          .enum([
                                                            "Item38",
                                                            "Item40",
                                                            "Item87",
                                                            "QS",
                                                            "CF",
                                                            "UQ",
                                                          ])
                                                          .describe(
                                                            "`PricingCoverageFactors.QuantityPricedCodeListQualifier` values.",
                                                          ),
                                                        zod.null(),
                                                      ])
                                                      .optional(),
                                                  QuantityPricedUnitOfMeasureType:
                                                    zod
                                                      .union([
                                                        zod.string(),
                                                        zod.null(),
                                                      ])
                                                      .optional(),
                                                  QuantityPricedUnitOfMeasureTypeId:
                                                    zod
                                                      .union([
                                                        zod.number(),
                                                        zod.null(),
                                                      ])
                                                      .optional(),
                                                  DaysSupplyPriced: zod
                                                    .union([
                                                      zod.string(),
                                                      zod.null(),
                                                    ])
                                                    .optional(),
                                                  PlanPayAmount: zod
                                                    .union([
                                                      zod.string(),
                                                      zod.null(),
                                                    ])
                                                    .optional(),
                                                  EstimatedPatientPayAmount: zod
                                                    .union([
                                                      zod.string(),
                                                      zod.null(),
                                                    ])
                                                    .optional(),
                                                  OOPAppliedAmount: zod
                                                    .union([
                                                      zod.string(),
                                                      zod.null(),
                                                    ])
                                                    .optional(),
                                                  OOPRemainingAmount: zod
                                                    .union([
                                                      zod.string(),
                                                      zod.null(),
                                                    ])
                                                    .optional(),
                                                  DeductibleAppliedAmount: zod
                                                    .union([
                                                      zod.string(),
                                                      zod.null(),
                                                    ])
                                                    .optional(),
                                                  DeductibleRemainingAmount: zod
                                                    .union([
                                                      zod.string(),
                                                      zod.null(),
                                                    ])
                                                    .optional(),
                                                  CoverageAlerts: zod
                                                    .union([
                                                      zod.array(
                                                        zod
                                                          .object({
                                                            ReferenceCode: zod
                                                              .union([
                                                                zod
                                                                  .enum([
                                                                    "AgeLimits",
                                                                    "DaysSupplyExceeded",
                                                                    "DrugExclusion",
                                                                    "ExcessiveUtilization",
                                                                    "FullCostNotCovered",
                                                                    "GenderLimits",
                                                                    "MandatoryGeneric",
                                                                    "MedicalNecessity",
                                                                    "NotOnFormulary",
                                                                    "PharmacyOutOfNetwork",
                                                                    "PlanLimitExclusion",
                                                                    "QuantityLimits",
                                                                    "QuantityLimitExceeded",
                                                                    "QuantityNotValid",
                                                                    "ResourceLink",
                                                                    "StepTherapy",
                                                                    "TextMessage",
                                                                  ])
                                                                  .describe(
                                                                    "`PricingCoverageFactorsCoverageAlerts.ReferenceCode` values.",
                                                                  ),
                                                                zod.null(),
                                                              ])
                                                              .optional(),
                                                            ReferenceText: zod
                                                              .union([
                                                                zod.string(),
                                                                zod.null(),
                                                              ])
                                                              .optional(),
                                                          })
                                                          .describe(
                                                            "`PricingCoverageFactorsCoverageAlerts` entry on :class:`PricingCoverageFactorsT`.\n\nDoseSpot returns coverage-alert \*objects\* here (not plain strings):\na ``ReferenceCode`` enum plus a human-readable ``ReferenceText``.",
                                                          ),
                                                      ),
                                                      zod.null(),
                                                    ])
                                                    .optional(),
                                                  FormularyStatus: zod
                                                    .union([
                                                      zod.string(),
                                                      zod.null(),
                                                    ])
                                                    .optional(),
                                                  PriorAuthRequired: zod
                                                    .union([
                                                      zod.boolean(),
                                                      zod.null(),
                                                    ])
                                                    .optional(),
                                                })
                                                .describe(
                                                  "`PricingCoverageFactors` — `PricingCoverage` sub-object on RTPB.\n\nThe realtime gate's authoritative PA source: ``PriorAuthRequired=true``\non any pharmacy-specific pricing coverage flips the gate to\n:attr:`PA_REQUIRED`. Pricing fields are kept for downstream UI — they\nare not consulted by the gate but are cheap to carry.",
                                                ),
                                              zod.null(),
                                            ])
                                            .optional(),
                                        })
                                        .describe(
                                          "`PatientSpecificPricingCoverage` — one (pharmacy × coverage) pricing row.\n\nA coverage can yield multiple entries — one per pharmacy the payer\npriced against — so the gate has to OR the ``PriorAuthRequired`` bits\nacross the list to get a conservative answer.",
                                        ),
                                    ),
                                    zod.null(),
                                  ])
                                  .optional(),
                                Ndc: zod
                                  .union([zod.string(), zod.null()])
                                  .optional(),
                                DisplayName: zod
                                  .union([zod.string(), zod.null()])
                                  .optional(),
                                RxCUI: zod
                                  .union([zod.number(), zod.null()])
                                  .optional(),
                                DispensableDrugId: zod
                                  .union([zod.number(), zod.null()])
                                  .optional(),
                                Coverage: zod
                                  .union([
                                    zod
                                      .object({
                                        FormularyStatus: zod
                                          .union([zod.string(), zod.null()])
                                          .optional(),
                                        Copays: zod
                                          .union([
                                            zod.array(
                                              zod
                                                .object({
                                                  IsDrugSpecific: zod
                                                    .union([
                                                      zod.boolean(),
                                                      zod.null(),
                                                    ])
                                                    .optional(),
                                                  PharmacyType: zod
                                                    .union([
                                                      zod
                                                        .enum([
                                                          "Any",
                                                          "FaxPharmacy",
                                                          "EPCS",
                                                          "TwentyFourHourPharmacy",
                                                          "LongTermCarePharmacy",
                                                          "MailOrder",
                                                          "Retail",
                                                          "SpecialtyPharmacy",
                                                        ])
                                                        .describe(
                                                          "Valid pharmacy specialty types for DoseSpot.",
                                                        ),
                                                      zod.null(),
                                                    ])
                                                    .optional(),
                                                  FlatCopayAmount: zod
                                                    .union([
                                                      zod.number(),
                                                      zod.null(),
                                                    ])
                                                    .optional(),
                                                  PercentCopayAmount: zod
                                                    .union([
                                                      zod.number(),
                                                      zod.null(),
                                                    ])
                                                    .optional(),
                                                  FlatCopayAmountFirst: zod
                                                    .union([
                                                      zod.boolean(),
                                                      zod.null(),
                                                    ])
                                                    .optional(),
                                                  MinimumCopayAmount: zod
                                                    .union([
                                                      zod.number(),
                                                      zod.null(),
                                                    ])
                                                    .optional(),
                                                  MaximumCopayAmount: zod
                                                    .union([
                                                      zod.number(),
                                                      zod.null(),
                                                    ])
                                                    .optional(),
                                                  DaysSupply: zod
                                                    .union([
                                                      zod.number(),
                                                      zod.null(),
                                                    ])
                                                    .optional(),
                                                  CopayTier: zod
                                                    .union([
                                                      zod.number(),
                                                      zod.null(),
                                                    ])
                                                    .optional(),
                                                  MaximumCopayTier: zod
                                                    .union([
                                                      zod.number(),
                                                      zod.null(),
                                                    ])
                                                    .optional(),
                                                  OutOfPocketMinimum: zod
                                                    .union([
                                                      zod.number(),
                                                      zod.null(),
                                                    ])
                                                    .optional(),
                                                  OutOfPocketMaximum: zod
                                                    .union([
                                                      zod.number(),
                                                      zod.null(),
                                                    ])
                                                    .optional(),
                                                })
                                                .describe(
                                                  "Single copay tier (`PayerCopay`).\n\nPer-channel pricing rule returned on formulary responses and on the\n``RepresentitiveFormularyCoverage`` slice of each alternative. The\ngate doesn't consult any of these fields directly — they're carried\nthrough for UI display next to an ``EXCLUDED`` \/ ``PA_REQUIRED``\nbanner.",
                                                ),
                                            ),
                                            zod.null(),
                                          ])
                                          .optional(),
                                        Alternatives: zod
                                          .union([
                                            zod.array(
                                              zod
                                                .object({
                                                  Ndc: zod
                                                    .union([
                                                      zod.string(),
                                                      zod.null(),
                                                    ])
                                                    .optional(),
                                                  Details: zod
                                                    .union([
                                                      zod.array(
                                                        zod
                                                          .object({
                                                            Ndc: zod
                                                              .union([
                                                                zod.string(),
                                                                zod.null(),
                                                              ])
                                                              .optional(),
                                                            Coverage: zod
                                                              .union([
                                                                zod.unknown(),
                                                                zod.null(),
                                                              ])
                                                              .optional(),
                                                          })
                                                          .describe(
                                                            "`PayerAlternativeDetail` — one detail under :class:`PayerAlternativeSimpleT`.",
                                                          ),
                                                      ),
                                                      zod.null(),
                                                    ])
                                                    .optional(),
                                                })
                                                .describe(
                                                  "`PayerAlternative` — the narrower alternative shape nested in :class:`MedicationCoverageT`.\n\nPer v2 swagger, nested alternatives (alternatives of alternatives) only\ncarry ``Ndc`` and a ``Details`` list, not the full\n:class:`PayerAlternativeT` payload.",
                                                ),
                                            ),
                                            zod.null(),
                                          ])
                                          .optional(),
                                        Restrictions: zod
                                          .union([
                                            zod
                                              .object({
                                                IsExcluded: zod
                                                  .union([
                                                    zod.boolean(),
                                                    zod.null(),
                                                  ])
                                                  .optional(),
                                                HasMedicalNecessity: zod
                                                  .union([
                                                    zod.boolean(),
                                                    zod.null(),
                                                  ])
                                                  .optional(),
                                                HasPriorAuthorization: zod
                                                  .union([
                                                    zod.boolean(),
                                                    zod.null(),
                                                  ])
                                                  .optional(),
                                                HasStepTherapy: zod
                                                  .union([
                                                    zod.boolean(),
                                                    zod.null(),
                                                  ])
                                                  .optional(),
                                                HasQuantityLimit: zod
                                                  .union([
                                                    zod.boolean(),
                                                    zod.null(),
                                                  ])
                                                  .optional(),
                                                HasAgeLimit: zod
                                                  .union([
                                                    zod.boolean(),
                                                    zod.null(),
                                                  ])
                                                  .optional(),
                                                AgeLimitRestrictions: zod
                                                  .union([
                                                    zod.array(
                                                      zod
                                                        .object({
                                                          MinimumAge: zod
                                                            .union([
                                                              zod.number(),
                                                              zod.null(),
                                                            ])
                                                            .optional(),
                                                          MinimumAgeUnit: zod
                                                            .union([
                                                              zod
                                                                .enum([
                                                                  "Days",
                                                                  "Years",
                                                                ])
                                                                .describe(
                                                                  "Unit on :class:`AgeLimitRestrictionT` bounds.",
                                                                ),
                                                              zod.null(),
                                                            ])
                                                            .optional(),
                                                          MaximumAge: zod
                                                            .union([
                                                              zod.number(),
                                                              zod.null(),
                                                            ])
                                                            .optional(),
                                                          MaximumAgeUnit: zod
                                                            .union([
                                                              zod
                                                                .enum([
                                                                  "Days",
                                                                  "Years",
                                                                ])
                                                                .describe(
                                                                  "Unit on :class:`AgeLimitRestrictionT` bounds.",
                                                                ),
                                                              zod.null(),
                                                            ])
                                                            .optional(),
                                                        })
                                                        .describe(
                                                          "`AgeLimitRestriction` entry on a `CoverageRestrictions`.",
                                                        ),
                                                    ),
                                                    zod.null(),
                                                  ])
                                                  .optional(),
                                                GenderRestriction: zod
                                                  .union([
                                                    zod
                                                      .enum([
                                                        "Male",
                                                        "Female",
                                                        "Unknown",
                                                      ])
                                                      .describe(
                                                        "`PayerDemographics.Gender` and `CoverageRestrictions.GenderRestriction` values.",
                                                      ),
                                                    zod.null(),
                                                  ])
                                                  .optional(),
                                                QuantityLimitRestrictions: zod
                                                  .union([
                                                    zod.array(
                                                      zod
                                                        .object({
                                                          MaximumAmount: zod
                                                            .union([
                                                              zod.number(),
                                                              zod.null(),
                                                            ])
                                                            .optional(),
                                                          AmountUnit: zod
                                                            .union([
                                                              zod
                                                                .enum([
                                                                  "DollarAmount",
                                                                  "DaysSupply",
                                                                  "Fills",
                                                                  "Quantity",
                                                                ])
                                                                .describe(
                                                                  "`QuantityLimitRestriction.AmountUnit` values.",
                                                                ),
                                                              zod.null(),
                                                            ])
                                                            .optional(),
                                                          TimePeriodUnit: zod
                                                            .union([
                                                              zod
                                                                .enum([
                                                                  "Days",
                                                                  "Lifetime",
                                                                  "PerDispensing",
                                                                  "SpecificDateRange",
                                                                  "CalendarYear",
                                                                  "CalendarQuarter",
                                                                  "CalendarMonth",
                                                                ])
                                                                .describe(
                                                                  "`QuantityLimitRestriction.TimePeriodUnit` values.",
                                                                ),
                                                              zod.null(),
                                                            ])
                                                            .optional(),
                                                          StartDate: zod
                                                            .union([
                                                              zod.string(),
                                                              zod.null(),
                                                            ])
                                                            .optional(),
                                                          EndDate: zod
                                                            .union([
                                                              zod.string(),
                                                              zod.null(),
                                                            ])
                                                            .optional(),
                                                          MaximumTimePeriodUnits:
                                                            zod
                                                              .union([
                                                                zod.number(),
                                                                zod.null(),
                                                              ])
                                                              .optional(),
                                                        })
                                                        .describe(
                                                          "`QuantityLimitRestriction` entry on a `CoverageRestrictions`.",
                                                        ),
                                                    ),
                                                    zod.null(),
                                                  ])
                                                  .optional(),
                                                StepMedicationRestrictions: zod
                                                  .union([
                                                    zod.array(
                                                      zod
                                                        .object({
                                                          Ndc: zod
                                                            .union([
                                                              zod.string(),
                                                              zod.null(),
                                                            ])
                                                            .optional(),
                                                          StepDrugType: zod
                                                            .union([
                                                              zod
                                                                .enum([
                                                                  "Unknown",
                                                                  "SpecificMedication",
                                                                  "PharmacologicalClass",
                                                                ])
                                                                .describe(
                                                                  "`StepMedicationRestriction.StepDrugType` values.",
                                                                ),
                                                              zod.null(),
                                                            ])
                                                            .optional(),
                                                          StepOrder: zod
                                                            .union([
                                                              zod.number(),
                                                              zod.null(),
                                                            ])
                                                            .optional(),
                                                          DisplayName: zod
                                                            .union([
                                                              zod.string(),
                                                              zod.null(),
                                                            ])
                                                            .optional(),
                                                          RxCUI: zod
                                                            .union([
                                                              zod.number(),
                                                              zod.null(),
                                                            ])
                                                            .optional(),
                                                          DispensableDrugId: zod
                                                            .union([
                                                              zod.number(),
                                                              zod.null(),
                                                            ])
                                                            .optional(),
                                                        })
                                                        .describe(
                                                          "`StepMedicationRestriction` entry on a `CoverageRestrictions`.",
                                                        ),
                                                    ),
                                                    zod.null(),
                                                  ])
                                                  .optional(),
                                                Messages: zod
                                                  .union([
                                                    zod.array(
                                                      zod
                                                        .object({
                                                          Message: zod
                                                            .union([
                                                              zod.string(),
                                                              zod.null(),
                                                            ])
                                                            .optional(),
                                                          LongMessage: zod
                                                            .union([
                                                              zod.string(),
                                                              zod.null(),
                                                            ])
                                                            .optional(),
                                                        })
                                                        .describe(
                                                          "`CoverageMessage` entry on a `CoverageRestrictions`.",
                                                        ),
                                                    ),
                                                    zod.null(),
                                                  ])
                                                  .optional(),
                                                DrugResources: zod
                                                  .union([
                                                    zod.array(
                                                      zod
                                                        .object({
                                                          Url: zod
                                                            .union([
                                                              zod.string(),
                                                              zod.null(),
                                                            ])
                                                            .optional(),
                                                          ResourceType: zod
                                                            .union([
                                                              zod
                                                                .enum([
                                                                  "AgeLimits",
                                                                  "ProductCoverageExclusion",
                                                                  "GenderLimits",
                                                                  "MedicalNecessity",
                                                                  "PriorAuthorization",
                                                                  "QuantityLimits",
                                                                  "StepTherapy",
                                                                  "General",
                                                                  "Copay",
                                                                  "Formulary",
                                                                ])
                                                                .describe(
                                                                  "`CoverageResource.ResourceType` values.",
                                                                ),
                                                              zod.null(),
                                                            ])
                                                            .optional(),
                                                        })
                                                        .describe(
                                                          "`CoverageResource` entry on a `CoverageRestrictions`.",
                                                        ),
                                                    ),
                                                    zod.null(),
                                                  ])
                                                  .optional(),
                                                SummaryResources: zod
                                                  .union([
                                                    zod.array(
                                                      zod
                                                        .object({
                                                          Url: zod
                                                            .union([
                                                              zod.string(),
                                                              zod.null(),
                                                            ])
                                                            .optional(),
                                                          ResourceType: zod
                                                            .union([
                                                              zod
                                                                .enum([
                                                                  "AgeLimits",
                                                                  "ProductCoverageExclusion",
                                                                  "GenderLimits",
                                                                  "MedicalNecessity",
                                                                  "PriorAuthorization",
                                                                  "QuantityLimits",
                                                                  "StepTherapy",
                                                                  "General",
                                                                  "Copay",
                                                                  "Formulary",
                                                                ])
                                                                .describe(
                                                                  "`CoverageResource.ResourceType` values.",
                                                                ),
                                                              zod.null(),
                                                            ])
                                                            .optional(),
                                                        })
                                                        .describe(
                                                          "`CoverageResource` entry on a `CoverageRestrictions`.",
                                                        ),
                                                    ),
                                                    zod.null(),
                                                  ])
                                                  .optional(),
                                              })
                                              .describe(
                                                "Coverage restrictions on the primary drug (`CoverageRestrictions`).\n\n``HasPriorAuthorization`` is the primary bit the gate consults when\n`\/prescriptionbenefits` is unavailable. ``IsExcluded`` shortcuts to\nthe `EXCLUDED` gate outcome: no point initiating a PA for a drug the\npayer will never cover.\n\nField-name alignment with the v2 swagger: ``HasAgeLimit`` \/\n``HasQuantityLimit`` are singular here (not plural as on\n:class:`RealTimeFormularyCoverageRestrictionsT`); there is no\n``HasGenderLimit`` — use ``GenderRestriction`` for that.",
                                              ),
                                            zod.null(),
                                          ])
                                          .optional(),
                                      })
                                      .describe(
                                        "`MedicationCoverage` — coverage slice nested under `PayerAlternativeDetail`.\n\nDistinct from :class:`MedicationCoverageResponseT` (the\n``\/formulary`` response body): no ``Otc`` \/ ``Brand`` \/\n``TherapeuticAlternatives`` \/ ``RealTimeFormularyRequestStatus``\nfields here.",
                                      ),
                                    zod.null(),
                                  ])
                                  .optional(),
                              })
                              .describe(
                                "`PrescriptionBenefitPayerAlternativeDetail` — one detail under :class:`PayerAlternativeT`.\n\nEach detail describes an NDC-level variant of the alternative drug\nalong with its patient-specific pricing.",
                              ),
                          ),
                          zod.null(),
                        ])
                        .optional(),
                      RepresentativeFormularyCoverage: zod
                        .union([
                          zod
                            .object({
                              CopayFactors: zod
                                .union([
                                  zod.array(
                                    zod
                                      .object({
                                        IsDrugSpecific: zod
                                          .union([zod.boolean(), zod.null()])
                                          .optional(),
                                        PharmacyType: zod
                                          .union([
                                            zod
                                              .enum([
                                                "Any",
                                                "FaxPharmacy",
                                                "EPCS",
                                                "TwentyFourHourPharmacy",
                                                "LongTermCarePharmacy",
                                                "MailOrder",
                                                "Retail",
                                                "SpecialtyPharmacy",
                                              ])
                                              .describe(
                                                "Valid pharmacy specialty types for DoseSpot.",
                                              ),
                                            zod.null(),
                                          ])
                                          .optional(),
                                        FlatCopayAmount: zod
                                          .union([zod.number(), zod.null()])
                                          .optional(),
                                        PercentCopayAmount: zod
                                          .union([zod.number(), zod.null()])
                                          .optional(),
                                        FlatCopayAmountFirst: zod
                                          .union([zod.boolean(), zod.null()])
                                          .optional(),
                                        MinimumCopayAmount: zod
                                          .union([zod.number(), zod.null()])
                                          .optional(),
                                        MaximumCopayAmount: zod
                                          .union([zod.number(), zod.null()])
                                          .optional(),
                                        DaysSupply: zod
                                          .union([zod.number(), zod.null()])
                                          .optional(),
                                        CopayTier: zod
                                          .union([zod.number(), zod.null()])
                                          .optional(),
                                        MaximumCopayTier: zod
                                          .union([zod.number(), zod.null()])
                                          .optional(),
                                        OutOfPocketMinimum: zod
                                          .union([zod.number(), zod.null()])
                                          .optional(),
                                        OutOfPocketMaximum: zod
                                          .union([zod.number(), zod.null()])
                                          .optional(),
                                      })
                                      .describe(
                                        "Single copay tier (`PayerCopay`).\n\nPer-channel pricing rule returned on formulary responses and on the\n``RepresentitiveFormularyCoverage`` slice of each alternative. The\ngate doesn't consult any of these fields directly — they're carried\nthrough for UI display next to an ``EXCLUDED`` \/ ``PA_REQUIRED``\nbanner.",
                                      ),
                                  ),
                                  zod.null(),
                                ])
                                .optional(),
                              FormularyStatus: zod
                                .union([zod.string(), zod.null()])
                                .optional(),
                              FormularyStatusText: zod
                                .union([zod.string(), zod.null()])
                                .optional(),
                              RealTimeFormularyCoverageRestrictions: zod
                                .union([
                                  zod
                                    .object({
                                      HasCoverageRestrictions: zod
                                        .union([zod.boolean(), zod.null()])
                                        .optional(),
                                      IsExcluded: zod
                                        .union([zod.boolean(), zod.null()])
                                        .optional(),
                                      HasMedicalNecessity: zod
                                        .union([zod.boolean(), zod.null()])
                                        .optional(),
                                      HasPriorAuthorization: zod
                                        .union([zod.boolean(), zod.null()])
                                        .optional(),
                                      HasStepTherapy: zod
                                        .union([zod.boolean(), zod.null()])
                                        .optional(),
                                      AgeLimitRestrictions: zod
                                        .union([
                                          zod.array(
                                            zod
                                              .object({
                                                MinimumAge: zod
                                                  .union([
                                                    zod.number(),
                                                    zod.null(),
                                                  ])
                                                  .optional(),
                                                MinimumAgeUnit: zod
                                                  .union([
                                                    zod
                                                      .enum(["Days", "Years"])
                                                      .describe(
                                                        "Unit on :class:`AgeLimitRestrictionT` bounds.",
                                                      ),
                                                    zod.null(),
                                                  ])
                                                  .optional(),
                                                MaximumAge: zod
                                                  .union([
                                                    zod.number(),
                                                    zod.null(),
                                                  ])
                                                  .optional(),
                                                MaximumAgeUnit: zod
                                                  .union([
                                                    zod
                                                      .enum(["Days", "Years"])
                                                      .describe(
                                                        "Unit on :class:`AgeLimitRestrictionT` bounds.",
                                                      ),
                                                    zod.null(),
                                                  ])
                                                  .optional(),
                                              })
                                              .describe(
                                                "`AgeLimitRestriction` entry on a `CoverageRestrictions`.",
                                              ),
                                          ),
                                          zod.null(),
                                        ])
                                        .optional(),
                                      GenderLimitRestrictions: zod
                                        .union([
                                          zod.array(
                                            zod
                                              .object({
                                                GenderAbbreviation: zod
                                                  .union([
                                                    zod.string(),
                                                    zod.null(),
                                                  ])
                                                  .optional(),
                                                GenderDescription: zod
                                                  .union([
                                                    zod.string(),
                                                    zod.null(),
                                                  ])
                                                  .optional(),
                                              })
                                              .describe(
                                                "`GenderLimitRestriction` entry on a `RealTimeFormularyCoverageRestrictions`.",
                                              ),
                                          ),
                                          zod.null(),
                                        ])
                                        .optional(),
                                      QuantityLimitRestrictions: zod
                                        .union([
                                          zod.array(
                                            zod
                                              .object({
                                                MaximumAmount: zod
                                                  .union([
                                                    zod.number(),
                                                    zod.null(),
                                                  ])
                                                  .optional(),
                                                AmountUnit: zod
                                                  .union([
                                                    zod
                                                      .enum([
                                                        "DollarAmount",
                                                        "DaysSupply",
                                                        "Fills",
                                                        "Quantity",
                                                      ])
                                                      .describe(
                                                        "`QuantityLimitRestriction.AmountUnit` values.",
                                                      ),
                                                    zod.null(),
                                                  ])
                                                  .optional(),
                                                TimePeriodUnit: zod
                                                  .union([
                                                    zod
                                                      .enum([
                                                        "Days",
                                                        "Lifetime",
                                                        "PerDispensing",
                                                        "SpecificDateRange",
                                                        "CalendarYear",
                                                        "CalendarQuarter",
                                                        "CalendarMonth",
                                                      ])
                                                      .describe(
                                                        "`QuantityLimitRestriction.TimePeriodUnit` values.",
                                                      ),
                                                    zod.null(),
                                                  ])
                                                  .optional(),
                                                StartDate: zod
                                                  .union([
                                                    zod.string(),
                                                    zod.null(),
                                                  ])
                                                  .optional(),
                                                EndDate: zod
                                                  .union([
                                                    zod.string(),
                                                    zod.null(),
                                                  ])
                                                  .optional(),
                                                MaximumTimePeriodUnits: zod
                                                  .union([
                                                    zod.number(),
                                                    zod.null(),
                                                  ])
                                                  .optional(),
                                              })
                                              .describe(
                                                "`QuantityLimitRestriction` entry on a `CoverageRestrictions`.",
                                              ),
                                          ),
                                          zod.null(),
                                        ])
                                        .optional(),
                                      StepMedicationRestrictions: zod
                                        .union([
                                          zod.array(
                                            zod
                                              .object({
                                                Ndc: zod
                                                  .union([
                                                    zod.string(),
                                                    zod.null(),
                                                  ])
                                                  .optional(),
                                                StepDrugType: zod
                                                  .union([
                                                    zod
                                                      .enum([
                                                        "Unknown",
                                                        "SpecificMedication",
                                                        "PharmacologicalClass",
                                                      ])
                                                      .describe(
                                                        "`StepMedicationRestriction.StepDrugType` values.",
                                                      ),
                                                    zod.null(),
                                                  ])
                                                  .optional(),
                                                StepOrder: zod
                                                  .union([
                                                    zod.number(),
                                                    zod.null(),
                                                  ])
                                                  .optional(),
                                                DisplayName: zod
                                                  .union([
                                                    zod.string(),
                                                    zod.null(),
                                                  ])
                                                  .optional(),
                                                RxCUI: zod
                                                  .union([
                                                    zod.number(),
                                                    zod.null(),
                                                  ])
                                                  .optional(),
                                                DispensableDrugId: zod
                                                  .union([
                                                    zod.number(),
                                                    zod.null(),
                                                  ])
                                                  .optional(),
                                              })
                                              .describe(
                                                "`StepMedicationRestriction` entry on a `CoverageRestrictions`.",
                                              ),
                                          ),
                                          zod.null(),
                                        ])
                                        .optional(),
                                      Messages: zod
                                        .union([
                                          zod.array(
                                            zod
                                              .object({
                                                Message: zod
                                                  .union([
                                                    zod.string(),
                                                    zod.null(),
                                                  ])
                                                  .optional(),
                                                LongMessage: zod
                                                  .union([
                                                    zod.string(),
                                                    zod.null(),
                                                  ])
                                                  .optional(),
                                              })
                                              .describe(
                                                "`CoverageMessage` entry on a `CoverageRestrictions`.",
                                              ),
                                          ),
                                          zod.null(),
                                        ])
                                        .optional(),
                                      DrugResources: zod
                                        .union([
                                          zod.array(
                                            zod
                                              .object({
                                                Url: zod
                                                  .union([
                                                    zod.string(),
                                                    zod.null(),
                                                  ])
                                                  .optional(),
                                                ResourceType: zod
                                                  .union([
                                                    zod
                                                      .enum([
                                                        "AgeLimits",
                                                        "ProductCoverageExclusion",
                                                        "GenderLimits",
                                                        "MedicalNecessity",
                                                        "PriorAuthorization",
                                                        "QuantityLimits",
                                                        "StepTherapy",
                                                        "General",
                                                        "Copay",
                                                        "Formulary",
                                                      ])
                                                      .describe(
                                                        "`CoverageResource.ResourceType` values.",
                                                      ),
                                                    zod.null(),
                                                  ])
                                                  .optional(),
                                              })
                                              .describe(
                                                "`CoverageResource` entry on a `CoverageRestrictions`.",
                                              ),
                                          ),
                                          zod.null(),
                                        ])
                                        .optional(),
                                      SummaryResources: zod
                                        .union([
                                          zod.array(
                                            zod
                                              .object({
                                                Url: zod
                                                  .union([
                                                    zod.string(),
                                                    zod.null(),
                                                  ])
                                                  .optional(),
                                                ResourceType: zod
                                                  .union([
                                                    zod
                                                      .enum([
                                                        "AgeLimits",
                                                        "ProductCoverageExclusion",
                                                        "GenderLimits",
                                                        "MedicalNecessity",
                                                        "PriorAuthorization",
                                                        "QuantityLimits",
                                                        "StepTherapy",
                                                        "General",
                                                        "Copay",
                                                        "Formulary",
                                                      ])
                                                      .describe(
                                                        "`CoverageResource.ResourceType` values.",
                                                      ),
                                                    zod.null(),
                                                  ])
                                                  .optional(),
                                              })
                                              .describe(
                                                "`CoverageResource` entry on a `CoverageRestrictions`.",
                                              ),
                                          ),
                                          zod.null(),
                                        ])
                                        .optional(),
                                    })
                                    .describe(
                                      "Realtime-only restriction slice (`RealTimeFormularyCoverageRestrictions`).\n\nAppears only on :class:`RepresentitiveFormularyCoverageT` (i.e. on each\nalternative drug), \*\*not\*\* on the primary drug's ``CoverageRestrictions``.\nThat asymmetry is per the v2 swagger: the primary drug's realtime PA\nbit is conveyed by ``\/prescriptionbenefits`` (``PriorAuthRequired``)\nand its cached bit by ``CoverageRestrictions.HasPriorAuthorization``.\n\nField names match the swagger exactly — note ``HasMedicalNecessity``\n(not the legacy ``RequiresMedicalNecessity``) and ``HasAge`` \/\n``HasQuantity`` rather than the plural ``…Limits`` spellings used on\n:class:`CoverageRestrictionsT`.",
                                    ),
                                  zod.null(),
                                ])
                                .optional(),
                            })
                            .describe(
                              "`RepresentitiveFormularyCoverage` on a :class:`PayerAlternativeT`.\n\nThe typo (``Representitive`` rather than ``Representative``) is\nDoseSpot's, not ours — the field name is verbatim from the v2 swagger\ndefinition so pydantic's ``model_validate`` of a raw DoseSpot\nresponse lines up.",
                            ),
                          zod.null(),
                        ])
                        .optional(),
                      PatientSpecificPricingCoverages: zod
                        .union([
                          zod.array(
                            zod
                              .object({
                                Pharmacy: zod
                                  .union([
                                    zod
                                      .object({
                                        PharmacyType: zod
                                          .union([
                                            zod
                                              .enum([
                                                "Retail",
                                                "Mail",
                                                "Item90DayAtRetail",
                                                "Specialty",
                                                "LongTermCare",
                                              ])
                                              .describe(
                                                "`PrescriptionBenefitsPharmacy.PharmacyType` values.\n\nDistinct from :class:`PharmacySpecialtyTypeT` — DoseSpot uses a\ndifferent (smaller) vocabulary for the pharmacy slice returned on\nrealtime-benefits responses than for channel-level eligibility.",
                                              ),
                                            zod.null(),
                                          ])
                                          .optional(),
                                        Identifications: zod
                                          .union([
                                            zod.record(
                                              zod.string(),
                                              zod.unknown(),
                                            ),
                                            zod.null(),
                                          ])
                                          .optional(),
                                        PharmacistLastName: zod
                                          .union([zod.string(), zod.null()])
                                          .optional(),
                                        PharmacistFirstName: zod
                                          .union([zod.string(), zod.null()])
                                          .optional(),
                                        PharmacistMiddleName: zod
                                          .union([zod.string(), zod.null()])
                                          .optional(),
                                        PharmacistSuffix: zod
                                          .union([zod.string(), zod.null()])
                                          .optional(),
                                        PharmacistPrefix: zod
                                          .union([zod.string(), zod.null()])
                                          .optional(),
                                        Email: zod
                                          .union([zod.string(), zod.null()])
                                          .optional(),
                                        DistanceFromRequestedPharmacy: zod
                                          .union([zod.number(), zod.null()])
                                          .optional(),
                                        PharmacyId: zod
                                          .union([zod.number(), zod.null()])
                                          .optional(),
                                        StoreName: zod
                                          .union([zod.string(), zod.null()])
                                          .optional(),
                                        Address1: zod
                                          .union([zod.string(), zod.null()])
                                          .optional(),
                                        Address2: zod
                                          .union([zod.string(), zod.null()])
                                          .optional(),
                                        City: zod
                                          .union([zod.string(), zod.null()])
                                          .optional(),
                                        State: zod
                                          .union([zod.string(), zod.null()])
                                          .optional(),
                                        ZipCode: zod
                                          .union([zod.string(), zod.null()])
                                          .optional(),
                                        PrimaryPhone: zod
                                          .union([zod.string(), zod.null()])
                                          .optional(),
                                        PrimaryPhoneType: zod
                                          .union([
                                            zod
                                              .enum([
                                                "Undefined",
                                                "Beeper",
                                                "Cell",
                                                "Fax",
                                                "Home",
                                                "Work",
                                                "Night",
                                                "Primary",
                                              ])
                                              .describe(
                                                "`PrescriptionBenefitsPharmacy.PrimaryPhoneType` \/ `PhoneAdditionalType\*` values.",
                                              ),
                                            zod.null(),
                                          ])
                                          .optional(),
                                        PrimaryFax: zod
                                          .union([zod.string(), zod.null()])
                                          .optional(),
                                        PhoneAdditional1: zod
                                          .union([zod.string(), zod.null()])
                                          .optional(),
                                        PhoneAdditionalType1: zod
                                          .union([
                                            zod
                                              .enum([
                                                "Undefined",
                                                "Beeper",
                                                "Cell",
                                                "Fax",
                                                "Home",
                                                "Work",
                                                "Night",
                                                "Primary",
                                              ])
                                              .describe(
                                                "`PrescriptionBenefitsPharmacy.PrimaryPhoneType` \/ `PhoneAdditionalType\*` values.",
                                              ),
                                            zod.null(),
                                          ])
                                          .optional(),
                                        PhoneAdditional2: zod
                                          .union([zod.string(), zod.null()])
                                          .optional(),
                                        PhoneAdditionalType2: zod
                                          .union([
                                            zod
                                              .enum([
                                                "Undefined",
                                                "Beeper",
                                                "Cell",
                                                "Fax",
                                                "Home",
                                                "Work",
                                                "Night",
                                                "Primary",
                                              ])
                                              .describe(
                                                "`PrescriptionBenefitsPharmacy.PrimaryPhoneType` \/ `PhoneAdditionalType\*` values.",
                                              ),
                                            zod.null(),
                                          ])
                                          .optional(),
                                        PhoneAdditional3: zod
                                          .union([zod.string(), zod.null()])
                                          .optional(),
                                        PhoneAdditionalType3: zod
                                          .union([
                                            zod
                                              .enum([
                                                "Undefined",
                                                "Beeper",
                                                "Cell",
                                                "Fax",
                                                "Home",
                                                "Work",
                                                "Night",
                                                "Primary",
                                              ])
                                              .describe(
                                                "`PrescriptionBenefitsPharmacy.PrimaryPhoneType` \/ `PhoneAdditionalType\*` values.",
                                              ),
                                            zod.null(),
                                          ])
                                          .optional(),
                                        PharmacySpecialties: zod
                                          .union([
                                            zod.array(zod.string()),
                                            zod.null(),
                                          ])
                                          .optional(),
                                        ServiceLevel: zod
                                          .union([zod.number(), zod.null()])
                                          .optional(),
                                        Latitude: zod
                                          .union([zod.number(), zod.null()])
                                          .optional(),
                                        Longitude: zod
                                          .union([zod.number(), zod.null()])
                                          .optional(),
                                        NCPDPID: zod
                                          .union([zod.string(), zod.null()])
                                          .optional(),
                                      })
                                      .describe(
                                        "`PrescriptionBenefitsPharmacy` — pharmacy slice on RTPB responses.\n\nNarrower-use than :class:`PharmacyT`; mirrors the full swagger shape\nso callers can surface dispensing-pharmacy details (name, address,\nNCPDPID) alongside pricing \/ PA signals from a\n``PatientSpecificPricingCoverage`` entry.",
                                      ),
                                    zod.null(),
                                  ])
                                  .optional(),
                                PricingCoverage: zod
                                  .union([
                                    zod
                                      .object({
                                        DrugStatusCode: zod
                                          .union([zod.string(), zod.null()])
                                          .optional(),
                                        DrugStatus: zod
                                          .union([zod.string(), zod.null()])
                                          .optional(),
                                        QuantityPricedValue: zod
                                          .union([zod.string(), zod.null()])
                                          .optional(),
                                        QuantityPricedCodeListQualifier: zod
                                          .union([
                                            zod
                                              .enum([
                                                "Item38",
                                                "Item40",
                                                "Item87",
                                                "QS",
                                                "CF",
                                                "UQ",
                                              ])
                                              .describe(
                                                "`PricingCoverageFactors.QuantityPricedCodeListQualifier` values.",
                                              ),
                                            zod.null(),
                                          ])
                                          .optional(),
                                        QuantityPricedUnitOfMeasureType: zod
                                          .union([zod.string(), zod.null()])
                                          .optional(),
                                        QuantityPricedUnitOfMeasureTypeId: zod
                                          .union([zod.number(), zod.null()])
                                          .optional(),
                                        DaysSupplyPriced: zod
                                          .union([zod.string(), zod.null()])
                                          .optional(),
                                        PlanPayAmount: zod
                                          .union([zod.string(), zod.null()])
                                          .optional(),
                                        EstimatedPatientPayAmount: zod
                                          .union([zod.string(), zod.null()])
                                          .optional(),
                                        OOPAppliedAmount: zod
                                          .union([zod.string(), zod.null()])
                                          .optional(),
                                        OOPRemainingAmount: zod
                                          .union([zod.string(), zod.null()])
                                          .optional(),
                                        DeductibleAppliedAmount: zod
                                          .union([zod.string(), zod.null()])
                                          .optional(),
                                        DeductibleRemainingAmount: zod
                                          .union([zod.string(), zod.null()])
                                          .optional(),
                                        CoverageAlerts: zod
                                          .union([
                                            zod.array(
                                              zod
                                                .object({
                                                  ReferenceCode: zod
                                                    .union([
                                                      zod
                                                        .enum([
                                                          "AgeLimits",
                                                          "DaysSupplyExceeded",
                                                          "DrugExclusion",
                                                          "ExcessiveUtilization",
                                                          "FullCostNotCovered",
                                                          "GenderLimits",
                                                          "MandatoryGeneric",
                                                          "MedicalNecessity",
                                                          "NotOnFormulary",
                                                          "PharmacyOutOfNetwork",
                                                          "PlanLimitExclusion",
                                                          "QuantityLimits",
                                                          "QuantityLimitExceeded",
                                                          "QuantityNotValid",
                                                          "ResourceLink",
                                                          "StepTherapy",
                                                          "TextMessage",
                                                        ])
                                                        .describe(
                                                          "`PricingCoverageFactorsCoverageAlerts.ReferenceCode` values.",
                                                        ),
                                                      zod.null(),
                                                    ])
                                                    .optional(),
                                                  ReferenceText: zod
                                                    .union([
                                                      zod.string(),
                                                      zod.null(),
                                                    ])
                                                    .optional(),
                                                })
                                                .describe(
                                                  "`PricingCoverageFactorsCoverageAlerts` entry on :class:`PricingCoverageFactorsT`.\n\nDoseSpot returns coverage-alert \*objects\* here (not plain strings):\na ``ReferenceCode`` enum plus a human-readable ``ReferenceText``.",
                                                ),
                                            ),
                                            zod.null(),
                                          ])
                                          .optional(),
                                        FormularyStatus: zod
                                          .union([zod.string(), zod.null()])
                                          .optional(),
                                        PriorAuthRequired: zod
                                          .union([zod.boolean(), zod.null()])
                                          .optional(),
                                      })
                                      .describe(
                                        "`PricingCoverageFactors` — `PricingCoverage` sub-object on RTPB.\n\nThe realtime gate's authoritative PA source: ``PriorAuthRequired=true``\non any pharmacy-specific pricing coverage flips the gate to\n:attr:`PA_REQUIRED`. Pricing fields are kept for downstream UI — they\nare not consulted by the gate but are cheap to carry.",
                                      ),
                                    zod.null(),
                                  ])
                                  .optional(),
                              })
                              .describe(
                                "`PatientSpecificPricingCoverage` — one (pharmacy × coverage) pricing row.\n\nA coverage can yield multiple entries — one per pharmacy the payer\npriced against — so the gate has to OR the ``PriorAuthRequired`` bits\nacross the list to get a conservative answer.",
                              ),
                          ),
                          zod.null(),
                        ])
                        .optional(),
                    })
                    .describe(
                      "`PayerAlternativeAPI` — payer-preferred alternative for an NDC.\n\nSurfaced alongside a gate decision of :attr:`EXCLUDED` or\n:attr:`PA_REQUIRED` so the clinician can rewrite to a preferred drug\ninstead of fighting a PA. Returned both on the formulary response\n(``MedicationCoverageResponse.Alternatives``) and on the RTPB\nresponse (``GetPrescriptionBenefitResponse.Alternatives``).",
                    ),
                ),
                zod.null(),
              ])
              .optional(),
            RealTimeFormularyRequestStatus: zod
              .union([zod.number(), zod.null()])
              .optional(),
            PatientSpecificPricingCoverages: zod
              .union([
                zod.array(
                  zod
                    .object({
                      Pharmacy: zod
                        .union([
                          zod
                            .object({
                              PharmacyType: zod
                                .union([
                                  zod
                                    .enum([
                                      "Retail",
                                      "Mail",
                                      "Item90DayAtRetail",
                                      "Specialty",
                                      "LongTermCare",
                                    ])
                                    .describe(
                                      "`PrescriptionBenefitsPharmacy.PharmacyType` values.\n\nDistinct from :class:`PharmacySpecialtyTypeT` — DoseSpot uses a\ndifferent (smaller) vocabulary for the pharmacy slice returned on\nrealtime-benefits responses than for channel-level eligibility.",
                                    ),
                                  zod.null(),
                                ])
                                .optional(),
                              Identifications: zod
                                .union([
                                  zod.record(zod.string(), zod.unknown()),
                                  zod.null(),
                                ])
                                .optional(),
                              PharmacistLastName: zod
                                .union([zod.string(), zod.null()])
                                .optional(),
                              PharmacistFirstName: zod
                                .union([zod.string(), zod.null()])
                                .optional(),
                              PharmacistMiddleName: zod
                                .union([zod.string(), zod.null()])
                                .optional(),
                              PharmacistSuffix: zod
                                .union([zod.string(), zod.null()])
                                .optional(),
                              PharmacistPrefix: zod
                                .union([zod.string(), zod.null()])
                                .optional(),
                              Email: zod
                                .union([zod.string(), zod.null()])
                                .optional(),
                              DistanceFromRequestedPharmacy: zod
                                .union([zod.number(), zod.null()])
                                .optional(),
                              PharmacyId: zod
                                .union([zod.number(), zod.null()])
                                .optional(),
                              StoreName: zod
                                .union([zod.string(), zod.null()])
                                .optional(),
                              Address1: zod
                                .union([zod.string(), zod.null()])
                                .optional(),
                              Address2: zod
                                .union([zod.string(), zod.null()])
                                .optional(),
                              City: zod
                                .union([zod.string(), zod.null()])
                                .optional(),
                              State: zod
                                .union([zod.string(), zod.null()])
                                .optional(),
                              ZipCode: zod
                                .union([zod.string(), zod.null()])
                                .optional(),
                              PrimaryPhone: zod
                                .union([zod.string(), zod.null()])
                                .optional(),
                              PrimaryPhoneType: zod
                                .union([
                                  zod
                                    .enum([
                                      "Undefined",
                                      "Beeper",
                                      "Cell",
                                      "Fax",
                                      "Home",
                                      "Work",
                                      "Night",
                                      "Primary",
                                    ])
                                    .describe(
                                      "`PrescriptionBenefitsPharmacy.PrimaryPhoneType` \/ `PhoneAdditionalType\*` values.",
                                    ),
                                  zod.null(),
                                ])
                                .optional(),
                              PrimaryFax: zod
                                .union([zod.string(), zod.null()])
                                .optional(),
                              PhoneAdditional1: zod
                                .union([zod.string(), zod.null()])
                                .optional(),
                              PhoneAdditionalType1: zod
                                .union([
                                  zod
                                    .enum([
                                      "Undefined",
                                      "Beeper",
                                      "Cell",
                                      "Fax",
                                      "Home",
                                      "Work",
                                      "Night",
                                      "Primary",
                                    ])
                                    .describe(
                                      "`PrescriptionBenefitsPharmacy.PrimaryPhoneType` \/ `PhoneAdditionalType\*` values.",
                                    ),
                                  zod.null(),
                                ])
                                .optional(),
                              PhoneAdditional2: zod
                                .union([zod.string(), zod.null()])
                                .optional(),
                              PhoneAdditionalType2: zod
                                .union([
                                  zod
                                    .enum([
                                      "Undefined",
                                      "Beeper",
                                      "Cell",
                                      "Fax",
                                      "Home",
                                      "Work",
                                      "Night",
                                      "Primary",
                                    ])
                                    .describe(
                                      "`PrescriptionBenefitsPharmacy.PrimaryPhoneType` \/ `PhoneAdditionalType\*` values.",
                                    ),
                                  zod.null(),
                                ])
                                .optional(),
                              PhoneAdditional3: zod
                                .union([zod.string(), zod.null()])
                                .optional(),
                              PhoneAdditionalType3: zod
                                .union([
                                  zod
                                    .enum([
                                      "Undefined",
                                      "Beeper",
                                      "Cell",
                                      "Fax",
                                      "Home",
                                      "Work",
                                      "Night",
                                      "Primary",
                                    ])
                                    .describe(
                                      "`PrescriptionBenefitsPharmacy.PrimaryPhoneType` \/ `PhoneAdditionalType\*` values.",
                                    ),
                                  zod.null(),
                                ])
                                .optional(),
                              PharmacySpecialties: zod
                                .union([zod.array(zod.string()), zod.null()])
                                .optional(),
                              ServiceLevel: zod
                                .union([zod.number(), zod.null()])
                                .optional(),
                              Latitude: zod
                                .union([zod.number(), zod.null()])
                                .optional(),
                              Longitude: zod
                                .union([zod.number(), zod.null()])
                                .optional(),
                              NCPDPID: zod
                                .union([zod.string(), zod.null()])
                                .optional(),
                            })
                            .describe(
                              "`PrescriptionBenefitsPharmacy` — pharmacy slice on RTPB responses.\n\nNarrower-use than :class:`PharmacyT`; mirrors the full swagger shape\nso callers can surface dispensing-pharmacy details (name, address,\nNCPDPID) alongside pricing \/ PA signals from a\n``PatientSpecificPricingCoverage`` entry.",
                            ),
                          zod.null(),
                        ])
                        .optional(),
                      PricingCoverage: zod
                        .union([
                          zod
                            .object({
                              DrugStatusCode: zod
                                .union([zod.string(), zod.null()])
                                .optional(),
                              DrugStatus: zod
                                .union([zod.string(), zod.null()])
                                .optional(),
                              QuantityPricedValue: zod
                                .union([zod.string(), zod.null()])
                                .optional(),
                              QuantityPricedCodeListQualifier: zod
                                .union([
                                  zod
                                    .enum([
                                      "Item38",
                                      "Item40",
                                      "Item87",
                                      "QS",
                                      "CF",
                                      "UQ",
                                    ])
                                    .describe(
                                      "`PricingCoverageFactors.QuantityPricedCodeListQualifier` values.",
                                    ),
                                  zod.null(),
                                ])
                                .optional(),
                              QuantityPricedUnitOfMeasureType: zod
                                .union([zod.string(), zod.null()])
                                .optional(),
                              QuantityPricedUnitOfMeasureTypeId: zod
                                .union([zod.number(), zod.null()])
                                .optional(),
                              DaysSupplyPriced: zod
                                .union([zod.string(), zod.null()])
                                .optional(),
                              PlanPayAmount: zod
                                .union([zod.string(), zod.null()])
                                .optional(),
                              EstimatedPatientPayAmount: zod
                                .union([zod.string(), zod.null()])
                                .optional(),
                              OOPAppliedAmount: zod
                                .union([zod.string(), zod.null()])
                                .optional(),
                              OOPRemainingAmount: zod
                                .union([zod.string(), zod.null()])
                                .optional(),
                              DeductibleAppliedAmount: zod
                                .union([zod.string(), zod.null()])
                                .optional(),
                              DeductibleRemainingAmount: zod
                                .union([zod.string(), zod.null()])
                                .optional(),
                              CoverageAlerts: zod
                                .union([
                                  zod.array(
                                    zod
                                      .object({
                                        ReferenceCode: zod
                                          .union([
                                            zod
                                              .enum([
                                                "AgeLimits",
                                                "DaysSupplyExceeded",
                                                "DrugExclusion",
                                                "ExcessiveUtilization",
                                                "FullCostNotCovered",
                                                "GenderLimits",
                                                "MandatoryGeneric",
                                                "MedicalNecessity",
                                                "NotOnFormulary",
                                                "PharmacyOutOfNetwork",
                                                "PlanLimitExclusion",
                                                "QuantityLimits",
                                                "QuantityLimitExceeded",
                                                "QuantityNotValid",
                                                "ResourceLink",
                                                "StepTherapy",
                                                "TextMessage",
                                              ])
                                              .describe(
                                                "`PricingCoverageFactorsCoverageAlerts.ReferenceCode` values.",
                                              ),
                                            zod.null(),
                                          ])
                                          .optional(),
                                        ReferenceText: zod
                                          .union([zod.string(), zod.null()])
                                          .optional(),
                                      })
                                      .describe(
                                        "`PricingCoverageFactorsCoverageAlerts` entry on :class:`PricingCoverageFactorsT`.\n\nDoseSpot returns coverage-alert \*objects\* here (not plain strings):\na ``ReferenceCode`` enum plus a human-readable ``ReferenceText``.",
                                      ),
                                  ),
                                  zod.null(),
                                ])
                                .optional(),
                              FormularyStatus: zod
                                .union([zod.string(), zod.null()])
                                .optional(),
                              PriorAuthRequired: zod
                                .union([zod.boolean(), zod.null()])
                                .optional(),
                            })
                            .describe(
                              "`PricingCoverageFactors` — `PricingCoverage` sub-object on RTPB.\n\nThe realtime gate's authoritative PA source: ``PriorAuthRequired=true``\non any pharmacy-specific pricing coverage flips the gate to\n:attr:`PA_REQUIRED`. Pricing fields are kept for downstream UI — they\nare not consulted by the gate but are cheap to carry.",
                            ),
                          zod.null(),
                        ])
                        .optional(),
                    })
                    .describe(
                      "`PatientSpecificPricingCoverage` — one (pharmacy × coverage) pricing row.\n\nA coverage can yield multiple entries — one per pharmacy the payer\npriced against — so the gate has to OR the ``PriorAuthRequired`` bits\nacross the list to get a conservative answer.",
                    ),
                ),
                zod.null(),
              ])
              .optional(),
            OptionalPharmacy: zod
              .union([
                zod
                  .object({
                    PharmacyType: zod
                      .union([
                        zod
                          .enum([
                            "Retail",
                            "Mail",
                            "Item90DayAtRetail",
                            "Specialty",
                            "LongTermCare",
                          ])
                          .describe(
                            "`PrescriptionBenefitsPharmacy.PharmacyType` values.\n\nDistinct from :class:`PharmacySpecialtyTypeT` — DoseSpot uses a\ndifferent (smaller) vocabulary for the pharmacy slice returned on\nrealtime-benefits responses than for channel-level eligibility.",
                          ),
                        zod.null(),
                      ])
                      .optional(),
                    Identifications: zod
                      .union([
                        zod.record(zod.string(), zod.unknown()),
                        zod.null(),
                      ])
                      .optional(),
                    PharmacistLastName: zod
                      .union([zod.string(), zod.null()])
                      .optional(),
                    PharmacistFirstName: zod
                      .union([zod.string(), zod.null()])
                      .optional(),
                    PharmacistMiddleName: zod
                      .union([zod.string(), zod.null()])
                      .optional(),
                    PharmacistSuffix: zod
                      .union([zod.string(), zod.null()])
                      .optional(),
                    PharmacistPrefix: zod
                      .union([zod.string(), zod.null()])
                      .optional(),
                    Email: zod.union([zod.string(), zod.null()]).optional(),
                    DistanceFromRequestedPharmacy: zod
                      .union([zod.number(), zod.null()])
                      .optional(),
                    PharmacyId: zod
                      .union([zod.number(), zod.null()])
                      .optional(),
                    StoreName: zod.union([zod.string(), zod.null()]).optional(),
                    Address1: zod.union([zod.string(), zod.null()]).optional(),
                    Address2: zod.union([zod.string(), zod.null()]).optional(),
                    City: zod.union([zod.string(), zod.null()]).optional(),
                    State: zod.union([zod.string(), zod.null()]).optional(),
                    ZipCode: zod.union([zod.string(), zod.null()]).optional(),
                    PrimaryPhone: zod
                      .union([zod.string(), zod.null()])
                      .optional(),
                    PrimaryPhoneType: zod
                      .union([
                        zod
                          .enum([
                            "Undefined",
                            "Beeper",
                            "Cell",
                            "Fax",
                            "Home",
                            "Work",
                            "Night",
                            "Primary",
                          ])
                          .describe(
                            "`PrescriptionBenefitsPharmacy.PrimaryPhoneType` \/ `PhoneAdditionalType\*` values.",
                          ),
                        zod.null(),
                      ])
                      .optional(),
                    PrimaryFax: zod
                      .union([zod.string(), zod.null()])
                      .optional(),
                    PhoneAdditional1: zod
                      .union([zod.string(), zod.null()])
                      .optional(),
                    PhoneAdditionalType1: zod
                      .union([
                        zod
                          .enum([
                            "Undefined",
                            "Beeper",
                            "Cell",
                            "Fax",
                            "Home",
                            "Work",
                            "Night",
                            "Primary",
                          ])
                          .describe(
                            "`PrescriptionBenefitsPharmacy.PrimaryPhoneType` \/ `PhoneAdditionalType\*` values.",
                          ),
                        zod.null(),
                      ])
                      .optional(),
                    PhoneAdditional2: zod
                      .union([zod.string(), zod.null()])
                      .optional(),
                    PhoneAdditionalType2: zod
                      .union([
                        zod
                          .enum([
                            "Undefined",
                            "Beeper",
                            "Cell",
                            "Fax",
                            "Home",
                            "Work",
                            "Night",
                            "Primary",
                          ])
                          .describe(
                            "`PrescriptionBenefitsPharmacy.PrimaryPhoneType` \/ `PhoneAdditionalType\*` values.",
                          ),
                        zod.null(),
                      ])
                      .optional(),
                    PhoneAdditional3: zod
                      .union([zod.string(), zod.null()])
                      .optional(),
                    PhoneAdditionalType3: zod
                      .union([
                        zod
                          .enum([
                            "Undefined",
                            "Beeper",
                            "Cell",
                            "Fax",
                            "Home",
                            "Work",
                            "Night",
                            "Primary",
                          ])
                          .describe(
                            "`PrescriptionBenefitsPharmacy.PrimaryPhoneType` \/ `PhoneAdditionalType\*` values.",
                          ),
                        zod.null(),
                      ])
                      .optional(),
                    PharmacySpecialties: zod
                      .union([zod.array(zod.string()), zod.null()])
                      .optional(),
                    ServiceLevel: zod
                      .union([zod.number(), zod.null()])
                      .optional(),
                    Latitude: zod.union([zod.number(), zod.null()]).optional(),
                    Longitude: zod.union([zod.number(), zod.null()]).optional(),
                    NCPDPID: zod.union([zod.string(), zod.null()]).optional(),
                  })
                  .describe(
                    "`PrescriptionBenefitsPharmacy` — pharmacy slice on RTPB responses.\n\nNarrower-use than :class:`PharmacyT`; mirrors the full swagger shape\nso callers can surface dispensing-pharmacy details (name, address,\nNCPDPID) alongside pricing \/ PA signals from a\n``PatientSpecificPricingCoverage`` entry.",
                  ),
                zod.null(),
              ])
              .optional(),
          })
          .describe(
            "`GetPrescriptionBenefitResponse` — inner item of ``ItemResponse[…]`` on\n``GET \/api\/patients\/{patient_id}\/prescriptionbenefits``.\n\nRetained under the historical ``PrescriptionBenefitsResponseT`` name\nfor in-repo stability; the shape is now the v2 swagger's unwrapped\n`Item` (see :class:`PrescriptionBenefitsItemResponseT` for the wire\nwrapper).\n\nKey fields for the gate:\n\n- ``PatientSpecificPricingCoverages[\*].PricingCoverage.PriorAuthRequired``\n  — authoritative per-fill PA bit. The gate ORs this across all\n  pricing coverages returned.\n- ``RealTimeFormularyRequestStatus`` — non-OK means the gate falls\n  back to `\/formulary`.",
          ),
        zod.null(),
      ])
      .optional(),
    payerInformation: zod
      .union([
        zod
          .object({
            PatientEligibilityId: zod
              .union([zod.number(), zod.null()])
              .optional(),
            PayerName: zod.union([zod.string(), zod.null()]).optional(),
            PharmacyEligibilities: zod
              .union([
                zod.array(
                  zod
                    .object({
                      PharmacyType: zod
                        .union([
                          zod
                            .enum([
                              "Any",
                              "FaxPharmacy",
                              "EPCS",
                              "TwentyFourHourPharmacy",
                              "LongTermCarePharmacy",
                              "MailOrder",
                              "Retail",
                              "SpecialtyPharmacy",
                            ])
                            .describe(
                              "Valid pharmacy specialty types for DoseSpot.",
                            ),
                          zod.null(),
                        ])
                        .optional(),
                      EligibilityStatus: zod
                        .union([
                          zod
                            .enum([
                              "Covered",
                              "NotCovered",
                              "OutOfPocket",
                              "Unknown",
                              "UnableToProcess",
                            ])
                            .describe(
                              "`EligibilityStatus` on a `PharmacyEligibility` entry.",
                            ),
                          zod.null(),
                        ])
                        .optional(),
                      Name: zod.union([zod.string(), zod.null()]).optional(),
                    })
                    .describe(
                      "Per-channel eligibility entry on a `PayerInformationResponse`.\n\nEach coverage reports one of these per pharmacy type so the Rx-time\ngate can pick the coverage that actually covers the channel the\nprescription is routed to (e.g. Retail vs MailOrder).",
                    ),
                ),
                zod.null(),
              ])
              .optional(),
            PlanName: zod.union([zod.string(), zod.null()]).optional(),
            CoverageId: zod.union([zod.string(), zod.null()]).optional(),
            PayerId: zod.union([zod.string(), zod.null()]).optional(),
            BIN: zod.union([zod.string(), zod.null()]).optional(),
            PCN: zod.union([zod.string(), zod.null()]).optional(),
            FormularyId: zod.union([zod.string(), zod.null()]).optional(),
            AlternativesId: zod.union([zod.string(), zod.null()]).optional(),
            CopayId: zod.union([zod.string(), zod.null()]).optional(),
            DemographicChanges: zod
              .union([zod.boolean(), zod.null()])
              .optional(),
            Demographics: zod
              .union([
                zod
                  .object({
                    LastName: zod.union([zod.string(), zod.null()]).optional(),
                    FirstName: zod.union([zod.string(), zod.null()]).optional(),
                    MiddleName: zod
                      .union([zod.string(), zod.null()])
                      .optional(),
                    Suffix: zod.union([zod.string(), zod.null()]).optional(),
                    DateOfBirth: zod
                      .union([zod.string(), zod.null()])
                      .optional(),
                    Gender: zod
                      .union([
                        zod
                          .enum(["Male", "Female", "Unknown"])
                          .describe(
                            "`PayerDemographics.Gender` and `CoverageRestrictions.GenderRestriction` values.",
                          ),
                        zod.null(),
                      ])
                      .optional(),
                    Address: zod
                      .union([
                        zod
                          .object({
                            AddressLine1: zod
                              .union([zod.string(), zod.null()])
                              .optional(),
                            AddressLine2: zod
                              .union([zod.string(), zod.null()])
                              .optional(),
                            City: zod
                              .union([zod.string(), zod.null()])
                              .optional(),
                            State: zod
                              .union([zod.string(), zod.null()])
                              .optional(),
                            ZipCode: zod
                              .union([zod.string(), zod.null()])
                              .optional(),
                          })
                          .describe(
                            "`PayerAddress` sub-object on :class:`PayerDemographicsT`.",
                          ),
                        zod.null(),
                      ])
                      .optional(),
                  })
                  .describe(
                    "`PayerDemographics` block on :class:`PayerInformationT`.\n\nSurfaced when the payer returns updated member demographics on an\neligibility response (combined with ``DemographicChanges=true``).",
                  ),
                zod.null(),
              ])
              .optional(),
            ErrorMessage: zod.union([zod.string(), zod.null()]).optional(),
            InfoMessage: zod.union([zod.string(), zod.null()]).optional(),
            MemberId: zod.union([zod.string(), zod.null()]).optional(),
          })
          .describe(
            "One active coverage for a patient (`PayerInformationResponse`).\n\nReturned by `GET \/api\/patients\/{patient_id}\/eligibilities`. The gate\nkeys subsequent `\/formulary` and `\/prescriptionbenefits` calls on\n``PatientEligibilityId``; the other ids (`CoverageId`, `FormularyId`,\n...) are carried through for audit but not otherwise consulted.\n\nFields match the DoseSpot v2 swagger `PayerInformationResponse`\ndefinition exactly. No `GroupId` here — that's a legacy field from\nthe v1 shape and was dropped when v2 consolidated onto `MemberId` +\n``Demographics``.",
          ),
        zod.null(),
      ])
      .optional(),
  })
  .describe(
    "Wrapper over :class:`PriorAuthGateResultT` for the Rx form.\n\nIncludes the raw DoseSpot ``\/formulary`` and ``\/prescriptionbenefits``\npayloads so the UI can surface formulary status, copay tiers, and\ntherapeutic alternatives alongside the gate decision. The client\nshould branch on ``outcome`` only — the extra payloads are\ninformational.\n\n``payer_information`` carries the BenefitsCoordination details per\nACR PA.109.1 — PayerName, PayerId, BIN, PCN, MemberId from the\nSurescripts 271 message. Displayed to the clinician so they can\nconfirm coverage being sent with the PA initiation.",
  );

/**
 * Get transmission errors for the authenticated user's associated clinic(s).

This endpoint retrieves transmission errors for prescriptions from the clinician's
associated clinic(s), with optional pagination support.

Args:
    page_number: The page number to retrieve (1-based, optional)
    clinic: The clinic to filter by (optional)

Returns:
    TransmissionErrorsPagedListResponseT: Paged list of transmission errors

Raises:
    AuthException: If the user lacks required privileges
    ValueError: If user doesn't have a DoseSpot clinician record
 * @summary Get My Transmission Errors
 */
export const getMyTransmissionErrorsQueryParams = zod.object({
  page_number: zod.union([zod.number(), zod.null()]).optional(),
  clinic: zod.union([zod.string(), zod.null()]).optional(),
});

export const getMyTransmissionErrorsResponse = zod
  .object({
    Items: zod
      .union([
        zod.array(
          zod
            .object({
              PrescriptionId: zod.union([zod.number(), zod.null()]).optional(),
              DateWritten: zod.union([zod.string(), zod.null()]).optional(),
              ErrorDateTimeStamp: zod
                .union([zod.string(), zod.null()])
                .optional(),
              ErrorDetails: zod.union([zod.string(), zod.null()]).optional(),
              PatientId: zod.union([zod.number(), zod.null()]).optional(),
              ClinicId: zod.union([zod.number(), zod.null()]).optional(),
            })
            .describe("DoseSpot Transmission Error notification."),
        ),
        zod.null(),
      ])
      .optional(),
    PageResult: zod
      .union([
        zod
          .object({
            CurrentPage: zod.union([zod.number(), zod.null()]).optional(),
            TotalPages: zod.union([zod.number(), zod.null()]).optional(),
            PageSize: zod.union([zod.number(), zod.null()]).optional(),
            TotalCount: zod.union([zod.number(), zod.null()]).optional(),
            HasPrevious: zod.union([zod.boolean(), zod.null()]).optional(),
            HasNext: zod.union([zod.boolean(), zod.null()]).optional(),
          })
          .describe("DoseSpot page result information."),
        zod.null(),
      ])
      .optional(),
    Result: zod
      .union([
        zod
          .object({
            ResultCode: zod.string(),
            ResultDescription: zod.union([zod.string(), zod.null()]).optional(),
          })
          .describe("Standard DoseSpot API result object."),
        zod.null(),
      ])
      .optional(),
  })
  .describe("PagedListResponse wrapper for transmission error lists.");

/**
 * Get notification counts for the authenticated user at a single clinic.

This endpoint retrieves the number of refill requests, transmission errors,
and pending prescriptions for the clinician at a single clinic.

Args:
    clinic: The clinic to get counts for (optional)

Returns:
    PrescriberNotificationCountsT: Notification counts

Raises:
    AuthException: If the user lacks required privileges
    ValueError: If user doesn't have a DoseSpot clinician record
 * @summary Get My Notification Counts
 */
export const getMyNotificationCountsQueryParams = zod.object({
  clinic: zod.union([zod.string(), zod.null()]).optional(),
});

export const getMyNotificationCountsResponse = zod
  .object({
    RefillRequestsCount: zod.union([zod.number(), zod.null()]).optional(),
    TransactionErrorsCount: zod.union([zod.number(), zod.null()]).optional(),
    PendingPrescriptionsCount: zod.union([zod.number(), zod.null()]).optional(),
    PendingRxChangeCount: zod.union([zod.number(), zod.null()]).optional(),
  })
  .describe("DoseSpot notification counts for a prescriber.");

/**
 * Get prescription information by DoseSpot prescription ID.

This endpoint fetches prescription details using the prescription model,
useful for displaying transmission error details.

Args:
    dosespot_prescription_id: The DoseSpot prescription ID

Returns:
    PrescriptionT or None: The prescription information if found

Raises:
    AuthException: If the user lacks required privileges
    ValueError: If user doesn't have a DoseSpot clinician record
 * @summary Get Prescription By Dosespot Id
 */
export const getPrescriptionByDosespotIdParams = zod.object({
  patient_id: zod.string(),
  dosespot_prescription_id: zod.string(),
});

export const getPrescriptionByDosespotIdResponse = zod.union([
  zod
    .object({
      PrescriptionId: zod.union([zod.number(), zod.null()]).optional(),
      PriorAuthorizationCaseId: zod
        .union([zod.number(), zod.null()])
        .optional(),
      WrittenDate: zod.union([zod.string(), zod.null()]).optional(),
      Directions: zod.union([zod.string(), zod.null()]).optional(),
      Quantity: zod.union([zod.string(), zod.null()]).optional(),
      DispenseUnitId: zod.union([zod.number(), zod.null()]).optional(),
      Refills: zod.union([zod.string(), zod.null()]).optional(),
      DaysSupply: zod.union([zod.number(), zod.null()]).optional(),
      PharmacyId: zod.union([zod.number(), zod.null()]).optional(),
      PharmacyNotes: zod.union([zod.string(), zod.null()]).optional(),
      NoSubstitutions: zod.union([zod.boolean(), zod.null()]).optional(),
      EffectiveDate: zod.union([zod.string(), zod.null()]).optional(),
      LastFillDate: zod.union([zod.string(), zod.null()]).optional(),
      PrescriberId: zod.union([zod.number(), zod.null()]).optional(),
      PrescriberAgentId: zod.union([zod.number(), zod.null()]).optional(),
      RxReferenceNumber: zod.union([zod.string(), zod.null()]).optional(),
      Status: zod
        .union([
          zod
            .enum([
              "Unknown",
              "Entered",
              "Printed",
              "Sending",
              "eRxSent",
              "FaxSent",
              "Error",
              "Deleted",
              "Requested",
              "Edited",
              "EpcsError",
              "EpcsSigned",
              "ReadyToSign",
              "PharmacyVerified",
              "PharmacySelect",
            ])
            .describe("Valid prescription status types for DoseSpot."),
          zod.null(),
        ])
        .optional(),
      Formulary: zod.union([zod.boolean(), zod.null()]).optional(),
      EligibilityId: zod.union([zod.number(), zod.null()]).optional(),
      Type: zod
        .union([
          zod
            .enum(["Coded", "FreeText", "NDC", "Supply", "Compound"])
            .describe("Valid prescription types for DoseSpot."),
          zod.null(),
        ])
        .optional(),
      NonDoseSpotPrescriptionId: zod
        .union([zod.string(), zod.null()])
        .optional(),
      ErrorIgnored: zod.union([zod.boolean(), zod.null()]).optional(),
      SupplyId: zod.union([zod.number(), zod.null()]).optional(),
      FreeTextType: zod
        .union([
          zod
            .enum(["Medication", "Supply", "Compound"])
            .describe("Valid free text types for DoseSpot prescriptions."),
          zod.null(),
        ])
        .optional(),
      ClinicId: zod.union([zod.number(), zod.null()]).optional(),
      SupervisorId: zod.union([zod.number(), zod.null()]).optional(),
      IsUrgent: zod.union([zod.boolean(), zod.null()]).optional(),
      IsRxRenewal: zod.union([zod.boolean(), zod.null()]).optional(),
      RxRenewalNote: zod.union([zod.string(), zod.null()]).optional(),
      FirstPrescriptionDiagnosis: zod
        .union([
          zod
            .object({
              PrimaryDiagnosis: zod
                .union([
                  zod
                    .object({
                      DiagnosisId: zod
                        .union([zod.number(), zod.null()])
                        .optional(),
                      DiagnosisCode: zod
                        .union([zod.string(), zod.null()])
                        .optional(),
                      DiagnosisDescription: zod
                        .union([zod.string(), zod.null()])
                        .optional(),
                    })
                    .describe("DoseSpot diagnosis information."),
                  zod.null(),
                ])
                .optional(),
              SecondaryDiagnosis: zod
                .union([
                  zod
                    .object({
                      DiagnosisId: zod
                        .union([zod.number(), zod.null()])
                        .optional(),
                      DiagnosisCode: zod
                        .union([zod.string(), zod.null()])
                        .optional(),
                      DiagnosisDescription: zod
                        .union([zod.string(), zod.null()])
                        .optional(),
                    })
                    .describe("DoseSpot diagnosis information."),
                  zod.null(),
                ])
                .optional(),
            })
            .describe("DoseSpot prescription diagnosis information."),
          zod.null(),
        ])
        .optional(),
      SecondPrescriptionDiagnosis: zod
        .union([
          zod
            .object({
              PrimaryDiagnosis: zod
                .union([
                  zod
                    .object({
                      DiagnosisId: zod
                        .union([zod.number(), zod.null()])
                        .optional(),
                      DiagnosisCode: zod
                        .union([zod.string(), zod.null()])
                        .optional(),
                      DiagnosisDescription: zod
                        .union([zod.string(), zod.null()])
                        .optional(),
                    })
                    .describe("DoseSpot diagnosis information."),
                  zod.null(),
                ])
                .optional(),
              SecondaryDiagnosis: zod
                .union([
                  zod
                    .object({
                      DiagnosisId: zod
                        .union([zod.number(), zod.null()])
                        .optional(),
                      DiagnosisCode: zod
                        .union([zod.string(), zod.null()])
                        .optional(),
                      DiagnosisDescription: zod
                        .union([zod.string(), zod.null()])
                        .optional(),
                    })
                    .describe("DoseSpot diagnosis information."),
                  zod.null(),
                ])
                .optional(),
            })
            .describe("DoseSpot prescription diagnosis information."),
          zod.null(),
        ])
        .optional(),
      Strength: zod.union([zod.string(), zod.null()]).optional(),
      PatientMedicationId: zod.union([zod.number(), zod.null()]).optional(),
      MedicationStatus: zod
        .union([
          zod
            .enum([
              "Unknown",
              "Active",
              "Inactive",
              "Discontinued",
              "Deleted",
              "Completed",
              "CancelRequested",
              "CancelPending",
              "Cancelled",
              "CancelDenied",
              "Changed",
              "FullFill",
              "PartialFill",
              "NoFill",
            ])
            .describe("Valid medication status types for DoseSpot."),
          zod.null(),
        ])
        .optional(),
      Comment: zod.union([zod.string(), zod.null()]).optional(),
      DateInactive: zod.union([zod.string(), zod.null()]).optional(),
      Encounter: zod.union([zod.string(), zod.null()]).optional(),
      DisplayName: zod.union([zod.string(), zod.null()]).optional(),
      DispensableDrugId: zod.union([zod.number(), zod.null()]).optional(),
      Schedule: zod.union([zod.number(), zod.null()]).optional(),
      CompoundIngredients: zod
        .union([
          zod.array(
            zod
              .object({
                DispensableDrugId: zod
                  .union([zod.number(), zod.null()])
                  .optional(),
                FreeText: zod.union([zod.string(), zod.null()]).optional(),
                DispenseUnitId: zod
                  .union([zod.number(), zod.null()])
                  .optional(),
                Quantity: zod.string(),
                IsFreeTextEPCS: zod
                  .union([zod.boolean(), zod.null()])
                  .optional(),
              })
              .describe("DoseSpot compound ingredient information."),
          ),
          zod.null(),
        ])
        .optional(),
    })
    .describe("Complete prescription information from DoseSpot API."),
  zod.null(),
]);

/**
 * Get patient information by DoseSpot patient ID.

This endpoint fetches patient details directly from DoseSpot using the
patient ID, useful for displaying transmission error details.

Args:
    dosespot_patient_id: The DoseSpot patient ID

Returns:
    PatientT or None: The patient information if found

Raises:
    AuthException: If the user lacks required privileges
    ValueError: If user doesn't have a DoseSpot clinician record
 * @summary Get Patient By Dosespot Id
 */
export const getPatientByDosespotIdParams = zod.object({
  dosespot_patient_id: zod.string(),
});

export const getPatientByDosespotIdResponse = zod.union([
  zod
    .object({
      FirstName: zod.string(),
      LastName: zod.string(),
      DateOfBirth: zod.string(),
      Gender: zod.enum(["Male", "Female", "Unknown"]),
      Address1: zod.string(),
      City: zod.string(),
      State: zod.string(),
      ZipCode: zod.string(),
      PrimaryPhone: zod.union([zod.string(), zod.null()]).optional(),
      Active: zod.boolean(),
      PatientId: zod.union([zod.number(), zod.null()]).optional(),
      Prefix: zod.union([zod.string(), zod.null()]).optional(),
      MiddleName: zod.union([zod.string(), zod.null()]).optional(),
      Suffix: zod.union([zod.string(), zod.null()]).optional(),
      Email: zod.union([zod.string(), zod.null()]).optional(),
      Address2: zod.union([zod.string(), zod.null()]).optional(),
      PhoneAdditional1: zod.union([zod.string(), zod.null()]).optional(),
      PhoneAdditional2: zod.union([zod.string(), zod.null()]).optional(),
      PhoneAdditionalType1: zod
        .union([
          zod.enum([
            "Undefined",
            "Beeper",
            "Cell",
            "Fax",
            "Home",
            "Work",
            "Night",
            "Primary",
          ]),
          zod.null(),
        ])
        .optional(),
      PhoneAdditionalType2: zod
        .union([
          zod.enum([
            "Undefined",
            "Beeper",
            "Cell",
            "Fax",
            "Home",
            "Work",
            "Night",
            "Primary",
          ]),
          zod.null(),
        ])
        .optional(),
      PrimaryPhoneType: zod
        .union([
          zod.enum([
            "Undefined",
            "Beeper",
            "Cell",
            "Fax",
            "Home",
            "Work",
            "Night",
            "Primary",
          ]),
          zod.null(),
        ])
        .optional(),
      Weight: zod.union([zod.number(), zod.null()]).optional(),
      WeightMetric: zod
        .union([
          zod
            .enum(["lb", "kg"])
            .describe("Valid weight metrics for DoseSpot patients."),
          zod.null(),
        ])
        .optional(),
      Height: zod.union([zod.number(), zod.null()]).optional(),
      HeightMetric: zod
        .union([
          zod
            .enum(["inch", "cm"])
            .describe("Valid height metrics for DoseSpot patients."),
          zod.null(),
        ])
        .optional(),
      NonDoseSpotMedicalRecordNumber: zod
        .union([zod.string(), zod.null()])
        .optional(),
      Encounter: zod.union([zod.string(), zod.null()]).optional(),
      IsHospice: zod.union([zod.boolean(), zod.null()]).optional(),
      Last4SSN: zod.union([zod.string(), zod.null()]).optional(),
    })
    .describe("Patient demographic information from DoseSpot API."),
  zod.null(),
]);

/**
 * Get prescription logs (full history) for a specific prescription.

This endpoint retrieves the complete history of a prescription including all
status changes and updates.

Args:
    user_id: The patient's user ID
    dosespot_prescription_id: The DoseSpot prescription ID

Returns:
    List[PrescriptionLogT]: List of prescription log entries

Raises:
    AuthException: If the user lacks required privileges
    ValueError: If the prescription record is not found or request fails
 * @summary Get Prescription Logs
 */
export const getPrescriptionLogsParams = zod.object({
  user_id: zod.uuid(),
  dosespot_prescription_id: zod.string(),
});

export const getPrescriptionLogsResponseItem = zod
  .object({
    Status: zod
      .union([
        zod
          .enum([
            "Unknown",
            "Entered",
            "Printed",
            "Sending",
            "eRxSent",
            "FaxSent",
            "Error",
            "Deleted",
            "Requested",
            "Edited",
            "EpcsError",
            "EpcsSigned",
            "ReadyToSign",
            "PharmacyVerified",
            "PharmacySelect",
          ])
          .describe("Valid prescription status types for DoseSpot."),
        zod.null(),
      ])
      .optional(),
    DateTimeStamp: zod.union([zod.string(), zod.null()]).optional(),
    AdditionalInfo: zod.union([zod.string(), zod.null()]).optional(),
    Ignored: zod.union([zod.boolean(), zod.null()]).optional(),
    User: zod.union([zod.string(), zod.null()]).optional(),
    WasRefillRequest: zod.union([zod.boolean(), zod.null()]).optional(),
    MedicationStatus: zod
      .union([
        zod
          .enum([
            "Unknown",
            "Active",
            "Inactive",
            "Discontinued",
            "Deleted",
            "Completed",
            "CancelRequested",
            "CancelPending",
            "Cancelled",
            "CancelDenied",
            "Changed",
            "FullFill",
            "PartialFill",
            "NoFill",
          ])
          .describe("Valid medication status types for DoseSpot."),
        zod.null(),
      ])
      .optional(),
  })
  .describe("DoseSpot prescription log entry.");
export const getPrescriptionLogsResponse = zod.array(
  getPrescriptionLogsResponseItem,
);

/**
 * Get pending refill requests for the authenticated user's associated clinic(s).

This endpoint retrieves basic refill request information with optional filtering
by clinic and patient, with pagination support.

Args:
    clinic: The clinic to filter by (optional)
    patientId: The patient ID to filter by (optional)
    pageNumber: The page number to retrieve (1-based, optional)

Returns:
    RefillPagedListResponseT: Paged list of pending refill requests

Raises:
    AuthException: If the user lacks required privileges
    ValueError: If user doesn't have a DoseSpot clinician record
 * @summary Get Pending Refills
 */
export const getPendingRefillsQueryParams = zod.object({
  clinic: zod.union([zod.string(), zod.null()]).optional(),
  patientId: zod.union([zod.number(), zod.null()]).optional(),
  pageNumber: zod.union([zod.number(), zod.null()]).optional(),
});

export const getPendingRefillsResponse = zod
  .object({
    Items: zod
      .union([
        zod.array(
          zod
            .object({
              RefillId: zod.union([zod.number(), zod.null()]).optional(),
              NewPatient: zod.union([zod.boolean(), zod.null()]).optional(),
              Patient: zod
                .union([
                  zod
                    .object({
                      FirstName: zod.string(),
                      LastName: zod.string(),
                      DateOfBirth: zod.string(),
                      Gender: zod.enum(["Male", "Female", "Unknown"]),
                      Address1: zod.string(),
                      City: zod.string(),
                      State: zod.string(),
                      ZipCode: zod.string(),
                      PrimaryPhone: zod
                        .union([zod.string(), zod.null()])
                        .optional(),
                      Active: zod.boolean(),
                      PatientId: zod
                        .union([zod.number(), zod.null()])
                        .optional(),
                      Prefix: zod.union([zod.string(), zod.null()]).optional(),
                      MiddleName: zod
                        .union([zod.string(), zod.null()])
                        .optional(),
                      Suffix: zod.union([zod.string(), zod.null()]).optional(),
                      Email: zod.union([zod.string(), zod.null()]).optional(),
                      Address2: zod
                        .union([zod.string(), zod.null()])
                        .optional(),
                      PhoneAdditional1: zod
                        .union([zod.string(), zod.null()])
                        .optional(),
                      PhoneAdditional2: zod
                        .union([zod.string(), zod.null()])
                        .optional(),
                      PhoneAdditionalType1: zod
                        .union([
                          zod.enum([
                            "Undefined",
                            "Beeper",
                            "Cell",
                            "Fax",
                            "Home",
                            "Work",
                            "Night",
                            "Primary",
                          ]),
                          zod.null(),
                        ])
                        .optional(),
                      PhoneAdditionalType2: zod
                        .union([
                          zod.enum([
                            "Undefined",
                            "Beeper",
                            "Cell",
                            "Fax",
                            "Home",
                            "Work",
                            "Night",
                            "Primary",
                          ]),
                          zod.null(),
                        ])
                        .optional(),
                      PrimaryPhoneType: zod
                        .union([
                          zod.enum([
                            "Undefined",
                            "Beeper",
                            "Cell",
                            "Fax",
                            "Home",
                            "Work",
                            "Night",
                            "Primary",
                          ]),
                          zod.null(),
                        ])
                        .optional(),
                      Weight: zod.union([zod.number(), zod.null()]).optional(),
                      WeightMetric: zod
                        .union([
                          zod
                            .enum(["lb", "kg"])
                            .describe(
                              "Valid weight metrics for DoseSpot patients.",
                            ),
                          zod.null(),
                        ])
                        .optional(),
                      Height: zod.union([zod.number(), zod.null()]).optional(),
                      HeightMetric: zod
                        .union([
                          zod
                            .enum(["inch", "cm"])
                            .describe(
                              "Valid height metrics for DoseSpot patients.",
                            ),
                          zod.null(),
                        ])
                        .optional(),
                      NonDoseSpotMedicalRecordNumber: zod
                        .union([zod.string(), zod.null()])
                        .optional(),
                      Encounter: zod
                        .union([zod.string(), zod.null()])
                        .optional(),
                      IsHospice: zod
                        .union([zod.boolean(), zod.null()])
                        .optional(),
                      Last4SSN: zod
                        .union([zod.string(), zod.null()])
                        .optional(),
                    })
                    .describe(
                      "Patient demographic information from DoseSpot API.",
                    ),
                  zod.null(),
                ])
                .optional(),
              ClinicId: zod.union([zod.number(), zod.null()]).optional(),
              ClinicianId: zod.union([zod.number(), zod.null()]).optional(),
              RequestedPrescriptionId: zod
                .union([zod.number(), zod.null()])
                .optional(),
              DispensedPrescriptionId: zod
                .union([zod.number(), zod.null()])
                .optional(),
              OriginalPrescriptionId: zod
                .union([zod.number(), zod.null()])
                .optional(),
              PharmacyId: zod.union([zod.number(), zod.null()]).optional(),
              RequestedDate: zod.union([zod.string(), zod.null()]).optional(),
            })
            .describe("Basic refill request information."),
        ),
        zod.null(),
      ])
      .optional(),
    PageResult: zod
      .union([
        zod
          .object({
            CurrentPage: zod.union([zod.number(), zod.null()]).optional(),
            TotalPages: zod.union([zod.number(), zod.null()]).optional(),
            PageSize: zod.union([zod.number(), zod.null()]).optional(),
            TotalCount: zod.union([zod.number(), zod.null()]).optional(),
            HasPrevious: zod.union([zod.boolean(), zod.null()]).optional(),
            HasNext: zod.union([zod.boolean(), zod.null()]).optional(),
          })
          .describe("DoseSpot page result information."),
        zod.null(),
      ])
      .optional(),
    Result: zod
      .union([
        zod
          .object({
            ResultCode: zod.string(),
            ResultDescription: zod.union([zod.string(), zod.null()]).optional(),
          })
          .describe("Standard DoseSpot API result object."),
        zod.null(),
      ])
      .optional(),
  })
  .describe("Paged list response for basic refill requests.");

/**
 * Get detailed pending refill requests for the authenticated user's associated clinic(s).

This endpoint retrieves detailed refill request information including full prescription
details, with optional filtering by clinic and patient, and pagination support.

Args:
    clinic: The clinic to filter by (optional)
    patientId: The patient ID to filter by (optional)
    pageNumber: The page number to retrieve (1-based, optional)

Returns:
    RefillDetailedPagedListResponseT: Paged list of detailed pending refill requests

Raises:
    AuthException: If the user lacks required privileges
    ValueError: If user doesn't have a DoseSpot clinician record
 * @summary Get Pending Refills Detailed
 */
export const getPendingRefillsDetailedQueryParams = zod.object({
  clinic: zod.union([zod.string(), zod.null()]).optional(),
  patientId: zod.union([zod.number(), zod.null()]).optional(),
  pageNumber: zod.union([zod.number(), zod.null()]).optional(),
});

export const getPendingRefillsDetailedResponse = zod
  .object({
    Items: zod
      .union([
        zod.array(
          zod
            .object({
              RefillId: zod.union([zod.number(), zod.null()]).optional(),
              NewPatient: zod.union([zod.boolean(), zod.null()]).optional(),
              Patient: zod
                .union([
                  zod
                    .object({
                      FirstName: zod.string(),
                      LastName: zod.string(),
                      DateOfBirth: zod.string(),
                      Gender: zod.enum(["Male", "Female", "Unknown"]),
                      Address1: zod.string(),
                      City: zod.string(),
                      State: zod.string(),
                      ZipCode: zod.string(),
                      PrimaryPhone: zod
                        .union([zod.string(), zod.null()])
                        .optional(),
                      Active: zod.boolean(),
                      PatientId: zod
                        .union([zod.number(), zod.null()])
                        .optional(),
                      Prefix: zod.union([zod.string(), zod.null()]).optional(),
                      MiddleName: zod
                        .union([zod.string(), zod.null()])
                        .optional(),
                      Suffix: zod.union([zod.string(), zod.null()]).optional(),
                      Email: zod.union([zod.string(), zod.null()]).optional(),
                      Address2: zod
                        .union([zod.string(), zod.null()])
                        .optional(),
                      PhoneAdditional1: zod
                        .union([zod.string(), zod.null()])
                        .optional(),
                      PhoneAdditional2: zod
                        .union([zod.string(), zod.null()])
                        .optional(),
                      PhoneAdditionalType1: zod
                        .union([
                          zod.enum([
                            "Undefined",
                            "Beeper",
                            "Cell",
                            "Fax",
                            "Home",
                            "Work",
                            "Night",
                            "Primary",
                          ]),
                          zod.null(),
                        ])
                        .optional(),
                      PhoneAdditionalType2: zod
                        .union([
                          zod.enum([
                            "Undefined",
                            "Beeper",
                            "Cell",
                            "Fax",
                            "Home",
                            "Work",
                            "Night",
                            "Primary",
                          ]),
                          zod.null(),
                        ])
                        .optional(),
                      PrimaryPhoneType: zod
                        .union([
                          zod.enum([
                            "Undefined",
                            "Beeper",
                            "Cell",
                            "Fax",
                            "Home",
                            "Work",
                            "Night",
                            "Primary",
                          ]),
                          zod.null(),
                        ])
                        .optional(),
                      Weight: zod.union([zod.number(), zod.null()]).optional(),
                      WeightMetric: zod
                        .union([
                          zod
                            .enum(["lb", "kg"])
                            .describe(
                              "Valid weight metrics for DoseSpot patients.",
                            ),
                          zod.null(),
                        ])
                        .optional(),
                      Height: zod.union([zod.number(), zod.null()]).optional(),
                      HeightMetric: zod
                        .union([
                          zod
                            .enum(["inch", "cm"])
                            .describe(
                              "Valid height metrics for DoseSpot patients.",
                            ),
                          zod.null(),
                        ])
                        .optional(),
                      NonDoseSpotMedicalRecordNumber: zod
                        .union([zod.string(), zod.null()])
                        .optional(),
                      Encounter: zod
                        .union([zod.string(), zod.null()])
                        .optional(),
                      IsHospice: zod
                        .union([zod.boolean(), zod.null()])
                        .optional(),
                      Last4SSN: zod
                        .union([zod.string(), zod.null()])
                        .optional(),
                    })
                    .describe(
                      "Patient demographic information from DoseSpot API.",
                    ),
                  zod.null(),
                ])
                .optional(),
              ClinicId: zod.union([zod.number(), zod.null()]).optional(),
              ClinicianId: zod.union([zod.number(), zod.null()]).optional(),
              RequestedPrescription: zod
                .union([
                  zod
                    .object({
                      PrescriptionId: zod
                        .union([zod.number(), zod.null()])
                        .optional(),
                      PriorAuthorizationCaseId: zod
                        .union([zod.number(), zod.null()])
                        .optional(),
                      WrittenDate: zod
                        .union([zod.string(), zod.null()])
                        .optional(),
                      Directions: zod
                        .union([zod.string(), zod.null()])
                        .optional(),
                      Quantity: zod
                        .union([zod.string(), zod.null()])
                        .optional(),
                      DispenseUnitId: zod
                        .union([zod.number(), zod.null()])
                        .optional(),
                      Refills: zod.union([zod.string(), zod.null()]).optional(),
                      DaysSupply: zod
                        .union([zod.number(), zod.null()])
                        .optional(),
                      PharmacyId: zod
                        .union([zod.number(), zod.null()])
                        .optional(),
                      PharmacyNotes: zod
                        .union([zod.string(), zod.null()])
                        .optional(),
                      NoSubstitutions: zod
                        .union([zod.boolean(), zod.null()])
                        .optional(),
                      EffectiveDate: zod
                        .union([zod.string(), zod.null()])
                        .optional(),
                      LastFillDate: zod
                        .union([zod.string(), zod.null()])
                        .optional(),
                      PrescriberId: zod
                        .union([zod.number(), zod.null()])
                        .optional(),
                      PrescriberAgentId: zod
                        .union([zod.number(), zod.null()])
                        .optional(),
                      RxReferenceNumber: zod
                        .union([zod.string(), zod.null()])
                        .optional(),
                      Status: zod
                        .union([
                          zod
                            .enum([
                              "Unknown",
                              "Entered",
                              "Printed",
                              "Sending",
                              "eRxSent",
                              "FaxSent",
                              "Error",
                              "Deleted",
                              "Requested",
                              "Edited",
                              "EpcsError",
                              "EpcsSigned",
                              "ReadyToSign",
                              "PharmacyVerified",
                              "PharmacySelect",
                            ])
                            .describe(
                              "Valid prescription status types for DoseSpot.",
                            ),
                          zod.null(),
                        ])
                        .optional(),
                      Formulary: zod
                        .union([zod.boolean(), zod.null()])
                        .optional(),
                      EligibilityId: zod
                        .union([zod.number(), zod.null()])
                        .optional(),
                      Type: zod
                        .union([
                          zod
                            .enum([
                              "Coded",
                              "FreeText",
                              "NDC",
                              "Supply",
                              "Compound",
                            ])
                            .describe("Valid prescription types for DoseSpot."),
                          zod.null(),
                        ])
                        .optional(),
                      NonDoseSpotPrescriptionId: zod
                        .union([zod.string(), zod.null()])
                        .optional(),
                      ErrorIgnored: zod
                        .union([zod.boolean(), zod.null()])
                        .optional(),
                      SupplyId: zod
                        .union([zod.number(), zod.null()])
                        .optional(),
                      FreeTextType: zod
                        .union([
                          zod
                            .enum(["Medication", "Supply", "Compound"])
                            .describe(
                              "Valid free text types for DoseSpot prescriptions.",
                            ),
                          zod.null(),
                        ])
                        .optional(),
                      ClinicId: zod
                        .union([zod.number(), zod.null()])
                        .optional(),
                      SupervisorId: zod
                        .union([zod.number(), zod.null()])
                        .optional(),
                      IsUrgent: zod
                        .union([zod.boolean(), zod.null()])
                        .optional(),
                      IsRxRenewal: zod
                        .union([zod.boolean(), zod.null()])
                        .optional(),
                      RxRenewalNote: zod
                        .union([zod.string(), zod.null()])
                        .optional(),
                      FirstPrescriptionDiagnosis: zod
                        .union([
                          zod
                            .object({
                              PrimaryDiagnosis: zod
                                .union([
                                  zod
                                    .object({
                                      DiagnosisId: zod
                                        .union([zod.number(), zod.null()])
                                        .optional(),
                                      DiagnosisCode: zod
                                        .union([zod.string(), zod.null()])
                                        .optional(),
                                      DiagnosisDescription: zod
                                        .union([zod.string(), zod.null()])
                                        .optional(),
                                    })
                                    .describe(
                                      "DoseSpot diagnosis information.",
                                    ),
                                  zod.null(),
                                ])
                                .optional(),
                              SecondaryDiagnosis: zod
                                .union([
                                  zod
                                    .object({
                                      DiagnosisId: zod
                                        .union([zod.number(), zod.null()])
                                        .optional(),
                                      DiagnosisCode: zod
                                        .union([zod.string(), zod.null()])
                                        .optional(),
                                      DiagnosisDescription: zod
                                        .union([zod.string(), zod.null()])
                                        .optional(),
                                    })
                                    .describe(
                                      "DoseSpot diagnosis information.",
                                    ),
                                  zod.null(),
                                ])
                                .optional(),
                            })
                            .describe(
                              "DoseSpot prescription diagnosis information.",
                            ),
                          zod.null(),
                        ])
                        .optional(),
                      SecondPrescriptionDiagnosis: zod
                        .union([
                          zod
                            .object({
                              PrimaryDiagnosis: zod
                                .union([
                                  zod
                                    .object({
                                      DiagnosisId: zod
                                        .union([zod.number(), zod.null()])
                                        .optional(),
                                      DiagnosisCode: zod
                                        .union([zod.string(), zod.null()])
                                        .optional(),
                                      DiagnosisDescription: zod
                                        .union([zod.string(), zod.null()])
                                        .optional(),
                                    })
                                    .describe(
                                      "DoseSpot diagnosis information.",
                                    ),
                                  zod.null(),
                                ])
                                .optional(),
                              SecondaryDiagnosis: zod
                                .union([
                                  zod
                                    .object({
                                      DiagnosisId: zod
                                        .union([zod.number(), zod.null()])
                                        .optional(),
                                      DiagnosisCode: zod
                                        .union([zod.string(), zod.null()])
                                        .optional(),
                                      DiagnosisDescription: zod
                                        .union([zod.string(), zod.null()])
                                        .optional(),
                                    })
                                    .describe(
                                      "DoseSpot diagnosis information.",
                                    ),
                                  zod.null(),
                                ])
                                .optional(),
                            })
                            .describe(
                              "DoseSpot prescription diagnosis information.",
                            ),
                          zod.null(),
                        ])
                        .optional(),
                      Strength: zod
                        .union([zod.string(), zod.null()])
                        .optional(),
                      PatientMedicationId: zod
                        .union([zod.number(), zod.null()])
                        .optional(),
                      MedicationStatus: zod
                        .union([
                          zod
                            .enum([
                              "Unknown",
                              "Active",
                              "Inactive",
                              "Discontinued",
                              "Deleted",
                              "Completed",
                              "CancelRequested",
                              "CancelPending",
                              "Cancelled",
                              "CancelDenied",
                              "Changed",
                              "FullFill",
                              "PartialFill",
                              "NoFill",
                            ])
                            .describe(
                              "Valid medication status types for DoseSpot.",
                            ),
                          zod.null(),
                        ])
                        .optional(),
                      Comment: zod.union([zod.string(), zod.null()]).optional(),
                      DateInactive: zod
                        .union([zod.string(), zod.null()])
                        .optional(),
                      Encounter: zod
                        .union([zod.string(), zod.null()])
                        .optional(),
                      DisplayName: zod
                        .union([zod.string(), zod.null()])
                        .optional(),
                      DispensableDrugId: zod
                        .union([zod.number(), zod.null()])
                        .optional(),
                      Schedule: zod
                        .union([zod.number(), zod.null()])
                        .optional(),
                      CompoundIngredients: zod
                        .union([
                          zod.array(
                            zod
                              .object({
                                DispensableDrugId: zod
                                  .union([zod.number(), zod.null()])
                                  .optional(),
                                FreeText: zod
                                  .union([zod.string(), zod.null()])
                                  .optional(),
                                DispenseUnitId: zod
                                  .union([zod.number(), zod.null()])
                                  .optional(),
                                Quantity: zod.string(),
                                IsFreeTextEPCS: zod
                                  .union([zod.boolean(), zod.null()])
                                  .optional(),
                              })
                              .describe(
                                "DoseSpot compound ingredient information.",
                              ),
                          ),
                          zod.null(),
                        ])
                        .optional(),
                    })
                    .describe(
                      "Complete prescription information from DoseSpot API.",
                    ),
                  zod.null(),
                ])
                .optional(),
              DispensedPrescription: zod
                .union([
                  zod
                    .object({
                      PrescriptionId: zod
                        .union([zod.number(), zod.null()])
                        .optional(),
                      PriorAuthorizationCaseId: zod
                        .union([zod.number(), zod.null()])
                        .optional(),
                      WrittenDate: zod
                        .union([zod.string(), zod.null()])
                        .optional(),
                      Directions: zod
                        .union([zod.string(), zod.null()])
                        .optional(),
                      Quantity: zod
                        .union([zod.string(), zod.null()])
                        .optional(),
                      DispenseUnitId: zod
                        .union([zod.number(), zod.null()])
                        .optional(),
                      Refills: zod.union([zod.string(), zod.null()]).optional(),
                      DaysSupply: zod
                        .union([zod.number(), zod.null()])
                        .optional(),
                      PharmacyId: zod
                        .union([zod.number(), zod.null()])
                        .optional(),
                      PharmacyNotes: zod
                        .union([zod.string(), zod.null()])
                        .optional(),
                      NoSubstitutions: zod
                        .union([zod.boolean(), zod.null()])
                        .optional(),
                      EffectiveDate: zod
                        .union([zod.string(), zod.null()])
                        .optional(),
                      LastFillDate: zod
                        .union([zod.string(), zod.null()])
                        .optional(),
                      PrescriberId: zod
                        .union([zod.number(), zod.null()])
                        .optional(),
                      PrescriberAgentId: zod
                        .union([zod.number(), zod.null()])
                        .optional(),
                      RxReferenceNumber: zod
                        .union([zod.string(), zod.null()])
                        .optional(),
                      Status: zod
                        .union([
                          zod
                            .enum([
                              "Unknown",
                              "Entered",
                              "Printed",
                              "Sending",
                              "eRxSent",
                              "FaxSent",
                              "Error",
                              "Deleted",
                              "Requested",
                              "Edited",
                              "EpcsError",
                              "EpcsSigned",
                              "ReadyToSign",
                              "PharmacyVerified",
                              "PharmacySelect",
                            ])
                            .describe(
                              "Valid prescription status types for DoseSpot.",
                            ),
                          zod.null(),
                        ])
                        .optional(),
                      Formulary: zod
                        .union([zod.boolean(), zod.null()])
                        .optional(),
                      EligibilityId: zod
                        .union([zod.number(), zod.null()])
                        .optional(),
                      Type: zod
                        .union([
                          zod
                            .enum([
                              "Coded",
                              "FreeText",
                              "NDC",
                              "Supply",
                              "Compound",
                            ])
                            .describe("Valid prescription types for DoseSpot."),
                          zod.null(),
                        ])
                        .optional(),
                      NonDoseSpotPrescriptionId: zod
                        .union([zod.string(), zod.null()])
                        .optional(),
                      ErrorIgnored: zod
                        .union([zod.boolean(), zod.null()])
                        .optional(),
                      SupplyId: zod
                        .union([zod.number(), zod.null()])
                        .optional(),
                      FreeTextType: zod
                        .union([
                          zod
                            .enum(["Medication", "Supply", "Compound"])
                            .describe(
                              "Valid free text types for DoseSpot prescriptions.",
                            ),
                          zod.null(),
                        ])
                        .optional(),
                      ClinicId: zod
                        .union([zod.number(), zod.null()])
                        .optional(),
                      SupervisorId: zod
                        .union([zod.number(), zod.null()])
                        .optional(),
                      IsUrgent: zod
                        .union([zod.boolean(), zod.null()])
                        .optional(),
                      IsRxRenewal: zod
                        .union([zod.boolean(), zod.null()])
                        .optional(),
                      RxRenewalNote: zod
                        .union([zod.string(), zod.null()])
                        .optional(),
                      FirstPrescriptionDiagnosis: zod
                        .union([
                          zod
                            .object({
                              PrimaryDiagnosis: zod
                                .union([
                                  zod
                                    .object({
                                      DiagnosisId: zod
                                        .union([zod.number(), zod.null()])
                                        .optional(),
                                      DiagnosisCode: zod
                                        .union([zod.string(), zod.null()])
                                        .optional(),
                                      DiagnosisDescription: zod
                                        .union([zod.string(), zod.null()])
                                        .optional(),
                                    })
                                    .describe(
                                      "DoseSpot diagnosis information.",
                                    ),
                                  zod.null(),
                                ])
                                .optional(),
                              SecondaryDiagnosis: zod
                                .union([
                                  zod
                                    .object({
                                      DiagnosisId: zod
                                        .union([zod.number(), zod.null()])
                                        .optional(),
                                      DiagnosisCode: zod
                                        .union([zod.string(), zod.null()])
                                        .optional(),
                                      DiagnosisDescription: zod
                                        .union([zod.string(), zod.null()])
                                        .optional(),
                                    })
                                    .describe(
                                      "DoseSpot diagnosis information.",
                                    ),
                                  zod.null(),
                                ])
                                .optional(),
                            })
                            .describe(
                              "DoseSpot prescription diagnosis information.",
                            ),
                          zod.null(),
                        ])
                        .optional(),
                      SecondPrescriptionDiagnosis: zod
                        .union([
                          zod
                            .object({
                              PrimaryDiagnosis: zod
                                .union([
                                  zod
                                    .object({
                                      DiagnosisId: zod
                                        .union([zod.number(), zod.null()])
                                        .optional(),
                                      DiagnosisCode: zod
                                        .union([zod.string(), zod.null()])
                                        .optional(),
                                      DiagnosisDescription: zod
                                        .union([zod.string(), zod.null()])
                                        .optional(),
                                    })
                                    .describe(
                                      "DoseSpot diagnosis information.",
                                    ),
                                  zod.null(),
                                ])
                                .optional(),
                              SecondaryDiagnosis: zod
                                .union([
                                  zod
                                    .object({
                                      DiagnosisId: zod
                                        .union([zod.number(), zod.null()])
                                        .optional(),
                                      DiagnosisCode: zod
                                        .union([zod.string(), zod.null()])
                                        .optional(),
                                      DiagnosisDescription: zod
                                        .union([zod.string(), zod.null()])
                                        .optional(),
                                    })
                                    .describe(
                                      "DoseSpot diagnosis information.",
                                    ),
                                  zod.null(),
                                ])
                                .optional(),
                            })
                            .describe(
                              "DoseSpot prescription diagnosis information.",
                            ),
                          zod.null(),
                        ])
                        .optional(),
                      Strength: zod
                        .union([zod.string(), zod.null()])
                        .optional(),
                      PatientMedicationId: zod
                        .union([zod.number(), zod.null()])
                        .optional(),
                      MedicationStatus: zod
                        .union([
                          zod
                            .enum([
                              "Unknown",
                              "Active",
                              "Inactive",
                              "Discontinued",
                              "Deleted",
                              "Completed",
                              "CancelRequested",
                              "CancelPending",
                              "Cancelled",
                              "CancelDenied",
                              "Changed",
                              "FullFill",
                              "PartialFill",
                              "NoFill",
                            ])
                            .describe(
                              "Valid medication status types for DoseSpot.",
                            ),
                          zod.null(),
                        ])
                        .optional(),
                      Comment: zod.union([zod.string(), zod.null()]).optional(),
                      DateInactive: zod
                        .union([zod.string(), zod.null()])
                        .optional(),
                      Encounter: zod
                        .union([zod.string(), zod.null()])
                        .optional(),
                      DisplayName: zod
                        .union([zod.string(), zod.null()])
                        .optional(),
                      DispensableDrugId: zod
                        .union([zod.number(), zod.null()])
                        .optional(),
                      Schedule: zod
                        .union([zod.number(), zod.null()])
                        .optional(),
                      CompoundIngredients: zod
                        .union([
                          zod.array(
                            zod
                              .object({
                                DispensableDrugId: zod
                                  .union([zod.number(), zod.null()])
                                  .optional(),
                                FreeText: zod
                                  .union([zod.string(), zod.null()])
                                  .optional(),
                                DispenseUnitId: zod
                                  .union([zod.number(), zod.null()])
                                  .optional(),
                                Quantity: zod.string(),
                                IsFreeTextEPCS: zod
                                  .union([zod.boolean(), zod.null()])
                                  .optional(),
                              })
                              .describe(
                                "DoseSpot compound ingredient information.",
                              ),
                          ),
                          zod.null(),
                        ])
                        .optional(),
                    })
                    .describe(
                      "Complete prescription information from DoseSpot API.",
                    ),
                  zod.null(),
                ])
                .optional(),
              OriginalPrescription: zod
                .union([
                  zod
                    .object({
                      PrescriptionId: zod
                        .union([zod.number(), zod.null()])
                        .optional(),
                      PriorAuthorizationCaseId: zod
                        .union([zod.number(), zod.null()])
                        .optional(),
                      WrittenDate: zod
                        .union([zod.string(), zod.null()])
                        .optional(),
                      Directions: zod
                        .union([zod.string(), zod.null()])
                        .optional(),
                      Quantity: zod
                        .union([zod.string(), zod.null()])
                        .optional(),
                      DispenseUnitId: zod
                        .union([zod.number(), zod.null()])
                        .optional(),
                      Refills: zod.union([zod.string(), zod.null()]).optional(),
                      DaysSupply: zod
                        .union([zod.number(), zod.null()])
                        .optional(),
                      PharmacyId: zod
                        .union([zod.number(), zod.null()])
                        .optional(),
                      PharmacyNotes: zod
                        .union([zod.string(), zod.null()])
                        .optional(),
                      NoSubstitutions: zod
                        .union([zod.boolean(), zod.null()])
                        .optional(),
                      EffectiveDate: zod
                        .union([zod.string(), zod.null()])
                        .optional(),
                      LastFillDate: zod
                        .union([zod.string(), zod.null()])
                        .optional(),
                      PrescriberId: zod
                        .union([zod.number(), zod.null()])
                        .optional(),
                      PrescriberAgentId: zod
                        .union([zod.number(), zod.null()])
                        .optional(),
                      RxReferenceNumber: zod
                        .union([zod.string(), zod.null()])
                        .optional(),
                      Status: zod
                        .union([
                          zod
                            .enum([
                              "Unknown",
                              "Entered",
                              "Printed",
                              "Sending",
                              "eRxSent",
                              "FaxSent",
                              "Error",
                              "Deleted",
                              "Requested",
                              "Edited",
                              "EpcsError",
                              "EpcsSigned",
                              "ReadyToSign",
                              "PharmacyVerified",
                              "PharmacySelect",
                            ])
                            .describe(
                              "Valid prescription status types for DoseSpot.",
                            ),
                          zod.null(),
                        ])
                        .optional(),
                      Formulary: zod
                        .union([zod.boolean(), zod.null()])
                        .optional(),
                      EligibilityId: zod
                        .union([zod.number(), zod.null()])
                        .optional(),
                      Type: zod
                        .union([
                          zod
                            .enum([
                              "Coded",
                              "FreeText",
                              "NDC",
                              "Supply",
                              "Compound",
                            ])
                            .describe("Valid prescription types for DoseSpot."),
                          zod.null(),
                        ])
                        .optional(),
                      NonDoseSpotPrescriptionId: zod
                        .union([zod.string(), zod.null()])
                        .optional(),
                      ErrorIgnored: zod
                        .union([zod.boolean(), zod.null()])
                        .optional(),
                      SupplyId: zod
                        .union([zod.number(), zod.null()])
                        .optional(),
                      FreeTextType: zod
                        .union([
                          zod
                            .enum(["Medication", "Supply", "Compound"])
                            .describe(
                              "Valid free text types for DoseSpot prescriptions.",
                            ),
                          zod.null(),
                        ])
                        .optional(),
                      ClinicId: zod
                        .union([zod.number(), zod.null()])
                        .optional(),
                      SupervisorId: zod
                        .union([zod.number(), zod.null()])
                        .optional(),
                      IsUrgent: zod
                        .union([zod.boolean(), zod.null()])
                        .optional(),
                      IsRxRenewal: zod
                        .union([zod.boolean(), zod.null()])
                        .optional(),
                      RxRenewalNote: zod
                        .union([zod.string(), zod.null()])
                        .optional(),
                      FirstPrescriptionDiagnosis: zod
                        .union([
                          zod
                            .object({
                              PrimaryDiagnosis: zod
                                .union([
                                  zod
                                    .object({
                                      DiagnosisId: zod
                                        .union([zod.number(), zod.null()])
                                        .optional(),
                                      DiagnosisCode: zod
                                        .union([zod.string(), zod.null()])
                                        .optional(),
                                      DiagnosisDescription: zod
                                        .union([zod.string(), zod.null()])
                                        .optional(),
                                    })
                                    .describe(
                                      "DoseSpot diagnosis information.",
                                    ),
                                  zod.null(),
                                ])
                                .optional(),
                              SecondaryDiagnosis: zod
                                .union([
                                  zod
                                    .object({
                                      DiagnosisId: zod
                                        .union([zod.number(), zod.null()])
                                        .optional(),
                                      DiagnosisCode: zod
                                        .union([zod.string(), zod.null()])
                                        .optional(),
                                      DiagnosisDescription: zod
                                        .union([zod.string(), zod.null()])
                                        .optional(),
                                    })
                                    .describe(
                                      "DoseSpot diagnosis information.",
                                    ),
                                  zod.null(),
                                ])
                                .optional(),
                            })
                            .describe(
                              "DoseSpot prescription diagnosis information.",
                            ),
                          zod.null(),
                        ])
                        .optional(),
                      SecondPrescriptionDiagnosis: zod
                        .union([
                          zod
                            .object({
                              PrimaryDiagnosis: zod
                                .union([
                                  zod
                                    .object({
                                      DiagnosisId: zod
                                        .union([zod.number(), zod.null()])
                                        .optional(),
                                      DiagnosisCode: zod
                                        .union([zod.string(), zod.null()])
                                        .optional(),
                                      DiagnosisDescription: zod
                                        .union([zod.string(), zod.null()])
                                        .optional(),
                                    })
                                    .describe(
                                      "DoseSpot diagnosis information.",
                                    ),
                                  zod.null(),
                                ])
                                .optional(),
                              SecondaryDiagnosis: zod
                                .union([
                                  zod
                                    .object({
                                      DiagnosisId: zod
                                        .union([zod.number(), zod.null()])
                                        .optional(),
                                      DiagnosisCode: zod
                                        .union([zod.string(), zod.null()])
                                        .optional(),
                                      DiagnosisDescription: zod
                                        .union([zod.string(), zod.null()])
                                        .optional(),
                                    })
                                    .describe(
                                      "DoseSpot diagnosis information.",
                                    ),
                                  zod.null(),
                                ])
                                .optional(),
                            })
                            .describe(
                              "DoseSpot prescription diagnosis information.",
                            ),
                          zod.null(),
                        ])
                        .optional(),
                      Strength: zod
                        .union([zod.string(), zod.null()])
                        .optional(),
                      PatientMedicationId: zod
                        .union([zod.number(), zod.null()])
                        .optional(),
                      MedicationStatus: zod
                        .union([
                          zod
                            .enum([
                              "Unknown",
                              "Active",
                              "Inactive",
                              "Discontinued",
                              "Deleted",
                              "Completed",
                              "CancelRequested",
                              "CancelPending",
                              "Cancelled",
                              "CancelDenied",
                              "Changed",
                              "FullFill",
                              "PartialFill",
                              "NoFill",
                            ])
                            .describe(
                              "Valid medication status types for DoseSpot.",
                            ),
                          zod.null(),
                        ])
                        .optional(),
                      Comment: zod.union([zod.string(), zod.null()]).optional(),
                      DateInactive: zod
                        .union([zod.string(), zod.null()])
                        .optional(),
                      Encounter: zod
                        .union([zod.string(), zod.null()])
                        .optional(),
                      DisplayName: zod
                        .union([zod.string(), zod.null()])
                        .optional(),
                      DispensableDrugId: zod
                        .union([zod.number(), zod.null()])
                        .optional(),
                      Schedule: zod
                        .union([zod.number(), zod.null()])
                        .optional(),
                      CompoundIngredients: zod
                        .union([
                          zod.array(
                            zod
                              .object({
                                DispensableDrugId: zod
                                  .union([zod.number(), zod.null()])
                                  .optional(),
                                FreeText: zod
                                  .union([zod.string(), zod.null()])
                                  .optional(),
                                DispenseUnitId: zod
                                  .union([zod.number(), zod.null()])
                                  .optional(),
                                Quantity: zod.string(),
                                IsFreeTextEPCS: zod
                                  .union([zod.boolean(), zod.null()])
                                  .optional(),
                              })
                              .describe(
                                "DoseSpot compound ingredient information.",
                              ),
                          ),
                          zod.null(),
                        ])
                        .optional(),
                    })
                    .describe(
                      "Complete prescription information from DoseSpot API.",
                    ),
                  zod.null(),
                ])
                .optional(),
              PharmacyId: zod.union([zod.number(), zod.null()]).optional(),
              RequestedDate: zod.union([zod.string(), zod.null()]).optional(),
            })
            .describe(
              "Detailed refill request information with prescription details.",
            ),
        ),
        zod.null(),
      ])
      .optional(),
    PageResult: zod
      .union([
        zod
          .object({
            CurrentPage: zod.union([zod.number(), zod.null()]).optional(),
            TotalPages: zod.union([zod.number(), zod.null()]).optional(),
            PageSize: zod.union([zod.number(), zod.null()]).optional(),
            TotalCount: zod.union([zod.number(), zod.null()]).optional(),
            HasPrevious: zod.union([zod.boolean(), zod.null()]).optional(),
            HasNext: zod.union([zod.boolean(), zod.null()]).optional(),
          })
          .describe("DoseSpot page result information."),
        zod.null(),
      ])
      .optional(),
    Result: zod
      .union([
        zod
          .object({
            ResultCode: zod.string(),
            ResultDescription: zod.union([zod.string(), zod.null()]).optional(),
          })
          .describe("Standard DoseSpot API result object."),
        zod.null(),
      ])
      .optional(),
  })
  .describe("Paged list response for detailed refill requests.");

/**
 * Approve a pending refill request.

This endpoint approves a refill request by providing the number of refills
and optional comment and effective date.

Args:
    refill_id: The refill ID to approve
    request: The approval request containing refills count and optional fields

Returns:
    IdentifierResponseT: Response from the approval operation

Raises:
    AuthException: If the user lacks required privileges
    ValueError: If user doesn't have a DoseSpot clinician record or approval fails
 * @summary Approve Refill
 */
export const approveRefillParams = zod.object({
  refill_id: zod.number(),
});

export const approveRefillBodyRefillsMax = 99;

export const approveRefillBody = zod
  .object({
    Refills: zod.number().min(1).max(approveRefillBodyRefillsMax),
    Comment: zod.union([zod.string(), zod.null()]).optional(),
    EffectiveDate: zod.union([zod.string(), zod.null()]).optional(),
  })
  .describe("Request to approve a refill.");

export const approveRefillResponse = zod
  .object({
    Id: zod.union([zod.number(), zod.null()]).optional(),
    Result: zod
      .union([
        zod
          .object({
            ResultCode: zod.string(),
            ResultDescription: zod.union([zod.string(), zod.null()]).optional(),
          })
          .describe("Standard DoseSpot API result object."),
        zod.null(),
      ])
      .optional(),
  })
  .describe(
    "Response wrapper for operations that return an entity identifier.",
  );

/**
 * Deny a pending refill request.

This endpoint denies a refill request by providing the denial reason
and optional note.

Args:
    refill_id: The refill ID to deny
    request: The denial request containing denial reason and optional note

Returns:
    IdentifierResponseT: Response from the denial operation

Raises:
    AuthException: If the user lacks required privileges
    ValueError: If user doesn't have a DoseSpot clinician record or denial fails
 * @summary Deny Refill
 */
export const denyRefillParams = zod.object({
  refill_id: zod.number(),
});

export const denyRefillBody = zod
  .object({
    DenialReason: zod
      .enum([
        "DeniedPatientUnknown",
        "DeniedPatientNotUnderCare",
        "DeniedPatientNoLongerUnderPatientCare",
        "DeniedTooSoon",
        "DeniedNeverPrescribed",
        "DeniedHavePatientContact",
        "DeniedRefillInappropriate",
        "DeniedAlreadyPickedUp",
        "DeniedAlreadyPickedUpPartialFill",
        "DeniedNotPickedUp",
        "DeniedChangeInappropriate",
        "DeniedNeedAppointment",
        "DeniedPrescriberNotAssociateWithLocation",
        "DeniedNoPriorAuthAttempt",
        "DeniedAlreadyHandled",
        "DeniedAtPatientRequest",
        "DeniedPatientAllergicToRequestMed",
        "DeniedMedicationDiscontinued",
      ])
      .describe("Valid denial reasons for refill requests."),
    Note: zod.union([zod.string(), zod.null()]).optional(),
  })
  .describe("Request to deny a refill.");

export const denyRefillResponse = zod
  .object({
    Id: zod.union([zod.number(), zod.null()]).optional(),
    Result: zod
      .union([
        zod
          .object({
            ResultCode: zod.string(),
            ResultDescription: zod.union([zod.string(), zod.null()]).optional(),
          })
          .describe("Standard DoseSpot API result object."),
        zod.null(),
      ])
      .optional(),
  })
  .describe(
    "Response wrapper for operations that return an entity identifier.",
  );

/**
 * Replace a refill request with a new prescription.

This endpoint replaces a refill request with a different prescription.
Only one of NewPrescription, NewSupplyPrescription, NewCompoundPrescription,
or NewFreeTextPrescription should be provided.

Args:
    refill_id: The refill ID to replace
    request: The replacement request containing patient ID and new prescription details

Returns:
    IdentifierResponseT: Response from the replacement operation

Raises:
    AuthException: If the user lacks required privileges
    ValueError: If user doesn't have a DoseSpot clinician record or replacement fails
 * @summary Replace Refill
 */
export const replaceRefillParams = zod.object({
  refill_id: zod.number(),
});

export const replaceRefillBody = zod
  .object({
    PatientID: zod.number(),
    Pin: zod.union([zod.string(), zod.null()]).optional(),
    Otp: zod.union([zod.string(), zod.null()]).optional(),
    NewPrescription: zod
      .union([
        zod
          .object({
            DispensableDrugId: zod.number(),
            PatientFormularyId: zod
              .union([zod.number(), zod.null()])
              .optional(),
            Refills: zod.number(),
            DaysSupply: zod.union([zod.number(), zod.null()]).optional(),
            DispenseUnitId: zod.number(),
            Quantity: zod.number(),
            Directions: zod.string(),
            PharmacyId: zod.number(),
            PharmacyNotes: zod.union([zod.string(), zod.null()]).optional(),
            NoSubstitutions: zod.union([zod.boolean(), zod.null()]).optional(),
            EffectiveDate: zod.string(),
            RxReferenceNumber: zod.union([zod.string(), zod.null()]).optional(),
            EligibilityId: zod.union([zod.number(), zod.null()]).optional(),
            NonDoseSpotPrescriptionId: zod
              .union([zod.string(), zod.null()])
              .optional(),
            FirstPrescriptionDiagnosis: zod
              .union([
                zod
                  .object({
                    PrimaryDiagnosisId: zod
                      .union([zod.number(), zod.null()])
                      .optional(),
                    SecondaryDiagnosisId: zod
                      .union([zod.number(), zod.null()])
                      .optional(),
                  })
                  .describe(
                    "DoseSpot prescription diagnosis IDs for requests.",
                  ),
                zod.null(),
              ])
              .optional(),
            SecondPrescriptionDiagnosis: zod
              .union([
                zod
                  .object({
                    PrimaryDiagnosisId: zod
                      .union([zod.number(), zod.null()])
                      .optional(),
                    SecondaryDiagnosisId: zod
                      .union([zod.number(), zod.null()])
                      .optional(),
                  })
                  .describe(
                    "DoseSpot prescription diagnosis IDs for requests.",
                  ),
                zod.null(),
              ])
              .optional(),
            IsRefillReplace: zod.union([zod.boolean(), zod.null()]).optional(),
            IsUrgent: zod.union([zod.boolean(), zod.null()]).optional(),
            SupervisorId: zod.union([zod.number(), zod.null()]).optional(),
            RetailPharmacyToMailToPatient: zod
              .union([zod.boolean(), zod.null()])
              .optional(),
            Status: zod
              .enum([
                "Unknown",
                "Active",
                "Inactive",
                "Discontinued",
                "Deleted",
                "Completed",
                "CancelRequested",
                "CancelPending",
                "Cancelled",
                "CancelDenied",
                "Changed",
                "FullFill",
                "PartialFill",
                "NoFill",
              ])
              .describe("Valid medication status types for DoseSpot."),
            InactiveDate: zod.union([zod.string(), zod.null()]).optional(),
            Comment: zod.union([zod.string(), zod.null()]).optional(),
            Encounter: zod.union([zod.string(), zod.null()]).optional(),
          })
          .describe("Request for coded prescription creation\/editing."),
        zod.null(),
      ])
      .optional(),
    NewSupplyPrescription: zod
      .union([
        zod
          .object({
            SupplyId: zod.number(),
            Refills: zod.number(),
            DaysSupply: zod.union([zod.number(), zod.null()]).optional(),
            DispenseUnitId: zod.number(),
            Quantity: zod.number(),
            Directions: zod.string(),
            PharmacyId: zod.number(),
            PharmacyNotes: zod.union([zod.string(), zod.null()]).optional(),
            NoSubstitutions: zod.union([zod.boolean(), zod.null()]).optional(),
            EffectiveDate: zod.string(),
            RxReferenceNumber: zod.union([zod.string(), zod.null()]).optional(),
            EligibilityId: zod.union([zod.number(), zod.null()]).optional(),
            NonDoseSpotPrescriptionId: zod
              .union([zod.string(), zod.null()])
              .optional(),
            FirstPrescriptionDiagnosis: zod
              .union([
                zod
                  .object({
                    PrimaryDiagnosisId: zod
                      .union([zod.number(), zod.null()])
                      .optional(),
                    SecondaryDiagnosisId: zod
                      .union([zod.number(), zod.null()])
                      .optional(),
                  })
                  .describe(
                    "DoseSpot prescription diagnosis IDs for requests.",
                  ),
                zod.null(),
              ])
              .optional(),
            SecondPrescriptionDiagnosis: zod
              .union([
                zod
                  .object({
                    PrimaryDiagnosisId: zod
                      .union([zod.number(), zod.null()])
                      .optional(),
                    SecondaryDiagnosisId: zod
                      .union([zod.number(), zod.null()])
                      .optional(),
                  })
                  .describe(
                    "DoseSpot prescription diagnosis IDs for requests.",
                  ),
                zod.null(),
              ])
              .optional(),
            IsRefillReplace: zod.union([zod.boolean(), zod.null()]).optional(),
            IsUrgent: zod.union([zod.boolean(), zod.null()]).optional(),
            SupervisorId: zod.union([zod.number(), zod.null()]).optional(),
            RetailPharmacyToMailToPatient: zod
              .union([zod.boolean(), zod.null()])
              .optional(),
            Status: zod
              .enum([
                "Unknown",
                "Active",
                "Inactive",
                "Discontinued",
                "Deleted",
                "Completed",
                "CancelRequested",
                "CancelPending",
                "Cancelled",
                "CancelDenied",
                "Changed",
                "FullFill",
                "PartialFill",
                "NoFill",
              ])
              .describe("Valid medication status types for DoseSpot."),
            InactiveDate: zod.union([zod.string(), zod.null()]).optional(),
            Comment: zod.union([zod.string(), zod.null()]).optional(),
            Encounter: zod.union([zod.string(), zod.null()]).optional(),
          })
          .describe("Request for coded supply prescription creation\/editing."),
        zod.null(),
      ])
      .optional(),
    NewCompoundPrescription: zod
      .union([
        zod
          .object({
            CompoundDescription: zod.string(),
            CompoundIngredients: zod.array(
              zod
                .object({
                  DispensableDrugId: zod
                    .union([zod.number(), zod.null()])
                    .optional(),
                  FreeText: zod.union([zod.string(), zod.null()]).optional(),
                  DispenseUnitId: zod
                    .union([zod.number(), zod.null()])
                    .optional(),
                  Quantity: zod.string(),
                  IsFreeTextEPCS: zod
                    .union([zod.boolean(), zod.null()])
                    .optional(),
                })
                .describe("DoseSpot compound ingredient information."),
            ),
            Refills: zod.number(),
            DaysSupply: zod.union([zod.number(), zod.null()]).optional(),
            DispenseUnitId: zod.number(),
            Quantity: zod.number(),
            Directions: zod.string(),
            PharmacyId: zod.number(),
            PharmacyNotes: zod.union([zod.string(), zod.null()]).optional(),
            NoSubstitutions: zod.union([zod.boolean(), zod.null()]).optional(),
            EffectiveDate: zod.string(),
            RxReferenceNumber: zod.union([zod.string(), zod.null()]).optional(),
            EligibilityId: zod.union([zod.number(), zod.null()]).optional(),
            NonDoseSpotPrescriptionId: zod
              .union([zod.string(), zod.null()])
              .optional(),
            FirstPrescriptionDiagnosis: zod
              .union([
                zod
                  .object({
                    PrimaryDiagnosisId: zod
                      .union([zod.number(), zod.null()])
                      .optional(),
                    SecondaryDiagnosisId: zod
                      .union([zod.number(), zod.null()])
                      .optional(),
                  })
                  .describe(
                    "DoseSpot prescription diagnosis IDs for requests.",
                  ),
                zod.null(),
              ])
              .optional(),
            SecondPrescriptionDiagnosis: zod
              .union([
                zod
                  .object({
                    PrimaryDiagnosisId: zod
                      .union([zod.number(), zod.null()])
                      .optional(),
                    SecondaryDiagnosisId: zod
                      .union([zod.number(), zod.null()])
                      .optional(),
                  })
                  .describe(
                    "DoseSpot prescription diagnosis IDs for requests.",
                  ),
                zod.null(),
              ])
              .optional(),
            IsRefillReplace: zod.union([zod.boolean(), zod.null()]).optional(),
            IsUrgent: zod.union([zod.boolean(), zod.null()]).optional(),
            SupervisorId: zod.union([zod.number(), zod.null()]).optional(),
            RetailPharmacyToMailToPatient: zod
              .union([zod.boolean(), zod.null()])
              .optional(),
            Status: zod
              .enum([
                "Unknown",
                "Active",
                "Inactive",
                "Discontinued",
                "Deleted",
                "Completed",
                "CancelRequested",
                "CancelPending",
                "Cancelled",
                "CancelDenied",
                "Changed",
                "FullFill",
                "PartialFill",
                "NoFill",
              ])
              .describe("Valid medication status types for DoseSpot."),
            InactiveDate: zod.union([zod.string(), zod.null()]).optional(),
            Comment: zod.union([zod.string(), zod.null()]).optional(),
            Encounter: zod.union([zod.string(), zod.null()]).optional(),
          })
          .describe("Request for compound prescription creation\/editing."),
        zod.null(),
      ])
      .optional(),
    NewFreeTextPrescription: zod
      .union([
        zod
          .object({
            DisplayName: zod.string(),
            NotControlled: zod.boolean(),
            Refills: zod.number(),
            DaysSupply: zod.union([zod.number(), zod.null()]).optional(),
            DispenseUnitId: zod.number(),
            Quantity: zod.number(),
            Directions: zod.string(),
            PharmacyId: zod.number(),
            PharmacyNotes: zod.union([zod.string(), zod.null()]).optional(),
            NoSubstitutions: zod.union([zod.boolean(), zod.null()]).optional(),
            EffectiveDate: zod.string(),
            RxReferenceNumber: zod.union([zod.string(), zod.null()]).optional(),
            EligibilityId: zod.union([zod.number(), zod.null()]).optional(),
            NonDoseSpotPrescriptionId: zod
              .union([zod.string(), zod.null()])
              .optional(),
            FirstPrescriptionDiagnosis: zod
              .union([
                zod
                  .object({
                    PrimaryDiagnosisId: zod
                      .union([zod.number(), zod.null()])
                      .optional(),
                    SecondaryDiagnosisId: zod
                      .union([zod.number(), zod.null()])
                      .optional(),
                  })
                  .describe(
                    "DoseSpot prescription diagnosis IDs for requests.",
                  ),
                zod.null(),
              ])
              .optional(),
            SecondPrescriptionDiagnosis: zod
              .union([
                zod
                  .object({
                    PrimaryDiagnosisId: zod
                      .union([zod.number(), zod.null()])
                      .optional(),
                    SecondaryDiagnosisId: zod
                      .union([zod.number(), zod.null()])
                      .optional(),
                  })
                  .describe(
                    "DoseSpot prescription diagnosis IDs for requests.",
                  ),
                zod.null(),
              ])
              .optional(),
            IsRefillReplace: zod.union([zod.boolean(), zod.null()]).optional(),
            IsUrgent: zod.union([zod.boolean(), zod.null()]).optional(),
            SupervisorId: zod.union([zod.number(), zod.null()]).optional(),
            RetailPharmacyToMailToPatient: zod
              .union([zod.boolean(), zod.null()])
              .optional(),
            Status: zod
              .enum([
                "Unknown",
                "Active",
                "Inactive",
                "Discontinued",
                "Deleted",
                "Completed",
                "CancelRequested",
                "CancelPending",
                "Cancelled",
                "CancelDenied",
                "Changed",
                "FullFill",
                "PartialFill",
                "NoFill",
              ])
              .describe("Valid medication status types for DoseSpot."),
            InactiveDate: zod.union([zod.string(), zod.null()]).optional(),
            Comment: zod.union([zod.string(), zod.null()]).optional(),
            Encounter: zod.union([zod.string(), zod.null()]).optional(),
          })
          .describe(
            "Request for free text supply prescription creation\/editing.",
          ),
        zod.null(),
      ])
      .optional(),
  })
  .describe("Request to replace a refill with a new prescription.");

export const replaceRefillResponse = zod
  .object({
    Id: zod.union([zod.number(), zod.null()]).optional(),
    Result: zod
      .union([
        zod
          .object({
            ResultCode: zod.string(),
            ResultDescription: zod.union([zod.string(), zod.null()]).optional(),
          })
          .describe("Standard DoseSpot API result object."),
        zod.null(),
      ])
      .optional(),
  })
  .describe(
    "Response wrapper for operations that return an entity identifier.",
  );

/**
 * Perform an action on a pending refill request.

Accepts a discriminated-union body whose ``action`` field selects
approve, deny, or replace.  Used by the copilot proposed-action
form so the clinician can review and submit in one step.
 * @summary Refill Action
 */
export const refillActionParams = zod.object({
  refill_id: zod.number(),
});

export const refillActionBodyActionDefault = "approve";
export const refillActionBodyRefillsMax = 99;

export const refillActionBodyActionDefaultOne = "deny";
export const refillActionBodyActionDefaultTwo = "replace";

export const refillActionBody = zod.union([
  zod.object({
    action: zod.literal("approve").default(refillActionBodyActionDefault),
    refills: zod.number().min(1).max(refillActionBodyRefillsMax),
    comment: zod.union([zod.string(), zod.null()]).optional(),
    effectiveDate: zod.union([zod.string(), zod.null()]).optional(),
  }),
  zod.object({
    action: zod.literal("deny").default(refillActionBodyActionDefaultOne),
    denialReason: zod
      .enum([
        "DeniedPatientUnknown",
        "DeniedPatientNotUnderCare",
        "DeniedPatientNoLongerUnderPatientCare",
        "DeniedTooSoon",
        "DeniedNeverPrescribed",
        "DeniedHavePatientContact",
        "DeniedRefillInappropriate",
        "DeniedAlreadyPickedUp",
        "DeniedAlreadyPickedUpPartialFill",
        "DeniedNotPickedUp",
        "DeniedChangeInappropriate",
        "DeniedNeedAppointment",
        "DeniedPrescriberNotAssociateWithLocation",
        "DeniedNoPriorAuthAttempt",
        "DeniedAlreadyHandled",
        "DeniedAtPatientRequest",
        "DeniedPatientAllergicToRequestMed",
        "DeniedMedicationDiscontinued",
      ])
      .optional()
      .describe("Valid denial reasons for refill requests."),
    note: zod.union([zod.string(), zod.null()]).optional(),
  }),
  zod.object({
    action: zod.literal("replace").default(refillActionBodyActionDefaultTwo),
    patientUserId: zod.string(),
    newPrescription: zod
      .object({
        DispensableDrugId: zod.number(),
        PatientFormularyId: zod.union([zod.number(), zod.null()]).optional(),
        Refills: zod.number(),
        DaysSupply: zod.union([zod.number(), zod.null()]).optional(),
        DispenseUnitId: zod.number(),
        Quantity: zod.number(),
        Directions: zod.string(),
        PharmacyId: zod.number(),
        PharmacyNotes: zod.union([zod.string(), zod.null()]).optional(),
        NoSubstitutions: zod.union([zod.boolean(), zod.null()]).optional(),
        EffectiveDate: zod.string(),
        RxReferenceNumber: zod.union([zod.string(), zod.null()]).optional(),
        EligibilityId: zod.union([zod.number(), zod.null()]).optional(),
        NonDoseSpotPrescriptionId: zod
          .union([zod.string(), zod.null()])
          .optional(),
        FirstPrescriptionDiagnosis: zod
          .union([
            zod
              .object({
                PrimaryDiagnosisId: zod
                  .union([zod.number(), zod.null()])
                  .optional(),
                SecondaryDiagnosisId: zod
                  .union([zod.number(), zod.null()])
                  .optional(),
              })
              .describe("DoseSpot prescription diagnosis IDs for requests."),
            zod.null(),
          ])
          .optional(),
        SecondPrescriptionDiagnosis: zod
          .union([
            zod
              .object({
                PrimaryDiagnosisId: zod
                  .union([zod.number(), zod.null()])
                  .optional(),
                SecondaryDiagnosisId: zod
                  .union([zod.number(), zod.null()])
                  .optional(),
              })
              .describe("DoseSpot prescription diagnosis IDs for requests."),
            zod.null(),
          ])
          .optional(),
        IsRefillReplace: zod.union([zod.boolean(), zod.null()]).optional(),
        IsUrgent: zod.union([zod.boolean(), zod.null()]).optional(),
        SupervisorId: zod.union([zod.number(), zod.null()]).optional(),
        RetailPharmacyToMailToPatient: zod
          .union([zod.boolean(), zod.null()])
          .optional(),
        Status: zod
          .enum([
            "Unknown",
            "Active",
            "Inactive",
            "Discontinued",
            "Deleted",
            "Completed",
            "CancelRequested",
            "CancelPending",
            "Cancelled",
            "CancelDenied",
            "Changed",
            "FullFill",
            "PartialFill",
            "NoFill",
          ])
          .describe("Valid medication status types for DoseSpot."),
        InactiveDate: zod.union([zod.string(), zod.null()]).optional(),
        Comment: zod.union([zod.string(), zod.null()]).optional(),
        Encounter: zod.union([zod.string(), zod.null()]).optional(),
      })
      .describe("Request for coded prescription creation\/editing."),
  }),
]);

export const refillActionResponse = zod
  .object({
    Id: zod.union([zod.number(), zod.null()]).optional(),
    Result: zod
      .union([
        zod
          .object({
            ResultCode: zod.string(),
            ResultDescription: zod.union([zod.string(), zod.null()]).optional(),
          })
          .describe("Standard DoseSpot API result object."),
        zod.null(),
      ])
      .optional(),
  })
  .describe(
    "Response wrapper for operations that return an entity identifier.",
  );

/**
 * Get detailed pending RxChange requests for the authenticated user's associated clinic(s).

This endpoint retrieves detailed RxChange request information including full prescription
details, with optional filtering by clinic and patient, and pagination support.

Args:
    clinic: The clinic to filter by (optional)
    patientId: The patient ID to filter by (optional)
    pageNumber: The page number to retrieve (1-based, optional)

Returns:
    RxChangeDetailedPagedListResponseT: Paged list of detailed pending RxChange requests

Raises:
    AuthException: If the user lacks required privileges
    ValueError: If user doesn't have a DoseSpot clinician record
 * @summary Get Pending Rx Changes Detailed
 */
export const getPendingRxChangesDetailedQueryParams = zod.object({
  clinic: zod.union([zod.string(), zod.null()]).optional(),
  patientId: zod.union([zod.number(), zod.null()]).optional(),
  pageNumber: zod.union([zod.number(), zod.null()]).optional(),
});

export const getPendingRxChangesDetailedResponse = zod
  .object({
    Items: zod
      .union([
        zod.array(
          zod
            .object({
              RxChangeRequestId: zod
                .union([zod.number(), zod.null()])
                .optional(),
              RxChangeType: zod.union([zod.string(), zod.null()]).optional(),
              RxChangeSubType: zod.union([zod.string(), zod.null()]).optional(),
              Source: zod.union([zod.string(), zod.null()]).optional(),
              NewPatient: zod.union([zod.boolean(), zod.null()]).optional(),
              Patient: zod
                .union([
                  zod
                    .object({
                      FirstName: zod.string(),
                      LastName: zod.string(),
                      DateOfBirth: zod.string(),
                      Gender: zod.enum(["Male", "Female", "Unknown"]),
                      Address1: zod.string(),
                      City: zod.string(),
                      State: zod.string(),
                      ZipCode: zod.string(),
                      PrimaryPhone: zod
                        .union([zod.string(), zod.null()])
                        .optional(),
                      Active: zod.boolean(),
                      PatientId: zod
                        .union([zod.number(), zod.null()])
                        .optional(),
                      Prefix: zod.union([zod.string(), zod.null()]).optional(),
                      MiddleName: zod
                        .union([zod.string(), zod.null()])
                        .optional(),
                      Suffix: zod.union([zod.string(), zod.null()]).optional(),
                      Email: zod.union([zod.string(), zod.null()]).optional(),
                      Address2: zod
                        .union([zod.string(), zod.null()])
                        .optional(),
                      PhoneAdditional1: zod
                        .union([zod.string(), zod.null()])
                        .optional(),
                      PhoneAdditional2: zod
                        .union([zod.string(), zod.null()])
                        .optional(),
                      PhoneAdditionalType1: zod
                        .union([
                          zod.enum([
                            "Undefined",
                            "Beeper",
                            "Cell",
                            "Fax",
                            "Home",
                            "Work",
                            "Night",
                            "Primary",
                          ]),
                          zod.null(),
                        ])
                        .optional(),
                      PhoneAdditionalType2: zod
                        .union([
                          zod.enum([
                            "Undefined",
                            "Beeper",
                            "Cell",
                            "Fax",
                            "Home",
                            "Work",
                            "Night",
                            "Primary",
                          ]),
                          zod.null(),
                        ])
                        .optional(),
                      PrimaryPhoneType: zod
                        .union([
                          zod.enum([
                            "Undefined",
                            "Beeper",
                            "Cell",
                            "Fax",
                            "Home",
                            "Work",
                            "Night",
                            "Primary",
                          ]),
                          zod.null(),
                        ])
                        .optional(),
                      Weight: zod.union([zod.number(), zod.null()]).optional(),
                      WeightMetric: zod
                        .union([
                          zod
                            .enum(["lb", "kg"])
                            .describe(
                              "Valid weight metrics for DoseSpot patients.",
                            ),
                          zod.null(),
                        ])
                        .optional(),
                      Height: zod.union([zod.number(), zod.null()]).optional(),
                      HeightMetric: zod
                        .union([
                          zod
                            .enum(["inch", "cm"])
                            .describe(
                              "Valid height metrics for DoseSpot patients.",
                            ),
                          zod.null(),
                        ])
                        .optional(),
                      NonDoseSpotMedicalRecordNumber: zod
                        .union([zod.string(), zod.null()])
                        .optional(),
                      Encounter: zod
                        .union([zod.string(), zod.null()])
                        .optional(),
                      IsHospice: zod
                        .union([zod.boolean(), zod.null()])
                        .optional(),
                      Last4SSN: zod
                        .union([zod.string(), zod.null()])
                        .optional(),
                    })
                    .describe(
                      "Patient demographic information from DoseSpot API.",
                    ),
                  zod.null(),
                ])
                .optional(),
              UnmatchedChange: zod
                .union([zod.boolean(), zod.null()])
                .optional(),
              PrescribedPrescription: zod
                .union([
                  zod
                    .object({
                      PrescriptionId: zod
                        .union([zod.number(), zod.null()])
                        .optional(),
                      PriorAuthorizationCaseId: zod
                        .union([zod.number(), zod.null()])
                        .optional(),
                      WrittenDate: zod
                        .union([zod.string(), zod.null()])
                        .optional(),
                      Directions: zod
                        .union([zod.string(), zod.null()])
                        .optional(),
                      Quantity: zod
                        .union([zod.string(), zod.null()])
                        .optional(),
                      DispenseUnitId: zod
                        .union([zod.number(), zod.null()])
                        .optional(),
                      Refills: zod.union([zod.string(), zod.null()]).optional(),
                      DaysSupply: zod
                        .union([zod.number(), zod.null()])
                        .optional(),
                      PharmacyId: zod
                        .union([zod.number(), zod.null()])
                        .optional(),
                      PharmacyNotes: zod
                        .union([zod.string(), zod.null()])
                        .optional(),
                      NoSubstitutions: zod
                        .union([zod.boolean(), zod.null()])
                        .optional(),
                      EffectiveDate: zod
                        .union([zod.string(), zod.null()])
                        .optional(),
                      LastFillDate: zod
                        .union([zod.string(), zod.null()])
                        .optional(),
                      PrescriberId: zod
                        .union([zod.number(), zod.null()])
                        .optional(),
                      PrescriberAgentId: zod
                        .union([zod.number(), zod.null()])
                        .optional(),
                      RxReferenceNumber: zod
                        .union([zod.string(), zod.null()])
                        .optional(),
                      Status: zod
                        .union([
                          zod
                            .enum([
                              "Unknown",
                              "Entered",
                              "Printed",
                              "Sending",
                              "eRxSent",
                              "FaxSent",
                              "Error",
                              "Deleted",
                              "Requested",
                              "Edited",
                              "EpcsError",
                              "EpcsSigned",
                              "ReadyToSign",
                              "PharmacyVerified",
                              "PharmacySelect",
                            ])
                            .describe(
                              "Valid prescription status types for DoseSpot.",
                            ),
                          zod.null(),
                        ])
                        .optional(),
                      Formulary: zod
                        .union([zod.boolean(), zod.null()])
                        .optional(),
                      EligibilityId: zod
                        .union([zod.number(), zod.null()])
                        .optional(),
                      Type: zod
                        .union([
                          zod
                            .enum([
                              "Coded",
                              "FreeText",
                              "NDC",
                              "Supply",
                              "Compound",
                            ])
                            .describe("Valid prescription types for DoseSpot."),
                          zod.null(),
                        ])
                        .optional(),
                      NonDoseSpotPrescriptionId: zod
                        .union([zod.string(), zod.null()])
                        .optional(),
                      ErrorIgnored: zod
                        .union([zod.boolean(), zod.null()])
                        .optional(),
                      SupplyId: zod
                        .union([zod.number(), zod.null()])
                        .optional(),
                      FreeTextType: zod
                        .union([
                          zod
                            .enum(["Medication", "Supply", "Compound"])
                            .describe(
                              "Valid free text types for DoseSpot prescriptions.",
                            ),
                          zod.null(),
                        ])
                        .optional(),
                      ClinicId: zod
                        .union([zod.number(), zod.null()])
                        .optional(),
                      SupervisorId: zod
                        .union([zod.number(), zod.null()])
                        .optional(),
                      IsUrgent: zod
                        .union([zod.boolean(), zod.null()])
                        .optional(),
                      IsRxRenewal: zod
                        .union([zod.boolean(), zod.null()])
                        .optional(),
                      RxRenewalNote: zod
                        .union([zod.string(), zod.null()])
                        .optional(),
                      FirstPrescriptionDiagnosis: zod
                        .union([
                          zod
                            .object({
                              PrimaryDiagnosis: zod
                                .union([
                                  zod
                                    .object({
                                      DiagnosisId: zod
                                        .union([zod.number(), zod.null()])
                                        .optional(),
                                      DiagnosisCode: zod
                                        .union([zod.string(), zod.null()])
                                        .optional(),
                                      DiagnosisDescription: zod
                                        .union([zod.string(), zod.null()])
                                        .optional(),
                                    })
                                    .describe(
                                      "DoseSpot diagnosis information.",
                                    ),
                                  zod.null(),
                                ])
                                .optional(),
                              SecondaryDiagnosis: zod
                                .union([
                                  zod
                                    .object({
                                      DiagnosisId: zod
                                        .union([zod.number(), zod.null()])
                                        .optional(),
                                      DiagnosisCode: zod
                                        .union([zod.string(), zod.null()])
                                        .optional(),
                                      DiagnosisDescription: zod
                                        .union([zod.string(), zod.null()])
                                        .optional(),
                                    })
                                    .describe(
                                      "DoseSpot diagnosis information.",
                                    ),
                                  zod.null(),
                                ])
                                .optional(),
                            })
                            .describe(
                              "DoseSpot prescription diagnosis information.",
                            ),
                          zod.null(),
                        ])
                        .optional(),
                      SecondPrescriptionDiagnosis: zod
                        .union([
                          zod
                            .object({
                              PrimaryDiagnosis: zod
                                .union([
                                  zod
                                    .object({
                                      DiagnosisId: zod
                                        .union([zod.number(), zod.null()])
                                        .optional(),
                                      DiagnosisCode: zod
                                        .union([zod.string(), zod.null()])
                                        .optional(),
                                      DiagnosisDescription: zod
                                        .union([zod.string(), zod.null()])
                                        .optional(),
                                    })
                                    .describe(
                                      "DoseSpot diagnosis information.",
                                    ),
                                  zod.null(),
                                ])
                                .optional(),
                              SecondaryDiagnosis: zod
                                .union([
                                  zod
                                    .object({
                                      DiagnosisId: zod
                                        .union([zod.number(), zod.null()])
                                        .optional(),
                                      DiagnosisCode: zod
                                        .union([zod.string(), zod.null()])
                                        .optional(),
                                      DiagnosisDescription: zod
                                        .union([zod.string(), zod.null()])
                                        .optional(),
                                    })
                                    .describe(
                                      "DoseSpot diagnosis information.",
                                    ),
                                  zod.null(),
                                ])
                                .optional(),
                            })
                            .describe(
                              "DoseSpot prescription diagnosis information.",
                            ),
                          zod.null(),
                        ])
                        .optional(),
                      Strength: zod
                        .union([zod.string(), zod.null()])
                        .optional(),
                      PatientMedicationId: zod
                        .union([zod.number(), zod.null()])
                        .optional(),
                      MedicationStatus: zod
                        .union([
                          zod
                            .enum([
                              "Unknown",
                              "Active",
                              "Inactive",
                              "Discontinued",
                              "Deleted",
                              "Completed",
                              "CancelRequested",
                              "CancelPending",
                              "Cancelled",
                              "CancelDenied",
                              "Changed",
                              "FullFill",
                              "PartialFill",
                              "NoFill",
                            ])
                            .describe(
                              "Valid medication status types for DoseSpot.",
                            ),
                          zod.null(),
                        ])
                        .optional(),
                      Comment: zod.union([zod.string(), zod.null()]).optional(),
                      DateInactive: zod
                        .union([zod.string(), zod.null()])
                        .optional(),
                      Encounter: zod
                        .union([zod.string(), zod.null()])
                        .optional(),
                      DisplayName: zod
                        .union([zod.string(), zod.null()])
                        .optional(),
                      DispensableDrugId: zod
                        .union([zod.number(), zod.null()])
                        .optional(),
                      Schedule: zod
                        .union([zod.number(), zod.null()])
                        .optional(),
                      CompoundIngredients: zod
                        .union([
                          zod.array(
                            zod
                              .object({
                                DispensableDrugId: zod
                                  .union([zod.number(), zod.null()])
                                  .optional(),
                                FreeText: zod
                                  .union([zod.string(), zod.null()])
                                  .optional(),
                                DispenseUnitId: zod
                                  .union([zod.number(), zod.null()])
                                  .optional(),
                                Quantity: zod.string(),
                                IsFreeTextEPCS: zod
                                  .union([zod.boolean(), zod.null()])
                                  .optional(),
                              })
                              .describe(
                                "DoseSpot compound ingredient information.",
                              ),
                          ),
                          zod.null(),
                        ])
                        .optional(),
                    })
                    .describe(
                      "Complete prescription information from DoseSpot API.",
                    ),
                  zod.null(),
                ])
                .optional(),
              RequestedMedications: zod
                .union([
                  zod.array(
                    zod
                      .object({
                        PrescriptionId: zod
                          .union([zod.number(), zod.null()])
                          .optional(),
                        PriorAuthorizationCaseId: zod
                          .union([zod.number(), zod.null()])
                          .optional(),
                        WrittenDate: zod
                          .union([zod.string(), zod.null()])
                          .optional(),
                        Directions: zod
                          .union([zod.string(), zod.null()])
                          .optional(),
                        Quantity: zod
                          .union([zod.string(), zod.null()])
                          .optional(),
                        DispenseUnitId: zod
                          .union([zod.number(), zod.null()])
                          .optional(),
                        Refills: zod
                          .union([zod.string(), zod.null()])
                          .optional(),
                        DaysSupply: zod
                          .union([zod.number(), zod.null()])
                          .optional(),
                        PharmacyId: zod
                          .union([zod.number(), zod.null()])
                          .optional(),
                        PharmacyNotes: zod
                          .union([zod.string(), zod.null()])
                          .optional(),
                        NoSubstitutions: zod
                          .union([zod.boolean(), zod.null()])
                          .optional(),
                        EffectiveDate: zod
                          .union([zod.string(), zod.null()])
                          .optional(),
                        LastFillDate: zod
                          .union([zod.string(), zod.null()])
                          .optional(),
                        PrescriberId: zod
                          .union([zod.number(), zod.null()])
                          .optional(),
                        PrescriberAgentId: zod
                          .union([zod.number(), zod.null()])
                          .optional(),
                        RxReferenceNumber: zod
                          .union([zod.string(), zod.null()])
                          .optional(),
                        Status: zod
                          .union([
                            zod
                              .enum([
                                "Unknown",
                                "Entered",
                                "Printed",
                                "Sending",
                                "eRxSent",
                                "FaxSent",
                                "Error",
                                "Deleted",
                                "Requested",
                                "Edited",
                                "EpcsError",
                                "EpcsSigned",
                                "ReadyToSign",
                                "PharmacyVerified",
                                "PharmacySelect",
                              ])
                              .describe(
                                "Valid prescription status types for DoseSpot.",
                              ),
                            zod.null(),
                          ])
                          .optional(),
                        Formulary: zod
                          .union([zod.boolean(), zod.null()])
                          .optional(),
                        EligibilityId: zod
                          .union([zod.number(), zod.null()])
                          .optional(),
                        Type: zod
                          .union([
                            zod
                              .enum([
                                "Coded",
                                "FreeText",
                                "NDC",
                                "Supply",
                                "Compound",
                              ])
                              .describe(
                                "Valid prescription types for DoseSpot.",
                              ),
                            zod.null(),
                          ])
                          .optional(),
                        NonDoseSpotPrescriptionId: zod
                          .union([zod.string(), zod.null()])
                          .optional(),
                        ErrorIgnored: zod
                          .union([zod.boolean(), zod.null()])
                          .optional(),
                        SupplyId: zod
                          .union([zod.number(), zod.null()])
                          .optional(),
                        FreeTextType: zod
                          .union([
                            zod
                              .enum(["Medication", "Supply", "Compound"])
                              .describe(
                                "Valid free text types for DoseSpot prescriptions.",
                              ),
                            zod.null(),
                          ])
                          .optional(),
                        ClinicId: zod
                          .union([zod.number(), zod.null()])
                          .optional(),
                        SupervisorId: zod
                          .union([zod.number(), zod.null()])
                          .optional(),
                        IsUrgent: zod
                          .union([zod.boolean(), zod.null()])
                          .optional(),
                        IsRxRenewal: zod
                          .union([zod.boolean(), zod.null()])
                          .optional(),
                        RxRenewalNote: zod
                          .union([zod.string(), zod.null()])
                          .optional(),
                        FirstPrescriptionDiagnosis: zod
                          .union([
                            zod
                              .object({
                                PrimaryDiagnosis: zod
                                  .union([
                                    zod
                                      .object({
                                        DiagnosisId: zod
                                          .union([zod.number(), zod.null()])
                                          .optional(),
                                        DiagnosisCode: zod
                                          .union([zod.string(), zod.null()])
                                          .optional(),
                                        DiagnosisDescription: zod
                                          .union([zod.string(), zod.null()])
                                          .optional(),
                                      })
                                      .describe(
                                        "DoseSpot diagnosis information.",
                                      ),
                                    zod.null(),
                                  ])
                                  .optional(),
                                SecondaryDiagnosis: zod
                                  .union([
                                    zod
                                      .object({
                                        DiagnosisId: zod
                                          .union([zod.number(), zod.null()])
                                          .optional(),
                                        DiagnosisCode: zod
                                          .union([zod.string(), zod.null()])
                                          .optional(),
                                        DiagnosisDescription: zod
                                          .union([zod.string(), zod.null()])
                                          .optional(),
                                      })
                                      .describe(
                                        "DoseSpot diagnosis information.",
                                      ),
                                    zod.null(),
                                  ])
                                  .optional(),
                              })
                              .describe(
                                "DoseSpot prescription diagnosis information.",
                              ),
                            zod.null(),
                          ])
                          .optional(),
                        SecondPrescriptionDiagnosis: zod
                          .union([
                            zod
                              .object({
                                PrimaryDiagnosis: zod
                                  .union([
                                    zod
                                      .object({
                                        DiagnosisId: zod
                                          .union([zod.number(), zod.null()])
                                          .optional(),
                                        DiagnosisCode: zod
                                          .union([zod.string(), zod.null()])
                                          .optional(),
                                        DiagnosisDescription: zod
                                          .union([zod.string(), zod.null()])
                                          .optional(),
                                      })
                                      .describe(
                                        "DoseSpot diagnosis information.",
                                      ),
                                    zod.null(),
                                  ])
                                  .optional(),
                                SecondaryDiagnosis: zod
                                  .union([
                                    zod
                                      .object({
                                        DiagnosisId: zod
                                          .union([zod.number(), zod.null()])
                                          .optional(),
                                        DiagnosisCode: zod
                                          .union([zod.string(), zod.null()])
                                          .optional(),
                                        DiagnosisDescription: zod
                                          .union([zod.string(), zod.null()])
                                          .optional(),
                                      })
                                      .describe(
                                        "DoseSpot diagnosis information.",
                                      ),
                                    zod.null(),
                                  ])
                                  .optional(),
                              })
                              .describe(
                                "DoseSpot prescription diagnosis information.",
                              ),
                            zod.null(),
                          ])
                          .optional(),
                        Strength: zod
                          .union([zod.string(), zod.null()])
                          .optional(),
                        PatientMedicationId: zod
                          .union([zod.number(), zod.null()])
                          .optional(),
                        MedicationStatus: zod
                          .union([
                            zod
                              .enum([
                                "Unknown",
                                "Active",
                                "Inactive",
                                "Discontinued",
                                "Deleted",
                                "Completed",
                                "CancelRequested",
                                "CancelPending",
                                "Cancelled",
                                "CancelDenied",
                                "Changed",
                                "FullFill",
                                "PartialFill",
                                "NoFill",
                              ])
                              .describe(
                                "Valid medication status types for DoseSpot.",
                              ),
                            zod.null(),
                          ])
                          .optional(),
                        Comment: zod
                          .union([zod.string(), zod.null()])
                          .optional(),
                        DateInactive: zod
                          .union([zod.string(), zod.null()])
                          .optional(),
                        Encounter: zod
                          .union([zod.string(), zod.null()])
                          .optional(),
                        DisplayName: zod
                          .union([zod.string(), zod.null()])
                          .optional(),
                        DispensableDrugId: zod
                          .union([zod.number(), zod.null()])
                          .optional(),
                        Schedule: zod
                          .union([zod.number(), zod.null()])
                          .optional(),
                        CompoundIngredients: zod
                          .union([
                            zod.array(
                              zod
                                .object({
                                  DispensableDrugId: zod
                                    .union([zod.number(), zod.null()])
                                    .optional(),
                                  FreeText: zod
                                    .union([zod.string(), zod.null()])
                                    .optional(),
                                  DispenseUnitId: zod
                                    .union([zod.number(), zod.null()])
                                    .optional(),
                                  Quantity: zod.string(),
                                  IsFreeTextEPCS: zod
                                    .union([zod.boolean(), zod.null()])
                                    .optional(),
                                })
                                .describe(
                                  "DoseSpot compound ingredient information.",
                                ),
                            ),
                            zod.null(),
                          ])
                          .optional(),
                      })
                      .describe(
                        "Complete prescription information from DoseSpot API.",
                      ),
                  ),
                  zod.null(),
                ])
                .optional(),
              ClinicianId: zod.union([zod.number(), zod.null()]).optional(),
              ClinicId: zod.union([zod.number(), zod.null()]).optional(),
              PharmacyId: zod.union([zod.number(), zod.null()]).optional(),
              RequestedDate: zod.union([zod.string(), zod.null()]).optional(),
              OriginalPrescription: zod
                .union([
                  zod
                    .object({
                      PrescriptionId: zod
                        .union([zod.number(), zod.null()])
                        .optional(),
                      PriorAuthorizationCaseId: zod
                        .union([zod.number(), zod.null()])
                        .optional(),
                      WrittenDate: zod
                        .union([zod.string(), zod.null()])
                        .optional(),
                      Directions: zod
                        .union([zod.string(), zod.null()])
                        .optional(),
                      Quantity: zod
                        .union([zod.string(), zod.null()])
                        .optional(),
                      DispenseUnitId: zod
                        .union([zod.number(), zod.null()])
                        .optional(),
                      Refills: zod.union([zod.string(), zod.null()]).optional(),
                      DaysSupply: zod
                        .union([zod.number(), zod.null()])
                        .optional(),
                      PharmacyId: zod
                        .union([zod.number(), zod.null()])
                        .optional(),
                      PharmacyNotes: zod
                        .union([zod.string(), zod.null()])
                        .optional(),
                      NoSubstitutions: zod
                        .union([zod.boolean(), zod.null()])
                        .optional(),
                      EffectiveDate: zod
                        .union([zod.string(), zod.null()])
                        .optional(),
                      LastFillDate: zod
                        .union([zod.string(), zod.null()])
                        .optional(),
                      PrescriberId: zod
                        .union([zod.number(), zod.null()])
                        .optional(),
                      PrescriberAgentId: zod
                        .union([zod.number(), zod.null()])
                        .optional(),
                      RxReferenceNumber: zod
                        .union([zod.string(), zod.null()])
                        .optional(),
                      Status: zod
                        .union([
                          zod
                            .enum([
                              "Unknown",
                              "Entered",
                              "Printed",
                              "Sending",
                              "eRxSent",
                              "FaxSent",
                              "Error",
                              "Deleted",
                              "Requested",
                              "Edited",
                              "EpcsError",
                              "EpcsSigned",
                              "ReadyToSign",
                              "PharmacyVerified",
                              "PharmacySelect",
                            ])
                            .describe(
                              "Valid prescription status types for DoseSpot.",
                            ),
                          zod.null(),
                        ])
                        .optional(),
                      Formulary: zod
                        .union([zod.boolean(), zod.null()])
                        .optional(),
                      EligibilityId: zod
                        .union([zod.number(), zod.null()])
                        .optional(),
                      Type: zod
                        .union([
                          zod
                            .enum([
                              "Coded",
                              "FreeText",
                              "NDC",
                              "Supply",
                              "Compound",
                            ])
                            .describe("Valid prescription types for DoseSpot."),
                          zod.null(),
                        ])
                        .optional(),
                      NonDoseSpotPrescriptionId: zod
                        .union([zod.string(), zod.null()])
                        .optional(),
                      ErrorIgnored: zod
                        .union([zod.boolean(), zod.null()])
                        .optional(),
                      SupplyId: zod
                        .union([zod.number(), zod.null()])
                        .optional(),
                      FreeTextType: zod
                        .union([
                          zod
                            .enum(["Medication", "Supply", "Compound"])
                            .describe(
                              "Valid free text types for DoseSpot prescriptions.",
                            ),
                          zod.null(),
                        ])
                        .optional(),
                      ClinicId: zod
                        .union([zod.number(), zod.null()])
                        .optional(),
                      SupervisorId: zod
                        .union([zod.number(), zod.null()])
                        .optional(),
                      IsUrgent: zod
                        .union([zod.boolean(), zod.null()])
                        .optional(),
                      IsRxRenewal: zod
                        .union([zod.boolean(), zod.null()])
                        .optional(),
                      RxRenewalNote: zod
                        .union([zod.string(), zod.null()])
                        .optional(),
                      FirstPrescriptionDiagnosis: zod
                        .union([
                          zod
                            .object({
                              PrimaryDiagnosis: zod
                                .union([
                                  zod
                                    .object({
                                      DiagnosisId: zod
                                        .union([zod.number(), zod.null()])
                                        .optional(),
                                      DiagnosisCode: zod
                                        .union([zod.string(), zod.null()])
                                        .optional(),
                                      DiagnosisDescription: zod
                                        .union([zod.string(), zod.null()])
                                        .optional(),
                                    })
                                    .describe(
                                      "DoseSpot diagnosis information.",
                                    ),
                                  zod.null(),
                                ])
                                .optional(),
                              SecondaryDiagnosis: zod
                                .union([
                                  zod
                                    .object({
                                      DiagnosisId: zod
                                        .union([zod.number(), zod.null()])
                                        .optional(),
                                      DiagnosisCode: zod
                                        .union([zod.string(), zod.null()])
                                        .optional(),
                                      DiagnosisDescription: zod
                                        .union([zod.string(), zod.null()])
                                        .optional(),
                                    })
                                    .describe(
                                      "DoseSpot diagnosis information.",
                                    ),
                                  zod.null(),
                                ])
                                .optional(),
                            })
                            .describe(
                              "DoseSpot prescription diagnosis information.",
                            ),
                          zod.null(),
                        ])
                        .optional(),
                      SecondPrescriptionDiagnosis: zod
                        .union([
                          zod
                            .object({
                              PrimaryDiagnosis: zod
                                .union([
                                  zod
                                    .object({
                                      DiagnosisId: zod
                                        .union([zod.number(), zod.null()])
                                        .optional(),
                                      DiagnosisCode: zod
                                        .union([zod.string(), zod.null()])
                                        .optional(),
                                      DiagnosisDescription: zod
                                        .union([zod.string(), zod.null()])
                                        .optional(),
                                    })
                                    .describe(
                                      "DoseSpot diagnosis information.",
                                    ),
                                  zod.null(),
                                ])
                                .optional(),
                              SecondaryDiagnosis: zod
                                .union([
                                  zod
                                    .object({
                                      DiagnosisId: zod
                                        .union([zod.number(), zod.null()])
                                        .optional(),
                                      DiagnosisCode: zod
                                        .union([zod.string(), zod.null()])
                                        .optional(),
                                      DiagnosisDescription: zod
                                        .union([zod.string(), zod.null()])
                                        .optional(),
                                    })
                                    .describe(
                                      "DoseSpot diagnosis information.",
                                    ),
                                  zod.null(),
                                ])
                                .optional(),
                            })
                            .describe(
                              "DoseSpot prescription diagnosis information.",
                            ),
                          zod.null(),
                        ])
                        .optional(),
                      Strength: zod
                        .union([zod.string(), zod.null()])
                        .optional(),
                      PatientMedicationId: zod
                        .union([zod.number(), zod.null()])
                        .optional(),
                      MedicationStatus: zod
                        .union([
                          zod
                            .enum([
                              "Unknown",
                              "Active",
                              "Inactive",
                              "Discontinued",
                              "Deleted",
                              "Completed",
                              "CancelRequested",
                              "CancelPending",
                              "Cancelled",
                              "CancelDenied",
                              "Changed",
                              "FullFill",
                              "PartialFill",
                              "NoFill",
                            ])
                            .describe(
                              "Valid medication status types for DoseSpot.",
                            ),
                          zod.null(),
                        ])
                        .optional(),
                      Comment: zod.union([zod.string(), zod.null()]).optional(),
                      DateInactive: zod
                        .union([zod.string(), zod.null()])
                        .optional(),
                      Encounter: zod
                        .union([zod.string(), zod.null()])
                        .optional(),
                      DisplayName: zod
                        .union([zod.string(), zod.null()])
                        .optional(),
                      DispensableDrugId: zod
                        .union([zod.number(), zod.null()])
                        .optional(),
                      Schedule: zod
                        .union([zod.number(), zod.null()])
                        .optional(),
                      CompoundIngredients: zod
                        .union([
                          zod.array(
                            zod
                              .object({
                                DispensableDrugId: zod
                                  .union([zod.number(), zod.null()])
                                  .optional(),
                                FreeText: zod
                                  .union([zod.string(), zod.null()])
                                  .optional(),
                                DispenseUnitId: zod
                                  .union([zod.number(), zod.null()])
                                  .optional(),
                                Quantity: zod.string(),
                                IsFreeTextEPCS: zod
                                  .union([zod.boolean(), zod.null()])
                                  .optional(),
                              })
                              .describe(
                                "DoseSpot compound ingredient information.",
                              ),
                          ),
                          zod.null(),
                        ])
                        .optional(),
                    })
                    .describe(
                      "Complete prescription information from DoseSpot API.",
                    ),
                  zod.null(),
                ])
                .optional(),
              PayerName: zod.union([zod.string(), zod.null()]).optional(),
              DrugUseEvaluations: zod
                .union([
                  zod.array(
                    zod
                      .object({
                        Reason: zod
                          .union([zod.string(), zod.null()])
                          .optional(),
                        Service: zod
                          .union([zod.string(), zod.null()])
                          .optional(),
                        AckReason: zod
                          .union([zod.string(), zod.null()])
                          .optional(),
                        Result: zod
                          .union([zod.string(), zod.null()])
                          .optional(),
                        Significance: zod
                          .union([zod.string(), zod.null()])
                          .optional(),
                      })
                      .describe("Drug use evaluation information."),
                  ),
                  zod.null(),
                ])
                .optional(),
            })
            .describe("Detailed RxChange request information."),
        ),
        zod.null(),
      ])
      .optional(),
    PageResult: zod
      .union([
        zod
          .object({
            CurrentPage: zod.union([zod.number(), zod.null()]).optional(),
            TotalPages: zod.union([zod.number(), zod.null()]).optional(),
            PageSize: zod.union([zod.number(), zod.null()]).optional(),
            TotalCount: zod.union([zod.number(), zod.null()]).optional(),
            HasPrevious: zod.union([zod.boolean(), zod.null()]).optional(),
            HasNext: zod.union([zod.boolean(), zod.null()]).optional(),
          })
          .describe("DoseSpot page result information."),
        zod.null(),
      ])
      .optional(),
    Result: zod
      .union([
        zod
          .object({
            ResultCode: zod.string(),
            ResultDescription: zod.union([zod.string(), zod.null()]).optional(),
          })
          .describe("Standard DoseSpot API result object."),
        zod.null(),
      ])
      .optional(),
  })
  .describe("Paged list response for detailed RxChange requests.");

/**
 * Approve a pending RxChange request.

This endpoint approves an RxChange request, optionally providing a new prescription
or selecting from the requested medications.

Args:
    rx_change_id: The RxChange ID to approve
    request: The approval request containing optional new prescription details

Returns:
    IdentifierResponseT: Response from the approval operation

Raises:
    AuthException: If the user lacks required privileges
    ValueError: If user doesn't have a DoseSpot clinician record or approval fails
 * @summary Approve Rx Change
 */
export const approveRxChangeParams = zod.object({
  rx_change_id: zod.number(),
});

export const approveRxChangeBody = zod
  .object({
    PriorAuthNumber: zod.union([zod.string(), zod.null()]).optional(),
    SelectedMedicationId: zod.union([zod.number(), zod.null()]).optional(),
    NewPrescriptionPatientId: zod.union([zod.number(), zod.null()]).optional(),
    NewPrescription: zod
      .union([
        zod
          .object({
            DispensableDrugId: zod.number(),
            PatientFormularyId: zod
              .union([zod.number(), zod.null()])
              .optional(),
            Refills: zod.number(),
            DaysSupply: zod.union([zod.number(), zod.null()]).optional(),
            DispenseUnitId: zod.number(),
            Quantity: zod.number(),
            Directions: zod.string(),
            PharmacyId: zod.number(),
            PharmacyNotes: zod.union([zod.string(), zod.null()]).optional(),
            NoSubstitutions: zod.union([zod.boolean(), zod.null()]).optional(),
            EffectiveDate: zod.string(),
            RxReferenceNumber: zod.union([zod.string(), zod.null()]).optional(),
            EligibilityId: zod.union([zod.number(), zod.null()]).optional(),
            NonDoseSpotPrescriptionId: zod
              .union([zod.string(), zod.null()])
              .optional(),
            FirstPrescriptionDiagnosis: zod
              .union([
                zod
                  .object({
                    PrimaryDiagnosisId: zod
                      .union([zod.number(), zod.null()])
                      .optional(),
                    SecondaryDiagnosisId: zod
                      .union([zod.number(), zod.null()])
                      .optional(),
                  })
                  .describe(
                    "DoseSpot prescription diagnosis IDs for requests.",
                  ),
                zod.null(),
              ])
              .optional(),
            SecondPrescriptionDiagnosis: zod
              .union([
                zod
                  .object({
                    PrimaryDiagnosisId: zod
                      .union([zod.number(), zod.null()])
                      .optional(),
                    SecondaryDiagnosisId: zod
                      .union([zod.number(), zod.null()])
                      .optional(),
                  })
                  .describe(
                    "DoseSpot prescription diagnosis IDs for requests.",
                  ),
                zod.null(),
              ])
              .optional(),
            IsRefillReplace: zod.union([zod.boolean(), zod.null()]).optional(),
            IsUrgent: zod.union([zod.boolean(), zod.null()]).optional(),
            SupervisorId: zod.union([zod.number(), zod.null()]).optional(),
            RetailPharmacyToMailToPatient: zod
              .union([zod.boolean(), zod.null()])
              .optional(),
            Status: zod
              .enum([
                "Unknown",
                "Active",
                "Inactive",
                "Discontinued",
                "Deleted",
                "Completed",
                "CancelRequested",
                "CancelPending",
                "Cancelled",
                "CancelDenied",
                "Changed",
                "FullFill",
                "PartialFill",
                "NoFill",
              ])
              .describe("Valid medication status types for DoseSpot."),
            InactiveDate: zod.union([zod.string(), zod.null()]).optional(),
            Comment: zod.union([zod.string(), zod.null()]).optional(),
            Encounter: zod.union([zod.string(), zod.null()]).optional(),
          })
          .describe("Request for coded prescription creation\/editing."),
        zod.null(),
      ])
      .optional(),
    Comment: zod.union([zod.string(), zod.null()]).optional(),
    PrescriberAuthorizationData: zod
      .union([zod.string(), zod.null()])
      .optional(),
    PrescriberLicenseInactive: zod
      .union([zod.boolean(), zod.null()])
      .optional(),
  })
  .describe("Request to approve an RxChange.");

export const approveRxChangeResponse = zod
  .object({
    Id: zod.union([zod.number(), zod.null()]).optional(),
    Result: zod
      .union([
        zod
          .object({
            ResultCode: zod.string(),
            ResultDescription: zod.union([zod.string(), zod.null()]).optional(),
          })
          .describe("Standard DoseSpot API result object."),
        zod.null(),
      ])
      .optional(),
  })
  .describe(
    "Response wrapper for operations that return an entity identifier.",
  );

/**
 * Deny a pending RxChange request.

This endpoint denies an RxChange request by providing the denial reason
and optional comment.

Args:
    rx_change_id: The RxChange ID to deny
    request: The denial request containing denial reason and optional comment

Returns:
    ResponseT: Response from the denial operation

Raises:
    AuthException: If the user lacks required privileges
    ValueError: If user doesn't have a DoseSpot clinician record or denial fails
 * @summary Deny Rx Change
 */
export const denyRxChangeParams = zod.object({
  rx_change_id: zod.number(),
});

export const denyRxChangeBody = zod
  .object({
    Reason: zod
      .enum([
        "DeniedPatientUnknown",
        "DeniedPatientNotUnderCare",
        "DeniedPatientNoLongerUnderPatientCare",
        "DeniedNeverPrescribed",
        "DeniedHavePatientContact",
        "DeniedChangeInappropriate",
        "DeniedNeedAppointment",
        "DeniedPrescriberNotAssociateWithLocation",
        "DeniedNoPriorAuthAttempt",
        "DeniedAlreadyHandled",
        "DeniedAtPatientRequest",
        "DeniedPriorAuthNoAttempt",
        "DeniedPriorAuthInProgress",
        "DeniedOrderNotFound",
        "DeniedPayerNoPriorAuth",
        "DeniedPatientNoRecord",
        "DeniedOrderExpired",
        "DeniedPharmacyNotRecognized",
      ])
      .describe("Reasons for denying an RxChange request."),
    Comment: zod.union([zod.string(), zod.null()]).optional(),
  })
  .describe("Request to deny an RxChange.");

export const denyRxChangeResponse = zod
  .object({
    Result: zod
      .union([
        zod
          .object({
            ResultCode: zod.string(),
            ResultDescription: zod.union([zod.string(), zod.null()]).optional(),
          })
          .describe("Standard DoseSpot API result object."),
        zod.null(),
      ])
      .optional(),
  })
  .describe("Generic response wrapper for operations that don't return data.");

/**
 * Perform an action on a pending RxChange request.

Accepts a discriminated-union body whose ``action`` field selects
approve, deny, or approve_with_changes.  Used by the copilot
proposed-action form so the clinician can review and submit in one step.
 * @summary Rx Change Action
 */
export const rxChangeActionParams = zod.object({
  rx_change_id: zod.number(),
});

export const rxChangeActionBodyActionDefault = "approve";
export const rxChangeActionBodyActionDefaultOne = "deny";
export const rxChangeActionBodyActionDefaultTwo = "approve_with_changes";

export const rxChangeActionBody = zod.union([
  zod.object({
    action: zod.literal("approve").default(rxChangeActionBodyActionDefault),
    selectedMedicationId: zod.union([zod.number(), zod.null()]).optional(),
    priorAuthNumber: zod.union([zod.string(), zod.null()]).optional(),
    comment: zod.union([zod.string(), zod.null()]).optional(),
  }),
  zod.object({
    action: zod.literal("deny").default(rxChangeActionBodyActionDefaultOne),
    denialReason: zod
      .enum([
        "DeniedPatientUnknown",
        "DeniedPatientNotUnderCare",
        "DeniedPatientNoLongerUnderPatientCare",
        "DeniedNeverPrescribed",
        "DeniedHavePatientContact",
        "DeniedChangeInappropriate",
        "DeniedNeedAppointment",
        "DeniedPrescriberNotAssociateWithLocation",
        "DeniedNoPriorAuthAttempt",
        "DeniedAlreadyHandled",
        "DeniedAtPatientRequest",
        "DeniedPriorAuthNoAttempt",
        "DeniedPriorAuthInProgress",
        "DeniedOrderNotFound",
        "DeniedPayerNoPriorAuth",
        "DeniedPatientNoRecord",
        "DeniedOrderExpired",
        "DeniedPharmacyNotRecognized",
      ])
      .optional()
      .describe("Reasons for denying an RxChange request."),
    comment: zod.union([zod.string(), zod.null()]).optional(),
  }),
  zod.object({
    action: zod
      .literal("approve_with_changes")
      .default(rxChangeActionBodyActionDefaultTwo),
    patientUserId: zod.string(),
    newPrescription: zod
      .object({
        DispensableDrugId: zod.number(),
        PatientFormularyId: zod.union([zod.number(), zod.null()]).optional(),
        Refills: zod.number(),
        DaysSupply: zod.union([zod.number(), zod.null()]).optional(),
        DispenseUnitId: zod.number(),
        Quantity: zod.number(),
        Directions: zod.string(),
        PharmacyId: zod.number(),
        PharmacyNotes: zod.union([zod.string(), zod.null()]).optional(),
        NoSubstitutions: zod.union([zod.boolean(), zod.null()]).optional(),
        EffectiveDate: zod.string(),
        RxReferenceNumber: zod.union([zod.string(), zod.null()]).optional(),
        EligibilityId: zod.union([zod.number(), zod.null()]).optional(),
        NonDoseSpotPrescriptionId: zod
          .union([zod.string(), zod.null()])
          .optional(),
        FirstPrescriptionDiagnosis: zod
          .union([
            zod
              .object({
                PrimaryDiagnosisId: zod
                  .union([zod.number(), zod.null()])
                  .optional(),
                SecondaryDiagnosisId: zod
                  .union([zod.number(), zod.null()])
                  .optional(),
              })
              .describe("DoseSpot prescription diagnosis IDs for requests."),
            zod.null(),
          ])
          .optional(),
        SecondPrescriptionDiagnosis: zod
          .union([
            zod
              .object({
                PrimaryDiagnosisId: zod
                  .union([zod.number(), zod.null()])
                  .optional(),
                SecondaryDiagnosisId: zod
                  .union([zod.number(), zod.null()])
                  .optional(),
              })
              .describe("DoseSpot prescription diagnosis IDs for requests."),
            zod.null(),
          ])
          .optional(),
        IsRefillReplace: zod.union([zod.boolean(), zod.null()]).optional(),
        IsUrgent: zod.union([zod.boolean(), zod.null()]).optional(),
        SupervisorId: zod.union([zod.number(), zod.null()]).optional(),
        RetailPharmacyToMailToPatient: zod
          .union([zod.boolean(), zod.null()])
          .optional(),
        Status: zod
          .enum([
            "Unknown",
            "Active",
            "Inactive",
            "Discontinued",
            "Deleted",
            "Completed",
            "CancelRequested",
            "CancelPending",
            "Cancelled",
            "CancelDenied",
            "Changed",
            "FullFill",
            "PartialFill",
            "NoFill",
          ])
          .describe("Valid medication status types for DoseSpot."),
        InactiveDate: zod.union([zod.string(), zod.null()]).optional(),
        Comment: zod.union([zod.string(), zod.null()]).optional(),
        Encounter: zod.union([zod.string(), zod.null()]).optional(),
      })
      .describe("Request for coded prescription creation\/editing."),
    comment: zod.union([zod.string(), zod.null()]).optional(),
  }),
]);

export const rxChangeActionResponse = zod.union([
  zod
    .object({
      Id: zod.union([zod.number(), zod.null()]).optional(),
      Result: zod
        .union([
          zod
            .object({
              ResultCode: zod.string(),
              ResultDescription: zod
                .union([zod.string(), zod.null()])
                .optional(),
            })
            .describe("Standard DoseSpot API result object."),
          zod.null(),
        ])
        .optional(),
    })
    .describe(
      "Response wrapper for operations that return an entity identifier.",
    ),
  zod
    .object({
      Result: zod
        .union([
          zod
            .object({
              ResultCode: zod.string(),
              ResultDescription: zod
                .union([zod.string(), zod.null()])
                .optional(),
            })
            .describe("Standard DoseSpot API result object."),
          zod.null(),
        ])
        .optional(),
    })
    .describe(
      "Generic response wrapper for operations that don't return data.",
    ),
]);

/**
 * Reconcile an RxChange request by linking it to a patient record.

This endpoint links an existing RxChange request to a patient record
and associates it with a referenced prescription.

Args:
    rx_change_id: The RxChange ID to reconcile
    user_id: The patient's user ID
    request: The reconciliation request containing the referenced prescription ID

Raises:
    AuthException: If the user lacks required privileges
    ValueError: If the patient has no DoseSpot record or reconciliation fails
 * @summary Reconcile Rx Change
 */
export const reconcileRxChangeParams = zod.object({
  rx_change_id: zod.number(),
  user_id: zod.uuid(),
});

export const reconcileRxChangeBody = zod.object({
  referencedPrescriptionId: zod.string(),
});

export const reconcileRxChangeResponse = zod.unknown();

/**
 * Change the patient linked to an RxChange request.

This endpoint links the RxChange request to a different, existing patient
in the same clinic.

Args:
    rx_change_id: The RxChange ID to update
    request: The request containing the new patient's user ID

Raises:
    AuthException: If the user lacks required privileges
    ValueError: If the patient has no DoseSpot record or change fails
 * @summary Change Rx Change Patient
 */
export const changeRxChangePatientParams = zod.object({
  rx_change_id: zod.number(),
});

export const changeRxChangePatientBody = zod.object({
  patientUserId: zod.uuid(),
});

export const changeRxChangePatientResponse = zod.unknown();

/**
 * List all prior authorization cases for a given patient.

Drives the Prior Auths tab in the copilot patient workspace. Results
are served from our SQL mirror (``DosespotPriorAuthRecord``), not live
DoseSpot, so the list stays consistent with the clinician inbox even
when DoseSpot is slow.
 * @summary List Patient Prior Auths
 */
export const listPatientPriorAuthsParams = zod.object({
  user_id: zod.uuid(),
});

export const listPatientPriorAuthsResponseItem = zod
  .object({
    id: zod.string(),
    dosespotPriorAuthCaseNumber: zod
      .union([zod.string(), zod.null()])
      .optional(),
    dosespotPrescriptionId: zod.string(),
    prescriptionRecordId: zod.string(),
    status: zod
      .union([
        zod
          .enum([
            "Requested",
            "Appealing",
            "Cancel Requested",
            "Action Required",
            "Approved",
            "Partially Approved",
            "Not Required",
            "Denied",
            "Cancelled",
            "Error",
            "Sent to Pharmacy",
            "Superseded",
            "Ended",
          ])
          .describe(
            'Normalized prior-authorization status.\n\nCollapses DoseSpot\'s 17-value `PriorAuthorizationStatusType` plus the\n25-value `ClosedReasonCodeId` super-status into an \"owns it right now\"\noriented enum. The full mapping from raw DoseSpot status lives on the PA\npoller (`_map_dosespot_status`) and is documented in `PRIOR_AUTH.md`.\n\n``NOT_REQUIRED`` is deliberately distinct from ``APPROVED`` (no auth\nnumber) and ``PARTIALLY_APPROVED`` is distinct from ``APPROVED`` because\nit comes with a narrower Quantity\/DaysSupply\/NumberOfRefills that the\nclinician must acknowledge or appeal.\n\n``StrEnum`` (not plain ``Enum``) because the values round-trip through\nthe ``dosespot_prior_auth_records.normalized_status`` ``TEXT`` column:\nasyncpg only accepts ``str`` for ``TEXT`` bind parameters, and a plain\n``Enum`` instance is not a ``str`` subclass.',
          ),
        zod.null(),
      ])
      .optional(),
    currentStatus: zod.union([zod.string(), zod.null()]).optional(),
    isExpedited: zod.boolean(),
    attachmentRequired: zod.boolean(),
    isOffline: zod.boolean(),
    canAppeal: zod.union([zod.boolean(), zod.null()]).optional(),
    authorizationNumber: zod.union([zod.string(), zod.null()]).optional(),
    nextResponseDeadline: zod.union([zod.string(), zod.null()]).optional(),
    currentStatusDate: zod.union([zod.string(), zod.null()]).optional(),
    lastSeenAt: zod.union([zod.string(), zod.null()]).optional(),
  })
  .describe(
    "Slim per-patient listing item.\n\nThe ``\/greenfield\/dosespot\/patients\/{user_id}\/prior_auths`` endpoint\nreturns a list of these so the Prior Auths tab can render without\npulling the full cached DoseSpot case for every row.",
  );
export const listPatientPriorAuthsResponse = zod.array(
  listPatientPriorAuthsResponseItem,
);

/**
 * Live ``GET /api/patients/{id}/eligibilities`` against DoseSpot.

Drives the Eligibilities sub-section under the Prior Auths tab in
the copilot patient workspace. Unlike the prior-auth list, this is
*live* against DoseSpot — coverages can change as PBM data updates
and we don't mirror them locally. The fake DoseSpot answers from its
in-memory ``CoverageEntry`` table; staging answers from real PBM
data.

Authenticates as the requesting clinician so the audit trail attributes the
eligibility lookup correctly. A Cortex account without a DoseSpot clinician
mapping receives an explicit configuration error; it never falls back to
the clinic administrator.
 * @summary List Patient Eligibilities
 */
export const listPatientEligibilitiesParams = zod.object({
  user_id: zod.uuid(),
});

export const listPatientEligibilitiesResponse = zod
  .object({
    dosespotPatientId: zod.number(),
    items: zod.array(
      zod
        .object({
          PatientEligibilityId: zod
            .union([zod.number(), zod.null()])
            .optional(),
          PayerName: zod.union([zod.string(), zod.null()]).optional(),
          PharmacyEligibilities: zod
            .union([
              zod.array(
                zod
                  .object({
                    PharmacyType: zod
                      .union([
                        zod
                          .enum([
                            "Any",
                            "FaxPharmacy",
                            "EPCS",
                            "TwentyFourHourPharmacy",
                            "LongTermCarePharmacy",
                            "MailOrder",
                            "Retail",
                            "SpecialtyPharmacy",
                          ])
                          .describe(
                            "Valid pharmacy specialty types for DoseSpot.",
                          ),
                        zod.null(),
                      ])
                      .optional(),
                    EligibilityStatus: zod
                      .union([
                        zod
                          .enum([
                            "Covered",
                            "NotCovered",
                            "OutOfPocket",
                            "Unknown",
                            "UnableToProcess",
                          ])
                          .describe(
                            "`EligibilityStatus` on a `PharmacyEligibility` entry.",
                          ),
                        zod.null(),
                      ])
                      .optional(),
                    Name: zod.union([zod.string(), zod.null()]).optional(),
                  })
                  .describe(
                    "Per-channel eligibility entry on a `PayerInformationResponse`.\n\nEach coverage reports one of these per pharmacy type so the Rx-time\ngate can pick the coverage that actually covers the channel the\nprescription is routed to (e.g. Retail vs MailOrder).",
                  ),
              ),
              zod.null(),
            ])
            .optional(),
          PlanName: zod.union([zod.string(), zod.null()]).optional(),
          CoverageId: zod.union([zod.string(), zod.null()]).optional(),
          PayerId: zod.union([zod.string(), zod.null()]).optional(),
          BIN: zod.union([zod.string(), zod.null()]).optional(),
          PCN: zod.union([zod.string(), zod.null()]).optional(),
          FormularyId: zod.union([zod.string(), zod.null()]).optional(),
          AlternativesId: zod.union([zod.string(), zod.null()]).optional(),
          CopayId: zod.union([zod.string(), zod.null()]).optional(),
          DemographicChanges: zod.union([zod.boolean(), zod.null()]).optional(),
          Demographics: zod
            .union([
              zod
                .object({
                  LastName: zod.union([zod.string(), zod.null()]).optional(),
                  FirstName: zod.union([zod.string(), zod.null()]).optional(),
                  MiddleName: zod.union([zod.string(), zod.null()]).optional(),
                  Suffix: zod.union([zod.string(), zod.null()]).optional(),
                  DateOfBirth: zod.union([zod.string(), zod.null()]).optional(),
                  Gender: zod
                    .union([
                      zod
                        .enum(["Male", "Female", "Unknown"])
                        .describe(
                          "`PayerDemographics.Gender` and `CoverageRestrictions.GenderRestriction` values.",
                        ),
                      zod.null(),
                    ])
                    .optional(),
                  Address: zod
                    .union([
                      zod
                        .object({
                          AddressLine1: zod
                            .union([zod.string(), zod.null()])
                            .optional(),
                          AddressLine2: zod
                            .union([zod.string(), zod.null()])
                            .optional(),
                          City: zod
                            .union([zod.string(), zod.null()])
                            .optional(),
                          State: zod
                            .union([zod.string(), zod.null()])
                            .optional(),
                          ZipCode: zod
                            .union([zod.string(), zod.null()])
                            .optional(),
                        })
                        .describe(
                          "`PayerAddress` sub-object on :class:`PayerDemographicsT`.",
                        ),
                      zod.null(),
                    ])
                    .optional(),
                })
                .describe(
                  "`PayerDemographics` block on :class:`PayerInformationT`.\n\nSurfaced when the payer returns updated member demographics on an\neligibility response (combined with ``DemographicChanges=true``).",
                ),
              zod.null(),
            ])
            .optional(),
          ErrorMessage: zod.union([zod.string(), zod.null()]).optional(),
          InfoMessage: zod.union([zod.string(), zod.null()]).optional(),
          MemberId: zod.union([zod.string(), zod.null()]).optional(),
        })
        .describe(
          "One active coverage for a patient (`PayerInformationResponse`).\n\nReturned by `GET \/api\/patients\/{patient_id}\/eligibilities`. The gate\nkeys subsequent `\/formulary` and `\/prescriptionbenefits` calls on\n``PatientEligibilityId``; the other ids (`CoverageId`, `FormularyId`,\n...) are carried through for audit but not otherwise consulted.\n\nFields match the DoseSpot v2 swagger `PayerInformationResponse`\ndefinition exactly. No `GroupId` here — that's a legacy field from\nthe v1 shape and was dropped when v2 consolidated onto `MemberId` +\n``Demographics``.",
        ),
    ),
  })
  .describe(
    'Wrapper around DoseSpot\'s ``\/eligibilities`` payload for the copilot UI.\n\nCarries the resolved ``dosespot_patient_id`` alongside the items so\nthe UI can deep-link into the fake DoseSpot admin (or just show\n\"patient #50000\" for debugging) without a second round-trip.\n``items`` is empty (not omitted) when the patient has no active\ncoverages — same shape DoseSpot itself returns.',
  );

/**
 * Full detail view of a PA case, including the pending question.

``record_id`` is our internal ``DosespotPriorAuthRecord.id`` (UUID7),
not DoseSpot's integer case id — this keeps the copilot URL scheme
stable across patient re-syncs. The handler resolves to DoseSpot when known.

Returns 404 when the record is unknown.
 * @summary Get Prior Auth Details
 */
export const getPriorAuthDetailsParams = zod.object({
  record_id: zod.uuid(),
});

export const getPriorAuthDetailsResponseDosespotCaseAnsweredQuestionsItemAnswersDefault =
  [];
export const getPriorAuthDetailsResponseDosespotCaseAnsweredQuestionsDefault =
  [];

export const getPriorAuthDetailsResponse = zod
  .object({
    caseId: zod.string(),
    prescriptionRecordId: zod.string(),
    initiationState: zod.enum([
      "STARTING",
      "CONFIRMED",
      "RESULT_UNCLEAR",
      "FAILED",
    ]),
    workflowState: zod
      .enum([
        "INITIATING",
        "CONFIRMING_INITIATION",
        "INITIATION_FAILED",
        "QUESTION_REQUIRED",
        "ATTACHMENT_REQUIRED",
        "READY_TO_SUBMIT",
        "SUBMISSION_FAILED",
        "PAYER_REVIEW",
        "APPEAL_REVIEW",
        "CANCELLATION_REVIEW",
        "APPROVED_READY_TO_SEND",
        "NOT_REQUIRED_READY_TO_SEND",
        "PARTIAL_APPROVAL_DECISION",
        "DENIAL_DECISION",
        "PA_FAILED",
        "SENT",
        "CANCELED",
        "SUPERSEDED",
        "ENDED",
      ])
      .describe("What is happening in the PA workflow right now."),
    currentOwner: zod
      .enum(["LOTUS_AUTOMATION", "PAYER", "CLINICIAN", "NONE"])
      .describe("The person or system expected to take the next action."),
    prescriber: zod.string(),
    isCurrentClinicianPrescriber: zod.boolean(),
    allowedActions: zod.array(
      zod
        .enum([
          "ANSWER_QUESTION",
          "UPLOAD_ATTACHMENT",
          "CANCEL",
          "SUBMIT",
          "SEND_PRESCRIPTION",
          "APPEAL",
          "END_PLAN",
          "SELF_PAY",
        ])
        .describe(
          "An action the clinician may take in the current workflow state.",
        ),
    ),
    initiationFailureReason: zod.union([zod.string(), zod.null()]).optional(),
    dosespotCase: zod
      .union([
        zod
          .object({
            caseNumber: zod.string(),
            case: zod
              .object({
                PriorAuthorizationCaseId: zod
                  .union([zod.number(), zod.null()])
                  .optional(),
                PrescriptionId: zod
                  .union([zod.number(), zod.null()])
                  .optional(),
                CaseAlias: zod.union([zod.string(), zod.null()]).optional(),
                Note: zod.union([zod.string(), zod.null()]).optional(),
                IsOffline: zod.union([zod.boolean(), zod.null()]).optional(),
                InitializedDate: zod
                  .union([zod.iso.datetime({}), zod.null()])
                  .optional(),
                NextResponseDeadline: zod
                  .union([zod.iso.datetime({}), zod.null()])
                  .optional(),
                CurrentStatus: zod
                  .union([
                    zod
                      .enum([
                        "Unknown",
                        "Requested",
                        "NotRequired",
                        "Closed",
                        "Deferred",
                        "ActionRequired",
                        "Pending",
                        "Approved",
                        "Denied",
                        "AppealRequested",
                        "CancelRequested",
                        "Canceled",
                        "CancelDenied",
                        "Error",
                        "Deleted",
                        "PartiallyDenied",
                        "InProcess",
                      ])
                      .describe(
                        "Raw `PriorAuthorizationStatusType` values returned by DoseSpot.\n\nAll 17 values from the v2 `PriorAuthorizationStatusType` enum. We collapse\nthese (plus `ClosedReasonCodeId` on `Closed`) into a smaller internal\n`CareStatePriorAuthStatusT` in the poller; the raw string is still stored\non `DosespotPriorAuthRecord.current_status` for observability.",
                      ),
                    zod.null(),
                  ])
                  .optional(),
                CurrentStatusDate: zod
                  .union([zod.iso.datetime({}), zod.null()])
                  .optional(),
                ExpectedResponseDate: zod
                  .union([zod.iso.datetime({}), zod.null()])
                  .optional(),
                AttachmentRequired: zod
                  .union([zod.boolean(), zod.null()])
                  .optional(),
                NextQuestionId: zod
                  .union([zod.number(), zod.null()])
                  .optional(),
                IsExpedited: zod.union([zod.boolean(), zod.null()]).optional(),
                FinalStatus: zod
                  .union([
                    zod
                      .object({
                        PriorAuthorizationStatusType: zod
                          .union([
                            zod
                              .enum([
                                "Unknown",
                                "Requested",
                                "NotRequired",
                                "Closed",
                                "Deferred",
                                "ActionRequired",
                                "Pending",
                                "Approved",
                                "Denied",
                                "AppealRequested",
                                "CancelRequested",
                                "Canceled",
                                "CancelDenied",
                                "Error",
                                "Deleted",
                                "PartiallyDenied",
                                "InProcess",
                              ])
                              .describe(
                                "Raw `PriorAuthorizationStatusType` values returned by DoseSpot.\n\nAll 17 values from the v2 `PriorAuthorizationStatusType` enum. We collapse\nthese (plus `ClosedReasonCodeId` on `Closed`) into a smaller internal\n`CareStatePriorAuthStatusT` in the poller; the raw string is still stored\non `DosespotPriorAuthRecord.current_status` for observability.",
                              ),
                            zod.null(),
                          ])
                          .optional(),
                        ClosedReasonCodeId: zod
                          .union([
                            zod
                              .enum([
                                "Unknown",
                                "ElectronicPriorAuthNotSupported",
                                "Other",
                                "PriorAuthNotRequired",
                                "CannotFindMatchingPatient",
                                "PatientNotEligible",
                                "PriorAuthDuplicateApproved",
                                "PriorAuthDuplicateInProcess",
                                "ClosedByPayer",
                                "ClosedByProvider",
                                "ClosedByMember",
                                "AttachmentTypeNotSupported",
                                "PrescriberNotAllowedToSubmitPARequest",
                                "ResponseInconsistentWithQuestion",
                                "ReceiverNotPAProcessorForThisPatient",
                                "ReceiverNotPAProcessorForPatientMedicationCombo",
                                "DuplicateDenied",
                                "ProviderRespondedAfterDeadlineToReply",
                                "ProductNotCoveredByThisPlanPriorAuthorizationNotAvailable",
                                "PrescriptionWithinPrescribingLimitsPriorAuthorizationNotRequiredForPatientMedication",
                                "CoverageLimitsMayExistForQuantityAndOrDaysSupply",
                                "CoverageLimitsHaveBeenExceededExceptionNotAvailable",
                                "ActivePAOnFile",
                                "SubmittedProductCodeIsNotValid",
                              ])
                              .describe(
                                "Raw `ClosedReasonCodeId` values on a `Closed` PA case.\n\nAll 25 values from the v2 `ClosedReasonCodeId` enum. Combined with the\n`Closed` super-status these disambiguate terminal outcomes (see\n`PRIOR_AUTH.md` for the mapping to our normalized status).",
                              ),
                            zod.null(),
                          ])
                          .optional(),
                        AuthorizationNumber: zod
                          .union([zod.string(), zod.null()])
                          .optional(),
                        AuthorizationPeriodStart: zod
                          .union([zod.iso.datetime({}), zod.null()])
                          .optional(),
                        AuthorizationPeriodEnd: zod
                          .union([zod.iso.datetime({}), zod.null()])
                          .optional(),
                        PharmacyType: zod
                          .union([
                            zod
                              .enum([
                                "Unknown",
                                "Retail",
                                "MailOrder",
                                "SpecialtyPharmacy",
                                "LongTermCarePharmacy",
                                "Any",
                                "TwentyFourHourPharmacy",
                                "FaxPharmacy",
                                "EPCS",
                                "InHouseDispensing",
                                "Compounding",
                                "DME",
                                "Kiosk",
                                "SupportsDigitalSignature",
                                "FaxPharmacyExternal",
                              ])
                              .describe(
                                "Raw `PharmacyType` values returned on `PAFinalStatus`.\n\nAll 15 values from the v2 `PharmacyType` enum. Carried through to\n`DosespotPriorAuthRecord.pharmacy_type` so downstream Rx routing can be\nconstrained to match the approved channel.",
                              ),
                            zod.null(),
                          ])
                          .optional(),
                        Quantity: zod
                          .union([zod.string(), zod.null()])
                          .optional(),
                        DaysSupply: zod
                          .union([zod.string(), zod.null()])
                          .optional(),
                        NumberOfCycles: zod
                          .union([zod.string(), zod.null()])
                          .optional(),
                        NumberOfRefills: zod
                          .union([zod.string(), zod.null()])
                          .optional(),
                        Note: zod.union([zod.string(), zod.null()]).optional(),
                        CanAppeal: zod
                          .union([zod.boolean(), zod.null()])
                          .optional(),
                      })
                      .describe(
                        "Terminal-state details on a closed PA case (`PAFinalStatus`).\n\n`PriorAuthorizationStatusType` holds the underlying DoseSpot status; for\ntruly closed cases `ClosedReasonCodeId` disambiguates approval vs. denial\nvs. not-required. `Quantity`, `DaysSupply`, `NumberOfCycles`, and\n`NumberOfRefills` are the payer's narrowed scope — all strings per the\nswagger — and drive downstream prescription-constraint enforcement.",
                      ),
                    zod.null(),
                  ])
                  .optional(),
                AppealDetails: zod
                  .union([
                    zod
                      .object({
                        AppealCaseId: zod
                          .union([zod.string(), zod.null()])
                          .optional(),
                        NotesForAppeal: zod
                          .union([zod.string(), zod.null()])
                          .optional(),
                        AppealReason: zod
                          .union([zod.string(), zod.null()])
                          .optional(),
                      })
                      .describe(
                        "Appeal metadata for an appealed PA case (`PAAppealDetails`).",
                      ),
                    zod.null(),
                  ])
                  .optional(),
                CancelDetails: zod
                  .union([
                    zod
                      .object({
                        CancelReason: zod
                          .union([zod.string(), zod.null()])
                          .optional(),
                      })
                      .describe(
                        "Cancellation metadata for a cancelled PA case (`PACancelDetails`).",
                      ),
                    zod.null(),
                  ])
                  .optional(),
                Attachments: zod
                  .union([
                    zod.array(
                      zod
                        .object({
                          AttachmentId: zod
                            .union([zod.number(), zod.null()])
                            .optional(),
                          CreatedDateStamp: zod
                            .union([zod.iso.datetime({}), zod.null()])
                            .optional(),
                          FileName: zod
                            .union([zod.string(), zod.null()])
                            .optional(),
                          IsOutbound: zod
                            .union([zod.boolean(), zod.null()])
                            .optional(),
                        })
                        .describe(
                          "A single attachment on a PA case (`PAAttachment`).",
                        ),
                    ),
                    zod.null(),
                  ])
                  .optional(),
              })
              .describe(
                "Full details of a PA case (`PriorAuthorizationCaseFullDetails`).\n\nReturned by `GET \/api\/priorAuths\/{id}` and list items under\n`GET \/api\/patients\/{patientId}\/priorAuths`. The whole payload is also\nstored verbatim on `DosespotPriorAuthRecord.cached_case` so downstream\nprocessing has access to every field (including `FinalStatus.Quantity` \/\n`DaysSupply` \/ `NumberOfCycles` \/ `NumberOfRefills`).",
              ),
            lastRefreshedAt: zod.union([zod.string(), zod.null()]).optional(),
            history: zod
              .union([
                zod
                  .object({
                    FinalStatus: zod
                      .union([zod.string(), zod.null()])
                      .optional(),
                    AuthorizationNumber: zod
                      .union([zod.string(), zod.null()])
                      .optional(),
                    EffectiveDate: zod
                      .union([zod.iso.datetime({}), zod.null()])
                      .optional(),
                    ExpirationDate: zod
                      .union([zod.iso.datetime({}), zod.null()])
                      .optional(),
                    Note: zod.union([zod.string(), zod.null()]).optional(),
                    CanAppeal: zod.union([zod.string(), zod.null()]).optional(),
                    IsOffline: zod
                      .union([zod.boolean(), zod.null()])
                      .optional(),
                    Attachments: zod
                      .union([
                        zod.array(
                          zod
                            .object({
                              AttachmentId: zod
                                .union([zod.number(), zod.null()])
                                .optional(),
                              CreatedDateStamp: zod
                                .union([zod.iso.datetime({}), zod.null()])
                                .optional(),
                              FileName: zod
                                .union([zod.string(), zod.null()])
                                .optional(),
                              IsOutbound: zod
                                .union([zod.boolean(), zod.null()])
                                .optional(),
                            })
                            .describe(
                              "A single attachment on a PA case (`PAAttachment`).",
                            ),
                        ),
                        zod.null(),
                      ])
                      .optional(),
                    StatusLogs: zod
                      .union([
                        zod.array(
                          zod
                            .object({
                              Status: zod
                                .union([zod.string(), zod.null()])
                                .optional(),
                              AdditionalInfo: zod
                                .union([zod.string(), zod.null()])
                                .optional(),
                              AdditionalInfoAttachmentId: zod
                                .union([zod.number(), zod.null()])
                                .optional(),
                              CreatedDateStamp: zod
                                .union([zod.iso.datetime({}), zod.null()])
                                .optional(),
                              Attachment: zod
                                .union([
                                  zod
                                    .object({
                                      AttachmentId: zod
                                        .union([zod.number(), zod.null()])
                                        .optional(),
                                      CreatedDateStamp: zod
                                        .union([
                                          zod.iso.datetime({}),
                                          zod.null(),
                                        ])
                                        .optional(),
                                      FileName: zod
                                        .union([zod.string(), zod.null()])
                                        .optional(),
                                      IsOutbound: zod
                                        .union([zod.boolean(), zod.null()])
                                        .optional(),
                                    })
                                    .describe(
                                      "A single attachment on a PA case (`PAAttachment`).",
                                    ),
                                  zod.null(),
                                ])
                                .optional(),
                            })
                            .describe(
                              "A single row in a PA status log.\n\nUnified shape covering both `PAStatusLog` (embedded in the history\nresponse — carries `AdditionalInfoAttachmentId`) and `PriorAuthStatusLogUI`\n(the `\/statusLog` endpoint — carries a fully-expanded `Attachment`). Only\none of the attachment fields is populated per row depending on the source.",
                            ),
                        ),
                        zod.null(),
                      ])
                      .optional(),
                    QuestionSets: zod
                      .union([
                        zod.array(
                          zod
                            .object({
                              PriorAuthorizationQuestionSetId: zod
                                .union([zod.number(), zod.null()])
                                .optional(),
                              QuestionSetAlias: zod
                                .union([zod.string(), zod.null()])
                                .optional(),
                              Title: zod
                                .union([zod.string(), zod.null()])
                                .optional(),
                              AnsweredQuestions: zod
                                .union([
                                  zod.array(
                                    zod
                                      .object({
                                        Question: zod
                                          .union([zod.string(), zod.null()])
                                          .optional(),
                                        Answers: zod
                                          .union([
                                            zod.array(
                                              zod
                                                .object({
                                                  Answer: zod
                                                    .union([
                                                      zod.string(),
                                                      zod.null(),
                                                    ])
                                                    .optional(),
                                                  AnswerDateTime: zod
                                                    .union([
                                                      zod.iso.datetime({}),
                                                      zod.null(),
                                                    ])
                                                    .optional(),
                                                  AnswerNumeric: zod
                                                    .union([
                                                      zod.number(),
                                                      zod.null(),
                                                    ])
                                                    .optional(),
                                                  AnswerFreeText: zod
                                                    .union([
                                                      zod.string(),
                                                      zod.null(),
                                                    ])
                                                    .optional(),
                                                })
                                                .describe(
                                                  "One captured answer in a PA question history (`PAAnswers`).\n\nOnly one of `AnswerDateTime` \/ `AnswerNumeric` \/ `AnswerFreeText` \/\n`Answer` is populated per row, determined by the question's\n`PriorAuthorizationAnswerTypeT`.",
                                                ),
                                            ),
                                            zod.null(),
                                          ])
                                          .optional(),
                                      })
                                      .describe(
                                        "A question together with its answers (`PAAnsweredQuestions`).",
                                      ),
                                  ),
                                  zod.null(),
                                ])
                                .optional(),
                              Attachments: zod
                                .union([
                                  zod.array(
                                    zod
                                      .object({
                                        AttachmentId: zod
                                          .union([zod.number(), zod.null()])
                                          .optional(),
                                        CreatedDateStamp: zod
                                          .union([
                                            zod.iso.datetime({}),
                                            zod.null(),
                                          ])
                                          .optional(),
                                        FileName: zod
                                          .union([zod.string(), zod.null()])
                                          .optional(),
                                        IsOutbound: zod
                                          .union([zod.boolean(), zod.null()])
                                          .optional(),
                                      })
                                      .describe(
                                        "A single attachment on a PA case (`PAAttachment`).",
                                      ),
                                  ),
                                  zod.null(),
                                ])
                                .optional(),
                            })
                            .describe(
                              "One question-set block inside a PA history (`PAHistoryQuestionSet`).",
                            ),
                        ),
                        zod.null(),
                      ])
                      .optional(),
                    Result: zod
                      .union([
                        zod
                          .object({
                            ResultCode: zod.string(),
                            ResultDescription: zod
                              .union([zod.string(), zod.null()])
                              .optional(),
                          })
                          .describe("Standard DoseSpot API result object."),
                        zod.null(),
                      ])
                      .optional(),
                  })
                  .describe(
                    "Full PA history payload (`PriorAuthorizationHistoryResponse`).\n\nStored verbatim on `DosespotPriorAuthRecord.cached_history` so the\nquestion\/answer trail and status log remain available for audit and\ncopilot context.",
                  ),
                zod.null(),
              ])
              .optional(),
            statusLog: zod
              .union([
                zod
                  .object({
                    StatusLog: zod
                      .union([
                        zod.array(
                          zod
                            .object({
                              Status: zod
                                .union([zod.string(), zod.null()])
                                .optional(),
                              AdditionalInfo: zod
                                .union([zod.string(), zod.null()])
                                .optional(),
                              AdditionalInfoAttachmentId: zod
                                .union([zod.number(), zod.null()])
                                .optional(),
                              CreatedDateStamp: zod
                                .union([zod.iso.datetime({}), zod.null()])
                                .optional(),
                              Attachment: zod
                                .union([
                                  zod
                                    .object({
                                      AttachmentId: zod
                                        .union([zod.number(), zod.null()])
                                        .optional(),
                                      CreatedDateStamp: zod
                                        .union([
                                          zod.iso.datetime({}),
                                          zod.null(),
                                        ])
                                        .optional(),
                                      FileName: zod
                                        .union([zod.string(), zod.null()])
                                        .optional(),
                                      IsOutbound: zod
                                        .union([zod.boolean(), zod.null()])
                                        .optional(),
                                    })
                                    .describe(
                                      "A single attachment on a PA case (`PAAttachment`).",
                                    ),
                                  zod.null(),
                                ])
                                .optional(),
                            })
                            .describe(
                              "A single row in a PA status log.\n\nUnified shape covering both `PAStatusLog` (embedded in the history\nresponse — carries `AdditionalInfoAttachmentId`) and `PriorAuthStatusLogUI`\n(the `\/statusLog` endpoint — carries a fully-expanded `Attachment`). Only\none of the attachment fields is populated per row depending on the source.",
                            ),
                        ),
                        zod.null(),
                      ])
                      .optional(),
                    Result: zod
                      .union([
                        zod
                          .object({
                            ResultCode: zod.string(),
                            ResultDescription: zod
                              .union([zod.string(), zod.null()])
                              .optional(),
                          })
                          .describe("Standard DoseSpot API result object."),
                        zod.null(),
                      ])
                      .optional(),
                  })
                  .describe(
                    "UI-oriented status log response (`PriorAuthorizationStatusLogUIResponse`).",
                  ),
                zod.null(),
              ])
              .optional(),
            pendingQuestion: zod
              .union([
                zod
                  .object({
                    QuestionText: zod
                      .union([zod.string(), zod.null()])
                      .optional(),
                    AnswerType: zod
                      .union([
                        zod
                          .enum([
                            "Select",
                            "Multiselect",
                            "Date",
                            "DateTime",
                            "Numeric",
                            "FreeText",
                          ])
                          .describe(
                            "Kind of answer a PA question expects.\n\nDrives which form widget the clinician UI renders for each question and,\nconsequently, which field(s) of ``PriorAuthorizationAnswerRequestT`` must\nbe populated when submitting the answer.",
                          ),
                        zod.null(),
                      ])
                      .optional(),
                    AnswerChoices: zod
                      .union([
                        zod.array(
                          zod
                            .object({
                              QuestionChoiceId: zod
                                .union([zod.number(), zod.null()])
                                .optional(),
                              QuestionChoiceText: zod
                                .union([zod.string(), zod.null()])
                                .optional(),
                              AdditionalFreeTextRequired: zod
                                .union([zod.boolean(), zod.null()])
                                .optional(),
                              AdditionalFreeTextAllowed: zod
                                .union([zod.boolean(), zod.null()])
                                .optional(),
                            })
                            .describe(
                              "One selectable choice on a PA question (`PriorAuthorizationQuestionResponseChoice`).",
                            ),
                        ),
                        zod.null(),
                      ])
                      .optional(),
                    Result: zod
                      .union([
                        zod
                          .object({
                            ResultCode: zod.string(),
                            ResultDescription: zod
                              .union([zod.string(), zod.null()])
                              .optional(),
                          })
                          .describe("Standard DoseSpot API result object."),
                        zod.null(),
                      ])
                      .optional(),
                  })
                  .describe(
                    "Single PA question detail (`PriorAuthQuestionResponse`).",
                  ),
                zod.null(),
              ])
              .optional(),
            pendingQuestionId: zod.union([zod.string(), zod.null()]).optional(),
            answeredQuestions: zod
              .array(
                zod
                  .object({
                    questionId: zod.string(),
                    questionText: zod
                      .union([zod.string(), zod.null()])
                      .optional(),
                    question: zod
                      .union([
                        zod
                          .object({
                            QuestionText: zod
                              .union([zod.string(), zod.null()])
                              .optional(),
                            AnswerType: zod
                              .union([
                                zod
                                  .enum([
                                    "Select",
                                    "Multiselect",
                                    "Date",
                                    "DateTime",
                                    "Numeric",
                                    "FreeText",
                                  ])
                                  .describe(
                                    "Kind of answer a PA question expects.\n\nDrives which form widget the clinician UI renders for each question and,\nconsequently, which field(s) of ``PriorAuthorizationAnswerRequestT`` must\nbe populated when submitting the answer.",
                                  ),
                                zod.null(),
                              ])
                              .optional(),
                            AnswerChoices: zod
                              .union([
                                zod.array(
                                  zod
                                    .object({
                                      QuestionChoiceId: zod
                                        .union([zod.number(), zod.null()])
                                        .optional(),
                                      QuestionChoiceText: zod
                                        .union([zod.string(), zod.null()])
                                        .optional(),
                                      AdditionalFreeTextRequired: zod
                                        .union([zod.boolean(), zod.null()])
                                        .optional(),
                                      AdditionalFreeTextAllowed: zod
                                        .union([zod.boolean(), zod.null()])
                                        .optional(),
                                    })
                                    .describe(
                                      "One selectable choice on a PA question (`PriorAuthorizationQuestionResponseChoice`).",
                                    ),
                                ),
                                zod.null(),
                              ])
                              .optional(),
                            Result: zod
                              .union([
                                zod
                                  .object({
                                    ResultCode: zod.string(),
                                    ResultDescription: zod
                                      .union([zod.string(), zod.null()])
                                      .optional(),
                                  })
                                  .describe(
                                    "Standard DoseSpot API result object.",
                                  ),
                                zod.null(),
                              ])
                              .optional(),
                          })
                          .describe(
                            "Single PA question detail (`PriorAuthQuestionResponse`).",
                          ),
                        zod.null(),
                      ])
                      .optional(),
                    answers: zod
                      .array(
                        zod
                          .object({
                            Answer: zod
                              .union([zod.string(), zod.null()])
                              .optional(),
                            AnswerDateTime: zod
                              .union([zod.iso.datetime({}), zod.null()])
                              .optional(),
                            AnswerNumeric: zod
                              .union([zod.number(), zod.null()])
                              .optional(),
                            AnswerFreeText: zod
                              .union([zod.string(), zod.null()])
                              .optional(),
                          })
                          .describe(
                            "One captured answer in a PA question history (`PAAnswers`).\n\nOnly one of `AnswerDateTime` \/ `AnswerNumeric` \/ `AnswerFreeText` \/\n`Answer` is populated per row, determined by the question's\n`PriorAuthorizationAnswerTypeT`.",
                          ),
                      )
                      .default(
                        getPriorAuthDetailsResponseDosespotCaseAnsweredQuestionsItemAnswersDefault,
                      ),
                  })
                  .describe(
                    "A previously-answered PA question, resolved back to its DoseSpot id.\n\nDoseSpot's history payload lists answered questions by \*text\* only, so we\npair each recorded observed question (captured when the clinician answered\nit) with the question detail. Carrying the full ``question`` (answer type +\nchoices) lets the copilot re-render the exact same answer form so the\nclinician can revise their reply and POST a new answer to ``question_id`` —\nDoseSpot accepts a fresh answer to an already-answered question until the\ncase is submitted.",
                  ),
              )
              .default(
                getPriorAuthDetailsResponseDosespotCaseAnsweredQuestionsDefault,
              ),
          })
          .describe(
            "DoseSpot facts available after Lotus confirms the external case.\n\nWraps the three DoseSpot read-only payloads (case details, history,\nstatus log) alongside the payer's currently-pending question when there\nis one. The frontend renders the question form from\n``pending_question`` when ``case.NextQuestionId`` is populated and\nstatus is ``ACTION_REQUIRED``.\n\n``answered_questions`` carries the already-answered questions resolved\nback to their DoseSpot ids so the clinician can re-open one and revise\nthe answer before submitting.",
          ),
        zod.null(),
      ])
      .optional(),
  })
  .describe(
    "Current Lotus workflow state for one durable PA case.\n\nThis local view exists from the first initiation attempt through the final\noutcome. ``dosespot_case`` is populated only after Lotus has confirmed and\nread the external case, keeping DoseSpot-owned facts separate from the\nLotus-owned workflow state and allowed actions.",
  );

/**
 * Perform an action on a PA case.

Accepts the discriminated-union command selected by ``action``; the case
endpoint is the source of truth for allowed commands. Used by the
clinician can review and submit in one step.
 * @summary Prior Auth Action
 */
export const priorAuthActionParams = zod.object({
  case_id: zod.uuid(),
});

export const priorAuthActionBodyActionDefault = "answer_question";
export const priorAuthActionBodyQuestionIdRegExp = new RegExp("^\\d+$");
export const priorAuthActionBodyActionDefaultOne = "submit";
export const priorAuthActionBodyActionDefaultTwo = "upload_attachment";
export const priorAuthActionBodyActionDefaultThree = "cancel";
export const priorAuthActionBodyActionDefaultFour = "appeal";
export const priorAuthActionBodyActionDefaultFive = "send_prescription";
export const priorAuthActionBodyActionDefaultSix = "end_plan";
export const priorAuthActionBodyActionDefaultSeven = "self_pay";

export const priorAuthActionBody = zod.union([
  zod.object({
    action: zod
      .literal("answer_question")
      .default(priorAuthActionBodyActionDefault),
    questionId: zod.string().regex(priorAuthActionBodyQuestionIdRegExp),
    answer: zod
      .object({
        PriorAuthorizationQuestionChoices: zod
          .union([
            zod.array(
              zod
                .object({
                  PriorAuthorizationQuestionChoiceId: zod
                    .union([zod.number(), zod.null()])
                    .optional(),
                  PriorAuthorizationQuestionChoiceText: zod
                    .union([zod.string(), zod.null()])
                    .optional(),
                })
                .describe(
                  "A single chosen answer value (`PriorAuthorizationChoiceAnswer`).\n\nUsed inside `PriorAuthorizationAnswerRequestT.PriorAuthorizationQuestionChoices`\nfor `Select`\/`Multiselect` question types.",
                ),
            ),
            zod.null(),
          ])
          .optional(),
        DateTimeAnswer: zod
          .union([zod.iso.datetime({}), zod.null()])
          .optional(),
        NumericAnswer: zod.union([zod.number(), zod.null()]).optional(),
        FreeTextAnswer: zod.union([zod.string(), zod.null()]).optional(),
      })
      .describe(
        "Body for `POST \/priorAuths\/{id}\/questions\/{qid}\/answer` (`PriorAuthAnswerRequest`).\n\nExactly one of these fields should be populated, matching the question's\n`AnswerType`:\n\n- `Select`\/`Multiselect` → `PriorAuthorizationQuestionChoices`\n- `Date`\/`DateTime`      → `DateTimeAnswer`\n- `Numeric`              → `NumericAnswer`\n- `FreeText`             → `FreeTextAnswer`",
      ),
  }),
  zod.object({
    action: zod.literal("submit").default(priorAuthActionBodyActionDefaultOne),
  }),
  zod
    .object({
      action: zod
        .literal("upload_attachment")
        .default(priorAuthActionBodyActionDefaultTwo),
      fileName: zod.string(),
      contentType: zod.string(),
      contentBase64: zod.string(),
    })
    .describe(
      "Upload an attachment to a PA case.\n\n``content`` is base64-encoded on the wire; the handler decodes it before\nforwarding to DoseSpot. Using a JSON body (rather than multipart) keeps\nthe endpoint uniform with the other PA actions and avoids the OpenAPI\ncodegen limitations around multipart\/form-data in our JS SDK.",
    ),
  zod.object({
    action: zod
      .literal("cancel")
      .default(priorAuthActionBodyActionDefaultThree),
  }),
  zod.object({
    action: zod.literal("appeal").default(priorAuthActionBodyActionDefaultFour),
    appealReason: zod.string(),
  }),
  zod.object({
    action: zod
      .literal("send_prescription")
      .default(priorAuthActionBodyActionDefaultFive),
  }),
  zod.object({
    action: zod
      .literal("end_plan")
      .default(priorAuthActionBodyActionDefaultSix),
    reason: zod.string().min(1),
  }),
  zod.object({
    action: zod
      .literal("self_pay")
      .default(priorAuthActionBodyActionDefaultSeven),
    reason: zod.string().min(1),
    patientAgreed: zod.boolean(),
  }),
]);

export const priorAuthActionResponseCurrentCaseDosespotCaseAnsweredQuestionsItemAnswersDefault =
  [];
export const priorAuthActionResponseCurrentCaseDosespotCaseAnsweredQuestionsDefault =
  [];

export const priorAuthActionResponse = zod.object({
  outcome: zod.enum([
    "APPLIED",
    "REJECTED",
    "CONFIRMATION_PENDING",
    "APPLIED_LOCAL_SYNC_PENDING",
  ]),
  currentCase: zod
    .object({
      caseId: zod.string(),
      prescriptionRecordId: zod.string(),
      initiationState: zod.enum([
        "STARTING",
        "CONFIRMED",
        "RESULT_UNCLEAR",
        "FAILED",
      ]),
      workflowState: zod
        .enum([
          "INITIATING",
          "CONFIRMING_INITIATION",
          "INITIATION_FAILED",
          "QUESTION_REQUIRED",
          "ATTACHMENT_REQUIRED",
          "READY_TO_SUBMIT",
          "SUBMISSION_FAILED",
          "PAYER_REVIEW",
          "APPEAL_REVIEW",
          "CANCELLATION_REVIEW",
          "APPROVED_READY_TO_SEND",
          "NOT_REQUIRED_READY_TO_SEND",
          "PARTIAL_APPROVAL_DECISION",
          "DENIAL_DECISION",
          "PA_FAILED",
          "SENT",
          "CANCELED",
          "SUPERSEDED",
          "ENDED",
        ])
        .describe("What is happening in the PA workflow right now."),
      currentOwner: zod
        .enum(["LOTUS_AUTOMATION", "PAYER", "CLINICIAN", "NONE"])
        .describe("The person or system expected to take the next action."),
      prescriber: zod.string(),
      isCurrentClinicianPrescriber: zod.boolean(),
      allowedActions: zod.array(
        zod
          .enum([
            "ANSWER_QUESTION",
            "UPLOAD_ATTACHMENT",
            "CANCEL",
            "SUBMIT",
            "SEND_PRESCRIPTION",
            "APPEAL",
            "END_PLAN",
            "SELF_PAY",
          ])
          .describe(
            "An action the clinician may take in the current workflow state.",
          ),
      ),
      initiationFailureReason: zod.union([zod.string(), zod.null()]).optional(),
      dosespotCase: zod
        .union([
          zod
            .object({
              caseNumber: zod.string(),
              case: zod
                .object({
                  PriorAuthorizationCaseId: zod
                    .union([zod.number(), zod.null()])
                    .optional(),
                  PrescriptionId: zod
                    .union([zod.number(), zod.null()])
                    .optional(),
                  CaseAlias: zod.union([zod.string(), zod.null()]).optional(),
                  Note: zod.union([zod.string(), zod.null()]).optional(),
                  IsOffline: zod.union([zod.boolean(), zod.null()]).optional(),
                  InitializedDate: zod
                    .union([zod.iso.datetime({}), zod.null()])
                    .optional(),
                  NextResponseDeadline: zod
                    .union([zod.iso.datetime({}), zod.null()])
                    .optional(),
                  CurrentStatus: zod
                    .union([
                      zod
                        .enum([
                          "Unknown",
                          "Requested",
                          "NotRequired",
                          "Closed",
                          "Deferred",
                          "ActionRequired",
                          "Pending",
                          "Approved",
                          "Denied",
                          "AppealRequested",
                          "CancelRequested",
                          "Canceled",
                          "CancelDenied",
                          "Error",
                          "Deleted",
                          "PartiallyDenied",
                          "InProcess",
                        ])
                        .describe(
                          "Raw `PriorAuthorizationStatusType` values returned by DoseSpot.\n\nAll 17 values from the v2 `PriorAuthorizationStatusType` enum. We collapse\nthese (plus `ClosedReasonCodeId` on `Closed`) into a smaller internal\n`CareStatePriorAuthStatusT` in the poller; the raw string is still stored\non `DosespotPriorAuthRecord.current_status` for observability.",
                        ),
                      zod.null(),
                    ])
                    .optional(),
                  CurrentStatusDate: zod
                    .union([zod.iso.datetime({}), zod.null()])
                    .optional(),
                  ExpectedResponseDate: zod
                    .union([zod.iso.datetime({}), zod.null()])
                    .optional(),
                  AttachmentRequired: zod
                    .union([zod.boolean(), zod.null()])
                    .optional(),
                  NextQuestionId: zod
                    .union([zod.number(), zod.null()])
                    .optional(),
                  IsExpedited: zod
                    .union([zod.boolean(), zod.null()])
                    .optional(),
                  FinalStatus: zod
                    .union([
                      zod
                        .object({
                          PriorAuthorizationStatusType: zod
                            .union([
                              zod
                                .enum([
                                  "Unknown",
                                  "Requested",
                                  "NotRequired",
                                  "Closed",
                                  "Deferred",
                                  "ActionRequired",
                                  "Pending",
                                  "Approved",
                                  "Denied",
                                  "AppealRequested",
                                  "CancelRequested",
                                  "Canceled",
                                  "CancelDenied",
                                  "Error",
                                  "Deleted",
                                  "PartiallyDenied",
                                  "InProcess",
                                ])
                                .describe(
                                  "Raw `PriorAuthorizationStatusType` values returned by DoseSpot.\n\nAll 17 values from the v2 `PriorAuthorizationStatusType` enum. We collapse\nthese (plus `ClosedReasonCodeId` on `Closed`) into a smaller internal\n`CareStatePriorAuthStatusT` in the poller; the raw string is still stored\non `DosespotPriorAuthRecord.current_status` for observability.",
                                ),
                              zod.null(),
                            ])
                            .optional(),
                          ClosedReasonCodeId: zod
                            .union([
                              zod
                                .enum([
                                  "Unknown",
                                  "ElectronicPriorAuthNotSupported",
                                  "Other",
                                  "PriorAuthNotRequired",
                                  "CannotFindMatchingPatient",
                                  "PatientNotEligible",
                                  "PriorAuthDuplicateApproved",
                                  "PriorAuthDuplicateInProcess",
                                  "ClosedByPayer",
                                  "ClosedByProvider",
                                  "ClosedByMember",
                                  "AttachmentTypeNotSupported",
                                  "PrescriberNotAllowedToSubmitPARequest",
                                  "ResponseInconsistentWithQuestion",
                                  "ReceiverNotPAProcessorForThisPatient",
                                  "ReceiverNotPAProcessorForPatientMedicationCombo",
                                  "DuplicateDenied",
                                  "ProviderRespondedAfterDeadlineToReply",
                                  "ProductNotCoveredByThisPlanPriorAuthorizationNotAvailable",
                                  "PrescriptionWithinPrescribingLimitsPriorAuthorizationNotRequiredForPatientMedication",
                                  "CoverageLimitsMayExistForQuantityAndOrDaysSupply",
                                  "CoverageLimitsHaveBeenExceededExceptionNotAvailable",
                                  "ActivePAOnFile",
                                  "SubmittedProductCodeIsNotValid",
                                ])
                                .describe(
                                  "Raw `ClosedReasonCodeId` values on a `Closed` PA case.\n\nAll 25 values from the v2 `ClosedReasonCodeId` enum. Combined with the\n`Closed` super-status these disambiguate terminal outcomes (see\n`PRIOR_AUTH.md` for the mapping to our normalized status).",
                                ),
                              zod.null(),
                            ])
                            .optional(),
                          AuthorizationNumber: zod
                            .union([zod.string(), zod.null()])
                            .optional(),
                          AuthorizationPeriodStart: zod
                            .union([zod.iso.datetime({}), zod.null()])
                            .optional(),
                          AuthorizationPeriodEnd: zod
                            .union([zod.iso.datetime({}), zod.null()])
                            .optional(),
                          PharmacyType: zod
                            .union([
                              zod
                                .enum([
                                  "Unknown",
                                  "Retail",
                                  "MailOrder",
                                  "SpecialtyPharmacy",
                                  "LongTermCarePharmacy",
                                  "Any",
                                  "TwentyFourHourPharmacy",
                                  "FaxPharmacy",
                                  "EPCS",
                                  "InHouseDispensing",
                                  "Compounding",
                                  "DME",
                                  "Kiosk",
                                  "SupportsDigitalSignature",
                                  "FaxPharmacyExternal",
                                ])
                                .describe(
                                  "Raw `PharmacyType` values returned on `PAFinalStatus`.\n\nAll 15 values from the v2 `PharmacyType` enum. Carried through to\n`DosespotPriorAuthRecord.pharmacy_type` so downstream Rx routing can be\nconstrained to match the approved channel.",
                                ),
                              zod.null(),
                            ])
                            .optional(),
                          Quantity: zod
                            .union([zod.string(), zod.null()])
                            .optional(),
                          DaysSupply: zod
                            .union([zod.string(), zod.null()])
                            .optional(),
                          NumberOfCycles: zod
                            .union([zod.string(), zod.null()])
                            .optional(),
                          NumberOfRefills: zod
                            .union([zod.string(), zod.null()])
                            .optional(),
                          Note: zod
                            .union([zod.string(), zod.null()])
                            .optional(),
                          CanAppeal: zod
                            .union([zod.boolean(), zod.null()])
                            .optional(),
                        })
                        .describe(
                          "Terminal-state details on a closed PA case (`PAFinalStatus`).\n\n`PriorAuthorizationStatusType` holds the underlying DoseSpot status; for\ntruly closed cases `ClosedReasonCodeId` disambiguates approval vs. denial\nvs. not-required. `Quantity`, `DaysSupply`, `NumberOfCycles`, and\n`NumberOfRefills` are the payer's narrowed scope — all strings per the\nswagger — and drive downstream prescription-constraint enforcement.",
                        ),
                      zod.null(),
                    ])
                    .optional(),
                  AppealDetails: zod
                    .union([
                      zod
                        .object({
                          AppealCaseId: zod
                            .union([zod.string(), zod.null()])
                            .optional(),
                          NotesForAppeal: zod
                            .union([zod.string(), zod.null()])
                            .optional(),
                          AppealReason: zod
                            .union([zod.string(), zod.null()])
                            .optional(),
                        })
                        .describe(
                          "Appeal metadata for an appealed PA case (`PAAppealDetails`).",
                        ),
                      zod.null(),
                    ])
                    .optional(),
                  CancelDetails: zod
                    .union([
                      zod
                        .object({
                          CancelReason: zod
                            .union([zod.string(), zod.null()])
                            .optional(),
                        })
                        .describe(
                          "Cancellation metadata for a cancelled PA case (`PACancelDetails`).",
                        ),
                      zod.null(),
                    ])
                    .optional(),
                  Attachments: zod
                    .union([
                      zod.array(
                        zod
                          .object({
                            AttachmentId: zod
                              .union([zod.number(), zod.null()])
                              .optional(),
                            CreatedDateStamp: zod
                              .union([zod.iso.datetime({}), zod.null()])
                              .optional(),
                            FileName: zod
                              .union([zod.string(), zod.null()])
                              .optional(),
                            IsOutbound: zod
                              .union([zod.boolean(), zod.null()])
                              .optional(),
                          })
                          .describe(
                            "A single attachment on a PA case (`PAAttachment`).",
                          ),
                      ),
                      zod.null(),
                    ])
                    .optional(),
                })
                .describe(
                  "Full details of a PA case (`PriorAuthorizationCaseFullDetails`).\n\nReturned by `GET \/api\/priorAuths\/{id}` and list items under\n`GET \/api\/patients\/{patientId}\/priorAuths`. The whole payload is also\nstored verbatim on `DosespotPriorAuthRecord.cached_case` so downstream\nprocessing has access to every field (including `FinalStatus.Quantity` \/\n`DaysSupply` \/ `NumberOfCycles` \/ `NumberOfRefills`).",
                ),
              lastRefreshedAt: zod.union([zod.string(), zod.null()]).optional(),
              history: zod
                .union([
                  zod
                    .object({
                      FinalStatus: zod
                        .union([zod.string(), zod.null()])
                        .optional(),
                      AuthorizationNumber: zod
                        .union([zod.string(), zod.null()])
                        .optional(),
                      EffectiveDate: zod
                        .union([zod.iso.datetime({}), zod.null()])
                        .optional(),
                      ExpirationDate: zod
                        .union([zod.iso.datetime({}), zod.null()])
                        .optional(),
                      Note: zod.union([zod.string(), zod.null()]).optional(),
                      CanAppeal: zod
                        .union([zod.string(), zod.null()])
                        .optional(),
                      IsOffline: zod
                        .union([zod.boolean(), zod.null()])
                        .optional(),
                      Attachments: zod
                        .union([
                          zod.array(
                            zod
                              .object({
                                AttachmentId: zod
                                  .union([zod.number(), zod.null()])
                                  .optional(),
                                CreatedDateStamp: zod
                                  .union([zod.iso.datetime({}), zod.null()])
                                  .optional(),
                                FileName: zod
                                  .union([zod.string(), zod.null()])
                                  .optional(),
                                IsOutbound: zod
                                  .union([zod.boolean(), zod.null()])
                                  .optional(),
                              })
                              .describe(
                                "A single attachment on a PA case (`PAAttachment`).",
                              ),
                          ),
                          zod.null(),
                        ])
                        .optional(),
                      StatusLogs: zod
                        .union([
                          zod.array(
                            zod
                              .object({
                                Status: zod
                                  .union([zod.string(), zod.null()])
                                  .optional(),
                                AdditionalInfo: zod
                                  .union([zod.string(), zod.null()])
                                  .optional(),
                                AdditionalInfoAttachmentId: zod
                                  .union([zod.number(), zod.null()])
                                  .optional(),
                                CreatedDateStamp: zod
                                  .union([zod.iso.datetime({}), zod.null()])
                                  .optional(),
                                Attachment: zod
                                  .union([
                                    zod
                                      .object({
                                        AttachmentId: zod
                                          .union([zod.number(), zod.null()])
                                          .optional(),
                                        CreatedDateStamp: zod
                                          .union([
                                            zod.iso.datetime({}),
                                            zod.null(),
                                          ])
                                          .optional(),
                                        FileName: zod
                                          .union([zod.string(), zod.null()])
                                          .optional(),
                                        IsOutbound: zod
                                          .union([zod.boolean(), zod.null()])
                                          .optional(),
                                      })
                                      .describe(
                                        "A single attachment on a PA case (`PAAttachment`).",
                                      ),
                                    zod.null(),
                                  ])
                                  .optional(),
                              })
                              .describe(
                                "A single row in a PA status log.\n\nUnified shape covering both `PAStatusLog` (embedded in the history\nresponse — carries `AdditionalInfoAttachmentId`) and `PriorAuthStatusLogUI`\n(the `\/statusLog` endpoint — carries a fully-expanded `Attachment`). Only\none of the attachment fields is populated per row depending on the source.",
                              ),
                          ),
                          zod.null(),
                        ])
                        .optional(),
                      QuestionSets: zod
                        .union([
                          zod.array(
                            zod
                              .object({
                                PriorAuthorizationQuestionSetId: zod
                                  .union([zod.number(), zod.null()])
                                  .optional(),
                                QuestionSetAlias: zod
                                  .union([zod.string(), zod.null()])
                                  .optional(),
                                Title: zod
                                  .union([zod.string(), zod.null()])
                                  .optional(),
                                AnsweredQuestions: zod
                                  .union([
                                    zod.array(
                                      zod
                                        .object({
                                          Question: zod
                                            .union([zod.string(), zod.null()])
                                            .optional(),
                                          Answers: zod
                                            .union([
                                              zod.array(
                                                zod
                                                  .object({
                                                    Answer: zod
                                                      .union([
                                                        zod.string(),
                                                        zod.null(),
                                                      ])
                                                      .optional(),
                                                    AnswerDateTime: zod
                                                      .union([
                                                        zod.iso.datetime({}),
                                                        zod.null(),
                                                      ])
                                                      .optional(),
                                                    AnswerNumeric: zod
                                                      .union([
                                                        zod.number(),
                                                        zod.null(),
                                                      ])
                                                      .optional(),
                                                    AnswerFreeText: zod
                                                      .union([
                                                        zod.string(),
                                                        zod.null(),
                                                      ])
                                                      .optional(),
                                                  })
                                                  .describe(
                                                    "One captured answer in a PA question history (`PAAnswers`).\n\nOnly one of `AnswerDateTime` \/ `AnswerNumeric` \/ `AnswerFreeText` \/\n`Answer` is populated per row, determined by the question's\n`PriorAuthorizationAnswerTypeT`.",
                                                  ),
                                              ),
                                              zod.null(),
                                            ])
                                            .optional(),
                                        })
                                        .describe(
                                          "A question together with its answers (`PAAnsweredQuestions`).",
                                        ),
                                    ),
                                    zod.null(),
                                  ])
                                  .optional(),
                                Attachments: zod
                                  .union([
                                    zod.array(
                                      zod
                                        .object({
                                          AttachmentId: zod
                                            .union([zod.number(), zod.null()])
                                            .optional(),
                                          CreatedDateStamp: zod
                                            .union([
                                              zod.iso.datetime({}),
                                              zod.null(),
                                            ])
                                            .optional(),
                                          FileName: zod
                                            .union([zod.string(), zod.null()])
                                            .optional(),
                                          IsOutbound: zod
                                            .union([zod.boolean(), zod.null()])
                                            .optional(),
                                        })
                                        .describe(
                                          "A single attachment on a PA case (`PAAttachment`).",
                                        ),
                                    ),
                                    zod.null(),
                                  ])
                                  .optional(),
                              })
                              .describe(
                                "One question-set block inside a PA history (`PAHistoryQuestionSet`).",
                              ),
                          ),
                          zod.null(),
                        ])
                        .optional(),
                      Result: zod
                        .union([
                          zod
                            .object({
                              ResultCode: zod.string(),
                              ResultDescription: zod
                                .union([zod.string(), zod.null()])
                                .optional(),
                            })
                            .describe("Standard DoseSpot API result object."),
                          zod.null(),
                        ])
                        .optional(),
                    })
                    .describe(
                      "Full PA history payload (`PriorAuthorizationHistoryResponse`).\n\nStored verbatim on `DosespotPriorAuthRecord.cached_history` so the\nquestion\/answer trail and status log remain available for audit and\ncopilot context.",
                    ),
                  zod.null(),
                ])
                .optional(),
              statusLog: zod
                .union([
                  zod
                    .object({
                      StatusLog: zod
                        .union([
                          zod.array(
                            zod
                              .object({
                                Status: zod
                                  .union([zod.string(), zod.null()])
                                  .optional(),
                                AdditionalInfo: zod
                                  .union([zod.string(), zod.null()])
                                  .optional(),
                                AdditionalInfoAttachmentId: zod
                                  .union([zod.number(), zod.null()])
                                  .optional(),
                                CreatedDateStamp: zod
                                  .union([zod.iso.datetime({}), zod.null()])
                                  .optional(),
                                Attachment: zod
                                  .union([
                                    zod
                                      .object({
                                        AttachmentId: zod
                                          .union([zod.number(), zod.null()])
                                          .optional(),
                                        CreatedDateStamp: zod
                                          .union([
                                            zod.iso.datetime({}),
                                            zod.null(),
                                          ])
                                          .optional(),
                                        FileName: zod
                                          .union([zod.string(), zod.null()])
                                          .optional(),
                                        IsOutbound: zod
                                          .union([zod.boolean(), zod.null()])
                                          .optional(),
                                      })
                                      .describe(
                                        "A single attachment on a PA case (`PAAttachment`).",
                                      ),
                                    zod.null(),
                                  ])
                                  .optional(),
                              })
                              .describe(
                                "A single row in a PA status log.\n\nUnified shape covering both `PAStatusLog` (embedded in the history\nresponse — carries `AdditionalInfoAttachmentId`) and `PriorAuthStatusLogUI`\n(the `\/statusLog` endpoint — carries a fully-expanded `Attachment`). Only\none of the attachment fields is populated per row depending on the source.",
                              ),
                          ),
                          zod.null(),
                        ])
                        .optional(),
                      Result: zod
                        .union([
                          zod
                            .object({
                              ResultCode: zod.string(),
                              ResultDescription: zod
                                .union([zod.string(), zod.null()])
                                .optional(),
                            })
                            .describe("Standard DoseSpot API result object."),
                          zod.null(),
                        ])
                        .optional(),
                    })
                    .describe(
                      "UI-oriented status log response (`PriorAuthorizationStatusLogUIResponse`).",
                    ),
                  zod.null(),
                ])
                .optional(),
              pendingQuestion: zod
                .union([
                  zod
                    .object({
                      QuestionText: zod
                        .union([zod.string(), zod.null()])
                        .optional(),
                      AnswerType: zod
                        .union([
                          zod
                            .enum([
                              "Select",
                              "Multiselect",
                              "Date",
                              "DateTime",
                              "Numeric",
                              "FreeText",
                            ])
                            .describe(
                              "Kind of answer a PA question expects.\n\nDrives which form widget the clinician UI renders for each question and,\nconsequently, which field(s) of ``PriorAuthorizationAnswerRequestT`` must\nbe populated when submitting the answer.",
                            ),
                          zod.null(),
                        ])
                        .optional(),
                      AnswerChoices: zod
                        .union([
                          zod.array(
                            zod
                              .object({
                                QuestionChoiceId: zod
                                  .union([zod.number(), zod.null()])
                                  .optional(),
                                QuestionChoiceText: zod
                                  .union([zod.string(), zod.null()])
                                  .optional(),
                                AdditionalFreeTextRequired: zod
                                  .union([zod.boolean(), zod.null()])
                                  .optional(),
                                AdditionalFreeTextAllowed: zod
                                  .union([zod.boolean(), zod.null()])
                                  .optional(),
                              })
                              .describe(
                                "One selectable choice on a PA question (`PriorAuthorizationQuestionResponseChoice`).",
                              ),
                          ),
                          zod.null(),
                        ])
                        .optional(),
                      Result: zod
                        .union([
                          zod
                            .object({
                              ResultCode: zod.string(),
                              ResultDescription: zod
                                .union([zod.string(), zod.null()])
                                .optional(),
                            })
                            .describe("Standard DoseSpot API result object."),
                          zod.null(),
                        ])
                        .optional(),
                    })
                    .describe(
                      "Single PA question detail (`PriorAuthQuestionResponse`).",
                    ),
                  zod.null(),
                ])
                .optional(),
              pendingQuestionId: zod
                .union([zod.string(), zod.null()])
                .optional(),
              answeredQuestions: zod
                .array(
                  zod
                    .object({
                      questionId: zod.string(),
                      questionText: zod
                        .union([zod.string(), zod.null()])
                        .optional(),
                      question: zod
                        .union([
                          zod
                            .object({
                              QuestionText: zod
                                .union([zod.string(), zod.null()])
                                .optional(),
                              AnswerType: zod
                                .union([
                                  zod
                                    .enum([
                                      "Select",
                                      "Multiselect",
                                      "Date",
                                      "DateTime",
                                      "Numeric",
                                      "FreeText",
                                    ])
                                    .describe(
                                      "Kind of answer a PA question expects.\n\nDrives which form widget the clinician UI renders for each question and,\nconsequently, which field(s) of ``PriorAuthorizationAnswerRequestT`` must\nbe populated when submitting the answer.",
                                    ),
                                  zod.null(),
                                ])
                                .optional(),
                              AnswerChoices: zod
                                .union([
                                  zod.array(
                                    zod
                                      .object({
                                        QuestionChoiceId: zod
                                          .union([zod.number(), zod.null()])
                                          .optional(),
                                        QuestionChoiceText: zod
                                          .union([zod.string(), zod.null()])
                                          .optional(),
                                        AdditionalFreeTextRequired: zod
                                          .union([zod.boolean(), zod.null()])
                                          .optional(),
                                        AdditionalFreeTextAllowed: zod
                                          .union([zod.boolean(), zod.null()])
                                          .optional(),
                                      })
                                      .describe(
                                        "One selectable choice on a PA question (`PriorAuthorizationQuestionResponseChoice`).",
                                      ),
                                  ),
                                  zod.null(),
                                ])
                                .optional(),
                              Result: zod
                                .union([
                                  zod
                                    .object({
                                      ResultCode: zod.string(),
                                      ResultDescription: zod
                                        .union([zod.string(), zod.null()])
                                        .optional(),
                                    })
                                    .describe(
                                      "Standard DoseSpot API result object.",
                                    ),
                                  zod.null(),
                                ])
                                .optional(),
                            })
                            .describe(
                              "Single PA question detail (`PriorAuthQuestionResponse`).",
                            ),
                          zod.null(),
                        ])
                        .optional(),
                      answers: zod
                        .array(
                          zod
                            .object({
                              Answer: zod
                                .union([zod.string(), zod.null()])
                                .optional(),
                              AnswerDateTime: zod
                                .union([zod.iso.datetime({}), zod.null()])
                                .optional(),
                              AnswerNumeric: zod
                                .union([zod.number(), zod.null()])
                                .optional(),
                              AnswerFreeText: zod
                                .union([zod.string(), zod.null()])
                                .optional(),
                            })
                            .describe(
                              "One captured answer in a PA question history (`PAAnswers`).\n\nOnly one of `AnswerDateTime` \/ `AnswerNumeric` \/ `AnswerFreeText` \/\n`Answer` is populated per row, determined by the question's\n`PriorAuthorizationAnswerTypeT`.",
                            ),
                        )
                        .default(
                          priorAuthActionResponseCurrentCaseDosespotCaseAnsweredQuestionsItemAnswersDefault,
                        ),
                    })
                    .describe(
                      "A previously-answered PA question, resolved back to its DoseSpot id.\n\nDoseSpot's history payload lists answered questions by \*text\* only, so we\npair each recorded observed question (captured when the clinician answered\nit) with the question detail. Carrying the full ``question`` (answer type +\nchoices) lets the copilot re-render the exact same answer form so the\nclinician can revise their reply and POST a new answer to ``question_id`` —\nDoseSpot accepts a fresh answer to an already-answered question until the\ncase is submitted.",
                    ),
                )
                .default(
                  priorAuthActionResponseCurrentCaseDosespotCaseAnsweredQuestionsDefault,
                ),
            })
            .describe(
              "DoseSpot facts available after Lotus confirms the external case.\n\nWraps the three DoseSpot read-only payloads (case details, history,\nstatus log) alongside the payer's currently-pending question when there\nis one. The frontend renders the question form from\n``pending_question`` when ``case.NextQuestionId`` is populated and\nstatus is ``ACTION_REQUIRED``.\n\n``answered_questions`` carries the already-answered questions resolved\nback to their DoseSpot ids so the clinician can re-open one and revise\nthe answer before submitting.",
            ),
          zod.null(),
        ])
        .optional(),
    })
    .describe(
      "Current Lotus workflow state for one durable PA case.\n\nThis local view exists from the first initiation attempt through the final\noutcome. ``dosespot_case`` is populated only after Lotus has confirmed and\nread the external case, keeping DoseSpot-owned facts separate from the\nLotus-owned workflow state and allowed actions.",
    ),
  rejectionCode: zod
    .union([
      zod.enum([
        "ACTION_NOT_ALLOWED",
        "DOSESPOT_CASE_NOT_CONFIRMED",
        "DOSESPOT_REJECTED",
        "OPERATION_IN_PROGRESS",
        "PRESCRIBER_REQUIRED",
        "DECISION_NOT_ALLOWED",
        "ELIGIBILITY_REQUIRED",
        "PRESCRIPTION_READ_FAILED",
      ]),
      zod.null(),
    ])
    .optional(),
  rejectionDetail: zod.union([zod.string(), zod.null()]).optional(),
});

/**
 * @summary Prescription Decision
 */

export const prescriptionDecisionBodyPatientAgreedDefault = false;
export const prescriptionDecisionBodyExpeditedDefault = false;

export const prescriptionDecisionBody = zod.object({
  prescriptionRecordId: zod.uuid(),
  decision: zod.enum([
    "SEND_NO_PA",
    "START_PA",
    "SELF_PAY",
    "EXCEPTIONAL_UNKNOWN_SEND",
    "END_PLAN",
  ]),
  reason: zod.union([zod.string().min(1), zod.null()]).optional(),
  patientAgreed: zod.boolean().optional(),
  patientEligibilityId: zod.union([zod.number(), zod.null()]).optional(),
  expedited: zod.boolean().optional(),
});

export const prescriptionDecisionResponseCurrentCaseDosespotCaseAnsweredQuestionsItemAnswersDefault =
  [];
export const prescriptionDecisionResponseCurrentCaseDosespotCaseAnsweredQuestionsDefault =
  [];

export const prescriptionDecisionResponse = zod.object({
  outcome: zod.enum([
    "APPLIED",
    "REJECTED",
    "CONFIRMATION_PENDING",
    "APPLIED_LOCAL_SYNC_PENDING",
  ]),
  prescriptionRecordId: zod.uuid(),
  currentCase: zod
    .union([
      zod
        .object({
          caseId: zod.string(),
          prescriptionRecordId: zod.string(),
          initiationState: zod.enum([
            "STARTING",
            "CONFIRMED",
            "RESULT_UNCLEAR",
            "FAILED",
          ]),
          workflowState: zod
            .enum([
              "INITIATING",
              "CONFIRMING_INITIATION",
              "INITIATION_FAILED",
              "QUESTION_REQUIRED",
              "ATTACHMENT_REQUIRED",
              "READY_TO_SUBMIT",
              "SUBMISSION_FAILED",
              "PAYER_REVIEW",
              "APPEAL_REVIEW",
              "CANCELLATION_REVIEW",
              "APPROVED_READY_TO_SEND",
              "NOT_REQUIRED_READY_TO_SEND",
              "PARTIAL_APPROVAL_DECISION",
              "DENIAL_DECISION",
              "PA_FAILED",
              "SENT",
              "CANCELED",
              "SUPERSEDED",
              "ENDED",
            ])
            .describe("What is happening in the PA workflow right now."),
          currentOwner: zod
            .enum(["LOTUS_AUTOMATION", "PAYER", "CLINICIAN", "NONE"])
            .describe("The person or system expected to take the next action."),
          prescriber: zod.string(),
          isCurrentClinicianPrescriber: zod.boolean(),
          allowedActions: zod.array(
            zod
              .enum([
                "ANSWER_QUESTION",
                "UPLOAD_ATTACHMENT",
                "CANCEL",
                "SUBMIT",
                "SEND_PRESCRIPTION",
                "APPEAL",
                "END_PLAN",
                "SELF_PAY",
              ])
              .describe(
                "An action the clinician may take in the current workflow state.",
              ),
          ),
          initiationFailureReason: zod
            .union([zod.string(), zod.null()])
            .optional(),
          dosespotCase: zod
            .union([
              zod
                .object({
                  caseNumber: zod.string(),
                  case: zod
                    .object({
                      PriorAuthorizationCaseId: zod
                        .union([zod.number(), zod.null()])
                        .optional(),
                      PrescriptionId: zod
                        .union([zod.number(), zod.null()])
                        .optional(),
                      CaseAlias: zod
                        .union([zod.string(), zod.null()])
                        .optional(),
                      Note: zod.union([zod.string(), zod.null()]).optional(),
                      IsOffline: zod
                        .union([zod.boolean(), zod.null()])
                        .optional(),
                      InitializedDate: zod
                        .union([zod.iso.datetime({}), zod.null()])
                        .optional(),
                      NextResponseDeadline: zod
                        .union([zod.iso.datetime({}), zod.null()])
                        .optional(),
                      CurrentStatus: zod
                        .union([
                          zod
                            .enum([
                              "Unknown",
                              "Requested",
                              "NotRequired",
                              "Closed",
                              "Deferred",
                              "ActionRequired",
                              "Pending",
                              "Approved",
                              "Denied",
                              "AppealRequested",
                              "CancelRequested",
                              "Canceled",
                              "CancelDenied",
                              "Error",
                              "Deleted",
                              "PartiallyDenied",
                              "InProcess",
                            ])
                            .describe(
                              "Raw `PriorAuthorizationStatusType` values returned by DoseSpot.\n\nAll 17 values from the v2 `PriorAuthorizationStatusType` enum. We collapse\nthese (plus `ClosedReasonCodeId` on `Closed`) into a smaller internal\n`CareStatePriorAuthStatusT` in the poller; the raw string is still stored\non `DosespotPriorAuthRecord.current_status` for observability.",
                            ),
                          zod.null(),
                        ])
                        .optional(),
                      CurrentStatusDate: zod
                        .union([zod.iso.datetime({}), zod.null()])
                        .optional(),
                      ExpectedResponseDate: zod
                        .union([zod.iso.datetime({}), zod.null()])
                        .optional(),
                      AttachmentRequired: zod
                        .union([zod.boolean(), zod.null()])
                        .optional(),
                      NextQuestionId: zod
                        .union([zod.number(), zod.null()])
                        .optional(),
                      IsExpedited: zod
                        .union([zod.boolean(), zod.null()])
                        .optional(),
                      FinalStatus: zod
                        .union([
                          zod
                            .object({
                              PriorAuthorizationStatusType: zod
                                .union([
                                  zod
                                    .enum([
                                      "Unknown",
                                      "Requested",
                                      "NotRequired",
                                      "Closed",
                                      "Deferred",
                                      "ActionRequired",
                                      "Pending",
                                      "Approved",
                                      "Denied",
                                      "AppealRequested",
                                      "CancelRequested",
                                      "Canceled",
                                      "CancelDenied",
                                      "Error",
                                      "Deleted",
                                      "PartiallyDenied",
                                      "InProcess",
                                    ])
                                    .describe(
                                      "Raw `PriorAuthorizationStatusType` values returned by DoseSpot.\n\nAll 17 values from the v2 `PriorAuthorizationStatusType` enum. We collapse\nthese (plus `ClosedReasonCodeId` on `Closed`) into a smaller internal\n`CareStatePriorAuthStatusT` in the poller; the raw string is still stored\non `DosespotPriorAuthRecord.current_status` for observability.",
                                    ),
                                  zod.null(),
                                ])
                                .optional(),
                              ClosedReasonCodeId: zod
                                .union([
                                  zod
                                    .enum([
                                      "Unknown",
                                      "ElectronicPriorAuthNotSupported",
                                      "Other",
                                      "PriorAuthNotRequired",
                                      "CannotFindMatchingPatient",
                                      "PatientNotEligible",
                                      "PriorAuthDuplicateApproved",
                                      "PriorAuthDuplicateInProcess",
                                      "ClosedByPayer",
                                      "ClosedByProvider",
                                      "ClosedByMember",
                                      "AttachmentTypeNotSupported",
                                      "PrescriberNotAllowedToSubmitPARequest",
                                      "ResponseInconsistentWithQuestion",
                                      "ReceiverNotPAProcessorForThisPatient",
                                      "ReceiverNotPAProcessorForPatientMedicationCombo",
                                      "DuplicateDenied",
                                      "ProviderRespondedAfterDeadlineToReply",
                                      "ProductNotCoveredByThisPlanPriorAuthorizationNotAvailable",
                                      "PrescriptionWithinPrescribingLimitsPriorAuthorizationNotRequiredForPatientMedication",
                                      "CoverageLimitsMayExistForQuantityAndOrDaysSupply",
                                      "CoverageLimitsHaveBeenExceededExceptionNotAvailable",
                                      "ActivePAOnFile",
                                      "SubmittedProductCodeIsNotValid",
                                    ])
                                    .describe(
                                      "Raw `ClosedReasonCodeId` values on a `Closed` PA case.\n\nAll 25 values from the v2 `ClosedReasonCodeId` enum. Combined with the\n`Closed` super-status these disambiguate terminal outcomes (see\n`PRIOR_AUTH.md` for the mapping to our normalized status).",
                                    ),
                                  zod.null(),
                                ])
                                .optional(),
                              AuthorizationNumber: zod
                                .union([zod.string(), zod.null()])
                                .optional(),
                              AuthorizationPeriodStart: zod
                                .union([zod.iso.datetime({}), zod.null()])
                                .optional(),
                              AuthorizationPeriodEnd: zod
                                .union([zod.iso.datetime({}), zod.null()])
                                .optional(),
                              PharmacyType: zod
                                .union([
                                  zod
                                    .enum([
                                      "Unknown",
                                      "Retail",
                                      "MailOrder",
                                      "SpecialtyPharmacy",
                                      "LongTermCarePharmacy",
                                      "Any",
                                      "TwentyFourHourPharmacy",
                                      "FaxPharmacy",
                                      "EPCS",
                                      "InHouseDispensing",
                                      "Compounding",
                                      "DME",
                                      "Kiosk",
                                      "SupportsDigitalSignature",
                                      "FaxPharmacyExternal",
                                    ])
                                    .describe(
                                      "Raw `PharmacyType` values returned on `PAFinalStatus`.\n\nAll 15 values from the v2 `PharmacyType` enum. Carried through to\n`DosespotPriorAuthRecord.pharmacy_type` so downstream Rx routing can be\nconstrained to match the approved channel.",
                                    ),
                                  zod.null(),
                                ])
                                .optional(),
                              Quantity: zod
                                .union([zod.string(), zod.null()])
                                .optional(),
                              DaysSupply: zod
                                .union([zod.string(), zod.null()])
                                .optional(),
                              NumberOfCycles: zod
                                .union([zod.string(), zod.null()])
                                .optional(),
                              NumberOfRefills: zod
                                .union([zod.string(), zod.null()])
                                .optional(),
                              Note: zod
                                .union([zod.string(), zod.null()])
                                .optional(),
                              CanAppeal: zod
                                .union([zod.boolean(), zod.null()])
                                .optional(),
                            })
                            .describe(
                              "Terminal-state details on a closed PA case (`PAFinalStatus`).\n\n`PriorAuthorizationStatusType` holds the underlying DoseSpot status; for\ntruly closed cases `ClosedReasonCodeId` disambiguates approval vs. denial\nvs. not-required. `Quantity`, `DaysSupply`, `NumberOfCycles`, and\n`NumberOfRefills` are the payer's narrowed scope — all strings per the\nswagger — and drive downstream prescription-constraint enforcement.",
                            ),
                          zod.null(),
                        ])
                        .optional(),
                      AppealDetails: zod
                        .union([
                          zod
                            .object({
                              AppealCaseId: zod
                                .union([zod.string(), zod.null()])
                                .optional(),
                              NotesForAppeal: zod
                                .union([zod.string(), zod.null()])
                                .optional(),
                              AppealReason: zod
                                .union([zod.string(), zod.null()])
                                .optional(),
                            })
                            .describe(
                              "Appeal metadata for an appealed PA case (`PAAppealDetails`).",
                            ),
                          zod.null(),
                        ])
                        .optional(),
                      CancelDetails: zod
                        .union([
                          zod
                            .object({
                              CancelReason: zod
                                .union([zod.string(), zod.null()])
                                .optional(),
                            })
                            .describe(
                              "Cancellation metadata for a cancelled PA case (`PACancelDetails`).",
                            ),
                          zod.null(),
                        ])
                        .optional(),
                      Attachments: zod
                        .union([
                          zod.array(
                            zod
                              .object({
                                AttachmentId: zod
                                  .union([zod.number(), zod.null()])
                                  .optional(),
                                CreatedDateStamp: zod
                                  .union([zod.iso.datetime({}), zod.null()])
                                  .optional(),
                                FileName: zod
                                  .union([zod.string(), zod.null()])
                                  .optional(),
                                IsOutbound: zod
                                  .union([zod.boolean(), zod.null()])
                                  .optional(),
                              })
                              .describe(
                                "A single attachment on a PA case (`PAAttachment`).",
                              ),
                          ),
                          zod.null(),
                        ])
                        .optional(),
                    })
                    .describe(
                      "Full details of a PA case (`PriorAuthorizationCaseFullDetails`).\n\nReturned by `GET \/api\/priorAuths\/{id}` and list items under\n`GET \/api\/patients\/{patientId}\/priorAuths`. The whole payload is also\nstored verbatim on `DosespotPriorAuthRecord.cached_case` so downstream\nprocessing has access to every field (including `FinalStatus.Quantity` \/\n`DaysSupply` \/ `NumberOfCycles` \/ `NumberOfRefills`).",
                    ),
                  lastRefreshedAt: zod
                    .union([zod.string(), zod.null()])
                    .optional(),
                  history: zod
                    .union([
                      zod
                        .object({
                          FinalStatus: zod
                            .union([zod.string(), zod.null()])
                            .optional(),
                          AuthorizationNumber: zod
                            .union([zod.string(), zod.null()])
                            .optional(),
                          EffectiveDate: zod
                            .union([zod.iso.datetime({}), zod.null()])
                            .optional(),
                          ExpirationDate: zod
                            .union([zod.iso.datetime({}), zod.null()])
                            .optional(),
                          Note: zod
                            .union([zod.string(), zod.null()])
                            .optional(),
                          CanAppeal: zod
                            .union([zod.string(), zod.null()])
                            .optional(),
                          IsOffline: zod
                            .union([zod.boolean(), zod.null()])
                            .optional(),
                          Attachments: zod
                            .union([
                              zod.array(
                                zod
                                  .object({
                                    AttachmentId: zod
                                      .union([zod.number(), zod.null()])
                                      .optional(),
                                    CreatedDateStamp: zod
                                      .union([zod.iso.datetime({}), zod.null()])
                                      .optional(),
                                    FileName: zod
                                      .union([zod.string(), zod.null()])
                                      .optional(),
                                    IsOutbound: zod
                                      .union([zod.boolean(), zod.null()])
                                      .optional(),
                                  })
                                  .describe(
                                    "A single attachment on a PA case (`PAAttachment`).",
                                  ),
                              ),
                              zod.null(),
                            ])
                            .optional(),
                          StatusLogs: zod
                            .union([
                              zod.array(
                                zod
                                  .object({
                                    Status: zod
                                      .union([zod.string(), zod.null()])
                                      .optional(),
                                    AdditionalInfo: zod
                                      .union([zod.string(), zod.null()])
                                      .optional(),
                                    AdditionalInfoAttachmentId: zod
                                      .union([zod.number(), zod.null()])
                                      .optional(),
                                    CreatedDateStamp: zod
                                      .union([zod.iso.datetime({}), zod.null()])
                                      .optional(),
                                    Attachment: zod
                                      .union([
                                        zod
                                          .object({
                                            AttachmentId: zod
                                              .union([zod.number(), zod.null()])
                                              .optional(),
                                            CreatedDateStamp: zod
                                              .union([
                                                zod.iso.datetime({}),
                                                zod.null(),
                                              ])
                                              .optional(),
                                            FileName: zod
                                              .union([zod.string(), zod.null()])
                                              .optional(),
                                            IsOutbound: zod
                                              .union([
                                                zod.boolean(),
                                                zod.null(),
                                              ])
                                              .optional(),
                                          })
                                          .describe(
                                            "A single attachment on a PA case (`PAAttachment`).",
                                          ),
                                        zod.null(),
                                      ])
                                      .optional(),
                                  })
                                  .describe(
                                    "A single row in a PA status log.\n\nUnified shape covering both `PAStatusLog` (embedded in the history\nresponse — carries `AdditionalInfoAttachmentId`) and `PriorAuthStatusLogUI`\n(the `\/statusLog` endpoint — carries a fully-expanded `Attachment`). Only\none of the attachment fields is populated per row depending on the source.",
                                  ),
                              ),
                              zod.null(),
                            ])
                            .optional(),
                          QuestionSets: zod
                            .union([
                              zod.array(
                                zod
                                  .object({
                                    PriorAuthorizationQuestionSetId: zod
                                      .union([zod.number(), zod.null()])
                                      .optional(),
                                    QuestionSetAlias: zod
                                      .union([zod.string(), zod.null()])
                                      .optional(),
                                    Title: zod
                                      .union([zod.string(), zod.null()])
                                      .optional(),
                                    AnsweredQuestions: zod
                                      .union([
                                        zod.array(
                                          zod
                                            .object({
                                              Question: zod
                                                .union([
                                                  zod.string(),
                                                  zod.null(),
                                                ])
                                                .optional(),
                                              Answers: zod
                                                .union([
                                                  zod.array(
                                                    zod
                                                      .object({
                                                        Answer: zod
                                                          .union([
                                                            zod.string(),
                                                            zod.null(),
                                                          ])
                                                          .optional(),
                                                        AnswerDateTime: zod
                                                          .union([
                                                            zod.iso.datetime(
                                                              {},
                                                            ),
                                                            zod.null(),
                                                          ])
                                                          .optional(),
                                                        AnswerNumeric: zod
                                                          .union([
                                                            zod.number(),
                                                            zod.null(),
                                                          ])
                                                          .optional(),
                                                        AnswerFreeText: zod
                                                          .union([
                                                            zod.string(),
                                                            zod.null(),
                                                          ])
                                                          .optional(),
                                                      })
                                                      .describe(
                                                        "One captured answer in a PA question history (`PAAnswers`).\n\nOnly one of `AnswerDateTime` \/ `AnswerNumeric` \/ `AnswerFreeText` \/\n`Answer` is populated per row, determined by the question's\n`PriorAuthorizationAnswerTypeT`.",
                                                      ),
                                                  ),
                                                  zod.null(),
                                                ])
                                                .optional(),
                                            })
                                            .describe(
                                              "A question together with its answers (`PAAnsweredQuestions`).",
                                            ),
                                        ),
                                        zod.null(),
                                      ])
                                      .optional(),
                                    Attachments: zod
                                      .union([
                                        zod.array(
                                          zod
                                            .object({
                                              AttachmentId: zod
                                                .union([
                                                  zod.number(),
                                                  zod.null(),
                                                ])
                                                .optional(),
                                              CreatedDateStamp: zod
                                                .union([
                                                  zod.iso.datetime({}),
                                                  zod.null(),
                                                ])
                                                .optional(),
                                              FileName: zod
                                                .union([
                                                  zod.string(),
                                                  zod.null(),
                                                ])
                                                .optional(),
                                              IsOutbound: zod
                                                .union([
                                                  zod.boolean(),
                                                  zod.null(),
                                                ])
                                                .optional(),
                                            })
                                            .describe(
                                              "A single attachment on a PA case (`PAAttachment`).",
                                            ),
                                        ),
                                        zod.null(),
                                      ])
                                      .optional(),
                                  })
                                  .describe(
                                    "One question-set block inside a PA history (`PAHistoryQuestionSet`).",
                                  ),
                              ),
                              zod.null(),
                            ])
                            .optional(),
                          Result: zod
                            .union([
                              zod
                                .object({
                                  ResultCode: zod.string(),
                                  ResultDescription: zod
                                    .union([zod.string(), zod.null()])
                                    .optional(),
                                })
                                .describe(
                                  "Standard DoseSpot API result object.",
                                ),
                              zod.null(),
                            ])
                            .optional(),
                        })
                        .describe(
                          "Full PA history payload (`PriorAuthorizationHistoryResponse`).\n\nStored verbatim on `DosespotPriorAuthRecord.cached_history` so the\nquestion\/answer trail and status log remain available for audit and\ncopilot context.",
                        ),
                      zod.null(),
                    ])
                    .optional(),
                  statusLog: zod
                    .union([
                      zod
                        .object({
                          StatusLog: zod
                            .union([
                              zod.array(
                                zod
                                  .object({
                                    Status: zod
                                      .union([zod.string(), zod.null()])
                                      .optional(),
                                    AdditionalInfo: zod
                                      .union([zod.string(), zod.null()])
                                      .optional(),
                                    AdditionalInfoAttachmentId: zod
                                      .union([zod.number(), zod.null()])
                                      .optional(),
                                    CreatedDateStamp: zod
                                      .union([zod.iso.datetime({}), zod.null()])
                                      .optional(),
                                    Attachment: zod
                                      .union([
                                        zod
                                          .object({
                                            AttachmentId: zod
                                              .union([zod.number(), zod.null()])
                                              .optional(),
                                            CreatedDateStamp: zod
                                              .union([
                                                zod.iso.datetime({}),
                                                zod.null(),
                                              ])
                                              .optional(),
                                            FileName: zod
                                              .union([zod.string(), zod.null()])
                                              .optional(),
                                            IsOutbound: zod
                                              .union([
                                                zod.boolean(),
                                                zod.null(),
                                              ])
                                              .optional(),
                                          })
                                          .describe(
                                            "A single attachment on a PA case (`PAAttachment`).",
                                          ),
                                        zod.null(),
                                      ])
                                      .optional(),
                                  })
                                  .describe(
                                    "A single row in a PA status log.\n\nUnified shape covering both `PAStatusLog` (embedded in the history\nresponse — carries `AdditionalInfoAttachmentId`) and `PriorAuthStatusLogUI`\n(the `\/statusLog` endpoint — carries a fully-expanded `Attachment`). Only\none of the attachment fields is populated per row depending on the source.",
                                  ),
                              ),
                              zod.null(),
                            ])
                            .optional(),
                          Result: zod
                            .union([
                              zod
                                .object({
                                  ResultCode: zod.string(),
                                  ResultDescription: zod
                                    .union([zod.string(), zod.null()])
                                    .optional(),
                                })
                                .describe(
                                  "Standard DoseSpot API result object.",
                                ),
                              zod.null(),
                            ])
                            .optional(),
                        })
                        .describe(
                          "UI-oriented status log response (`PriorAuthorizationStatusLogUIResponse`).",
                        ),
                      zod.null(),
                    ])
                    .optional(),
                  pendingQuestion: zod
                    .union([
                      zod
                        .object({
                          QuestionText: zod
                            .union([zod.string(), zod.null()])
                            .optional(),
                          AnswerType: zod
                            .union([
                              zod
                                .enum([
                                  "Select",
                                  "Multiselect",
                                  "Date",
                                  "DateTime",
                                  "Numeric",
                                  "FreeText",
                                ])
                                .describe(
                                  "Kind of answer a PA question expects.\n\nDrives which form widget the clinician UI renders for each question and,\nconsequently, which field(s) of ``PriorAuthorizationAnswerRequestT`` must\nbe populated when submitting the answer.",
                                ),
                              zod.null(),
                            ])
                            .optional(),
                          AnswerChoices: zod
                            .union([
                              zod.array(
                                zod
                                  .object({
                                    QuestionChoiceId: zod
                                      .union([zod.number(), zod.null()])
                                      .optional(),
                                    QuestionChoiceText: zod
                                      .union([zod.string(), zod.null()])
                                      .optional(),
                                    AdditionalFreeTextRequired: zod
                                      .union([zod.boolean(), zod.null()])
                                      .optional(),
                                    AdditionalFreeTextAllowed: zod
                                      .union([zod.boolean(), zod.null()])
                                      .optional(),
                                  })
                                  .describe(
                                    "One selectable choice on a PA question (`PriorAuthorizationQuestionResponseChoice`).",
                                  ),
                              ),
                              zod.null(),
                            ])
                            .optional(),
                          Result: zod
                            .union([
                              zod
                                .object({
                                  ResultCode: zod.string(),
                                  ResultDescription: zod
                                    .union([zod.string(), zod.null()])
                                    .optional(),
                                })
                                .describe(
                                  "Standard DoseSpot API result object.",
                                ),
                              zod.null(),
                            ])
                            .optional(),
                        })
                        .describe(
                          "Single PA question detail (`PriorAuthQuestionResponse`).",
                        ),
                      zod.null(),
                    ])
                    .optional(),
                  pendingQuestionId: zod
                    .union([zod.string(), zod.null()])
                    .optional(),
                  answeredQuestions: zod
                    .array(
                      zod
                        .object({
                          questionId: zod.string(),
                          questionText: zod
                            .union([zod.string(), zod.null()])
                            .optional(),
                          question: zod
                            .union([
                              zod
                                .object({
                                  QuestionText: zod
                                    .union([zod.string(), zod.null()])
                                    .optional(),
                                  AnswerType: zod
                                    .union([
                                      zod
                                        .enum([
                                          "Select",
                                          "Multiselect",
                                          "Date",
                                          "DateTime",
                                          "Numeric",
                                          "FreeText",
                                        ])
                                        .describe(
                                          "Kind of answer a PA question expects.\n\nDrives which form widget the clinician UI renders for each question and,\nconsequently, which field(s) of ``PriorAuthorizationAnswerRequestT`` must\nbe populated when submitting the answer.",
                                        ),
                                      zod.null(),
                                    ])
                                    .optional(),
                                  AnswerChoices: zod
                                    .union([
                                      zod.array(
                                        zod
                                          .object({
                                            QuestionChoiceId: zod
                                              .union([zod.number(), zod.null()])
                                              .optional(),
                                            QuestionChoiceText: zod
                                              .union([zod.string(), zod.null()])
                                              .optional(),
                                            AdditionalFreeTextRequired: zod
                                              .union([
                                                zod.boolean(),
                                                zod.null(),
                                              ])
                                              .optional(),
                                            AdditionalFreeTextAllowed: zod
                                              .union([
                                                zod.boolean(),
                                                zod.null(),
                                              ])
                                              .optional(),
                                          })
                                          .describe(
                                            "One selectable choice on a PA question (`PriorAuthorizationQuestionResponseChoice`).",
                                          ),
                                      ),
                                      zod.null(),
                                    ])
                                    .optional(),
                                  Result: zod
                                    .union([
                                      zod
                                        .object({
                                          ResultCode: zod.string(),
                                          ResultDescription: zod
                                            .union([zod.string(), zod.null()])
                                            .optional(),
                                        })
                                        .describe(
                                          "Standard DoseSpot API result object.",
                                        ),
                                      zod.null(),
                                    ])
                                    .optional(),
                                })
                                .describe(
                                  "Single PA question detail (`PriorAuthQuestionResponse`).",
                                ),
                              zod.null(),
                            ])
                            .optional(),
                          answers: zod
                            .array(
                              zod
                                .object({
                                  Answer: zod
                                    .union([zod.string(), zod.null()])
                                    .optional(),
                                  AnswerDateTime: zod
                                    .union([zod.iso.datetime({}), zod.null()])
                                    .optional(),
                                  AnswerNumeric: zod
                                    .union([zod.number(), zod.null()])
                                    .optional(),
                                  AnswerFreeText: zod
                                    .union([zod.string(), zod.null()])
                                    .optional(),
                                })
                                .describe(
                                  "One captured answer in a PA question history (`PAAnswers`).\n\nOnly one of `AnswerDateTime` \/ `AnswerNumeric` \/ `AnswerFreeText` \/\n`Answer` is populated per row, determined by the question's\n`PriorAuthorizationAnswerTypeT`.",
                                ),
                            )
                            .default(
                              prescriptionDecisionResponseCurrentCaseDosespotCaseAnsweredQuestionsItemAnswersDefault,
                            ),
                        })
                        .describe(
                          "A previously-answered PA question, resolved back to its DoseSpot id.\n\nDoseSpot's history payload lists answered questions by \*text\* only, so we\npair each recorded observed question (captured when the clinician answered\nit) with the question detail. Carrying the full ``question`` (answer type +\nchoices) lets the copilot re-render the exact same answer form so the\nclinician can revise their reply and POST a new answer to ``question_id`` —\nDoseSpot accepts a fresh answer to an already-answered question until the\ncase is submitted.",
                        ),
                    )
                    .default(
                      prescriptionDecisionResponseCurrentCaseDosespotCaseAnsweredQuestionsDefault,
                    ),
                })
                .describe(
                  "DoseSpot facts available after Lotus confirms the external case.\n\nWraps the three DoseSpot read-only payloads (case details, history,\nstatus log) alongside the payer's currently-pending question when there\nis one. The frontend renders the question form from\n``pending_question`` when ``case.NextQuestionId`` is populated and\nstatus is ``ACTION_REQUIRED``.\n\n``answered_questions`` carries the already-answered questions resolved\nback to their DoseSpot ids so the clinician can re-open one and revise\nthe answer before submitting.",
                ),
              zod.null(),
            ])
            .optional(),
        })
        .describe(
          "Current Lotus workflow state for one durable PA case.\n\nThis local view exists from the first initiation attempt through the final\noutcome. ``dosespot_case`` is populated only after Lotus has confirmed and\nread the external case, keeping DoseSpot-owned facts separate from the\nLotus-owned workflow state and allowed actions.",
        ),
      zod.null(),
    ])
    .optional(),
  rejectionCode: zod
    .union([
      zod.enum([
        "ACTION_NOT_ALLOWED",
        "DOSESPOT_CASE_NOT_CONFIRMED",
        "DOSESPOT_REJECTED",
        "OPERATION_IN_PROGRESS",
        "PRESCRIBER_REQUIRED",
        "DECISION_NOT_ALLOWED",
        "ELIGIBILITY_REQUIRED",
        "PRESCRIPTION_READ_FAILED",
      ]),
      zod.null(),
    ])
    .optional(),
  rejectionDetail: zod.union([zod.string(), zod.null()]).optional(),
});

/**
 * Stream a PA attachment back to the browser as a file download.

Proxies DoseSpot's binary endpoint through cortex so the browser can
use our normal Firebase auth instead of needing a DoseSpot bearer
token. Returns ``application/octet-stream`` because DoseSpot doesn't
expose a content-type for attachments and we don't trust filenames
enough to guess; the caller already knows the filename from the
case detail and can pick the right MIME on the client side.

404 when the case or attachment is unknown to DoseSpot — surfaced as
a ``ValueError`` from ``download_attachment`` and translated below.
 * @summary Download Prior Auth Attachment
 */
export const downloadPriorAuthAttachmentParams = zod.object({
  record_id: zod.uuid(),
  attachment_id: zod.number(),
});

export const downloadPriorAuthAttachmentResponse = zod.unknown();

/**
 * Force an immediate poll scoped to a patient.

The same poll the scheduled sweep runs, on demand for one patient: it
mirrors their whole DoseSpot state, so cases we have no local row for
(opened in the DoseSpot UI, or an ``/initiate`` whose response we lost)
appear on the Prior Auths tab too, and brings their CareState in line.
 * @summary Sync Prior Auths
 */
export const syncPriorAuthsParams = zod.object({
  patient_user_id: zod.uuid(),
});

export const syncPriorAuthsResponse = zod
  .object({
    processed: zod.number(),
    requestsOpened: zod.number(),
    requestsResolved: zod.number(),
    operationsRecovered: zod.number(),
  })
  .describe(
    "Response from the manual PA sync endpoint.\n\nEvery count is zero: the poll, which now also updates CareState, reports\nwhat it did through the logger rather than a return value. Drop these\nwith the next SDK regeneration.",
  );

/**
 * @summary Fetch Primary Conversation
 */
export const fetchPrimaryConversationResponseConversationIsPrimaryDefault = false;

export const fetchPrimaryConversationResponse = zod.object({
  conversation: zod
    .union([
      zod.object({
        id: zod.uuid(),
        createdAt: zod.iso.datetime({}),
        displayName: zod.string(),
        lastInteractedAt: zod.iso.datetime({}),
        isPrimary: zod.boolean().optional(),
        conversationType: zod
          .enum([
            "onboarding",
            "evaluation",
            "clinician_request",
            "intake",
            "by_sheet",
          ])
          .optional(),
        key: zod.union([zod.string(), zod.null()]).optional(),
      }),
      zod.null(),
    ])
    .optional(),
});

/**
 * @summary Fetch Conversation Messages
 */
export const fetchConversationMessagesParams = zod.object({
  conversation_id: zod.uuid(),
});

export const fetchConversationMessagesQueryParams = zod.object({
  before: zod.union([zod.uuid(), zod.null()]).optional(),
  after: zod.union([zod.uuid(), zod.null()]).optional(),
});

export const fetchConversationMessagesResponseMessagesItemContentBlocksItemBodyTypeDefault =
  "text";
export const fetchConversationMessagesResponseMessagesItemContentBlocksItemBodyTypeDefaultOne =
  "choiceChip";
export const fetchConversationMessagesResponseMessagesItemContentBlocksItemBodyTypeDefaultTwo =
  "error";
export const fetchConversationMessagesResponseMessagesItemContentBlocksItemBodyTypeDefaultThree =
  "chart";
export const fetchConversationMessagesResponseMessagesItemContentBlocksItemBodyTypeDefaultFour =
  "toolUse";
export const fetchConversationMessagesResponseMessagesItemContentBlocksItemBodyTypeDefaultFive =
  "article";
export const fetchConversationMessagesResponseMessagesItemContentBlocksItemBodyTypeDefaultSix =
  "sources_v2";
export const fetchConversationMessagesResponseMessagesItemContentBlocksItemBodySourcesItemContentTypeDefault =
  "table";
export const fetchConversationMessagesResponseMessagesItemContentBlocksItemBodySourcesItemContentColumnSchemaDefault =
  {};
export const fetchConversationMessagesResponseMessagesItemContentBlocksItemBodySourcesItemContentTypeDefaultOne =
  "link";
export const fetchConversationMessagesResponseMessagesItemContentBlocksItemBodyTypeDefaultSeven =
  "pendingReview";
export const fetchConversationMessagesResponseMessagesItemContentBlocksItemBodyTypeDefaultEight =
  "chainOfThought";
export const fetchConversationMessagesResponseMessagesItemContentBlocksItemBodyTypeDefaultNine =
  "revised";
export const fetchConversationMessagesResponseMessagesItemContentBlocksItemBodyTypeDefaultOnezero =
  "origin";
export const fetchConversationMessagesResponseMessagesItemContentBlocksItemBodyTypeDefaultOneone =
  "stagingStatus";
export const fetchConversationMessagesResponseMessagesItemContentBlocksItemBodyTypeDefaultOnetwo =
  "completeStatus";
export const fetchConversationMessagesResponseMessagesItemContentBlocksItemBodyTypeDefaultOnethree =
  "retryStatus";
export const fetchConversationMessagesResponseMessagesItemContentBlocksItemBodyTypeDefaultOnefour =
  "assessmentResult";
export const fetchConversationMessagesResponseMessagesItemContentBlocksItemBodyTypeDefaultOnefive =
  "voiceMessageMarker";
export const fetchConversationMessagesResponseMessagesItemContentBlocksItemBodyTypeDefaultOnesix =
  "voiceUpload";
export const fetchConversationMessagesResponseMessagesItemContentBlocksItemBodyTypeDefaultOneseven =
  "debug";
export const fetchConversationMessagesResponseMessagesItemContentBlocksItemBodyTypeDefaultOneeight =
  "blank";
export const fetchConversationMessagesResponseMessagesItemContentBlocksItemBodyTypeDefaultOnenine =
  "answerPartSuggestion";
export const fetchConversationMessagesResponseMessagesItemContentBlocksItemBodyAnswerPartAnswerPartTypeDefault =
  "revise_message";
export const fetchConversationMessagesResponseMessagesItemContentBlocksItemBodyAnswerPartSendToPatientDefault = true;
export const fetchConversationMessagesResponseMessagesItemContentBlocksItemBodyAnswerPartAnswerPartTypeDefaultOne =
  "note";
export const fetchConversationMessagesResponseMessagesItemContentBlocksItemBodyAnswerPartAnswerPartTypeDefaultTwo =
  "rejected";
export const fetchConversationMessagesResponseMessagesItemContentBlocksItemBodyAnswerPartAnswerPartTypeDefaultThree =
  "prescription";
export const fetchConversationMessagesResponseMessagesItemContentBlocksItemBodyAnswerPartAnswerPartTypeDefaultFour =
  "prescription_suggestion";
export const fetchConversationMessagesResponseMessagesItemContentBlocksItemBodyTypeDefaultTwozero =
  "fileAttachment";
export const fetchConversationMessagesResponseMessagesItemContentBlocksItemBodyTypeDefaultTwoone =
  "actionChip";
export const fetchConversationMessagesResponseMessagesItemContentBlocksItemBodyTypeDefaultTwotwo =
  "mention";
export const fetchConversationMessagesResponseMessagesItemContentBlocksItemBodyTypeDefaultTwothree =
  "directive";

export const fetchConversationMessagesResponse = zod.object({
  messages: zod.array(
    zod.object({
      id: zod.uuid(),
      createdAt: zod.iso.datetime({}),
      sender: zod.enum(["Lotus", "Debug", "User", "Clinician"]),
      status: zod.enum(["committed", "staged"]).optional(),
      contentBlocks: zod.array(
        zod.object({
          id: zod.uuid(),
          body: zod.union([
            zod.union([
              zod.object({
                type: zod
                  .literal("text")
                  .default(
                    fetchConversationMessagesResponseMessagesItemContentBlocksItemBodyTypeDefault,
                  ),
                stream: zod.enum(["Chat", "Thinking"]).optional(),
                text: zod.string(),
              }),
              zod.object({
                type: zod
                  .literal("choiceChip")
                  .default(
                    fetchConversationMessagesResponseMessagesItemContentBlocksItemBodyTypeDefaultOne,
                  ),
                text: zod.string(),
              }),
              zod.object({
                type: zod
                  .literal("error")
                  .default(
                    fetchConversationMessagesResponseMessagesItemContentBlocksItemBodyTypeDefaultTwo,
                  ),
                text: zod.string(),
              }),
              zod.object({
                type: zod
                  .literal("chart")
                  .default(
                    fetchConversationMessagesResponseMessagesItemContentBlocksItemBodyTypeDefaultThree,
                  ),
                chartData: zod.record(zod.string(), zod.unknown()),
              }),
              zod.object({
                type: zod
                  .literal("toolUse")
                  .default(
                    fetchConversationMessagesResponseMessagesItemContentBlocksItemBodyTypeDefaultFour,
                  ),
                text: zod.string(),
              }),
              zod.object({
                type: zod
                  .literal("article")
                  .default(
                    fetchConversationMessagesResponseMessagesItemContentBlocksItemBodyTypeDefaultFive,
                  ),
                articleData: zod.object({
                  title: zod.string(),
                  citation: zod.string(),
                  abstract: zod.string(),
                  published_date: zod.iso.datetime({}),
                  pmcid: zod.string(),
                  pmid: zod.string(),
                  chunks: zod.array(zod.string()),
                  citation_data: zod.object({
                    pmcid: zod.string(),
                    title: zod.string(),
                    authors: zod.array(
                      zod.object({
                        surname: zod
                          .union([zod.string(), zod.null()])
                          .optional(),
                        given_names: zod
                          .union([zod.string(), zod.null()])
                          .optional(),
                        full_name: zod
                          .union([zod.string(), zod.null()])
                          .optional(),
                      }),
                    ),
                    author_string: zod.string(),
                    journal: zod.string(),
                    pub_date: zod.string(),
                    volume: zod.union([zod.string(), zod.null()]).optional(),
                    issue: zod.union([zod.string(), zod.null()]).optional(),
                    pages: zod.union([zod.string(), zod.null()]).optional(),
                    doi: zod.union([zod.string(), zod.null()]).optional(),
                    issn: zod.union([zod.string(), zod.null()]).optional(),
                    pubmed_link: zod
                      .union([zod.string(), zod.null()])
                      .optional(),
                    formatted: zod.object({
                      apa: zod.string(),
                      mla: zod.string(),
                      vancouver: zod.string(),
                    }),
                  }),
                }),
              }),
              zod.object({
                type: zod
                  .literal("sources_v2")
                  .default(
                    fetchConversationMessagesResponseMessagesItemContentBlocksItemBodyTypeDefaultSix,
                  ),
                sources: zod.array(
                  zod.object({
                    title: zod.string(),
                    subtitle: zod.string(),
                    content: zod.union([
                      zod.object({
                        type: zod
                          .literal("table")
                          .default(
                            fetchConversationMessagesResponseMessagesItemContentBlocksItemBodySourcesItemContentTypeDefault,
                          ),
                        rows: zod.array(
                          zod.record(zod.string(), zod.unknown()),
                        ),
                        columns: zod.array(zod.string()),
                        note: zod.string(),
                        column_schema: zod
                          .record(
                            zod.string(),
                            zod.enum([
                              "string",
                              "integer",
                              "float",
                              "boolean",
                              "datetime",
                            ]),
                          )
                          .default(
                            fetchConversationMessagesResponseMessagesItemContentBlocksItemBodySourcesItemContentColumnSchemaDefault,
                          ),
                      }),
                      zod.object({
                        type: zod
                          .literal("link")
                          .default(
                            fetchConversationMessagesResponseMessagesItemContentBlocksItemBodySourcesItemContentTypeDefaultOne,
                          ),
                        link: zod.string(),
                      }),
                    ]),
                    icon: zod
                      .union([
                        zod
                          .string()
                          .describe(
                            "An icon identifier - opaque to the client.",
                          ),
                        zod.null(),
                      ])
                      .optional(),
                  }),
                ),
              }),
              zod.object({
                type: zod
                  .literal("pendingReview")
                  .default(
                    fetchConversationMessagesResponseMessagesItemContentBlocksItemBodyTypeDefaultSeven,
                  ),
              }),
              zod.object({
                type: zod
                  .literal("chainOfThought")
                  .default(
                    fetchConversationMessagesResponseMessagesItemContentBlocksItemBodyTypeDefaultEight,
                  ),
                text: zod.string(),
              }),
              zod.object({
                type: zod
                  .literal("revised")
                  .default(
                    fetchConversationMessagesResponseMessagesItemContentBlocksItemBodyTypeDefaultNine,
                  ),
                text: zod.string(),
              }),
              zod.object({
                type: zod
                  .literal("origin")
                  .default(
                    fetchConversationMessagesResponseMessagesItemContentBlocksItemBodyTypeDefaultOnezero,
                  ),
                origin: zod.union([zod.enum(["insight"]), zod.unknown()]),
              }),
              zod.object({
                type: zod
                  .literal("stagingStatus")
                  .default(
                    fetchConversationMessagesResponseMessagesItemContentBlocksItemBodyTypeDefaultOneone,
                  ),
                status: zod.enum(["committed", "staged"]),
              }),
              zod.object({
                type: zod
                  .literal("completeStatus")
                  .default(
                    fetchConversationMessagesResponseMessagesItemContentBlocksItemBodyTypeDefaultOnetwo,
                  ),
                status: zod.enum(["incomplete", "complete"]),
              }),
              zod.object({
                type: zod
                  .literal("retryStatus")
                  .default(
                    fetchConversationMessagesResponseMessagesItemContentBlocksItemBodyTypeDefaultOnethree,
                  ),
                status: zod.enum(["retry", "handled"]),
                error: zod
                  .union([
                    zod.object({
                      message: zod.string(),
                      trace: zod.string(),
                      code: zod.union([zod.string(), zod.null()]).optional(),
                      payload: zod
                        .union([
                          zod.record(zod.string(), zod.unknown()),
                          zod.null(),
                        ])
                        .optional(),
                      status_code: zod
                        .union([zod.number(), zod.null()])
                        .optional(),
                    }),
                    zod.null(),
                  ])
                  .optional(),
              }),
              zod.object({
                type: zod
                  .literal("assessmentResult")
                  .default(
                    fetchConversationMessagesResponseMessagesItemContentBlocksItemBodyTypeDefaultOnefour,
                  ),
                assessmentResult: zod.unknown(),
              }),
              zod.object({
                type: zod
                  .literal("voiceMessageMarker")
                  .default(
                    fetchConversationMessagesResponseMessagesItemContentBlocksItemBodyTypeDefaultOnefive,
                  ),
                obscured: zod.boolean(),
              }),
              zod
                .object({
                  type: zod
                    .literal("voiceUpload")
                    .default(
                      fetchConversationMessagesResponseMessagesItemContentBlocksItemBodyTypeDefaultOnesix,
                    ),
                  uploadId: zod.uuid(),
                })
                .describe(
                  "Reference to a confirmed voice upload associated with the message.\nThis is provenance metadata, not semantic message content.",
                ),
              zod.object({
                type: zod
                  .literal("debug")
                  .default(
                    fetchConversationMessagesResponseMessagesItemContentBlocksItemBodyTypeDefaultOneseven,
                  ),
                title: zod.string(),
                content: zod.string(),
              }),
              zod.object({
                type: zod
                  .literal("blank")
                  .default(
                    fetchConversationMessagesResponseMessagesItemContentBlocksItemBodyTypeDefaultOneeight,
                  ),
              }),
              zod.object({
                type: zod
                  .literal("answerPartSuggestion")
                  .default(
                    fetchConversationMessagesResponseMessagesItemContentBlocksItemBodyTypeDefaultOnenine,
                  ),
                answerPart: zod.union([
                  zod
                    .object({
                      answer_part_type: zod
                        .literal("revise_message")
                        .default(
                          fetchConversationMessagesResponseMessagesItemContentBlocksItemBodyAnswerPartAnswerPartTypeDefault,
                        ),
                      message_id: zod.uuid(),
                      response: zod.enum(["accept", "revise"]),
                      new_response: zod.string(),
                      explanation: zod
                        .union([zod.string(), zod.null()])
                        .optional(),
                      send_to_patient: zod
                        .boolean()
                        .default(
                          fetchConversationMessagesResponseMessagesItemContentBlocksItemBodyAnswerPartSendToPatientDefault,
                        ),
                    })
                    .describe(
                      "This is a response to a ReviseMessageAnswerPartRequestT. It stores the clinician's judgement on the message.",
                    ),
                  zod
                    .object({
                      answer_part_type: zod
                        .literal("note")
                        .default(
                          fetchConversationMessagesResponseMessagesItemContentBlocksItemBodyAnswerPartAnswerPartTypeDefaultOne,
                        ),
                      patient_id: zod.uuid(),
                      note: zod.string(),
                    })
                    .describe(
                      "This is a response to a NoteAnswerPartRequestT. It is a note that will be entered into the EHR system.",
                    ),
                  zod
                    .object({
                      answer_part_type: zod
                        .literal("rejected")
                        .default(
                          fetchConversationMessagesResponseMessagesItemContentBlocksItemBodyAnswerPartAnswerPartTypeDefaultTwo,
                        ),
                      reason: zod
                        .union([zod.string(), zod.null()])
                        .optional()
                        .describe("Optional reason for rejection"),
                    })
                    .describe(
                      "This is a response to a RejectedAnswerPartRequestT. It indicates the clinician is rejecting the entire request.",
                    ),
                  zod
                    .object({
                      answer_part_type: zod
                        .literal("prescription")
                        .default(
                          fetchConversationMessagesResponseMessagesItemContentBlocksItemBodyAnswerPartAnswerPartTypeDefaultThree,
                        ),
                      patient_id: zod.uuid(),
                      dosespot_prescription_id: zod.string(),
                    })
                    .describe(
                      "This is a response to a PrescriptionAnswerPartRequestT. It stores a prescription ID that will be sent to pharmacy.",
                    ),
                  zod
                    .object({
                      answer_part_type: zod
                        .literal("prescription_suggestion")
                        .default(
                          fetchConversationMessagesResponseMessagesItemContentBlocksItemBodyAnswerPartAnswerPartTypeDefaultFour,
                        ),
                      dispensable_drug_id: zod
                        .union([zod.number(), zod.null()])
                        .optional()
                        .describe(
                          "DoseSpot DispensableDrugId for the medication",
                        ),
                      pharmacy_id: zod
                        .union([zod.number(), zod.null()])
                        .optional()
                        .describe("DoseSpot PharmacyId for the pharmacy"),
                      directions: zod
                        .union([zod.string(), zod.null()])
                        .optional()
                        .describe("Suggested directions for use"),
                      quantity: zod
                        .union([zod.number(), zod.null()])
                        .optional()
                        .describe("Suggested quantity"),
                      refills: zod
                        .union([zod.number(), zod.null()])
                        .optional()
                        .describe("Suggested number of refills"),
                      notes: zod
                        .union([zod.string(), zod.null()])
                        .optional()
                        .describe("Additional notes about the prescription"),
                    })
                    .describe(
                      "Suggested prescription data that can be used to prepopulate a prescription form.",
                    ),
                ]),
              }),
              zod
                .object({
                  type: zod
                    .literal("fileAttachment")
                    .default(
                      fetchConversationMessagesResponseMessagesItemContentBlocksItemBodyTypeDefaultTwozero,
                    ),
                  attachmentId: zod.uuid(),
                  filename: zod.union([zod.string(), zod.null()]).optional(),
                  mimeType: zod.union([zod.string(), zod.null()]).optional(),
                  fileType: zod
                    .union([
                      zod
                        .enum(["image", "document", "audio"])
                        .describe("Type of file attachment."),
                      zod.null(),
                    ])
                    .optional(),
                })
                .describe(
                  "Reference to an uploaded file (image or PDF).\nAll metadata is stored in the database and fetched when needed.",
                ),
              zod.object({
                type: zod
                  .literal("actionChip")
                  .default(
                    fetchConversationMessagesResponseMessagesItemContentBlocksItemBodyTypeDefaultTwoone,
                  ),
                label: zod.string(),
                action: zod.string(),
              }),
              zod
                .object({
                  type: zod
                    .literal("mention")
                    .default(
                      fetchConversationMessagesResponseMessagesItemContentBlocksItemBodyTypeDefaultTwotwo,
                    ),
                  sourceUrl: zod.string(),
                })
                .describe(
                  "Reference to a durable, resolver-backed snapshot (`LiveSource`).\n\nMentions are not rendered on the client at all -- they exist purely so the\nagent can read the underlying snapshot as a prompt fragment. Clients\nshould hide these blocks from the user-facing message view.\n\n`source_url` is a `lotus-kb:\/\/live-sources\/users\/{user_id}\/...` URL minted\nby the LiveSource promotion endpoint. The URL is owner-scoped: the\nvalidation layer drops the block if the URL is not a LiveSource URL\nowned by the calling user, so users cannot fabricate authoritative-looking\nmentions or smuggle in another user's snapshot.\n\nThe url is resolvable by the Lotus URL resolver, so the agent can cite\nit directly and the snapshot persists indefinitely (not bound to a\nRedis TTL).",
                ),
              zod
                .object({
                  type: zod
                    .literal("directive")
                    .default(
                      fetchConversationMessagesResponseMessagesItemContentBlocksItemBodyTypeDefaultTwothree,
                    ),
                  directive: zod.string(),
                })
                .describe(
                  "The directive a Lotus message was written to answer.\n\nThe patient never sees it; Lotus sees it as part of the message wherever\nthe message appears in its history.",
                ),
            ]),
            zod.unknown(),
          ]),
          createdAt: zod.iso.datetime({}).optional(),
        }),
      ),
      completionState: zod.enum(["incomplete", "complete"]).optional(),
    }),
  ),
});

/**
 * @summary Create Conversation Message
 */
export const createConversationMessageParams = zod.object({
  conversation_id: zod.uuid(),
});

export const createConversationMessageBodyContentBlocksItemTypeDefault = "text";
export const createConversationMessageBodyContentBlocksItemTypeDefaultOne =
  "choiceChip";
export const createConversationMessageBodyContentBlocksItemTypeDefaultTwo =
  "error";
export const createConversationMessageBodyContentBlocksItemTypeDefaultThree =
  "chart";
export const createConversationMessageBodyContentBlocksItemTypeDefaultFour =
  "toolUse";
export const createConversationMessageBodyContentBlocksItemTypeDefaultFive =
  "article";
export const createConversationMessageBodyContentBlocksItemTypeDefaultSix =
  "sources_v2";
export const createConversationMessageBodyContentBlocksItemSourcesItemContentTypeDefault =
  "table";
export const createConversationMessageBodyContentBlocksItemSourcesItemContentColumnSchemaDefault =
  {};
export const createConversationMessageBodyContentBlocksItemSourcesItemContentTypeDefaultOne =
  "link";
export const createConversationMessageBodyContentBlocksItemTypeDefaultSeven =
  "pendingReview";
export const createConversationMessageBodyContentBlocksItemTypeDefaultEight =
  "chainOfThought";
export const createConversationMessageBodyContentBlocksItemTypeDefaultNine =
  "revised";
export const createConversationMessageBodyContentBlocksItemTypeDefaultOnezero =
  "origin";
export const createConversationMessageBodyContentBlocksItemTypeDefaultOneone =
  "stagingStatus";
export const createConversationMessageBodyContentBlocksItemTypeDefaultOnetwo =
  "completeStatus";
export const createConversationMessageBodyContentBlocksItemTypeDefaultOnethree =
  "retryStatus";
export const createConversationMessageBodyContentBlocksItemTypeDefaultOnefour =
  "assessmentResult";
export const createConversationMessageBodyContentBlocksItemTypeDefaultOnefive =
  "voiceMessageMarker";
export const createConversationMessageBodyContentBlocksItemTypeDefaultOnesix =
  "voiceUpload";
export const createConversationMessageBodyContentBlocksItemTypeDefaultOneseven =
  "debug";
export const createConversationMessageBodyContentBlocksItemTypeDefaultOneeight =
  "blank";
export const createConversationMessageBodyContentBlocksItemTypeDefaultOnenine =
  "answerPartSuggestion";
export const createConversationMessageBodyContentBlocksItemAnswerPartAnswerPartTypeDefault =
  "revise_message";
export const createConversationMessageBodyContentBlocksItemAnswerPartSendToPatientDefault = true;
export const createConversationMessageBodyContentBlocksItemAnswerPartAnswerPartTypeDefaultOne =
  "note";
export const createConversationMessageBodyContentBlocksItemAnswerPartAnswerPartTypeDefaultTwo =
  "rejected";
export const createConversationMessageBodyContentBlocksItemAnswerPartAnswerPartTypeDefaultThree =
  "prescription";
export const createConversationMessageBodyContentBlocksItemAnswerPartAnswerPartTypeDefaultFour =
  "prescription_suggestion";
export const createConversationMessageBodyContentBlocksItemTypeDefaultTwozero =
  "fileAttachment";
export const createConversationMessageBodyContentBlocksItemTypeDefaultTwoone =
  "actionChip";
export const createConversationMessageBodyContentBlocksItemTypeDefaultTwotwo =
  "mention";
export const createConversationMessageBodyContentBlocksItemTypeDefaultTwothree =
  "directive";
export const createConversationMessageBodyUseAudioDefault = false;
export const createConversationMessageBodyAsynchronousDefault = false;
export const createConversationMessageBodyIsTriggeredByDirectiveDefault = false;
export const createConversationMessageBodyAddContentBlocksDirectlyToInvocationDefault = false;

export const createConversationMessageBody = zod.object({
  sender: zod.enum(["Lotus", "Debug", "User", "Clinician"]).optional(),
  contentBlocks: zod.array(
    zod.union([
      zod.union([
        zod.object({
          type: zod
            .literal("text")
            .default(createConversationMessageBodyContentBlocksItemTypeDefault),
          stream: zod.enum(["Chat", "Thinking"]).optional(),
          text: zod.string(),
        }),
        zod.object({
          type: zod
            .literal("choiceChip")
            .default(
              createConversationMessageBodyContentBlocksItemTypeDefaultOne,
            ),
          text: zod.string(),
        }),
        zod.object({
          type: zod
            .literal("error")
            .default(
              createConversationMessageBodyContentBlocksItemTypeDefaultTwo,
            ),
          text: zod.string(),
        }),
        zod.object({
          type: zod
            .literal("chart")
            .default(
              createConversationMessageBodyContentBlocksItemTypeDefaultThree,
            ),
          chartData: zod.record(zod.string(), zod.unknown()),
        }),
        zod.object({
          type: zod
            .literal("toolUse")
            .default(
              createConversationMessageBodyContentBlocksItemTypeDefaultFour,
            ),
          text: zod.string(),
        }),
        zod.object({
          type: zod
            .literal("article")
            .default(
              createConversationMessageBodyContentBlocksItemTypeDefaultFive,
            ),
          articleData: zod.object({
            title: zod.string(),
            citation: zod.string(),
            abstract: zod.string(),
            published_date: zod.iso.datetime({}),
            pmcid: zod.string(),
            pmid: zod.string(),
            chunks: zod.array(zod.string()),
            citation_data: zod.object({
              pmcid: zod.string(),
              title: zod.string(),
              authors: zod.array(
                zod.object({
                  surname: zod.union([zod.string(), zod.null()]).optional(),
                  given_names: zod.union([zod.string(), zod.null()]).optional(),
                  full_name: zod.union([zod.string(), zod.null()]).optional(),
                }),
              ),
              author_string: zod.string(),
              journal: zod.string(),
              pub_date: zod.string(),
              volume: zod.union([zod.string(), zod.null()]).optional(),
              issue: zod.union([zod.string(), zod.null()]).optional(),
              pages: zod.union([zod.string(), zod.null()]).optional(),
              doi: zod.union([zod.string(), zod.null()]).optional(),
              issn: zod.union([zod.string(), zod.null()]).optional(),
              pubmed_link: zod.union([zod.string(), zod.null()]).optional(),
              formatted: zod.object({
                apa: zod.string(),
                mla: zod.string(),
                vancouver: zod.string(),
              }),
            }),
          }),
        }),
        zod.object({
          type: zod
            .literal("sources_v2")
            .default(
              createConversationMessageBodyContentBlocksItemTypeDefaultSix,
            ),
          sources: zod.array(
            zod.object({
              title: zod.string(),
              subtitle: zod.string(),
              content: zod.union([
                zod.object({
                  type: zod
                    .literal("table")
                    .default(
                      createConversationMessageBodyContentBlocksItemSourcesItemContentTypeDefault,
                    ),
                  rows: zod.array(zod.record(zod.string(), zod.unknown())),
                  columns: zod.array(zod.string()),
                  note: zod.string(),
                  column_schema: zod
                    .record(
                      zod.string(),
                      zod.enum([
                        "string",
                        "integer",
                        "float",
                        "boolean",
                        "datetime",
                      ]),
                    )
                    .default(
                      createConversationMessageBodyContentBlocksItemSourcesItemContentColumnSchemaDefault,
                    ),
                }),
                zod.object({
                  type: zod
                    .literal("link")
                    .default(
                      createConversationMessageBodyContentBlocksItemSourcesItemContentTypeDefaultOne,
                    ),
                  link: zod.string(),
                }),
              ]),
              icon: zod
                .union([
                  zod
                    .string()
                    .describe("An icon identifier - opaque to the client."),
                  zod.null(),
                ])
                .optional(),
            }),
          ),
        }),
        zod.object({
          type: zod
            .literal("pendingReview")
            .default(
              createConversationMessageBodyContentBlocksItemTypeDefaultSeven,
            ),
        }),
        zod.object({
          type: zod
            .literal("chainOfThought")
            .default(
              createConversationMessageBodyContentBlocksItemTypeDefaultEight,
            ),
          text: zod.string(),
        }),
        zod.object({
          type: zod
            .literal("revised")
            .default(
              createConversationMessageBodyContentBlocksItemTypeDefaultNine,
            ),
          text: zod.string(),
        }),
        zod.object({
          type: zod
            .literal("origin")
            .default(
              createConversationMessageBodyContentBlocksItemTypeDefaultOnezero,
            ),
          origin: zod.union([zod.enum(["insight"]), zod.unknown()]),
        }),
        zod.object({
          type: zod
            .literal("stagingStatus")
            .default(
              createConversationMessageBodyContentBlocksItemTypeDefaultOneone,
            ),
          status: zod.enum(["committed", "staged"]),
        }),
        zod.object({
          type: zod
            .literal("completeStatus")
            .default(
              createConversationMessageBodyContentBlocksItemTypeDefaultOnetwo,
            ),
          status: zod.enum(["incomplete", "complete"]),
        }),
        zod.object({
          type: zod
            .literal("retryStatus")
            .default(
              createConversationMessageBodyContentBlocksItemTypeDefaultOnethree,
            ),
          status: zod.enum(["retry", "handled"]),
          error: zod
            .union([
              zod.object({
                message: zod.string(),
                trace: zod.string(),
                code: zod.union([zod.string(), zod.null()]).optional(),
                payload: zod
                  .union([zod.record(zod.string(), zod.unknown()), zod.null()])
                  .optional(),
                status_code: zod.union([zod.number(), zod.null()]).optional(),
              }),
              zod.null(),
            ])
            .optional(),
        }),
        zod.object({
          type: zod
            .literal("assessmentResult")
            .default(
              createConversationMessageBodyContentBlocksItemTypeDefaultOnefour,
            ),
          assessmentResult: zod.unknown(),
        }),
        zod.object({
          type: zod
            .literal("voiceMessageMarker")
            .default(
              createConversationMessageBodyContentBlocksItemTypeDefaultOnefive,
            ),
          obscured: zod.boolean(),
        }),
        zod
          .object({
            type: zod
              .literal("voiceUpload")
              .default(
                createConversationMessageBodyContentBlocksItemTypeDefaultOnesix,
              ),
            uploadId: zod.uuid(),
          })
          .describe(
            "Reference to a confirmed voice upload associated with the message.\nThis is provenance metadata, not semantic message content.",
          ),
        zod.object({
          type: zod
            .literal("debug")
            .default(
              createConversationMessageBodyContentBlocksItemTypeDefaultOneseven,
            ),
          title: zod.string(),
          content: zod.string(),
        }),
        zod.object({
          type: zod
            .literal("blank")
            .default(
              createConversationMessageBodyContentBlocksItemTypeDefaultOneeight,
            ),
        }),
        zod.object({
          type: zod
            .literal("answerPartSuggestion")
            .default(
              createConversationMessageBodyContentBlocksItemTypeDefaultOnenine,
            ),
          answerPart: zod.union([
            zod
              .object({
                answer_part_type: zod
                  .literal("revise_message")
                  .default(
                    createConversationMessageBodyContentBlocksItemAnswerPartAnswerPartTypeDefault,
                  ),
                message_id: zod.uuid(),
                response: zod.enum(["accept", "revise"]),
                new_response: zod.string(),
                explanation: zod.union([zod.string(), zod.null()]).optional(),
                send_to_patient: zod
                  .boolean()
                  .default(
                    createConversationMessageBodyContentBlocksItemAnswerPartSendToPatientDefault,
                  ),
              })
              .describe(
                "This is a response to a ReviseMessageAnswerPartRequestT. It stores the clinician's judgement on the message.",
              ),
            zod
              .object({
                answer_part_type: zod
                  .literal("note")
                  .default(
                    createConversationMessageBodyContentBlocksItemAnswerPartAnswerPartTypeDefaultOne,
                  ),
                patient_id: zod.uuid(),
                note: zod.string(),
              })
              .describe(
                "This is a response to a NoteAnswerPartRequestT. It is a note that will be entered into the EHR system.",
              ),
            zod
              .object({
                answer_part_type: zod
                  .literal("rejected")
                  .default(
                    createConversationMessageBodyContentBlocksItemAnswerPartAnswerPartTypeDefaultTwo,
                  ),
                reason: zod
                  .union([zod.string(), zod.null()])
                  .optional()
                  .describe("Optional reason for rejection"),
              })
              .describe(
                "This is a response to a RejectedAnswerPartRequestT. It indicates the clinician is rejecting the entire request.",
              ),
            zod
              .object({
                answer_part_type: zod
                  .literal("prescription")
                  .default(
                    createConversationMessageBodyContentBlocksItemAnswerPartAnswerPartTypeDefaultThree,
                  ),
                patient_id: zod.uuid(),
                dosespot_prescription_id: zod.string(),
              })
              .describe(
                "This is a response to a PrescriptionAnswerPartRequestT. It stores a prescription ID that will be sent to pharmacy.",
              ),
            zod
              .object({
                answer_part_type: zod
                  .literal("prescription_suggestion")
                  .default(
                    createConversationMessageBodyContentBlocksItemAnswerPartAnswerPartTypeDefaultFour,
                  ),
                dispensable_drug_id: zod
                  .union([zod.number(), zod.null()])
                  .optional()
                  .describe("DoseSpot DispensableDrugId for the medication"),
                pharmacy_id: zod
                  .union([zod.number(), zod.null()])
                  .optional()
                  .describe("DoseSpot PharmacyId for the pharmacy"),
                directions: zod
                  .union([zod.string(), zod.null()])
                  .optional()
                  .describe("Suggested directions for use"),
                quantity: zod
                  .union([zod.number(), zod.null()])
                  .optional()
                  .describe("Suggested quantity"),
                refills: zod
                  .union([zod.number(), zod.null()])
                  .optional()
                  .describe("Suggested number of refills"),
                notes: zod
                  .union([zod.string(), zod.null()])
                  .optional()
                  .describe("Additional notes about the prescription"),
              })
              .describe(
                "Suggested prescription data that can be used to prepopulate a prescription form.",
              ),
          ]),
        }),
        zod
          .object({
            type: zod
              .literal("fileAttachment")
              .default(
                createConversationMessageBodyContentBlocksItemTypeDefaultTwozero,
              ),
            attachmentId: zod.uuid(),
            filename: zod.union([zod.string(), zod.null()]).optional(),
            mimeType: zod.union([zod.string(), zod.null()]).optional(),
            fileType: zod
              .union([
                zod
                  .enum(["image", "document", "audio"])
                  .describe("Type of file attachment."),
                zod.null(),
              ])
              .optional(),
          })
          .describe(
            "Reference to an uploaded file (image or PDF).\nAll metadata is stored in the database and fetched when needed.",
          ),
        zod.object({
          type: zod
            .literal("actionChip")
            .default(
              createConversationMessageBodyContentBlocksItemTypeDefaultTwoone,
            ),
          label: zod.string(),
          action: zod.string(),
        }),
        zod
          .object({
            type: zod
              .literal("mention")
              .default(
                createConversationMessageBodyContentBlocksItemTypeDefaultTwotwo,
              ),
            sourceUrl: zod.string(),
          })
          .describe(
            "Reference to a durable, resolver-backed snapshot (`LiveSource`).\n\nMentions are not rendered on the client at all -- they exist purely so the\nagent can read the underlying snapshot as a prompt fragment. Clients\nshould hide these blocks from the user-facing message view.\n\n`source_url` is a `lotus-kb:\/\/live-sources\/users\/{user_id}\/...` URL minted\nby the LiveSource promotion endpoint. The URL is owner-scoped: the\nvalidation layer drops the block if the URL is not a LiveSource URL\nowned by the calling user, so users cannot fabricate authoritative-looking\nmentions or smuggle in another user's snapshot.\n\nThe url is resolvable by the Lotus URL resolver, so the agent can cite\nit directly and the snapshot persists indefinitely (not bound to a\nRedis TTL).",
          ),
        zod
          .object({
            type: zod
              .literal("directive")
              .default(
                createConversationMessageBodyContentBlocksItemTypeDefaultTwothree,
              ),
            directive: zod.string(),
          })
          .describe(
            "The directive a Lotus message was written to answer.\n\nThe patient never sees it; Lotus sees it as part of the message wherever\nthe message appears in its history.",
          ),
      ]),
      zod.unknown(),
    ]),
  ),
  useAudio: zod.union([zod.boolean(), zod.null()]).optional(),
  asynchronous: zod.boolean().optional(),
  isTriggeredByDirective: zod.boolean().optional(),
  customChainOfThoughtPrompt: zod.union([zod.string(), zod.null()]).optional(),
  addContentBlocksDirectlyToInvocation: zod.boolean().optional(),
});

/**
 * @summary Fetch Messages With User Info Endpoint
 */
export const fetchMessagesWithUserInfoEndpointQueryLimitDefault = 50;

export const fetchMessagesWithUserInfoEndpointQueryParams = zod.object({
  limit: zod
    .number()
    .default(fetchMessagesWithUserInfoEndpointQueryLimitDefault),
  before: zod.union([zod.uuid(), zod.null()]).optional(),
  after: zod.union([zod.uuid(), zod.null()]).optional(),
  start_date: zod.union([zod.iso.datetime({}), zod.null()]).optional(),
  end_date: zod.union([zod.iso.datetime({}), zod.null()]).optional(),
  search: zod.union([zod.string(), zod.null()]).optional(),
  sender: zod
    .union([zod.enum(["Lotus", "Debug", "User", "Clinician"]), zod.null()])
    .optional(),
  conversation_id: zod.union([zod.uuid(), zod.null()]).optional(),
});

export const fetchMessagesWithUserInfoEndpointResponseResultItemsItemConversationMessageContentBlocksItemBodyTypeDefault =
  "text";
export const fetchMessagesWithUserInfoEndpointResponseResultItemsItemConversationMessageContentBlocksItemBodyTypeDefaultOne =
  "choiceChip";
export const fetchMessagesWithUserInfoEndpointResponseResultItemsItemConversationMessageContentBlocksItemBodyTypeDefaultTwo =
  "error";
export const fetchMessagesWithUserInfoEndpointResponseResultItemsItemConversationMessageContentBlocksItemBodyTypeDefaultThree =
  "chart";
export const fetchMessagesWithUserInfoEndpointResponseResultItemsItemConversationMessageContentBlocksItemBodyTypeDefaultFour =
  "toolUse";
export const fetchMessagesWithUserInfoEndpointResponseResultItemsItemConversationMessageContentBlocksItemBodyTypeDefaultFive =
  "article";
export const fetchMessagesWithUserInfoEndpointResponseResultItemsItemConversationMessageContentBlocksItemBodyTypeDefaultSix =
  "sources_v2";
export const fetchMessagesWithUserInfoEndpointResponseResultItemsItemConversationMessageContentBlocksItemBodySourcesItemContentTypeDefault =
  "table";
export const fetchMessagesWithUserInfoEndpointResponseResultItemsItemConversationMessageContentBlocksItemBodySourcesItemContentColumnSchemaDefault =
  {};
export const fetchMessagesWithUserInfoEndpointResponseResultItemsItemConversationMessageContentBlocksItemBodySourcesItemContentTypeDefaultOne =
  "link";
export const fetchMessagesWithUserInfoEndpointResponseResultItemsItemConversationMessageContentBlocksItemBodyTypeDefaultSeven =
  "pendingReview";
export const fetchMessagesWithUserInfoEndpointResponseResultItemsItemConversationMessageContentBlocksItemBodyTypeDefaultEight =
  "chainOfThought";
export const fetchMessagesWithUserInfoEndpointResponseResultItemsItemConversationMessageContentBlocksItemBodyTypeDefaultNine =
  "revised";
export const fetchMessagesWithUserInfoEndpointResponseResultItemsItemConversationMessageContentBlocksItemBodyTypeDefaultOnezero =
  "origin";
export const fetchMessagesWithUserInfoEndpointResponseResultItemsItemConversationMessageContentBlocksItemBodyTypeDefaultOneone =
  "stagingStatus";
export const fetchMessagesWithUserInfoEndpointResponseResultItemsItemConversationMessageContentBlocksItemBodyTypeDefaultOnetwo =
  "completeStatus";
export const fetchMessagesWithUserInfoEndpointResponseResultItemsItemConversationMessageContentBlocksItemBodyTypeDefaultOnethree =
  "retryStatus";
export const fetchMessagesWithUserInfoEndpointResponseResultItemsItemConversationMessageContentBlocksItemBodyTypeDefaultOnefour =
  "assessmentResult";
export const fetchMessagesWithUserInfoEndpointResponseResultItemsItemConversationMessageContentBlocksItemBodyTypeDefaultOnefive =
  "voiceMessageMarker";
export const fetchMessagesWithUserInfoEndpointResponseResultItemsItemConversationMessageContentBlocksItemBodyTypeDefaultOnesix =
  "voiceUpload";
export const fetchMessagesWithUserInfoEndpointResponseResultItemsItemConversationMessageContentBlocksItemBodyTypeDefaultOneseven =
  "debug";
export const fetchMessagesWithUserInfoEndpointResponseResultItemsItemConversationMessageContentBlocksItemBodyTypeDefaultOneeight =
  "blank";
export const fetchMessagesWithUserInfoEndpointResponseResultItemsItemConversationMessageContentBlocksItemBodyTypeDefaultOnenine =
  "answerPartSuggestion";
export const fetchMessagesWithUserInfoEndpointResponseResultItemsItemConversationMessageContentBlocksItemBodyAnswerPartAnswerPartTypeDefault =
  "revise_message";
export const fetchMessagesWithUserInfoEndpointResponseResultItemsItemConversationMessageContentBlocksItemBodyAnswerPartSendToPatientDefault = true;
export const fetchMessagesWithUserInfoEndpointResponseResultItemsItemConversationMessageContentBlocksItemBodyAnswerPartAnswerPartTypeDefaultOne =
  "note";
export const fetchMessagesWithUserInfoEndpointResponseResultItemsItemConversationMessageContentBlocksItemBodyAnswerPartAnswerPartTypeDefaultTwo =
  "rejected";
export const fetchMessagesWithUserInfoEndpointResponseResultItemsItemConversationMessageContentBlocksItemBodyAnswerPartAnswerPartTypeDefaultThree =
  "prescription";
export const fetchMessagesWithUserInfoEndpointResponseResultItemsItemConversationMessageContentBlocksItemBodyAnswerPartAnswerPartTypeDefaultFour =
  "prescription_suggestion";
export const fetchMessagesWithUserInfoEndpointResponseResultItemsItemConversationMessageContentBlocksItemBodyTypeDefaultTwozero =
  "fileAttachment";
export const fetchMessagesWithUserInfoEndpointResponseResultItemsItemConversationMessageContentBlocksItemBodyTypeDefaultTwoone =
  "actionChip";
export const fetchMessagesWithUserInfoEndpointResponseResultItemsItemConversationMessageContentBlocksItemBodyTypeDefaultTwotwo =
  "mention";
export const fetchMessagesWithUserInfoEndpointResponseResultItemsItemConversationMessageContentBlocksItemBodyTypeDefaultTwothree =
  "directive";
export const fetchMessagesWithUserInfoEndpointResponseResultItemsItemUserInfoBasicInfoNameDefault =
  [];
export const fetchMessagesWithUserInfoEndpointResponseResultItemsItemUserInfoBasicInfoEmailDefault =
  [];
export const fetchMessagesWithUserInfoEndpointResponseResultItemsItemUserInfoBasicInfoPhoneDefault =
  [];
export const fetchMessagesWithUserInfoEndpointResponseResultItemsItemUserInfoBasicInfoAddressDefault =
  [];
export const fetchMessagesWithUserInfoEndpointResponseResultItemsItemUserInfoBasicInfoDateOfBirthDefault =
  [];
export const fetchMessagesWithUserInfoEndpointResponseResultItemsItemUserInfoCareStateExportsActionableItemsBagItemItemTagsUsStatesDefault =
  [];
export const fetchMessagesWithUserInfoEndpointResponseResultItemsItemUserInfoCareStateExportsActionableItemsBagItemItemTagsPracticeAreasDefault =
  [];
export const fetchMessagesWithUserInfoEndpointResponseResultItemsItemUserInfoCareStateExportsActionableItemsBagItemItemTagsOriginPracticesDefault =
  [];
export const fetchMessagesWithUserInfoEndpointResponseResultItemsItemUserInfoCareStateExportsFollowUpsAwaitingResponseItemLinkTypeDefault =
  "patient";
export const fetchMessagesWithUserInfoEndpointResponseResultItemsItemUserInfoCareStateExportsFollowUpsAwaitingResponseItemLinkTypeDefaultOne =
  "problem";
export const fetchMessagesWithUserInfoEndpointResponseResultItemsItemUserInfoCareStateExportsFollowUpsAwaitingResponseItemLinkTypeDefaultTwo =
  "request";
export const fetchMessagesWithUserInfoEndpointResponseResultItemsItemUserInfoCareStateExportsFollowUpsAwaitingResponseItemLinkTypeDefaultThree =
  "orphan";
export const fetchMessagesWithUserInfoEndpointResponseResultItemsItemUserInfoCareStateExportsFollowUpsAwaitingResponseItemUnreadDefault = false;
export const fetchMessagesWithUserInfoEndpointResponseResultItemsItemUserInfoCareStateExportsFollowUpsAwaitingResponseItemTransmissionLinkTypeDefault =
  "chat_message";
export const fetchMessagesWithUserInfoEndpointResponseResultItemsItemUserInfoCareStateExportsFollowUpsAwaitingResponseItemTransmissionLinkTypeDefaultOne =
  "chat_conversation";
export const fetchMessagesWithUserInfoEndpointResponseResultItemsItemUserInfoCareStateExportsFollowUpsAwaitingResponseItemAcknowledgementLinkTypeDefault =
  "chat_message";
export const fetchMessagesWithUserInfoEndpointResponseResultItemsItemUserInfoCareStateExportsFollowUpsAwaitingResponseItemAcknowledgementLinkTypeDefaultOne =
  "chat_conversation";
export const fetchMessagesWithUserInfoEndpointResponseResultItemsItemUserInfoCareStateExportsFollowUpsAwaitingResponseItemResponseInstrumentFormDefinitionFieldsItemSuggestedSubmissionTypeDefault =
  "string";
export const fetchMessagesWithUserInfoEndpointResponseResultItemsItemUserInfoCareStateExportsFollowUpsAwaitingResponseItemResponseInstrumentFormDefinitionFieldsItemSuggestedSubmissionTypeDefaultOne =
  "int";
export const fetchMessagesWithUserInfoEndpointResponseResultItemsItemUserInfoCareStateExportsFollowUpsAwaitingResponseItemResponseInstrumentFormDefinitionFieldsItemSuggestedSubmissionTypeDefaultTwo =
  "simple_address";
export const fetchMessagesWithUserInfoEndpointResponseResultItemsItemUserInfoCareStateExportsFollowUpsAwaitingResponseItemResponseInstrumentFormDefinitionFieldsItemSuggestedSubmissionTypeDefaultThree =
  "list";
export const fetchMessagesWithUserInfoEndpointResponseResultItemsItemUserInfoCareStateExportsFollowUpsAwaitingResponseItemResponseInstrumentFormDefinitionFieldsItemSuggestedSubmissionValuesItemTypeDefault =
  "string";
export const fetchMessagesWithUserInfoEndpointResponseResultItemsItemUserInfoCareStateExportsFollowUpsAwaitingResponseItemResponseInstrumentFormDefinitionFieldsItemSuggestedSubmissionValuesItemTypeDefaultOne =
  "int";
export const fetchMessagesWithUserInfoEndpointResponseResultItemsItemUserInfoCareStateExportsFollowUpsAwaitingResponseItemResponseInstrumentFormDefinitionFieldsItemSuggestedSubmissionValuesItemTypeDefaultTwo =
  "simple_address";
export const fetchMessagesWithUserInfoEndpointResponseResultItemsItemUserInfoCareStateExportsFollowUpsAwaitingResponseItemResponseInstrumentFormDefinitionFieldsItemDefaultSubmissionTypeDefault =
  "string";
export const fetchMessagesWithUserInfoEndpointResponseResultItemsItemUserInfoCareStateExportsFollowUpsAwaitingResponseItemResponseInstrumentFormDefinitionFieldsItemDefaultSubmissionTypeDefaultOne =
  "int";
export const fetchMessagesWithUserInfoEndpointResponseResultItemsItemUserInfoCareStateExportsFollowUpsAwaitingResponseItemResponseInstrumentFormDefinitionFieldsItemDefaultSubmissionTypeDefaultTwo =
  "simple_address";
export const fetchMessagesWithUserInfoEndpointResponseResultItemsItemUserInfoCareStateExportsFollowUpsAwaitingResponseItemResponseInstrumentFormDefinitionFieldsItemDefaultSubmissionTypeDefaultThree =
  "list";
export const fetchMessagesWithUserInfoEndpointResponseResultItemsItemUserInfoCareStateExportsFollowUpsAwaitingResponseItemResponseInstrumentFormDefinitionFieldsItemDefaultSubmissionValuesItemTypeDefault =
  "string";
export const fetchMessagesWithUserInfoEndpointResponseResultItemsItemUserInfoCareStateExportsFollowUpsAwaitingResponseItemResponseInstrumentFormDefinitionFieldsItemDefaultSubmissionValuesItemTypeDefaultOne =
  "int";
export const fetchMessagesWithUserInfoEndpointResponseResultItemsItemUserInfoCareStateExportsFollowUpsAwaitingResponseItemResponseInstrumentFormDefinitionFieldsItemDefaultSubmissionValuesItemTypeDefaultTwo =
  "simple_address";
export const fetchMessagesWithUserInfoEndpointResponseResultItemsItemUserInfoCareStateExportsFollowUpsAwaitingResponseItemResponseInstrumentFormDefinitionFieldsItemValidatorTypeDefault =
  "non_empty_string";
export const fetchMessagesWithUserInfoEndpointResponseResultItemsItemUserInfoCareStateExportsFollowUpsAwaitingResponseItemResponseInstrumentFormDefinitionFieldsItemValidatorTypeDefaultOne =
  "date";
export const fetchMessagesWithUserInfoEndpointResponseResultItemsItemUserInfoCareStateExportsFollowUpsAwaitingResponseItemResponseInstrumentFormDefinitionFieldsItemValidatorTypeDefaultTwo =
  "coded_choice";
export const fetchMessagesWithUserInfoEndpointResponseResultItemsItemUserInfoCareStateExportsFollowUpsAwaitingResponseItemResponseInstrumentFormDefinitionFieldsItemValidatorTypeDefaultThree =
  "phone_number";
export const fetchMessagesWithUserInfoEndpointResponseResultItemsItemUserInfoCareStateExportsFollowUpsAwaitingResponseItemResponseInstrumentFormDefinitionFieldsItemValidatorTypeDefaultFour =
  "email";
export const fetchMessagesWithUserInfoEndpointResponseResultItemsItemUserInfoCareStateExportsFollowUpsAwaitingResponseItemResponseInstrumentFormDefinitionFieldsItemValidatorTypeDefaultFive =
  "city_state_zip";
export const fetchMessagesWithUserInfoEndpointResponseResultItemsItemUserInfoCareStateExportsFollowUpsAwaitingResponseItemResponseInstrumentFormDefinitionFieldsItemValidatorTypeDefaultSix =
  "optional";
export const fetchMessagesWithUserInfoEndpointResponseResultItemsItemUserInfoCareStateExportsFollowUpsAwaitingResponseItemResponseInstrumentFormDefinitionFieldsItemValidatorRawValidatorTypeDefault =
  "non_empty_string";
export const fetchMessagesWithUserInfoEndpointResponseResultItemsItemUserInfoCareStateExportsFollowUpsAwaitingResponseItemResponseInstrumentFormDefinitionFieldsItemValidatorRawValidatorTypeDefaultOne =
  "date";
export const fetchMessagesWithUserInfoEndpointResponseResultItemsItemUserInfoCareStateExportsFollowUpsAwaitingResponseItemResponseInstrumentFormDefinitionFieldsItemValidatorRawValidatorTypeDefaultTwo =
  "coded_choice";
export const fetchMessagesWithUserInfoEndpointResponseResultItemsItemUserInfoCareStateExportsFollowUpsAwaitingResponseItemResponseInstrumentFormDefinitionFieldsItemValidatorRawValidatorTypeDefaultThree =
  "phone_number";
export const fetchMessagesWithUserInfoEndpointResponseResultItemsItemUserInfoCareStateExportsFollowUpsAwaitingResponseItemResponseInstrumentFormDefinitionFieldsItemValidatorRawValidatorTypeDefaultFour =
  "email";
export const fetchMessagesWithUserInfoEndpointResponseResultItemsItemUserInfoCareStateExportsFollowUpsAwaitingResponseItemResponseInstrumentFormDefinitionFieldsItemValidatorRawValidatorTypeDefaultFive =
  "city_state_zip";
export const fetchMessagesWithUserInfoEndpointResponseResultItemsItemUserInfoCareStateExportsFollowUpsAwaitingResponseItemResponseInstrumentFormDefinitionFieldsItemValidatorRawValidatorTypeDefaultSix =
  "list";
export const fetchMessagesWithUserInfoEndpointResponseResultItemsItemUserInfoCareStateExportsFollowUpsAwaitingResponseItemResponseInstrumentFormDefinitionFieldsItemValidatorRawValidatorRawValidatorTypeDefault =
  "non_empty_string";
export const fetchMessagesWithUserInfoEndpointResponseResultItemsItemUserInfoCareStateExportsFollowUpsAwaitingResponseItemResponseInstrumentFormDefinitionFieldsItemValidatorRawValidatorRawValidatorTypeDefaultOne =
  "date";
export const fetchMessagesWithUserInfoEndpointResponseResultItemsItemUserInfoCareStateExportsFollowUpsAwaitingResponseItemResponseInstrumentFormDefinitionFieldsItemValidatorRawValidatorRawValidatorTypeDefaultTwo =
  "coded_choice";
export const fetchMessagesWithUserInfoEndpointResponseResultItemsItemUserInfoCareStateExportsFollowUpsAwaitingResponseItemResponseInstrumentFormDefinitionFieldsItemValidatorRawValidatorRawValidatorTypeDefaultThree =
  "phone_number";
export const fetchMessagesWithUserInfoEndpointResponseResultItemsItemUserInfoCareStateExportsFollowUpsAwaitingResponseItemResponseInstrumentFormDefinitionFieldsItemValidatorRawValidatorRawValidatorTypeDefaultFour =
  "email";
export const fetchMessagesWithUserInfoEndpointResponseResultItemsItemUserInfoCareStateExportsFollowUpsAwaitingResponseItemResponseInstrumentFormDefinitionFieldsItemValidatorRawValidatorRawValidatorTypeDefaultFive =
  "city_state_zip";
export const fetchMessagesWithUserInfoEndpointResponseResultItemsItemUserInfoCareStateExportsFollowUpsAwaitingResponseItemResponseInstrumentFormDefinitionFieldsItemValidatorTypeDefaultSeven =
  "list";
export const fetchMessagesWithUserInfoEndpointResponseResultItemsItemUserInfoCareStateExportsFollowUpsAwaitingResponseItemResponseInstrumentFormDefinitionFieldsItemValidatorRawValidatorTypeDefaultSeven =
  "non_empty_string";
export const fetchMessagesWithUserInfoEndpointResponseResultItemsItemUserInfoCareStateExportsFollowUpsAwaitingResponseItemResponseInstrumentFormDefinitionFieldsItemValidatorRawValidatorTypeDefaultEight =
  "date";
export const fetchMessagesWithUserInfoEndpointResponseResultItemsItemUserInfoCareStateExportsFollowUpsAwaitingResponseItemResponseInstrumentFormDefinitionFieldsItemValidatorRawValidatorTypeDefaultNine =
  "coded_choice";
export const fetchMessagesWithUserInfoEndpointResponseResultItemsItemUserInfoCareStateExportsFollowUpsAwaitingResponseItemResponseInstrumentFormDefinitionFieldsItemValidatorRawValidatorTypeDefaultOnezero =
  "phone_number";
export const fetchMessagesWithUserInfoEndpointResponseResultItemsItemUserInfoCareStateExportsFollowUpsAwaitingResponseItemResponseInstrumentFormDefinitionFieldsItemValidatorRawValidatorTypeDefaultOneone =
  "email";
export const fetchMessagesWithUserInfoEndpointResponseResultItemsItemUserInfoCareStateExportsFollowUpsAwaitingResponseItemResponseInstrumentFormDefinitionFieldsItemValidatorRawValidatorTypeDefaultOnetwo =
  "city_state_zip";
export const fetchMessagesWithUserInfoEndpointResponseResultItemsItemUserInfoCareStateExportsFollowUpsAwaitingResponseItemResponseInstrumentFormDefinitionFieldsItemValidatorRawValidatorTypeDefaultOnethree =
  "optional";
export const fetchMessagesWithUserInfoEndpointResponseResultItemsItemUserInfoCareStateExportsFollowUpsAwaitingResponseItemResponseInstrumentFormDefinitionFieldsItemValidatorRawValidatorRawValidatorTypeDefaultSix =
  "non_empty_string";
export const fetchMessagesWithUserInfoEndpointResponseResultItemsItemUserInfoCareStateExportsFollowUpsAwaitingResponseItemResponseInstrumentFormDefinitionFieldsItemValidatorRawValidatorRawValidatorTypeDefaultSeven =
  "date";
export const fetchMessagesWithUserInfoEndpointResponseResultItemsItemUserInfoCareStateExportsFollowUpsAwaitingResponseItemResponseInstrumentFormDefinitionFieldsItemValidatorRawValidatorRawValidatorTypeDefaultEight =
  "coded_choice";
export const fetchMessagesWithUserInfoEndpointResponseResultItemsItemUserInfoCareStateExportsFollowUpsAwaitingResponseItemResponseInstrumentFormDefinitionFieldsItemValidatorRawValidatorRawValidatorTypeDefaultNine =
  "phone_number";
export const fetchMessagesWithUserInfoEndpointResponseResultItemsItemUserInfoCareStateExportsFollowUpsAwaitingResponseItemResponseInstrumentFormDefinitionFieldsItemValidatorRawValidatorRawValidatorTypeDefaultOnezero =
  "email";
export const fetchMessagesWithUserInfoEndpointResponseResultItemsItemUserInfoCareStateExportsFollowUpsAwaitingResponseItemResponseInstrumentFormDefinitionFieldsItemValidatorRawValidatorRawValidatorTypeDefaultOneone =
  "city_state_zip";
export const fetchMessagesWithUserInfoEndpointResponseResultItemsItemUserInfoCareStateExportsFollowUpsAwaitingResponseItemResponseInstrumentSubmissionsSubmissionsTypeDefault =
  "string";
export const fetchMessagesWithUserInfoEndpointResponseResultItemsItemUserInfoCareStateExportsFollowUpsAwaitingResponseItemResponseInstrumentSubmissionsSubmissionsTypeDefaultOne =
  "int";
export const fetchMessagesWithUserInfoEndpointResponseResultItemsItemUserInfoCareStateExportsFollowUpsAwaitingResponseItemResponseInstrumentSubmissionsSubmissionsTypeDefaultTwo =
  "simple_address";
export const fetchMessagesWithUserInfoEndpointResponseResultItemsItemUserInfoCareStateExportsFollowUpsAwaitingResponseItemResponseInstrumentSubmissionsSubmissionsTypeDefaultThree =
  "list";
export const fetchMessagesWithUserInfoEndpointResponseResultItemsItemUserInfoCareStateExportsFollowUpsAwaitingResponseItemResponseInstrumentSubmissionsSubmissionsValuesItemTypeDefault =
  "string";
export const fetchMessagesWithUserInfoEndpointResponseResultItemsItemUserInfoCareStateExportsFollowUpsAwaitingResponseItemResponseInstrumentSubmissionsSubmissionsValuesItemTypeDefaultOne =
  "int";
export const fetchMessagesWithUserInfoEndpointResponseResultItemsItemUserInfoCareStateExportsFollowUpsAwaitingResponseItemResponseInstrumentSubmissionsSubmissionsValuesItemTypeDefaultTwo =
  "simple_address";

export const fetchMessagesWithUserInfoEndpointResponse = zod.object({
  result: zod.object({
    items: zod.array(
      zod.object({
        conversation_message: zod.object({
          id: zod.uuid(),
          createdAt: zod.iso.datetime({}),
          sender: zod.enum(["Lotus", "Debug", "User", "Clinician"]),
          status: zod.enum(["committed", "staged"]).optional(),
          contentBlocks: zod.array(
            zod.object({
              id: zod.uuid(),
              body: zod.union([
                zod.union([
                  zod.object({
                    type: zod
                      .literal("text")
                      .default(
                        fetchMessagesWithUserInfoEndpointResponseResultItemsItemConversationMessageContentBlocksItemBodyTypeDefault,
                      ),
                    stream: zod.enum(["Chat", "Thinking"]).optional(),
                    text: zod.string(),
                  }),
                  zod.object({
                    type: zod
                      .literal("choiceChip")
                      .default(
                        fetchMessagesWithUserInfoEndpointResponseResultItemsItemConversationMessageContentBlocksItemBodyTypeDefaultOne,
                      ),
                    text: zod.string(),
                  }),
                  zod.object({
                    type: zod
                      .literal("error")
                      .default(
                        fetchMessagesWithUserInfoEndpointResponseResultItemsItemConversationMessageContentBlocksItemBodyTypeDefaultTwo,
                      ),
                    text: zod.string(),
                  }),
                  zod.object({
                    type: zod
                      .literal("chart")
                      .default(
                        fetchMessagesWithUserInfoEndpointResponseResultItemsItemConversationMessageContentBlocksItemBodyTypeDefaultThree,
                      ),
                    chartData: zod.record(zod.string(), zod.unknown()),
                  }),
                  zod.object({
                    type: zod
                      .literal("toolUse")
                      .default(
                        fetchMessagesWithUserInfoEndpointResponseResultItemsItemConversationMessageContentBlocksItemBodyTypeDefaultFour,
                      ),
                    text: zod.string(),
                  }),
                  zod.object({
                    type: zod
                      .literal("article")
                      .default(
                        fetchMessagesWithUserInfoEndpointResponseResultItemsItemConversationMessageContentBlocksItemBodyTypeDefaultFive,
                      ),
                    articleData: zod.object({
                      title: zod.string(),
                      citation: zod.string(),
                      abstract: zod.string(),
                      published_date: zod.iso.datetime({}),
                      pmcid: zod.string(),
                      pmid: zod.string(),
                      chunks: zod.array(zod.string()),
                      citation_data: zod.object({
                        pmcid: zod.string(),
                        title: zod.string(),
                        authors: zod.array(
                          zod.object({
                            surname: zod
                              .union([zod.string(), zod.null()])
                              .optional(),
                            given_names: zod
                              .union([zod.string(), zod.null()])
                              .optional(),
                            full_name: zod
                              .union([zod.string(), zod.null()])
                              .optional(),
                          }),
                        ),
                        author_string: zod.string(),
                        journal: zod.string(),
                        pub_date: zod.string(),
                        volume: zod
                          .union([zod.string(), zod.null()])
                          .optional(),
                        issue: zod.union([zod.string(), zod.null()]).optional(),
                        pages: zod.union([zod.string(), zod.null()]).optional(),
                        doi: zod.union([zod.string(), zod.null()]).optional(),
                        issn: zod.union([zod.string(), zod.null()]).optional(),
                        pubmed_link: zod
                          .union([zod.string(), zod.null()])
                          .optional(),
                        formatted: zod.object({
                          apa: zod.string(),
                          mla: zod.string(),
                          vancouver: zod.string(),
                        }),
                      }),
                    }),
                  }),
                  zod.object({
                    type: zod
                      .literal("sources_v2")
                      .default(
                        fetchMessagesWithUserInfoEndpointResponseResultItemsItemConversationMessageContentBlocksItemBodyTypeDefaultSix,
                      ),
                    sources: zod.array(
                      zod.object({
                        title: zod.string(),
                        subtitle: zod.string(),
                        content: zod.union([
                          zod.object({
                            type: zod
                              .literal("table")
                              .default(
                                fetchMessagesWithUserInfoEndpointResponseResultItemsItemConversationMessageContentBlocksItemBodySourcesItemContentTypeDefault,
                              ),
                            rows: zod.array(
                              zod.record(zod.string(), zod.unknown()),
                            ),
                            columns: zod.array(zod.string()),
                            note: zod.string(),
                            column_schema: zod
                              .record(
                                zod.string(),
                                zod.enum([
                                  "string",
                                  "integer",
                                  "float",
                                  "boolean",
                                  "datetime",
                                ]),
                              )
                              .default(
                                fetchMessagesWithUserInfoEndpointResponseResultItemsItemConversationMessageContentBlocksItemBodySourcesItemContentColumnSchemaDefault,
                              ),
                          }),
                          zod.object({
                            type: zod
                              .literal("link")
                              .default(
                                fetchMessagesWithUserInfoEndpointResponseResultItemsItemConversationMessageContentBlocksItemBodySourcesItemContentTypeDefaultOne,
                              ),
                            link: zod.string(),
                          }),
                        ]),
                        icon: zod
                          .union([
                            zod
                              .string()
                              .describe(
                                "An icon identifier - opaque to the client.",
                              ),
                            zod.null(),
                          ])
                          .optional(),
                      }),
                    ),
                  }),
                  zod.object({
                    type: zod
                      .literal("pendingReview")
                      .default(
                        fetchMessagesWithUserInfoEndpointResponseResultItemsItemConversationMessageContentBlocksItemBodyTypeDefaultSeven,
                      ),
                  }),
                  zod.object({
                    type: zod
                      .literal("chainOfThought")
                      .default(
                        fetchMessagesWithUserInfoEndpointResponseResultItemsItemConversationMessageContentBlocksItemBodyTypeDefaultEight,
                      ),
                    text: zod.string(),
                  }),
                  zod.object({
                    type: zod
                      .literal("revised")
                      .default(
                        fetchMessagesWithUserInfoEndpointResponseResultItemsItemConversationMessageContentBlocksItemBodyTypeDefaultNine,
                      ),
                    text: zod.string(),
                  }),
                  zod.object({
                    type: zod
                      .literal("origin")
                      .default(
                        fetchMessagesWithUserInfoEndpointResponseResultItemsItemConversationMessageContentBlocksItemBodyTypeDefaultOnezero,
                      ),
                    origin: zod.union([zod.enum(["insight"]), zod.unknown()]),
                  }),
                  zod.object({
                    type: zod
                      .literal("stagingStatus")
                      .default(
                        fetchMessagesWithUserInfoEndpointResponseResultItemsItemConversationMessageContentBlocksItemBodyTypeDefaultOneone,
                      ),
                    status: zod.enum(["committed", "staged"]),
                  }),
                  zod.object({
                    type: zod
                      .literal("completeStatus")
                      .default(
                        fetchMessagesWithUserInfoEndpointResponseResultItemsItemConversationMessageContentBlocksItemBodyTypeDefaultOnetwo,
                      ),
                    status: zod.enum(["incomplete", "complete"]),
                  }),
                  zod.object({
                    type: zod
                      .literal("retryStatus")
                      .default(
                        fetchMessagesWithUserInfoEndpointResponseResultItemsItemConversationMessageContentBlocksItemBodyTypeDefaultOnethree,
                      ),
                    status: zod.enum(["retry", "handled"]),
                    error: zod
                      .union([
                        zod.object({
                          message: zod.string(),
                          trace: zod.string(),
                          code: zod
                            .union([zod.string(), zod.null()])
                            .optional(),
                          payload: zod
                            .union([
                              zod.record(zod.string(), zod.unknown()),
                              zod.null(),
                            ])
                            .optional(),
                          status_code: zod
                            .union([zod.number(), zod.null()])
                            .optional(),
                        }),
                        zod.null(),
                      ])
                      .optional(),
                  }),
                  zod.object({
                    type: zod
                      .literal("assessmentResult")
                      .default(
                        fetchMessagesWithUserInfoEndpointResponseResultItemsItemConversationMessageContentBlocksItemBodyTypeDefaultOnefour,
                      ),
                    assessmentResult: zod.unknown(),
                  }),
                  zod.object({
                    type: zod
                      .literal("voiceMessageMarker")
                      .default(
                        fetchMessagesWithUserInfoEndpointResponseResultItemsItemConversationMessageContentBlocksItemBodyTypeDefaultOnefive,
                      ),
                    obscured: zod.boolean(),
                  }),
                  zod
                    .object({
                      type: zod
                        .literal("voiceUpload")
                        .default(
                          fetchMessagesWithUserInfoEndpointResponseResultItemsItemConversationMessageContentBlocksItemBodyTypeDefaultOnesix,
                        ),
                      uploadId: zod.uuid(),
                    })
                    .describe(
                      "Reference to a confirmed voice upload associated with the message.\nThis is provenance metadata, not semantic message content.",
                    ),
                  zod.object({
                    type: zod
                      .literal("debug")
                      .default(
                        fetchMessagesWithUserInfoEndpointResponseResultItemsItemConversationMessageContentBlocksItemBodyTypeDefaultOneseven,
                      ),
                    title: zod.string(),
                    content: zod.string(),
                  }),
                  zod.object({
                    type: zod
                      .literal("blank")
                      .default(
                        fetchMessagesWithUserInfoEndpointResponseResultItemsItemConversationMessageContentBlocksItemBodyTypeDefaultOneeight,
                      ),
                  }),
                  zod.object({
                    type: zod
                      .literal("answerPartSuggestion")
                      .default(
                        fetchMessagesWithUserInfoEndpointResponseResultItemsItemConversationMessageContentBlocksItemBodyTypeDefaultOnenine,
                      ),
                    answerPart: zod.union([
                      zod
                        .object({
                          answer_part_type: zod
                            .literal("revise_message")
                            .default(
                              fetchMessagesWithUserInfoEndpointResponseResultItemsItemConversationMessageContentBlocksItemBodyAnswerPartAnswerPartTypeDefault,
                            ),
                          message_id: zod.uuid(),
                          response: zod.enum(["accept", "revise"]),
                          new_response: zod.string(),
                          explanation: zod
                            .union([zod.string(), zod.null()])
                            .optional(),
                          send_to_patient: zod
                            .boolean()
                            .default(
                              fetchMessagesWithUserInfoEndpointResponseResultItemsItemConversationMessageContentBlocksItemBodyAnswerPartSendToPatientDefault,
                            ),
                        })
                        .describe(
                          "This is a response to a ReviseMessageAnswerPartRequestT. It stores the clinician's judgement on the message.",
                        ),
                      zod
                        .object({
                          answer_part_type: zod
                            .literal("note")
                            .default(
                              fetchMessagesWithUserInfoEndpointResponseResultItemsItemConversationMessageContentBlocksItemBodyAnswerPartAnswerPartTypeDefaultOne,
                            ),
                          patient_id: zod.uuid(),
                          note: zod.string(),
                        })
                        .describe(
                          "This is a response to a NoteAnswerPartRequestT. It is a note that will be entered into the EHR system.",
                        ),
                      zod
                        .object({
                          answer_part_type: zod
                            .literal("rejected")
                            .default(
                              fetchMessagesWithUserInfoEndpointResponseResultItemsItemConversationMessageContentBlocksItemBodyAnswerPartAnswerPartTypeDefaultTwo,
                            ),
                          reason: zod
                            .union([zod.string(), zod.null()])
                            .optional()
                            .describe("Optional reason for rejection"),
                        })
                        .describe(
                          "This is a response to a RejectedAnswerPartRequestT. It indicates the clinician is rejecting the entire request.",
                        ),
                      zod
                        .object({
                          answer_part_type: zod
                            .literal("prescription")
                            .default(
                              fetchMessagesWithUserInfoEndpointResponseResultItemsItemConversationMessageContentBlocksItemBodyAnswerPartAnswerPartTypeDefaultThree,
                            ),
                          patient_id: zod.uuid(),
                          dosespot_prescription_id: zod.string(),
                        })
                        .describe(
                          "This is a response to a PrescriptionAnswerPartRequestT. It stores a prescription ID that will be sent to pharmacy.",
                        ),
                      zod
                        .object({
                          answer_part_type: zod
                            .literal("prescription_suggestion")
                            .default(
                              fetchMessagesWithUserInfoEndpointResponseResultItemsItemConversationMessageContentBlocksItemBodyAnswerPartAnswerPartTypeDefaultFour,
                            ),
                          dispensable_drug_id: zod
                            .union([zod.number(), zod.null()])
                            .optional()
                            .describe(
                              "DoseSpot DispensableDrugId for the medication",
                            ),
                          pharmacy_id: zod
                            .union([zod.number(), zod.null()])
                            .optional()
                            .describe("DoseSpot PharmacyId for the pharmacy"),
                          directions: zod
                            .union([zod.string(), zod.null()])
                            .optional()
                            .describe("Suggested directions for use"),
                          quantity: zod
                            .union([zod.number(), zod.null()])
                            .optional()
                            .describe("Suggested quantity"),
                          refills: zod
                            .union([zod.number(), zod.null()])
                            .optional()
                            .describe("Suggested number of refills"),
                          notes: zod
                            .union([zod.string(), zod.null()])
                            .optional()
                            .describe(
                              "Additional notes about the prescription",
                            ),
                        })
                        .describe(
                          "Suggested prescription data that can be used to prepopulate a prescription form.",
                        ),
                    ]),
                  }),
                  zod
                    .object({
                      type: zod
                        .literal("fileAttachment")
                        .default(
                          fetchMessagesWithUserInfoEndpointResponseResultItemsItemConversationMessageContentBlocksItemBodyTypeDefaultTwozero,
                        ),
                      attachmentId: zod.uuid(),
                      filename: zod
                        .union([zod.string(), zod.null()])
                        .optional(),
                      mimeType: zod
                        .union([zod.string(), zod.null()])
                        .optional(),
                      fileType: zod
                        .union([
                          zod
                            .enum(["image", "document", "audio"])
                            .describe("Type of file attachment."),
                          zod.null(),
                        ])
                        .optional(),
                    })
                    .describe(
                      "Reference to an uploaded file (image or PDF).\nAll metadata is stored in the database and fetched when needed.",
                    ),
                  zod.object({
                    type: zod
                      .literal("actionChip")
                      .default(
                        fetchMessagesWithUserInfoEndpointResponseResultItemsItemConversationMessageContentBlocksItemBodyTypeDefaultTwoone,
                      ),
                    label: zod.string(),
                    action: zod.string(),
                  }),
                  zod
                    .object({
                      type: zod
                        .literal("mention")
                        .default(
                          fetchMessagesWithUserInfoEndpointResponseResultItemsItemConversationMessageContentBlocksItemBodyTypeDefaultTwotwo,
                        ),
                      sourceUrl: zod.string(),
                    })
                    .describe(
                      "Reference to a durable, resolver-backed snapshot (`LiveSource`).\n\nMentions are not rendered on the client at all -- they exist purely so the\nagent can read the underlying snapshot as a prompt fragment. Clients\nshould hide these blocks from the user-facing message view.\n\n`source_url` is a `lotus-kb:\/\/live-sources\/users\/{user_id}\/...` URL minted\nby the LiveSource promotion endpoint. The URL is owner-scoped: the\nvalidation layer drops the block if the URL is not a LiveSource URL\nowned by the calling user, so users cannot fabricate authoritative-looking\nmentions or smuggle in another user's snapshot.\n\nThe url is resolvable by the Lotus URL resolver, so the agent can cite\nit directly and the snapshot persists indefinitely (not bound to a\nRedis TTL).",
                    ),
                  zod
                    .object({
                      type: zod
                        .literal("directive")
                        .default(
                          fetchMessagesWithUserInfoEndpointResponseResultItemsItemConversationMessageContentBlocksItemBodyTypeDefaultTwothree,
                        ),
                      directive: zod.string(),
                    })
                    .describe(
                      "The directive a Lotus message was written to answer.\n\nThe patient never sees it; Lotus sees it as part of the message wherever\nthe message appears in its history.",
                    ),
                ]),
                zod.unknown(),
              ]),
              createdAt: zod.iso.datetime({}).optional(),
            }),
          ),
          completionState: zod.enum(["incomplete", "complete"]).optional(),
        }),
        conversation_id: zod.uuid(),
        user_info: zod
          .object({
            user_id: zod.uuid(),
            created_at: zod
              .union([zod.iso.datetime({}), zod.null()])
              .optional(),
            basic_info: zod
              .union([
                zod.object({
                  name: zod
                    .array(zod.string())
                    .default(
                      fetchMessagesWithUserInfoEndpointResponseResultItemsItemUserInfoBasicInfoNameDefault,
                    ),
                  email: zod
                    .array(zod.string())
                    .default(
                      fetchMessagesWithUserInfoEndpointResponseResultItemsItemUserInfoBasicInfoEmailDefault,
                    ),
                  phone: zod
                    .array(zod.string())
                    .default(
                      fetchMessagesWithUserInfoEndpointResponseResultItemsItemUserInfoBasicInfoPhoneDefault,
                    ),
                  address: zod
                    .array(zod.string())
                    .default(
                      fetchMessagesWithUserInfoEndpointResponseResultItemsItemUserInfoBasicInfoAddressDefault,
                    ),
                  date_of_birth: zod
                    .array(zod.iso.date())
                    .default(
                      fetchMessagesWithUserInfoEndpointResponseResultItemsItemUserInfoBasicInfoDateOfBirthDefault,
                    ),
                }),
                zod.null(),
              ])
              .optional(),
            name: zod
              .union([
                zod.object({
                  legal_first_name: zod
                    .union([zod.string(), zod.null()])
                    .optional(),
                  first_name: zod.union([zod.string(), zod.null()]).optional(),
                  last_name: zod.union([zod.string(), zod.null()]).optional(),
                  pronouns: zod.union([zod.string(), zod.null()]).optional(),
                }),
                zod.null(),
              ])
              .optional(),
            display_name: zod.union([zod.string(), zod.null()]).optional(),
            is_anonymous: zod.union([zod.boolean(), zod.null()]).optional(),
            is_new_user: zod.union([zod.boolean(), zod.null()]).optional(),
            is_deleted: zod.union([zod.boolean(), zod.null()]).optional(),
            login_phone_number: zod
              .union([zod.string(), zod.null()])
              .optional(),
            breadcrumbs: zod
              .union([zod.record(zod.string(), zod.unknown()), zod.null()])
              .optional(),
            gating_group: zod
              .union([
                zod.enum(["banned", "limited_access", "full_access"]),
                zod.null(),
              ])
              .optional(),
            groups: zod
              .union([
                zod.array(
                  zod.enum([
                    "lotus_admin",
                    "lotus_developer",
                    "lotus_test_user",
                    "doctor",
                    "practitioners",
                    "evaluator_bot",
                    "banned",
                    "any_user",
                    "anonymous_user",
                    "partially_gated_user",
                    "limited_access_user",
                    "app_reviewer",
                    "full_access_user",
                    "invite_loop_group_1",
                    "invite_loop_group_2",
                    "invite_loop_group_3",
                    "skip_service_area_check",
                  ]),
                ),
                zod.null(),
              ])
              .optional(),
            pulse_buffer_status: zod
              .union([
                zod
                  .object({
                    bufferCount: zod.number(),
                    targetSize: zod.number(),
                    replenishThreshold: zod.number(),
                    needsReplenishment: zod.boolean(),
                  })
                  .describe("Status of the pulse buffer for a user."),
                zod.null(),
              ])
              .optional(),
            sync_in_progress: zod.union([zod.boolean(), zod.null()]).optional(),
            care_state_exports: zod
              .union([
                zod.object({
                  urgent_requests: zod.number(),
                  routine_requests: zod.number(),
                  unread_items: zod.number(),
                  actionable: zod.boolean(),
                  actionable_items: zod.union([
                    zod.object({
                      bag: zod.array(
                        zod.object({
                          item: zod.object({
                            type: zod.enum([
                              "urgent_request",
                              "routine_request",
                              "urgent_suggestion",
                              "routine_suggestion",
                              "unread_follow_up",
                            ]),
                            tags: zod
                              .object({
                                us_states: zod
                                  .array(zod.string())
                                  .default(
                                    fetchMessagesWithUserInfoEndpointResponseResultItemsItemUserInfoCareStateExportsActionableItemsBagItemItemTagsUsStatesDefault,
                                  ),
                                practice_areas: zod
                                  .array(
                                    zod.enum(["Primary Care", "Psychiatry"]),
                                  )
                                  .default(
                                    fetchMessagesWithUserInfoEndpointResponseResultItemsItemUserInfoCareStateExportsActionableItemsBagItemItemTagsPracticeAreasDefault,
                                  ),
                                origin_practices: zod
                                  .array(zod.string())
                                  .default(
                                    fetchMessagesWithUserInfoEndpointResponseResultItemsItemUserInfoCareStateExportsActionableItemsBagItemItemTagsOriginPracticesDefault,
                                  ),
                              })
                              .describe(
                                "Fully typed tag set — each routing dimension is an explicit field.",
                              ),
                          }),
                          count: zod.number(),
                        }),
                      ),
                    }),
                    zod.null(),
                  ]),
                  earliest_request_created_at: zod.union([
                    zod.iso.datetime({}),
                    zod.null(),
                  ]),
                  last_request_created_at: zod.union([
                    zod.iso.datetime({}),
                    zod.null(),
                  ]),
                  follow_ups_awaiting_response: zod.array(
                    zod.object({
                      id: zod.uuid(),
                      originating_action_id: zod
                        .union([zod.uuid(), zod.null()])
                        .optional(),
                      link: zod.union([
                        zod.object({
                          type: zod
                            .literal("patient")
                            .default(
                              fetchMessagesWithUserInfoEndpointResponseResultItemsItemUserInfoCareStateExportsFollowUpsAwaitingResponseItemLinkTypeDefault,
                            ),
                        }),
                        zod.object({
                          type: zod
                            .literal("problem")
                            .default(
                              fetchMessagesWithUserInfoEndpointResponseResultItemsItemUserInfoCareStateExportsFollowUpsAwaitingResponseItemLinkTypeDefaultOne,
                            ),
                          id: zod.uuid(),
                        }),
                        zod.object({
                          type: zod
                            .literal("request")
                            .default(
                              fetchMessagesWithUserInfoEndpointResponseResultItemsItemUserInfoCareStateExportsFollowUpsAwaitingResponseItemLinkTypeDefaultTwo,
                            ),
                          id: zod.uuid(),
                        }),
                        zod.object({
                          type: zod
                            .literal("orphan")
                            .default(
                              fetchMessagesWithUserInfoEndpointResponseResultItemsItemUserInfoCareStateExportsFollowUpsAwaitingResponseItemLinkTypeDefaultThree,
                            ),
                        }),
                      ]),
                      title: zod.string(),
                      status: zod
                        .enum([
                          "Pending",
                          "Awaiting Response from Patient",
                          "Response Received from Patient",
                        ])
                        .optional(),
                      unread: zod.boolean().optional(),
                      transmission_link: zod
                        .union([
                          zod.union([
                            zod.object({
                              type: zod
                                .literal("chat_message")
                                .default(
                                  fetchMessagesWithUserInfoEndpointResponseResultItemsItemUserInfoCareStateExportsFollowUpsAwaitingResponseItemTransmissionLinkTypeDefault,
                                ),
                              conversation_id: zod.uuid(),
                              message_id: zod.uuid(),
                            }),
                            zod.object({
                              type: zod
                                .literal("chat_conversation")
                                .default(
                                  fetchMessagesWithUserInfoEndpointResponseResultItemsItemUserInfoCareStateExportsFollowUpsAwaitingResponseItemTransmissionLinkTypeDefaultOne,
                                ),
                              conversation_id: zod.uuid(),
                            }),
                          ]),
                          zod.null(),
                        ])
                        .optional(),
                      acknowledgement_link: zod
                        .union([
                          zod.union([
                            zod.object({
                              type: zod
                                .literal("chat_message")
                                .default(
                                  fetchMessagesWithUserInfoEndpointResponseResultItemsItemUserInfoCareStateExportsFollowUpsAwaitingResponseItemAcknowledgementLinkTypeDefault,
                                ),
                              conversation_id: zod.uuid(),
                              message_id: zod.uuid(),
                            }),
                            zod.object({
                              type: zod
                                .literal("chat_conversation")
                                .default(
                                  fetchMessagesWithUserInfoEndpointResponseResultItemsItemUserInfoCareStateExportsFollowUpsAwaitingResponseItemAcknowledgementLinkTypeDefaultOne,
                                ),
                              conversation_id: zod.uuid(),
                            }),
                          ]),
                          zod.null(),
                        ])
                        .optional(),
                      content_to_transmit: zod.string(),
                      response_instrument: zod
                        .union([
                          zod
                            .object({
                              instrument_id: zod.string(),
                              form_definition: zod.object({
                                fields: zod.array(
                                  zod.object({
                                    id: zod.string(),
                                    profile: zod.object({
                                      name: zod.string(),
                                      description: zod
                                        .union([zod.string(), zod.null()])
                                        .optional(),
                                    }),
                                    suggested_submission: zod
                                      .union([
                                        zod.union([
                                          zod.object({
                                            type: zod
                                              .literal("string")
                                              .default(
                                                fetchMessagesWithUserInfoEndpointResponseResultItemsItemUserInfoCareStateExportsFollowUpsAwaitingResponseItemResponseInstrumentFormDefinitionFieldsItemSuggestedSubmissionTypeDefault,
                                              ),
                                            value: zod.string(),
                                          }),
                                          zod.object({
                                            type: zod
                                              .literal("int")
                                              .default(
                                                fetchMessagesWithUserInfoEndpointResponseResultItemsItemUserInfoCareStateExportsFollowUpsAwaitingResponseItemResponseInstrumentFormDefinitionFieldsItemSuggestedSubmissionTypeDefaultOne,
                                              ),
                                            value: zod.number(),
                                          }),
                                          zod.object({
                                            type: zod
                                              .literal("simple_address")
                                              .default(
                                                fetchMessagesWithUserInfoEndpointResponseResultItemsItemUserInfoCareStateExportsFollowUpsAwaitingResponseItemResponseInstrumentFormDefinitionFieldsItemSuggestedSubmissionTypeDefaultTwo,
                                              ),
                                            street_address: zod.string(),
                                            city_state_zip: zod.string(),
                                          }),
                                          zod.object({
                                            type: zod
                                              .literal("list")
                                              .default(
                                                fetchMessagesWithUserInfoEndpointResponseResultItemsItemUserInfoCareStateExportsFollowUpsAwaitingResponseItemResponseInstrumentFormDefinitionFieldsItemSuggestedSubmissionTypeDefaultThree,
                                              ),
                                            values: zod.array(
                                              zod.union([
                                                zod.object({
                                                  type: zod
                                                    .literal("string")
                                                    .default(
                                                      fetchMessagesWithUserInfoEndpointResponseResultItemsItemUserInfoCareStateExportsFollowUpsAwaitingResponseItemResponseInstrumentFormDefinitionFieldsItemSuggestedSubmissionValuesItemTypeDefault,
                                                    ),
                                                  value: zod.string(),
                                                }),
                                                zod.object({
                                                  type: zod
                                                    .literal("int")
                                                    .default(
                                                      fetchMessagesWithUserInfoEndpointResponseResultItemsItemUserInfoCareStateExportsFollowUpsAwaitingResponseItemResponseInstrumentFormDefinitionFieldsItemSuggestedSubmissionValuesItemTypeDefaultOne,
                                                    ),
                                                  value: zod.number(),
                                                }),
                                                zod.object({
                                                  type: zod
                                                    .literal("simple_address")
                                                    .default(
                                                      fetchMessagesWithUserInfoEndpointResponseResultItemsItemUserInfoCareStateExportsFollowUpsAwaitingResponseItemResponseInstrumentFormDefinitionFieldsItemSuggestedSubmissionValuesItemTypeDefaultTwo,
                                                    ),
                                                  street_address: zod.string(),
                                                  city_state_zip: zod.string(),
                                                }),
                                                zod.unknown(),
                                              ]),
                                            ),
                                          }),
                                        ]),
                                        zod.null(),
                                      ])
                                      .optional(),
                                    default_submission: zod
                                      .union([
                                        zod.union([
                                          zod.object({
                                            type: zod
                                              .literal("string")
                                              .default(
                                                fetchMessagesWithUserInfoEndpointResponseResultItemsItemUserInfoCareStateExportsFollowUpsAwaitingResponseItemResponseInstrumentFormDefinitionFieldsItemDefaultSubmissionTypeDefault,
                                              ),
                                            value: zod.string(),
                                          }),
                                          zod.object({
                                            type: zod
                                              .literal("int")
                                              .default(
                                                fetchMessagesWithUserInfoEndpointResponseResultItemsItemUserInfoCareStateExportsFollowUpsAwaitingResponseItemResponseInstrumentFormDefinitionFieldsItemDefaultSubmissionTypeDefaultOne,
                                              ),
                                            value: zod.number(),
                                          }),
                                          zod.object({
                                            type: zod
                                              .literal("simple_address")
                                              .default(
                                                fetchMessagesWithUserInfoEndpointResponseResultItemsItemUserInfoCareStateExportsFollowUpsAwaitingResponseItemResponseInstrumentFormDefinitionFieldsItemDefaultSubmissionTypeDefaultTwo,
                                              ),
                                            street_address: zod.string(),
                                            city_state_zip: zod.string(),
                                          }),
                                          zod.object({
                                            type: zod
                                              .literal("list")
                                              .default(
                                                fetchMessagesWithUserInfoEndpointResponseResultItemsItemUserInfoCareStateExportsFollowUpsAwaitingResponseItemResponseInstrumentFormDefinitionFieldsItemDefaultSubmissionTypeDefaultThree,
                                              ),
                                            values: zod.array(
                                              zod.union([
                                                zod.object({
                                                  type: zod
                                                    .literal("string")
                                                    .default(
                                                      fetchMessagesWithUserInfoEndpointResponseResultItemsItemUserInfoCareStateExportsFollowUpsAwaitingResponseItemResponseInstrumentFormDefinitionFieldsItemDefaultSubmissionValuesItemTypeDefault,
                                                    ),
                                                  value: zod.string(),
                                                }),
                                                zod.object({
                                                  type: zod
                                                    .literal("int")
                                                    .default(
                                                      fetchMessagesWithUserInfoEndpointResponseResultItemsItemUserInfoCareStateExportsFollowUpsAwaitingResponseItemResponseInstrumentFormDefinitionFieldsItemDefaultSubmissionValuesItemTypeDefaultOne,
                                                    ),
                                                  value: zod.number(),
                                                }),
                                                zod.object({
                                                  type: zod
                                                    .literal("simple_address")
                                                    .default(
                                                      fetchMessagesWithUserInfoEndpointResponseResultItemsItemUserInfoCareStateExportsFollowUpsAwaitingResponseItemResponseInstrumentFormDefinitionFieldsItemDefaultSubmissionValuesItemTypeDefaultTwo,
                                                    ),
                                                  street_address: zod.string(),
                                                  city_state_zip: zod.string(),
                                                }),
                                                zod.unknown(),
                                              ]),
                                            ),
                                          }),
                                        ]),
                                        zod.null(),
                                      ])
                                      .optional(),
                                    validator: zod.union([
                                      zod
                                        .object({
                                          type: zod
                                            .literal("non_empty_string")
                                            .default(
                                              fetchMessagesWithUserInfoEndpointResponseResultItemsItemUserInfoCareStateExportsFollowUpsAwaitingResponseItemResponseInstrumentFormDefinitionFieldsItemValidatorTypeDefault,
                                            ),
                                        })
                                        .describe(
                                          "Validator that accepts arbitrary non-empty strings.",
                                        ),
                                      zod
                                        .object({
                                          type: zod
                                            .literal("date")
                                            .default(
                                              fetchMessagesWithUserInfoEndpointResponseResultItemsItemUserInfoCareStateExportsFollowUpsAwaitingResponseItemResponseInstrumentFormDefinitionFieldsItemValidatorTypeDefaultOne,
                                            ),
                                        })
                                        .describe(
                                          "Validator that accepts arbitrary dates.",
                                        ),
                                      zod
                                        .object({
                                          type: zod
                                            .literal("coded_choice")
                                            .default(
                                              fetchMessagesWithUserInfoEndpointResponseResultItemsItemUserInfoCareStateExportsFollowUpsAwaitingResponseItemResponseInstrumentFormDefinitionFieldsItemValidatorTypeDefaultTwo,
                                            ),
                                          options: zod.array(
                                            zod
                                              .object({
                                                code: zod.string(),
                                                display: zod.string(),
                                              })
                                              .describe(
                                                "An option from a list of choices.",
                                              ),
                                          ),
                                        })
                                        .describe(
                                          "Validator that accepts any option from a list of choices.",
                                        ),
                                      zod
                                        .object({
                                          type: zod
                                            .literal("phone_number")
                                            .default(
                                              fetchMessagesWithUserInfoEndpointResponseResultItemsItemUserInfoCareStateExportsFollowUpsAwaitingResponseItemResponseInstrumentFormDefinitionFieldsItemValidatorTypeDefaultThree,
                                            ),
                                        })
                                        .describe(
                                          "Validator that accepts arbitrary phone numbers.",
                                        ),
                                      zod
                                        .object({
                                          type: zod
                                            .literal("email")
                                            .default(
                                              fetchMessagesWithUserInfoEndpointResponseResultItemsItemUserInfoCareStateExportsFollowUpsAwaitingResponseItemResponseInstrumentFormDefinitionFieldsItemValidatorTypeDefaultFour,
                                            ),
                                        })
                                        .describe(
                                          "Validator that accepts arbitrary emails.",
                                        ),
                                      zod
                                        .object({
                                          type: zod
                                            .literal("city_state_zip")
                                            .default(
                                              fetchMessagesWithUserInfoEndpointResponseResultItemsItemUserInfoCareStateExportsFollowUpsAwaitingResponseItemResponseInstrumentFormDefinitionFieldsItemValidatorTypeDefaultFive,
                                            ),
                                        })
                                        .describe(
                                          "Validator that accepts city, state, and ZIP code combinations.",
                                        ),
                                      zod
                                        .object({
                                          type: zod
                                            .literal("optional")
                                            .default(
                                              fetchMessagesWithUserInfoEndpointResponseResultItemsItemUserInfoCareStateExportsFollowUpsAwaitingResponseItemResponseInstrumentFormDefinitionFieldsItemValidatorTypeDefaultSix,
                                            ),
                                          raw_validator: zod.union([
                                            zod
                                              .object({
                                                type: zod
                                                  .literal("non_empty_string")
                                                  .default(
                                                    fetchMessagesWithUserInfoEndpointResponseResultItemsItemUserInfoCareStateExportsFollowUpsAwaitingResponseItemResponseInstrumentFormDefinitionFieldsItemValidatorRawValidatorTypeDefault,
                                                  ),
                                              })
                                              .describe(
                                                "Validator that accepts arbitrary non-empty strings.",
                                              ),
                                            zod
                                              .object({
                                                type: zod
                                                  .literal("date")
                                                  .default(
                                                    fetchMessagesWithUserInfoEndpointResponseResultItemsItemUserInfoCareStateExportsFollowUpsAwaitingResponseItemResponseInstrumentFormDefinitionFieldsItemValidatorRawValidatorTypeDefaultOne,
                                                  ),
                                              })
                                              .describe(
                                                "Validator that accepts arbitrary dates.",
                                              ),
                                            zod
                                              .object({
                                                type: zod
                                                  .literal("coded_choice")
                                                  .default(
                                                    fetchMessagesWithUserInfoEndpointResponseResultItemsItemUserInfoCareStateExportsFollowUpsAwaitingResponseItemResponseInstrumentFormDefinitionFieldsItemValidatorRawValidatorTypeDefaultTwo,
                                                  ),
                                                options: zod.array(
                                                  zod
                                                    .object({
                                                      code: zod.string(),
                                                      display: zod.string(),
                                                    })
                                                    .describe(
                                                      "An option from a list of choices.",
                                                    ),
                                                ),
                                              })
                                              .describe(
                                                "Validator that accepts any option from a list of choices.",
                                              ),
                                            zod
                                              .object({
                                                type: zod
                                                  .literal("phone_number")
                                                  .default(
                                                    fetchMessagesWithUserInfoEndpointResponseResultItemsItemUserInfoCareStateExportsFollowUpsAwaitingResponseItemResponseInstrumentFormDefinitionFieldsItemValidatorRawValidatorTypeDefaultThree,
                                                  ),
                                              })
                                              .describe(
                                                "Validator that accepts arbitrary phone numbers.",
                                              ),
                                            zod
                                              .object({
                                                type: zod
                                                  .literal("email")
                                                  .default(
                                                    fetchMessagesWithUserInfoEndpointResponseResultItemsItemUserInfoCareStateExportsFollowUpsAwaitingResponseItemResponseInstrumentFormDefinitionFieldsItemValidatorRawValidatorTypeDefaultFour,
                                                  ),
                                              })
                                              .describe(
                                                "Validator that accepts arbitrary emails.",
                                              ),
                                            zod
                                              .object({
                                                type: zod
                                                  .literal("city_state_zip")
                                                  .default(
                                                    fetchMessagesWithUserInfoEndpointResponseResultItemsItemUserInfoCareStateExportsFollowUpsAwaitingResponseItemResponseInstrumentFormDefinitionFieldsItemValidatorRawValidatorTypeDefaultFive,
                                                  ),
                                              })
                                              .describe(
                                                "Validator that accepts city, state, and ZIP code combinations.",
                                              ),
                                            zod.unknown(),
                                            zod
                                              .object({
                                                type: zod
                                                  .literal("list")
                                                  .default(
                                                    fetchMessagesWithUserInfoEndpointResponseResultItemsItemUserInfoCareStateExportsFollowUpsAwaitingResponseItemResponseInstrumentFormDefinitionFieldsItemValidatorRawValidatorTypeDefaultSix,
                                                  ),
                                                raw_validator: zod.union([
                                                  zod
                                                    .object({
                                                      type: zod
                                                        .literal(
                                                          "non_empty_string",
                                                        )
                                                        .default(
                                                          fetchMessagesWithUserInfoEndpointResponseResultItemsItemUserInfoCareStateExportsFollowUpsAwaitingResponseItemResponseInstrumentFormDefinitionFieldsItemValidatorRawValidatorRawValidatorTypeDefault,
                                                        ),
                                                    })
                                                    .describe(
                                                      "Validator that accepts arbitrary non-empty strings.",
                                                    ),
                                                  zod
                                                    .object({
                                                      type: zod
                                                        .literal("date")
                                                        .default(
                                                          fetchMessagesWithUserInfoEndpointResponseResultItemsItemUserInfoCareStateExportsFollowUpsAwaitingResponseItemResponseInstrumentFormDefinitionFieldsItemValidatorRawValidatorRawValidatorTypeDefaultOne,
                                                        ),
                                                    })
                                                    .describe(
                                                      "Validator that accepts arbitrary dates.",
                                                    ),
                                                  zod
                                                    .object({
                                                      type: zod
                                                        .literal("coded_choice")
                                                        .default(
                                                          fetchMessagesWithUserInfoEndpointResponseResultItemsItemUserInfoCareStateExportsFollowUpsAwaitingResponseItemResponseInstrumentFormDefinitionFieldsItemValidatorRawValidatorRawValidatorTypeDefaultTwo,
                                                        ),
                                                      options: zod.array(
                                                        zod
                                                          .object({
                                                            code: zod.string(),
                                                            display:
                                                              zod.string(),
                                                          })
                                                          .describe(
                                                            "An option from a list of choices.",
                                                          ),
                                                      ),
                                                    })
                                                    .describe(
                                                      "Validator that accepts any option from a list of choices.",
                                                    ),
                                                  zod
                                                    .object({
                                                      type: zod
                                                        .literal("phone_number")
                                                        .default(
                                                          fetchMessagesWithUserInfoEndpointResponseResultItemsItemUserInfoCareStateExportsFollowUpsAwaitingResponseItemResponseInstrumentFormDefinitionFieldsItemValidatorRawValidatorRawValidatorTypeDefaultThree,
                                                        ),
                                                    })
                                                    .describe(
                                                      "Validator that accepts arbitrary phone numbers.",
                                                    ),
                                                  zod
                                                    .object({
                                                      type: zod
                                                        .literal("email")
                                                        .default(
                                                          fetchMessagesWithUserInfoEndpointResponseResultItemsItemUserInfoCareStateExportsFollowUpsAwaitingResponseItemResponseInstrumentFormDefinitionFieldsItemValidatorRawValidatorRawValidatorTypeDefaultFour,
                                                        ),
                                                    })
                                                    .describe(
                                                      "Validator that accepts arbitrary emails.",
                                                    ),
                                                  zod
                                                    .object({
                                                      type: zod
                                                        .literal(
                                                          "city_state_zip",
                                                        )
                                                        .default(
                                                          fetchMessagesWithUserInfoEndpointResponseResultItemsItemUserInfoCareStateExportsFollowUpsAwaitingResponseItemResponseInstrumentFormDefinitionFieldsItemValidatorRawValidatorRawValidatorTypeDefaultFive,
                                                        ),
                                                    })
                                                    .describe(
                                                      "Validator that accepts city, state, and ZIP code combinations.",
                                                    ),
                                                  zod.unknown(),
                                                  zod.unknown(),
                                                ]),
                                              })
                                              .describe(
                                                "Validator that accepts lists of items.",
                                              ),
                                          ]),
                                        })
                                        .describe(
                                          "Validator that accepts optional fields.",
                                        ),
                                      zod
                                        .object({
                                          type: zod
                                            .literal("list")
                                            .default(
                                              fetchMessagesWithUserInfoEndpointResponseResultItemsItemUserInfoCareStateExportsFollowUpsAwaitingResponseItemResponseInstrumentFormDefinitionFieldsItemValidatorTypeDefaultSeven,
                                            ),
                                          raw_validator: zod.union([
                                            zod
                                              .object({
                                                type: zod
                                                  .literal("non_empty_string")
                                                  .default(
                                                    fetchMessagesWithUserInfoEndpointResponseResultItemsItemUserInfoCareStateExportsFollowUpsAwaitingResponseItemResponseInstrumentFormDefinitionFieldsItemValidatorRawValidatorTypeDefaultSeven,
                                                  ),
                                              })
                                              .describe(
                                                "Validator that accepts arbitrary non-empty strings.",
                                              ),
                                            zod
                                              .object({
                                                type: zod
                                                  .literal("date")
                                                  .default(
                                                    fetchMessagesWithUserInfoEndpointResponseResultItemsItemUserInfoCareStateExportsFollowUpsAwaitingResponseItemResponseInstrumentFormDefinitionFieldsItemValidatorRawValidatorTypeDefaultEight,
                                                  ),
                                              })
                                              .describe(
                                                "Validator that accepts arbitrary dates.",
                                              ),
                                            zod
                                              .object({
                                                type: zod
                                                  .literal("coded_choice")
                                                  .default(
                                                    fetchMessagesWithUserInfoEndpointResponseResultItemsItemUserInfoCareStateExportsFollowUpsAwaitingResponseItemResponseInstrumentFormDefinitionFieldsItemValidatorRawValidatorTypeDefaultNine,
                                                  ),
                                                options: zod.array(
                                                  zod
                                                    .object({
                                                      code: zod.string(),
                                                      display: zod.string(),
                                                    })
                                                    .describe(
                                                      "An option from a list of choices.",
                                                    ),
                                                ),
                                              })
                                              .describe(
                                                "Validator that accepts any option from a list of choices.",
                                              ),
                                            zod
                                              .object({
                                                type: zod
                                                  .literal("phone_number")
                                                  .default(
                                                    fetchMessagesWithUserInfoEndpointResponseResultItemsItemUserInfoCareStateExportsFollowUpsAwaitingResponseItemResponseInstrumentFormDefinitionFieldsItemValidatorRawValidatorTypeDefaultOnezero,
                                                  ),
                                              })
                                              .describe(
                                                "Validator that accepts arbitrary phone numbers.",
                                              ),
                                            zod
                                              .object({
                                                type: zod
                                                  .literal("email")
                                                  .default(
                                                    fetchMessagesWithUserInfoEndpointResponseResultItemsItemUserInfoCareStateExportsFollowUpsAwaitingResponseItemResponseInstrumentFormDefinitionFieldsItemValidatorRawValidatorTypeDefaultOneone,
                                                  ),
                                              })
                                              .describe(
                                                "Validator that accepts arbitrary emails.",
                                              ),
                                            zod
                                              .object({
                                                type: zod
                                                  .literal("city_state_zip")
                                                  .default(
                                                    fetchMessagesWithUserInfoEndpointResponseResultItemsItemUserInfoCareStateExportsFollowUpsAwaitingResponseItemResponseInstrumentFormDefinitionFieldsItemValidatorRawValidatorTypeDefaultOnetwo,
                                                  ),
                                              })
                                              .describe(
                                                "Validator that accepts city, state, and ZIP code combinations.",
                                              ),
                                            zod
                                              .object({
                                                type: zod
                                                  .literal("optional")
                                                  .default(
                                                    fetchMessagesWithUserInfoEndpointResponseResultItemsItemUserInfoCareStateExportsFollowUpsAwaitingResponseItemResponseInstrumentFormDefinitionFieldsItemValidatorRawValidatorTypeDefaultOnethree,
                                                  ),
                                                raw_validator: zod.union([
                                                  zod
                                                    .object({
                                                      type: zod
                                                        .literal(
                                                          "non_empty_string",
                                                        )
                                                        .default(
                                                          fetchMessagesWithUserInfoEndpointResponseResultItemsItemUserInfoCareStateExportsFollowUpsAwaitingResponseItemResponseInstrumentFormDefinitionFieldsItemValidatorRawValidatorRawValidatorTypeDefaultSix,
                                                        ),
                                                    })
                                                    .describe(
                                                      "Validator that accepts arbitrary non-empty strings.",
                                                    ),
                                                  zod
                                                    .object({
                                                      type: zod
                                                        .literal("date")
                                                        .default(
                                                          fetchMessagesWithUserInfoEndpointResponseResultItemsItemUserInfoCareStateExportsFollowUpsAwaitingResponseItemResponseInstrumentFormDefinitionFieldsItemValidatorRawValidatorRawValidatorTypeDefaultSeven,
                                                        ),
                                                    })
                                                    .describe(
                                                      "Validator that accepts arbitrary dates.",
                                                    ),
                                                  zod
                                                    .object({
                                                      type: zod
                                                        .literal("coded_choice")
                                                        .default(
                                                          fetchMessagesWithUserInfoEndpointResponseResultItemsItemUserInfoCareStateExportsFollowUpsAwaitingResponseItemResponseInstrumentFormDefinitionFieldsItemValidatorRawValidatorRawValidatorTypeDefaultEight,
                                                        ),
                                                      options: zod.array(
                                                        zod
                                                          .object({
                                                            code: zod.string(),
                                                            display:
                                                              zod.string(),
                                                          })
                                                          .describe(
                                                            "An option from a list of choices.",
                                                          ),
                                                      ),
                                                    })
                                                    .describe(
                                                      "Validator that accepts any option from a list of choices.",
                                                    ),
                                                  zod
                                                    .object({
                                                      type: zod
                                                        .literal("phone_number")
                                                        .default(
                                                          fetchMessagesWithUserInfoEndpointResponseResultItemsItemUserInfoCareStateExportsFollowUpsAwaitingResponseItemResponseInstrumentFormDefinitionFieldsItemValidatorRawValidatorRawValidatorTypeDefaultNine,
                                                        ),
                                                    })
                                                    .describe(
                                                      "Validator that accepts arbitrary phone numbers.",
                                                    ),
                                                  zod
                                                    .object({
                                                      type: zod
                                                        .literal("email")
                                                        .default(
                                                          fetchMessagesWithUserInfoEndpointResponseResultItemsItemUserInfoCareStateExportsFollowUpsAwaitingResponseItemResponseInstrumentFormDefinitionFieldsItemValidatorRawValidatorRawValidatorTypeDefaultOnezero,
                                                        ),
                                                    })
                                                    .describe(
                                                      "Validator that accepts arbitrary emails.",
                                                    ),
                                                  zod
                                                    .object({
                                                      type: zod
                                                        .literal(
                                                          "city_state_zip",
                                                        )
                                                        .default(
                                                          fetchMessagesWithUserInfoEndpointResponseResultItemsItemUserInfoCareStateExportsFollowUpsAwaitingResponseItemResponseInstrumentFormDefinitionFieldsItemValidatorRawValidatorRawValidatorTypeDefaultOneone,
                                                        ),
                                                    })
                                                    .describe(
                                                      "Validator that accepts city, state, and ZIP code combinations.",
                                                    ),
                                                  zod.unknown(),
                                                  zod.unknown(),
                                                ]),
                                              })
                                              .describe(
                                                "Validator that accepts optional fields.",
                                              ),
                                            zod.unknown(),
                                          ]),
                                        })
                                        .describe(
                                          "Validator that accepts lists of items.",
                                        ),
                                    ]),
                                  }),
                                ),
                              }),
                              submissions: zod.object({
                                submissions: zod.record(
                                  zod.string(),
                                  zod.union([
                                    zod.object({
                                      type: zod
                                        .literal("string")
                                        .default(
                                          fetchMessagesWithUserInfoEndpointResponseResultItemsItemUserInfoCareStateExportsFollowUpsAwaitingResponseItemResponseInstrumentSubmissionsSubmissionsTypeDefault,
                                        ),
                                      value: zod.string(),
                                    }),
                                    zod.object({
                                      type: zod
                                        .literal("int")
                                        .default(
                                          fetchMessagesWithUserInfoEndpointResponseResultItemsItemUserInfoCareStateExportsFollowUpsAwaitingResponseItemResponseInstrumentSubmissionsSubmissionsTypeDefaultOne,
                                        ),
                                      value: zod.number(),
                                    }),
                                    zod.object({
                                      type: zod
                                        .literal("simple_address")
                                        .default(
                                          fetchMessagesWithUserInfoEndpointResponseResultItemsItemUserInfoCareStateExportsFollowUpsAwaitingResponseItemResponseInstrumentSubmissionsSubmissionsTypeDefaultTwo,
                                        ),
                                      street_address: zod.string(),
                                      city_state_zip: zod.string(),
                                    }),
                                    zod.object({
                                      type: zod
                                        .literal("list")
                                        .default(
                                          fetchMessagesWithUserInfoEndpointResponseResultItemsItemUserInfoCareStateExportsFollowUpsAwaitingResponseItemResponseInstrumentSubmissionsSubmissionsTypeDefaultThree,
                                        ),
                                      values: zod.array(
                                        zod.union([
                                          zod.object({
                                            type: zod
                                              .literal("string")
                                              .default(
                                                fetchMessagesWithUserInfoEndpointResponseResultItemsItemUserInfoCareStateExportsFollowUpsAwaitingResponseItemResponseInstrumentSubmissionsSubmissionsValuesItemTypeDefault,
                                              ),
                                            value: zod.string(),
                                          }),
                                          zod.object({
                                            type: zod
                                              .literal("int")
                                              .default(
                                                fetchMessagesWithUserInfoEndpointResponseResultItemsItemUserInfoCareStateExportsFollowUpsAwaitingResponseItemResponseInstrumentSubmissionsSubmissionsValuesItemTypeDefaultOne,
                                              ),
                                            value: zod.number(),
                                          }),
                                          zod.object({
                                            type: zod
                                              .literal("simple_address")
                                              .default(
                                                fetchMessagesWithUserInfoEndpointResponseResultItemsItemUserInfoCareStateExportsFollowUpsAwaitingResponseItemResponseInstrumentSubmissionsSubmissionsValuesItemTypeDefaultTwo,
                                              ),
                                            street_address: zod.string(),
                                            city_state_zip: zod.string(),
                                          }),
                                          zod.unknown(),
                                        ]),
                                      ),
                                    }),
                                  ]),
                                ),
                              }),
                              problems: zod.record(zod.string(), zod.string()),
                              interpretation: zod.union([
                                zod.object({
                                  type: zod.enum([
                                    "complete",
                                    "incomplete",
                                    "error",
                                  ]),
                                  text: zod.string(),
                                }),
                                zod.null(),
                              ]),
                            })
                            .describe(
                              'An \"instrument session\" links the immediate state of a form with an instrumnet,\nwhich\n\nThis captures the instrument type, its form definition, and the user\'s\ncurrent submissions so that follow-ups can be processed without needing\nto look up the instrument again.',
                            ),
                          zod.null(),
                        ])
                        .optional(),
                      response_from_patient: zod
                        .union([zod.string(), zod.null()])
                        .optional(),
                      practice_area: zod
                        .enum(["Primary Care", "Psychiatry"])
                        .optional(),
                      origin_practice: zod
                        .union([zod.string(), zod.null()])
                        .optional(),
                    }),
                  ),
                  total_karma_offer: zod.number(),
                  pending_lab_orders: zod.number(),
                  critical_lab_results: zod.number(),
                  has_critical_labs: zod.boolean(),
                }),
                zod.null(),
              ])
              .optional(),
            waitlist_priority: zod
              .union([
                zod
                  .object({
                    is_eligible: zod.boolean(),
                    priority_score: zod.number(),
                    score_components: zod
                      .union([
                        zod.object({
                          message_count_score: zod.number(),
                          demographics_score: zod.number(),
                          random_seed_score: zod.number(),
                        }),
                        zod.null(),
                      ])
                      .optional(),
                  })
                  .describe("Result of waitlist priority calculation."),
                zod.null(),
              ])
              .optional(),
            onboarding_progress: zod
              .union([
                zod
                  .object({
                    has_consented_to_treatment: zod.boolean(),
                    identity_verification_done: zod.boolean(),
                  })
                  .describe("Onboarding progress information for a user."),
                zod.null(),
              ])
              .optional(),
            current_location: zod
              .union([
                zod.object({
                  time: zod.iso.datetime({}),
                  location: zod.object({
                    latitude: zod.number(),
                    longitude: zod.number(),
                    tzinfo: zod.string(),
                  }),
                  reverse_geocode: zod
                    .union([
                      zod.object({
                        formatted_address: zod
                          .union([zod.string(), zod.null()])
                          .optional(),
                        locality: zod
                          .union([zod.string(), zod.null()])
                          .optional(),
                        administrative_area_level_1: zod
                          .union([zod.string(), zod.null()])
                          .optional(),
                        country: zod
                          .union([zod.string(), zod.null()])
                          .optional(),
                        types: zod
                          .union([zod.array(zod.string()), zod.null()])
                          .optional(),
                      }),
                      zod.null(),
                    ])
                    .optional(),
                }),
                zod.null(),
              ])
              .optional(),
          })
          .describe(
            'A fairly maximalist representation of \"what is known about a user\".\n\nAll items must be:\n- reasonably fast to compute\n- up to date (if tweakable by admins)\n- close to up-to-date (if computed from other data sources)\n\nWe try to produce partial information if possible -- therefore,\nwe assume any item _can_ be missing, although for obvious reasons\nwe try to avoid it!',
          ),
      }),
    ),
    limit: zod.number(),
    count: zod.number(),
  }),
});

/**
 * @summary Fetch Streaming Mailbox Cursor
 */
export const fetchStreamingMailboxCursorResponse = zod.object({
  cursor: zod.uuid(),
});

/**
 * Report the ID of the newest event in the caller's own mailbox.

Note that this differs from `/app/mailbox/cursor`, which mints a fresh "start
from now" cursor: this one names an event that really exists, so a client can
compare it against the cursor it holds to see whether it is caught up.
 * @summary Fetch Streaming Mailbox Latest Event
 */
export const fetchStreamingMailboxLatestEventResponse = zod.object({
  latestEventId: zod.union([zod.uuid(), zod.null()]).optional(),
});

/**
 * @summary Stream From Mailbox
 */
export const streamFromMailboxBodyConversationsToStreamAudioForDefault = [];

export const streamFromMailboxBody = zod.object({
  cursor: zod.union([zod.uuid(), zod.null()]).optional(),
  conversationsToStreamAudioFor: zod
    .array(zod.uuid())
    .default(streamFromMailboxBodyConversationsToStreamAudioForDefault),
});

/**
 * @summary Create Conversation Direct
 */
export const createConversationDirectBodySendInitialMessageDefault = true;
export const createConversationDirectBodyMustBePrimaryDefault = true;

export const createConversationDirectBody = zod.object({
  sendInitialMessage: zod
    .boolean()
    .default(createConversationDirectBodySendInitialMessageDefault),
  mustBePrimary: zod
    .boolean()
    .default(createConversationDirectBodyMustBePrimaryDefault),
});

export const createConversationDirectResponse = zod.object({
  conversationId: zod.uuid(),
});

/**
 * Data sources for the caller, keeping the administrative rationale.

Unlike ``fetch_data_sources``, this retains the ``AdministrativeDataSourceT``
wrapper so the web app can explain why each source is in its current state.
 * @summary Fetch Data Source Progress
 */
export const fetchDataSourceProgressResponse = zod.object({
  data_sources: zod.array(
    zod
      .object({
        dataSource: zod.object({
          id: zod.string(),
          name: zod.string(),
          logoUrl: zod.union([zod.string(), zod.null()]).optional(),
          caption: zod
            .union([
              zod.object({
                bulb: zod.enum(["failed", "inProgress", "succeeded", "lotus"]),
                note: zod.string(),
              }),
              zod.null(),
            ])
            .optional(),
          buttonState: zod.enum([
            "connect",
            "spinner",
            "tryAgain",
            "connected",
          ]),
          buttonLabel: zod.string(),
          connectActionType: zod.union([
            zod.enum([
              "demographics",
              "healthkit",
              "flexpa",
              "vital",
              "hkclinical",
              "smart_on_fhir",
            ]),
            zod.unknown(),
          ]),
          smartOnFhir: zod
            .union([
              zod
                .object({
                  connectionId: zod.uuid(),
                  fhirEndpointId: zod.string(),
                })
                .describe(
                  "Identifiers for a data source backed by a SMART on FHIR connection.\n\nSet exactly when ``connect_action_type`` is\n``DataSourceConnectActionTypeT.SmartOnFhir``, and None otherwise.",
                ),
              zod.null(),
            ])
            .optional(),
        }),
        rationale: zod.union([zod.string(), zod.null()]).optional(),
      })
      .describe(
        "Administrative wrapper for a DataSourceT, with additional fields that\nexplain or justify the computed state.",
      ),
  ),
});

/**
 * @summary Search Fhir Directory
 */
export const searchFhirDirectoryBody = zod.object({
  query: zod.string(),
  state: zod.union([zod.string(), zod.null()]).optional(),
});

export const searchFhirDirectoryResponse = zod.object({
  results: zod.array(
    zod
      .object({
        id: zod.string(),
        name: zod.string(),
        city: zod.union([zod.string(), zod.null()]).optional(),
        state: zod.union([zod.string(), zod.null()]).optional(),
        logoUrl: zod.union([zod.string(), zod.null()]).optional(),
      })
      .describe("Endpoint fields needed to display a search result."),
  ),
});

/**
 * @summary Get Fhir Endpoint
 */
export const getFhirEndpointParams = zod.object({
  endpoint_id: zod.string(),
});

export const getFhirEndpointResponse = zod
  .object({
    id: zod.string(),
    name: zod.string(),
    fhirBaseUrl: zod.string(),
    city: zod.union([zod.string(), zod.null()]).optional(),
    state: zod.union([zod.string(), zod.null()]).optional(),
    logoUrl: zod.union([zod.string(), zod.null()]).optional(),
  })
  .describe(
    "Full endpoint detail returned by the GET route (for the connection flow).",
  );

/**
 * @summary Search Referral Destinations
 */
export const searchReferralDestinationsBodyQueryMax = 200;

export const searchReferralDestinationsBodyStateRegExpOne = new RegExp(
  "^[A-Za-z]{2}$",
);
export const searchReferralDestinationsBodyPostalCodeRegExpOne = new RegExp(
  "^\\d{2,5}\\\*?$",
);
export const searchReferralDestinationsBodyLimitDefault = 50;
export const searchReferralDestinationsBodyLimitMax = 50;

export const searchReferralDestinationsBody = zod.object({
  query: zod
    .string()
    .min(1)
    .max(searchReferralDestinationsBodyQueryMax)
    .describe("Current provider name, organization, or exact NPI."),
  state: zod
    .union([
      zod.string().regex(searchReferralDestinationsBodyStateRegExpOne),
      zod.null(),
    ])
    .optional()
    .describe("Optional two-letter state abbreviation."),
  postal_code: zod
    .union([
      zod.string().regex(searchReferralDestinationsBodyPostalCodeRegExpOne),
      zod.null(),
    ])
    .optional()
    .describe(
      "Optional ZIP code or prefix, e.g. 94107 (searches its three-digit region), 941, or 941\*.",
    ),
  limit: zod
    .number()
    .min(1)
    .max(searchReferralDestinationsBodyLimitMax)
    .default(searchReferralDestinationsBodyLimitDefault)
    .describe("How many of the closest matches to return."),
});

export const searchReferralDestinationsResponseTypeDefault = "success";
export const searchReferralDestinationsResponseDestinationsItemChannelDefault =
  "nppes";
export const searchReferralDestinationsResponseDestinationsItemNpiRegExp =
  new RegExp("^\\d{10}$");

export const searchReferralDestinationsResponseDestinationsItemPracticeLocationPostalCodeRegExp =
  new RegExp("^\\d{5}(?:-?\\d{4})?$");
export const searchReferralDestinationsResponseDestinationsItemPracticeLocationPhoneNumberRegExp =
  new RegExp("^\\+[1-9]\\d{7,14}$");
export const searchReferralDestinationsResponseDestinationsItemPracticeLocationFaxNumberRegExp =
  new RegExp("^\\+[1-9]\\d{7,14}$");
export const searchReferralDestinationsResponseTypeDefaultOne = "unavailable";

export const searchReferralDestinationsResponse = zod.union([
  zod.object({
    type: zod
      .literal("success")
      .default(searchReferralDestinationsResponseTypeDefault),
    destinations: zod
      .array(
        zod
          .object({
            channel: zod
              .literal("nppes")
              .default(
                searchReferralDestinationsResponseDestinationsItemChannelDefault,
              ),
            npi: zod
              .string()
              .regex(
                searchReferralDestinationsResponseDestinationsItemNpiRegExp,
              ),
            provider_name: zod.string().min(1),
            organization_name: zod.union([zod.string(), zod.null()]).optional(),
            specialties: zod.array(zod.string()),
            practice_location: zod
              .object({
                address_line_1: zod.string().min(1),
                address_line_2: zod
                  .union([zod.string(), zod.null()])
                  .optional(),
                city: zod.string().min(1),
                state: zod.string().min(1),
                postal_code: zod
                  .string()
                  .regex(
                    searchReferralDestinationsResponseDestinationsItemPracticeLocationPostalCodeRegExp,
                  ),
                phone_number: zod
                  .string()
                  .regex(
                    searchReferralDestinationsResponseDestinationsItemPracticeLocationPhoneNumberRegExp,
                  ),
                fax_number: zod
                  .string()
                  .regex(
                    searchReferralDestinationsResponseDestinationsItemPracticeLocationFaxNumberRegExp,
                  ),
              })
              .describe(
                "One exact practice location that can receive a referral by fax.",
              ),
          })
          .describe(
            "A provider and exact fax-reachable location returned by the finder.",
          ),
      )
      .describe("The closest matches first; one ordered list, not a page."),
  }),
  zod.object({
    type: zod
      .literal("unavailable")
      .default(searchReferralDestinationsResponseTypeDefaultOne),
    details: zod.string(),
  }),
]);

/**
 * Find messaging-capable Metriport destinations for a referral.
 * @summary Search Metriport Destinations
 */
export const searchMetriportDestinationsBodyQueryMax = 200;

export const searchMetriportDestinationsBodyStateRegExpOne = new RegExp(
  "^[A-Za-z]{2}$",
);
export const searchMetriportDestinationsBodyPostalCodeRegExpOne = new RegExp(
  "^\\d{2,5}\\\*?$",
);

export const searchMetriportDestinationsBody = zod.object({
  query: zod
    .string()
    .min(1)
    .max(searchMetriportDestinationsBodyQueryMax)
    .describe("Provider name, organization, or NPI to look up in Metriport."),
  state: zod
    .union([
      zod.string().regex(searchMetriportDestinationsBodyStateRegExpOne),
      zod.null(),
    ])
    .optional()
    .describe("Optional two-letter state abbreviation."),
  postal_code: zod
    .union([
      zod.string().regex(searchMetriportDestinationsBodyPostalCodeRegExpOne),
      zod.null(),
    ])
    .optional()
    .describe(
      "Optional ZIP code or prefix; filters to its three-digit region.",
    ),
});

export const searchMetriportDestinationsResponseTypeDefault = "success";

export const searchMetriportDestinationsResponseDestinationsItemSupportsMessagingDefault = true;
export const searchMetriportDestinationsResponseDestinationsItemChannelDefault =
  "metriport";
export const searchMetriportDestinationsResponseTypeDefaultOne = "unavailable";

export const searchMetriportDestinationsResponse = zod.union([
  zod.object({
    type: zod
      .literal("success")
      .default(searchMetriportDestinationsResponseTypeDefault),
    destinations: zod.array(
      zod
        .object({
          name: zod.union([zod.string(), zod.null()]).optional(),
          oid: zod
            .string()
            .min(1)
            .describe(
              "Recipient organization OID; pass this as message destination.",
            ),
          npi: zod.string().min(1),
          addressLine: zod.union([zod.string(), zod.null()]).optional(),
          city: zod.union([zod.string(), zod.null()]).optional(),
          state: zod.union([zod.string(), zod.null()]).optional(),
          zipCode: zod.union([zod.string(), zod.null()]).optional(),
          rootOrganization: zod.union([zod.string(), zod.null()]).optional(),
          managingOrgOid: zod.union([zod.string(), zod.null()]).optional(),
          network: zod.union([zod.string(), zod.null()]).optional(),
          supportsMessaging: zod
            .boolean()
            .default(
              searchMetriportDestinationsResponseDestinationsItemSupportsMessagingDefault,
            ),
          channel: zod
            .literal("metriport")
            .default(
              searchMetriportDestinationsResponseDestinationsItemChannelDefault,
            ),
        })
        .describe(
          "A Metriport directory entry that is safe to use for message delivery.",
        ),
    ),
  }),
  zod.object({
    type: zod
      .literal("unavailable")
      .default(searchMetriportDestinationsResponseTypeDefaultOne),
    details: zod.string(),
  }),
]);

/**
 * Return the patient's outbound referral communications.
 * @summary Fetch Patient Outbound Referrals
 */
export const fetchPatientOutboundReferralsParams = zod.object({
  user_id: zod.uuid(),
});

export const fetchPatientOutboundReferralsResponseAttachmentsItemMetadataFileTypeDefault =
  "image";
export const fetchPatientOutboundReferralsResponseAttachmentsItemMetadataFileTypeDefaultOne =
  "document";
export const fetchPatientOutboundReferralsResponseAttachmentsItemMetadataUniqueFileTypeDefault =
  "document";
export const fetchPatientOutboundReferralsResponseAttachmentsItemMetadataFileTypeDefaultTwo =
  "audio";
export const fetchPatientOutboundReferralsResponseAttachmentsItemMetadataUniqueFileTypeDefaultOne =
  "audio";
export const fetchPatientOutboundReferralsResponseMethodSpecificPartTypeDefault =
  "metriport";
export const fetchPatientOutboundReferralsResponseMethodSpecificPartTypeDefaultOne =
  "efax";
export const fetchPatientOutboundReferralsResponseDirectionDefault = "outbound";

export const fetchPatientOutboundReferralsResponseItem = zod.object({
  id: zod.uuid(),
  patient_id: zod.uuid(),
  subject: zod.string(),
  body: zod.union([zod.string(), zod.null()]),
  attachments: zod.array(
    zod
      .object({
        id: zod.uuid(),
        userId: zod.uuid(),
        metadata: zod.union([
          zod.object({
            file_type: zod
              .literal("image")
              .default(
                fetchPatientOutboundReferralsResponseAttachmentsItemMetadataFileTypeDefault,
              ),
            pre_upload: zod
              .object({
                mime_type: zod.string(),
                filename: zod.string(),
                caption: zod.union([zod.string(), zod.null()]),
              })
              .describe(
                "Metadata for a file attachment before upload (image or PDF).",
              ),
            post_upload: zod.union([
              zod
                .object({
                  file_size_bytes: zod.number(),
                })
                .describe(
                  "Metadata for an file attachment after upload (image or PDF).",
                ),
              zod.null(),
            ]),
            unique: zod.union([
              zod
                .object({
                  width: zod.number(),
                  height: zod.number(),
                })
                .describe("Metadata specific to image files."),
              zod.null(),
            ]),
          }),
          zod.object({
            file_type: zod
              .literal("document")
              .default(
                fetchPatientOutboundReferralsResponseAttachmentsItemMetadataFileTypeDefaultOne,
              ),
            pre_upload: zod
              .object({
                mime_type: zod.string(),
                filename: zod.string(),
                caption: zod.union([zod.string(), zod.null()]),
              })
              .describe(
                "Metadata for a file attachment before upload (image or PDF).",
              ),
            post_upload: zod.union([
              zod
                .object({
                  file_size_bytes: zod.number(),
                })
                .describe(
                  "Metadata for an file attachment after upload (image or PDF).",
                ),
              zod.null(),
            ]),
            unique: zod.union([
              zod
                .object({
                  file_type: zod
                    .literal("document")
                    .default(
                      fetchPatientOutboundReferralsResponseAttachmentsItemMetadataUniqueFileTypeDefault,
                    ),
                  page_count: zod.number(),
                })
                .describe("Metadata specific to PDF documents."),
              zod.null(),
            ]),
          }),
          zod.object({
            file_type: zod
              .literal("audio")
              .default(
                fetchPatientOutboundReferralsResponseAttachmentsItemMetadataFileTypeDefaultTwo,
              ),
            source: zod
              .enum(["user_upload", "lotus_tts"])
              .describe(
                "Where an audio attachment originated.\n\nThis is provenance metadata, not authorization — access control still goes\nthrough `FileAttachment.user_id`. The distinction matters for audit\/retention\n(Lotus-produced audio may have different licensing than user-captured audio),\nUI affordances (e.g. a re-generate control only on TTS outputs), and ingestion\npolicy (don't re-transcribe Lotus TTS — we already have the source text).",
              ),
            pre_upload: zod
              .object({
                mime_type: zod.string(),
                filename: zod.string(),
                caption: zod.union([zod.string(), zod.null()]),
              })
              .describe(
                "Metadata for a file attachment before upload (image or PDF).",
              ),
            post_upload: zod.union([
              zod
                .object({
                  file_size_bytes: zod.number(),
                })
                .describe(
                  "Metadata for an file attachment after upload (image or PDF).",
                ),
              zod.null(),
            ]),
            unique: zod.union([
              zod
                .object({
                  file_type: zod
                    .literal("audio")
                    .default(
                      fetchPatientOutboundReferralsResponseAttachmentsItemMetadataUniqueFileTypeDefaultOne,
                    ),
                  duration_ms: zod.number(),
                  sample_rate_hz: zod
                    .union([zod.number(), zod.null()])
                    .optional(),
                  channels: zod.union([zod.number(), zod.null()]).optional(),
                  waveform_peaks: zod
                    .union([zod.array(zod.number()), zod.null()])
                    .optional(),
                })
                .describe(
                  "Metadata specific to audio files, populated by the plugin on confirm_upload.\n\nTranscripts are stored as separate objects via the memoizer (same pattern\nas image summaries in ``AttachmentSummarizer``).  This struct only holds\nphysical\/codec metadata that is intrinsic to the audio file itself.",
                ),
              zod.null(),
            ]),
          }),
        ]),
        createdAt: zod.iso.datetime({}),
        confirmedAt: zod.union([zod.iso.datetime({}), zod.null()]).optional(),
        expiresAt: zod.iso.datetime({}),
      })
      .describe("Metadata for an uploaded file attachment (image or PDF)."),
  ),
  method_specific_part: zod.union([
    zod.object({
      type: zod
        .literal("metriport")
        .default(
          fetchPatientOutboundReferralsResponseMethodSpecificPartTypeDefault,
        ),
      message_id: zod.string(),
      destination_oid: zod.union([zod.string(), zod.null()]).optional(),
      sender: zod.union([zod.string(), zod.null()]).optional(),
    }),
    zod.object({
      type: zod
        .literal("efax")
        .default(
          fetchPatientOutboundReferralsResponseMethodSpecificPartTypeDefaultOne,
        ),
      fax_id: zod.uuid(),
      remote_fax_number: zod.string(),
    }),
  ]),
  error_details: zod.union([zod.string(), zod.null()]),
  created_at: zod.iso.datetime({}),
  updated_at: zod.iso.datetime({}),
  direction: zod
    .literal("outbound")
    .default(fetchPatientOutboundReferralsResponseDirectionDefault),
  status: zod.enum(["in_progress", "delivered", "failed"]),
  delivered_at: zod.union([zod.iso.datetime({}), zod.null()]),
});
export const fetchPatientOutboundReferralsResponse = zod.array(
  fetchPatientOutboundReferralsResponseItem,
);

/**
 * Send one clinician-approved referral by fax or Metriport.
 * @summary Send Patient Referral
 */
export const sendPatientReferralParams = zod.object({
  user_id: zod.uuid(),
});

export const sendPatientReferralBodyRecipientChannelDefault = "nppes";
export const sendPatientReferralBodyRecipientNpiRegExp = new RegExp(
  "^\\d{10}$",
);

export const sendPatientReferralBodyRecipientPracticeLocationPostalCodeRegExp =
  new RegExp("^\\d{5}(?:-?\\d{4})?$");
export const sendPatientReferralBodyRecipientPracticeLocationPhoneNumberRegExp =
  new RegExp("^\\+[1-9]\\d{7,14}$");
export const sendPatientReferralBodyRecipientPracticeLocationFaxNumberRegExp =
  new RegExp("^\\+[1-9]\\d{7,14}$");

export const sendPatientReferralBodyRecipientSupportsMessagingDefault = true;
export const sendPatientReferralBodyRecipientChannelDefaultOne = "metriport";
export const sendPatientReferralBodySubjectMax = 500;

export const sendPatientReferralBodyBodyMax = 100000;

export const sendPatientReferralBodyAttachmentIdsMax = 20;

export const sendPatientReferralBody = zod.object({
  send_id: zod.uuid().describe("Client-generated idempotency key."),
  recipient: zod.union([
    zod
      .object({
        channel: zod
          .literal("nppes")
          .default(sendPatientReferralBodyRecipientChannelDefault),
        npi: zod.string().regex(sendPatientReferralBodyRecipientNpiRegExp),
        provider_name: zod.string().min(1),
        organization_name: zod.union([zod.string(), zod.null()]).optional(),
        specialties: zod.array(zod.string()),
        practice_location: zod
          .object({
            address_line_1: zod.string().min(1),
            address_line_2: zod.union([zod.string(), zod.null()]).optional(),
            city: zod.string().min(1),
            state: zod.string().min(1),
            postal_code: zod
              .string()
              .regex(
                sendPatientReferralBodyRecipientPracticeLocationPostalCodeRegExp,
              ),
            phone_number: zod
              .string()
              .regex(
                sendPatientReferralBodyRecipientPracticeLocationPhoneNumberRegExp,
              ),
            fax_number: zod
              .string()
              .regex(
                sendPatientReferralBodyRecipientPracticeLocationFaxNumberRegExp,
              ),
          })
          .describe(
            "One exact practice location that can receive a referral by fax.",
          ),
      })
      .describe(
        "A provider and exact fax-reachable location returned by the finder.",
      ),
    zod
      .object({
        name: zod.union([zod.string(), zod.null()]).optional(),
        oid: zod
          .string()
          .min(1)
          .describe(
            "Recipient organization OID; pass this as message destination.",
          ),
        npi: zod.string().min(1),
        addressLine: zod.union([zod.string(), zod.null()]).optional(),
        city: zod.union([zod.string(), zod.null()]).optional(),
        state: zod.union([zod.string(), zod.null()]).optional(),
        zipCode: zod.union([zod.string(), zod.null()]).optional(),
        rootOrganization: zod.union([zod.string(), zod.null()]).optional(),
        managingOrgOid: zod.union([zod.string(), zod.null()]).optional(),
        network: zod.union([zod.string(), zod.null()]).optional(),
        supportsMessaging: zod
          .boolean()
          .default(sendPatientReferralBodyRecipientSupportsMessagingDefault),
        channel: zod
          .literal("metriport")
          .default(sendPatientReferralBodyRecipientChannelDefaultOne),
      })
      .describe(
        "A Metriport directory entry that is safe to use for message delivery.",
      ),
  ]),
  subject: zod.string().min(1).max(sendPatientReferralBodySubjectMax),
  body: zod.string().min(1).max(sendPatientReferralBodyBodyMax),
  attachment_ids: zod
    .array(zod.uuid())
    .max(sendPatientReferralBodyAttachmentIdsMax)
    .optional(),
});

export const sendPatientReferralResponseAttachmentsItemMetadataFileTypeDefault =
  "image";
export const sendPatientReferralResponseAttachmentsItemMetadataFileTypeDefaultOne =
  "document";
export const sendPatientReferralResponseAttachmentsItemMetadataUniqueFileTypeDefault =
  "document";
export const sendPatientReferralResponseAttachmentsItemMetadataFileTypeDefaultTwo =
  "audio";
export const sendPatientReferralResponseAttachmentsItemMetadataUniqueFileTypeDefaultOne =
  "audio";
export const sendPatientReferralResponseMethodSpecificPartTypeDefault =
  "metriport";
export const sendPatientReferralResponseMethodSpecificPartTypeDefaultOne =
  "efax";
export const sendPatientReferralResponseDirectionDefault = "outbound";

export const sendPatientReferralResponse = zod.object({
  id: zod.uuid(),
  patient_id: zod.uuid(),
  subject: zod.string(),
  body: zod.union([zod.string(), zod.null()]),
  attachments: zod.array(
    zod
      .object({
        id: zod.uuid(),
        userId: zod.uuid(),
        metadata: zod.union([
          zod.object({
            file_type: zod
              .literal("image")
              .default(
                sendPatientReferralResponseAttachmentsItemMetadataFileTypeDefault,
              ),
            pre_upload: zod
              .object({
                mime_type: zod.string(),
                filename: zod.string(),
                caption: zod.union([zod.string(), zod.null()]),
              })
              .describe(
                "Metadata for a file attachment before upload (image or PDF).",
              ),
            post_upload: zod.union([
              zod
                .object({
                  file_size_bytes: zod.number(),
                })
                .describe(
                  "Metadata for an file attachment after upload (image or PDF).",
                ),
              zod.null(),
            ]),
            unique: zod.union([
              zod
                .object({
                  width: zod.number(),
                  height: zod.number(),
                })
                .describe("Metadata specific to image files."),
              zod.null(),
            ]),
          }),
          zod.object({
            file_type: zod
              .literal("document")
              .default(
                sendPatientReferralResponseAttachmentsItemMetadataFileTypeDefaultOne,
              ),
            pre_upload: zod
              .object({
                mime_type: zod.string(),
                filename: zod.string(),
                caption: zod.union([zod.string(), zod.null()]),
              })
              .describe(
                "Metadata for a file attachment before upload (image or PDF).",
              ),
            post_upload: zod.union([
              zod
                .object({
                  file_size_bytes: zod.number(),
                })
                .describe(
                  "Metadata for an file attachment after upload (image or PDF).",
                ),
              zod.null(),
            ]),
            unique: zod.union([
              zod
                .object({
                  file_type: zod
                    .literal("document")
                    .default(
                      sendPatientReferralResponseAttachmentsItemMetadataUniqueFileTypeDefault,
                    ),
                  page_count: zod.number(),
                })
                .describe("Metadata specific to PDF documents."),
              zod.null(),
            ]),
          }),
          zod.object({
            file_type: zod
              .literal("audio")
              .default(
                sendPatientReferralResponseAttachmentsItemMetadataFileTypeDefaultTwo,
              ),
            source: zod
              .enum(["user_upload", "lotus_tts"])
              .describe(
                "Where an audio attachment originated.\n\nThis is provenance metadata, not authorization — access control still goes\nthrough `FileAttachment.user_id`. The distinction matters for audit\/retention\n(Lotus-produced audio may have different licensing than user-captured audio),\nUI affordances (e.g. a re-generate control only on TTS outputs), and ingestion\npolicy (don't re-transcribe Lotus TTS — we already have the source text).",
              ),
            pre_upload: zod
              .object({
                mime_type: zod.string(),
                filename: zod.string(),
                caption: zod.union([zod.string(), zod.null()]),
              })
              .describe(
                "Metadata for a file attachment before upload (image or PDF).",
              ),
            post_upload: zod.union([
              zod
                .object({
                  file_size_bytes: zod.number(),
                })
                .describe(
                  "Metadata for an file attachment after upload (image or PDF).",
                ),
              zod.null(),
            ]),
            unique: zod.union([
              zod
                .object({
                  file_type: zod
                    .literal("audio")
                    .default(
                      sendPatientReferralResponseAttachmentsItemMetadataUniqueFileTypeDefaultOne,
                    ),
                  duration_ms: zod.number(),
                  sample_rate_hz: zod
                    .union([zod.number(), zod.null()])
                    .optional(),
                  channels: zod.union([zod.number(), zod.null()]).optional(),
                  waveform_peaks: zod
                    .union([zod.array(zod.number()), zod.null()])
                    .optional(),
                })
                .describe(
                  "Metadata specific to audio files, populated by the plugin on confirm_upload.\n\nTranscripts are stored as separate objects via the memoizer (same pattern\nas image summaries in ``AttachmentSummarizer``).  This struct only holds\nphysical\/codec metadata that is intrinsic to the audio file itself.",
                ),
              zod.null(),
            ]),
          }),
        ]),
        createdAt: zod.iso.datetime({}),
        confirmedAt: zod.union([zod.iso.datetime({}), zod.null()]).optional(),
        expiresAt: zod.iso.datetime({}),
      })
      .describe("Metadata for an uploaded file attachment (image or PDF)."),
  ),
  method_specific_part: zod.union([
    zod.object({
      type: zod
        .literal("metriport")
        .default(sendPatientReferralResponseMethodSpecificPartTypeDefault),
      message_id: zod.string(),
      destination_oid: zod.union([zod.string(), zod.null()]).optional(),
      sender: zod.union([zod.string(), zod.null()]).optional(),
    }),
    zod.object({
      type: zod
        .literal("efax")
        .default(sendPatientReferralResponseMethodSpecificPartTypeDefaultOne),
      fax_id: zod.uuid(),
      remote_fax_number: zod.string(),
    }),
  ]),
  error_details: zod.union([zod.string(), zod.null()]),
  created_at: zod.iso.datetime({}),
  updated_at: zod.iso.datetime({}),
  direction: zod
    .literal("outbound")
    .default(sendPatientReferralResponseDirectionDefault),
  status: zod.enum(["in_progress", "delivered", "failed"]),
  delivered_at: zod.union([zod.iso.datetime({}), zod.null()]),
});

/**
 * Return the patient's inbound communications classified as referrals.
 * @summary Fetch Patient Referrals
 */
export const fetchPatientReferralsParams = zod.object({
  user_id: zod.uuid(),
});

export const fetchPatientReferralsResponseCommunicationAttachmentsItemMetadataFileTypeDefault =
  "image";
export const fetchPatientReferralsResponseCommunicationAttachmentsItemMetadataFileTypeDefaultOne =
  "document";
export const fetchPatientReferralsResponseCommunicationAttachmentsItemMetadataUniqueFileTypeDefault =
  "document";
export const fetchPatientReferralsResponseCommunicationAttachmentsItemMetadataFileTypeDefaultTwo =
  "audio";
export const fetchPatientReferralsResponseCommunicationAttachmentsItemMetadataUniqueFileTypeDefaultOne =
  "audio";
export const fetchPatientReferralsResponseCommunicationMethodSpecificPartTypeDefault =
  "metriport";
export const fetchPatientReferralsResponseCommunicationMethodSpecificPartTypeDefaultOne =
  "efax";
export const fetchPatientReferralsResponseCommunicationDirectionDefault =
  "outbound";
export const fetchPatientReferralsResponseCommunicationAttachmentsItemMetadataFileTypeDefaultThree =
  "image";
export const fetchPatientReferralsResponseCommunicationAttachmentsItemMetadataFileTypeDefaultFour =
  "document";
export const fetchPatientReferralsResponseCommunicationAttachmentsItemMetadataUniqueFileTypeDefaultTwo =
  "document";
export const fetchPatientReferralsResponseCommunicationAttachmentsItemMetadataFileTypeDefaultFive =
  "audio";
export const fetchPatientReferralsResponseCommunicationAttachmentsItemMetadataUniqueFileTypeDefaultThree =
  "audio";
export const fetchPatientReferralsResponseCommunicationMethodSpecificPartTypeDefaultTwo =
  "metriport";
export const fetchPatientReferralsResponseCommunicationMethodSpecificPartTypeDefaultThree =
  "efax";
export const fetchPatientReferralsResponseCommunicationDirectionDefaultOne =
  "inbound";

export const fetchPatientReferralsResponseItem = zod.object({
  id: zod.uuid(),
  communication: zod.union([
    zod.object({
      id: zod.uuid(),
      patient_id: zod.uuid(),
      subject: zod.string(),
      body: zod.union([zod.string(), zod.null()]),
      attachments: zod.array(
        zod
          .object({
            id: zod.uuid(),
            userId: zod.uuid(),
            metadata: zod.union([
              zod.object({
                file_type: zod
                  .literal("image")
                  .default(
                    fetchPatientReferralsResponseCommunicationAttachmentsItemMetadataFileTypeDefault,
                  ),
                pre_upload: zod
                  .object({
                    mime_type: zod.string(),
                    filename: zod.string(),
                    caption: zod.union([zod.string(), zod.null()]),
                  })
                  .describe(
                    "Metadata for a file attachment before upload (image or PDF).",
                  ),
                post_upload: zod.union([
                  zod
                    .object({
                      file_size_bytes: zod.number(),
                    })
                    .describe(
                      "Metadata for an file attachment after upload (image or PDF).",
                    ),
                  zod.null(),
                ]),
                unique: zod.union([
                  zod
                    .object({
                      width: zod.number(),
                      height: zod.number(),
                    })
                    .describe("Metadata specific to image files."),
                  zod.null(),
                ]),
              }),
              zod.object({
                file_type: zod
                  .literal("document")
                  .default(
                    fetchPatientReferralsResponseCommunicationAttachmentsItemMetadataFileTypeDefaultOne,
                  ),
                pre_upload: zod
                  .object({
                    mime_type: zod.string(),
                    filename: zod.string(),
                    caption: zod.union([zod.string(), zod.null()]),
                  })
                  .describe(
                    "Metadata for a file attachment before upload (image or PDF).",
                  ),
                post_upload: zod.union([
                  zod
                    .object({
                      file_size_bytes: zod.number(),
                    })
                    .describe(
                      "Metadata for an file attachment after upload (image or PDF).",
                    ),
                  zod.null(),
                ]),
                unique: zod.union([
                  zod
                    .object({
                      file_type: zod
                        .literal("document")
                        .default(
                          fetchPatientReferralsResponseCommunicationAttachmentsItemMetadataUniqueFileTypeDefault,
                        ),
                      page_count: zod.number(),
                    })
                    .describe("Metadata specific to PDF documents."),
                  zod.null(),
                ]),
              }),
              zod.object({
                file_type: zod
                  .literal("audio")
                  .default(
                    fetchPatientReferralsResponseCommunicationAttachmentsItemMetadataFileTypeDefaultTwo,
                  ),
                source: zod
                  .enum(["user_upload", "lotus_tts"])
                  .describe(
                    "Where an audio attachment originated.\n\nThis is provenance metadata, not authorization — access control still goes\nthrough `FileAttachment.user_id`. The distinction matters for audit\/retention\n(Lotus-produced audio may have different licensing than user-captured audio),\nUI affordances (e.g. a re-generate control only on TTS outputs), and ingestion\npolicy (don't re-transcribe Lotus TTS — we already have the source text).",
                  ),
                pre_upload: zod
                  .object({
                    mime_type: zod.string(),
                    filename: zod.string(),
                    caption: zod.union([zod.string(), zod.null()]),
                  })
                  .describe(
                    "Metadata for a file attachment before upload (image or PDF).",
                  ),
                post_upload: zod.union([
                  zod
                    .object({
                      file_size_bytes: zod.number(),
                    })
                    .describe(
                      "Metadata for an file attachment after upload (image or PDF).",
                    ),
                  zod.null(),
                ]),
                unique: zod.union([
                  zod
                    .object({
                      file_type: zod
                        .literal("audio")
                        .default(
                          fetchPatientReferralsResponseCommunicationAttachmentsItemMetadataUniqueFileTypeDefaultOne,
                        ),
                      duration_ms: zod.number(),
                      sample_rate_hz: zod
                        .union([zod.number(), zod.null()])
                        .optional(),
                      channels: zod
                        .union([zod.number(), zod.null()])
                        .optional(),
                      waveform_peaks: zod
                        .union([zod.array(zod.number()), zod.null()])
                        .optional(),
                    })
                    .describe(
                      "Metadata specific to audio files, populated by the plugin on confirm_upload.\n\nTranscripts are stored as separate objects via the memoizer (same pattern\nas image summaries in ``AttachmentSummarizer``).  This struct only holds\nphysical\/codec metadata that is intrinsic to the audio file itself.",
                    ),
                  zod.null(),
                ]),
              }),
            ]),
            createdAt: zod.iso.datetime({}),
            confirmedAt: zod
              .union([zod.iso.datetime({}), zod.null()])
              .optional(),
            expiresAt: zod.iso.datetime({}),
          })
          .describe("Metadata for an uploaded file attachment (image or PDF)."),
      ),
      method_specific_part: zod.union([
        zod.object({
          type: zod
            .literal("metriport")
            .default(
              fetchPatientReferralsResponseCommunicationMethodSpecificPartTypeDefault,
            ),
          message_id: zod.string(),
          destination_oid: zod.union([zod.string(), zod.null()]).optional(),
          sender: zod.union([zod.string(), zod.null()]).optional(),
        }),
        zod.object({
          type: zod
            .literal("efax")
            .default(
              fetchPatientReferralsResponseCommunicationMethodSpecificPartTypeDefaultOne,
            ),
          fax_id: zod.uuid(),
          remote_fax_number: zod.string(),
        }),
      ]),
      error_details: zod.union([zod.string(), zod.null()]),
      created_at: zod.iso.datetime({}),
      updated_at: zod.iso.datetime({}),
      direction: zod
        .literal("outbound")
        .default(fetchPatientReferralsResponseCommunicationDirectionDefault),
      status: zod.enum(["in_progress", "delivered", "failed"]),
      delivered_at: zod.union([zod.iso.datetime({}), zod.null()]),
    }),
    zod.object({
      id: zod.uuid(),
      patient_id: zod.uuid(),
      subject: zod.string(),
      body: zod.union([zod.string(), zod.null()]),
      attachments: zod.array(
        zod
          .object({
            id: zod.uuid(),
            userId: zod.uuid(),
            metadata: zod.union([
              zod.object({
                file_type: zod
                  .literal("image")
                  .default(
                    fetchPatientReferralsResponseCommunicationAttachmentsItemMetadataFileTypeDefaultThree,
                  ),
                pre_upload: zod
                  .object({
                    mime_type: zod.string(),
                    filename: zod.string(),
                    caption: zod.union([zod.string(), zod.null()]),
                  })
                  .describe(
                    "Metadata for a file attachment before upload (image or PDF).",
                  ),
                post_upload: zod.union([
                  zod
                    .object({
                      file_size_bytes: zod.number(),
                    })
                    .describe(
                      "Metadata for an file attachment after upload (image or PDF).",
                    ),
                  zod.null(),
                ]),
                unique: zod.union([
                  zod
                    .object({
                      width: zod.number(),
                      height: zod.number(),
                    })
                    .describe("Metadata specific to image files."),
                  zod.null(),
                ]),
              }),
              zod.object({
                file_type: zod
                  .literal("document")
                  .default(
                    fetchPatientReferralsResponseCommunicationAttachmentsItemMetadataFileTypeDefaultFour,
                  ),
                pre_upload: zod
                  .object({
                    mime_type: zod.string(),
                    filename: zod.string(),
                    caption: zod.union([zod.string(), zod.null()]),
                  })
                  .describe(
                    "Metadata for a file attachment before upload (image or PDF).",
                  ),
                post_upload: zod.union([
                  zod
                    .object({
                      file_size_bytes: zod.number(),
                    })
                    .describe(
                      "Metadata for an file attachment after upload (image or PDF).",
                    ),
                  zod.null(),
                ]),
                unique: zod.union([
                  zod
                    .object({
                      file_type: zod
                        .literal("document")
                        .default(
                          fetchPatientReferralsResponseCommunicationAttachmentsItemMetadataUniqueFileTypeDefaultTwo,
                        ),
                      page_count: zod.number(),
                    })
                    .describe("Metadata specific to PDF documents."),
                  zod.null(),
                ]),
              }),
              zod.object({
                file_type: zod
                  .literal("audio")
                  .default(
                    fetchPatientReferralsResponseCommunicationAttachmentsItemMetadataFileTypeDefaultFive,
                  ),
                source: zod
                  .enum(["user_upload", "lotus_tts"])
                  .describe(
                    "Where an audio attachment originated.\n\nThis is provenance metadata, not authorization — access control still goes\nthrough `FileAttachment.user_id`. The distinction matters for audit\/retention\n(Lotus-produced audio may have different licensing than user-captured audio),\nUI affordances (e.g. a re-generate control only on TTS outputs), and ingestion\npolicy (don't re-transcribe Lotus TTS — we already have the source text).",
                  ),
                pre_upload: zod
                  .object({
                    mime_type: zod.string(),
                    filename: zod.string(),
                    caption: zod.union([zod.string(), zod.null()]),
                  })
                  .describe(
                    "Metadata for a file attachment before upload (image or PDF).",
                  ),
                post_upload: zod.union([
                  zod
                    .object({
                      file_size_bytes: zod.number(),
                    })
                    .describe(
                      "Metadata for an file attachment after upload (image or PDF).",
                    ),
                  zod.null(),
                ]),
                unique: zod.union([
                  zod
                    .object({
                      file_type: zod
                        .literal("audio")
                        .default(
                          fetchPatientReferralsResponseCommunicationAttachmentsItemMetadataUniqueFileTypeDefaultThree,
                        ),
                      duration_ms: zod.number(),
                      sample_rate_hz: zod
                        .union([zod.number(), zod.null()])
                        .optional(),
                      channels: zod
                        .union([zod.number(), zod.null()])
                        .optional(),
                      waveform_peaks: zod
                        .union([zod.array(zod.number()), zod.null()])
                        .optional(),
                    })
                    .describe(
                      "Metadata specific to audio files, populated by the plugin on confirm_upload.\n\nTranscripts are stored as separate objects via the memoizer (same pattern\nas image summaries in ``AttachmentSummarizer``).  This struct only holds\nphysical\/codec metadata that is intrinsic to the audio file itself.",
                    ),
                  zod.null(),
                ]),
              }),
            ]),
            createdAt: zod.iso.datetime({}),
            confirmedAt: zod
              .union([zod.iso.datetime({}), zod.null()])
              .optional(),
            expiresAt: zod.iso.datetime({}),
          })
          .describe("Metadata for an uploaded file attachment (image or PDF)."),
      ),
      method_specific_part: zod.union([
        zod.object({
          type: zod
            .literal("metriport")
            .default(
              fetchPatientReferralsResponseCommunicationMethodSpecificPartTypeDefaultTwo,
            ),
          message_id: zod.string(),
          destination_oid: zod.union([zod.string(), zod.null()]).optional(),
          sender: zod.union([zod.string(), zod.null()]).optional(),
        }),
        zod.object({
          type: zod
            .literal("efax")
            .default(
              fetchPatientReferralsResponseCommunicationMethodSpecificPartTypeDefaultThree,
            ),
          fax_id: zod.uuid(),
          remote_fax_number: zod.string(),
        }),
      ]),
      error_details: zod.union([zod.string(), zod.null()]),
      created_at: zod.iso.datetime({}),
      updated_at: zod.iso.datetime({}),
      direction: zod
        .literal("inbound")
        .default(fetchPatientReferralsResponseCommunicationDirectionDefaultOne),
      status: zod.enum(["download_pending", "downloaded", "failed"]),
      received_at: zod.union([zod.iso.datetime({}), zod.null()]),
      downloaded_at: zod.union([zod.iso.datetime({}), zod.null()]),
    }),
  ]),
  created_at: zod.iso.datetime({}),
  updated_at: zod.iso.datetime({}),
});
export const fetchPatientReferralsResponse = zod.array(
  fetchPatientReferralsResponseItem,
);

/**
 * Return personalized and global portal endpoint IDs.

The SMART on FHIR launcher resolves each ID to a ``fhir_base_url`` via
``GET /app/fhir-directory/{endpoint_id}``.

``endpoint_ids`` are personalized: ``source="observed"`` when the user has
stored crossmatch rows, or ``source="predicted"`` from ZIP3 cold-start when
no resolved crossmatch rows exist.  ``global_favorite_endpoint_ids`` are
returned on every request from the cached global favorites bucket.

Both lists only ever contain endpoints this server can currently run SMART
against, so every ID is launchable.  Either list may be empty.
 * @summary Get Portal Recommendations
 */
export const getPortalRecommendationsResponse = zod.object({
  endpointIds: zod.array(zod.string()),
  globalFavoriteEndpointIds: zod.array(zod.string()),
});

/**
 * @summary Fetch Employee Roll
 */
export const fetchEmployeeRollResponse = zod.object({
  possibleGroups: zod.array(
    zod.enum([
      "lotus_admin",
      "lotus_developer",
      "lotus_test_user",
      "doctor",
      "practitioners",
      "evaluator_bot",
      "banned",
      "any_user",
      "anonymous_user",
      "partially_gated_user",
      "limited_access_user",
      "app_reviewer",
      "full_access_user",
      "invite_loop_group_1",
      "invite_loop_group_2",
      "invite_loop_group_3",
      "skip_service_area_check",
    ]),
  ),
  roll: zod.object({
    employees: zod.array(
      zod.object({
        userId: zod.uuid(),
        groups: zod.array(
          zod.enum([
            "lotus_admin",
            "lotus_developer",
            "lotus_test_user",
            "doctor",
            "practitioners",
            "evaluator_bot",
            "banned",
            "any_user",
            "anonymous_user",
            "partially_gated_user",
            "limited_access_user",
            "app_reviewer",
            "full_access_user",
            "invite_loop_group_1",
            "invite_loop_group_2",
            "invite_loop_group_3",
            "skip_service_area_check",
          ]),
        ),
        record: zod.object({
          displayName: zod.union([zod.string(), zod.null()]),
          phoneNumber: zod.union([zod.string(), zod.null()]),
          email: zod.union([zod.string(), zod.null()]),
          licensedStates: zod.union([zod.array(zod.string()), zod.null()]),
          licensedPracticeAreas: zod.union([
            zod.array(zod.string()),
            zod.null(),
          ]),
          originPractices: zod.union([zod.array(zod.string()), zod.null()]),
          mailingAddressStreet: zod
            .union([zod.string(), zod.null()])
            .optional(),
          mailingAddressCity: zod.union([zod.string(), zod.null()]).optional(),
          mailingAddressState: zod.union([zod.string(), zod.null()]).optional(),
          mailingAddressZip: zod.union([zod.string(), zod.null()]).optional(),
          dateOfBirth: zod.union([zod.iso.date(), zod.null()]).optional(),
          npiNumber: zod.union([zod.string(), zod.null()]).optional(),
          headshotFileId: zod.union([zod.uuid(), zod.null()]).optional(),
        }),
      }),
    ),
    developers: zod
      .array(
        zod.object({
          userId: zod.uuid(),
          groups: zod.array(
            zod.enum([
              "lotus_admin",
              "lotus_developer",
              "lotus_test_user",
              "doctor",
              "practitioners",
              "evaluator_bot",
              "banned",
              "any_user",
              "anonymous_user",
              "partially_gated_user",
              "limited_access_user",
              "app_reviewer",
              "full_access_user",
              "invite_loop_group_1",
              "invite_loop_group_2",
              "invite_loop_group_3",
              "skip_service_area_check",
            ]),
          ),
          record: zod.object({
            displayName: zod.union([zod.string(), zod.null()]),
            phoneNumber: zod.union([zod.string(), zod.null()]),
            email: zod.union([zod.string(), zod.null()]),
            licensedStates: zod.union([zod.array(zod.string()), zod.null()]),
            licensedPracticeAreas: zod.union([
              zod.array(zod.string()),
              zod.null(),
            ]),
            originPractices: zod.union([zod.array(zod.string()), zod.null()]),
            mailingAddressStreet: zod
              .union([zod.string(), zod.null()])
              .optional(),
            mailingAddressCity: zod
              .union([zod.string(), zod.null()])
              .optional(),
            mailingAddressState: zod
              .union([zod.string(), zod.null()])
              .optional(),
            mailingAddressZip: zod.union([zod.string(), zod.null()]).optional(),
            dateOfBirth: zod.union([zod.iso.date(), zod.null()]).optional(),
            npiNumber: zod.union([zod.string(), zod.null()]).optional(),
            headshotFileId: zod.union([zod.uuid(), zod.null()]).optional(),
          }),
        }),
      )
      .optional()
      .describe(
        "Users with database-assigned developer groups and no employee record.",
      ),
  }),
});

/**
 * @summary Update Employee From Roll
 */
export const updateEmployeeFromRollParams = zod.object({
  user_id: zod.uuid(),
});

export const updateEmployeeFromRollBody = zod.object({
  newRecord: zod.union([
    zod.object({
      displayName: zod.union([zod.string(), zod.null()]),
      email: zod.union([zod.string(), zod.null()]),
      licensedStates: zod
        .union([zod.array(zod.string()), zod.null()])
        .optional(),
      licensedPracticeAreas: zod
        .union([zod.array(zod.string()), zod.null()])
        .optional(),
      originPractices: zod
        .union([zod.array(zod.string()), zod.null()])
        .optional(),
    }),
    zod.null(),
  ]),
  newGroups: zod.union([
    zod.array(
      zod.enum([
        "lotus_admin",
        "lotus_developer",
        "lotus_test_user",
        "doctor",
        "practitioners",
        "evaluator_bot",
        "banned",
        "any_user",
        "anonymous_user",
        "partially_gated_user",
        "limited_access_user",
        "app_reviewer",
        "full_access_user",
        "invite_loop_group_1",
        "invite_loop_group_2",
        "invite_loop_group_3",
        "skip_service_area_check",
      ]),
    ),
    zod.null(),
  ]),
});

export const updateEmployeeFromRollResponse = zod.object({
  entry: zod.object({
    userId: zod.uuid(),
    groups: zod.array(
      zod.enum([
        "lotus_admin",
        "lotus_developer",
        "lotus_test_user",
        "doctor",
        "practitioners",
        "evaluator_bot",
        "banned",
        "any_user",
        "anonymous_user",
        "partially_gated_user",
        "limited_access_user",
        "app_reviewer",
        "full_access_user",
        "invite_loop_group_1",
        "invite_loop_group_2",
        "invite_loop_group_3",
        "skip_service_area_check",
      ]),
    ),
    record: zod.object({
      displayName: zod.union([zod.string(), zod.null()]),
      phoneNumber: zod.union([zod.string(), zod.null()]),
      email: zod.union([zod.string(), zod.null()]),
      licensedStates: zod.union([zod.array(zod.string()), zod.null()]),
      licensedPracticeAreas: zod.union([zod.array(zod.string()), zod.null()]),
      originPractices: zod.union([zod.array(zod.string()), zod.null()]),
      mailingAddressStreet: zod.union([zod.string(), zod.null()]).optional(),
      mailingAddressCity: zod.union([zod.string(), zod.null()]).optional(),
      mailingAddressState: zod.union([zod.string(), zod.null()]).optional(),
      mailingAddressZip: zod.union([zod.string(), zod.null()]).optional(),
      dateOfBirth: zod.union([zod.iso.date(), zod.null()]).optional(),
      npiNumber: zod.union([zod.string(), zod.null()]).optional(),
      headshotFileId: zod.union([zod.uuid(), zod.null()]).optional(),
    }),
  }),
});

/**
 * @summary Create Smart Connection
 */
export const createSmartConnectionBody = zod.object({
  fhirEndpointId: zod.string(),
  redirectUrl: zod.union([zod.string(), zod.null()]).optional(),
});

export const createSmartConnectionResponseTypeDefault = "started";
export const createSmartConnectionResponseTypeDefaultOne = "failed";

export const createSmartConnectionResponse = zod.union([
  zod.object({
    type: zod
      .literal("started")
      .default(createSmartConnectionResponseTypeDefault),
    oauthState: zod.string(),
    url: zod.string(),
  }),
  zod.object({
    type: zod
      .literal("failed")
      .default(createSmartConnectionResponseTypeDefaultOne),
    error: zod.string(),
  }),
]);

/**
 * @summary Refresh Login For Smart Connection
 */
export const refreshLoginForSmartConnectionParams = zod.object({
  connection_id: zod.uuid(),
});

export const refreshLoginForSmartConnectionBody = zod.union([
  zod.object({
    redirectUrl: zod.union([zod.string(), zod.null()]).optional(),
  }),
  zod.null(),
]);

export const refreshLoginForSmartConnectionResponseTypeDefault = "started";
export const refreshLoginForSmartConnectionResponseTypeDefaultOne = "failed";

export const refreshLoginForSmartConnectionResponse = zod.union([
  zod.object({
    type: zod
      .literal("started")
      .default(refreshLoginForSmartConnectionResponseTypeDefault),
    oauthState: zod.string(),
    url: zod.string(),
  }),
  zod.object({
    type: zod
      .literal("failed")
      .default(refreshLoginForSmartConnectionResponseTypeDefaultOne),
    error: zod.string(),
  }),
]);

/**
 * @summary Delete Smart Connection
 */
export const deleteSmartConnectionParams = zod.object({
  connection_id: zod.uuid(),
});

export const deleteSmartConnectionResponse = zod.object({});

/**
 * @summary Smart Oauth Redirect
 */
export const smartOauthRedirectQueryParams = zod.object({
  state: zod.string(),
  code: zod.union([zod.string(), zod.null()]).optional(),
  error: zod.union([zod.string(), zod.null()]).optional(),
  error_description: zod.union([zod.string(), zod.null()]).optional(),
});

export const smartOauthRedirectResponse = zod.unknown();

/**
 * @summary Fetch Smart Login Status
 */
export const fetchSmartLoginStatusParams = zod.object({
  oauth_state: zod.string(),
});

export const fetchSmartLoginStatusResponse = zod.object({
  status: zod.object({
    code: zod.enum(["unrecognized", "pending", "success", "error"]),
    message: zod.union([zod.string(), zod.null()]).optional(),
    reason: zod
      .union([
        zod.union([
          zod
            .enum([
              "login_expired",
              "access_denied",
              "provider_unreachable",
              "provider_error",
              "internal_error",
            ])
            .describe(
              'A machine-readable category for a failed login, so clients can branch\n(e.g. offer a \"reconnect\" button) without parsing ``message``.',
            ),
          zod.string(),
        ]),
        zod.null(),
      ])
      .optional(),
  }),
});

/**
 * @summary Search Smart Endpoints
 */
export const searchSmartEndpointsBody = zod.object({
  query: zod.string(),
  state: zod.union([zod.string(), zod.null()]).optional(),
});

export const searchSmartEndpointsResponse = zod.object({
  results: zod.array(
    zod
      .object({
        id: zod.string(),
        name: zod.string(),
        city: zod.union([zod.string(), zod.null()]).optional(),
        state: zod.union([zod.string(), zod.null()]).optional(),
        logoUrl: zod.union([zod.string(), zod.null()]).optional(),
      })
      .describe("Endpoint fields needed to display a search result."),
  ),
});

/**
 * @summary Fetch Smart Endpoint
 */
export const fetchSmartEndpointParams = zod.object({
  endpoint_id: zod.string(),
});

export const fetchSmartEndpointResponse = zod
  .object({
    id: zod.string(),
    name: zod.string(),
    fhirBaseUrl: zod.string(),
    city: zod.union([zod.string(), zod.null()]).optional(),
    state: zod.union([zod.string(), zod.null()]).optional(),
    logoUrl: zod.union([zod.string(), zod.null()]).optional(),
  })
  .describe(
    "Full endpoint detail returned by the GET route (for the connection flow).",
  );

/**
 * Render signature text as a transparent PNG.
 * @summary Render Signature Endpoint
 */
export const renderSignatureEndpointBodyTextMax = 128;

export const renderSignatureEndpointBody = zod.object({
  text: zod
    .string()
    .min(1)
    .max(renderSignatureEndpointBodyTextMax)
    .describe("Text to render as a cursive signature."),
});

/**
 * @summary Fetch Me
 */
export const fetchMeResponseSubsystemAccessDefault = {};

export const fetchMeResponse = zod.object({
  requiresEmployeeRecord: zod.boolean(),
  subsystemAccess: zod
    .record(zod.string(), zod.boolean())
    .default(fetchMeResponseSubsystemAccessDefault),
  sapientResult: zod.object({
    user_status: zod.union([
      zod.enum([
        "banned",
        "hazardous",
        "gated",
        "anonymous",
        "registered_non_clinical",
        "registered_but_incomplete",
        "fully_onboarded",
      ]),
      zod.string(),
    ]),
    explanation: zod.string(),
  }),
});

/**
 * @summary Update Gating Group
 */
export const updateGatingGroupParams = zod.object({
  user_id: zod.uuid(),
});

export const updateGatingGroupBody = zod.object({
  gatingGroup: zod.enum(["banned", "limited_access", "full_access"]),
});

export const updateGatingGroupResponse = zod.object({
  gatingGroup: zod.enum(["banned", "limited_access", "full_access"]),
  groups: zod.array(
    zod.enum([
      "lotus_admin",
      "lotus_developer",
      "lotus_test_user",
      "doctor",
      "practitioners",
      "evaluator_bot",
      "banned",
      "any_user",
      "anonymous_user",
      "partially_gated_user",
      "limited_access_user",
      "app_reviewer",
      "full_access_user",
      "invite_loop_group_1",
      "invite_loop_group_2",
      "invite_loop_group_3",
      "skip_service_area_check",
    ]),
  ),
});

/**
 * Enable or disable the skip_service_area_check group for a user.
When enabled, the user will bypass service area checks.
 * @summary Set Skip Service Area Check
 */
export const setSkipServiceAreaCheckParams = zod.object({
  user_id: zod.uuid(),
});

export const setSkipServiceAreaCheckBody = zod.object({
  enabled: zod.boolean(),
});

export const setSkipServiceAreaCheckResponse = zod.object({
  enabled: zod.boolean(),
  groups: zod.array(
    zod.enum([
      "lotus_admin",
      "lotus_developer",
      "lotus_test_user",
      "doctor",
      "practitioners",
      "evaluator_bot",
      "banned",
      "any_user",
      "anonymous_user",
      "partially_gated_user",
      "limited_access_user",
      "app_reviewer",
      "full_access_user",
      "invite_loop_group_1",
      "invite_loop_group_2",
      "invite_loop_group_3",
      "skip_service_area_check",
    ]),
  ),
});

/**
 * @summary Fetch Identification
 */
export const fetchIdentificationResponseIdentificationHomeExperienceKindDefault =
  "full_access";
export const fetchIdentificationResponseIdentificationHomeExperienceDefault: {
  kind: "full_access";
} = { kind: "full_access" };
export const fetchIdentificationResponseIdentificationFallbackHomeExperienceKindDefault =
  "full_access";
export const fetchIdentificationResponseIdentificationFallbackHomeExperienceDefault: {
  kind: "full_access";
} = { kind: "full_access" };

export const fetchIdentificationResponse = zod.object({
  identification: zod.object({
    devId: zod.union([zod.string(), zod.null()]).optional(),
    userId: zod.uuid(),
    intercomJwt: zod.union([zod.string(), zod.null()]).optional(),
    homeExperience: zod
      .union([
        zod.object({
          kind: zod
            .literal("full_access")
            .default(
              fetchIdentificationResponseIdentificationHomeExperienceKindDefault,
            ),
        }),
        zod.null(),
      ])
      .default(fetchIdentificationResponseIdentificationHomeExperienceDefault),
    fallbackHomeExperience: zod
      .union([
        zod.object({
          kind: zod
            .literal("full_access")
            .default(
              fetchIdentificationResponseIdentificationFallbackHomeExperienceKindDefault,
            ),
        }),
        zod.null(),
      ])
      .default(
        fetchIdentificationResponseIdentificationFallbackHomeExperienceDefault,
      ),
  }),
});

/**
 * @summary Fetch Employee Record
 */
export const fetchEmployeeRecordResponse = zod.object({
  employeeRecord: zod.object({
    displayName: zod.union([zod.string(), zod.null()]),
    phoneNumber: zod.union([zod.string(), zod.null()]),
    email: zod.union([zod.string(), zod.null()]),
    licensedStates: zod.union([zod.array(zod.string()), zod.null()]),
    licensedPracticeAreas: zod.union([zod.array(zod.string()), zod.null()]),
    originPractices: zod.union([zod.array(zod.string()), zod.null()]),
    mailingAddressStreet: zod.union([zod.string(), zod.null()]).optional(),
    mailingAddressCity: zod.union([zod.string(), zod.null()]).optional(),
    mailingAddressState: zod.union([zod.string(), zod.null()]).optional(),
    mailingAddressZip: zod.union([zod.string(), zod.null()]).optional(),
    dateOfBirth: zod.union([zod.iso.date(), zod.null()]).optional(),
    npiNumber: zod.union([zod.string(), zod.null()]).optional(),
    headshotFileId: zod.union([zod.uuid(), zod.null()]).optional(),
  }),
});

/**
 * @summary Update Employee Record
 */
export const updateEmployeeRecordBody = zod.object({
  displayName: zod.union([zod.string(), zod.null()]),
  email: zod.union([zod.string(), zod.null()]),
  licensedStates: zod.union([zod.array(zod.string()), zod.null()]).optional(),
  licensedPracticeAreas: zod
    .union([zod.array(zod.string()), zod.null()])
    .optional(),
  originPractices: zod.union([zod.array(zod.string()), zod.null()]).optional(),
});

export const updateEmployeeRecordResponse = zod.object({
  message: zod.string(),
});

/**
 * Fetch a cursor-paginated page of admin patient rows.

This pages over the canonical users table, then hydrates only the selected
page into the compact row shape needed by the admin Patients tab.
 * @summary Fetch Admin Patients
 */
export const fetchAdminPatientsQueryLimitDefault = 50;
export const fetchAdminPatientsQueryLimitMax = 200;

export const fetchAdminPatientsQueryParams = zod.object({
  limit: zod
    .number()
    .min(1)
    .max(fetchAdminPatientsQueryLimitMax)
    .default(fetchAdminPatientsQueryLimitDefault),
  cursor: zod.union([zod.string(), zod.null()]).optional(),
  filters: zod.union([zod.string(), zod.null()]).optional(),
  search: zod.union([zod.string(), zod.null()]).optional(),
});

export const fetchAdminPatientsResponseRowsItemRequestsUrgentDefault = 0;
export const fetchAdminPatientsResponseRowsItemRequestsRoutineDefault = 0;
export const fetchAdminPatientsResponseRowsItemRequestsUnreadDefault = 0;

export const fetchAdminPatientsResponse = zod.object({
  rows: zod.array(
    zod.object({
      userId: zod.uuid(),
      createdAt: zod.union([zod.iso.datetime({}), zod.null()]).optional(),
      name: zod.union([zod.string(), zod.null()]).optional(),
      onboardingStatus: zod.union([zod.string(), zod.null()]).optional(),
      onboardingStates: zod.array(
        zod.enum([
          "admitted",
          "identity_verified",
          "treatment_consented",
          "clinical_setup_complete",
        ]),
      ),
      state: zod.union([zod.string(), zod.null()]).optional(),
      lastActiveAt: zod.union([zod.iso.datetime({}), zod.null()]).optional(),
      syncStatus: zod.string(),
      flags: zod.array(zod.string()),
      requests: zod.object({
        urgent: zod.number().optional(),
        routine: zod.number().optional(),
        unread: zod.number().optional(),
      }),
      phone: zod.union([zod.string(), zod.null()]).optional(),
      email: zod.union([zod.string(), zod.null()]).optional(),
      gatingGroup: zod.union([zod.string(), zod.null()]).optional(),
      groups: zod.array(zod.string()),
      isDeleted: zod.boolean(),
      hasCachedUserInfo: zod.boolean(),
    }),
  ),
  nextCursor: zod.union([zod.string(), zod.null()]).optional(),
});

/**
 * Fetch a single admin patient row by user ID.

Resolves the user authoritatively (independent of the search index), then
hydrates it into the same compact row shape returned by /admin/patients, so
direct-link navigation has full projection parity with the list. Returns
null when the user does not exist.
 * @summary Fetch Admin Patient
 */
export const fetchAdminPatientParams = zod.object({
  user_id: zod.uuid(),
});

export const fetchAdminPatientResponseRequestsUrgentDefault = 0;
export const fetchAdminPatientResponseRequestsRoutineDefault = 0;
export const fetchAdminPatientResponseRequestsUnreadDefault = 0;

export const fetchAdminPatientResponse = zod.union([
  zod.object({
    userId: zod.uuid(),
    createdAt: zod.union([zod.iso.datetime({}), zod.null()]).optional(),
    name: zod.union([zod.string(), zod.null()]).optional(),
    onboardingStatus: zod.union([zod.string(), zod.null()]).optional(),
    onboardingStates: zod.array(
      zod.enum([
        "admitted",
        "identity_verified",
        "treatment_consented",
        "clinical_setup_complete",
      ]),
    ),
    state: zod.union([zod.string(), zod.null()]).optional(),
    lastActiveAt: zod.union([zod.iso.datetime({}), zod.null()]).optional(),
    syncStatus: zod.string(),
    flags: zod.array(zod.string()),
    requests: zod.object({
      urgent: zod.number().optional(),
      routine: zod.number().optional(),
      unread: zod.number().optional(),
    }),
    phone: zod.union([zod.string(), zod.null()]).optional(),
    email: zod.union([zod.string(), zod.null()]).optional(),
    gatingGroup: zod.union([zod.string(), zod.null()]).optional(),
    groups: zod.array(zod.string()),
    isDeleted: zod.boolean(),
    hasCachedUserInfo: zod.boolean(),
  }),
  zod.null(),
]);

/**
 * Backfill all users with brain data
 * @summary Backfill All Users
 */
export const backfillAllUsersResponse = zod.object({
  started: zod.boolean(),
});

/**
 * Force a refresh of the full user info cache for a specific user.
 * @summary Refresh User Info
 */
export const refreshUserInfoParams = zod.object({
  user_id: zod.uuid(),
});

export const refreshUserInfoResponse = zod.unknown();

/**
 * Admin-only endpoint to delete a user's account.

This deactivates the user's account by creating a tombstone and unlinking
all credentials. The user's data will eventually be deleted.
 * @summary Admin Delete User
 */
export const adminDeleteUserParams = zod.object({
  user_id: zod.uuid(),
});

export const adminDeleteUserResponse = zod.object({});

/**
 * Get all brain-related data for the user including event logs, brain events, actions, and scheduled actions
 * @summary Get Recent Brain Data
 */
export const getRecentBrainDataParams = zod.object({
  user_id: zod.uuid(),
});

export const getRecentBrainDataResponsePendingEventLogsItemEventEventTypeDefault =
  "HEALTHKIT_UPLOAD";
export const getRecentBrainDataResponsePendingEventLogsItemEventEventTypeDefaultOne =
  "EHR_SYNC";
export const getRecentBrainDataResponsePendingEventLogsItemEventEventTypeDefaultTwo =
  "FLEXPA_SYNC";
export const getRecentBrainDataResponsePendingEventLogsItemEventEventTypeDefaultThree =
  "CHAT_MESSAGE";
export const getRecentBrainDataResponsePendingEventLogsItemEventEventTypeDefaultFour =
  "TOOL_CALL";
export const getRecentBrainDataResponsePendingEventLogsItemEventEventTypeDefaultFive =
  "INSIGHT_SENTIMENT";
export const getRecentBrainDataResponsePendingEventLogsItemEventInsightContentPreviewTypeDefault =
  "text";
export const getRecentBrainDataResponsePendingEventLogsItemEventInsightContentPreviewTypeDefaultOne =
  "unused";
export const getRecentBrainDataResponsePendingEventLogsItemEventInsightContentExpansionContentItemTypeDefault =
  "text";
export const getRecentBrainDataResponsePendingEventLogsItemEventInsightContentExpansionContentItemTypeDefaultOne =
  "ctaButton";
export const getRecentBrainDataResponsePendingEventLogsItemEventInsightContentExpansionContentItemTypeDefaultTwo =
  "spinner";
export const getRecentBrainDataResponsePendingEventLogsItemEventInsightContentExpansionContentItemTypeDefaultThree =
  "assessmentCTAButton";
export const getRecentBrainDataResponsePendingEventLogsItemEventSentimentTypeDefault =
  "sentiment";
export const getRecentBrainDataResponsePendingEventLogsItemEventSentimentTargetTypeDefault =
  "conversationMessage";
export const getRecentBrainDataResponsePendingEventLogsItemEventSentimentTargetValueContentBlocksItemBodyTypeDefault =
  "text";
export const getRecentBrainDataResponsePendingEventLogsItemEventSentimentTargetValueContentBlocksItemBodyTypeDefaultOne =
  "choiceChip";
export const getRecentBrainDataResponsePendingEventLogsItemEventSentimentTargetValueContentBlocksItemBodyTypeDefaultTwo =
  "error";
export const getRecentBrainDataResponsePendingEventLogsItemEventSentimentTargetValueContentBlocksItemBodyTypeDefaultThree =
  "chart";
export const getRecentBrainDataResponsePendingEventLogsItemEventSentimentTargetValueContentBlocksItemBodyTypeDefaultFour =
  "toolUse";
export const getRecentBrainDataResponsePendingEventLogsItemEventSentimentTargetValueContentBlocksItemBodyTypeDefaultFive =
  "article";
export const getRecentBrainDataResponsePendingEventLogsItemEventSentimentTargetValueContentBlocksItemBodyTypeDefaultSix =
  "sources_v2";
export const getRecentBrainDataResponsePendingEventLogsItemEventSentimentTargetValueContentBlocksItemBodySourcesItemContentTypeDefault =
  "table";
export const getRecentBrainDataResponsePendingEventLogsItemEventSentimentTargetValueContentBlocksItemBodySourcesItemContentColumnSchemaDefault =
  {};
export const getRecentBrainDataResponsePendingEventLogsItemEventSentimentTargetValueContentBlocksItemBodySourcesItemContentTypeDefaultOne =
  "link";
export const getRecentBrainDataResponsePendingEventLogsItemEventSentimentTargetValueContentBlocksItemBodyTypeDefaultSeven =
  "pendingReview";
export const getRecentBrainDataResponsePendingEventLogsItemEventSentimentTargetValueContentBlocksItemBodyTypeDefaultEight =
  "chainOfThought";
export const getRecentBrainDataResponsePendingEventLogsItemEventSentimentTargetValueContentBlocksItemBodyTypeDefaultNine =
  "revised";
export const getRecentBrainDataResponsePendingEventLogsItemEventSentimentTargetValueContentBlocksItemBodyTypeDefaultOnezero =
  "origin";
export const getRecentBrainDataResponsePendingEventLogsItemEventSentimentTargetValueContentBlocksItemBodyTypeDefaultOneone =
  "stagingStatus";
export const getRecentBrainDataResponsePendingEventLogsItemEventSentimentTargetValueContentBlocksItemBodyTypeDefaultOnetwo =
  "completeStatus";
export const getRecentBrainDataResponsePendingEventLogsItemEventSentimentTargetValueContentBlocksItemBodyTypeDefaultOnethree =
  "retryStatus";
export const getRecentBrainDataResponsePendingEventLogsItemEventSentimentTargetValueContentBlocksItemBodyTypeDefaultOnefour =
  "assessmentResult";
export const getRecentBrainDataResponsePendingEventLogsItemEventSentimentTargetValueContentBlocksItemBodyTypeDefaultOnefive =
  "voiceMessageMarker";
export const getRecentBrainDataResponsePendingEventLogsItemEventSentimentTargetValueContentBlocksItemBodyTypeDefaultOnesix =
  "voiceUpload";
export const getRecentBrainDataResponsePendingEventLogsItemEventSentimentTargetValueContentBlocksItemBodyTypeDefaultOneseven =
  "debug";
export const getRecentBrainDataResponsePendingEventLogsItemEventSentimentTargetValueContentBlocksItemBodyTypeDefaultOneeight =
  "blank";
export const getRecentBrainDataResponsePendingEventLogsItemEventSentimentTargetValueContentBlocksItemBodyTypeDefaultOnenine =
  "answerPartSuggestion";
export const getRecentBrainDataResponsePendingEventLogsItemEventSentimentTargetValueContentBlocksItemBodyAnswerPartAnswerPartTypeDefault =
  "revise_message";
export const getRecentBrainDataResponsePendingEventLogsItemEventSentimentTargetValueContentBlocksItemBodyAnswerPartSendToPatientDefault = true;
export const getRecentBrainDataResponsePendingEventLogsItemEventSentimentTargetValueContentBlocksItemBodyAnswerPartAnswerPartTypeDefaultOne =
  "note";
export const getRecentBrainDataResponsePendingEventLogsItemEventSentimentTargetValueContentBlocksItemBodyAnswerPartAnswerPartTypeDefaultTwo =
  "rejected";
export const getRecentBrainDataResponsePendingEventLogsItemEventSentimentTargetValueContentBlocksItemBodyAnswerPartAnswerPartTypeDefaultThree =
  "prescription";
export const getRecentBrainDataResponsePendingEventLogsItemEventSentimentTargetValueContentBlocksItemBodyAnswerPartAnswerPartTypeDefaultFour =
  "prescription_suggestion";
export const getRecentBrainDataResponsePendingEventLogsItemEventSentimentTargetValueContentBlocksItemBodyTypeDefaultTwozero =
  "fileAttachment";
export const getRecentBrainDataResponsePendingEventLogsItemEventSentimentTargetValueContentBlocksItemBodyTypeDefaultTwoone =
  "actionChip";
export const getRecentBrainDataResponsePendingEventLogsItemEventSentimentTargetValueContentBlocksItemBodyTypeDefaultTwotwo =
  "mention";
export const getRecentBrainDataResponsePendingEventLogsItemEventSentimentTargetValueContentBlocksItemBodyTypeDefaultTwothree =
  "directive";
export const getRecentBrainDataResponsePendingEventLogsItemEventSentimentTargetTypeDefaultOne =
  "insight";
export const getRecentBrainDataResponsePendingEventLogsItemEventSentimentTargetValueContentPreviewTypeDefault =
  "text";
export const getRecentBrainDataResponsePendingEventLogsItemEventSentimentTargetValueContentPreviewTypeDefaultOne =
  "unused";
export const getRecentBrainDataResponsePendingEventLogsItemEventSentimentTargetValueContentExpansionContentItemTypeDefault =
  "text";
export const getRecentBrainDataResponsePendingEventLogsItemEventSentimentTargetValueContentExpansionContentItemTypeDefaultOne =
  "ctaButton";
export const getRecentBrainDataResponsePendingEventLogsItemEventSentimentTargetValueContentExpansionContentItemTypeDefaultTwo =
  "spinner";
export const getRecentBrainDataResponsePendingEventLogsItemEventSentimentTargetValueContentExpansionContentItemTypeDefaultThree =
  "assessmentCTAButton";
export const getRecentBrainDataResponsePendingEventLogsItemEventEventTypeDefaultSix =
  "PULSE_SENTIMENT";
export const getRecentBrainDataResponsePendingEventLogsItemEventEventTypeDefaultSeven =
  "PULSE_GENERATED";
export const getRecentBrainDataResponsePendingEventLogsItemEventEventTypeDefaultEight =
  "PULSE_CONSUMED";
export const getRecentBrainDataResponsePendingEventLogsItemEventEventTypeDefaultNine =
  "LOTUS_BRAIN_INVOCATION_SKIPPED";
export const getRecentBrainDataResponsePendingEventLogsItemEventEventTypeDefaultOnezero =
  "LOTUS_BRAIN_SWARM_INVOCATION_SKIPPED";
export const getRecentBrainDataResponsePendingEventLogsItemEventEventTypeDefaultOneone =
  "LOTUS_BRAIN_INVOCATION_START";
export const getRecentBrainDataResponsePendingEventLogsItemEventEventTypeDefaultOnetwo =
  "LOTUS_BRAIN_INVOCATION";
export const getRecentBrainDataResponsePendingEventLogsItemEventEventTypeDefaultOnethree =
  "CASE_STARTED";
export const getRecentBrainDataResponsePendingEventLogsItemEventEventTypeDefaultOnefour =
  "CASE_COMPLETED";
export const getRecentBrainDataResponsePendingEventLogsItemEventEventTypeDefaultOnefive =
  "CASE_ESCALATED";
export const getRecentBrainDataResponsePendingEventLogsItemEventEventTypeDefaultOnesix =
  "TRANSMIT_CASE_SUMMARY";
export const getRecentBrainDataResponsePendingEventLogsItemEventEventTypeDefaultOneseven =
  "RESOLVED_REQUEST";
export const getRecentBrainDataResponsePendingEventLogsItemEventEventTypeDefaultOneeight =
  "REQUEST_CREATED";
export const getRecentBrainDataResponsePendingEventLogsItemEventEventTypeDefaultOnenine =
  "REQUEST_RESOLVED";
export const getRecentBrainDataResponsePendingEventLogsItemEventEventTypeDefaultTwozero =
  "QUESTION_REPETITION_CHECK";
export const getRecentBrainDataResponsePendingEventLogsItemEventEventTypeDefaultTwoone =
  "REQUEST_SHOT_CLOCK_EXCEEDED";
export const getRecentBrainDataResponsePendingEventLogsItemEventEventTypeDefaultTwotwo =
  "PRE_REQUEST_ESCALATION_OVERDUE";
export const getRecentBrainDataResponsePendingEventLogsItemEventEventTypeDefaultTwothree =
  "VERIFIED_DISCOVERY";
export const getRecentBrainDataResponseProcessedEventLogsItemEventEventTypeDefault =
  "HEALTHKIT_UPLOAD";
export const getRecentBrainDataResponseProcessedEventLogsItemEventEventTypeDefaultOne =
  "EHR_SYNC";
export const getRecentBrainDataResponseProcessedEventLogsItemEventEventTypeDefaultTwo =
  "FLEXPA_SYNC";
export const getRecentBrainDataResponseProcessedEventLogsItemEventEventTypeDefaultThree =
  "CHAT_MESSAGE";
export const getRecentBrainDataResponseProcessedEventLogsItemEventEventTypeDefaultFour =
  "TOOL_CALL";
export const getRecentBrainDataResponseProcessedEventLogsItemEventEventTypeDefaultFive =
  "INSIGHT_SENTIMENT";
export const getRecentBrainDataResponseProcessedEventLogsItemEventInsightContentPreviewTypeDefault =
  "text";
export const getRecentBrainDataResponseProcessedEventLogsItemEventInsightContentPreviewTypeDefaultOne =
  "unused";
export const getRecentBrainDataResponseProcessedEventLogsItemEventInsightContentExpansionContentItemTypeDefault =
  "text";
export const getRecentBrainDataResponseProcessedEventLogsItemEventInsightContentExpansionContentItemTypeDefaultOne =
  "ctaButton";
export const getRecentBrainDataResponseProcessedEventLogsItemEventInsightContentExpansionContentItemTypeDefaultTwo =
  "spinner";
export const getRecentBrainDataResponseProcessedEventLogsItemEventInsightContentExpansionContentItemTypeDefaultThree =
  "assessmentCTAButton";
export const getRecentBrainDataResponseProcessedEventLogsItemEventSentimentTypeDefault =
  "sentiment";
export const getRecentBrainDataResponseProcessedEventLogsItemEventSentimentTargetTypeDefault =
  "conversationMessage";
export const getRecentBrainDataResponseProcessedEventLogsItemEventSentimentTargetValueContentBlocksItemBodyTypeDefault =
  "text";
export const getRecentBrainDataResponseProcessedEventLogsItemEventSentimentTargetValueContentBlocksItemBodyTypeDefaultOne =
  "choiceChip";
export const getRecentBrainDataResponseProcessedEventLogsItemEventSentimentTargetValueContentBlocksItemBodyTypeDefaultTwo =
  "error";
export const getRecentBrainDataResponseProcessedEventLogsItemEventSentimentTargetValueContentBlocksItemBodyTypeDefaultThree =
  "chart";
export const getRecentBrainDataResponseProcessedEventLogsItemEventSentimentTargetValueContentBlocksItemBodyTypeDefaultFour =
  "toolUse";
export const getRecentBrainDataResponseProcessedEventLogsItemEventSentimentTargetValueContentBlocksItemBodyTypeDefaultFive =
  "article";
export const getRecentBrainDataResponseProcessedEventLogsItemEventSentimentTargetValueContentBlocksItemBodyTypeDefaultSix =
  "sources_v2";
export const getRecentBrainDataResponseProcessedEventLogsItemEventSentimentTargetValueContentBlocksItemBodySourcesItemContentTypeDefault =
  "table";
export const getRecentBrainDataResponseProcessedEventLogsItemEventSentimentTargetValueContentBlocksItemBodySourcesItemContentColumnSchemaDefault =
  {};
export const getRecentBrainDataResponseProcessedEventLogsItemEventSentimentTargetValueContentBlocksItemBodySourcesItemContentTypeDefaultOne =
  "link";
export const getRecentBrainDataResponseProcessedEventLogsItemEventSentimentTargetValueContentBlocksItemBodyTypeDefaultSeven =
  "pendingReview";
export const getRecentBrainDataResponseProcessedEventLogsItemEventSentimentTargetValueContentBlocksItemBodyTypeDefaultEight =
  "chainOfThought";
export const getRecentBrainDataResponseProcessedEventLogsItemEventSentimentTargetValueContentBlocksItemBodyTypeDefaultNine =
  "revised";
export const getRecentBrainDataResponseProcessedEventLogsItemEventSentimentTargetValueContentBlocksItemBodyTypeDefaultOnezero =
  "origin";
export const getRecentBrainDataResponseProcessedEventLogsItemEventSentimentTargetValueContentBlocksItemBodyTypeDefaultOneone =
  "stagingStatus";
export const getRecentBrainDataResponseProcessedEventLogsItemEventSentimentTargetValueContentBlocksItemBodyTypeDefaultOnetwo =
  "completeStatus";
export const getRecentBrainDataResponseProcessedEventLogsItemEventSentimentTargetValueContentBlocksItemBodyTypeDefaultOnethree =
  "retryStatus";
export const getRecentBrainDataResponseProcessedEventLogsItemEventSentimentTargetValueContentBlocksItemBodyTypeDefaultOnefour =
  "assessmentResult";
export const getRecentBrainDataResponseProcessedEventLogsItemEventSentimentTargetValueContentBlocksItemBodyTypeDefaultOnefive =
  "voiceMessageMarker";
export const getRecentBrainDataResponseProcessedEventLogsItemEventSentimentTargetValueContentBlocksItemBodyTypeDefaultOnesix =
  "voiceUpload";
export const getRecentBrainDataResponseProcessedEventLogsItemEventSentimentTargetValueContentBlocksItemBodyTypeDefaultOneseven =
  "debug";
export const getRecentBrainDataResponseProcessedEventLogsItemEventSentimentTargetValueContentBlocksItemBodyTypeDefaultOneeight =
  "blank";
export const getRecentBrainDataResponseProcessedEventLogsItemEventSentimentTargetValueContentBlocksItemBodyTypeDefaultOnenine =
  "answerPartSuggestion";
export const getRecentBrainDataResponseProcessedEventLogsItemEventSentimentTargetValueContentBlocksItemBodyAnswerPartAnswerPartTypeDefault =
  "revise_message";
export const getRecentBrainDataResponseProcessedEventLogsItemEventSentimentTargetValueContentBlocksItemBodyAnswerPartSendToPatientDefault = true;
export const getRecentBrainDataResponseProcessedEventLogsItemEventSentimentTargetValueContentBlocksItemBodyAnswerPartAnswerPartTypeDefaultOne =
  "note";
export const getRecentBrainDataResponseProcessedEventLogsItemEventSentimentTargetValueContentBlocksItemBodyAnswerPartAnswerPartTypeDefaultTwo =
  "rejected";
export const getRecentBrainDataResponseProcessedEventLogsItemEventSentimentTargetValueContentBlocksItemBodyAnswerPartAnswerPartTypeDefaultThree =
  "prescription";
export const getRecentBrainDataResponseProcessedEventLogsItemEventSentimentTargetValueContentBlocksItemBodyAnswerPartAnswerPartTypeDefaultFour =
  "prescription_suggestion";
export const getRecentBrainDataResponseProcessedEventLogsItemEventSentimentTargetValueContentBlocksItemBodyTypeDefaultTwozero =
  "fileAttachment";
export const getRecentBrainDataResponseProcessedEventLogsItemEventSentimentTargetValueContentBlocksItemBodyTypeDefaultTwoone =
  "actionChip";
export const getRecentBrainDataResponseProcessedEventLogsItemEventSentimentTargetValueContentBlocksItemBodyTypeDefaultTwotwo =
  "mention";
export const getRecentBrainDataResponseProcessedEventLogsItemEventSentimentTargetValueContentBlocksItemBodyTypeDefaultTwothree =
  "directive";
export const getRecentBrainDataResponseProcessedEventLogsItemEventSentimentTargetTypeDefaultOne =
  "insight";
export const getRecentBrainDataResponseProcessedEventLogsItemEventSentimentTargetValueContentPreviewTypeDefault =
  "text";
export const getRecentBrainDataResponseProcessedEventLogsItemEventSentimentTargetValueContentPreviewTypeDefaultOne =
  "unused";
export const getRecentBrainDataResponseProcessedEventLogsItemEventSentimentTargetValueContentExpansionContentItemTypeDefault =
  "text";
export const getRecentBrainDataResponseProcessedEventLogsItemEventSentimentTargetValueContentExpansionContentItemTypeDefaultOne =
  "ctaButton";
export const getRecentBrainDataResponseProcessedEventLogsItemEventSentimentTargetValueContentExpansionContentItemTypeDefaultTwo =
  "spinner";
export const getRecentBrainDataResponseProcessedEventLogsItemEventSentimentTargetValueContentExpansionContentItemTypeDefaultThree =
  "assessmentCTAButton";
export const getRecentBrainDataResponseProcessedEventLogsItemEventEventTypeDefaultSix =
  "PULSE_SENTIMENT";
export const getRecentBrainDataResponseProcessedEventLogsItemEventEventTypeDefaultSeven =
  "PULSE_GENERATED";
export const getRecentBrainDataResponseProcessedEventLogsItemEventEventTypeDefaultEight =
  "PULSE_CONSUMED";
export const getRecentBrainDataResponseProcessedEventLogsItemEventEventTypeDefaultNine =
  "LOTUS_BRAIN_INVOCATION_SKIPPED";
export const getRecentBrainDataResponseProcessedEventLogsItemEventEventTypeDefaultOnezero =
  "LOTUS_BRAIN_SWARM_INVOCATION_SKIPPED";
export const getRecentBrainDataResponseProcessedEventLogsItemEventEventTypeDefaultOneone =
  "LOTUS_BRAIN_INVOCATION_START";
export const getRecentBrainDataResponseProcessedEventLogsItemEventEventTypeDefaultOnetwo =
  "LOTUS_BRAIN_INVOCATION";
export const getRecentBrainDataResponseProcessedEventLogsItemEventEventTypeDefaultOnethree =
  "CASE_STARTED";
export const getRecentBrainDataResponseProcessedEventLogsItemEventEventTypeDefaultOnefour =
  "CASE_COMPLETED";
export const getRecentBrainDataResponseProcessedEventLogsItemEventEventTypeDefaultOnefive =
  "CASE_ESCALATED";
export const getRecentBrainDataResponseProcessedEventLogsItemEventEventTypeDefaultOnesix =
  "TRANSMIT_CASE_SUMMARY";
export const getRecentBrainDataResponseProcessedEventLogsItemEventEventTypeDefaultOneseven =
  "RESOLVED_REQUEST";
export const getRecentBrainDataResponseProcessedEventLogsItemEventEventTypeDefaultOneeight =
  "REQUEST_CREATED";
export const getRecentBrainDataResponseProcessedEventLogsItemEventEventTypeDefaultOnenine =
  "REQUEST_RESOLVED";
export const getRecentBrainDataResponseProcessedEventLogsItemEventEventTypeDefaultTwozero =
  "QUESTION_REPETITION_CHECK";
export const getRecentBrainDataResponseProcessedEventLogsItemEventEventTypeDefaultTwoone =
  "REQUEST_SHOT_CLOCK_EXCEEDED";
export const getRecentBrainDataResponseProcessedEventLogsItemEventEventTypeDefaultTwotwo =
  "PRE_REQUEST_ESCALATION_OVERDUE";
export const getRecentBrainDataResponseProcessedEventLogsItemEventEventTypeDefaultTwothree =
  "VERIFIED_DISCOVERY";

export const getRecentBrainDataResponse = zod.object({
  pending_event_logs: zod.array(
    zod.object({
      event: zod.union([
        zod.object({
          event_type: zod
            .literal("HEALTHKIT_UPLOAD")
            .default(
              getRecentBrainDataResponsePendingEventLogsItemEventEventTypeDefault,
            ),
          timestamp: zod.iso.datetime({}),
          updates: zod.record(zod.string(), zod.number()),
        }),
        zod.object({
          event_type: zod
            .literal("EHR_SYNC")
            .default(
              getRecentBrainDataResponsePendingEventLogsItemEventEventTypeDefaultOne,
            ),
          timestamp: zod.iso.datetime({}),
          updates: zod.record(zod.string(), zod.number()),
        }),
        zod.object({
          event_type: zod
            .literal("FLEXPA_SYNC")
            .default(
              getRecentBrainDataResponsePendingEventLogsItemEventEventTypeDefaultTwo,
            ),
          timestamp: zod.iso.datetime({}),
          updates: zod.record(zod.string(), zod.number()),
        }),
        zod.object({
          event_type: zod
            .literal("CHAT_MESSAGE")
            .default(
              getRecentBrainDataResponsePendingEventLogsItemEventEventTypeDefaultThree,
            ),
          sender: zod.enum(["Lotus", "Debug", "User", "Clinician"]),
          message_content: zod.string(),
          message_id: zod.union([zod.uuid(), zod.null()]).optional(),
        }),
        zod.object({
          event_type: zod
            .literal("TOOL_CALL")
            .default(
              getRecentBrainDataResponsePendingEventLogsItemEventEventTypeDefaultFour,
            ),
          tool_name: zod.string(),
          tool_invocation_summary: zod.string(),
        }),
        zod.object({
          event_type: zod
            .literal("INSIGHT_SENTIMENT")
            .default(
              getRecentBrainDataResponsePendingEventLogsItemEventEventTypeDefaultFive,
            ),
          insight: zod.object({
            id: zod.uuid(),
            lifecycleStage: zod.enum(["active", "dismissed"]),
            content: zod.object({
              categories: zod.array(
                zod.union([
                  zod.enum([
                    "unspecified",
                    "dataUpdate",
                    "investigatory",
                    "general",
                    "agentic",
                    "flexpa",
                    "vital",
                    "assessment",
                    "pulse",
                  ]),
                  zod.string(),
                ]),
              ),
              preview: zod.union([
                zod.union([
                  zod.object({
                    type: zod
                      .literal("text")
                      .default(
                        getRecentBrainDataResponsePendingEventLogsItemEventInsightContentPreviewTypeDefault,
                      ),
                    title: zod.string(),
                    content: zod.string(),
                  }),
                  zod.object({
                    type: zod
                      .literal("unused")
                      .default(
                        getRecentBrainDataResponsePendingEventLogsItemEventInsightContentPreviewTypeDefaultOne,
                      ),
                  }),
                ]),
                zod.unknown(),
              ]),
              expansion: zod.object({
                title: zod.string(),
                content: zod.array(
                  zod.union([
                    zod.union([
                      zod.object({
                        type: zod
                          .literal("text")
                          .default(
                            getRecentBrainDataResponsePendingEventLogsItemEventInsightContentExpansionContentItemTypeDefault,
                          ),
                        text: zod.string(),
                      }),
                      zod.object({
                        type: zod
                          .literal("ctaButton")
                          .default(
                            getRecentBrainDataResponsePendingEventLogsItemEventInsightContentExpansionContentItemTypeDefaultOne,
                          ),
                        text: zod.string(),
                        actionType: zod.string(),
                      }),
                      zod.object({
                        type: zod
                          .literal("spinner")
                          .default(
                            getRecentBrainDataResponsePendingEventLogsItemEventInsightContentExpansionContentItemTypeDefaultTwo,
                          ),
                        text: zod.string(),
                        spinnerPercentage: zod.number(),
                      }),
                      zod.object({
                        type: zod
                          .literal("assessmentCTAButton")
                          .default(
                            getRecentBrainDataResponsePendingEventLogsItemEventInsightContentExpansionContentItemTypeDefaultThree,
                          ),
                        text: zod.string(),
                        assessmentTicket: zod
                          .union([zod.unknown(), zod.null()])
                          .optional(),
                      }),
                    ]),
                    zod.unknown(),
                  ]),
                ),
              }),
            }),
            eventId: zod.union([zod.uuid(), zod.null()]).optional(),
          }),
          sentiment: zod.object({
            type: zod
              .literal("sentiment")
              .default(
                getRecentBrainDataResponsePendingEventLogsItemEventSentimentTypeDefault,
              ),
            user_id: zod.uuid(),
            target: zod.union([
              zod.object({
                type: zod
                  .literal("conversationMessage")
                  .default(
                    getRecentBrainDataResponsePendingEventLogsItemEventSentimentTargetTypeDefault,
                  ),
                id: zod.uuid(),
                value: zod
                  .union([
                    zod.object({
                      id: zod.uuid(),
                      createdAt: zod.iso.datetime({}),
                      sender: zod.enum(["Lotus", "Debug", "User", "Clinician"]),
                      status: zod.enum(["committed", "staged"]).optional(),
                      contentBlocks: zod.array(
                        zod.object({
                          id: zod.uuid(),
                          body: zod.union([
                            zod.union([
                              zod.object({
                                type: zod
                                  .literal("text")
                                  .default(
                                    getRecentBrainDataResponsePendingEventLogsItemEventSentimentTargetValueContentBlocksItemBodyTypeDefault,
                                  ),
                                stream: zod
                                  .enum(["Chat", "Thinking"])
                                  .optional(),
                                text: zod.string(),
                              }),
                              zod.object({
                                type: zod
                                  .literal("choiceChip")
                                  .default(
                                    getRecentBrainDataResponsePendingEventLogsItemEventSentimentTargetValueContentBlocksItemBodyTypeDefaultOne,
                                  ),
                                text: zod.string(),
                              }),
                              zod.object({
                                type: zod
                                  .literal("error")
                                  .default(
                                    getRecentBrainDataResponsePendingEventLogsItemEventSentimentTargetValueContentBlocksItemBodyTypeDefaultTwo,
                                  ),
                                text: zod.string(),
                              }),
                              zod.object({
                                type: zod
                                  .literal("chart")
                                  .default(
                                    getRecentBrainDataResponsePendingEventLogsItemEventSentimentTargetValueContentBlocksItemBodyTypeDefaultThree,
                                  ),
                                chartData: zod.record(
                                  zod.string(),
                                  zod.unknown(),
                                ),
                              }),
                              zod.object({
                                type: zod
                                  .literal("toolUse")
                                  .default(
                                    getRecentBrainDataResponsePendingEventLogsItemEventSentimentTargetValueContentBlocksItemBodyTypeDefaultFour,
                                  ),
                                text: zod.string(),
                              }),
                              zod.object({
                                type: zod
                                  .literal("article")
                                  .default(
                                    getRecentBrainDataResponsePendingEventLogsItemEventSentimentTargetValueContentBlocksItemBodyTypeDefaultFive,
                                  ),
                                articleData: zod.object({
                                  title: zod.string(),
                                  citation: zod.string(),
                                  abstract: zod.string(),
                                  published_date: zod.iso.datetime({}),
                                  pmcid: zod.string(),
                                  pmid: zod.string(),
                                  chunks: zod.array(zod.string()),
                                  citation_data: zod.object({
                                    pmcid: zod.string(),
                                    title: zod.string(),
                                    authors: zod.array(
                                      zod.object({
                                        surname: zod
                                          .union([zod.string(), zod.null()])
                                          .optional(),
                                        given_names: zod
                                          .union([zod.string(), zod.null()])
                                          .optional(),
                                        full_name: zod
                                          .union([zod.string(), zod.null()])
                                          .optional(),
                                      }),
                                    ),
                                    author_string: zod.string(),
                                    journal: zod.string(),
                                    pub_date: zod.string(),
                                    volume: zod
                                      .union([zod.string(), zod.null()])
                                      .optional(),
                                    issue: zod
                                      .union([zod.string(), zod.null()])
                                      .optional(),
                                    pages: zod
                                      .union([zod.string(), zod.null()])
                                      .optional(),
                                    doi: zod
                                      .union([zod.string(), zod.null()])
                                      .optional(),
                                    issn: zod
                                      .union([zod.string(), zod.null()])
                                      .optional(),
                                    pubmed_link: zod
                                      .union([zod.string(), zod.null()])
                                      .optional(),
                                    formatted: zod.object({
                                      apa: zod.string(),
                                      mla: zod.string(),
                                      vancouver: zod.string(),
                                    }),
                                  }),
                                }),
                              }),
                              zod.object({
                                type: zod
                                  .literal("sources_v2")
                                  .default(
                                    getRecentBrainDataResponsePendingEventLogsItemEventSentimentTargetValueContentBlocksItemBodyTypeDefaultSix,
                                  ),
                                sources: zod.array(
                                  zod.object({
                                    title: zod.string(),
                                    subtitle: zod.string(),
                                    content: zod.union([
                                      zod.object({
                                        type: zod
                                          .literal("table")
                                          .default(
                                            getRecentBrainDataResponsePendingEventLogsItemEventSentimentTargetValueContentBlocksItemBodySourcesItemContentTypeDefault,
                                          ),
                                        rows: zod.array(
                                          zod.record(
                                            zod.string(),
                                            zod.unknown(),
                                          ),
                                        ),
                                        columns: zod.array(zod.string()),
                                        note: zod.string(),
                                        column_schema: zod
                                          .record(
                                            zod.string(),
                                            zod.enum([
                                              "string",
                                              "integer",
                                              "float",
                                              "boolean",
                                              "datetime",
                                            ]),
                                          )
                                          .default(
                                            getRecentBrainDataResponsePendingEventLogsItemEventSentimentTargetValueContentBlocksItemBodySourcesItemContentColumnSchemaDefault,
                                          ),
                                      }),
                                      zod.object({
                                        type: zod
                                          .literal("link")
                                          .default(
                                            getRecentBrainDataResponsePendingEventLogsItemEventSentimentTargetValueContentBlocksItemBodySourcesItemContentTypeDefaultOne,
                                          ),
                                        link: zod.string(),
                                      }),
                                    ]),
                                    icon: zod
                                      .union([
                                        zod
                                          .string()
                                          .describe(
                                            "An icon identifier - opaque to the client.",
                                          ),
                                        zod.null(),
                                      ])
                                      .optional(),
                                  }),
                                ),
                              }),
                              zod.object({
                                type: zod
                                  .literal("pendingReview")
                                  .default(
                                    getRecentBrainDataResponsePendingEventLogsItemEventSentimentTargetValueContentBlocksItemBodyTypeDefaultSeven,
                                  ),
                              }),
                              zod.object({
                                type: zod
                                  .literal("chainOfThought")
                                  .default(
                                    getRecentBrainDataResponsePendingEventLogsItemEventSentimentTargetValueContentBlocksItemBodyTypeDefaultEight,
                                  ),
                                text: zod.string(),
                              }),
                              zod.object({
                                type: zod
                                  .literal("revised")
                                  .default(
                                    getRecentBrainDataResponsePendingEventLogsItemEventSentimentTargetValueContentBlocksItemBodyTypeDefaultNine,
                                  ),
                                text: zod.string(),
                              }),
                              zod.object({
                                type: zod
                                  .literal("origin")
                                  .default(
                                    getRecentBrainDataResponsePendingEventLogsItemEventSentimentTargetValueContentBlocksItemBodyTypeDefaultOnezero,
                                  ),
                                origin: zod.union([
                                  zod.enum(["insight"]),
                                  zod.unknown(),
                                ]),
                              }),
                              zod.object({
                                type: zod
                                  .literal("stagingStatus")
                                  .default(
                                    getRecentBrainDataResponsePendingEventLogsItemEventSentimentTargetValueContentBlocksItemBodyTypeDefaultOneone,
                                  ),
                                status: zod.enum(["committed", "staged"]),
                              }),
                              zod.object({
                                type: zod
                                  .literal("completeStatus")
                                  .default(
                                    getRecentBrainDataResponsePendingEventLogsItemEventSentimentTargetValueContentBlocksItemBodyTypeDefaultOnetwo,
                                  ),
                                status: zod.enum(["incomplete", "complete"]),
                              }),
                              zod.object({
                                type: zod
                                  .literal("retryStatus")
                                  .default(
                                    getRecentBrainDataResponsePendingEventLogsItemEventSentimentTargetValueContentBlocksItemBodyTypeDefaultOnethree,
                                  ),
                                status: zod.enum(["retry", "handled"]),
                                error: zod
                                  .union([
                                    zod.object({
                                      message: zod.string(),
                                      trace: zod.string(),
                                      code: zod
                                        .union([zod.string(), zod.null()])
                                        .optional(),
                                      payload: zod
                                        .union([
                                          zod.record(
                                            zod.string(),
                                            zod.unknown(),
                                          ),
                                          zod.null(),
                                        ])
                                        .optional(),
                                      status_code: zod
                                        .union([zod.number(), zod.null()])
                                        .optional(),
                                    }),
                                    zod.null(),
                                  ])
                                  .optional(),
                              }),
                              zod.object({
                                type: zod
                                  .literal("assessmentResult")
                                  .default(
                                    getRecentBrainDataResponsePendingEventLogsItemEventSentimentTargetValueContentBlocksItemBodyTypeDefaultOnefour,
                                  ),
                                assessmentResult: zod.unknown(),
                              }),
                              zod.object({
                                type: zod
                                  .literal("voiceMessageMarker")
                                  .default(
                                    getRecentBrainDataResponsePendingEventLogsItemEventSentimentTargetValueContentBlocksItemBodyTypeDefaultOnefive,
                                  ),
                                obscured: zod.boolean(),
                              }),
                              zod
                                .object({
                                  type: zod
                                    .literal("voiceUpload")
                                    .default(
                                      getRecentBrainDataResponsePendingEventLogsItemEventSentimentTargetValueContentBlocksItemBodyTypeDefaultOnesix,
                                    ),
                                  uploadId: zod.uuid(),
                                })
                                .describe(
                                  "Reference to a confirmed voice upload associated with the message.\nThis is provenance metadata, not semantic message content.",
                                ),
                              zod.object({
                                type: zod
                                  .literal("debug")
                                  .default(
                                    getRecentBrainDataResponsePendingEventLogsItemEventSentimentTargetValueContentBlocksItemBodyTypeDefaultOneseven,
                                  ),
                                title: zod.string(),
                                content: zod.string(),
                              }),
                              zod.object({
                                type: zod
                                  .literal("blank")
                                  .default(
                                    getRecentBrainDataResponsePendingEventLogsItemEventSentimentTargetValueContentBlocksItemBodyTypeDefaultOneeight,
                                  ),
                              }),
                              zod.object({
                                type: zod
                                  .literal("answerPartSuggestion")
                                  .default(
                                    getRecentBrainDataResponsePendingEventLogsItemEventSentimentTargetValueContentBlocksItemBodyTypeDefaultOnenine,
                                  ),
                                answerPart: zod.union([
                                  zod
                                    .object({
                                      answer_part_type: zod
                                        .literal("revise_message")
                                        .default(
                                          getRecentBrainDataResponsePendingEventLogsItemEventSentimentTargetValueContentBlocksItemBodyAnswerPartAnswerPartTypeDefault,
                                        ),
                                      message_id: zod.uuid(),
                                      response: zod.enum(["accept", "revise"]),
                                      new_response: zod.string(),
                                      explanation: zod
                                        .union([zod.string(), zod.null()])
                                        .optional(),
                                      send_to_patient: zod
                                        .boolean()
                                        .default(
                                          getRecentBrainDataResponsePendingEventLogsItemEventSentimentTargetValueContentBlocksItemBodyAnswerPartSendToPatientDefault,
                                        ),
                                    })
                                    .describe(
                                      "This is a response to a ReviseMessageAnswerPartRequestT. It stores the clinician's judgement on the message.",
                                    ),
                                  zod
                                    .object({
                                      answer_part_type: zod
                                        .literal("note")
                                        .default(
                                          getRecentBrainDataResponsePendingEventLogsItemEventSentimentTargetValueContentBlocksItemBodyAnswerPartAnswerPartTypeDefaultOne,
                                        ),
                                      patient_id: zod.uuid(),
                                      note: zod.string(),
                                    })
                                    .describe(
                                      "This is a response to a NoteAnswerPartRequestT. It is a note that will be entered into the EHR system.",
                                    ),
                                  zod
                                    .object({
                                      answer_part_type: zod
                                        .literal("rejected")
                                        .default(
                                          getRecentBrainDataResponsePendingEventLogsItemEventSentimentTargetValueContentBlocksItemBodyAnswerPartAnswerPartTypeDefaultTwo,
                                        ),
                                      reason: zod
                                        .union([zod.string(), zod.null()])
                                        .optional()
                                        .describe(
                                          "Optional reason for rejection",
                                        ),
                                    })
                                    .describe(
                                      "This is a response to a RejectedAnswerPartRequestT. It indicates the clinician is rejecting the entire request.",
                                    ),
                                  zod
                                    .object({
                                      answer_part_type: zod
                                        .literal("prescription")
                                        .default(
                                          getRecentBrainDataResponsePendingEventLogsItemEventSentimentTargetValueContentBlocksItemBodyAnswerPartAnswerPartTypeDefaultThree,
                                        ),
                                      patient_id: zod.uuid(),
                                      dosespot_prescription_id: zod.string(),
                                    })
                                    .describe(
                                      "This is a response to a PrescriptionAnswerPartRequestT. It stores a prescription ID that will be sent to pharmacy.",
                                    ),
                                  zod
                                    .object({
                                      answer_part_type: zod
                                        .literal("prescription_suggestion")
                                        .default(
                                          getRecentBrainDataResponsePendingEventLogsItemEventSentimentTargetValueContentBlocksItemBodyAnswerPartAnswerPartTypeDefaultFour,
                                        ),
                                      dispensable_drug_id: zod
                                        .union([zod.number(), zod.null()])
                                        .optional()
                                        .describe(
                                          "DoseSpot DispensableDrugId for the medication",
                                        ),
                                      pharmacy_id: zod
                                        .union([zod.number(), zod.null()])
                                        .optional()
                                        .describe(
                                          "DoseSpot PharmacyId for the pharmacy",
                                        ),
                                      directions: zod
                                        .union([zod.string(), zod.null()])
                                        .optional()
                                        .describe(
                                          "Suggested directions for use",
                                        ),
                                      quantity: zod
                                        .union([zod.number(), zod.null()])
                                        .optional()
                                        .describe("Suggested quantity"),
                                      refills: zod
                                        .union([zod.number(), zod.null()])
                                        .optional()
                                        .describe(
                                          "Suggested number of refills",
                                        ),
                                      notes: zod
                                        .union([zod.string(), zod.null()])
                                        .optional()
                                        .describe(
                                          "Additional notes about the prescription",
                                        ),
                                    })
                                    .describe(
                                      "Suggested prescription data that can be used to prepopulate a prescription form.",
                                    ),
                                ]),
                              }),
                              zod
                                .object({
                                  type: zod
                                    .literal("fileAttachment")
                                    .default(
                                      getRecentBrainDataResponsePendingEventLogsItemEventSentimentTargetValueContentBlocksItemBodyTypeDefaultTwozero,
                                    ),
                                  attachmentId: zod.uuid(),
                                  filename: zod
                                    .union([zod.string(), zod.null()])
                                    .optional(),
                                  mimeType: zod
                                    .union([zod.string(), zod.null()])
                                    .optional(),
                                  fileType: zod
                                    .union([
                                      zod
                                        .enum(["image", "document", "audio"])
                                        .describe("Type of file attachment."),
                                      zod.null(),
                                    ])
                                    .optional(),
                                })
                                .describe(
                                  "Reference to an uploaded file (image or PDF).\nAll metadata is stored in the database and fetched when needed.",
                                ),
                              zod.object({
                                type: zod
                                  .literal("actionChip")
                                  .default(
                                    getRecentBrainDataResponsePendingEventLogsItemEventSentimentTargetValueContentBlocksItemBodyTypeDefaultTwoone,
                                  ),
                                label: zod.string(),
                                action: zod.string(),
                              }),
                              zod
                                .object({
                                  type: zod
                                    .literal("mention")
                                    .default(
                                      getRecentBrainDataResponsePendingEventLogsItemEventSentimentTargetValueContentBlocksItemBodyTypeDefaultTwotwo,
                                    ),
                                  sourceUrl: zod.string(),
                                })
                                .describe(
                                  "Reference to a durable, resolver-backed snapshot (`LiveSource`).\n\nMentions are not rendered on the client at all -- they exist purely so the\nagent can read the underlying snapshot as a prompt fragment. Clients\nshould hide these blocks from the user-facing message view.\n\n`source_url` is a `lotus-kb:\/\/live-sources\/users\/{user_id}\/...` URL minted\nby the LiveSource promotion endpoint. The URL is owner-scoped: the\nvalidation layer drops the block if the URL is not a LiveSource URL\nowned by the calling user, so users cannot fabricate authoritative-looking\nmentions or smuggle in another user's snapshot.\n\nThe url is resolvable by the Lotus URL resolver, so the agent can cite\nit directly and the snapshot persists indefinitely (not bound to a\nRedis TTL).",
                                ),
                              zod
                                .object({
                                  type: zod
                                    .literal("directive")
                                    .default(
                                      getRecentBrainDataResponsePendingEventLogsItemEventSentimentTargetValueContentBlocksItemBodyTypeDefaultTwothree,
                                    ),
                                  directive: zod.string(),
                                })
                                .describe(
                                  "The directive a Lotus message was written to answer.\n\nThe patient never sees it; Lotus sees it as part of the message wherever\nthe message appears in its history.",
                                ),
                            ]),
                            zod.unknown(),
                          ]),
                          createdAt: zod.iso.datetime({}).optional(),
                        }),
                      ),
                      completionState: zod
                        .enum(["incomplete", "complete"])
                        .optional(),
                    }),
                    zod.null(),
                  ])
                  .optional(),
              }),
              zod.object({
                type: zod
                  .literal("insight")
                  .default(
                    getRecentBrainDataResponsePendingEventLogsItemEventSentimentTargetTypeDefaultOne,
                  ),
                id: zod.uuid(),
                value: zod
                  .union([
                    zod.object({
                      id: zod.uuid(),
                      lifecycleStage: zod.enum(["active", "dismissed"]),
                      content: zod.object({
                        categories: zod.array(
                          zod.union([
                            zod.enum([
                              "unspecified",
                              "dataUpdate",
                              "investigatory",
                              "general",
                              "agentic",
                              "flexpa",
                              "vital",
                              "assessment",
                              "pulse",
                            ]),
                            zod.string(),
                          ]),
                        ),
                        preview: zod.union([
                          zod.union([
                            zod.object({
                              type: zod
                                .literal("text")
                                .default(
                                  getRecentBrainDataResponsePendingEventLogsItemEventSentimentTargetValueContentPreviewTypeDefault,
                                ),
                              title: zod.string(),
                              content: zod.string(),
                            }),
                            zod.object({
                              type: zod
                                .literal("unused")
                                .default(
                                  getRecentBrainDataResponsePendingEventLogsItemEventSentimentTargetValueContentPreviewTypeDefaultOne,
                                ),
                            }),
                          ]),
                          zod.unknown(),
                        ]),
                        expansion: zod.object({
                          title: zod.string(),
                          content: zod.array(
                            zod.union([
                              zod.union([
                                zod.object({
                                  type: zod
                                    .literal("text")
                                    .default(
                                      getRecentBrainDataResponsePendingEventLogsItemEventSentimentTargetValueContentExpansionContentItemTypeDefault,
                                    ),
                                  text: zod.string(),
                                }),
                                zod.object({
                                  type: zod
                                    .literal("ctaButton")
                                    .default(
                                      getRecentBrainDataResponsePendingEventLogsItemEventSentimentTargetValueContentExpansionContentItemTypeDefaultOne,
                                    ),
                                  text: zod.string(),
                                  actionType: zod.string(),
                                }),
                                zod.object({
                                  type: zod
                                    .literal("spinner")
                                    .default(
                                      getRecentBrainDataResponsePendingEventLogsItemEventSentimentTargetValueContentExpansionContentItemTypeDefaultTwo,
                                    ),
                                  text: zod.string(),
                                  spinnerPercentage: zod.number(),
                                }),
                                zod.object({
                                  type: zod
                                    .literal("assessmentCTAButton")
                                    .default(
                                      getRecentBrainDataResponsePendingEventLogsItemEventSentimentTargetValueContentExpansionContentItemTypeDefaultThree,
                                    ),
                                  text: zod.string(),
                                  assessmentTicket: zod
                                    .union([zod.unknown(), zod.null()])
                                    .optional(),
                                }),
                              ]),
                              zod.unknown(),
                            ]),
                          ),
                        }),
                      }),
                      eventId: zod.union([zod.uuid(), zod.null()]).optional(),
                    }),
                    zod.null(),
                  ])
                  .optional(),
              }),
            ]),
            opinion: zod.object({
              value: zod.number(),
              note: zod.union([zod.string(), zod.null()]),
            }),
          }),
        }),
        zod
          .object({
            event_type: zod
              .literal("PULSE_SENTIMENT")
              .default(
                getRecentBrainDataResponsePendingEventLogsItemEventEventTypeDefaultSix,
              ),
            pulse_id: zod.uuid(),
            sentiment_type: zod.string(),
            value: zod.number(),
            note: zod.union([zod.string(), zod.null()]).optional(),
            signal_id: zod.union([zod.uuid(), zod.null()]).optional(),
          })
          .describe(
            "Event for tracking pulse sentiment (viewed, opened, bookmarked, liked, consumed).",
          ),
        zod
          .object({
            event_type: zod
              .literal("PULSE_GENERATED")
              .default(
                getRecentBrainDataResponsePendingEventLogsItemEventEventTypeDefaultSeven,
              ),
            timestamp: zod.iso.datetime({}),
            pulse_id: zod.uuid(),
            pulse_type: zod
              .enum(["PERSONALIZED", "GENERAL"])
              .describe(
                "Type of pulse - either personalized for the user or general for all users.",
              ),
            signal_id: zod.union([zod.uuid(), zod.null()]).optional(),
          })
          .describe(
            "Event for tracking when a single pulse is generated and added to a user's buffer.\n\nCovers both personalized pulses (generated specifically for the user) and\ngeneral pulses (materialized from the global cache).",
          ),
        zod
          .object({
            event_type: zod
              .literal("PULSE_CONSUMED")
              .default(
                getRecentBrainDataResponsePendingEventLogsItemEventEventTypeDefaultEight,
              ),
            timestamp: zod.iso.datetime({}),
            pulse_id: zod.uuid(),
            signal_id: zod.union([zod.uuid(), zod.null()]).optional(),
          })
          .describe(
            "Event for tracking when a single pulse is consumed by a user.",
          ),
        zod.object({
          event_type: zod
            .literal("LOTUS_BRAIN_INVOCATION_SKIPPED")
            .default(
              getRecentBrainDataResponsePendingEventLogsItemEventEventTypeDefaultNine,
            ),
        }),
        zod
          .object({
            event_type: zod
              .literal("LOTUS_BRAIN_SWARM_INVOCATION_SKIPPED")
              .default(
                getRecentBrainDataResponsePendingEventLogsItemEventEventTypeDefaultOnezero,
              ),
          })
          .describe(
            "Batched event containing all agents skipped during a single swarm invocation.",
          ),
        zod.object({
          event_type: zod
            .literal("LOTUS_BRAIN_INVOCATION_START")
            .default(
              getRecentBrainDataResponsePendingEventLogsItemEventEventTypeDefaultOneone,
            ),
        }),
        zod.object({
          event_type: zod
            .literal("LOTUS_BRAIN_INVOCATION")
            .default(
              getRecentBrainDataResponsePendingEventLogsItemEventEventTypeDefaultOnetwo,
            ),
        }),
        zod.object({
          event_type: zod
            .literal("CASE_STARTED")
            .default(
              getRecentBrainDataResponsePendingEventLogsItemEventEventTypeDefaultOnethree,
            ),
          timestamp: zod.iso.datetime({}),
          case_id: zod.uuid(),
          conversation_id: zod.uuid(),
          patient_id: zod.uuid(),
        }),
        zod.object({
          event_type: zod
            .literal("CASE_COMPLETED")
            .default(
              getRecentBrainDataResponsePendingEventLogsItemEventEventTypeDefaultOnefour,
            ),
          timestamp: zod.iso.datetime({}),
          case_id: zod.uuid(),
          conversation_id: zod.uuid(),
          patient_id: zod.uuid(),
          clinician_ids: zod.array(zod.uuid()),
          clinician_names: zod.array(zod.string()),
        }),
        zod.object({
          event_type: zod
            .literal("CASE_ESCALATED")
            .default(
              getRecentBrainDataResponsePendingEventLogsItemEventEventTypeDefaultOnefive,
            ),
          timestamp: zod.iso.datetime({}),
          conversation_id: zod.union([zod.uuid(), zod.null()]),
          urgency: zod.string(),
          title: zod.string(),
        }),
        zod.object({
          event_type: zod
            .literal("TRANSMIT_CASE_SUMMARY")
            .default(
              getRecentBrainDataResponsePendingEventLogsItemEventEventTypeDefaultOnesix,
            ),
          timestamp: zod.iso.datetime({}),
          case_id: zod.uuid(),
          conversation_id: zod.uuid(),
          patient_id: zod.uuid(),
          clinician_ids: zod.array(zod.uuid()),
          clinician_names: zod.array(zod.string()),
        }),
        zod.object({
          event_type: zod
            .literal("RESOLVED_REQUEST")
            .default(
              getRecentBrainDataResponsePendingEventLogsItemEventEventTypeDefaultOneseven,
            ),
          timestamp: zod.iso.datetime({}),
          request_id: zod.uuid(),
          clinician_id: zod.uuid(),
          clinician_name: zod.string(),
        }),
        zod.object({
          event_type: zod
            .literal("REQUEST_CREATED")
            .default(
              getRecentBrainDataResponsePendingEventLogsItemEventEventTypeDefaultOneeight,
            ),
          timestamp: zod.iso.datetime({}),
          request_id: zod.uuid(),
          title: zod.string(),
        }),
        zod.object({
          event_type: zod
            .literal("REQUEST_RESOLVED")
            .default(
              getRecentBrainDataResponsePendingEventLogsItemEventEventTypeDefaultOnenine,
            ),
          timestamp: zod.iso.datetime({}),
          request_id: zod.uuid(),
          title: zod.string(),
        }),
        zod.object({
          event_type: zod
            .literal("QUESTION_REPETITION_CHECK")
            .default(
              getRecentBrainDataResponsePendingEventLogsItemEventEventTypeDefaultTwozero,
            ),
        }),
        zod
          .object({
            event_type: zod
              .literal("REQUEST_SHOT_CLOCK_EXCEEDED")
              .default(
                getRecentBrainDataResponsePendingEventLogsItemEventEventTypeDefaultTwoone,
              ),
            timestamp: zod.iso.datetime({}),
            request_id: zod.uuid(),
            title: zod.string(),
            urgency: zod.string(),
            open_duration_hours: zod.number(),
          })
          .describe(
            "Fired when an open request has exceeded its allowable time without resolution.",
          ),
        zod
          .object({
            event_type: zod
              .literal("PRE_REQUEST_ESCALATION_OVERDUE")
              .default(
                getRecentBrainDataResponsePendingEventLogsItemEventEventTypeDefaultTwotwo,
              ),
            timestamp: zod.iso.datetime({}),
            pre_request_id: zod.uuid(),
            title: zod.string(),
            pending_duration_hours: zod.number(),
          })
          .describe(
            "Fired when a pending pre-request has not been escalated within the allowed window.",
          ),
        zod
          .object({
            event_type: zod
              .literal("VERIFIED_DISCOVERY")
              .default(
                getRecentBrainDataResponsePendingEventLogsItemEventEventTypeDefaultTwothree,
              ),
            outcome: zod.enum(["success", "failure"]),
            duration_ms: zod.number(),
            failure_reason: zod.union([zod.string(), zod.null()]).optional(),
            http_status: zod.union([zod.number(), zod.null()]).optional(),
          })
          .describe(
            "Outcome of a Verified Inc 1-Click Signup discovery API attempt (dossier plugin).",
          ),
      ]),
      user_id: zod.uuid(),
      timestamp: zod.iso.datetime({}),
      embedding: zod.union([zod.array(zod.number()), zod.null()]).optional(),
    }),
  ),
  processed_event_logs: zod.array(
    zod.object({
      event: zod.union([
        zod.object({
          event_type: zod
            .literal("HEALTHKIT_UPLOAD")
            .default(
              getRecentBrainDataResponseProcessedEventLogsItemEventEventTypeDefault,
            ),
          timestamp: zod.iso.datetime({}),
          updates: zod.record(zod.string(), zod.number()),
        }),
        zod.object({
          event_type: zod
            .literal("EHR_SYNC")
            .default(
              getRecentBrainDataResponseProcessedEventLogsItemEventEventTypeDefaultOne,
            ),
          timestamp: zod.iso.datetime({}),
          updates: zod.record(zod.string(), zod.number()),
        }),
        zod.object({
          event_type: zod
            .literal("FLEXPA_SYNC")
            .default(
              getRecentBrainDataResponseProcessedEventLogsItemEventEventTypeDefaultTwo,
            ),
          timestamp: zod.iso.datetime({}),
          updates: zod.record(zod.string(), zod.number()),
        }),
        zod.object({
          event_type: zod
            .literal("CHAT_MESSAGE")
            .default(
              getRecentBrainDataResponseProcessedEventLogsItemEventEventTypeDefaultThree,
            ),
          sender: zod.enum(["Lotus", "Debug", "User", "Clinician"]),
          message_content: zod.string(),
          message_id: zod.union([zod.uuid(), zod.null()]).optional(),
        }),
        zod.object({
          event_type: zod
            .literal("TOOL_CALL")
            .default(
              getRecentBrainDataResponseProcessedEventLogsItemEventEventTypeDefaultFour,
            ),
          tool_name: zod.string(),
          tool_invocation_summary: zod.string(),
        }),
        zod.object({
          event_type: zod
            .literal("INSIGHT_SENTIMENT")
            .default(
              getRecentBrainDataResponseProcessedEventLogsItemEventEventTypeDefaultFive,
            ),
          insight: zod.object({
            id: zod.uuid(),
            lifecycleStage: zod.enum(["active", "dismissed"]),
            content: zod.object({
              categories: zod.array(
                zod.union([
                  zod.enum([
                    "unspecified",
                    "dataUpdate",
                    "investigatory",
                    "general",
                    "agentic",
                    "flexpa",
                    "vital",
                    "assessment",
                    "pulse",
                  ]),
                  zod.string(),
                ]),
              ),
              preview: zod.union([
                zod.union([
                  zod.object({
                    type: zod
                      .literal("text")
                      .default(
                        getRecentBrainDataResponseProcessedEventLogsItemEventInsightContentPreviewTypeDefault,
                      ),
                    title: zod.string(),
                    content: zod.string(),
                  }),
                  zod.object({
                    type: zod
                      .literal("unused")
                      .default(
                        getRecentBrainDataResponseProcessedEventLogsItemEventInsightContentPreviewTypeDefaultOne,
                      ),
                  }),
                ]),
                zod.unknown(),
              ]),
              expansion: zod.object({
                title: zod.string(),
                content: zod.array(
                  zod.union([
                    zod.union([
                      zod.object({
                        type: zod
                          .literal("text")
                          .default(
                            getRecentBrainDataResponseProcessedEventLogsItemEventInsightContentExpansionContentItemTypeDefault,
                          ),
                        text: zod.string(),
                      }),
                      zod.object({
                        type: zod
                          .literal("ctaButton")
                          .default(
                            getRecentBrainDataResponseProcessedEventLogsItemEventInsightContentExpansionContentItemTypeDefaultOne,
                          ),
                        text: zod.string(),
                        actionType: zod.string(),
                      }),
                      zod.object({
                        type: zod
                          .literal("spinner")
                          .default(
                            getRecentBrainDataResponseProcessedEventLogsItemEventInsightContentExpansionContentItemTypeDefaultTwo,
                          ),
                        text: zod.string(),
                        spinnerPercentage: zod.number(),
                      }),
                      zod.object({
                        type: zod
                          .literal("assessmentCTAButton")
                          .default(
                            getRecentBrainDataResponseProcessedEventLogsItemEventInsightContentExpansionContentItemTypeDefaultThree,
                          ),
                        text: zod.string(),
                        assessmentTicket: zod
                          .union([zod.unknown(), zod.null()])
                          .optional(),
                      }),
                    ]),
                    zod.unknown(),
                  ]),
                ),
              }),
            }),
            eventId: zod.union([zod.uuid(), zod.null()]).optional(),
          }),
          sentiment: zod.object({
            type: zod
              .literal("sentiment")
              .default(
                getRecentBrainDataResponseProcessedEventLogsItemEventSentimentTypeDefault,
              ),
            user_id: zod.uuid(),
            target: zod.union([
              zod.object({
                type: zod
                  .literal("conversationMessage")
                  .default(
                    getRecentBrainDataResponseProcessedEventLogsItemEventSentimentTargetTypeDefault,
                  ),
                id: zod.uuid(),
                value: zod
                  .union([
                    zod.object({
                      id: zod.uuid(),
                      createdAt: zod.iso.datetime({}),
                      sender: zod.enum(["Lotus", "Debug", "User", "Clinician"]),
                      status: zod.enum(["committed", "staged"]).optional(),
                      contentBlocks: zod.array(
                        zod.object({
                          id: zod.uuid(),
                          body: zod.union([
                            zod.union([
                              zod.object({
                                type: zod
                                  .literal("text")
                                  .default(
                                    getRecentBrainDataResponseProcessedEventLogsItemEventSentimentTargetValueContentBlocksItemBodyTypeDefault,
                                  ),
                                stream: zod
                                  .enum(["Chat", "Thinking"])
                                  .optional(),
                                text: zod.string(),
                              }),
                              zod.object({
                                type: zod
                                  .literal("choiceChip")
                                  .default(
                                    getRecentBrainDataResponseProcessedEventLogsItemEventSentimentTargetValueContentBlocksItemBodyTypeDefaultOne,
                                  ),
                                text: zod.string(),
                              }),
                              zod.object({
                                type: zod
                                  .literal("error")
                                  .default(
                                    getRecentBrainDataResponseProcessedEventLogsItemEventSentimentTargetValueContentBlocksItemBodyTypeDefaultTwo,
                                  ),
                                text: zod.string(),
                              }),
                              zod.object({
                                type: zod
                                  .literal("chart")
                                  .default(
                                    getRecentBrainDataResponseProcessedEventLogsItemEventSentimentTargetValueContentBlocksItemBodyTypeDefaultThree,
                                  ),
                                chartData: zod.record(
                                  zod.string(),
                                  zod.unknown(),
                                ),
                              }),
                              zod.object({
                                type: zod
                                  .literal("toolUse")
                                  .default(
                                    getRecentBrainDataResponseProcessedEventLogsItemEventSentimentTargetValueContentBlocksItemBodyTypeDefaultFour,
                                  ),
                                text: zod.string(),
                              }),
                              zod.object({
                                type: zod
                                  .literal("article")
                                  .default(
                                    getRecentBrainDataResponseProcessedEventLogsItemEventSentimentTargetValueContentBlocksItemBodyTypeDefaultFive,
                                  ),
                                articleData: zod.object({
                                  title: zod.string(),
                                  citation: zod.string(),
                                  abstract: zod.string(),
                                  published_date: zod.iso.datetime({}),
                                  pmcid: zod.string(),
                                  pmid: zod.string(),
                                  chunks: zod.array(zod.string()),
                                  citation_data: zod.object({
                                    pmcid: zod.string(),
                                    title: zod.string(),
                                    authors: zod.array(
                                      zod.object({
                                        surname: zod
                                          .union([zod.string(), zod.null()])
                                          .optional(),
                                        given_names: zod
                                          .union([zod.string(), zod.null()])
                                          .optional(),
                                        full_name: zod
                                          .union([zod.string(), zod.null()])
                                          .optional(),
                                      }),
                                    ),
                                    author_string: zod.string(),
                                    journal: zod.string(),
                                    pub_date: zod.string(),
                                    volume: zod
                                      .union([zod.string(), zod.null()])
                                      .optional(),
                                    issue: zod
                                      .union([zod.string(), zod.null()])
                                      .optional(),
                                    pages: zod
                                      .union([zod.string(), zod.null()])
                                      .optional(),
                                    doi: zod
                                      .union([zod.string(), zod.null()])
                                      .optional(),
                                    issn: zod
                                      .union([zod.string(), zod.null()])
                                      .optional(),
                                    pubmed_link: zod
                                      .union([zod.string(), zod.null()])
                                      .optional(),
                                    formatted: zod.object({
                                      apa: zod.string(),
                                      mla: zod.string(),
                                      vancouver: zod.string(),
                                    }),
                                  }),
                                }),
                              }),
                              zod.object({
                                type: zod
                                  .literal("sources_v2")
                                  .default(
                                    getRecentBrainDataResponseProcessedEventLogsItemEventSentimentTargetValueContentBlocksItemBodyTypeDefaultSix,
                                  ),
                                sources: zod.array(
                                  zod.object({
                                    title: zod.string(),
                                    subtitle: zod.string(),
                                    content: zod.union([
                                      zod.object({
                                        type: zod
                                          .literal("table")
                                          .default(
                                            getRecentBrainDataResponseProcessedEventLogsItemEventSentimentTargetValueContentBlocksItemBodySourcesItemContentTypeDefault,
                                          ),
                                        rows: zod.array(
                                          zod.record(
                                            zod.string(),
                                            zod.unknown(),
                                          ),
                                        ),
                                        columns: zod.array(zod.string()),
                                        note: zod.string(),
                                        column_schema: zod
                                          .record(
                                            zod.string(),
                                            zod.enum([
                                              "string",
                                              "integer",
                                              "float",
                                              "boolean",
                                              "datetime",
                                            ]),
                                          )
                                          .default(
                                            getRecentBrainDataResponseProcessedEventLogsItemEventSentimentTargetValueContentBlocksItemBodySourcesItemContentColumnSchemaDefault,
                                          ),
                                      }),
                                      zod.object({
                                        type: zod
                                          .literal("link")
                                          .default(
                                            getRecentBrainDataResponseProcessedEventLogsItemEventSentimentTargetValueContentBlocksItemBodySourcesItemContentTypeDefaultOne,
                                          ),
                                        link: zod.string(),
                                      }),
                                    ]),
                                    icon: zod
                                      .union([
                                        zod
                                          .string()
                                          .describe(
                                            "An icon identifier - opaque to the client.",
                                          ),
                                        zod.null(),
                                      ])
                                      .optional(),
                                  }),
                                ),
                              }),
                              zod.object({
                                type: zod
                                  .literal("pendingReview")
                                  .default(
                                    getRecentBrainDataResponseProcessedEventLogsItemEventSentimentTargetValueContentBlocksItemBodyTypeDefaultSeven,
                                  ),
                              }),
                              zod.object({
                                type: zod
                                  .literal("chainOfThought")
                                  .default(
                                    getRecentBrainDataResponseProcessedEventLogsItemEventSentimentTargetValueContentBlocksItemBodyTypeDefaultEight,
                                  ),
                                text: zod.string(),
                              }),
                              zod.object({
                                type: zod
                                  .literal("revised")
                                  .default(
                                    getRecentBrainDataResponseProcessedEventLogsItemEventSentimentTargetValueContentBlocksItemBodyTypeDefaultNine,
                                  ),
                                text: zod.string(),
                              }),
                              zod.object({
                                type: zod
                                  .literal("origin")
                                  .default(
                                    getRecentBrainDataResponseProcessedEventLogsItemEventSentimentTargetValueContentBlocksItemBodyTypeDefaultOnezero,
                                  ),
                                origin: zod.union([
                                  zod.enum(["insight"]),
                                  zod.unknown(),
                                ]),
                              }),
                              zod.object({
                                type: zod
                                  .literal("stagingStatus")
                                  .default(
                                    getRecentBrainDataResponseProcessedEventLogsItemEventSentimentTargetValueContentBlocksItemBodyTypeDefaultOneone,
                                  ),
                                status: zod.enum(["committed", "staged"]),
                              }),
                              zod.object({
                                type: zod
                                  .literal("completeStatus")
                                  .default(
                                    getRecentBrainDataResponseProcessedEventLogsItemEventSentimentTargetValueContentBlocksItemBodyTypeDefaultOnetwo,
                                  ),
                                status: zod.enum(["incomplete", "complete"]),
                              }),
                              zod.object({
                                type: zod
                                  .literal("retryStatus")
                                  .default(
                                    getRecentBrainDataResponseProcessedEventLogsItemEventSentimentTargetValueContentBlocksItemBodyTypeDefaultOnethree,
                                  ),
                                status: zod.enum(["retry", "handled"]),
                                error: zod
                                  .union([
                                    zod.object({
                                      message: zod.string(),
                                      trace: zod.string(),
                                      code: zod
                                        .union([zod.string(), zod.null()])
                                        .optional(),
                                      payload: zod
                                        .union([
                                          zod.record(
                                            zod.string(),
                                            zod.unknown(),
                                          ),
                                          zod.null(),
                                        ])
                                        .optional(),
                                      status_code: zod
                                        .union([zod.number(), zod.null()])
                                        .optional(),
                                    }),
                                    zod.null(),
                                  ])
                                  .optional(),
                              }),
                              zod.object({
                                type: zod
                                  .literal("assessmentResult")
                                  .default(
                                    getRecentBrainDataResponseProcessedEventLogsItemEventSentimentTargetValueContentBlocksItemBodyTypeDefaultOnefour,
                                  ),
                                assessmentResult: zod.unknown(),
                              }),
                              zod.object({
                                type: zod
                                  .literal("voiceMessageMarker")
                                  .default(
                                    getRecentBrainDataResponseProcessedEventLogsItemEventSentimentTargetValueContentBlocksItemBodyTypeDefaultOnefive,
                                  ),
                                obscured: zod.boolean(),
                              }),
                              zod
                                .object({
                                  type: zod
                                    .literal("voiceUpload")
                                    .default(
                                      getRecentBrainDataResponseProcessedEventLogsItemEventSentimentTargetValueContentBlocksItemBodyTypeDefaultOnesix,
                                    ),
                                  uploadId: zod.uuid(),
                                })
                                .describe(
                                  "Reference to a confirmed voice upload associated with the message.\nThis is provenance metadata, not semantic message content.",
                                ),
                              zod.object({
                                type: zod
                                  .literal("debug")
                                  .default(
                                    getRecentBrainDataResponseProcessedEventLogsItemEventSentimentTargetValueContentBlocksItemBodyTypeDefaultOneseven,
                                  ),
                                title: zod.string(),
                                content: zod.string(),
                              }),
                              zod.object({
                                type: zod
                                  .literal("blank")
                                  .default(
                                    getRecentBrainDataResponseProcessedEventLogsItemEventSentimentTargetValueContentBlocksItemBodyTypeDefaultOneeight,
                                  ),
                              }),
                              zod.object({
                                type: zod
                                  .literal("answerPartSuggestion")
                                  .default(
                                    getRecentBrainDataResponseProcessedEventLogsItemEventSentimentTargetValueContentBlocksItemBodyTypeDefaultOnenine,
                                  ),
                                answerPart: zod.union([
                                  zod
                                    .object({
                                      answer_part_type: zod
                                        .literal("revise_message")
                                        .default(
                                          getRecentBrainDataResponseProcessedEventLogsItemEventSentimentTargetValueContentBlocksItemBodyAnswerPartAnswerPartTypeDefault,
                                        ),
                                      message_id: zod.uuid(),
                                      response: zod.enum(["accept", "revise"]),
                                      new_response: zod.string(),
                                      explanation: zod
                                        .union([zod.string(), zod.null()])
                                        .optional(),
                                      send_to_patient: zod
                                        .boolean()
                                        .default(
                                          getRecentBrainDataResponseProcessedEventLogsItemEventSentimentTargetValueContentBlocksItemBodyAnswerPartSendToPatientDefault,
                                        ),
                                    })
                                    .describe(
                                      "This is a response to a ReviseMessageAnswerPartRequestT. It stores the clinician's judgement on the message.",
                                    ),
                                  zod
                                    .object({
                                      answer_part_type: zod
                                        .literal("note")
                                        .default(
                                          getRecentBrainDataResponseProcessedEventLogsItemEventSentimentTargetValueContentBlocksItemBodyAnswerPartAnswerPartTypeDefaultOne,
                                        ),
                                      patient_id: zod.uuid(),
                                      note: zod.string(),
                                    })
                                    .describe(
                                      "This is a response to a NoteAnswerPartRequestT. It is a note that will be entered into the EHR system.",
                                    ),
                                  zod
                                    .object({
                                      answer_part_type: zod
                                        .literal("rejected")
                                        .default(
                                          getRecentBrainDataResponseProcessedEventLogsItemEventSentimentTargetValueContentBlocksItemBodyAnswerPartAnswerPartTypeDefaultTwo,
                                        ),
                                      reason: zod
                                        .union([zod.string(), zod.null()])
                                        .optional()
                                        .describe(
                                          "Optional reason for rejection",
                                        ),
                                    })
                                    .describe(
                                      "This is a response to a RejectedAnswerPartRequestT. It indicates the clinician is rejecting the entire request.",
                                    ),
                                  zod
                                    .object({
                                      answer_part_type: zod
                                        .literal("prescription")
                                        .default(
                                          getRecentBrainDataResponseProcessedEventLogsItemEventSentimentTargetValueContentBlocksItemBodyAnswerPartAnswerPartTypeDefaultThree,
                                        ),
                                      patient_id: zod.uuid(),
                                      dosespot_prescription_id: zod.string(),
                                    })
                                    .describe(
                                      "This is a response to a PrescriptionAnswerPartRequestT. It stores a prescription ID that will be sent to pharmacy.",
                                    ),
                                  zod
                                    .object({
                                      answer_part_type: zod
                                        .literal("prescription_suggestion")
                                        .default(
                                          getRecentBrainDataResponseProcessedEventLogsItemEventSentimentTargetValueContentBlocksItemBodyAnswerPartAnswerPartTypeDefaultFour,
                                        ),
                                      dispensable_drug_id: zod
                                        .union([zod.number(), zod.null()])
                                        .optional()
                                        .describe(
                                          "DoseSpot DispensableDrugId for the medication",
                                        ),
                                      pharmacy_id: zod
                                        .union([zod.number(), zod.null()])
                                        .optional()
                                        .describe(
                                          "DoseSpot PharmacyId for the pharmacy",
                                        ),
                                      directions: zod
                                        .union([zod.string(), zod.null()])
                                        .optional()
                                        .describe(
                                          "Suggested directions for use",
                                        ),
                                      quantity: zod
                                        .union([zod.number(), zod.null()])
                                        .optional()
                                        .describe("Suggested quantity"),
                                      refills: zod
                                        .union([zod.number(), zod.null()])
                                        .optional()
                                        .describe(
                                          "Suggested number of refills",
                                        ),
                                      notes: zod
                                        .union([zod.string(), zod.null()])
                                        .optional()
                                        .describe(
                                          "Additional notes about the prescription",
                                        ),
                                    })
                                    .describe(
                                      "Suggested prescription data that can be used to prepopulate a prescription form.",
                                    ),
                                ]),
                              }),
                              zod
                                .object({
                                  type: zod
                                    .literal("fileAttachment")
                                    .default(
                                      getRecentBrainDataResponseProcessedEventLogsItemEventSentimentTargetValueContentBlocksItemBodyTypeDefaultTwozero,
                                    ),
                                  attachmentId: zod.uuid(),
                                  filename: zod
                                    .union([zod.string(), zod.null()])
                                    .optional(),
                                  mimeType: zod
                                    .union([zod.string(), zod.null()])
                                    .optional(),
                                  fileType: zod
                                    .union([
                                      zod
                                        .enum(["image", "document", "audio"])
                                        .describe("Type of file attachment."),
                                      zod.null(),
                                    ])
                                    .optional(),
                                })
                                .describe(
                                  "Reference to an uploaded file (image or PDF).\nAll metadata is stored in the database and fetched when needed.",
                                ),
                              zod.object({
                                type: zod
                                  .literal("actionChip")
                                  .default(
                                    getRecentBrainDataResponseProcessedEventLogsItemEventSentimentTargetValueContentBlocksItemBodyTypeDefaultTwoone,
                                  ),
                                label: zod.string(),
                                action: zod.string(),
                              }),
                              zod
                                .object({
                                  type: zod
                                    .literal("mention")
                                    .default(
                                      getRecentBrainDataResponseProcessedEventLogsItemEventSentimentTargetValueContentBlocksItemBodyTypeDefaultTwotwo,
                                    ),
                                  sourceUrl: zod.string(),
                                })
                                .describe(
                                  "Reference to a durable, resolver-backed snapshot (`LiveSource`).\n\nMentions are not rendered on the client at all -- they exist purely so the\nagent can read the underlying snapshot as a prompt fragment. Clients\nshould hide these blocks from the user-facing message view.\n\n`source_url` is a `lotus-kb:\/\/live-sources\/users\/{user_id}\/...` URL minted\nby the LiveSource promotion endpoint. The URL is owner-scoped: the\nvalidation layer drops the block if the URL is not a LiveSource URL\nowned by the calling user, so users cannot fabricate authoritative-looking\nmentions or smuggle in another user's snapshot.\n\nThe url is resolvable by the Lotus URL resolver, so the agent can cite\nit directly and the snapshot persists indefinitely (not bound to a\nRedis TTL).",
                                ),
                              zod
                                .object({
                                  type: zod
                                    .literal("directive")
                                    .default(
                                      getRecentBrainDataResponseProcessedEventLogsItemEventSentimentTargetValueContentBlocksItemBodyTypeDefaultTwothree,
                                    ),
                                  directive: zod.string(),
                                })
                                .describe(
                                  "The directive a Lotus message was written to answer.\n\nThe patient never sees it; Lotus sees it as part of the message wherever\nthe message appears in its history.",
                                ),
                            ]),
                            zod.unknown(),
                          ]),
                          createdAt: zod.iso.datetime({}).optional(),
                        }),
                      ),
                      completionState: zod
                        .enum(["incomplete", "complete"])
                        .optional(),
                    }),
                    zod.null(),
                  ])
                  .optional(),
              }),
              zod.object({
                type: zod
                  .literal("insight")
                  .default(
                    getRecentBrainDataResponseProcessedEventLogsItemEventSentimentTargetTypeDefaultOne,
                  ),
                id: zod.uuid(),
                value: zod
                  .union([
                    zod.object({
                      id: zod.uuid(),
                      lifecycleStage: zod.enum(["active", "dismissed"]),
                      content: zod.object({
                        categories: zod.array(
                          zod.union([
                            zod.enum([
                              "unspecified",
                              "dataUpdate",
                              "investigatory",
                              "general",
                              "agentic",
                              "flexpa",
                              "vital",
                              "assessment",
                              "pulse",
                            ]),
                            zod.string(),
                          ]),
                        ),
                        preview: zod.union([
                          zod.union([
                            zod.object({
                              type: zod
                                .literal("text")
                                .default(
                                  getRecentBrainDataResponseProcessedEventLogsItemEventSentimentTargetValueContentPreviewTypeDefault,
                                ),
                              title: zod.string(),
                              content: zod.string(),
                            }),
                            zod.object({
                              type: zod
                                .literal("unused")
                                .default(
                                  getRecentBrainDataResponseProcessedEventLogsItemEventSentimentTargetValueContentPreviewTypeDefaultOne,
                                ),
                            }),
                          ]),
                          zod.unknown(),
                        ]),
                        expansion: zod.object({
                          title: zod.string(),
                          content: zod.array(
                            zod.union([
                              zod.union([
                                zod.object({
                                  type: zod
                                    .literal("text")
                                    .default(
                                      getRecentBrainDataResponseProcessedEventLogsItemEventSentimentTargetValueContentExpansionContentItemTypeDefault,
                                    ),
                                  text: zod.string(),
                                }),
                                zod.object({
                                  type: zod
                                    .literal("ctaButton")
                                    .default(
                                      getRecentBrainDataResponseProcessedEventLogsItemEventSentimentTargetValueContentExpansionContentItemTypeDefaultOne,
                                    ),
                                  text: zod.string(),
                                  actionType: zod.string(),
                                }),
                                zod.object({
                                  type: zod
                                    .literal("spinner")
                                    .default(
                                      getRecentBrainDataResponseProcessedEventLogsItemEventSentimentTargetValueContentExpansionContentItemTypeDefaultTwo,
                                    ),
                                  text: zod.string(),
                                  spinnerPercentage: zod.number(),
                                }),
                                zod.object({
                                  type: zod
                                    .literal("assessmentCTAButton")
                                    .default(
                                      getRecentBrainDataResponseProcessedEventLogsItemEventSentimentTargetValueContentExpansionContentItemTypeDefaultThree,
                                    ),
                                  text: zod.string(),
                                  assessmentTicket: zod
                                    .union([zod.unknown(), zod.null()])
                                    .optional(),
                                }),
                              ]),
                              zod.unknown(),
                            ]),
                          ),
                        }),
                      }),
                      eventId: zod.union([zod.uuid(), zod.null()]).optional(),
                    }),
                    zod.null(),
                  ])
                  .optional(),
              }),
            ]),
            opinion: zod.object({
              value: zod.number(),
              note: zod.union([zod.string(), zod.null()]),
            }),
          }),
        }),
        zod
          .object({
            event_type: zod
              .literal("PULSE_SENTIMENT")
              .default(
                getRecentBrainDataResponseProcessedEventLogsItemEventEventTypeDefaultSix,
              ),
            pulse_id: zod.uuid(),
            sentiment_type: zod.string(),
            value: zod.number(),
            note: zod.union([zod.string(), zod.null()]).optional(),
            signal_id: zod.union([zod.uuid(), zod.null()]).optional(),
          })
          .describe(
            "Event for tracking pulse sentiment (viewed, opened, bookmarked, liked, consumed).",
          ),
        zod
          .object({
            event_type: zod
              .literal("PULSE_GENERATED")
              .default(
                getRecentBrainDataResponseProcessedEventLogsItemEventEventTypeDefaultSeven,
              ),
            timestamp: zod.iso.datetime({}),
            pulse_id: zod.uuid(),
            pulse_type: zod
              .enum(["PERSONALIZED", "GENERAL"])
              .describe(
                "Type of pulse - either personalized for the user or general for all users.",
              ),
            signal_id: zod.union([zod.uuid(), zod.null()]).optional(),
          })
          .describe(
            "Event for tracking when a single pulse is generated and added to a user's buffer.\n\nCovers both personalized pulses (generated specifically for the user) and\ngeneral pulses (materialized from the global cache).",
          ),
        zod
          .object({
            event_type: zod
              .literal("PULSE_CONSUMED")
              .default(
                getRecentBrainDataResponseProcessedEventLogsItemEventEventTypeDefaultEight,
              ),
            timestamp: zod.iso.datetime({}),
            pulse_id: zod.uuid(),
            signal_id: zod.union([zod.uuid(), zod.null()]).optional(),
          })
          .describe(
            "Event for tracking when a single pulse is consumed by a user.",
          ),
        zod.object({
          event_type: zod
            .literal("LOTUS_BRAIN_INVOCATION_SKIPPED")
            .default(
              getRecentBrainDataResponseProcessedEventLogsItemEventEventTypeDefaultNine,
            ),
        }),
        zod
          .object({
            event_type: zod
              .literal("LOTUS_BRAIN_SWARM_INVOCATION_SKIPPED")
              .default(
                getRecentBrainDataResponseProcessedEventLogsItemEventEventTypeDefaultOnezero,
              ),
          })
          .describe(
            "Batched event containing all agents skipped during a single swarm invocation.",
          ),
        zod.object({
          event_type: zod
            .literal("LOTUS_BRAIN_INVOCATION_START")
            .default(
              getRecentBrainDataResponseProcessedEventLogsItemEventEventTypeDefaultOneone,
            ),
        }),
        zod.object({
          event_type: zod
            .literal("LOTUS_BRAIN_INVOCATION")
            .default(
              getRecentBrainDataResponseProcessedEventLogsItemEventEventTypeDefaultOnetwo,
            ),
        }),
        zod.object({
          event_type: zod
            .literal("CASE_STARTED")
            .default(
              getRecentBrainDataResponseProcessedEventLogsItemEventEventTypeDefaultOnethree,
            ),
          timestamp: zod.iso.datetime({}),
          case_id: zod.uuid(),
          conversation_id: zod.uuid(),
          patient_id: zod.uuid(),
        }),
        zod.object({
          event_type: zod
            .literal("CASE_COMPLETED")
            .default(
              getRecentBrainDataResponseProcessedEventLogsItemEventEventTypeDefaultOnefour,
            ),
          timestamp: zod.iso.datetime({}),
          case_id: zod.uuid(),
          conversation_id: zod.uuid(),
          patient_id: zod.uuid(),
          clinician_ids: zod.array(zod.uuid()),
          clinician_names: zod.array(zod.string()),
        }),
        zod.object({
          event_type: zod
            .literal("CASE_ESCALATED")
            .default(
              getRecentBrainDataResponseProcessedEventLogsItemEventEventTypeDefaultOnefive,
            ),
          timestamp: zod.iso.datetime({}),
          conversation_id: zod.union([zod.uuid(), zod.null()]),
          urgency: zod.string(),
          title: zod.string(),
        }),
        zod.object({
          event_type: zod
            .literal("TRANSMIT_CASE_SUMMARY")
            .default(
              getRecentBrainDataResponseProcessedEventLogsItemEventEventTypeDefaultOnesix,
            ),
          timestamp: zod.iso.datetime({}),
          case_id: zod.uuid(),
          conversation_id: zod.uuid(),
          patient_id: zod.uuid(),
          clinician_ids: zod.array(zod.uuid()),
          clinician_names: zod.array(zod.string()),
        }),
        zod.object({
          event_type: zod
            .literal("RESOLVED_REQUEST")
            .default(
              getRecentBrainDataResponseProcessedEventLogsItemEventEventTypeDefaultOneseven,
            ),
          timestamp: zod.iso.datetime({}),
          request_id: zod.uuid(),
          clinician_id: zod.uuid(),
          clinician_name: zod.string(),
        }),
        zod.object({
          event_type: zod
            .literal("REQUEST_CREATED")
            .default(
              getRecentBrainDataResponseProcessedEventLogsItemEventEventTypeDefaultOneeight,
            ),
          timestamp: zod.iso.datetime({}),
          request_id: zod.uuid(),
          title: zod.string(),
        }),
        zod.object({
          event_type: zod
            .literal("REQUEST_RESOLVED")
            .default(
              getRecentBrainDataResponseProcessedEventLogsItemEventEventTypeDefaultOnenine,
            ),
          timestamp: zod.iso.datetime({}),
          request_id: zod.uuid(),
          title: zod.string(),
        }),
        zod.object({
          event_type: zod
            .literal("QUESTION_REPETITION_CHECK")
            .default(
              getRecentBrainDataResponseProcessedEventLogsItemEventEventTypeDefaultTwozero,
            ),
        }),
        zod
          .object({
            event_type: zod
              .literal("REQUEST_SHOT_CLOCK_EXCEEDED")
              .default(
                getRecentBrainDataResponseProcessedEventLogsItemEventEventTypeDefaultTwoone,
              ),
            timestamp: zod.iso.datetime({}),
            request_id: zod.uuid(),
            title: zod.string(),
            urgency: zod.string(),
            open_duration_hours: zod.number(),
          })
          .describe(
            "Fired when an open request has exceeded its allowable time without resolution.",
          ),
        zod
          .object({
            event_type: zod
              .literal("PRE_REQUEST_ESCALATION_OVERDUE")
              .default(
                getRecentBrainDataResponseProcessedEventLogsItemEventEventTypeDefaultTwotwo,
              ),
            timestamp: zod.iso.datetime({}),
            pre_request_id: zod.uuid(),
            title: zod.string(),
            pending_duration_hours: zod.number(),
          })
          .describe(
            "Fired when a pending pre-request has not been escalated within the allowed window.",
          ),
        zod
          .object({
            event_type: zod
              .literal("VERIFIED_DISCOVERY")
              .default(
                getRecentBrainDataResponseProcessedEventLogsItemEventEventTypeDefaultTwothree,
              ),
            outcome: zod.enum(["success", "failure"]),
            duration_ms: zod.number(),
            failure_reason: zod.union([zod.string(), zod.null()]).optional(),
            http_status: zod.union([zod.number(), zod.null()]).optional(),
          })
          .describe(
            "Outcome of a Verified Inc 1-Click Signup discovery API attempt (dossier plugin).",
          ),
      ]),
      user_id: zod.uuid(),
      timestamp: zod.iso.datetime({}),
      embedding: zod.union([zod.array(zod.number()), zod.null()]).optional(),
    }),
  ),
});

/**
 * Trigger a full data sync for a specific user.
 * @summary Force Sync For User
 */
export const forceSyncForUserParams = zod.object({
  user_id: zod.uuid(),
});

export const forceSyncForUserResponse = zod.unknown();

/**
 * Get the resolved client profile for a user, including their client version
and available deep links.
 * @summary Get Client Profile For User
 */
export const getClientProfileForUserParams = zod.object({
  user_id: zod.uuid(),
});

export const getClientProfileForUserResponse = zod.object({
  clientVersion: zod.string(),
  profileNote: zod.union([zod.string(), zod.null()]),
  deepLinkScheme: zod.string(),
  deepLinks: zod.array(
    zod.object({
      path: zod.string(),
      availability: zod.string(),
      note: zod.union([zod.string(), zod.null()]),
    }),
  ),
});

/**
 * Check whether phone-number verification would be useful for a user.
 * @summary Get Phone Verification Status For User
 */
export const getPhoneVerificationStatusForUserParams = zod.object({
  user_id: zod.uuid(),
});

export const getPhoneVerificationStatusForUserResponse = zod.object({
  helpful: zod.boolean(),
});

/**
 * Record that a user's phone number was just verified (admin action).
 * @summary Signal Phone Verified For User
 */
export const signalPhoneVerifiedForUserParams = zod.object({
  user_id: zod.uuid(),
});

export const signalPhoneVerifiedForUserResponse = zod.unknown();

/**
 * Fetch the user's customization overlay.

Returns the current customization overlay for the authenticated user.
If no customizations exist, returns an empty overlay.
 * @summary Fetch Customization
 */
export const fetchCustomizationResponse = zod.object({
  base: zod
    .object({
      data: zod.record(zod.string(), zod.string()),
    })
    .describe("An FsT is a dictionary of file names to bytes."),
  overlay: zod
    .object({
      data: zod.record(zod.string(), zod.union([zod.string(), zod.null()])),
    })
    .describe(
      "An overlay is a dictionary of file names to either:\n\n- bytes: The new data for that file\n- None: A deletion marker for that file",
    ),
});

/**
 * Update the user's customization overlay.

This endpoint replaces the existing customization overlay with the provided overlay.
 * @summary Update Customization
 */
export const updateCustomizationBody = zod.object({
  overlay: zod
    .object({
      data: zod.record(zod.string(), zod.union([zod.string(), zod.null()])),
    })
    .describe(
      "An overlay is a dictionary of file names to either:\n\n- bytes: The new data for that file\n- None: A deletion marker for that file",
    ),
});

export const updateCustomizationResponse = zod.object({});

/**
 * @summary List Moderation Actions
 */
export const listModerationActionsQueryLimitDefault = 20;

export const listModerationActionsQueryParams = zod.object({
  cursor: zod.union([zod.uuid(), zod.null()]).optional(),
  limit: zod.number().default(listModerationActionsQueryLimitDefault),
});

export const listModerationActionsResponse = zod.object({
  items: zod.array(
    zod.object({
      id: zod.uuid(),
      createdAt: zod.iso.datetime({}),
      actorNamespace: zod.string(),
      actorIdentity: zod.string(),
      action: zod
        .enum(["ban", "revert"])
        .describe(
          "A ModerationActionType is a verb from the moderation interface. Generally, each action\nis performed by some moderator and targets some set of credentials.",
        ),
      reason: zod.string(),
      revertedByActionId: zod.union([zod.uuid(), zod.null()]),
      statuses: zod.array(
        zod.object({
          id: zod.uuid(),
          createdAt: zod.iso.datetime({}),
          credentialType: zod.string(),
          credentialValue: zod.string(),
          statusType: zod
            .enum(["banned"])
            .describe(
              "A ModerationStatusType is a condition that a credential is under as the result of a ModerationAction.",
            ),
          active: zod.boolean(),
        }),
      ),
    }),
  ),
  nextCursor: zod.union([zod.uuid(), zod.null()]),
});

/**
 * @summary Create Ban
 */
export const createBanBody = zod.object({
  user_id: zod.uuid(),
  reason: zod.string(),
});

export const createBanResponse = zod.object({
  id: zod.uuid(),
  createdAt: zod.iso.datetime({}),
  actorNamespace: zod.string(),
  actorIdentity: zod.string(),
  action: zod
    .enum(["ban", "revert"])
    .describe(
      "A ModerationActionType is a verb from the moderation interface. Generally, each action\nis performed by some moderator and targets some set of credentials.",
    ),
  reason: zod.string(),
  revertedByActionId: zod.union([zod.uuid(), zod.null()]),
  statuses: zod.array(
    zod.object({
      id: zod.uuid(),
      createdAt: zod.iso.datetime({}),
      credentialType: zod.string(),
      credentialValue: zod.string(),
      statusType: zod
        .enum(["banned"])
        .describe(
          "A ModerationStatusType is a condition that a credential is under as the result of a ModerationAction.",
        ),
      active: zod.boolean(),
    }),
  ),
});

/**
 * @summary Revert Moderation Action
 */
export const revertModerationActionParams = zod.object({
  action_id: zod.uuid(),
});

export const revertModerationActionBody = zod.object({
  reason: zod.string(),
});

export const revertModerationActionResponse = zod.object({
  id: zod.uuid(),
  createdAt: zod.iso.datetime({}),
  actorNamespace: zod.string(),
  actorIdentity: zod.string(),
  action: zod
    .enum(["ban", "revert"])
    .describe(
      "A ModerationActionType is a verb from the moderation interface. Generally, each action\nis performed by some moderator and targets some set of credentials.",
    ),
  reason: zod.string(),
  revertedByActionId: zod.union([zod.uuid(), zod.null()]),
  statuses: zod.array(
    zod.object({
      id: zod.uuid(),
      createdAt: zod.iso.datetime({}),
      credentialType: zod.string(),
      credentialValue: zod.string(),
      statusType: zod
        .enum(["banned"])
        .describe(
          "A ModerationStatusType is a condition that a credential is under as the result of a ModerationAction.",
        ),
      active: zod.boolean(),
    }),
  ),
});

/**
 * Get the full PHR output from the proctor reconciler.
 * @summary Get Full Phr For Implementation
 */
export const getFullPhrForImplementationParams = zod.object({
  user_id: zod.uuid(),
  implementation: zod.enum(["diffagents", "proctor"]),
});

export const getFullPhrForImplementationResponseParcelCollectionParcelSchemaIsNullableDefault = true;

export const getFullPhrForImplementationResponse = zod.object({
  parcelCollection: zod.record(
    zod.string(),
    zod
      .object({
        table_name: zod.string(),
        hint: zod.union([zod.string(), zod.null()]),
        parcel_schema: zod.record(
          zod.string(),
          zod.object({
            type: zod
              .union([
                zod.enum([
                  "TINYINT",
                  "SMALLINT",
                  "INTEGER",
                  "BIGINT",
                  "HUGEINT",
                  "UTINYINT",
                  "USMALLINT",
                  "UINTEGER",
                  "UBIGINT",
                  "FLOAT",
                  "DOUBLE",
                  "DECIMAL",
                  "VARCHAR",
                  "BOOLEAN",
                  "DATE",
                  "TIME",
                  "TIMESTAMP",
                  "TIMESTAMPTZ",
                  "UUID",
                  "JSON",
                  "FLOAT[1536]",
                ]),
                zod.null(),
              ])
              .optional(),
            is_nullable: zod
              .boolean()
              .default(
                getFullPhrForImplementationResponseParcelCollectionParcelSchemaIsNullableDefault,
              ),
            description: zod.union([zod.string(), zod.null()]).optional(),
          }),
        ),
        rows: zod.array(zod.record(zod.string(), zod.unknown())),
      })
      .describe(
        "This type represents a bunch of data that might be fed to the agent,\nalong with its schema.\n\nThis is specifically intended for the exhaustive agent, but is a broad\nenough type that it might be generally useful for code that processes\nuntyped data.",
      ),
  ),
});

/**
 * Fetch available realtime data streams for a specific user.

This is an admin endpoint that allows viewing another user's data streams.

Args:
    user_id: The user ID to fetch inventory for
    user: Authenticated admin user

Returns:
    FetchRealtimeInventoryResponseT with list of available streams
 * @summary Fetch Realtime Inventory For User
 */
export const fetchRealtimeInventoryForUserParams = zod.object({
  user_id: zod.uuid(),
});

export const fetchRealtimeInventoryForUserResponse = zod.object({
  streams: zod.array(
    zod
      .object({
        id: zod.string(),
        type: zod.enum(["quantitative", "categorical", "blob"]),
        friendly_name: zod.union([zod.string(), zod.null()]).optional(),
        description: zod.string(),
        first_observed_at: zod.iso.datetime({}),
        last_observed_at: zod.iso.datetime({}),
        source_label: zod.union([zod.string(), zod.null()]).optional(),
      })
      .describe("A stream of data."),
  ),
  connected_providers: zod
    .union([
      zod.array(
        zod
          .object({
            ad: zod.string(),
            health: zod.enum(["healthy", "error"]),
          })
          .describe(
            'A wearable provider the user has connected at Junction (from\n`VitalConnectionList`), surfaced alongside available streams so an investigator\ncan distinguish \"connected but no streams\" (sync\/labeling failure) from \"never\nconnected\" (OAuth never completed).',
          ),
      ),
      zod.null(),
    ])
    .optional(),
});

/**
 * Fetch realtime data for specific streams for a user.

This is an admin endpoint that allows viewing another user's data.

Args:
    user_id: The user ID to fetch data for
    user: Authenticated admin user
    request: The fetch request with stream IDs and time range

Returns:
    FetchRealtimeDataResponseT with data for each requested stream
 * @summary Fetch Realtime Data For User
 */
export const fetchRealtimeDataForUserParams = zod.object({
  user_id: zod.uuid(),
});

export const fetchRealtimeDataForUserBody = zod
  .object({
    streamIds: zod.array(zod.string()),
    timezone: zod.union([zod.string(), zod.null()]).optional(),
    start: zod.iso.datetime({}),
    end: zod.iso.datetime({}),
    interval: zod.enum(["minutely", "hourly", "daily"]),
  })
  .describe("Request body for fetching realtime data.");

export const fetchRealtimeDataForUserResponse = zod.object({
  data: zod.record(
    zod.string(),
    zod
      .object({
        fact_id: zod.string(),
        data: zod.array(zod.record(zod.string(), zod.unknown())),
        comment: zod.union([zod.string(), zod.null()]).optional(),
        unit: zod.union([zod.string(), zod.null()]).optional(),
      })
      .describe("Real-time stream data with its associated fact ID."),
  ),
});

/**
 * Fetch the Care Feed for an arbitrary patient (admin / debug).

Same projection as `GET /app/care/feed`, but the target patient is
supplied by path parameter so the BrainDataView Care Plan tab can
inspect any patient's feed alongside their snapshot/timeline.
 * @summary Fetch Patient Care Feed
 */
export const fetchPatientCareFeedParams = zod.object({
  user_id: zod.uuid(),
});

export const fetchPatientCareFeedResponseFeedCardsItemChromeDefault = [];
export const fetchPatientCareFeedResponseFeedCardsItemWidgetsItemTypeDefault =
  "text";
export const fetchPatientCareFeedResponseFeedCardsItemWidgetsItemTypeDefaultOne =
  "highlights";
export const fetchPatientCareFeedResponseFeedCardsItemWidgetsItemTypeDefaultTwo =
  "action_prompt";
export const fetchPatientCareFeedResponseFeedCardsItemWidgetsItemTypeDefaultThree =
  "button";
export const fetchPatientCareFeedResponseFeedCardsItemWidgetsItemTypeDefaultFour =
  "suggestion_chips";
export const fetchPatientCareFeedResponseFeedCardsItemWidgetsItemTypeDefaultFive =
  "portal";
export const fetchPatientCareFeedResponseFeedCardsItemWidgetsItemTypeDefaultSix =
  "carousel";

export const fetchPatientCareFeedResponse = zod.object({
  feed: zod.object({
    cards: zod.array(
      zod
        .object({
          id: zod.string(),
          chrome: zod
            .array(
              zod.union([
                zod
                  .enum([
                    "care_plan",
                    "actions",
                    "latest_activity",
                    "requests",
                    "prescriptions",
                    "labs",
                    "care_team_feature",
                    "center_header",
                  ])
                  .describe(
                    'Open enum naming a chrome (background \/ surface \/ imagery)\ntreatment the client can render around a card.\n\nCards advertise a \*priority list\* of chrome treatments via\n``CardT.chrome``. The client applies the first value it recognises\nand falls back to its default chrome if it knows none of them.\nThat lets the backend ship a new chrome generation by prepending\na new value to the list (``[\"liquid_glass_v2\", \"requests\"]``)\nwithout coordinating an iOS release.\n\nThe list is also a \*style reducer\* on the client: each recognised\nvalue is folded in order, so an additive modifier appended last wins\nover the base chrome. ``CenterHeader`` is such a modifier -- it only\ncenters the header and is meant to be appended after a base chrome\n(e.g. ``[\"actions\", \"center_header\"]``) rather than used alone.',
                  ),
                zod.string(),
              ]),
            )
            .default(fetchPatientCareFeedResponseFeedCardsItemChromeDefault),
          header: zod.object({
            title: zod.string(),
            subtitle: zod.union([zod.string(), zod.null()]).optional(),
          }),
          widgets: zod.array(
            zod.union([
              zod.union([
                zod.object({
                  type: zod
                    .literal("text")
                    .default(
                      fetchPatientCareFeedResponseFeedCardsItemWidgetsItemTypeDefault,
                    ),
                  markdownContent: zod.string(),
                  fallback: zod
                    .union([zod.array(zod.unknown()), zod.null()])
                    .optional(),
                }),
                zod.object({
                  type: zod
                    .literal("highlights")
                    .default(
                      fetchPatientCareFeedResponseFeedCardsItemWidgetsItemTypeDefaultOne,
                    ),
                  markdownBulletPoints: zod.array(zod.string()),
                  fallback: zod
                    .union([zod.array(zod.unknown()), zod.null()])
                    .optional(),
                }),
                zod
                  .object({
                    type: zod
                      .literal("action_prompt")
                      .default(
                        fetchPatientCareFeedResponseFeedCardsItemWidgetsItemTypeDefaultTwo,
                      ),
                    title: zod.string(),
                    subtitle: zod.union([zod.string(), zod.null()]).optional(),
                    action: zod.object({
                      link: zod.string(),
                      caption: zod.string(),
                    }),
                    fallback: zod
                      .union([zod.array(zod.unknown()), zod.null()])
                      .optional(),
                  })
                  .describe(
                    'Titled CTA: a row with a heading, optional subtitle, and a button.\n\nUse when the CTA needs visual context (e.g. ``\"Please set your\nprimary pharmacy\"`` above the ``Set pharmacy`` button). For a bare\nbutton with just a caption, use :class:`CardButtonWidgetT` instead.',
                  ),
                zod
                  .object({
                    type: zod
                      .literal("button")
                      .default(
                        fetchPatientCareFeedResponseFeedCardsItemWidgetsItemTypeDefaultThree,
                      ),
                    action: zod.object({
                      link: zod.string(),
                      caption: zod.string(),
                    }),
                    fallback: zod
                      .union([zod.array(zod.unknown()), zod.null()])
                      .optional(),
                  })
                  .describe(
                    "Standalone button: just a caption + deep-link, no surrounding chrome.\n\nUse when the surrounding card body already provides the context and\nthe CTA is a single tap target (e.g. an ``Edit`` button at the\nbottom of a summary card). Reach for :class:`CardActionPromptWidgetT`\ninstead when the CTA needs its own heading.",
                  ),
                zod
                  .object({
                    type: zod
                      .literal("suggestion_chips")
                      .default(
                        fetchPatientCareFeedResponseFeedCardsItemWidgetsItemTypeDefaultFour,
                      ),
                    chips: zod.array(zod.string()),
                    fallback: zod
                      .union([zod.array(zod.unknown()), zod.null()])
                      .optional(),
                  })
                  .describe(
                    "Tapping a chip should send its text as a chat message to the primary\npatient\/Lotus thread.",
                  ),
                zod
                  .object({
                    type: zod
                      .literal("portal")
                      .default(
                        fetchPatientCareFeedResponseFeedCardsItemWidgetsItemTypeDefaultFive,
                      ),
                    kind: zod.union([
                      zod
                        .enum([
                          "requests",
                          "prescriptions",
                          "labs",
                          "focus_areas",
                          "latest_activity",
                        ])
                        .describe(
                          "Which CareState subscription a portal slot reflects.\n\nAdding a new portal domain is a one-line enum addition. Old clients\nthat don't yet know a `kind` should render the portal's `fallback`\nwidgets instead of the live view.",
                        ),
                      zod.string(),
                    ]),
                    onPortalEmpty: zod
                      .union([zod.array(zod.unknown()), zod.null()])
                      .optional(),
                    fallback: zod
                      .union([zod.array(zod.unknown()), zod.null()])
                      .optional(),
                  })
                  .describe(
                    "Portal into one of the patient's CareState subscriptions.\n\nConfig-only: the frontend subscribes to CareState directly for\n`kind`. If the portal would be empty, the frontend renders\n`on_portal_empty` instead.",
                  ),
                zod
                  .object({
                    type: zod
                      .literal("carousel")
                      .default(
                        fetchPatientCareFeedResponseFeedCardsItemWidgetsItemTypeDefaultSix,
                      ),
                    items: zod
                      .array(
                        zod
                          .object({
                            imageUrl: zod.string(),
                            title: zod.string(),
                            subtitle: zod
                              .union([zod.string(), zod.null()])
                              .optional(),
                          })
                          .describe(
                            "A single tile in a carousel: an image with a title and optional subtitle.",
                          ),
                      )
                      .min(1),
                    fallback: zod
                      .union([zod.array(zod.unknown()), zod.null()])
                      .optional(),
                  })
                  .describe(
                    "A horizontally-scrolling list of image tiles.\n\nGeneric on purpose: the surrounding card's chrome (e.g.\n``CardChromeT.CareTeamFeature``) decides the visual treatment; this widget\nonly carries the per-tile data.",
                  ),
              ]),
              zod
                .object({
                  fallback: zod
                    .union([zod.array(zod.unknown()), zod.null()])
                    .optional(),
                })
                .describe(
                  'A \"widget\" that has no `type`, but has an optional `fallback` field.\n\nIf the client can\'t parse a widget, it should get this, which it might use to render a fallback.',
                ),
            ]),
          ),
        })
        .describe(
          'A single card in the Care Feed.\n\n``id`` is a stable semantic string used by the client as the list\nkey for focus \/ scroll preservation across feed refetches. It is\n\*not\* a rendering discriminator -- pick chrome from ``chrome``\n(priority list, first-match-wins) and dispatch widget bodies on\n``widget.type`` and (for portals) ``portal.kind``.\n\n``chrome`` is the priority-ordered list of chrome treatments the\nbackend prefers; an empty list means \"use your default chrome\".',
        ),
    ),
  }),
});

/**
 * List the facets of all actions currently visible to a clinician.
 * @summary Fetch Clinician Action Facets Endpoint
 */
export const fetchClinicianActionFacetsEndpointParams = zod.object({
  user_id: zod.uuid(),
});

export const fetchClinicianActionFacetsEndpointResponseActionsItemFacetDetailsTypeDefault =
  "no_op";
export const fetchClinicianActionFacetsEndpointResponseActionsItemFacetDetailsTypeDefaultOne =
  "permission_seeking";
export const fetchClinicianActionFacetsEndpointResponseActionsItemFacetDetailsTypeDefaultTwo =
  "suggestion";

export const fetchClinicianActionFacetsEndpointResponseActionsItemFacetDetailsLifecycleTypeDefault =
  "open";
export const fetchClinicianActionFacetsEndpointResponseActionsItemFacetDetailsLifecycleTypeDefaultOne =
  "approved";

export const fetchClinicianActionFacetsEndpointResponseActionsItemFacetDetailsLifecycleItemResultsItemTypeDefault =
  "materialized";

export const fetchClinicianActionFacetsEndpointResponseActionsItemFacetDetailsLifecycleItemResultsItemTypeDefaultOne =
  "failed";

export const fetchClinicianActionFacetsEndpointResponseActionsItemFacetDetailsTypeDefaultThree =
  "order_lab";
export const fetchClinicianActionFacetsEndpointResponseActionsItemFacetDetailsLifecycleTypeDefaultTwo =
  "pending";
export const fetchClinicianActionFacetsEndpointResponseActionsItemFacetDetailsLifecycleTypeDefaultThree =
  "placed";
export const fetchClinicianActionFacetsEndpointResponseActionsItemFacetDetailsLifecycleTypeDefaultFour =
  "failed";
export const fetchClinicianActionFacetsEndpointResponseActionsItemFacetDetailsTypeDefaultFour =
  "prescribe";
export const fetchClinicianActionFacetsEndpointResponseActionsItemFacetDetailsLifecycleTypeDefaultFive =
  "pending";
export const fetchClinicianActionFacetsEndpointResponseActionsItemFacetDetailsLifecycleTypeDefaultSix =
  "entered";
export const fetchClinicianActionFacetsEndpointResponseActionsItemFacetDetailsLifecycleTypeDefaultSeven =
  "placed";
export const fetchClinicianActionFacetsEndpointResponseActionsItemFacetDetailsLifecycleTypeDefaultEight =
  "failed";
export const fetchClinicianActionFacetsEndpointResponseActionsItemFacetFeaturesItemTypeDefault =
  "assigned_clinician";
export const fetchClinicianActionFacetsEndpointResponseActionsItemFacetFeaturesItemTypeDefaultOne =
  "suggestion";

export const fetchClinicianActionFacetsEndpointResponse = zod.object({
  actions: zod.array(
    zod.object({
      actionId: zod.uuid(),
      key: zod.string(),
      facet: zod
        .object({
          details: zod.union([
            zod
              .object({
                type: zod
                  .literal("no_op")
                  .default(
                    fetchClinicianActionFacetsEndpointResponseActionsItemFacetDetailsTypeDefault,
                  ),
              })
              .describe(
                "The minimal clinician-facing form proposed by a no-op action.",
              ),
            zod
              .object({
                type: zod
                  .literal("permission_seeking")
                  .default(
                    fetchClinicianActionFacetsEndpointResponseActionsItemFacetDetailsTypeDefaultOne,
                  ),
                required_role: zod
                  .enum(["patient", "clinician", "system"])
                  .describe(
                    "The authority an actor carries when it updates an action.\n\nUnlike action cores and features, roles have no unreadable-value fallback:\nan unrecognized role reaching a permission gate is a security-shaped bug\nrather than a compatibility one. Adding a role is therefore a two-phase\ndeploy — ship the member before anything writes it.",
                  ),
              })
              .describe(
                "Asks this reader to grant a permission the action is waiting on.\n\nThe one facet both readers share, because a gate can require the\npatient's own consent as readily as a clinician's. It is exempt from the\nrule keeping the two unions apart — that rule exists so clinical\nreasoning cannot reach a patient, and this carries none.",
              ),
            zod
              .object({
                type: zod
                  .literal("suggestion")
                  .default(
                    fetchClinicianActionFacetsEndpointResponseActionsItemFacetDetailsTypeDefaultTwo,
                  ),
                revision: zod.number().min(1),
                current_draft: zod.unknown(),
                placement: zod.union([
                  zod
                    .object({
                      care_state_problem_id: zod
                        .union([zod.uuid(), zod.null()])
                        .optional(),
                      provisional_problem_label: zod
                        .union([zod.string().min(1), zod.null()])
                        .optional(),
                      specialty: zod
                        .enum([
                          "primary_care",
                          "allergy_immunology",
                          "cardiology",
                          "dermatology",
                          "endocrinology",
                          "gastroenterology",
                          "general_surgery",
                          "hematology",
                          "infectious_disease",
                          "nephrology",
                          "neurology",
                          "obstetrics_gynecology",
                          "oncology",
                          "ophthalmology",
                          "orthopedics",
                          "otolaryngology",
                          "physical_medicine_rehabilitation",
                          "psychiatry",
                          "pulmonology",
                          "rheumatology",
                          "urology",
                        ])
                        .describe(
                          "Stable machine values for clinical specialty placement.",
                        ),
                    })
                    .describe(
                      "Mutable Cortex grouping that is not part of Suggestion identity.",
                    ),
                  zod.null(),
                ]),
                lifecycle: zod.union([
                  zod
                    .object({
                      type: zod
                        .literal("open")
                        .default(
                          fetchClinicianActionFacetsEndpointResponseActionsItemFacetDetailsLifecycleTypeDefault,
                        ),
                    })
                    .describe(
                      "Under review: the draft may still be revised, and the clinician has\nnot decided. A bare marker; the draft and its revision are the core's.",
                    ),
                  zod
                    .object({
                      type: zod
                        .literal("approved")
                        .default(
                          fetchClinicianActionFacetsEndpointResponseActionsItemFacetDetailsLifecycleTypeDefaultOne,
                        ),
                      reviewed_revision: zod.number().min(1),
                      plan: zod.array(zod.unknown()).min(1),
                      item_results: zod.array(
                        zod.union([
                          zod
                            .object({
                              type: zod
                                .literal("materialized")
                                .default(
                                  fetchClinicianActionFacetsEndpointResponseActionsItemFacetDetailsLifecycleItemResultsItemTypeDefault,
                                ),
                              item_id: zod.string().min(1),
                              action_key: zod.string().min(1),
                            })
                            .describe(
                              "The approved item became the action under `action_key`.",
                            ),
                          zod
                            .object({
                              type: zod
                                .literal("failed")
                                .default(
                                  fetchClinicianActionFacetsEndpointResponseActionsItemFacetDetailsLifecycleItemResultsItemTypeDefaultOne,
                                ),
                              item_id: zod.string().min(1),
                              details: zod.string().min(1),
                            })
                            .describe(
                              "The approved item could not be turned into an action.",
                            ),
                        ]),
                      ),
                      approved_at: zod.iso.datetime({}),
                    })
                    .describe(
                      "The clinician approved a final plan against `reviewed_revision`.\nTerminal for this occurrence.\n\nThe plan is frozen here, as the clinician saw it, so that what was\nauthorised is a fact of the Suggestion's own record rather than\nsomething reconstructed from the draft — the final plan may differ from\nthe draft's options. Each item is held as JSON the way the draft holds\nits options: a build that cannot parse one still reads the Suggestion,\nand the parse happens once, where the item is turned into an action,\nwhere a version it cannot read is one item failing rather than a\nSuggestion nobody can open.\n\nAOE answers, directions, pharmacy and PIN are deliberately absent: they\nare collected when the order is placed, by the flow that places it.",
                    ),
                ]),
                urgency: zod
                  .enum(["Routine", "Urgent"])
                  .describe(
                    "How quickly a clinician should review an open Suggestion.",
                  ),
              })
              .describe(
                "The current Suggestion draft, its revision, its urgency, its Cortex\nplacement, and whether the clinician has decided it.",
              ),
            zod
              .object({
                type: zod
                  .literal("order_lab")
                  .default(
                    fetchClinicianActionFacetsEndpointResponseActionsItemFacetDetailsTypeDefaultThree,
                  ),
                selection: zod
                  .object({
                    lab_test_ids: zod.array(zod.string()),
                    marker_ids: zod.array(zod.string()),
                  })
                  .describe(
                    "What to test, as a set: saved panels and single markers, at least one\nof either. The part of an order set a caller can know before anyone has\nchosen how the draw is collected — `NativeLabOrderSetSelectionT` minus\nthe lab and the collection method, which are the ordering flow's to\ndecide with the patient.\n\nFrozen and tuple-valued because it lives on frozen cores. Normalized as\nthe native selection is (stripped, deduplicated, sorted), so two\nselections naming the same tests compare equal however they were\nspelled.",
                  ),
                lifecycle: zod.union([
                  zod
                    .object({
                      type: zod
                        .literal("pending")
                        .default(
                          fetchClinicianActionFacetsEndpointResponseActionsItemFacetDetailsLifecycleTypeDefaultTwo,
                        ),
                    })
                    .describe(
                      "The order exists and nothing has been sent to the vendor yet.\n\nWhere every order starts, and a bare marker: who created the order and\nwhen are the record's `created_by` and `created_at`, and whether anyone\nstill has to approve it is a permission feature's question, not the\ncore's. An executor that could not learn whether its call reached the\nvendor leaves the order here and retries; there is deliberately no\n\"outcome unknown\" member, because the retry resolves it.",
                    ),
                  zod
                    .object({
                      type: zod
                        .literal("placed")
                        .default(
                          fetchClinicianActionFacetsEndpointResponseActionsItemFacetDetailsLifecycleTypeDefaultThree,
                        ),
                      remote_id: zod.string().min(1),
                      placed_at: zod.iso.datetime({}),
                    })
                    .describe(
                      "The vendor has taken responsibility for the order. Terminal.\n\nFor a lab, Junction accepted the order. For a prescription, DoseSpot's\n`send` succeeded — the prescription was signed and handed to Surescripts\n— and not merely `add`, which is `entered`.",
                    ),
                  zod
                    .object({
                      type: zod
                        .literal("failed")
                        .default(
                          fetchClinicianActionFacetsEndpointResponseActionsItemFacetDetailsLifecycleTypeDefaultFour,
                        ),
                      details: zod.string().min(1),
                      failed_at: zod.iso.datetime({}),
                    })
                    .describe(
                      "Placing the order failed. Terminal.\n\nA failure to \*place\*: the vendor refused to create it, refused to send\nit, or rejected the clinician's signature. What the pharmacy or the lab\ndoes with an order the vendor already accepted is the vendor's record,\nnot this one's.",
                    ),
                ]),
              })
              .describe(
                "The lab order a clinician approved, and where it has got to — enough\nfor Cortex to list the orders still waiting to be placed.\n\nWhere the order came from is not here because the core proposing these\ndetails does not know: the Suggestion link is the provenance feature's\nto contribute, and lands beside the details on the facet as a\n`SuggestionClinicianFeatureT`.",
              ),
            zod
              .object({
                type: zod
                  .literal("prescribe")
                  .default(
                    fetchClinicianActionFacetsEndpointResponseActionsItemFacetDetailsTypeDefaultFour,
                  ),
                dispensable_drug_id: zod.number(),
                lifecycle: zod.union([
                  zod
                    .object({
                      type: zod
                        .literal("pending")
                        .default(
                          fetchClinicianActionFacetsEndpointResponseActionsItemFacetDetailsLifecycleTypeDefaultFive,
                        ),
                    })
                    .describe(
                      "The order exists and nothing has been sent to the vendor yet.\n\nWhere every order starts, and a bare marker: who created the order and\nwhen are the record's `created_by` and `created_at`, and whether anyone\nstill has to approve it is a permission feature's question, not the\ncore's. An executor that could not learn whether its call reached the\nvendor leaves the order here and retries; there is deliberately no\n\"outcome unknown\" member, because the retry resolves it.",
                    ),
                  zod
                    .object({
                      type: zod
                        .literal("entered")
                        .default(
                          fetchClinicianActionFacetsEndpointResponseActionsItemFacetDetailsLifecycleTypeDefaultSix,
                        ),
                      remote_id: zod.string().min(1),
                      entered_at: zod.iso.datetime({}),
                    })
                    .describe(
                      "DoseSpot holds the prescription as a draft under `remote_id` — its\n`Entered` status. Nothing has been signed or sent.\n\nA prescription's own step, because DoseSpot places in two calls where\nJunction places in one: `add` creates the draft and returns its id,\n`send` signs it with the clinician's PIN and hands it to the pharmacy\nnetwork. The id has to be kept between the two, so the send can name\nthe draft the add made rather than adding another.",
                    ),
                  zod
                    .object({
                      type: zod
                        .literal("placed")
                        .default(
                          fetchClinicianActionFacetsEndpointResponseActionsItemFacetDetailsLifecycleTypeDefaultSeven,
                        ),
                      remote_id: zod.string().min(1),
                      placed_at: zod.iso.datetime({}),
                    })
                    .describe(
                      "The vendor has taken responsibility for the order. Terminal.\n\nFor a lab, Junction accepted the order. For a prescription, DoseSpot's\n`send` succeeded — the prescription was signed and handed to Surescripts\n— and not merely `add`, which is `entered`.",
                    ),
                  zod
                    .object({
                      type: zod
                        .literal("failed")
                        .default(
                          fetchClinicianActionFacetsEndpointResponseActionsItemFacetDetailsLifecycleTypeDefaultEight,
                        ),
                      details: zod.string().min(1),
                      failed_at: zod.iso.datetime({}),
                    })
                    .describe(
                      "Placing the order failed. Terminal.\n\nA failure to \*place\*: the vendor refused to create it, refused to send\nit, or rejected the clinician's signature. What the pharmacy or the lab\ndoes with an order the vendor already accepted is the vendor's record,\nnot this one's.",
                    ),
                ]),
              })
              .describe(
                "The prescription a clinician approved, and where it has got to, on the\nsame terms as the lab order's facet.",
              ),
          ]),
          features: zod.array(
            zod.union([
              zod
                .object({
                  type: zod
                    .literal("assigned_clinician")
                    .default(
                      fetchClinicianActionFacetsEndpointResponseActionsItemFacetFeaturesItemTypeDefault,
                    ),
                  clinician: zod
                    .object({
                      role: zod
                        .enum(["patient", "clinician", "system"])
                        .describe(
                          "The authority an actor carries when it updates an action.\n\nUnlike action cores and features, roles have no unreadable-value fallback:\nan unrecognized role reaching a permission gate is a security-shaped bug\nrather than a compatibility one. Adding a role is therefore a two-phase\ndeploy — ship the member before anything writes it.",
                        ),
                      kind: zod
                        .enum(["user", "agent"])
                        .describe(
                          "Whether an actor's identity names a Lotus user or a system.",
                        ),
                      identity: zod.string(),
                    })
                    .describe(
                      "Who sent an update, and under what authority.\n\nRole and kind are independent. An agent may hold the `Clinician` role when\nit acts under delegated clinician authority, and a gate testing for that\nrole will admit it; a gate that must require a \*human\* clinician has to\ntest `kind` as well. Storing both keeps the audit trail able to tell a bot\nfrom a person.\n\nFrozen, so actors can be set members and dict keys.",
                    ),
                })
                .describe(
                  "The clinician responsible for progressing this action.",
                ),
              zod
                .object({
                  type: zod
                    .literal("suggestion")
                    .default(
                      fetchClinicianActionFacetsEndpointResponseActionsItemFacetFeaturesItemTypeDefaultOne,
                    ),
                  suggestion_action_id: zod.uuid(),
                  item_id: zod.string().min(1),
                })
                .describe(
                  "The approved Suggestion item this action was created from.\n\nContributed to the facet by the provenance feature, so any kind of\naction can carry the link and no core has to know Suggestions exist.",
                ),
            ]),
          ),
        })
        .describe(
          "What a clinician sees about an action.\n\nAssembled from two kinds of contribution: the details, from the core or\nthe one feature allowed to substitute them, and one entry per feature\nthat has something to add beside them. How the walk keeps that\nassembly independent of feature order is argued in `facets.py`.\n\nNothing renders a clinician facet yet, so nothing has asked what a\nclinician may \*do\* about one. When something does, the affordance is a\nthird part beside these two, as `dismissible` is on the patient's.",
        ),
    }),
  ),
});

/**
 * List current Suggestions for a patient, including all specialties.
 * @summary Fetch Patient Suggestions Endpoint
 */
export const fetchPatientSuggestionsEndpointParams = zod.object({
  user_id: zod.uuid(),
});

export const fetchPatientSuggestionsEndpointResponseSuggestionsItemDraftTypeDefault =
  "suggestion_draft";

export const fetchPatientSuggestionsEndpointResponseSuggestionsItemDraftProposedClinicalActionsItemIdRegExp =
  new RegExp("^[A-Za-z0-9_-]+$");

export const fetchPatientSuggestionsEndpointResponseSuggestionsItemDraftProposedClinicalActionsItemProposalTypeDefault =
  "request_lab";
export const fetchPatientSuggestionsEndpointResponseSuggestionsItemDraftProposedClinicalActionsItemProposalLabTestIdsItemRegExp =
  new RegExp("^\\S+$");
export const fetchPatientSuggestionsEndpointResponseSuggestionsItemDraftProposedClinicalActionsItemProposalMarkerIdsItemRegExp =
  new RegExp("^\\S+$");
export const fetchPatientSuggestionsEndpointResponseSuggestionsItemDraftProposedClinicalActionsItemProposalTypeDefaultOne =
  "discuss";
export const fetchPatientSuggestionsEndpointResponseSuggestionsItemDraftProposedClinicalActionsItemProposalTypeDefaultTwo =
  "request_prescription";
export const fetchPatientSuggestionsEndpointResponseSuggestionsItemDraftProposedClinicalActionsItemTypeDefault =
  "unavailable";
export const fetchPatientSuggestionsEndpointResponseSuggestionsItemDraftTypeDefaultOne =
  "unavailable";
export const fetchPatientSuggestionsEndpointResponseSuggestionsItemLifecycleTypeDefault =
  "open";
export const fetchPatientSuggestionsEndpointResponseSuggestionsItemLifecycleTypeDefaultOne =
  "approved";

export const fetchPatientSuggestionsEndpointResponseSuggestionsItemLifecycleItemResultsItemTypeDefault =
  "materialized";

export const fetchPatientSuggestionsEndpointResponseSuggestionsItemLifecycleItemResultsItemTypeDefaultOne =
  "failed";

export const fetchPatientSuggestionsEndpointResponse = zod.object({
  suggestions: zod.array(
    zod
      .object({
        actionId: zod.uuid(),
        key: zod.string(),
        revision: zod.number(),
        draft: zod.union([
          zod
            .object({
              type: zod
                .literal("suggestion_draft")
                .default(
                  fetchPatientSuggestionsEndpointResponseSuggestionsItemDraftTypeDefault,
                ),
              title: zod.string(),
              cortex_context: zod.string(),
              proposed_clinical_actions: zod.array(
                zod.union([
                  zod
                    .object({
                      id: zod
                        .string()
                        .min(1)
                        .regex(
                          fetchPatientSuggestionsEndpointResponseSuggestionsItemDraftProposedClinicalActionsItemIdRegExp,
                        ),
                      payload_schema_version: zod.number(),
                      rationale: zod.string().min(1),
                      proposal: zod.union([
                        zod
                          .object({
                            type: zod
                              .literal("request_lab")
                              .default(
                                fetchPatientSuggestionsEndpointResponseSuggestionsItemDraftProposedClinicalActionsItemProposalTypeDefault,
                              ),
                            problem_area: zod.string(),
                            lab_test_ids: zod.array(
                              zod
                                .string()
                                .regex(
                                  fetchPatientSuggestionsEndpointResponseSuggestionsItemDraftProposedClinicalActionsItemProposalLabTestIdsItemRegExp,
                                ),
                            ),
                            marker_ids: zod.array(
                              zod
                                .string()
                                .regex(
                                  fetchPatientSuggestionsEndpointResponseSuggestionsItemDraftProposedClinicalActionsItemProposalMarkerIdsItemRegExp,
                                ),
                            ),
                            subtitle: zod.string(),
                            instruction: zod.string(),
                          })
                          .describe(
                            "The agent wants a lab card raised.\n\nThe vocabulary choice is the string the agent wrote, not a validated\nmember — a deliberate departure from \"enum-shaped fields are enums\".\nWhether it names anything is the contract's question to answer in band,\nbecause a logged refusal is the signal for growing the lists and a parse\nerror at the edge would lose it. The selection's ids are carried on the\nsame terms, and so is its emptiness: a proposal naming nothing to test\nparses, and is refused where the refusal is logged.",
                          ),
                        zod
                          .object({
                            type: zod
                              .literal("discuss")
                              .default(
                                fetchPatientSuggestionsEndpointResponseSuggestionsItemDraftProposedClinicalActionsItemProposalTypeDefaultOne,
                              ),
                            subject: zod.string(),
                            subtitle: zod.string(),
                            instruction: zod.string(),
                          })
                          .describe(
                            "The agent wants a conversation raised rather than an order. The\nsubject ranges over both vocabularies plus discussion's catch-all, as\nthe discuss key does, and arrives as the agent's string on the same terms\nas the lab proposal's problem area.",
                          ),
                        zod
                          .object({
                            type: zod
                              .literal("request_prescription")
                              .default(
                                fetchPatientSuggestionsEndpointResponseSuggestionsItemDraftProposedClinicalActionsItemProposalTypeDefaultTwo,
                              ),
                            problem_area: zod.string(),
                            dispensable_drug_id: zod.number(),
                            subtitle: zod.string(),
                            instruction: zod.string(),
                          })
                          .describe(
                            "The agent wants a card raised proposing a medication. The problem\narea arrives as the agent's string on the same terms as a lab\nproposal's; the drug is one DoseSpot id rather than a set, because a\nprescription request is for one drug.",
                          ),
                      ]),
                    })
                    .describe(
                      "One typed, non-executable option in a Suggestion draft.",
                    ),
                  zod
                    .object({
                      type: zod
                        .literal("unavailable")
                        .default(
                          fetchPatientSuggestionsEndpointResponseSuggestionsItemDraftProposedClinicalActionsItemTypeDefault,
                        ),
                    })
                    .describe(
                      "A Proposed Clinical Action this build cannot parse.",
                    ),
                ]),
              ),
            })
            .describe("A Suggestion's current draft, as a clinician sees it."),
          zod
            .object({
              type: zod
                .literal("unavailable")
                .default(
                  fetchPatientSuggestionsEndpointResponseSuggestionsItemDraftTypeDefaultOne,
                ),
            })
            .describe(
              "A Suggestion whose current draft this build cannot parse.",
            ),
        ]),
        placement: zod.union([
          zod
            .object({
              care_state_problem_id: zod
                .union([zod.uuid(), zod.null()])
                .optional(),
              provisional_problem_label: zod
                .union([zod.string().min(1), zod.null()])
                .optional(),
              specialty: zod
                .enum([
                  "primary_care",
                  "allergy_immunology",
                  "cardiology",
                  "dermatology",
                  "endocrinology",
                  "gastroenterology",
                  "general_surgery",
                  "hematology",
                  "infectious_disease",
                  "nephrology",
                  "neurology",
                  "obstetrics_gynecology",
                  "oncology",
                  "ophthalmology",
                  "orthopedics",
                  "otolaryngology",
                  "physical_medicine_rehabilitation",
                  "psychiatry",
                  "pulmonology",
                  "rheumatology",
                  "urology",
                ])
                .describe(
                  "Stable machine values for clinical specialty placement.",
                ),
            })
            .describe(
              "Mutable Cortex grouping that is not part of Suggestion identity.",
            ),
          zod.null(),
        ]),
        lifecycle: zod.union([
          zod
            .object({
              type: zod
                .literal("open")
                .default(
                  fetchPatientSuggestionsEndpointResponseSuggestionsItemLifecycleTypeDefault,
                ),
            })
            .describe(
              "Under review: the draft may still be revised, and the clinician has\nnot decided. A bare marker; the draft and its revision are the core's.",
            ),
          zod
            .object({
              type: zod
                .literal("approved")
                .default(
                  fetchPatientSuggestionsEndpointResponseSuggestionsItemLifecycleTypeDefaultOne,
                ),
              reviewed_revision: zod.number().min(1),
              plan: zod.array(zod.unknown()).min(1),
              item_results: zod.array(
                zod.union([
                  zod
                    .object({
                      type: zod
                        .literal("materialized")
                        .default(
                          fetchPatientSuggestionsEndpointResponseSuggestionsItemLifecycleItemResultsItemTypeDefault,
                        ),
                      item_id: zod.string().min(1),
                      action_key: zod.string().min(1),
                    })
                    .describe(
                      "The approved item became the action under `action_key`.",
                    ),
                  zod
                    .object({
                      type: zod
                        .literal("failed")
                        .default(
                          fetchPatientSuggestionsEndpointResponseSuggestionsItemLifecycleItemResultsItemTypeDefaultOne,
                        ),
                      item_id: zod.string().min(1),
                      details: zod.string().min(1),
                    })
                    .describe(
                      "The approved item could not be turned into an action.",
                    ),
                ]),
              ),
              approved_at: zod.iso.datetime({}),
            })
            .describe(
              "The clinician approved a final plan against `reviewed_revision`.\nTerminal for this occurrence.\n\nThe plan is frozen here, as the clinician saw it, so that what was\nauthorised is a fact of the Suggestion's own record rather than\nsomething reconstructed from the draft — the final plan may differ from\nthe draft's options. Each item is held as JSON the way the draft holds\nits options: a build that cannot parse one still reads the Suggestion,\nand the parse happens once, where the item is turned into an action,\nwhere a version it cannot read is one item failing rather than a\nSuggestion nobody can open.\n\nAOE answers, directions, pharmacy and PIN are deliberately absent: they\nare collected when the order is placed, by the flow that places it.",
            ),
        ]),
        urgency: zod
          .enum(["Routine", "Urgent"])
          .describe(
            "How quickly a clinician should review an open Suggestion.",
          ),
      })
      .describe("A clinician-facing Suggestion and its current draft."),
  ),
});

/**
 * Fetch a current Suggestion and its current draft.
 * @summary Fetch Patient Suggestion Endpoint
 */
export const fetchPatientSuggestionEndpointParams = zod.object({
  user_id: zod.uuid(),
  action_id: zod.uuid(),
});

export const fetchPatientSuggestionEndpointResponseDraftTypeDefault =
  "suggestion_draft";

export const fetchPatientSuggestionEndpointResponseDraftProposedClinicalActionsItemIdRegExp =
  new RegExp("^[A-Za-z0-9_-]+$");

export const fetchPatientSuggestionEndpointResponseDraftProposedClinicalActionsItemProposalTypeDefault =
  "request_lab";
export const fetchPatientSuggestionEndpointResponseDraftProposedClinicalActionsItemProposalLabTestIdsItemRegExp =
  new RegExp("^\\S+$");
export const fetchPatientSuggestionEndpointResponseDraftProposedClinicalActionsItemProposalMarkerIdsItemRegExp =
  new RegExp("^\\S+$");
export const fetchPatientSuggestionEndpointResponseDraftProposedClinicalActionsItemProposalTypeDefaultOne =
  "discuss";
export const fetchPatientSuggestionEndpointResponseDraftProposedClinicalActionsItemProposalTypeDefaultTwo =
  "request_prescription";
export const fetchPatientSuggestionEndpointResponseDraftProposedClinicalActionsItemTypeDefault =
  "unavailable";
export const fetchPatientSuggestionEndpointResponseDraftTypeDefaultOne =
  "unavailable";
export const fetchPatientSuggestionEndpointResponseLifecycleTypeDefault =
  "open";
export const fetchPatientSuggestionEndpointResponseLifecycleTypeDefaultOne =
  "approved";

export const fetchPatientSuggestionEndpointResponseLifecycleItemResultsItemTypeDefault =
  "materialized";

export const fetchPatientSuggestionEndpointResponseLifecycleItemResultsItemTypeDefaultOne =
  "failed";

export const fetchPatientSuggestionEndpointResponse = zod
  .object({
    actionId: zod.uuid(),
    key: zod.string(),
    revision: zod.number(),
    draft: zod.union([
      zod
        .object({
          type: zod
            .literal("suggestion_draft")
            .default(fetchPatientSuggestionEndpointResponseDraftTypeDefault),
          title: zod.string(),
          cortex_context: zod.string(),
          proposed_clinical_actions: zod.array(
            zod.union([
              zod
                .object({
                  id: zod
                    .string()
                    .min(1)
                    .regex(
                      fetchPatientSuggestionEndpointResponseDraftProposedClinicalActionsItemIdRegExp,
                    ),
                  payload_schema_version: zod.number(),
                  rationale: zod.string().min(1),
                  proposal: zod.union([
                    zod
                      .object({
                        type: zod
                          .literal("request_lab")
                          .default(
                            fetchPatientSuggestionEndpointResponseDraftProposedClinicalActionsItemProposalTypeDefault,
                          ),
                        problem_area: zod.string(),
                        lab_test_ids: zod.array(
                          zod
                            .string()
                            .regex(
                              fetchPatientSuggestionEndpointResponseDraftProposedClinicalActionsItemProposalLabTestIdsItemRegExp,
                            ),
                        ),
                        marker_ids: zod.array(
                          zod
                            .string()
                            .regex(
                              fetchPatientSuggestionEndpointResponseDraftProposedClinicalActionsItemProposalMarkerIdsItemRegExp,
                            ),
                        ),
                        subtitle: zod.string(),
                        instruction: zod.string(),
                      })
                      .describe(
                        "The agent wants a lab card raised.\n\nThe vocabulary choice is the string the agent wrote, not a validated\nmember — a deliberate departure from \"enum-shaped fields are enums\".\nWhether it names anything is the contract's question to answer in band,\nbecause a logged refusal is the signal for growing the lists and a parse\nerror at the edge would lose it. The selection's ids are carried on the\nsame terms, and so is its emptiness: a proposal naming nothing to test\nparses, and is refused where the refusal is logged.",
                      ),
                    zod
                      .object({
                        type: zod
                          .literal("discuss")
                          .default(
                            fetchPatientSuggestionEndpointResponseDraftProposedClinicalActionsItemProposalTypeDefaultOne,
                          ),
                        subject: zod.string(),
                        subtitle: zod.string(),
                        instruction: zod.string(),
                      })
                      .describe(
                        "The agent wants a conversation raised rather than an order. The\nsubject ranges over both vocabularies plus discussion's catch-all, as\nthe discuss key does, and arrives as the agent's string on the same terms\nas the lab proposal's problem area.",
                      ),
                    zod
                      .object({
                        type: zod
                          .literal("request_prescription")
                          .default(
                            fetchPatientSuggestionEndpointResponseDraftProposedClinicalActionsItemProposalTypeDefaultTwo,
                          ),
                        problem_area: zod.string(),
                        dispensable_drug_id: zod.number(),
                        subtitle: zod.string(),
                        instruction: zod.string(),
                      })
                      .describe(
                        "The agent wants a card raised proposing a medication. The problem\narea arrives as the agent's string on the same terms as a lab\nproposal's; the drug is one DoseSpot id rather than a set, because a\nprescription request is for one drug.",
                      ),
                  ]),
                })
                .describe(
                  "One typed, non-executable option in a Suggestion draft.",
                ),
              zod
                .object({
                  type: zod
                    .literal("unavailable")
                    .default(
                      fetchPatientSuggestionEndpointResponseDraftProposedClinicalActionsItemTypeDefault,
                    ),
                })
                .describe(
                  "A Proposed Clinical Action this build cannot parse.",
                ),
            ]),
          ),
        })
        .describe("A Suggestion's current draft, as a clinician sees it."),
      zod
        .object({
          type: zod
            .literal("unavailable")
            .default(fetchPatientSuggestionEndpointResponseDraftTypeDefaultOne),
        })
        .describe("A Suggestion whose current draft this build cannot parse."),
    ]),
    placement: zod.union([
      zod
        .object({
          care_state_problem_id: zod.union([zod.uuid(), zod.null()]).optional(),
          provisional_problem_label: zod
            .union([zod.string().min(1), zod.null()])
            .optional(),
          specialty: zod
            .enum([
              "primary_care",
              "allergy_immunology",
              "cardiology",
              "dermatology",
              "endocrinology",
              "gastroenterology",
              "general_surgery",
              "hematology",
              "infectious_disease",
              "nephrology",
              "neurology",
              "obstetrics_gynecology",
              "oncology",
              "ophthalmology",
              "orthopedics",
              "otolaryngology",
              "physical_medicine_rehabilitation",
              "psychiatry",
              "pulmonology",
              "rheumatology",
              "urology",
            ])
            .describe(
              "Stable machine values for clinical specialty placement.",
            ),
        })
        .describe(
          "Mutable Cortex grouping that is not part of Suggestion identity.",
        ),
      zod.null(),
    ]),
    lifecycle: zod.union([
      zod
        .object({
          type: zod
            .literal("open")
            .default(
              fetchPatientSuggestionEndpointResponseLifecycleTypeDefault,
            ),
        })
        .describe(
          "Under review: the draft may still be revised, and the clinician has\nnot decided. A bare marker; the draft and its revision are the core's.",
        ),
      zod
        .object({
          type: zod
            .literal("approved")
            .default(
              fetchPatientSuggestionEndpointResponseLifecycleTypeDefaultOne,
            ),
          reviewed_revision: zod.number().min(1),
          plan: zod.array(zod.unknown()).min(1),
          item_results: zod.array(
            zod.union([
              zod
                .object({
                  type: zod
                    .literal("materialized")
                    .default(
                      fetchPatientSuggestionEndpointResponseLifecycleItemResultsItemTypeDefault,
                    ),
                  item_id: zod.string().min(1),
                  action_key: zod.string().min(1),
                })
                .describe(
                  "The approved item became the action under `action_key`.",
                ),
              zod
                .object({
                  type: zod
                    .literal("failed")
                    .default(
                      fetchPatientSuggestionEndpointResponseLifecycleItemResultsItemTypeDefaultOne,
                    ),
                  item_id: zod.string().min(1),
                  details: zod.string().min(1),
                })
                .describe(
                  "The approved item could not be turned into an action.",
                ),
            ]),
          ),
          approved_at: zod.iso.datetime({}),
        })
        .describe(
          "The clinician approved a final plan against `reviewed_revision`.\nTerminal for this occurrence.\n\nThe plan is frozen here, as the clinician saw it, so that what was\nauthorised is a fact of the Suggestion's own record rather than\nsomething reconstructed from the draft — the final plan may differ from\nthe draft's options. Each item is held as JSON the way the draft holds\nits options: a build that cannot parse one still reads the Suggestion,\nand the parse happens once, where the item is turned into an action,\nwhere a version it cannot read is one item failing rather than a\nSuggestion nobody can open.\n\nAOE answers, directions, pharmacy and PIN are deliberately absent: they\nare collected when the order is placed, by the flow that places it.",
        ),
    ]),
    urgency: zod
      .enum(["Routine", "Urgent"])
      .describe("How quickly a clinician should review an open Suggestion."),
  })
  .describe("A clinician-facing Suggestion and its current draft.");

/**
 * Approve a final plan on a Suggestion, as the clinician calling.

The plan's items are turned into actions before the Suggestion is
resolved; a retry with the same plan finds them and completes.
 * @summary Approve Patient Suggestion Endpoint
 */
export const approvePatientSuggestionEndpointParams = zod.object({
  user_id: zod.uuid(),
  action_id: zod.uuid(),
});

export const approvePatientSuggestionEndpointBodyPlanItemIdRegExp = new RegExp(
  "^[A-Za-z0-9_-]+$",
);

export const approvePatientSuggestionEndpointBodyPlanItemProposalTypeDefault =
  "request_lab";
export const approvePatientSuggestionEndpointBodyPlanItemProposalLabTestIdsItemRegExp =
  new RegExp("^\\S+$");
export const approvePatientSuggestionEndpointBodyPlanItemProposalMarkerIdsItemRegExp =
  new RegExp("^\\S+$");
export const approvePatientSuggestionEndpointBodyPlanItemProposalTypeDefaultOne =
  "discuss";
export const approvePatientSuggestionEndpointBodyPlanItemProposalTypeDefaultTwo =
  "request_prescription";

export const approvePatientSuggestionEndpointBody = zod.object({
  expectedRevision: zod.number().min(1),
  plan: zod
    .array(
      zod
        .object({
          id: zod
            .string()
            .min(1)
            .regex(approvePatientSuggestionEndpointBodyPlanItemIdRegExp),
          payload_schema_version: zod.number(),
          rationale: zod.string().min(1),
          proposal: zod.union([
            zod
              .object({
                type: zod
                  .literal("request_lab")
                  .default(
                    approvePatientSuggestionEndpointBodyPlanItemProposalTypeDefault,
                  ),
                problem_area: zod.string(),
                lab_test_ids: zod.array(
                  zod
                    .string()
                    .regex(
                      approvePatientSuggestionEndpointBodyPlanItemProposalLabTestIdsItemRegExp,
                    ),
                ),
                marker_ids: zod.array(
                  zod
                    .string()
                    .regex(
                      approvePatientSuggestionEndpointBodyPlanItemProposalMarkerIdsItemRegExp,
                    ),
                ),
                subtitle: zod.string(),
                instruction: zod.string(),
              })
              .describe(
                "The agent wants a lab card raised.\n\nThe vocabulary choice is the string the agent wrote, not a validated\nmember — a deliberate departure from \"enum-shaped fields are enums\".\nWhether it names anything is the contract's question to answer in band,\nbecause a logged refusal is the signal for growing the lists and a parse\nerror at the edge would lose it. The selection's ids are carried on the\nsame terms, and so is its emptiness: a proposal naming nothing to test\nparses, and is refused where the refusal is logged.",
              ),
            zod
              .object({
                type: zod
                  .literal("discuss")
                  .default(
                    approvePatientSuggestionEndpointBodyPlanItemProposalTypeDefaultOne,
                  ),
                subject: zod.string(),
                subtitle: zod.string(),
                instruction: zod.string(),
              })
              .describe(
                "The agent wants a conversation raised rather than an order. The\nsubject ranges over both vocabularies plus discussion's catch-all, as\nthe discuss key does, and arrives as the agent's string on the same terms\nas the lab proposal's problem area.",
              ),
            zod
              .object({
                type: zod
                  .literal("request_prescription")
                  .default(
                    approvePatientSuggestionEndpointBodyPlanItemProposalTypeDefaultTwo,
                  ),
                problem_area: zod.string(),
                dispensable_drug_id: zod.number(),
                subtitle: zod.string(),
                instruction: zod.string(),
              })
              .describe(
                "The agent wants a card raised proposing a medication. The problem\narea arrives as the agent's string on the same terms as a lab\nproposal's; the drug is one DoseSpot id rather than a set, because a\nprescription request is for one drug.",
              ),
          ]),
        })
        .describe("One typed, non-executable option in a Suggestion draft."),
    )
    .min(1),
});

export const approvePatientSuggestionEndpointResponseOutcomeTypeDefault =
  "approved";
export const approvePatientSuggestionEndpointResponseOutcomeLifecycleTypeDefault =
  "approved";

export const approvePatientSuggestionEndpointResponseOutcomeLifecycleItemResultsItemTypeDefault =
  "materialized";

export const approvePatientSuggestionEndpointResponseOutcomeLifecycleItemResultsItemTypeDefaultOne =
  "failed";

export const approvePatientSuggestionEndpointResponseOutcomeTypeDefaultOne =
  "refused";
export const approvePatientSuggestionEndpointResponseOutcomeTypeDefaultTwo =
  "not_a_suggestion";

export const approvePatientSuggestionEndpointResponse = zod.object({
  outcome: zod.union([
    zod
      .object({
        type: zod
          .literal("approved")
          .default(approvePatientSuggestionEndpointResponseOutcomeTypeDefault),
        lifecycle: zod
          .object({
            type: zod
              .literal("approved")
              .default(
                approvePatientSuggestionEndpointResponseOutcomeLifecycleTypeDefault,
              ),
            reviewed_revision: zod.number().min(1),
            plan: zod.array(zod.unknown()).min(1),
            item_results: zod.array(
              zod.union([
                zod
                  .object({
                    type: zod
                      .literal("materialized")
                      .default(
                        approvePatientSuggestionEndpointResponseOutcomeLifecycleItemResultsItemTypeDefault,
                      ),
                    item_id: zod.string().min(1),
                    action_key: zod.string().min(1),
                  })
                  .describe(
                    "The approved item became the action under `action_key`.",
                  ),
                zod
                  .object({
                    type: zod
                      .literal("failed")
                      .default(
                        approvePatientSuggestionEndpointResponseOutcomeLifecycleItemResultsItemTypeDefaultOne,
                      ),
                    item_id: zod.string().min(1),
                    details: zod.string().min(1),
                  })
                  .describe(
                    "The approved item could not be turned into an action.",
                  ),
              ]),
            ),
            approved_at: zod.iso.datetime({}),
          })
          .describe(
            "The clinician approved a final plan against `reviewed_revision`.\nTerminal for this occurrence.\n\nThe plan is frozen here, as the clinician saw it, so that what was\nauthorised is a fact of the Suggestion's own record rather than\nsomething reconstructed from the draft — the final plan may differ from\nthe draft's options. Each item is held as JSON the way the draft holds\nits options: a build that cannot parse one still reads the Suggestion,\nand the parse happens once, where the item is turned into an action,\nwhere a version it cannot read is one item failing rather than a\nSuggestion nobody can open.\n\nAOE answers, directions, pharmacy and PIN are deliberately absent: they\nare collected when the order is placed, by the flow that places it.",
          ),
      })
      .describe(
        "The Suggestion is approved. `lifecycle` is the frozen decision: the\nplan as approved and what each item became.",
      ),
    zod.object({
      type: zod
        .literal("refused")
        .default(approvePatientSuggestionEndpointResponseOutcomeTypeDefaultOne),
      reason: zod.enum([
        "stale_revision",
        "invalid_plan",
        "rejected_by_rules",
        "concurrent",
      ]),
      details: zod.string(),
    }),
    zod
      .object({
        type: zod
          .literal("not_a_suggestion")
          .default(
            approvePatientSuggestionEndpointResponseOutcomeTypeDefaultTwo,
          ),
      })
      .describe(
        "No Suggestion of this patient answers to that id: it is not theirs,\ndoes not exist, or is not a Suggestion. Refresh the list.",
      ),
  ]),
});

/**
 * Dismiss a Suggestion: the clinician's refusal, recorded as such.
 * @summary Dismiss Patient Suggestion Endpoint
 */
export const dismissPatientSuggestionEndpointParams = zod.object({
  user_id: zod.uuid(),
  action_id: zod.uuid(),
});

export const dismissPatientSuggestionEndpointResponseOutcomeTypeDefault =
  "dismissed";
export const dismissPatientSuggestionEndpointResponseOutcomeTypeDefaultOne =
  "refused";
export const dismissPatientSuggestionEndpointResponseOutcomeTypeDefaultTwo =
  "not_a_suggestion";

export const dismissPatientSuggestionEndpointResponse = zod.object({
  outcome: zod.union([
    zod
      .object({
        type: zod
          .literal("dismissed")
          .default(dismissPatientSuggestionEndpointResponseOutcomeTypeDefault),
      })
      .describe(
        "The Suggestion is dismissed and has left the clinician's view.",
      ),
    zod.object({
      type: zod
        .literal("refused")
        .default(dismissPatientSuggestionEndpointResponseOutcomeTypeDefaultOne),
      reason: zod.enum(["already_approved", "rejected_by_rules", "concurrent"]),
      details: zod.string(),
    }),
    zod
      .object({
        type: zod
          .literal("not_a_suggestion")
          .default(
            dismissPatientSuggestionEndpointResponseOutcomeTypeDefaultTwo,
          ),
      })
      .describe(
        "No Suggestion of this patient answers to that id: it is not theirs,\ndoes not exist, or is not a Suggestion. Refresh the list.",
      ),
  ]),
});

/**
 * Cancel a pending order: the clinician decided not to place it after
all. An order already at the vendor is refused; cancel it there.
 * @summary Dismiss Patient Order Endpoint
 */
export const dismissPatientOrderEndpointParams = zod.object({
  user_id: zod.uuid(),
  action_id: zod.uuid(),
});

export const dismissPatientOrderEndpointResponseOutcomeTypeDefault =
  "dismissed";
export const dismissPatientOrderEndpointResponseOutcomeTypeDefaultOne =
  "refused";
export const dismissPatientOrderEndpointResponseOutcomeTypeDefaultTwo =
  "not_an_order";

export const dismissPatientOrderEndpointResponse = zod.object({
  outcome: zod.union([
    zod
      .object({
        type: zod
          .literal("dismissed")
          .default(dismissPatientOrderEndpointResponseOutcomeTypeDefault),
      })
      .describe(
        "The order is dismissed: the clinician will not place it, and it has\nleft every clinician view.",
      ),
    zod.object({
      type: zod
        .literal("refused")
        .default(dismissPatientOrderEndpointResponseOutcomeTypeDefaultOne),
      reason: zod.enum(["already_moved_on", "rejected_by_rules", "concurrent"]),
      details: zod.string(),
    }),
    zod
      .object({
        type: zod
          .literal("not_an_order")
          .default(dismissPatientOrderEndpointResponseOutcomeTypeDefaultTwo),
      })
      .describe(
        "No order of this patient answers to that id: it is not theirs, does\nnot exist, or is not an order. Refresh.",
      ),
  ]),
});

/**
 * @summary Fetch Suggestion Chat Endpoint
 */
export const fetchSuggestionChatEndpointParams = zod.object({
  user_id: zod.uuid(),
  action_id: zod.uuid(),
});

export const fetchSuggestionChatEndpointResponse = zod.object({
  messages: zod.array(
    zod.object({
      id: zod.uuid(),
      role: zod.enum(["user", "assistant"]),
      text: zod.string(),
    }),
  ),
});

/**
 * @summary Stream Suggestion Chat Endpoint
 */
export const streamSuggestionChatEndpointParams = zod.object({
  user_id: zod.uuid(),
  action_id: zod.uuid(),
});

export const streamSuggestionChatEndpointBodyMessageMax = 8000;

export const streamSuggestionChatEndpointBody = zod.object({
  message: zod.string().min(1).max(streamSuggestionChatEndpointBodyMessageMax),
});

export const streamSuggestionChatEndpointResponse = zod.unknown();

/**
 * Fetch the full Personal Health Record (PHR) for the current user.

Returns a structured representation of all PHR tables including:
- Medications
- Conditions
- Labs
# - Diagnostics (not a part of the PHR yet)
- Procedures
- Vitals
- Notes

Returns:
    FetchPHRResponseT containing the full FrontendPHRT
 * @summary Fetch Phr
 */
export const fetchPhrParams = zod.object({
  user_id: zod.string(),
});

export const fetchPhrResponse = zod
  .object({
    phr: zod
      .object({
        medications: zod.array(
          zod
            .object({
              name: zod.string(),
              start: zod.union([zod.iso.date(), zod.null()]).optional(),
              end: zod.union([zod.iso.date(), zod.null()]).optional(),
              status: zod.enum(["Unknown", "Active", "Stopped", "Completed"]),
              dosage_instructions: zod.string(),
            })
            .describe("Frontend representation of a medication record."),
        ),
        conditions: zod.array(
          zod
            .object({
              name: zod.string(),
              start: zod.union([zod.iso.date(), zod.null()]).optional(),
              end: zod.union([zod.iso.date(), zod.null()]).optional(),
              status: zod.enum(["Active", "Resolved", "Unknown"]),
              classification: zod.enum([
                "Acute",
                "Chronic",
                "Remission",
                "Unknown",
              ]),
            })
            .describe("Frontend representation of a condition record."),
        ),
        labs: zod.array(
          zod
            .object({
              name: zod.string(),
              start: zod.union([zod.iso.date(), zod.null()]).optional(),
              end: zod.union([zod.iso.date(), zod.null()]).optional(),
              status: zod.enum([
                "Unknown",
                "Registered",
                "Preliminary",
                "Final",
                "Amended",
                "Corrected",
              ]),
              performers: zod.array(zod.string()),
              value: zod.string(),
            })
            .describe("Frontend representation of a lab result record."),
        ),
        procedures: zod.array(
          zod
            .object({
              name: zod.string(),
              start: zod.union([zod.iso.date(), zod.null()]).optional(),
              end: zod.union([zod.iso.date(), zod.null()]).optional(),
              status: zod.enum([
                "Planned",
                "Completed",
                "In-Progress",
                "Canceled",
                "Not Done",
                "Unknown",
              ]),
              performers: zod.array(zod.string()),
            })
            .describe("Frontend representation of a procedure record."),
        ),
        vitals: zod.array(
          zod
            .object({
              name: zod.string(),
              start: zod.union([zod.iso.date(), zod.null()]).optional(),
              end: zod.union([zod.iso.date(), zod.null()]).optional(),
              status: zod.enum([
                "Unknown",
                "Registered",
                "Preliminary",
                "Final",
                "Amended",
                "Corrected",
              ]),
              value: zod.string(),
              unit: zod.string(),
            })
            .describe("Frontend representation of a vital sign record."),
        ),
        notes: zod.array(
          zod
            .object({
              name: zod.string(),
              start: zod.union([zod.iso.date(), zod.null()]).optional(),
              end: zod.union([zod.iso.date(), zod.null()]).optional(),
              title: zod.string(),
              authors: zod.array(zod.string()),
              description: zod.string(),
            })
            .describe("Frontend representation of a clinical note record."),
        ),
      })
      .describe(
        "Frontend representation of the full PHR.\n\nContains lists for each entity type, providing a structured view of\nall patient health records suitable for API responses.",
      ),
  })
  .describe("Response containing the full PHR data.");

/**
 * Validate the staging input.

Providing this API makes sure the openapi schema includes a definition of HostageStagingInputT.
 * @summary Validate Staging Input
 */
export const validateStagingInputBody = zod.object({
  injections: zod.object({
    model_slug: zod.union([zod.string(), zod.null()]).optional(),
    base_prompt: zod.union([zod.string(), zod.null()]).optional(),
    prompt_fragment: zod.string(),
    tool_definitions: zod.array(
      zod.object({
        name: zod.string(),
        description: zod.string(),
        input_schema: zod.record(zod.string(), zod.unknown()),
      }),
    ),
  }),
});

export const validateStagingInputResponse = zod.string();

/**
 * @summary Host
 */
export const hostParams = zod.object({
  user_id: zod.uuid(),
});

export const hostResponse = zod.unknown();

/**
 * Fetch the list of conversations for a patient.

Returns all non-abandoned conversations for the specified user,
ordered by last interaction time (most recent first).

Args:
    user_id: The patient's user ID

Returns:
    FetchConversationsResponseT containing the list of conversations
 * @summary Fetch Conversations
 */
export const fetchConversationsParams = zod.object({
  user_id: zod.uuid(),
});

export const fetchConversationsResponseConversationsItemIsPrimaryDefault = false;

export const fetchConversationsResponse = zod
  .object({
    conversations: zod.array(
      zod.object({
        id: zod.uuid(),
        createdAt: zod.iso.datetime({}),
        displayName: zod.string(),
        lastInteractedAt: zod.iso.datetime({}),
        isPrimary: zod.boolean().optional(),
        conversationType: zod
          .enum([
            "onboarding",
            "evaluation",
            "clinician_request",
            "intake",
            "by_sheet",
          ])
          .optional(),
        key: zod.union([zod.string(), zod.null()]).optional(),
      }),
    ),
  })
  .describe("Response containing the list of conversations for a user.");

/**
 * Fetch chat messages for a specific conversation.

Supports pagination via before/after message IDs:
- Use `before` to fetch messages older than the specified message ID
- Use `after` to fetch messages newer than the specified message ID

Args:
    user_id: The patient's user ID
    conversation_id: The conversation ID to fetch messages from
    before: Optional message ID to fetch messages before (older than)
    after: Optional message ID to fetch messages after (newer than)

Returns:
    FetchChatResponseT containing the list of messages and conversation ID
 * @summary Fetch Chat
 */
export const fetchChatParams = zod.object({
  user_id: zod.uuid(),
  conversation_id: zod.uuid(),
});

export const fetchChatQueryParams = zod.object({
  before: zod.union([zod.uuid(), zod.null()]).optional(),
  after: zod.union([zod.uuid(), zod.null()]).optional(),
});

export const fetchChatResponseMessagesItemContentBlocksItemBodyTypeDefault =
  "text";
export const fetchChatResponseMessagesItemContentBlocksItemBodyTypeDefaultOne =
  "choiceChip";
export const fetchChatResponseMessagesItemContentBlocksItemBodyTypeDefaultTwo =
  "error";
export const fetchChatResponseMessagesItemContentBlocksItemBodyTypeDefaultThree =
  "chart";
export const fetchChatResponseMessagesItemContentBlocksItemBodyTypeDefaultFour =
  "toolUse";
export const fetchChatResponseMessagesItemContentBlocksItemBodyTypeDefaultFive =
  "article";
export const fetchChatResponseMessagesItemContentBlocksItemBodyTypeDefaultSix =
  "sources_v2";
export const fetchChatResponseMessagesItemContentBlocksItemBodySourcesItemContentTypeDefault =
  "table";
export const fetchChatResponseMessagesItemContentBlocksItemBodySourcesItemContentColumnSchemaDefault =
  {};
export const fetchChatResponseMessagesItemContentBlocksItemBodySourcesItemContentTypeDefaultOne =
  "link";
export const fetchChatResponseMessagesItemContentBlocksItemBodyTypeDefaultSeven =
  "pendingReview";
export const fetchChatResponseMessagesItemContentBlocksItemBodyTypeDefaultEight =
  "chainOfThought";
export const fetchChatResponseMessagesItemContentBlocksItemBodyTypeDefaultNine =
  "revised";
export const fetchChatResponseMessagesItemContentBlocksItemBodyTypeDefaultOnezero =
  "origin";
export const fetchChatResponseMessagesItemContentBlocksItemBodyTypeDefaultOneone =
  "stagingStatus";
export const fetchChatResponseMessagesItemContentBlocksItemBodyTypeDefaultOnetwo =
  "completeStatus";
export const fetchChatResponseMessagesItemContentBlocksItemBodyTypeDefaultOnethree =
  "retryStatus";
export const fetchChatResponseMessagesItemContentBlocksItemBodyTypeDefaultOnefour =
  "assessmentResult";
export const fetchChatResponseMessagesItemContentBlocksItemBodyTypeDefaultOnefive =
  "voiceMessageMarker";
export const fetchChatResponseMessagesItemContentBlocksItemBodyTypeDefaultOnesix =
  "voiceUpload";
export const fetchChatResponseMessagesItemContentBlocksItemBodyTypeDefaultOneseven =
  "debug";
export const fetchChatResponseMessagesItemContentBlocksItemBodyTypeDefaultOneeight =
  "blank";
export const fetchChatResponseMessagesItemContentBlocksItemBodyTypeDefaultOnenine =
  "answerPartSuggestion";
export const fetchChatResponseMessagesItemContentBlocksItemBodyAnswerPartAnswerPartTypeDefault =
  "revise_message";
export const fetchChatResponseMessagesItemContentBlocksItemBodyAnswerPartSendToPatientDefault = true;
export const fetchChatResponseMessagesItemContentBlocksItemBodyAnswerPartAnswerPartTypeDefaultOne =
  "note";
export const fetchChatResponseMessagesItemContentBlocksItemBodyAnswerPartAnswerPartTypeDefaultTwo =
  "rejected";
export const fetchChatResponseMessagesItemContentBlocksItemBodyAnswerPartAnswerPartTypeDefaultThree =
  "prescription";
export const fetchChatResponseMessagesItemContentBlocksItemBodyAnswerPartAnswerPartTypeDefaultFour =
  "prescription_suggestion";
export const fetchChatResponseMessagesItemContentBlocksItemBodyTypeDefaultTwozero =
  "fileAttachment";
export const fetchChatResponseMessagesItemContentBlocksItemBodyTypeDefaultTwoone =
  "actionChip";
export const fetchChatResponseMessagesItemContentBlocksItemBodyTypeDefaultTwotwo =
  "mention";
export const fetchChatResponseMessagesItemContentBlocksItemBodyTypeDefaultTwothree =
  "directive";

export const fetchChatResponse = zod
  .object({
    messages: zod.array(
      zod.object({
        id: zod.uuid(),
        createdAt: zod.iso.datetime({}),
        sender: zod.enum(["Lotus", "Debug", "User", "Clinician"]),
        status: zod.enum(["committed", "staged"]).optional(),
        contentBlocks: zod.array(
          zod.object({
            id: zod.uuid(),
            body: zod.union([
              zod.union([
                zod.object({
                  type: zod
                    .literal("text")
                    .default(
                      fetchChatResponseMessagesItemContentBlocksItemBodyTypeDefault,
                    ),
                  stream: zod.enum(["Chat", "Thinking"]).optional(),
                  text: zod.string(),
                }),
                zod.object({
                  type: zod
                    .literal("choiceChip")
                    .default(
                      fetchChatResponseMessagesItemContentBlocksItemBodyTypeDefaultOne,
                    ),
                  text: zod.string(),
                }),
                zod.object({
                  type: zod
                    .literal("error")
                    .default(
                      fetchChatResponseMessagesItemContentBlocksItemBodyTypeDefaultTwo,
                    ),
                  text: zod.string(),
                }),
                zod.object({
                  type: zod
                    .literal("chart")
                    .default(
                      fetchChatResponseMessagesItemContentBlocksItemBodyTypeDefaultThree,
                    ),
                  chartData: zod.record(zod.string(), zod.unknown()),
                }),
                zod.object({
                  type: zod
                    .literal("toolUse")
                    .default(
                      fetchChatResponseMessagesItemContentBlocksItemBodyTypeDefaultFour,
                    ),
                  text: zod.string(),
                }),
                zod.object({
                  type: zod
                    .literal("article")
                    .default(
                      fetchChatResponseMessagesItemContentBlocksItemBodyTypeDefaultFive,
                    ),
                  articleData: zod.object({
                    title: zod.string(),
                    citation: zod.string(),
                    abstract: zod.string(),
                    published_date: zod.iso.datetime({}),
                    pmcid: zod.string(),
                    pmid: zod.string(),
                    chunks: zod.array(zod.string()),
                    citation_data: zod.object({
                      pmcid: zod.string(),
                      title: zod.string(),
                      authors: zod.array(
                        zod.object({
                          surname: zod
                            .union([zod.string(), zod.null()])
                            .optional(),
                          given_names: zod
                            .union([zod.string(), zod.null()])
                            .optional(),
                          full_name: zod
                            .union([zod.string(), zod.null()])
                            .optional(),
                        }),
                      ),
                      author_string: zod.string(),
                      journal: zod.string(),
                      pub_date: zod.string(),
                      volume: zod.union([zod.string(), zod.null()]).optional(),
                      issue: zod.union([zod.string(), zod.null()]).optional(),
                      pages: zod.union([zod.string(), zod.null()]).optional(),
                      doi: zod.union([zod.string(), zod.null()]).optional(),
                      issn: zod.union([zod.string(), zod.null()]).optional(),
                      pubmed_link: zod
                        .union([zod.string(), zod.null()])
                        .optional(),
                      formatted: zod.object({
                        apa: zod.string(),
                        mla: zod.string(),
                        vancouver: zod.string(),
                      }),
                    }),
                  }),
                }),
                zod.object({
                  type: zod
                    .literal("sources_v2")
                    .default(
                      fetchChatResponseMessagesItemContentBlocksItemBodyTypeDefaultSix,
                    ),
                  sources: zod.array(
                    zod.object({
                      title: zod.string(),
                      subtitle: zod.string(),
                      content: zod.union([
                        zod.object({
                          type: zod
                            .literal("table")
                            .default(
                              fetchChatResponseMessagesItemContentBlocksItemBodySourcesItemContentTypeDefault,
                            ),
                          rows: zod.array(
                            zod.record(zod.string(), zod.unknown()),
                          ),
                          columns: zod.array(zod.string()),
                          note: zod.string(),
                          column_schema: zod
                            .record(
                              zod.string(),
                              zod.enum([
                                "string",
                                "integer",
                                "float",
                                "boolean",
                                "datetime",
                              ]),
                            )
                            .default(
                              fetchChatResponseMessagesItemContentBlocksItemBodySourcesItemContentColumnSchemaDefault,
                            ),
                        }),
                        zod.object({
                          type: zod
                            .literal("link")
                            .default(
                              fetchChatResponseMessagesItemContentBlocksItemBodySourcesItemContentTypeDefaultOne,
                            ),
                          link: zod.string(),
                        }),
                      ]),
                      icon: zod
                        .union([
                          zod
                            .string()
                            .describe(
                              "An icon identifier - opaque to the client.",
                            ),
                          zod.null(),
                        ])
                        .optional(),
                    }),
                  ),
                }),
                zod.object({
                  type: zod
                    .literal("pendingReview")
                    .default(
                      fetchChatResponseMessagesItemContentBlocksItemBodyTypeDefaultSeven,
                    ),
                }),
                zod.object({
                  type: zod
                    .literal("chainOfThought")
                    .default(
                      fetchChatResponseMessagesItemContentBlocksItemBodyTypeDefaultEight,
                    ),
                  text: zod.string(),
                }),
                zod.object({
                  type: zod
                    .literal("revised")
                    .default(
                      fetchChatResponseMessagesItemContentBlocksItemBodyTypeDefaultNine,
                    ),
                  text: zod.string(),
                }),
                zod.object({
                  type: zod
                    .literal("origin")
                    .default(
                      fetchChatResponseMessagesItemContentBlocksItemBodyTypeDefaultOnezero,
                    ),
                  origin: zod.union([zod.enum(["insight"]), zod.unknown()]),
                }),
                zod.object({
                  type: zod
                    .literal("stagingStatus")
                    .default(
                      fetchChatResponseMessagesItemContentBlocksItemBodyTypeDefaultOneone,
                    ),
                  status: zod.enum(["committed", "staged"]),
                }),
                zod.object({
                  type: zod
                    .literal("completeStatus")
                    .default(
                      fetchChatResponseMessagesItemContentBlocksItemBodyTypeDefaultOnetwo,
                    ),
                  status: zod.enum(["incomplete", "complete"]),
                }),
                zod.object({
                  type: zod
                    .literal("retryStatus")
                    .default(
                      fetchChatResponseMessagesItemContentBlocksItemBodyTypeDefaultOnethree,
                    ),
                  status: zod.enum(["retry", "handled"]),
                  error: zod
                    .union([
                      zod.object({
                        message: zod.string(),
                        trace: zod.string(),
                        code: zod.union([zod.string(), zod.null()]).optional(),
                        payload: zod
                          .union([
                            zod.record(zod.string(), zod.unknown()),
                            zod.null(),
                          ])
                          .optional(),
                        status_code: zod
                          .union([zod.number(), zod.null()])
                          .optional(),
                      }),
                      zod.null(),
                    ])
                    .optional(),
                }),
                zod.object({
                  type: zod
                    .literal("assessmentResult")
                    .default(
                      fetchChatResponseMessagesItemContentBlocksItemBodyTypeDefaultOnefour,
                    ),
                  assessmentResult: zod.unknown(),
                }),
                zod.object({
                  type: zod
                    .literal("voiceMessageMarker")
                    .default(
                      fetchChatResponseMessagesItemContentBlocksItemBodyTypeDefaultOnefive,
                    ),
                  obscured: zod.boolean(),
                }),
                zod
                  .object({
                    type: zod
                      .literal("voiceUpload")
                      .default(
                        fetchChatResponseMessagesItemContentBlocksItemBodyTypeDefaultOnesix,
                      ),
                    uploadId: zod.uuid(),
                  })
                  .describe(
                    "Reference to a confirmed voice upload associated with the message.\nThis is provenance metadata, not semantic message content.",
                  ),
                zod.object({
                  type: zod
                    .literal("debug")
                    .default(
                      fetchChatResponseMessagesItemContentBlocksItemBodyTypeDefaultOneseven,
                    ),
                  title: zod.string(),
                  content: zod.string(),
                }),
                zod.object({
                  type: zod
                    .literal("blank")
                    .default(
                      fetchChatResponseMessagesItemContentBlocksItemBodyTypeDefaultOneeight,
                    ),
                }),
                zod.object({
                  type: zod
                    .literal("answerPartSuggestion")
                    .default(
                      fetchChatResponseMessagesItemContentBlocksItemBodyTypeDefaultOnenine,
                    ),
                  answerPart: zod.union([
                    zod
                      .object({
                        answer_part_type: zod
                          .literal("revise_message")
                          .default(
                            fetchChatResponseMessagesItemContentBlocksItemBodyAnswerPartAnswerPartTypeDefault,
                          ),
                        message_id: zod.uuid(),
                        response: zod.enum(["accept", "revise"]),
                        new_response: zod.string(),
                        explanation: zod
                          .union([zod.string(), zod.null()])
                          .optional(),
                        send_to_patient: zod
                          .boolean()
                          .default(
                            fetchChatResponseMessagesItemContentBlocksItemBodyAnswerPartSendToPatientDefault,
                          ),
                      })
                      .describe(
                        "This is a response to a ReviseMessageAnswerPartRequestT. It stores the clinician's judgement on the message.",
                      ),
                    zod
                      .object({
                        answer_part_type: zod
                          .literal("note")
                          .default(
                            fetchChatResponseMessagesItemContentBlocksItemBodyAnswerPartAnswerPartTypeDefaultOne,
                          ),
                        patient_id: zod.uuid(),
                        note: zod.string(),
                      })
                      .describe(
                        "This is a response to a NoteAnswerPartRequestT. It is a note that will be entered into the EHR system.",
                      ),
                    zod
                      .object({
                        answer_part_type: zod
                          .literal("rejected")
                          .default(
                            fetchChatResponseMessagesItemContentBlocksItemBodyAnswerPartAnswerPartTypeDefaultTwo,
                          ),
                        reason: zod
                          .union([zod.string(), zod.null()])
                          .optional()
                          .describe("Optional reason for rejection"),
                      })
                      .describe(
                        "This is a response to a RejectedAnswerPartRequestT. It indicates the clinician is rejecting the entire request.",
                      ),
                    zod
                      .object({
                        answer_part_type: zod
                          .literal("prescription")
                          .default(
                            fetchChatResponseMessagesItemContentBlocksItemBodyAnswerPartAnswerPartTypeDefaultThree,
                          ),
                        patient_id: zod.uuid(),
                        dosespot_prescription_id: zod.string(),
                      })
                      .describe(
                        "This is a response to a PrescriptionAnswerPartRequestT. It stores a prescription ID that will be sent to pharmacy.",
                      ),
                    zod
                      .object({
                        answer_part_type: zod
                          .literal("prescription_suggestion")
                          .default(
                            fetchChatResponseMessagesItemContentBlocksItemBodyAnswerPartAnswerPartTypeDefaultFour,
                          ),
                        dispensable_drug_id: zod
                          .union([zod.number(), zod.null()])
                          .optional()
                          .describe(
                            "DoseSpot DispensableDrugId for the medication",
                          ),
                        pharmacy_id: zod
                          .union([zod.number(), zod.null()])
                          .optional()
                          .describe("DoseSpot PharmacyId for the pharmacy"),
                        directions: zod
                          .union([zod.string(), zod.null()])
                          .optional()
                          .describe("Suggested directions for use"),
                        quantity: zod
                          .union([zod.number(), zod.null()])
                          .optional()
                          .describe("Suggested quantity"),
                        refills: zod
                          .union([zod.number(), zod.null()])
                          .optional()
                          .describe("Suggested number of refills"),
                        notes: zod
                          .union([zod.string(), zod.null()])
                          .optional()
                          .describe("Additional notes about the prescription"),
                      })
                      .describe(
                        "Suggested prescription data that can be used to prepopulate a prescription form.",
                      ),
                  ]),
                }),
                zod
                  .object({
                    type: zod
                      .literal("fileAttachment")
                      .default(
                        fetchChatResponseMessagesItemContentBlocksItemBodyTypeDefaultTwozero,
                      ),
                    attachmentId: zod.uuid(),
                    filename: zod.union([zod.string(), zod.null()]).optional(),
                    mimeType: zod.union([zod.string(), zod.null()]).optional(),
                    fileType: zod
                      .union([
                        zod
                          .enum(["image", "document", "audio"])
                          .describe("Type of file attachment."),
                        zod.null(),
                      ])
                      .optional(),
                  })
                  .describe(
                    "Reference to an uploaded file (image or PDF).\nAll metadata is stored in the database and fetched when needed.",
                  ),
                zod.object({
                  type: zod
                    .literal("actionChip")
                    .default(
                      fetchChatResponseMessagesItemContentBlocksItemBodyTypeDefaultTwoone,
                    ),
                  label: zod.string(),
                  action: zod.string(),
                }),
                zod
                  .object({
                    type: zod
                      .literal("mention")
                      .default(
                        fetchChatResponseMessagesItemContentBlocksItemBodyTypeDefaultTwotwo,
                      ),
                    sourceUrl: zod.string(),
                  })
                  .describe(
                    "Reference to a durable, resolver-backed snapshot (`LiveSource`).\n\nMentions are not rendered on the client at all -- they exist purely so the\nagent can read the underlying snapshot as a prompt fragment. Clients\nshould hide these blocks from the user-facing message view.\n\n`source_url` is a `lotus-kb:\/\/live-sources\/users\/{user_id}\/...` URL minted\nby the LiveSource promotion endpoint. The URL is owner-scoped: the\nvalidation layer drops the block if the URL is not a LiveSource URL\nowned by the calling user, so users cannot fabricate authoritative-looking\nmentions or smuggle in another user's snapshot.\n\nThe url is resolvable by the Lotus URL resolver, so the agent can cite\nit directly and the snapshot persists indefinitely (not bound to a\nRedis TTL).",
                  ),
                zod
                  .object({
                    type: zod
                      .literal("directive")
                      .default(
                        fetchChatResponseMessagesItemContentBlocksItemBodyTypeDefaultTwothree,
                      ),
                    directive: zod.string(),
                  })
                  .describe(
                    "The directive a Lotus message was written to answer.\n\nThe patient never sees it; Lotus sees it as part of the message wherever\nthe message appears in its history.",
                  ),
              ]),
              zod.unknown(),
            ]),
            createdAt: zod.iso.datetime({}).optional(),
          }),
        ),
        completionState: zod.enum(["incomplete", "complete"]).optional(),
      }),
    ),
    conversationId: zod.uuid(),
  })
  .describe("Response containing chat messages for a conversation.");

/**
 * Fetch chat messages for the primary conversation.

If no conversation ID is specified, this endpoint returns messages from
the user's primary conversation.

Supports pagination via before/after message IDs:
- Use `before` to fetch messages older than the specified message ID
- Use `after` to fetch messages newer than the specified message ID

Args:
    user_id: The patient's user ID
    before: Optional message ID to fetch messages before (older than)
    after: Optional message ID to fetch messages after (newer than)

Returns:
    FetchChatResponseT containing the list of messages and conversation ID

Raises:
    ValueError: If the user has no primary conversation
 * @summary Fetch Primary Chat
 */
export const fetchPrimaryChatParams = zod.object({
  user_id: zod.uuid(),
});

export const fetchPrimaryChatQueryParams = zod.object({
  before: zod.union([zod.uuid(), zod.null()]).optional(),
  after: zod.union([zod.uuid(), zod.null()]).optional(),
});

export const fetchPrimaryChatResponseMessagesItemContentBlocksItemBodyTypeDefault =
  "text";
export const fetchPrimaryChatResponseMessagesItemContentBlocksItemBodyTypeDefaultOne =
  "choiceChip";
export const fetchPrimaryChatResponseMessagesItemContentBlocksItemBodyTypeDefaultTwo =
  "error";
export const fetchPrimaryChatResponseMessagesItemContentBlocksItemBodyTypeDefaultThree =
  "chart";
export const fetchPrimaryChatResponseMessagesItemContentBlocksItemBodyTypeDefaultFour =
  "toolUse";
export const fetchPrimaryChatResponseMessagesItemContentBlocksItemBodyTypeDefaultFive =
  "article";
export const fetchPrimaryChatResponseMessagesItemContentBlocksItemBodyTypeDefaultSix =
  "sources_v2";
export const fetchPrimaryChatResponseMessagesItemContentBlocksItemBodySourcesItemContentTypeDefault =
  "table";
export const fetchPrimaryChatResponseMessagesItemContentBlocksItemBodySourcesItemContentColumnSchemaDefault =
  {};
export const fetchPrimaryChatResponseMessagesItemContentBlocksItemBodySourcesItemContentTypeDefaultOne =
  "link";
export const fetchPrimaryChatResponseMessagesItemContentBlocksItemBodyTypeDefaultSeven =
  "pendingReview";
export const fetchPrimaryChatResponseMessagesItemContentBlocksItemBodyTypeDefaultEight =
  "chainOfThought";
export const fetchPrimaryChatResponseMessagesItemContentBlocksItemBodyTypeDefaultNine =
  "revised";
export const fetchPrimaryChatResponseMessagesItemContentBlocksItemBodyTypeDefaultOnezero =
  "origin";
export const fetchPrimaryChatResponseMessagesItemContentBlocksItemBodyTypeDefaultOneone =
  "stagingStatus";
export const fetchPrimaryChatResponseMessagesItemContentBlocksItemBodyTypeDefaultOnetwo =
  "completeStatus";
export const fetchPrimaryChatResponseMessagesItemContentBlocksItemBodyTypeDefaultOnethree =
  "retryStatus";
export const fetchPrimaryChatResponseMessagesItemContentBlocksItemBodyTypeDefaultOnefour =
  "assessmentResult";
export const fetchPrimaryChatResponseMessagesItemContentBlocksItemBodyTypeDefaultOnefive =
  "voiceMessageMarker";
export const fetchPrimaryChatResponseMessagesItemContentBlocksItemBodyTypeDefaultOnesix =
  "voiceUpload";
export const fetchPrimaryChatResponseMessagesItemContentBlocksItemBodyTypeDefaultOneseven =
  "debug";
export const fetchPrimaryChatResponseMessagesItemContentBlocksItemBodyTypeDefaultOneeight =
  "blank";
export const fetchPrimaryChatResponseMessagesItemContentBlocksItemBodyTypeDefaultOnenine =
  "answerPartSuggestion";
export const fetchPrimaryChatResponseMessagesItemContentBlocksItemBodyAnswerPartAnswerPartTypeDefault =
  "revise_message";
export const fetchPrimaryChatResponseMessagesItemContentBlocksItemBodyAnswerPartSendToPatientDefault = true;
export const fetchPrimaryChatResponseMessagesItemContentBlocksItemBodyAnswerPartAnswerPartTypeDefaultOne =
  "note";
export const fetchPrimaryChatResponseMessagesItemContentBlocksItemBodyAnswerPartAnswerPartTypeDefaultTwo =
  "rejected";
export const fetchPrimaryChatResponseMessagesItemContentBlocksItemBodyAnswerPartAnswerPartTypeDefaultThree =
  "prescription";
export const fetchPrimaryChatResponseMessagesItemContentBlocksItemBodyAnswerPartAnswerPartTypeDefaultFour =
  "prescription_suggestion";
export const fetchPrimaryChatResponseMessagesItemContentBlocksItemBodyTypeDefaultTwozero =
  "fileAttachment";
export const fetchPrimaryChatResponseMessagesItemContentBlocksItemBodyTypeDefaultTwoone =
  "actionChip";
export const fetchPrimaryChatResponseMessagesItemContentBlocksItemBodyTypeDefaultTwotwo =
  "mention";
export const fetchPrimaryChatResponseMessagesItemContentBlocksItemBodyTypeDefaultTwothree =
  "directive";

export const fetchPrimaryChatResponse = zod
  .object({
    messages: zod.array(
      zod.object({
        id: zod.uuid(),
        createdAt: zod.iso.datetime({}),
        sender: zod.enum(["Lotus", "Debug", "User", "Clinician"]),
        status: zod.enum(["committed", "staged"]).optional(),
        contentBlocks: zod.array(
          zod.object({
            id: zod.uuid(),
            body: zod.union([
              zod.union([
                zod.object({
                  type: zod
                    .literal("text")
                    .default(
                      fetchPrimaryChatResponseMessagesItemContentBlocksItemBodyTypeDefault,
                    ),
                  stream: zod.enum(["Chat", "Thinking"]).optional(),
                  text: zod.string(),
                }),
                zod.object({
                  type: zod
                    .literal("choiceChip")
                    .default(
                      fetchPrimaryChatResponseMessagesItemContentBlocksItemBodyTypeDefaultOne,
                    ),
                  text: zod.string(),
                }),
                zod.object({
                  type: zod
                    .literal("error")
                    .default(
                      fetchPrimaryChatResponseMessagesItemContentBlocksItemBodyTypeDefaultTwo,
                    ),
                  text: zod.string(),
                }),
                zod.object({
                  type: zod
                    .literal("chart")
                    .default(
                      fetchPrimaryChatResponseMessagesItemContentBlocksItemBodyTypeDefaultThree,
                    ),
                  chartData: zod.record(zod.string(), zod.unknown()),
                }),
                zod.object({
                  type: zod
                    .literal("toolUse")
                    .default(
                      fetchPrimaryChatResponseMessagesItemContentBlocksItemBodyTypeDefaultFour,
                    ),
                  text: zod.string(),
                }),
                zod.object({
                  type: zod
                    .literal("article")
                    .default(
                      fetchPrimaryChatResponseMessagesItemContentBlocksItemBodyTypeDefaultFive,
                    ),
                  articleData: zod.object({
                    title: zod.string(),
                    citation: zod.string(),
                    abstract: zod.string(),
                    published_date: zod.iso.datetime({}),
                    pmcid: zod.string(),
                    pmid: zod.string(),
                    chunks: zod.array(zod.string()),
                    citation_data: zod.object({
                      pmcid: zod.string(),
                      title: zod.string(),
                      authors: zod.array(
                        zod.object({
                          surname: zod
                            .union([zod.string(), zod.null()])
                            .optional(),
                          given_names: zod
                            .union([zod.string(), zod.null()])
                            .optional(),
                          full_name: zod
                            .union([zod.string(), zod.null()])
                            .optional(),
                        }),
                      ),
                      author_string: zod.string(),
                      journal: zod.string(),
                      pub_date: zod.string(),
                      volume: zod.union([zod.string(), zod.null()]).optional(),
                      issue: zod.union([zod.string(), zod.null()]).optional(),
                      pages: zod.union([zod.string(), zod.null()]).optional(),
                      doi: zod.union([zod.string(), zod.null()]).optional(),
                      issn: zod.union([zod.string(), zod.null()]).optional(),
                      pubmed_link: zod
                        .union([zod.string(), zod.null()])
                        .optional(),
                      formatted: zod.object({
                        apa: zod.string(),
                        mla: zod.string(),
                        vancouver: zod.string(),
                      }),
                    }),
                  }),
                }),
                zod.object({
                  type: zod
                    .literal("sources_v2")
                    .default(
                      fetchPrimaryChatResponseMessagesItemContentBlocksItemBodyTypeDefaultSix,
                    ),
                  sources: zod.array(
                    zod.object({
                      title: zod.string(),
                      subtitle: zod.string(),
                      content: zod.union([
                        zod.object({
                          type: zod
                            .literal("table")
                            .default(
                              fetchPrimaryChatResponseMessagesItemContentBlocksItemBodySourcesItemContentTypeDefault,
                            ),
                          rows: zod.array(
                            zod.record(zod.string(), zod.unknown()),
                          ),
                          columns: zod.array(zod.string()),
                          note: zod.string(),
                          column_schema: zod
                            .record(
                              zod.string(),
                              zod.enum([
                                "string",
                                "integer",
                                "float",
                                "boolean",
                                "datetime",
                              ]),
                            )
                            .default(
                              fetchPrimaryChatResponseMessagesItemContentBlocksItemBodySourcesItemContentColumnSchemaDefault,
                            ),
                        }),
                        zod.object({
                          type: zod
                            .literal("link")
                            .default(
                              fetchPrimaryChatResponseMessagesItemContentBlocksItemBodySourcesItemContentTypeDefaultOne,
                            ),
                          link: zod.string(),
                        }),
                      ]),
                      icon: zod
                        .union([
                          zod
                            .string()
                            .describe(
                              "An icon identifier - opaque to the client.",
                            ),
                          zod.null(),
                        ])
                        .optional(),
                    }),
                  ),
                }),
                zod.object({
                  type: zod
                    .literal("pendingReview")
                    .default(
                      fetchPrimaryChatResponseMessagesItemContentBlocksItemBodyTypeDefaultSeven,
                    ),
                }),
                zod.object({
                  type: zod
                    .literal("chainOfThought")
                    .default(
                      fetchPrimaryChatResponseMessagesItemContentBlocksItemBodyTypeDefaultEight,
                    ),
                  text: zod.string(),
                }),
                zod.object({
                  type: zod
                    .literal("revised")
                    .default(
                      fetchPrimaryChatResponseMessagesItemContentBlocksItemBodyTypeDefaultNine,
                    ),
                  text: zod.string(),
                }),
                zod.object({
                  type: zod
                    .literal("origin")
                    .default(
                      fetchPrimaryChatResponseMessagesItemContentBlocksItemBodyTypeDefaultOnezero,
                    ),
                  origin: zod.union([zod.enum(["insight"]), zod.unknown()]),
                }),
                zod.object({
                  type: zod
                    .literal("stagingStatus")
                    .default(
                      fetchPrimaryChatResponseMessagesItemContentBlocksItemBodyTypeDefaultOneone,
                    ),
                  status: zod.enum(["committed", "staged"]),
                }),
                zod.object({
                  type: zod
                    .literal("completeStatus")
                    .default(
                      fetchPrimaryChatResponseMessagesItemContentBlocksItemBodyTypeDefaultOnetwo,
                    ),
                  status: zod.enum(["incomplete", "complete"]),
                }),
                zod.object({
                  type: zod
                    .literal("retryStatus")
                    .default(
                      fetchPrimaryChatResponseMessagesItemContentBlocksItemBodyTypeDefaultOnethree,
                    ),
                  status: zod.enum(["retry", "handled"]),
                  error: zod
                    .union([
                      zod.object({
                        message: zod.string(),
                        trace: zod.string(),
                        code: zod.union([zod.string(), zod.null()]).optional(),
                        payload: zod
                          .union([
                            zod.record(zod.string(), zod.unknown()),
                            zod.null(),
                          ])
                          .optional(),
                        status_code: zod
                          .union([zod.number(), zod.null()])
                          .optional(),
                      }),
                      zod.null(),
                    ])
                    .optional(),
                }),
                zod.object({
                  type: zod
                    .literal("assessmentResult")
                    .default(
                      fetchPrimaryChatResponseMessagesItemContentBlocksItemBodyTypeDefaultOnefour,
                    ),
                  assessmentResult: zod.unknown(),
                }),
                zod.object({
                  type: zod
                    .literal("voiceMessageMarker")
                    .default(
                      fetchPrimaryChatResponseMessagesItemContentBlocksItemBodyTypeDefaultOnefive,
                    ),
                  obscured: zod.boolean(),
                }),
                zod
                  .object({
                    type: zod
                      .literal("voiceUpload")
                      .default(
                        fetchPrimaryChatResponseMessagesItemContentBlocksItemBodyTypeDefaultOnesix,
                      ),
                    uploadId: zod.uuid(),
                  })
                  .describe(
                    "Reference to a confirmed voice upload associated with the message.\nThis is provenance metadata, not semantic message content.",
                  ),
                zod.object({
                  type: zod
                    .literal("debug")
                    .default(
                      fetchPrimaryChatResponseMessagesItemContentBlocksItemBodyTypeDefaultOneseven,
                    ),
                  title: zod.string(),
                  content: zod.string(),
                }),
                zod.object({
                  type: zod
                    .literal("blank")
                    .default(
                      fetchPrimaryChatResponseMessagesItemContentBlocksItemBodyTypeDefaultOneeight,
                    ),
                }),
                zod.object({
                  type: zod
                    .literal("answerPartSuggestion")
                    .default(
                      fetchPrimaryChatResponseMessagesItemContentBlocksItemBodyTypeDefaultOnenine,
                    ),
                  answerPart: zod.union([
                    zod
                      .object({
                        answer_part_type: zod
                          .literal("revise_message")
                          .default(
                            fetchPrimaryChatResponseMessagesItemContentBlocksItemBodyAnswerPartAnswerPartTypeDefault,
                          ),
                        message_id: zod.uuid(),
                        response: zod.enum(["accept", "revise"]),
                        new_response: zod.string(),
                        explanation: zod
                          .union([zod.string(), zod.null()])
                          .optional(),
                        send_to_patient: zod
                          .boolean()
                          .default(
                            fetchPrimaryChatResponseMessagesItemContentBlocksItemBodyAnswerPartSendToPatientDefault,
                          ),
                      })
                      .describe(
                        "This is a response to a ReviseMessageAnswerPartRequestT. It stores the clinician's judgement on the message.",
                      ),
                    zod
                      .object({
                        answer_part_type: zod
                          .literal("note")
                          .default(
                            fetchPrimaryChatResponseMessagesItemContentBlocksItemBodyAnswerPartAnswerPartTypeDefaultOne,
                          ),
                        patient_id: zod.uuid(),
                        note: zod.string(),
                      })
                      .describe(
                        "This is a response to a NoteAnswerPartRequestT. It is a note that will be entered into the EHR system.",
                      ),
                    zod
                      .object({
                        answer_part_type: zod
                          .literal("rejected")
                          .default(
                            fetchPrimaryChatResponseMessagesItemContentBlocksItemBodyAnswerPartAnswerPartTypeDefaultTwo,
                          ),
                        reason: zod
                          .union([zod.string(), zod.null()])
                          .optional()
                          .describe("Optional reason for rejection"),
                      })
                      .describe(
                        "This is a response to a RejectedAnswerPartRequestT. It indicates the clinician is rejecting the entire request.",
                      ),
                    zod
                      .object({
                        answer_part_type: zod
                          .literal("prescription")
                          .default(
                            fetchPrimaryChatResponseMessagesItemContentBlocksItemBodyAnswerPartAnswerPartTypeDefaultThree,
                          ),
                        patient_id: zod.uuid(),
                        dosespot_prescription_id: zod.string(),
                      })
                      .describe(
                        "This is a response to a PrescriptionAnswerPartRequestT. It stores a prescription ID that will be sent to pharmacy.",
                      ),
                    zod
                      .object({
                        answer_part_type: zod
                          .literal("prescription_suggestion")
                          .default(
                            fetchPrimaryChatResponseMessagesItemContentBlocksItemBodyAnswerPartAnswerPartTypeDefaultFour,
                          ),
                        dispensable_drug_id: zod
                          .union([zod.number(), zod.null()])
                          .optional()
                          .describe(
                            "DoseSpot DispensableDrugId for the medication",
                          ),
                        pharmacy_id: zod
                          .union([zod.number(), zod.null()])
                          .optional()
                          .describe("DoseSpot PharmacyId for the pharmacy"),
                        directions: zod
                          .union([zod.string(), zod.null()])
                          .optional()
                          .describe("Suggested directions for use"),
                        quantity: zod
                          .union([zod.number(), zod.null()])
                          .optional()
                          .describe("Suggested quantity"),
                        refills: zod
                          .union([zod.number(), zod.null()])
                          .optional()
                          .describe("Suggested number of refills"),
                        notes: zod
                          .union([zod.string(), zod.null()])
                          .optional()
                          .describe("Additional notes about the prescription"),
                      })
                      .describe(
                        "Suggested prescription data that can be used to prepopulate a prescription form.",
                      ),
                  ]),
                }),
                zod
                  .object({
                    type: zod
                      .literal("fileAttachment")
                      .default(
                        fetchPrimaryChatResponseMessagesItemContentBlocksItemBodyTypeDefaultTwozero,
                      ),
                    attachmentId: zod.uuid(),
                    filename: zod.union([zod.string(), zod.null()]).optional(),
                    mimeType: zod.union([zod.string(), zod.null()]).optional(),
                    fileType: zod
                      .union([
                        zod
                          .enum(["image", "document", "audio"])
                          .describe("Type of file attachment."),
                        zod.null(),
                      ])
                      .optional(),
                  })
                  .describe(
                    "Reference to an uploaded file (image or PDF).\nAll metadata is stored in the database and fetched when needed.",
                  ),
                zod.object({
                  type: zod
                    .literal("actionChip")
                    .default(
                      fetchPrimaryChatResponseMessagesItemContentBlocksItemBodyTypeDefaultTwoone,
                    ),
                  label: zod.string(),
                  action: zod.string(),
                }),
                zod
                  .object({
                    type: zod
                      .literal("mention")
                      .default(
                        fetchPrimaryChatResponseMessagesItemContentBlocksItemBodyTypeDefaultTwotwo,
                      ),
                    sourceUrl: zod.string(),
                  })
                  .describe(
                    "Reference to a durable, resolver-backed snapshot (`LiveSource`).\n\nMentions are not rendered on the client at all -- they exist purely so the\nagent can read the underlying snapshot as a prompt fragment. Clients\nshould hide these blocks from the user-facing message view.\n\n`source_url` is a `lotus-kb:\/\/live-sources\/users\/{user_id}\/...` URL minted\nby the LiveSource promotion endpoint. The URL is owner-scoped: the\nvalidation layer drops the block if the URL is not a LiveSource URL\nowned by the calling user, so users cannot fabricate authoritative-looking\nmentions or smuggle in another user's snapshot.\n\nThe url is resolvable by the Lotus URL resolver, so the agent can cite\nit directly and the snapshot persists indefinitely (not bound to a\nRedis TTL).",
                  ),
                zod
                  .object({
                    type: zod
                      .literal("directive")
                      .default(
                        fetchPrimaryChatResponseMessagesItemContentBlocksItemBodyTypeDefaultTwothree,
                      ),
                    directive: zod.string(),
                  })
                  .describe(
                    "The directive a Lotus message was written to answer.\n\nThe patient never sees it; Lotus sees it as part of the message wherever\nthe message appears in its history.",
                  ),
              ]),
              zod.unknown(),
            ]),
            createdAt: zod.iso.datetime({}).optional(),
          }),
        ),
        completionState: zod.enum(["incomplete", "complete"]).optional(),
      }),
    ),
    conversationId: zod.uuid(),
  })
  .describe("Response containing chat messages for a conversation.");

/**
 * Fetch a presigned S3 URL for a specific variant of a patient's file attachment.

Clinicians can request a specific variant (dimensions and zoom type for images,
page truncation for documents).
Returns null if the variant is not meaningful for the content or is unknown to Lotus.

Args:
    user_id: The patient's user ID
    attachment_id: The attachment ID
    args: The variant request

Returns:
    FetchViewUrlForVariantReplyT with the presigned URL if the variant
    is applicable, or with view_url=None if the variant is not meaningful
    for the content type.
 * @summary Fetch Attachment Variant
 */
export const fetchAttachmentVariantParams = zod.object({
  user_id: zod.uuid(),
  attachment_id: zod.uuid(),
});

export const fetchAttachmentVariantBody = zod
  .object({
    variant: zod.union([
      zod
        .object({
          variantType: zod
            .enum(["original", "square", "same_aspect_ratio"])
            .describe("Type of image variant."),
          dimensions: zod
            .object({
              width: zod.number(),
              height: zod.number(),
            })
            .describe("Dimensions for image variant."),
          zoomType: zod
            .enum(["content"])
            .optional()
            .describe("Type of zoom for image variants."),
        })
        .describe("Request for a specific image variant."),
      zod
        .object({
          variantType: zod
            .enum([
              "original",
              "truncated",
              "textualize_over",
              "textualize_always",
            ])
            .describe("Type of document variant."),
          pages: zod.number(),
          bytesOfText: zod.number(),
        })
        .describe("Request for a specific document variant."),
    ]),
  })
  .describe("Request for fetching a specific variant of a file attachment.");

export const fetchAttachmentVariantResponse = zod.object({
  viewUrl: zod.union([zod.string(), zod.null()]).optional(),
  fileType: zod
    .enum(["image", "document", "audio"])
    .describe("Type of file attachment."),
  filename: zod.string(),
  mimeType: zod.string(),
  expiresInSeconds: zod.union([zod.number(), zod.null()]).optional(),
});

/**
 * Fetch patient demographic information for the specified user.

All fields are derived from the dossier — the single source of truth used
by insurance discovery, lab-order billing, and the rest of the care
pipeline.
 * @summary Fetch Patient Info
 */
export const fetchPatientInfoParams = zod.object({
  user_id: zod.string(),
});

export const fetchPatientInfoResponsePatientInfoOriginIdsDefault = [];

export const fetchPatientInfoResponse = zod
  .object({
    patientInfo: zod.object({
      id: zod.string(),
      name: zod.string(),
      age: zod.union([zod.number(), zod.null()]).optional(),
      date_of_birth: zod.union([zod.string(), zod.null()]).optional(),
      sex: zod
        .union([zod.enum(["male", "female", "other", "unknown"]), zod.null()])
        .optional(),
      primary_language: zod.union([zod.string(), zod.null()]).optional(),
      phone: zod.union([zod.string(), zod.null()]).optional(),
      email: zod.union([zod.string(), zod.null()]).optional(),
      address: zod.union([zod.string(), zod.null()]).optional(),
      insurance: zod.union([zod.string(), zod.null()]).optional(),
      primary_pharmacy: zod.union([zod.string(), zod.null()]).optional(),
      emergency_contact: zod.union([zod.string(), zod.null()]).optional(),
      med_history_consent_at: zod.union([zod.string(), zod.null()]).optional(),
      origin_ids: zod
        .array(zod.string())
        .default(fetchPatientInfoResponsePatientInfoOriginIdsDefault),
    }),
  })
  .describe("Response containing patient demographic information.");

/**
 * Pull Surescripts medication history for a patient via DoseSpot.

Fetches the history, and returns it directly.
The data is also ingested into the PHR via the reingested FHIR plugin on
the next PHR refresh.
 * @summary Pull Med History
 */
export const pullMedHistoryParams = zod.object({
  user_id: zod.string(),
});

export const pullMedHistoryResponse = zod.object({
  items: zod.array(
    zod.object({
      displayName: zod.union([zod.string(), zod.null()]).optional(),
      genericDrugName: zod.union([zod.string(), zod.null()]).optional(),
      ndc: zod.union([zod.string(), zod.null()]).optional(),
      rxcui: zod.union([zod.string(), zod.null()]).optional(),
      strength: zod.union([zod.string(), zod.null()]).optional(),
      doseForm: zod.union([zod.string(), zod.null()]).optional(),
      route: zod.union([zod.string(), zod.null()]).optional(),
      directions: zod.union([zod.string(), zod.null()]).optional(),
      quantity: zod.union([zod.string(), zod.null()]).optional(),
      dispenseUnit: zod.union([zod.string(), zod.null()]).optional(),
      daysSupply: zod.union([zod.number(), zod.null()]).optional(),
      refills: zod.union([zod.string(), zod.null()]).optional(),
      noSubstitutions: zod.union([zod.boolean(), zod.null()]).optional(),
      lastFillDate: zod.union([zod.string(), zod.null()]).optional(),
      effectiveDate: zod.union([zod.string(), zod.null()]).optional(),
      writtenDate: zod.union([zod.string(), zod.null()]).optional(),
      expirationDate: zod.union([zod.string(), zod.null()]).optional(),
      payer: zod.union([zod.string(), zod.null()]).optional(),
      drugClassification: zod.union([zod.string(), zod.null()]).optional(),
      diagnosisCode: zod.union([zod.string(), zod.null()]).optional(),
      schedule: zod.union([zod.number(), zod.null()]).optional(),
      pharmacyNotes: zod.union([zod.string(), zod.null()]).optional(),
      pharmacyRxNumber: zod.union([zod.string(), zod.null()]).optional(),
      compoundIngredientSequence: zod
        .union([zod.number(), zod.null()])
        .optional(),
      patientMedicationHistoryId: zod
        .union([zod.number(), zod.null()])
        .optional(),
      diagnosisQualifier: zod.union([zod.string(), zod.null()]).optional(),
      dispensableDrugId: zod.union([zod.number(), zod.null()]).optional(),
      brand: zod.union([zod.boolean(), zod.null()]).optional(),
      otc: zod.union([zod.boolean(), zod.null()]).optional(),
    }),
  ),
  total: zod.number(),
  disclaimer: zod.string(),
  resultDescription: zod.union([zod.string(), zod.null()]).optional(),
});

/**
 * Every committed demo fixture as it stands for this clinician.

Answers 200 everywhere. Off sandbox the roster is unavailable with no
slots, which is what the copilot keys its rendering on.
 * @summary Fetch Sandbox Demo Roster
 */
export const fetchSandboxDemoRosterResponseRosterAvailabilityTypeDefault =
  "available";
export const fetchSandboxDemoRosterResponseRosterAvailabilityTypeDefaultOne =
  "unavailable";
export const fetchSandboxDemoRosterResponseRosterSlotsItemStateTypeDefault =
  "absent";
export const fetchSandboxDemoRosterResponseRosterSlotsItemStateTypeDefaultOne =
  "seeding";
export const fetchSandboxDemoRosterResponseRosterSlotsItemStateTypeDefaultTwo =
  "ready";
export const fetchSandboxDemoRosterResponseRosterSlotsItemStateTypeDefaultThree =
  "failed";

export const fetchSandboxDemoRosterResponse = zod.object({
  roster: zod.object({
    availability: zod.union([
      zod.object({
        type: zod
          .literal("available")
          .default(fetchSandboxDemoRosterResponseRosterAvailabilityTypeDefault),
      }),
      zod.object({
        type: zod
          .literal("unavailable")
          .default(
            fetchSandboxDemoRosterResponseRosterAvailabilityTypeDefaultOne,
          ),
        reason: zod.enum(["not_sandbox", "overlay_wipe_not_permitted"]),
      }),
    ]),
    slots: zod.array(
      zod
        .object({
          slug: zod.string(),
          display_name: zod.string(),
          state: zod.union([
            zod.object({
              type: zod
                .literal("absent")
                .default(
                  fetchSandboxDemoRosterResponseRosterSlotsItemStateTypeDefault,
                ),
            }),
            zod.object({
              type: zod
                .literal("seeding")
                .default(
                  fetchSandboxDemoRosterResponseRosterSlotsItemStateTypeDefaultOne,
                ),
            }),
            zod
              .object({
                type: zod
                  .literal("ready")
                  .default(
                    fetchSandboxDemoRosterResponseRosterSlotsItemStateTypeDefaultTwo,
                  ),
                patient_user_id: zod.uuid(),
              })
              .describe(
                "The only slot state that carries a chart to open. A link to a copy that\nis not ready is unrepresentable.",
              ),
            zod.object({
              type: zod
                .literal("failed")
                .default(
                  fetchSandboxDemoRosterResponseRosterSlotsItemStateTypeDefaultThree,
                ),
              error_summary: zod.string(),
            }),
          ]),
        })
        .describe("One fixture as it stands for one clinician."),
    ),
  }),
});

/**
 * Create every demo copy this clinician does not have yet.

The copilot calls this once per authenticated session on sandbox. It is
idempotent and never retries a failed copy, so it is safe on every login.
 * @summary Ensure Sandbox Demo Patients
 */
export const ensureSandboxDemoPatientsResponseRosterAvailabilityTypeDefault =
  "available";
export const ensureSandboxDemoPatientsResponseRosterAvailabilityTypeDefaultOne =
  "unavailable";
export const ensureSandboxDemoPatientsResponseRosterSlotsItemStateTypeDefault =
  "absent";
export const ensureSandboxDemoPatientsResponseRosterSlotsItemStateTypeDefaultOne =
  "seeding";
export const ensureSandboxDemoPatientsResponseRosterSlotsItemStateTypeDefaultTwo =
  "ready";
export const ensureSandboxDemoPatientsResponseRosterSlotsItemStateTypeDefaultThree =
  "failed";

export const ensureSandboxDemoPatientsResponse = zod.object({
  roster: zod.object({
    availability: zod.union([
      zod.object({
        type: zod
          .literal("available")
          .default(
            ensureSandboxDemoPatientsResponseRosterAvailabilityTypeDefault,
          ),
      }),
      zod.object({
        type: zod
          .literal("unavailable")
          .default(
            ensureSandboxDemoPatientsResponseRosterAvailabilityTypeDefaultOne,
          ),
        reason: zod.enum(["not_sandbox", "overlay_wipe_not_permitted"]),
      }),
    ]),
    slots: zod.array(
      zod
        .object({
          slug: zod.string(),
          display_name: zod.string(),
          state: zod.union([
            zod.object({
              type: zod
                .literal("absent")
                .default(
                  ensureSandboxDemoPatientsResponseRosterSlotsItemStateTypeDefault,
                ),
            }),
            zod.object({
              type: zod
                .literal("seeding")
                .default(
                  ensureSandboxDemoPatientsResponseRosterSlotsItemStateTypeDefaultOne,
                ),
            }),
            zod
              .object({
                type: zod
                  .literal("ready")
                  .default(
                    ensureSandboxDemoPatientsResponseRosterSlotsItemStateTypeDefaultTwo,
                  ),
                patient_user_id: zod.uuid(),
              })
              .describe(
                "The only slot state that carries a chart to open. A link to a copy that\nis not ready is unrepresentable.",
              ),
            zod.object({
              type: zod
                .literal("failed")
                .default(
                  ensureSandboxDemoPatientsResponseRosterSlotsItemStateTypeDefaultThree,
                ),
              error_summary: zod.string(),
            }),
          ]),
        })
        .describe("One fixture as it stands for one clinician."),
    ),
  }),
});

/**
 * Return the named copies to base. Ready and failed copies are reseeded,
absent ones are created, and copies already seeding are left to the job
that owns them.
 * @summary Reseed Sandbox Demo Patients
 */
export const reseedSandboxDemoPatientsBody = zod.object({
  slugs: zod.array(zod.string()),
});

export const reseedSandboxDemoPatientsResponseRosterAvailabilityTypeDefault =
  "available";
export const reseedSandboxDemoPatientsResponseRosterAvailabilityTypeDefaultOne =
  "unavailable";
export const reseedSandboxDemoPatientsResponseRosterSlotsItemStateTypeDefault =
  "absent";
export const reseedSandboxDemoPatientsResponseRosterSlotsItemStateTypeDefaultOne =
  "seeding";
export const reseedSandboxDemoPatientsResponseRosterSlotsItemStateTypeDefaultTwo =
  "ready";
export const reseedSandboxDemoPatientsResponseRosterSlotsItemStateTypeDefaultThree =
  "failed";

export const reseedSandboxDemoPatientsResponse = zod.object({
  roster: zod.object({
    availability: zod.union([
      zod.object({
        type: zod
          .literal("available")
          .default(
            reseedSandboxDemoPatientsResponseRosterAvailabilityTypeDefault,
          ),
      }),
      zod.object({
        type: zod
          .literal("unavailable")
          .default(
            reseedSandboxDemoPatientsResponseRosterAvailabilityTypeDefaultOne,
          ),
        reason: zod.enum(["not_sandbox", "overlay_wipe_not_permitted"]),
      }),
    ]),
    slots: zod.array(
      zod
        .object({
          slug: zod.string(),
          display_name: zod.string(),
          state: zod.union([
            zod.object({
              type: zod
                .literal("absent")
                .default(
                  reseedSandboxDemoPatientsResponseRosterSlotsItemStateTypeDefault,
                ),
            }),
            zod.object({
              type: zod
                .literal("seeding")
                .default(
                  reseedSandboxDemoPatientsResponseRosterSlotsItemStateTypeDefaultOne,
                ),
            }),
            zod
              .object({
                type: zod
                  .literal("ready")
                  .default(
                    reseedSandboxDemoPatientsResponseRosterSlotsItemStateTypeDefaultTwo,
                  ),
                patient_user_id: zod.uuid(),
              })
              .describe(
                "The only slot state that carries a chart to open. A link to a copy that\nis not ready is unrepresentable.",
              ),
            zod.object({
              type: zod
                .literal("failed")
                .default(
                  reseedSandboxDemoPatientsResponseRosterSlotsItemStateTypeDefaultThree,
                ),
              error_summary: zod.string(),
            }),
          ]),
        })
        .describe("One fixture as it stands for one clinician."),
    ),
  }),
});

/**
 * @summary Search Patients
 */
export const searchPatientsBodyLimitDefault = 1000;

export const searchPatientsBody = zod.object({
  limit: zod.number().default(searchPatientsBodyLimitDefault),
  query: zod.string(),
  desired_relationship: zod
    .enum(["actionable", "licensed", "unlicensed"])
    .optional(),
});

export const searchPatientsResponsePatientsItemPolicyResultDebugYouTagsUsStatesDefault =
  [];
export const searchPatientsResponsePatientsItemPolicyResultDebugYouTagsPracticeAreasDefault =
  [];
export const searchPatientsResponsePatientsItemPolicyResultDebugYouTagsOriginPracticesDefault =
  [];
export const searchPatientsResponsePatientsItemPolicyResultDebugPatientTagsUsStatesDefault =
  [];
export const searchPatientsResponsePatientsItemPolicyResultDebugPatientTagsPracticeAreasDefault =
  [];
export const searchPatientsResponsePatientsItemPolicyResultDebugPatientTagsOriginPracticesDefault =
  [];

export const searchPatientsResponse = zod.object({
  patients: zod.array(
    zod.object({
      user_id: zod.uuid(),
      full_name: zod.string(),
      display_name: zod.string(),
      oldest_request_at: zod.union([zod.iso.datetime({}), zod.null()]),
      urgent_count: zod.number(),
      routine_count: zod.number(),
      unread_count: zod.number(),
      viewer_count: zod.number(),
      total_karma_offer: zod.number(),
      policy_result: zod.object({
        debug: zod.union([
          zod.object({
            you: zod
              .object({
                tags: zod
                  .object({
                    us_states: zod
                      .array(zod.string())
                      .default(
                        searchPatientsResponsePatientsItemPolicyResultDebugYouTagsUsStatesDefault,
                      ),
                    practice_areas: zod
                      .array(zod.enum(["Primary Care", "Psychiatry"]))
                      .default(
                        searchPatientsResponsePatientsItemPolicyResultDebugYouTagsPracticeAreasDefault,
                      ),
                    origin_practices: zod
                      .array(zod.string())
                      .default(
                        searchPatientsResponsePatientsItemPolicyResultDebugYouTagsOriginPracticesDefault,
                      ),
                  })
                  .describe(
                    "Fully typed tag set — each routing dimension is an explicit field.",
                  ),
              })
              .describe(
                "Criteria representing what a clinician is licensed to do.\n\nUses a RoutingTagSetT so that matching generalizes across\nall routing dimensions (state, practice area, origin practice, etc.).",
              ),
            patient: zod
              .object({
                tags: zod
                  .object({
                    us_states: zod
                      .array(zod.string())
                      .default(
                        searchPatientsResponsePatientsItemPolicyResultDebugPatientTagsUsStatesDefault,
                      ),
                    practice_areas: zod
                      .array(zod.enum(["Primary Care", "Psychiatry"]))
                      .default(
                        searchPatientsResponsePatientsItemPolicyResultDebugPatientTagsPracticeAreasDefault,
                      ),
                    origin_practices: zod
                      .array(zod.string())
                      .default(
                        searchPatientsResponsePatientsItemPolicyResultDebugPatientTagsOriginPracticesDefault,
                      ),
                  })
                  .describe(
                    "Fully typed tag set — each routing dimension is an explicit field.",
                  ),
              })
              .describe(
                "What a patient (or a specific request) needs from a clinician.",
              ),
          }),
          zod.string(),
        ]),
        relationship: zod.enum(["actionable", "licensed", "unlicensed"]),
        notes: zod.array(
          zod.object({
            title: zod.string(),
            detail: zod.string(),
          }),
        ),
      }),
      origin_practice: zod.union([zod.string(), zod.null()]).optional(),
      is_new_user: zod.union([zod.boolean(), zod.null()]).optional(),
    }),
  ),
});

/**
 * @summary Hydrate Patients
 */
export const hydratePatientsBody = zod.object({
  patient_ids: zod.array(zod.uuid()),
});

export const hydratePatientsResponsePatientsPolicyResultDebugYouTagsUsStatesDefault =
  [];
export const hydratePatientsResponsePatientsPolicyResultDebugYouTagsPracticeAreasDefault =
  [];
export const hydratePatientsResponsePatientsPolicyResultDebugYouTagsOriginPracticesDefault =
  [];
export const hydratePatientsResponsePatientsPolicyResultDebugPatientTagsUsStatesDefault =
  [];
export const hydratePatientsResponsePatientsPolicyResultDebugPatientTagsPracticeAreasDefault =
  [];
export const hydratePatientsResponsePatientsPolicyResultDebugPatientTagsOriginPracticesDefault =
  [];

export const hydratePatientsResponse = zod.object({
  patients: zod.record(
    zod.string(),
    zod.object({
      user_id: zod.uuid(),
      full_name: zod.string(),
      display_name: zod.string(),
      oldest_request_at: zod.union([zod.iso.datetime({}), zod.null()]),
      urgent_count: zod.number(),
      routine_count: zod.number(),
      unread_count: zod.number(),
      viewer_count: zod.number(),
      total_karma_offer: zod.number(),
      policy_result: zod.object({
        debug: zod.union([
          zod.object({
            you: zod
              .object({
                tags: zod
                  .object({
                    us_states: zod
                      .array(zod.string())
                      .default(
                        hydratePatientsResponsePatientsPolicyResultDebugYouTagsUsStatesDefault,
                      ),
                    practice_areas: zod
                      .array(zod.enum(["Primary Care", "Psychiatry"]))
                      .default(
                        hydratePatientsResponsePatientsPolicyResultDebugYouTagsPracticeAreasDefault,
                      ),
                    origin_practices: zod
                      .array(zod.string())
                      .default(
                        hydratePatientsResponsePatientsPolicyResultDebugYouTagsOriginPracticesDefault,
                      ),
                  })
                  .describe(
                    "Fully typed tag set — each routing dimension is an explicit field.",
                  ),
              })
              .describe(
                "Criteria representing what a clinician is licensed to do.\n\nUses a RoutingTagSetT so that matching generalizes across\nall routing dimensions (state, practice area, origin practice, etc.).",
              ),
            patient: zod
              .object({
                tags: zod
                  .object({
                    us_states: zod
                      .array(zod.string())
                      .default(
                        hydratePatientsResponsePatientsPolicyResultDebugPatientTagsUsStatesDefault,
                      ),
                    practice_areas: zod
                      .array(zod.enum(["Primary Care", "Psychiatry"]))
                      .default(
                        hydratePatientsResponsePatientsPolicyResultDebugPatientTagsPracticeAreasDefault,
                      ),
                    origin_practices: zod
                      .array(zod.string())
                      .default(
                        hydratePatientsResponsePatientsPolicyResultDebugPatientTagsOriginPracticesDefault,
                      ),
                  })
                  .describe(
                    "Fully typed tag set — each routing dimension is an explicit field.",
                  ),
              })
              .describe(
                "What a patient (or a specific request) needs from a clinician.",
              ),
          }),
          zod.string(),
        ]),
        relationship: zod.enum(["actionable", "licensed", "unlicensed"]),
        notes: zod.array(
          zod.object({
            title: zod.string(),
            detail: zod.string(),
          }),
        ),
      }),
      origin_practice: zod.union([zod.string(), zod.null()]).optional(),
      is_new_user: zod.union([zod.boolean(), zod.null()]).optional(),
    }),
  ),
});

/**
 * Suggest the most urgent actionable patient that currently has no viewers.

This endpoint uses a mutex (ActiveLock) to ensure that two clinicians
cannot be suggested the same patient simultaneously. When a patient is
suggested, a "view claim" is automatically created for the requesting
clinician.

Returns None if no actionable patients are available (either there are
no actionable patients, or all actionable patients already have viewers).
 * @summary Suggest Patient Endpoint
 */
export const suggestPatientEndpointResponsePatientPolicyResultDebugYouTagsUsStatesDefault =
  [];
export const suggestPatientEndpointResponsePatientPolicyResultDebugYouTagsPracticeAreasDefault =
  [];
export const suggestPatientEndpointResponsePatientPolicyResultDebugYouTagsOriginPracticesDefault =
  [];
export const suggestPatientEndpointResponsePatientPolicyResultDebugPatientTagsUsStatesDefault =
  [];
export const suggestPatientEndpointResponsePatientPolicyResultDebugPatientTagsPracticeAreasDefault =
  [];
export const suggestPatientEndpointResponsePatientPolicyResultDebugPatientTagsOriginPracticesDefault =
  [];

export const suggestPatientEndpointResponse = zod.object({
  patient: zod.union([
    zod.object({
      user_id: zod.uuid(),
      full_name: zod.string(),
      display_name: zod.string(),
      oldest_request_at: zod.union([zod.iso.datetime({}), zod.null()]),
      urgent_count: zod.number(),
      routine_count: zod.number(),
      unread_count: zod.number(),
      viewer_count: zod.number(),
      total_karma_offer: zod.number(),
      policy_result: zod.object({
        debug: zod.union([
          zod.object({
            you: zod
              .object({
                tags: zod
                  .object({
                    us_states: zod
                      .array(zod.string())
                      .default(
                        suggestPatientEndpointResponsePatientPolicyResultDebugYouTagsUsStatesDefault,
                      ),
                    practice_areas: zod
                      .array(zod.enum(["Primary Care", "Psychiatry"]))
                      .default(
                        suggestPatientEndpointResponsePatientPolicyResultDebugYouTagsPracticeAreasDefault,
                      ),
                    origin_practices: zod
                      .array(zod.string())
                      .default(
                        suggestPatientEndpointResponsePatientPolicyResultDebugYouTagsOriginPracticesDefault,
                      ),
                  })
                  .describe(
                    "Fully typed tag set — each routing dimension is an explicit field.",
                  ),
              })
              .describe(
                "Criteria representing what a clinician is licensed to do.\n\nUses a RoutingTagSetT so that matching generalizes across\nall routing dimensions (state, practice area, origin practice, etc.).",
              ),
            patient: zod
              .object({
                tags: zod
                  .object({
                    us_states: zod
                      .array(zod.string())
                      .default(
                        suggestPatientEndpointResponsePatientPolicyResultDebugPatientTagsUsStatesDefault,
                      ),
                    practice_areas: zod
                      .array(zod.enum(["Primary Care", "Psychiatry"]))
                      .default(
                        suggestPatientEndpointResponsePatientPolicyResultDebugPatientTagsPracticeAreasDefault,
                      ),
                    origin_practices: zod
                      .array(zod.string())
                      .default(
                        suggestPatientEndpointResponsePatientPolicyResultDebugPatientTagsOriginPracticesDefault,
                      ),
                  })
                  .describe(
                    "Fully typed tag set — each routing dimension is an explicit field.",
                  ),
              })
              .describe(
                "What a patient (or a specific request) needs from a clinician.",
              ),
          }),
          zod.string(),
        ]),
        relationship: zod.enum(["actionable", "licensed", "unlicensed"]),
        notes: zod.array(
          zod.object({
            title: zod.string(),
            detail: zod.string(),
          }),
        ),
      }),
      origin_practice: zod.union([zod.string(), zod.null()]).optional(),
      is_new_user: zod.union([zod.boolean(), zod.null()]).optional(),
    }),
    zod.null(),
  ]),
});

/**
 * Fetch the current care state snapshot for a patient.

Returns the full care state including all tables (patients, problems,
requests, internal notes, follow-ups) along with a cursor for fetching
subsequent events.

Also records the clinician as a viewer of this patient.
 * @summary Fetch State
 */
export const fetchStateParams = zod.object({
  user_id: zod.uuid(),
});

export const fetchStateResponseStatePatientProfilingItemFocusAreasDefault = [];
export const fetchStateResponseStateRequestsItemLinkTypeDefault = "patient";
export const fetchStateResponseStateRequestsItemLinkTypeDefaultOne = "problem";
export const fetchStateResponseStateRequestsItemLinkTypeDefaultTwo = "request";
export const fetchStateResponseStateRequestsItemLinkTypeDefaultThree = "orphan";
export const fetchStateResponseStateRequestsItemChatLinkTypeDefault =
  "chat_message";
export const fetchStateResponseStateRequestsItemChatLinkTypeDefaultOne =
  "chat_conversation";
export const fetchStateResponseStateInternalNotesItemLinkTypeDefault =
  "patient";
export const fetchStateResponseStateInternalNotesItemLinkTypeDefaultOne =
  "problem";
export const fetchStateResponseStateInternalNotesItemLinkTypeDefaultTwo =
  "request";
export const fetchStateResponseStateInternalNotesItemLinkTypeDefaultThree =
  "orphan";
export const fetchStateResponseStateFollowUpsItemLinkTypeDefault = "patient";
export const fetchStateResponseStateFollowUpsItemLinkTypeDefaultOne = "problem";
export const fetchStateResponseStateFollowUpsItemLinkTypeDefaultTwo = "request";
export const fetchStateResponseStateFollowUpsItemLinkTypeDefaultThree =
  "orphan";
export const fetchStateResponseStateFollowUpsItemUnreadDefault = false;
export const fetchStateResponseStateFollowUpsItemTransmissionLinkTypeDefault =
  "chat_message";
export const fetchStateResponseStateFollowUpsItemTransmissionLinkTypeDefaultOne =
  "chat_conversation";
export const fetchStateResponseStateFollowUpsItemAcknowledgementLinkTypeDefault =
  "chat_message";
export const fetchStateResponseStateFollowUpsItemAcknowledgementLinkTypeDefaultOne =
  "chat_conversation";
export const fetchStateResponseStateFollowUpsItemResponseInstrumentFormDefinitionFieldsItemSuggestedSubmissionTypeDefault =
  "string";
export const fetchStateResponseStateFollowUpsItemResponseInstrumentFormDefinitionFieldsItemSuggestedSubmissionTypeDefaultOne =
  "int";
export const fetchStateResponseStateFollowUpsItemResponseInstrumentFormDefinitionFieldsItemSuggestedSubmissionTypeDefaultTwo =
  "simple_address";
export const fetchStateResponseStateFollowUpsItemResponseInstrumentFormDefinitionFieldsItemSuggestedSubmissionTypeDefaultThree =
  "list";
export const fetchStateResponseStateFollowUpsItemResponseInstrumentFormDefinitionFieldsItemSuggestedSubmissionValuesItemTypeDefault =
  "string";
export const fetchStateResponseStateFollowUpsItemResponseInstrumentFormDefinitionFieldsItemSuggestedSubmissionValuesItemTypeDefaultOne =
  "int";
export const fetchStateResponseStateFollowUpsItemResponseInstrumentFormDefinitionFieldsItemSuggestedSubmissionValuesItemTypeDefaultTwo =
  "simple_address";
export const fetchStateResponseStateFollowUpsItemResponseInstrumentFormDefinitionFieldsItemDefaultSubmissionTypeDefault =
  "string";
export const fetchStateResponseStateFollowUpsItemResponseInstrumentFormDefinitionFieldsItemDefaultSubmissionTypeDefaultOne =
  "int";
export const fetchStateResponseStateFollowUpsItemResponseInstrumentFormDefinitionFieldsItemDefaultSubmissionTypeDefaultTwo =
  "simple_address";
export const fetchStateResponseStateFollowUpsItemResponseInstrumentFormDefinitionFieldsItemDefaultSubmissionTypeDefaultThree =
  "list";
export const fetchStateResponseStateFollowUpsItemResponseInstrumentFormDefinitionFieldsItemDefaultSubmissionValuesItemTypeDefault =
  "string";
export const fetchStateResponseStateFollowUpsItemResponseInstrumentFormDefinitionFieldsItemDefaultSubmissionValuesItemTypeDefaultOne =
  "int";
export const fetchStateResponseStateFollowUpsItemResponseInstrumentFormDefinitionFieldsItemDefaultSubmissionValuesItemTypeDefaultTwo =
  "simple_address";
export const fetchStateResponseStateFollowUpsItemResponseInstrumentFormDefinitionFieldsItemValidatorTypeDefault =
  "non_empty_string";
export const fetchStateResponseStateFollowUpsItemResponseInstrumentFormDefinitionFieldsItemValidatorTypeDefaultOne =
  "date";
export const fetchStateResponseStateFollowUpsItemResponseInstrumentFormDefinitionFieldsItemValidatorTypeDefaultTwo =
  "coded_choice";
export const fetchStateResponseStateFollowUpsItemResponseInstrumentFormDefinitionFieldsItemValidatorTypeDefaultThree =
  "phone_number";
export const fetchStateResponseStateFollowUpsItemResponseInstrumentFormDefinitionFieldsItemValidatorTypeDefaultFour =
  "email";
export const fetchStateResponseStateFollowUpsItemResponseInstrumentFormDefinitionFieldsItemValidatorTypeDefaultFive =
  "city_state_zip";
export const fetchStateResponseStateFollowUpsItemResponseInstrumentFormDefinitionFieldsItemValidatorTypeDefaultSix =
  "optional";
export const fetchStateResponseStateFollowUpsItemResponseInstrumentFormDefinitionFieldsItemValidatorRawValidatorTypeDefault =
  "non_empty_string";
export const fetchStateResponseStateFollowUpsItemResponseInstrumentFormDefinitionFieldsItemValidatorRawValidatorTypeDefaultOne =
  "date";
export const fetchStateResponseStateFollowUpsItemResponseInstrumentFormDefinitionFieldsItemValidatorRawValidatorTypeDefaultTwo =
  "coded_choice";
export const fetchStateResponseStateFollowUpsItemResponseInstrumentFormDefinitionFieldsItemValidatorRawValidatorTypeDefaultThree =
  "phone_number";
export const fetchStateResponseStateFollowUpsItemResponseInstrumentFormDefinitionFieldsItemValidatorRawValidatorTypeDefaultFour =
  "email";
export const fetchStateResponseStateFollowUpsItemResponseInstrumentFormDefinitionFieldsItemValidatorRawValidatorTypeDefaultFive =
  "city_state_zip";
export const fetchStateResponseStateFollowUpsItemResponseInstrumentFormDefinitionFieldsItemValidatorRawValidatorTypeDefaultSix =
  "list";
export const fetchStateResponseStateFollowUpsItemResponseInstrumentFormDefinitionFieldsItemValidatorRawValidatorRawValidatorTypeDefault =
  "non_empty_string";
export const fetchStateResponseStateFollowUpsItemResponseInstrumentFormDefinitionFieldsItemValidatorRawValidatorRawValidatorTypeDefaultOne =
  "date";
export const fetchStateResponseStateFollowUpsItemResponseInstrumentFormDefinitionFieldsItemValidatorRawValidatorRawValidatorTypeDefaultTwo =
  "coded_choice";
export const fetchStateResponseStateFollowUpsItemResponseInstrumentFormDefinitionFieldsItemValidatorRawValidatorRawValidatorTypeDefaultThree =
  "phone_number";
export const fetchStateResponseStateFollowUpsItemResponseInstrumentFormDefinitionFieldsItemValidatorRawValidatorRawValidatorTypeDefaultFour =
  "email";
export const fetchStateResponseStateFollowUpsItemResponseInstrumentFormDefinitionFieldsItemValidatorRawValidatorRawValidatorTypeDefaultFive =
  "city_state_zip";
export const fetchStateResponseStateFollowUpsItemResponseInstrumentFormDefinitionFieldsItemValidatorTypeDefaultSeven =
  "list";
export const fetchStateResponseStateFollowUpsItemResponseInstrumentFormDefinitionFieldsItemValidatorRawValidatorTypeDefaultSeven =
  "non_empty_string";
export const fetchStateResponseStateFollowUpsItemResponseInstrumentFormDefinitionFieldsItemValidatorRawValidatorTypeDefaultEight =
  "date";
export const fetchStateResponseStateFollowUpsItemResponseInstrumentFormDefinitionFieldsItemValidatorRawValidatorTypeDefaultNine =
  "coded_choice";
export const fetchStateResponseStateFollowUpsItemResponseInstrumentFormDefinitionFieldsItemValidatorRawValidatorTypeDefaultOnezero =
  "phone_number";
export const fetchStateResponseStateFollowUpsItemResponseInstrumentFormDefinitionFieldsItemValidatorRawValidatorTypeDefaultOneone =
  "email";
export const fetchStateResponseStateFollowUpsItemResponseInstrumentFormDefinitionFieldsItemValidatorRawValidatorTypeDefaultOnetwo =
  "city_state_zip";
export const fetchStateResponseStateFollowUpsItemResponseInstrumentFormDefinitionFieldsItemValidatorRawValidatorTypeDefaultOnethree =
  "optional";
export const fetchStateResponseStateFollowUpsItemResponseInstrumentFormDefinitionFieldsItemValidatorRawValidatorRawValidatorTypeDefaultSix =
  "non_empty_string";
export const fetchStateResponseStateFollowUpsItemResponseInstrumentFormDefinitionFieldsItemValidatorRawValidatorRawValidatorTypeDefaultSeven =
  "date";
export const fetchStateResponseStateFollowUpsItemResponseInstrumentFormDefinitionFieldsItemValidatorRawValidatorRawValidatorTypeDefaultEight =
  "coded_choice";
export const fetchStateResponseStateFollowUpsItemResponseInstrumentFormDefinitionFieldsItemValidatorRawValidatorRawValidatorTypeDefaultNine =
  "phone_number";
export const fetchStateResponseStateFollowUpsItemResponseInstrumentFormDefinitionFieldsItemValidatorRawValidatorRawValidatorTypeDefaultOnezero =
  "email";
export const fetchStateResponseStateFollowUpsItemResponseInstrumentFormDefinitionFieldsItemValidatorRawValidatorRawValidatorTypeDefaultOneone =
  "city_state_zip";
export const fetchStateResponseStateFollowUpsItemResponseInstrumentSubmissionsSubmissionsTypeDefault =
  "string";
export const fetchStateResponseStateFollowUpsItemResponseInstrumentSubmissionsSubmissionsTypeDefaultOne =
  "int";
export const fetchStateResponseStateFollowUpsItemResponseInstrumentSubmissionsSubmissionsTypeDefaultTwo =
  "simple_address";
export const fetchStateResponseStateFollowUpsItemResponseInstrumentSubmissionsSubmissionsTypeDefaultThree =
  "list";
export const fetchStateResponseStateFollowUpsItemResponseInstrumentSubmissionsSubmissionsValuesItemTypeDefault =
  "string";
export const fetchStateResponseStateFollowUpsItemResponseInstrumentSubmissionsSubmissionsValuesItemTypeDefaultOne =
  "int";
export const fetchStateResponseStateFollowUpsItemResponseInstrumentSubmissionsSubmissionsValuesItemTypeDefaultTwo =
  "simple_address";
export const fetchStateResponseStateLabOrdersItemLinkTypeDefault = "patient";
export const fetchStateResponseStateLabOrdersItemLinkTypeDefaultOne = "problem";
export const fetchStateResponseStateLabOrdersItemLinkTypeDefaultTwo = "request";
export const fetchStateResponseStateLabOrdersItemLinkTypeDefaultThree =
  "orphan";
export const fetchStateResponseStateLabOrdersItemOrderDataTypeDefault = "vital";
export const fetchStateResponseStateLabOrdersItemOrderDataValueLabTestMarkersItemMetadataProviderDefault =
  "vital";
export const fetchStateResponseStateLabOrdersItemOrderDataValueLabTestMarkersItemMetadataALaCarteEnabledDefault = false;
export const fetchStateResponseStateLabOrdersItemOrderDataValueLabTestMetadataProviderDefault =
  "vital";
export const fetchStateResponseStateLabOrdersItemOrderDataValueMetadataProviderDefault =
  "vital";
export const fetchStateResponseStateLabOrdersItemOrderDataValueMetadataDetailsTypeDefault =
  "testkit";
export const fetchStateResponseStateLabOrdersItemOrderDataValueMetadataDetailsTypeDefaultOne =
  "walk_in_test";
export const fetchStateResponseStateLabOrdersItemOrderDataValueMetadataDetailsTypeDefaultTwo =
  "at_home_phlebotomy";
export const fetchStateResponseStateLabOrdersItemOrderDataValueMetadataDetailsTypeDefaultThree =
  "on_site_collection";
export const fetchStateResponseStateLabOrdersItemOrderDataValueMetadataPriorityDefault = false;
export const fetchStateResponseStateLabOrdersItemOrderDataValueMetadataEventsDefault =
  [];
export const fetchStateResponseStateDiagnosesItemLinkTypeDefault = "patient";
export const fetchStateResponseStateDiagnosesItemLinkTypeDefaultOne = "problem";
export const fetchStateResponseStateDiagnosesItemLinkTypeDefaultTwo = "request";
export const fetchStateResponseStateDiagnosesItemLinkTypeDefaultThree =
  "orphan";
export const fetchStateResponseStatePrescriptionsItemLinkTypeDefault =
  "patient";
export const fetchStateResponseStatePrescriptionsItemLinkTypeDefaultOne =
  "problem";
export const fetchStateResponseStatePrescriptionsItemLinkTypeDefaultTwo =
  "request";
export const fetchStateResponseStatePrescriptionsItemLinkTypeDefaultThree =
  "orphan";
export const fetchStateResponseStatePriorAuthRequestsItemLinkTypeDefault =
  "patient";
export const fetchStateResponseStatePriorAuthRequestsItemLinkTypeDefaultOne =
  "problem";
export const fetchStateResponseStatePriorAuthRequestsItemLinkTypeDefaultTwo =
  "request";
export const fetchStateResponseStatePriorAuthRequestsItemLinkTypeDefaultThree =
  "orphan";
export const fetchStateResponseStatePriorAuthRequestsItemIsOfflineDefault = false;
export const fetchStateResponseStatePreRequestsItemChatLinkTypeDefault =
  "chat_message";
export const fetchStateResponseStatePreRequestsItemChatLinkTypeDefaultOne =
  "chat_conversation";
export const fetchStateResponseStatePreRequestsItemProposedActionCreatedByTypeDefault =
  "clinician";
export const fetchStateResponseStatePreRequestsItemProposedActionCreatedByTypeDefaultOne =
  "system";
export const fetchStateResponseStateProposedActionsItemLinkTypeDefault =
  "patient";
export const fetchStateResponseStateProposedActionsItemLinkTypeDefaultOne =
  "problem";
export const fetchStateResponseStateProposedActionsItemLinkTypeDefaultTwo =
  "request";
export const fetchStateResponseStateProposedActionsItemLinkTypeDefaultThree =
  "orphan";
export const fetchStateResponseStateProposedActionsItemCreatedByTypeDefault =
  "clinician";
export const fetchStateResponseStateProposedActionsItemCreatedByTypeDefaultOne =
  "system";
export const fetchStateResponseStateAmendmentLogItemValueResourceTypeDefault =
  "medication";
export const fetchStateResponseStateAmendmentLogItemValueResourceTypeDefaultOne =
  "condition";
export const fetchStateResponseStateAmendmentLogItemValueResourceTypeDefaultTwo =
  "allergy";

export const fetchStateResponse = zod.object({
  state: zod.object({
    patients: zod.array(
      zod.object({
        id: zod.literal("root"),
        note: zod.object({
          value: zod.string(),
          expiry: zod.object({
            basis: zod.union([zod.string(), zod.null()]),
            time: zod.union([zod.iso.datetime({}), zod.null()]),
          }),
        }),
        severity_note: zod
          .union([
            zod.object({
              value: zod
                .enum([
                  "tier_1_mild",
                  "tier_2_moderate",
                  "tier_3_severe",
                  "tier_4_critical",
                ])
                .describe(
                  "Patient risk \/ acuity tier — orthogonal to MDM (CPT) complexity.\n\nStored on the patient row as a ``CareStateNoteT[PatientSeverityTierT]``\n(``CareStatePatientT.severity_note``) and regenerated by the librarian from\nthe patient's global note. Consumed by clinician-activity karma scoring.",
                ),
              expiry: zod.object({
                basis: zod.union([zod.string(), zod.null()]),
                time: zod.union([zod.iso.datetime({}), zod.null()]),
              }),
            }),
            zod.null(),
          ])
          .optional(),
      }),
    ),
    patient_profiling: zod.array(
      zod
        .object({
          id: zod.literal("root"),
          focus_areas: zod
            .array(
              zod.union([
                zod
                  .enum([
                    "weight",
                    "stress",
                    "mood",
                    "sleep_and_fatigue",
                    "energy",
                    "nutrition",
                    "movement",
                    "hormonal",
                    "cycle",
                    "fertility",
                    "pregnancy_and_postpartum",
                    "menopause",
                    "hair_and_skin",
                    "heart_health",
                    "overall_health",
                  ])
                  .describe(
                    "A patient-selected health focus area.\n\nSurfaced in iOS as the chips a patient picks before\/alongside the Care\nPlan. Patient-authored: the librarian and care-plan agent only read it.\n\nWomen's Health:\nWhere the name overlaps ``HealthAreaT`` (``care.menus.explore_health``) the wire\nvalue deliberately matches, so the two surfaces agree on one spelling.\n\nRemoving or renaming a value is a breaking change: the enum is open on\nreads (old iOS clients round-trip unknown strings) and strict on writes.",
                  ),
                zod.string(),
              ]),
            )
            .default(
              fetchStateResponseStatePatientProfilingItemFocusAreasDefault,
            ),
        })
        .describe(
          "Patient-authored profile data that lives independently of the patient row.\n\nSplit out from ``CareStatePatientT`` so that patient-driven preferences\n(currently just ``focus_areas``, the empty-state chips on the Care Plan\nscreen) can be created\/destroyed without coupling to the librarian-owned\npatient row's lifecycle. As a singleton table the row id is always\n``\"root\"``; the row simply may or may not exist yet.\n\nAudit\/identity: writes here originate from\n``SYSTEM_SOURCE_PATIENT_EDIT`` (the patient's own device), so this row\nhas no contention with librarian or clinician writes.",
        ),
    ),
    problems: zod.array(
      zod.object({
        id: zod.uuid(),
        title: zod.string(),
        note: zod.object({
          value: zod.string(),
          expiry: zod.object({
            basis: zod.union([zod.string(), zod.null()]),
            time: zod.union([zod.iso.datetime({}), zod.null()]),
          }),
        }),
      }),
    ),
    requests: zod.array(
      zod.object({
        id: zod.uuid(),
        link: zod.union([
          zod.object({
            type: zod
              .literal("patient")
              .default(fetchStateResponseStateRequestsItemLinkTypeDefault),
          }),
          zod.object({
            type: zod
              .literal("problem")
              .default(fetchStateResponseStateRequestsItemLinkTypeDefaultOne),
            id: zod.uuid(),
          }),
          zod.object({
            type: zod
              .literal("request")
              .default(fetchStateResponseStateRequestsItemLinkTypeDefaultTwo),
            id: zod.uuid(),
          }),
          zod.object({
            type: zod
              .literal("orphan")
              .default(fetchStateResponseStateRequestsItemLinkTypeDefaultThree),
          }),
        ]),
        chat_link: zod
          .union([
            zod.union([
              zod.object({
                type: zod
                  .literal("chat_message")
                  .default(
                    fetchStateResponseStateRequestsItemChatLinkTypeDefault,
                  ),
                conversation_id: zod.uuid(),
                message_id: zod.uuid(),
              }),
              zod.object({
                type: zod
                  .literal("chat_conversation")
                  .default(
                    fetchStateResponseStateRequestsItemChatLinkTypeDefaultOne,
                  ),
                conversation_id: zod.uuid(),
              }),
            ]),
            zod.null(),
          ])
          .optional(),
        title: zod.string(),
        note: zod.object({
          value: zod.string(),
          expiry: zod.object({
            basis: zod.union([zod.string(), zod.null()]),
            time: zod.union([zod.iso.datetime({}), zod.null()]),
          }),
        }),
        status: zod.enum([
          "Open",
          "Pending Follow Up",
          "Resolved",
          "Cancelled",
        ]),
        urgency: zod.enum(["Routine", "Urgent"]),
        assignee: zod.enum(["Patient", "Clinician"]),
        kind: zod
          .enum(["General", "Refill", "Rx Change", "Prior Auth"])
          .optional()
          .describe(
            "Machine-readable discriminator for inbox request type.\n\nKind-specific data lives on paired rows (CareStatePriorAuthRequestT,\nCareStateProposedActionT payload, SQL dosespot_\*_records). ``kind`` is\na facet for routing\/filtering, never a row-shape discriminator.\n\nDefaulted to GENERAL so historical rows decode cleanly without migration.",
          ),
        practice_area: zod.enum(["Primary Care", "Psychiatry"]).optional(),
        origin_practice: zod.union([zod.string(), zod.null()]).optional(),
        cpt_code: zod
          .union([
            zod
              .enum(["99212", "99213", "99214", "99215"])
              .describe(
                "E\/M office visit CPT codes used to classify request complexity by MDM level.",
              ),
            zod.null(),
          ])
          .optional(),
        karma_offer_min: zod.union([zod.number(), zod.null()]).optional(),
        karma_offer_max: zod.union([zod.number(), zod.null()]).optional(),
      }),
    ),
    internal_notes: zod.array(
      zod.object({
        id: zod.uuid(),
        link: zod.union([
          zod.object({
            type: zod
              .literal("patient")
              .default(fetchStateResponseStateInternalNotesItemLinkTypeDefault),
          }),
          zod.object({
            type: zod
              .literal("problem")
              .default(
                fetchStateResponseStateInternalNotesItemLinkTypeDefaultOne,
              ),
            id: zod.uuid(),
          }),
          zod.object({
            type: zod
              .literal("request")
              .default(
                fetchStateResponseStateInternalNotesItemLinkTypeDefaultTwo,
              ),
            id: zod.uuid(),
          }),
          zod.object({
            type: zod
              .literal("orphan")
              .default(
                fetchStateResponseStateInternalNotesItemLinkTypeDefaultThree,
              ),
          }),
        ]),
        note: zod.object({
          value: zod.string(),
          expiry: zod.object({
            basis: zod.union([zod.string(), zod.null()]),
            time: zod.union([zod.iso.datetime({}), zod.null()]),
          }),
        }),
        created_by: zod.uuid(),
      }),
    ),
    follow_ups: zod.array(
      zod.object({
        id: zod.uuid(),
        originating_action_id: zod.union([zod.uuid(), zod.null()]).optional(),
        link: zod.union([
          zod.object({
            type: zod
              .literal("patient")
              .default(fetchStateResponseStateFollowUpsItemLinkTypeDefault),
          }),
          zod.object({
            type: zod
              .literal("problem")
              .default(fetchStateResponseStateFollowUpsItemLinkTypeDefaultOne),
            id: zod.uuid(),
          }),
          zod.object({
            type: zod
              .literal("request")
              .default(fetchStateResponseStateFollowUpsItemLinkTypeDefaultTwo),
            id: zod.uuid(),
          }),
          zod.object({
            type: zod
              .literal("orphan")
              .default(
                fetchStateResponseStateFollowUpsItemLinkTypeDefaultThree,
              ),
          }),
        ]),
        title: zod.string(),
        status: zod
          .enum([
            "Pending",
            "Awaiting Response from Patient",
            "Response Received from Patient",
          ])
          .optional(),
        unread: zod.boolean().optional(),
        transmission_link: zod
          .union([
            zod.union([
              zod.object({
                type: zod
                  .literal("chat_message")
                  .default(
                    fetchStateResponseStateFollowUpsItemTransmissionLinkTypeDefault,
                  ),
                conversation_id: zod.uuid(),
                message_id: zod.uuid(),
              }),
              zod.object({
                type: zod
                  .literal("chat_conversation")
                  .default(
                    fetchStateResponseStateFollowUpsItemTransmissionLinkTypeDefaultOne,
                  ),
                conversation_id: zod.uuid(),
              }),
            ]),
            zod.null(),
          ])
          .optional(),
        acknowledgement_link: zod
          .union([
            zod.union([
              zod.object({
                type: zod
                  .literal("chat_message")
                  .default(
                    fetchStateResponseStateFollowUpsItemAcknowledgementLinkTypeDefault,
                  ),
                conversation_id: zod.uuid(),
                message_id: zod.uuid(),
              }),
              zod.object({
                type: zod
                  .literal("chat_conversation")
                  .default(
                    fetchStateResponseStateFollowUpsItemAcknowledgementLinkTypeDefaultOne,
                  ),
                conversation_id: zod.uuid(),
              }),
            ]),
            zod.null(),
          ])
          .optional(),
        content_to_transmit: zod.string(),
        response_instrument: zod
          .union([
            zod
              .object({
                instrument_id: zod.string(),
                form_definition: zod.object({
                  fields: zod.array(
                    zod.object({
                      id: zod.string(),
                      profile: zod.object({
                        name: zod.string(),
                        description: zod
                          .union([zod.string(), zod.null()])
                          .optional(),
                      }),
                      suggested_submission: zod
                        .union([
                          zod.union([
                            zod.object({
                              type: zod
                                .literal("string")
                                .default(
                                  fetchStateResponseStateFollowUpsItemResponseInstrumentFormDefinitionFieldsItemSuggestedSubmissionTypeDefault,
                                ),
                              value: zod.string(),
                            }),
                            zod.object({
                              type: zod
                                .literal("int")
                                .default(
                                  fetchStateResponseStateFollowUpsItemResponseInstrumentFormDefinitionFieldsItemSuggestedSubmissionTypeDefaultOne,
                                ),
                              value: zod.number(),
                            }),
                            zod.object({
                              type: zod
                                .literal("simple_address")
                                .default(
                                  fetchStateResponseStateFollowUpsItemResponseInstrumentFormDefinitionFieldsItemSuggestedSubmissionTypeDefaultTwo,
                                ),
                              street_address: zod.string(),
                              city_state_zip: zod.string(),
                            }),
                            zod.object({
                              type: zod
                                .literal("list")
                                .default(
                                  fetchStateResponseStateFollowUpsItemResponseInstrumentFormDefinitionFieldsItemSuggestedSubmissionTypeDefaultThree,
                                ),
                              values: zod.array(
                                zod.union([
                                  zod.object({
                                    type: zod
                                      .literal("string")
                                      .default(
                                        fetchStateResponseStateFollowUpsItemResponseInstrumentFormDefinitionFieldsItemSuggestedSubmissionValuesItemTypeDefault,
                                      ),
                                    value: zod.string(),
                                  }),
                                  zod.object({
                                    type: zod
                                      .literal("int")
                                      .default(
                                        fetchStateResponseStateFollowUpsItemResponseInstrumentFormDefinitionFieldsItemSuggestedSubmissionValuesItemTypeDefaultOne,
                                      ),
                                    value: zod.number(),
                                  }),
                                  zod.object({
                                    type: zod
                                      .literal("simple_address")
                                      .default(
                                        fetchStateResponseStateFollowUpsItemResponseInstrumentFormDefinitionFieldsItemSuggestedSubmissionValuesItemTypeDefaultTwo,
                                      ),
                                    street_address: zod.string(),
                                    city_state_zip: zod.string(),
                                  }),
                                  zod.unknown(),
                                ]),
                              ),
                            }),
                          ]),
                          zod.null(),
                        ])
                        .optional(),
                      default_submission: zod
                        .union([
                          zod.union([
                            zod.object({
                              type: zod
                                .literal("string")
                                .default(
                                  fetchStateResponseStateFollowUpsItemResponseInstrumentFormDefinitionFieldsItemDefaultSubmissionTypeDefault,
                                ),
                              value: zod.string(),
                            }),
                            zod.object({
                              type: zod
                                .literal("int")
                                .default(
                                  fetchStateResponseStateFollowUpsItemResponseInstrumentFormDefinitionFieldsItemDefaultSubmissionTypeDefaultOne,
                                ),
                              value: zod.number(),
                            }),
                            zod.object({
                              type: zod
                                .literal("simple_address")
                                .default(
                                  fetchStateResponseStateFollowUpsItemResponseInstrumentFormDefinitionFieldsItemDefaultSubmissionTypeDefaultTwo,
                                ),
                              street_address: zod.string(),
                              city_state_zip: zod.string(),
                            }),
                            zod.object({
                              type: zod
                                .literal("list")
                                .default(
                                  fetchStateResponseStateFollowUpsItemResponseInstrumentFormDefinitionFieldsItemDefaultSubmissionTypeDefaultThree,
                                ),
                              values: zod.array(
                                zod.union([
                                  zod.object({
                                    type: zod
                                      .literal("string")
                                      .default(
                                        fetchStateResponseStateFollowUpsItemResponseInstrumentFormDefinitionFieldsItemDefaultSubmissionValuesItemTypeDefault,
                                      ),
                                    value: zod.string(),
                                  }),
                                  zod.object({
                                    type: zod
                                      .literal("int")
                                      .default(
                                        fetchStateResponseStateFollowUpsItemResponseInstrumentFormDefinitionFieldsItemDefaultSubmissionValuesItemTypeDefaultOne,
                                      ),
                                    value: zod.number(),
                                  }),
                                  zod.object({
                                    type: zod
                                      .literal("simple_address")
                                      .default(
                                        fetchStateResponseStateFollowUpsItemResponseInstrumentFormDefinitionFieldsItemDefaultSubmissionValuesItemTypeDefaultTwo,
                                      ),
                                    street_address: zod.string(),
                                    city_state_zip: zod.string(),
                                  }),
                                  zod.unknown(),
                                ]),
                              ),
                            }),
                          ]),
                          zod.null(),
                        ])
                        .optional(),
                      validator: zod.union([
                        zod
                          .object({
                            type: zod
                              .literal("non_empty_string")
                              .default(
                                fetchStateResponseStateFollowUpsItemResponseInstrumentFormDefinitionFieldsItemValidatorTypeDefault,
                              ),
                          })
                          .describe(
                            "Validator that accepts arbitrary non-empty strings.",
                          ),
                        zod
                          .object({
                            type: zod
                              .literal("date")
                              .default(
                                fetchStateResponseStateFollowUpsItemResponseInstrumentFormDefinitionFieldsItemValidatorTypeDefaultOne,
                              ),
                          })
                          .describe("Validator that accepts arbitrary dates."),
                        zod
                          .object({
                            type: zod
                              .literal("coded_choice")
                              .default(
                                fetchStateResponseStateFollowUpsItemResponseInstrumentFormDefinitionFieldsItemValidatorTypeDefaultTwo,
                              ),
                            options: zod.array(
                              zod
                                .object({
                                  code: zod.string(),
                                  display: zod.string(),
                                })
                                .describe("An option from a list of choices."),
                            ),
                          })
                          .describe(
                            "Validator that accepts any option from a list of choices.",
                          ),
                        zod
                          .object({
                            type: zod
                              .literal("phone_number")
                              .default(
                                fetchStateResponseStateFollowUpsItemResponseInstrumentFormDefinitionFieldsItemValidatorTypeDefaultThree,
                              ),
                          })
                          .describe(
                            "Validator that accepts arbitrary phone numbers.",
                          ),
                        zod
                          .object({
                            type: zod
                              .literal("email")
                              .default(
                                fetchStateResponseStateFollowUpsItemResponseInstrumentFormDefinitionFieldsItemValidatorTypeDefaultFour,
                              ),
                          })
                          .describe("Validator that accepts arbitrary emails."),
                        zod
                          .object({
                            type: zod
                              .literal("city_state_zip")
                              .default(
                                fetchStateResponseStateFollowUpsItemResponseInstrumentFormDefinitionFieldsItemValidatorTypeDefaultFive,
                              ),
                          })
                          .describe(
                            "Validator that accepts city, state, and ZIP code combinations.",
                          ),
                        zod
                          .object({
                            type: zod
                              .literal("optional")
                              .default(
                                fetchStateResponseStateFollowUpsItemResponseInstrumentFormDefinitionFieldsItemValidatorTypeDefaultSix,
                              ),
                            raw_validator: zod.union([
                              zod
                                .object({
                                  type: zod
                                    .literal("non_empty_string")
                                    .default(
                                      fetchStateResponseStateFollowUpsItemResponseInstrumentFormDefinitionFieldsItemValidatorRawValidatorTypeDefault,
                                    ),
                                })
                                .describe(
                                  "Validator that accepts arbitrary non-empty strings.",
                                ),
                              zod
                                .object({
                                  type: zod
                                    .literal("date")
                                    .default(
                                      fetchStateResponseStateFollowUpsItemResponseInstrumentFormDefinitionFieldsItemValidatorRawValidatorTypeDefaultOne,
                                    ),
                                })
                                .describe(
                                  "Validator that accepts arbitrary dates.",
                                ),
                              zod
                                .object({
                                  type: zod
                                    .literal("coded_choice")
                                    .default(
                                      fetchStateResponseStateFollowUpsItemResponseInstrumentFormDefinitionFieldsItemValidatorRawValidatorTypeDefaultTwo,
                                    ),
                                  options: zod.array(
                                    zod
                                      .object({
                                        code: zod.string(),
                                        display: zod.string(),
                                      })
                                      .describe(
                                        "An option from a list of choices.",
                                      ),
                                  ),
                                })
                                .describe(
                                  "Validator that accepts any option from a list of choices.",
                                ),
                              zod
                                .object({
                                  type: zod
                                    .literal("phone_number")
                                    .default(
                                      fetchStateResponseStateFollowUpsItemResponseInstrumentFormDefinitionFieldsItemValidatorRawValidatorTypeDefaultThree,
                                    ),
                                })
                                .describe(
                                  "Validator that accepts arbitrary phone numbers.",
                                ),
                              zod
                                .object({
                                  type: zod
                                    .literal("email")
                                    .default(
                                      fetchStateResponseStateFollowUpsItemResponseInstrumentFormDefinitionFieldsItemValidatorRawValidatorTypeDefaultFour,
                                    ),
                                })
                                .describe(
                                  "Validator that accepts arbitrary emails.",
                                ),
                              zod
                                .object({
                                  type: zod
                                    .literal("city_state_zip")
                                    .default(
                                      fetchStateResponseStateFollowUpsItemResponseInstrumentFormDefinitionFieldsItemValidatorRawValidatorTypeDefaultFive,
                                    ),
                                })
                                .describe(
                                  "Validator that accepts city, state, and ZIP code combinations.",
                                ),
                              zod.unknown(),
                              zod
                                .object({
                                  type: zod
                                    .literal("list")
                                    .default(
                                      fetchStateResponseStateFollowUpsItemResponseInstrumentFormDefinitionFieldsItemValidatorRawValidatorTypeDefaultSix,
                                    ),
                                  raw_validator: zod.union([
                                    zod
                                      .object({
                                        type: zod
                                          .literal("non_empty_string")
                                          .default(
                                            fetchStateResponseStateFollowUpsItemResponseInstrumentFormDefinitionFieldsItemValidatorRawValidatorRawValidatorTypeDefault,
                                          ),
                                      })
                                      .describe(
                                        "Validator that accepts arbitrary non-empty strings.",
                                      ),
                                    zod
                                      .object({
                                        type: zod
                                          .literal("date")
                                          .default(
                                            fetchStateResponseStateFollowUpsItemResponseInstrumentFormDefinitionFieldsItemValidatorRawValidatorRawValidatorTypeDefaultOne,
                                          ),
                                      })
                                      .describe(
                                        "Validator that accepts arbitrary dates.",
                                      ),
                                    zod
                                      .object({
                                        type: zod
                                          .literal("coded_choice")
                                          .default(
                                            fetchStateResponseStateFollowUpsItemResponseInstrumentFormDefinitionFieldsItemValidatorRawValidatorRawValidatorTypeDefaultTwo,
                                          ),
                                        options: zod.array(
                                          zod
                                            .object({
                                              code: zod.string(),
                                              display: zod.string(),
                                            })
                                            .describe(
                                              "An option from a list of choices.",
                                            ),
                                        ),
                                      })
                                      .describe(
                                        "Validator that accepts any option from a list of choices.",
                                      ),
                                    zod
                                      .object({
                                        type: zod
                                          .literal("phone_number")
                                          .default(
                                            fetchStateResponseStateFollowUpsItemResponseInstrumentFormDefinitionFieldsItemValidatorRawValidatorRawValidatorTypeDefaultThree,
                                          ),
                                      })
                                      .describe(
                                        "Validator that accepts arbitrary phone numbers.",
                                      ),
                                    zod
                                      .object({
                                        type: zod
                                          .literal("email")
                                          .default(
                                            fetchStateResponseStateFollowUpsItemResponseInstrumentFormDefinitionFieldsItemValidatorRawValidatorRawValidatorTypeDefaultFour,
                                          ),
                                      })
                                      .describe(
                                        "Validator that accepts arbitrary emails.",
                                      ),
                                    zod
                                      .object({
                                        type: zod
                                          .literal("city_state_zip")
                                          .default(
                                            fetchStateResponseStateFollowUpsItemResponseInstrumentFormDefinitionFieldsItemValidatorRawValidatorRawValidatorTypeDefaultFive,
                                          ),
                                      })
                                      .describe(
                                        "Validator that accepts city, state, and ZIP code combinations.",
                                      ),
                                    zod.unknown(),
                                    zod.unknown(),
                                  ]),
                                })
                                .describe(
                                  "Validator that accepts lists of items.",
                                ),
                            ]),
                          })
                          .describe("Validator that accepts optional fields."),
                        zod
                          .object({
                            type: zod
                              .literal("list")
                              .default(
                                fetchStateResponseStateFollowUpsItemResponseInstrumentFormDefinitionFieldsItemValidatorTypeDefaultSeven,
                              ),
                            raw_validator: zod.union([
                              zod
                                .object({
                                  type: zod
                                    .literal("non_empty_string")
                                    .default(
                                      fetchStateResponseStateFollowUpsItemResponseInstrumentFormDefinitionFieldsItemValidatorRawValidatorTypeDefaultSeven,
                                    ),
                                })
                                .describe(
                                  "Validator that accepts arbitrary non-empty strings.",
                                ),
                              zod
                                .object({
                                  type: zod
                                    .literal("date")
                                    .default(
                                      fetchStateResponseStateFollowUpsItemResponseInstrumentFormDefinitionFieldsItemValidatorRawValidatorTypeDefaultEight,
                                    ),
                                })
                                .describe(
                                  "Validator that accepts arbitrary dates.",
                                ),
                              zod
                                .object({
                                  type: zod
                                    .literal("coded_choice")
                                    .default(
                                      fetchStateResponseStateFollowUpsItemResponseInstrumentFormDefinitionFieldsItemValidatorRawValidatorTypeDefaultNine,
                                    ),
                                  options: zod.array(
                                    zod
                                      .object({
                                        code: zod.string(),
                                        display: zod.string(),
                                      })
                                      .describe(
                                        "An option from a list of choices.",
                                      ),
                                  ),
                                })
                                .describe(
                                  "Validator that accepts any option from a list of choices.",
                                ),
                              zod
                                .object({
                                  type: zod
                                    .literal("phone_number")
                                    .default(
                                      fetchStateResponseStateFollowUpsItemResponseInstrumentFormDefinitionFieldsItemValidatorRawValidatorTypeDefaultOnezero,
                                    ),
                                })
                                .describe(
                                  "Validator that accepts arbitrary phone numbers.",
                                ),
                              zod
                                .object({
                                  type: zod
                                    .literal("email")
                                    .default(
                                      fetchStateResponseStateFollowUpsItemResponseInstrumentFormDefinitionFieldsItemValidatorRawValidatorTypeDefaultOneone,
                                    ),
                                })
                                .describe(
                                  "Validator that accepts arbitrary emails.",
                                ),
                              zod
                                .object({
                                  type: zod
                                    .literal("city_state_zip")
                                    .default(
                                      fetchStateResponseStateFollowUpsItemResponseInstrumentFormDefinitionFieldsItemValidatorRawValidatorTypeDefaultOnetwo,
                                    ),
                                })
                                .describe(
                                  "Validator that accepts city, state, and ZIP code combinations.",
                                ),
                              zod
                                .object({
                                  type: zod
                                    .literal("optional")
                                    .default(
                                      fetchStateResponseStateFollowUpsItemResponseInstrumentFormDefinitionFieldsItemValidatorRawValidatorTypeDefaultOnethree,
                                    ),
                                  raw_validator: zod.union([
                                    zod
                                      .object({
                                        type: zod
                                          .literal("non_empty_string")
                                          .default(
                                            fetchStateResponseStateFollowUpsItemResponseInstrumentFormDefinitionFieldsItemValidatorRawValidatorRawValidatorTypeDefaultSix,
                                          ),
                                      })
                                      .describe(
                                        "Validator that accepts arbitrary non-empty strings.",
                                      ),
                                    zod
                                      .object({
                                        type: zod
                                          .literal("date")
                                          .default(
                                            fetchStateResponseStateFollowUpsItemResponseInstrumentFormDefinitionFieldsItemValidatorRawValidatorRawValidatorTypeDefaultSeven,
                                          ),
                                      })
                                      .describe(
                                        "Validator that accepts arbitrary dates.",
                                      ),
                                    zod
                                      .object({
                                        type: zod
                                          .literal("coded_choice")
                                          .default(
                                            fetchStateResponseStateFollowUpsItemResponseInstrumentFormDefinitionFieldsItemValidatorRawValidatorRawValidatorTypeDefaultEight,
                                          ),
                                        options: zod.array(
                                          zod
                                            .object({
                                              code: zod.string(),
                                              display: zod.string(),
                                            })
                                            .describe(
                                              "An option from a list of choices.",
                                            ),
                                        ),
                                      })
                                      .describe(
                                        "Validator that accepts any option from a list of choices.",
                                      ),
                                    zod
                                      .object({
                                        type: zod
                                          .literal("phone_number")
                                          .default(
                                            fetchStateResponseStateFollowUpsItemResponseInstrumentFormDefinitionFieldsItemValidatorRawValidatorRawValidatorTypeDefaultNine,
                                          ),
                                      })
                                      .describe(
                                        "Validator that accepts arbitrary phone numbers.",
                                      ),
                                    zod
                                      .object({
                                        type: zod
                                          .literal("email")
                                          .default(
                                            fetchStateResponseStateFollowUpsItemResponseInstrumentFormDefinitionFieldsItemValidatorRawValidatorRawValidatorTypeDefaultOnezero,
                                          ),
                                      })
                                      .describe(
                                        "Validator that accepts arbitrary emails.",
                                      ),
                                    zod
                                      .object({
                                        type: zod
                                          .literal("city_state_zip")
                                          .default(
                                            fetchStateResponseStateFollowUpsItemResponseInstrumentFormDefinitionFieldsItemValidatorRawValidatorRawValidatorTypeDefaultOneone,
                                          ),
                                      })
                                      .describe(
                                        "Validator that accepts city, state, and ZIP code combinations.",
                                      ),
                                    zod.unknown(),
                                    zod.unknown(),
                                  ]),
                                })
                                .describe(
                                  "Validator that accepts optional fields.",
                                ),
                              zod.unknown(),
                            ]),
                          })
                          .describe("Validator that accepts lists of items."),
                      ]),
                    }),
                  ),
                }),
                submissions: zod.object({
                  submissions: zod.record(
                    zod.string(),
                    zod.union([
                      zod.object({
                        type: zod
                          .literal("string")
                          .default(
                            fetchStateResponseStateFollowUpsItemResponseInstrumentSubmissionsSubmissionsTypeDefault,
                          ),
                        value: zod.string(),
                      }),
                      zod.object({
                        type: zod
                          .literal("int")
                          .default(
                            fetchStateResponseStateFollowUpsItemResponseInstrumentSubmissionsSubmissionsTypeDefaultOne,
                          ),
                        value: zod.number(),
                      }),
                      zod.object({
                        type: zod
                          .literal("simple_address")
                          .default(
                            fetchStateResponseStateFollowUpsItemResponseInstrumentSubmissionsSubmissionsTypeDefaultTwo,
                          ),
                        street_address: zod.string(),
                        city_state_zip: zod.string(),
                      }),
                      zod.object({
                        type: zod
                          .literal("list")
                          .default(
                            fetchStateResponseStateFollowUpsItemResponseInstrumentSubmissionsSubmissionsTypeDefaultThree,
                          ),
                        values: zod.array(
                          zod.union([
                            zod.object({
                              type: zod
                                .literal("string")
                                .default(
                                  fetchStateResponseStateFollowUpsItemResponseInstrumentSubmissionsSubmissionsValuesItemTypeDefault,
                                ),
                              value: zod.string(),
                            }),
                            zod.object({
                              type: zod
                                .literal("int")
                                .default(
                                  fetchStateResponseStateFollowUpsItemResponseInstrumentSubmissionsSubmissionsValuesItemTypeDefaultOne,
                                ),
                              value: zod.number(),
                            }),
                            zod.object({
                              type: zod
                                .literal("simple_address")
                                .default(
                                  fetchStateResponseStateFollowUpsItemResponseInstrumentSubmissionsSubmissionsValuesItemTypeDefaultTwo,
                                ),
                              street_address: zod.string(),
                              city_state_zip: zod.string(),
                            }),
                            zod.unknown(),
                          ]),
                        ),
                      }),
                    ]),
                  ),
                }),
                problems: zod.record(zod.string(), zod.string()),
                interpretation: zod.union([
                  zod.object({
                    type: zod.enum(["complete", "incomplete", "error"]),
                    text: zod.string(),
                  }),
                  zod.null(),
                ]),
              })
              .describe(
                'An \"instrument session\" links the immediate state of a form with an instrumnet,\nwhich\n\nThis captures the instrument type, its form definition, and the user\'s\ncurrent submissions so that follow-ups can be processed without needing\nto look up the instrument again.',
              ),
            zod.null(),
          ])
          .optional(),
        response_from_patient: zod.union([zod.string(), zod.null()]).optional(),
        practice_area: zod.enum(["Primary Care", "Psychiatry"]).optional(),
        origin_practice: zod.union([zod.string(), zod.null()]).optional(),
      }),
    ),
    lab_orders: zod.array(
      zod
        .object({
          id: zod.uuid(),
          link: zod.union([
            zod.object({
              type: zod
                .literal("patient")
                .default(fetchStateResponseStateLabOrdersItemLinkTypeDefault),
            }),
            zod.object({
              type: zod
                .literal("problem")
                .default(
                  fetchStateResponseStateLabOrdersItemLinkTypeDefaultOne,
                ),
              id: zod.uuid(),
            }),
            zod.object({
              type: zod
                .literal("request")
                .default(
                  fetchStateResponseStateLabOrdersItemLinkTypeDefaultTwo,
                ),
              id: zod.uuid(),
            }),
            zod.object({
              type: zod
                .literal("orphan")
                .default(
                  fetchStateResponseStateLabOrdersItemLinkTypeDefaultThree,
                ),
            }),
          ]),
          remote_id: zod.string(),
          provider: zod.string(),
          status: zod.enum([
            "received",
            "collecting_sample",
            "sample_with_lab",
            "completed",
            "cancelled",
            "failed",
            "unknown",
          ]),
          interpretation: zod.enum([
            "normal",
            "abnormal",
            "critical",
            "unknown",
          ]),
          ordered_at: zod.iso.datetime({}),
          updated_at: zod.iso.datetime({}),
          version: zod.uuid(),
          order_data: zod
            .object({
              type: zod
                .literal("vital")
                .default(
                  fetchStateResponseStateLabOrdersItemOrderDataTypeDefault,
                ),
              value: zod.object({
                remote_id: zod.uuid(),
                user_id: zod.uuid(),
                created_at: zod.iso.datetime({}),
                updated_at: zod.iso.datetime({}),
                lab_test: zod.object({
                  id: zod.string(),
                  name: zod.string(),
                  sample_type: zod.enum([
                    "dried_blood_spot",
                    "arm_collector",
                    "serum",
                    "saliva",
                    "urine",
                  ]),
                  method: zod.enum([
                    "testkit",
                    "walk_in_test",
                    "at_home_phlebotomy",
                    "on_site_collection",
                  ]),
                  laboratory: zod.union([
                    zod
                      .object({
                        name: zod.string(),
                        formatted_address: zod.string(),
                        collection_methods: zod.array(
                          zod.enum([
                            "testkit",
                            "walk_in_test",
                            "at_home_phlebotomy",
                            "on_site_collection",
                          ]),
                        ),
                        sample_types: zod.array(
                          zod.enum([
                            "dried_blood_spot",
                            "arm_collector",
                            "serum",
                            "saliva",
                            "urine",
                          ]),
                        ),
                        slug: zod.union([zod.string(), zod.null()]).optional(),
                      })
                      .describe("Information about a lab facility."),
                    zod.null(),
                  ]),
                  markers: zod.array(
                    zod.object({
                      id: zod.string(),
                      name: zod.string(),
                      description: zod.union([zod.string(), zod.null()]),
                      unit: zod.union([zod.string(), zod.null()]),
                      metadata: zod
                        .object({
                          provider: zod
                            .literal("vital")
                            .default(
                              fetchStateResponseStateLabOrdersItemOrderDataValueLabTestMarkersItemMetadataProviderDefault,
                            ),
                          slug: zod.string(),
                          type: zod.union([
                            zod.enum(["biomarker", "panel"]),
                            zod.null(),
                          ]),
                          provider_id: zod.union([zod.string(), zod.null()]),
                          price: zod.union([zod.string(), zod.null()]),
                          a_la_carte_enabled: zod.boolean().optional(),
                          questions: zod.array(
                            zod
                              .object({
                                marker_id: zod.string(),
                                question_id: zod.string(),
                                body: zod.object({
                                  required: zod.boolean(),
                                  code: zod.string(),
                                  value: zod.string(),
                                  constraint: zod.union([
                                    zod.string(),
                                    zod.null(),
                                  ]),
                                  validator: zod.union([
                                    zod.object({
                                      type: zod.literal("choice"),
                                      answers: zod.array(
                                        zod.object({
                                          code: zod.string(),
                                          value: zod.string(),
                                        }),
                                      ),
                                    }),
                                    zod.object({
                                      type: zod.literal("text"),
                                    }),
                                    zod.object({
                                      type: zod.literal("numeric"),
                                    }),
                                    zod.object({
                                      type: zod.literal("multi_choice"),
                                      answers: zod.array(
                                        zod.object({
                                          code: zod.string(),
                                          value: zod.string(),
                                        }),
                                      ),
                                    }),
                                  ]),
                                  default: zod.union([
                                    zod.string(),
                                    zod.null(),
                                  ]),
                                }),
                              })
                              .describe("Vital-specific lab marker question."),
                          ),
                          lab_info: zod
                            .union([
                              zod
                                .object({
                                  lab_id: zod.string(),
                                  name: zod
                                    .enum([
                                      "MyUTI",
                                      "Nexus",
                                      "Precision Analytical",
                                      "Boston Heart At-Home Kit",
                                      "Quest",
                                      "Labcorp",
                                      "BioReference",
                                      "IHD",
                                      "SanoCardio",
                                      "Ayumetrix",
                                      "Diagnostic Solutions",
                                      "Cell Science Systems",
                                      "Genova Diagnostics",
                                      "ZRT Laboratory",
                                      "USSL",
                                      "Spiriplex",
                                      "US Biotek",
                                    ])
                                    .describe("Lab names from Vital."),
                                })
                                .describe(
                                  "Short lab information containing ID and name.",
                                ),
                              zod.null(),
                            ])
                            .optional(),
                          expected_results: zod
                            .array(
                              zod
                                .object({
                                  id: zod.string(),
                                  name: zod.string(),
                                })
                                .describe(
                                  "A result Junction expects an orderable marker or panel to produce.",
                                ),
                            )
                            .optional(),
                        })
                        .describe("Vital-specific lab marker metadata."),
                    }),
                  ),
                  metadata: zod
                    .object({
                      provider: zod
                        .literal("vital")
                        .default(
                          fetchStateResponseStateLabOrdersItemOrderDataValueLabTestMetadataProviderDefault,
                        ),
                      slug: zod.string(),
                      price: zod.number(),
                      is_active: zod.boolean(),
                      status: zod.enum([
                        "active",
                        "pending_approval",
                        "inactive",
                        "unknown",
                      ]),
                      fasting: zod.union([zod.boolean(), zod.null()]),
                      auto_generated: zod
                        .union([zod.boolean(), zod.null()])
                        .optional(),
                    })
                    .describe("Vital-specific lab test metadata."),
                  aoe_schema: zod
                    .object({
                      sections: zod.array(
                        zod
                          .object({
                            title: zod.string(),
                            description: zod.union([zod.string(), zod.null()]),
                            questions: zod.array(
                              zod
                                .object({
                                  id: zod.string(),
                                  body: zod.object({
                                    required: zod.boolean(),
                                    code: zod.string(),
                                    value: zod.string(),
                                    constraint: zod.union([
                                      zod.string(),
                                      zod.null(),
                                    ]),
                                    validator: zod.union([
                                      zod.object({
                                        type: zod.literal("choice"),
                                        answers: zod.array(
                                          zod.object({
                                            code: zod.string(),
                                            value: zod.string(),
                                          }),
                                        ),
                                      }),
                                      zod.object({
                                        type: zod.literal("text"),
                                      }),
                                      zod.object({
                                        type: zod.literal("numeric"),
                                      }),
                                      zod.object({
                                        type: zod.literal("multi_choice"),
                                        answers: zod.array(
                                          zod.object({
                                            code: zod.string(),
                                            value: zod.string(),
                                          }),
                                        ),
                                      }),
                                    ]),
                                    default: zod.union([
                                      zod.string(),
                                      zod.null(),
                                    ]),
                                  }),
                                })
                                .describe(
                                  "A required question (AOE - Ask on Entry) for a lab marker.",
                                ),
                            ),
                          })
                          .describe(
                            "A section of AOE questions grouped by marker.\n\nEach section represents questions from a single marker\/biomarker,\nwith the marker's name and description as context for the questions.",
                          ),
                      ),
                    })
                    .describe(
                      "Schema for AOE (Ask on Entry) questions organized by sections.\n\nEach section corresponds to a marker and contains all questions\nassociated with that marker.",
                    ),
                  clinician: zod
                    .union([
                      zod
                        .object({
                          first_name: zod.string(),
                          last_name: zod.string(),
                          dob: zod.iso.date(),
                          address: zod
                            .object({
                              address1: zod.string(),
                              address2: zod.union([zod.string(), zod.null()]),
                              city: zod.string(),
                              state: zod.string(),
                              zip_code: zod.string(),
                            })
                            .describe(
                              "Clinician's address for lab order attribution.",
                            ),
                          npi: zod.string(),
                          email: zod.union([zod.string(), zod.null()]),
                          phone: zod.union([zod.string(), zod.null()]),
                        })
                        .describe(
                          "Clinician information required for lab orders.\n\nThis information is extracted from DoseSpot clinician records\nand validated before allowing clinicians to submit lab orders\nor create lab tests.",
                        ),
                      zod.null(),
                    ])
                    .optional(),
                }),
                metadata: zod
                  .object({
                    provider: zod
                      .literal("vital")
                      .default(
                        fetchStateResponseStateLabOrdersItemOrderDataValueMetadataProviderDefault,
                      ),
                    details: zod.union([
                      zod
                        .object({
                          type: zod
                            .literal("testkit")
                            .default(
                              fetchStateResponseStateLabOrdersItemOrderDataValueMetadataDetailsTypeDefault,
                            ),
                          id: zod.uuid(),
                          shipment: zod.union([
                            zod
                              .object({
                                id: zod.uuid(),
                                outbound: zod.union([
                                  zod
                                    .object({
                                      tracking_number: zod.union([
                                        zod.string(),
                                        zod.null(),
                                      ]),
                                      tracking_url: zod.union([
                                        zod.string(),
                                        zod.null(),
                                      ]),
                                      courier: zod.union([
                                        zod.string(),
                                        zod.null(),
                                      ]),
                                    })
                                    .describe(
                                      "Tracking information for a shipment direction (outbound or inbound).",
                                    ),
                                  zod.null(),
                                ]),
                                inbound: zod.union([
                                  zod
                                    .object({
                                      tracking_number: zod.union([
                                        zod.string(),
                                        zod.null(),
                                      ]),
                                      tracking_url: zod.union([
                                        zod.string(),
                                        zod.null(),
                                      ]),
                                      courier: zod.union([
                                        zod.string(),
                                        zod.null(),
                                      ]),
                                    })
                                    .describe(
                                      "Tracking information for a shipment direction (outbound or inbound).",
                                    ),
                                  zod.null(),
                                ]),
                                notes: zod.union([zod.string(), zod.null()]),
                              })
                              .describe(
                                "Shipment tracking information for testkit orders.",
                              ),
                            zod.null(),
                          ]),
                          created_at: zod.iso.datetime({}),
                          updated_at: zod.iso.datetime({}),
                        })
                        .describe("Details for testkit orders."),
                      zod
                        .object({
                          type: zod
                            .literal("walk_in_test")
                            .default(
                              fetchStateResponseStateLabOrdersItemOrderDataValueMetadataDetailsTypeDefaultOne,
                            ),
                          id: zod.uuid(),
                          appointment_id: zod.union([zod.uuid(), zod.null()]),
                          created_at: zod.iso.datetime({}),
                          updated_at: zod.iso.datetime({}),
                        })
                        .describe("Details for walk-in test orders."),
                      zod
                        .object({
                          type: zod
                            .literal("at_home_phlebotomy")
                            .default(
                              fetchStateResponseStateLabOrdersItemOrderDataValueMetadataDetailsTypeDefaultTwo,
                            ),
                          id: zod.uuid(),
                          appointment_id: zod.union([zod.uuid(), zod.null()]),
                          created_at: zod.iso.datetime({}),
                          updated_at: zod.iso.datetime({}),
                        })
                        .describe("Details for at-home phlebotomy orders."),
                      zod
                        .object({
                          type: zod
                            .literal("on_site_collection")
                            .default(
                              fetchStateResponseStateLabOrdersItemOrderDataValueMetadataDetailsTypeDefaultThree,
                            ),
                          id: zod.uuid(),
                          created_at: zod.iso.datetime({}),
                          updated_at: zod.iso.datetime({}),
                        })
                        .describe("Details for on-site collection orders."),
                    ]),
                    sample_id: zod.union([zod.string(), zod.null()]),
                    notes: zod.union([zod.string(), zod.null()]),
                    priority: zod.boolean().optional(),
                    events: zod
                      .array(
                        zod
                          .object({
                            remote_id: zod.number(),
                            created_at: zod.iso.datetime({}),
                            status: zod.union([
                              zod.enum([
                                "received.walk_in_test.ordered",
                                "received.walk_in_test.requisition_created",
                                "received.walk_in_test.requisition_bypassed",
                                "completed.walk_in_test.completed",
                                "sample_with_lab.walk_in_test.partial_results",
                                "failed.walk_in_test.sample_error",
                                "cancelled.walk_in_test.cancelled",
                                "collecting_sample.walk_in_test.appointment_pending",
                                "collecting_sample.walk_in_test.appointment_scheduled",
                                "collecting_sample.walk_in_test.appointment_cancelled",
                                "collecting_sample.walk_in_test.redraw_available",
                                "received.at_home_phlebotomy.ordered",
                                "received.at_home_phlebotomy.requisition_created",
                                "received.at_home_phlebotomy.requisition_bypassed",
                                "collecting_sample.at_home_phlebotomy.appointment_pending",
                                "collecting_sample.at_home_phlebotomy.appointment_scheduled",
                                "collecting_sample.at_home_phlebotomy.draw_completed",
                                "collecting_sample.at_home_phlebotomy.appointment_cancelled",
                                "completed.at_home_phlebotomy.completed",
                                "sample_with_lab.at_home_phlebotomy.partial_results",
                                "cancelled.at_home_phlebotomy.cancelled",
                                "failed.at_home_phlebotomy.sample_error",
                                "received.testkit.ordered",
                                "received.testkit.awaiting_registration",
                                "received.testkit.requisition_created",
                                "received.testkit.requisition_bypassed",
                                "received.testkit.registered",
                                "collecting_sample.testkit.transit_customer",
                                "collecting_sample.testkit.out_for_delivery",
                                "collecting_sample.testkit.with_customer",
                                "collecting_sample.testkit.transit_lab",
                                "sample_with_lab.testkit.delivered_to_lab",
                                "completed.testkit.completed",
                                "failed.testkit.failure_to_deliver_to_customer",
                                "failed.testkit.failure_to_deliver_to_lab",
                                "failed.testkit.sample_error",
                                "failed.testkit.lost",
                                "cancelled.testkit.cancelled",
                                "cancelled.testkit.do_not_process",
                                "collecting_sample.testkit.problem_in_transit_customer",
                                "collecting_sample.testkit.problem_in_transit_lab",
                                "received.on_site_collection.ordered",
                                "received.on_site_collection.requisition_created",
                                "received.on_site_collection.requisition_bypassed",
                                "sample_with_lab.on_site_collection.draw_completed",
                                "completed.on_site_collection.completed",
                                "cancelled.on_site_collection.cancelled",
                                "sample_with_lab.on_site_collection.partial_results",
                                "failed.on_site_collection.sample_error",
                              ]),
                              zod.string(),
                            ]),
                            status_detail: zod
                              .union([zod.string(), zod.null()])
                              .optional(),
                          })
                          .describe("An event in the lifecycle of an order."),
                      )
                      .default(
                        fetchStateResponseStateLabOrdersItemOrderDataValueMetadataEventsDefault,
                      ),
                  })
                  .describe("Vital-specific order metadata."),
                interpretation: zod.enum([
                  "normal",
                  "abnormal",
                  "critical",
                  "unknown",
                ]),
                status: zod.enum([
                  "received",
                  "collecting_sample",
                  "sample_with_lab",
                  "completed",
                  "cancelled",
                  "failed",
                  "unknown",
                ]),
              }),
            })
            .describe("Tagged lab order for Vital provider."),
        })
        .describe(
          "A lab order in the care state.\n\nThis mirrors the LabOrder SQL entity but in the diff-based CareState store,\nenabling change tracking and integration with other care state entities.",
        ),
    ),
    diagnoses: zod.array(
      zod
        .object({
          id: zod.uuid(),
          link: zod.union([
            zod.object({
              type: zod
                .literal("patient")
                .default(fetchStateResponseStateDiagnosesItemLinkTypeDefault),
            }),
            zod.object({
              type: zod
                .literal("problem")
                .default(
                  fetchStateResponseStateDiagnosesItemLinkTypeDefaultOne,
                ),
              id: zod.uuid(),
            }),
            zod.object({
              type: zod
                .literal("request")
                .default(
                  fetchStateResponseStateDiagnosesItemLinkTypeDefaultTwo,
                ),
              id: zod.uuid(),
            }),
            zod.object({
              type: zod
                .literal("orphan")
                .default(
                  fetchStateResponseStateDiagnosesItemLinkTypeDefaultThree,
                ),
            }),
          ]),
          icd10_code: zod.string(),
          icd10_description: zod.string(),
          note: zod.object({
            value: zod.string(),
            expiry: zod.object({
              basis: zod.union([zod.string(), zod.null()]),
              time: zod.union([zod.iso.datetime({}), zod.null()]),
            }),
          }),
          recorded_by: zod.union([zod.uuid(), zod.null()]).optional(),
        })
        .describe(
          "A clinician-recorded diagnosis mirrored into care state.\n\nCreated when a clinician executes a ``diagnose`` proposed action (either\none proposed by the action reviewer \/ Cortex, or one they authored\nmanually). Care State owns identity and linkage; the diagnosis flows out\nto the patient's PHR and to Metriport as a FHIR ``Condition`` via the\n``CareStateReingestedFhirPlugin``.\n\n``icd10_code`` is stored without dots (e.g. ``E119``) exactly as the\nICD-10 search index normalizes it, so it round-trips cleanly back through\nthe FHIR ``Condition.code`` coding.",
        ),
    ),
    prescriptions: zod.array(
      zod
        .object({
          id: zod.uuid(),
          link: zod.union([
            zod.object({
              type: zod
                .literal("patient")
                .default(
                  fetchStateResponseStatePrescriptionsItemLinkTypeDefault,
                ),
            }),
            zod.object({
              type: zod
                .literal("problem")
                .default(
                  fetchStateResponseStatePrescriptionsItemLinkTypeDefaultOne,
                ),
              id: zod.uuid(),
            }),
            zod.object({
              type: zod
                .literal("request")
                .default(
                  fetchStateResponseStatePrescriptionsItemLinkTypeDefaultTwo,
                ),
              id: zod.uuid(),
            }),
            zod.object({
              type: zod
                .literal("orphan")
                .default(
                  fetchStateResponseStatePrescriptionsItemLinkTypeDefaultThree,
                ),
            }),
          ]),
          dosespot_prescription_id: zod.string(),
          prescription_record_id: zod.uuid(),
          cached_info: zod
            .union([
              zod
                .object({
                  PrescriptionId: zod
                    .union([zod.number(), zod.null()])
                    .optional(),
                  PriorAuthorizationCaseId: zod
                    .union([zod.number(), zod.null()])
                    .optional(),
                  WrittenDate: zod.union([zod.string(), zod.null()]).optional(),
                  Directions: zod.union([zod.string(), zod.null()]).optional(),
                  Quantity: zod.union([zod.string(), zod.null()]).optional(),
                  DispenseUnitId: zod
                    .union([zod.number(), zod.null()])
                    .optional(),
                  Refills: zod.union([zod.string(), zod.null()]).optional(),
                  DaysSupply: zod.union([zod.number(), zod.null()]).optional(),
                  PharmacyId: zod.union([zod.number(), zod.null()]).optional(),
                  PharmacyNotes: zod
                    .union([zod.string(), zod.null()])
                    .optional(),
                  NoSubstitutions: zod
                    .union([zod.boolean(), zod.null()])
                    .optional(),
                  EffectiveDate: zod
                    .union([zod.string(), zod.null()])
                    .optional(),
                  LastFillDate: zod
                    .union([zod.string(), zod.null()])
                    .optional(),
                  PrescriberId: zod
                    .union([zod.number(), zod.null()])
                    .optional(),
                  PrescriberAgentId: zod
                    .union([zod.number(), zod.null()])
                    .optional(),
                  RxReferenceNumber: zod
                    .union([zod.string(), zod.null()])
                    .optional(),
                  Status: zod
                    .union([
                      zod
                        .enum([
                          "Unknown",
                          "Entered",
                          "Printed",
                          "Sending",
                          "eRxSent",
                          "FaxSent",
                          "Error",
                          "Deleted",
                          "Requested",
                          "Edited",
                          "EpcsError",
                          "EpcsSigned",
                          "ReadyToSign",
                          "PharmacyVerified",
                          "PharmacySelect",
                        ])
                        .describe(
                          "Valid prescription status types for DoseSpot.",
                        ),
                      zod.null(),
                    ])
                    .optional(),
                  Formulary: zod.union([zod.boolean(), zod.null()]).optional(),
                  EligibilityId: zod
                    .union([zod.number(), zod.null()])
                    .optional(),
                  Type: zod
                    .union([
                      zod
                        .enum([
                          "Coded",
                          "FreeText",
                          "NDC",
                          "Supply",
                          "Compound",
                        ])
                        .describe("Valid prescription types for DoseSpot."),
                      zod.null(),
                    ])
                    .optional(),
                  NonDoseSpotPrescriptionId: zod
                    .union([zod.string(), zod.null()])
                    .optional(),
                  ErrorIgnored: zod
                    .union([zod.boolean(), zod.null()])
                    .optional(),
                  SupplyId: zod.union([zod.number(), zod.null()]).optional(),
                  FreeTextType: zod
                    .union([
                      zod
                        .enum(["Medication", "Supply", "Compound"])
                        .describe(
                          "Valid free text types for DoseSpot prescriptions.",
                        ),
                      zod.null(),
                    ])
                    .optional(),
                  ClinicId: zod.union([zod.number(), zod.null()]).optional(),
                  SupervisorId: zod
                    .union([zod.number(), zod.null()])
                    .optional(),
                  IsUrgent: zod.union([zod.boolean(), zod.null()]).optional(),
                  IsRxRenewal: zod
                    .union([zod.boolean(), zod.null()])
                    .optional(),
                  RxRenewalNote: zod
                    .union([zod.string(), zod.null()])
                    .optional(),
                  FirstPrescriptionDiagnosis: zod
                    .union([
                      zod
                        .object({
                          PrimaryDiagnosis: zod
                            .union([
                              zod
                                .object({
                                  DiagnosisId: zod
                                    .union([zod.number(), zod.null()])
                                    .optional(),
                                  DiagnosisCode: zod
                                    .union([zod.string(), zod.null()])
                                    .optional(),
                                  DiagnosisDescription: zod
                                    .union([zod.string(), zod.null()])
                                    .optional(),
                                })
                                .describe("DoseSpot diagnosis information."),
                              zod.null(),
                            ])
                            .optional(),
                          SecondaryDiagnosis: zod
                            .union([
                              zod
                                .object({
                                  DiagnosisId: zod
                                    .union([zod.number(), zod.null()])
                                    .optional(),
                                  DiagnosisCode: zod
                                    .union([zod.string(), zod.null()])
                                    .optional(),
                                  DiagnosisDescription: zod
                                    .union([zod.string(), zod.null()])
                                    .optional(),
                                })
                                .describe("DoseSpot diagnosis information."),
                              zod.null(),
                            ])
                            .optional(),
                        })
                        .describe(
                          "DoseSpot prescription diagnosis information.",
                        ),
                      zod.null(),
                    ])
                    .optional(),
                  SecondPrescriptionDiagnosis: zod
                    .union([
                      zod
                        .object({
                          PrimaryDiagnosis: zod
                            .union([
                              zod
                                .object({
                                  DiagnosisId: zod
                                    .union([zod.number(), zod.null()])
                                    .optional(),
                                  DiagnosisCode: zod
                                    .union([zod.string(), zod.null()])
                                    .optional(),
                                  DiagnosisDescription: zod
                                    .union([zod.string(), zod.null()])
                                    .optional(),
                                })
                                .describe("DoseSpot diagnosis information."),
                              zod.null(),
                            ])
                            .optional(),
                          SecondaryDiagnosis: zod
                            .union([
                              zod
                                .object({
                                  DiagnosisId: zod
                                    .union([zod.number(), zod.null()])
                                    .optional(),
                                  DiagnosisCode: zod
                                    .union([zod.string(), zod.null()])
                                    .optional(),
                                  DiagnosisDescription: zod
                                    .union([zod.string(), zod.null()])
                                    .optional(),
                                })
                                .describe("DoseSpot diagnosis information."),
                              zod.null(),
                            ])
                            .optional(),
                        })
                        .describe(
                          "DoseSpot prescription diagnosis information.",
                        ),
                      zod.null(),
                    ])
                    .optional(),
                  Strength: zod.union([zod.string(), zod.null()]).optional(),
                  PatientMedicationId: zod
                    .union([zod.number(), zod.null()])
                    .optional(),
                  MedicationStatus: zod
                    .union([
                      zod
                        .enum([
                          "Unknown",
                          "Active",
                          "Inactive",
                          "Discontinued",
                          "Deleted",
                          "Completed",
                          "CancelRequested",
                          "CancelPending",
                          "Cancelled",
                          "CancelDenied",
                          "Changed",
                          "FullFill",
                          "PartialFill",
                          "NoFill",
                        ])
                        .describe(
                          "Valid medication status types for DoseSpot.",
                        ),
                      zod.null(),
                    ])
                    .optional(),
                  Comment: zod.union([zod.string(), zod.null()]).optional(),
                  DateInactive: zod
                    .union([zod.string(), zod.null()])
                    .optional(),
                  Encounter: zod.union([zod.string(), zod.null()]).optional(),
                  DisplayName: zod.union([zod.string(), zod.null()]).optional(),
                  DispensableDrugId: zod
                    .union([zod.number(), zod.null()])
                    .optional(),
                  Schedule: zod.union([zod.number(), zod.null()]).optional(),
                  CompoundIngredients: zod
                    .union([
                      zod.array(
                        zod
                          .object({
                            DispensableDrugId: zod
                              .union([zod.number(), zod.null()])
                              .optional(),
                            FreeText: zod
                              .union([zod.string(), zod.null()])
                              .optional(),
                            DispenseUnitId: zod
                              .union([zod.number(), zod.null()])
                              .optional(),
                            Quantity: zod.string(),
                            IsFreeTextEPCS: zod
                              .union([zod.boolean(), zod.null()])
                              .optional(),
                          })
                          .describe(
                            "DoseSpot compound ingredient information.",
                          ),
                      ),
                      zod.null(),
                    ])
                    .optional(),
                })
                .describe(
                  "Complete prescription information from DoseSpot API.",
                ),
              zod.null(),
            ])
            .optional(),
        })
        .describe(
          'A prescription written by a clinician, mirrored into care state for\nunified audit and timeline tracking.\n\nCare State owns identity and linkage (``id``, ``link``,\n``dosespot_prescription_id``, ``prescription_record_id``); the full\nDoseSpot clinical payload is carried verbatim in ``cached_info`` so the\nCare State row is a self-contained snapshot. ``cached_info`` is\noptional because DoseSpot populates fields lazily across the\nprescription lifecycle; consumers needing clinical detail should treat\na ``None`` payload as \"row exists but not yet hydrated.\"',
        ),
    ),
    prior_auth_requests: zod.array(
      zod
        .object({
          id: zod.uuid(),
          link: zod.union([
            zod.object({
              type: zod
                .literal("patient")
                .default(
                  fetchStateResponseStatePriorAuthRequestsItemLinkTypeDefault,
                ),
            }),
            zod.object({
              type: zod
                .literal("problem")
                .default(
                  fetchStateResponseStatePriorAuthRequestsItemLinkTypeDefaultOne,
                ),
              id: zod.uuid(),
            }),
            zod.object({
              type: zod
                .literal("request")
                .default(
                  fetchStateResponseStatePriorAuthRequestsItemLinkTypeDefaultTwo,
                ),
              id: zod.uuid(),
            }),
            zod.object({
              type: zod
                .literal("orphan")
                .default(
                  fetchStateResponseStatePriorAuthRequestsItemLinkTypeDefaultThree,
                ),
            }),
          ]),
          dosespot_prescription_id: zod.string(),
          prescription_record_id: zod.uuid(),
          dosespot_prior_auth_case_number: zod
            .union([zod.string(), zod.null()])
            .optional(),
          status: zod
            .enum([
              "Requested",
              "Appealing",
              "Cancel Requested",
              "Action Required",
              "Approved",
              "Partially Approved",
              "Not Required",
              "Denied",
              "Cancelled",
              "Error",
              "Sent to Pharmacy",
              "Superseded",
              "Ended",
            ])
            .describe(
              'Normalized prior-authorization status.\n\nCollapses DoseSpot\'s 17-value `PriorAuthorizationStatusType` plus the\n25-value `ClosedReasonCodeId` super-status into an \"owns it right now\"\noriented enum. The full mapping from raw DoseSpot status lives on the PA\npoller (`_map_dosespot_status`) and is documented in `PRIOR_AUTH.md`.\n\n``NOT_REQUIRED`` is deliberately distinct from ``APPROVED`` (no auth\nnumber) and ``PARTIALLY_APPROVED`` is distinct from ``APPROVED`` because\nit comes with a narrower Quantity\/DaysSupply\/NumberOfRefills that the\nclinician must acknowledge or appeal.\n\n``StrEnum`` (not plain ``Enum``) because the values round-trip through\nthe ``dosespot_prior_auth_records.normalized_status`` ``TEXT`` column:\nasyncpg only accepts ``str`` for ``TEXT`` bind parameters, and a plain\n``Enum`` instance is not a ``str`` subclass.',
            ),
          note: zod.object({
            value: zod.string(),
            expiry: zod.object({
              basis: zod.union([zod.string(), zod.null()]),
              time: zod.union([zod.iso.datetime({}), zod.null()]),
            }),
          }),
          is_offline: zod.boolean().optional(),
          prior_auth_number: zod.union([zod.string(), zod.null()]).optional(),
          denial_reason: zod.union([zod.string(), zod.null()]).optional(),
        })
        .describe(
          "A prior-authorization case mirrored into CareState.\n\nThin and denormalized for patient-timeline rendering. The full cached\nDoseSpot payload lives on ``DosespotPriorAuthRecord`` (SQL); this row\ncarries only what the timeline, inbox, and copilot need.",
        ),
    ),
    pre_requests: zod.array(
      zod
        .object({
          id: zod.uuid(),
          title: zod.string(),
          message: zod.string(),
          urgency: zod.enum(["Routine", "Urgent"]),
          status: zod
            .enum(["Pending", "Processed"])
            .describe("Status of a pre-request in the escalation pipeline."),
          chat_link: zod
            .union([
              zod.union([
                zod.object({
                  type: zod
                    .literal("chat_message")
                    .default(
                      fetchStateResponseStatePreRequestsItemChatLinkTypeDefault,
                    ),
                  conversation_id: zod.uuid(),
                  message_id: zod.uuid(),
                }),
                zod.object({
                  type: zod
                    .literal("chat_conversation")
                    .default(
                      fetchStateResponseStatePreRequestsItemChatLinkTypeDefaultOne,
                    ),
                  conversation_id: zod.uuid(),
                }),
              ]),
              zod.null(),
            ])
            .optional(),
          idempotency_key: zod.union([zod.string(), zod.null()]).optional(),
          proposed_action_intents: zod
            .array(
              zod
                .object({
                  external_id: zod.string(),
                  title: zod.string(),
                  payload: zod
                    .object({
                      payload_id: zod.string(),
                      tool_name: zod.string(),
                      tool_input: zod.record(zod.string(), zod.unknown()),
                      justification: zod.string(),
                    })
                    .describe(
                      "A frozen tool call: the exact invocation to execute when the action is run.\n\nThis type is shared between CareState rows and REST API modification\nrecords. It deliberately does NOT use ``APIVIEW_MODEL_CONFIG`` because\nCareState serialisation (``model_dump()``) must produce snake_case keys\nand the SDK type must match that runtime shape. The REST API input layer\nconverts camelCase payload fields to snake_case before Pydantic sees them.\n\nThe opaque ``tool_input`` dict keys are never converted — they preserve\nwhatever casing the LLM originally used (typically camelCase).",
                    ),
                  alternatives: zod
                    .array(
                      zod
                        .object({
                          payload_id: zod.string(),
                          tool_name: zod.string(),
                          tool_input: zod.record(zod.string(), zod.unknown()),
                          justification: zod.string(),
                        })
                        .describe(
                          "A frozen tool call: the exact invocation to execute when the action is run.\n\nThis type is shared between CareState rows and REST API modification\nrecords. It deliberately does NOT use ``APIVIEW_MODEL_CONFIG`` because\nCareState serialisation (``model_dump()``) must produce snake_case keys\nand the SDK type must match that runtime shape. The REST API input layer\nconverts camelCase payload fields to snake_case before Pydantic sees them.\n\nThe opaque ``tool_input`` dict keys are never converted — they preserve\nwhatever casing the LLM originally used (typically camelCase).",
                        ),
                    )
                    .optional(),
                  justification: zod.string(),
                  depends_on_action_external_ids: zod
                    .array(zod.string())
                    .optional(),
                })
                .describe(
                  "A proposed action that is waiting for its owning request to be resolved.",
                ),
            )
            .optional(),
          proposed_action_created_by: zod
            .union([
              zod.union([
                zod.object({
                  type: zod
                    .literal("clinician")
                    .default(
                      fetchStateResponseStatePreRequestsItemProposedActionCreatedByTypeDefault,
                    ),
                  clinician_id: zod.string(),
                }),
                zod
                  .object({
                    type: zod
                      .literal("system")
                      .default(
                        fetchStateResponseStatePreRequestsItemProposedActionCreatedByTypeDefaultOne,
                      ),
                    source: zod.string(),
                  })
                  .describe(
                    "Identity for system-initiated updates to the care state.\nUsed when automated processes (like clinician escalations) need to\nmodify the care state without a specific clinician acting.",
                  ),
              ]),
              zod.null(),
            ])
            .optional(),
        })
        .describe(
          "A pre-request awaiting resolution into a clinician request.\n\nProposed-action intents stay on this hidden staging record until the\nlibrarian resolves the final request. They are then materialized directly\nagainst that request, so no temporary patient-linked action is exposed.",
        ),
    ),
    proposed_actions: zod.array(
      zod
        .object({
          id: zod.uuid(),
          external_id: zod.string(),
          link: zod.union([
            zod.object({
              type: zod
                .literal("patient")
                .default(
                  fetchStateResponseStateProposedActionsItemLinkTypeDefault,
                ),
            }),
            zod.object({
              type: zod
                .literal("problem")
                .default(
                  fetchStateResponseStateProposedActionsItemLinkTypeDefaultOne,
                ),
              id: zod.uuid(),
            }),
            zod.object({
              type: zod
                .literal("request")
                .default(
                  fetchStateResponseStateProposedActionsItemLinkTypeDefaultTwo,
                ),
              id: zod.uuid(),
            }),
            zod.object({
              type: zod
                .literal("orphan")
                .default(
                  fetchStateResponseStateProposedActionsItemLinkTypeDefaultThree,
                ),
            }),
          ]),
          title: zod.string(),
          todo_status: zod.enum(["Open", "Done", "Archived"]),
          decision: zod.enum([
            "Pending",
            "Approved",
            "AutoApproved",
            "Rejected",
          ]),
          payload: zod
            .object({
              payload_id: zod.string(),
              tool_name: zod.string(),
              tool_input: zod.record(zod.string(), zod.unknown()),
              justification: zod.string(),
            })
            .describe(
              "A frozen tool call: the exact invocation to execute when the action is run.\n\nThis type is shared between CareState rows and REST API modification\nrecords. It deliberately does NOT use ``APIVIEW_MODEL_CONFIG`` because\nCareState serialisation (``model_dump()``) must produce snake_case keys\nand the SDK type must match that runtime shape. The REST API input layer\nconverts camelCase payload fields to snake_case before Pydantic sees them.\n\nThe opaque ``tool_input`` dict keys are never converted — they preserve\nwhatever casing the LLM originally used (typically camelCase).",
            ),
          alternatives: zod.array(
            zod
              .object({
                payload_id: zod.string(),
                tool_name: zod.string(),
                tool_input: zod.record(zod.string(), zod.unknown()),
                justification: zod.string(),
              })
              .describe(
                "A frozen tool call: the exact invocation to execute when the action is run.\n\nThis type is shared between CareState rows and REST API modification\nrecords. It deliberately does NOT use ``APIVIEW_MODEL_CONFIG`` because\nCareState serialisation (``model_dump()``) must produce snake_case keys\nand the SDK type must match that runtime shape. The REST API input layer\nconverts camelCase payload fields to snake_case before Pydantic sees them.\n\nThe opaque ``tool_input`` dict keys are never converted — they preserve\nwhatever casing the LLM originally used (typically camelCase).",
              ),
          ),
          justification: zod.string(),
          depends_on_action_external_ids: zod.array(zod.string()),
          created_by: zod
            .union([
              zod.union([
                zod.object({
                  type: zod
                    .literal("clinician")
                    .default(
                      fetchStateResponseStateProposedActionsItemCreatedByTypeDefault,
                    ),
                  clinician_id: zod.string(),
                }),
                zod
                  .object({
                    type: zod
                      .literal("system")
                      .default(
                        fetchStateResponseStateProposedActionsItemCreatedByTypeDefaultOne,
                      ),
                    source: zod.string(),
                  })
                  .describe(
                    "Identity for system-initiated updates to the care state.\nUsed when automated processes (like clinician escalations) need to\nmodify the care state without a specific clinician acting.",
                  ),
              ]),
              zod.null(),
            ])
            .optional(),
          run_status: zod
            .enum(["Idle", "Running", "Succeeded", "Failed"])
            .optional(),
          tool_output: zod
            .union([zod.record(zod.string(), zod.unknown()), zod.null()])
            .optional(),
          run_error: zod.union([zod.string(), zod.null()]).optional(),
        })
        .describe(
          "A discrete action in a patient's care plan that a clinician can approve\/reject.\n\nOnce approved, it behaves as a frozen tool call: executing it runs the exact\nprecomputed tool invocation without additional LLM reasoning.\n\nActions may form a workflow graph via depends_on_action_external_ids.\nExecution state (run_status, tool_output, run_error) lives directly on the\naction row rather than in a separate runs table.",
        ),
    ),
    care_plans: zod.array(
      zod
        .object({
          title: zod.string(),
          goal: zod.string(),
          progress_note: zod.string(),
          progress_highlights: zod.array(zod.string()),
          next_steps: zod.string(),
          id: zod.literal("root"),
          anchor: zod.string(),
          last_updated_at: zod.iso.datetime({}),
        })
        .describe(
          'The patient\'s living Care Plan as stored in care state.\n\nSingleton row per patient (`id: Literal[\"root\"]`, mirroring\n`CareStatePatientT`). The librarian creates the row on the first\nregeneration cycle and updates it in place thereafter. See\n`lotushealth.care.librarian.care_plan`.',
        ),
    ),
    amendment_log: zod.array(
      zod
        .object({
          author: zod.enum(["patient", "clinician"]),
          row_ref: zod
            .object({
              resource_type: zod.union([
                zod.enum(["medication", "condition", "allergy"]),
                zod.string(),
              ]),
              origin_ids: zod.array(zod.string()),
              display_name: zod.string(),
            })
            .describe(
              "A stable, submittable reference to a PHR row.\n\nThe overlay joins on ``(resource_type, origin_id)`` for every origin_id, so\none ref can match a row that was reconciled\/merged from several source FHIR\nresources. ``display_name`` is carried for audit\/display only and never\nparticipates in the join.",
            ),
          value: zod.union([
            zod.object({
              resource_type: zod
                .literal("medication")
                .default(
                  fetchStateResponseStateAmendmentLogItemValueResourceTypeDefault,
                ),
              status: zod.enum(["Unknown", "Active", "Stopped", "Completed"]),
            }),
            zod.object({
              resource_type: zod
                .literal("condition")
                .default(
                  fetchStateResponseStateAmendmentLogItemValueResourceTypeDefaultOne,
                ),
              status: zod.enum(["Active", "Resolved", "Unknown"]),
            }),
            zod.object({
              resource_type: zod
                .literal("allergy")
                .default(
                  fetchStateResponseStateAmendmentLogItemValueResourceTypeDefaultTwo,
                ),
              status: zod.enum(["Unknown", "Inactive", "Active", "Resolved"]),
            }),
          ]),
          note: zod.union([zod.string(), zod.null()]).optional(),
          id: zod.uuid(),
          basis: zod.string(),
        })
        .describe(
          "A single patient-authored amendment; the ``CareStateT.amendment_log`` row.\n\nA stamped ``AmendmentBodyT``: the shared body (author\/row_ref\/value\/note +\nthe resource-type invariant) is inherited; this adds the two server-owned\nfields. Concrete (not a union) so the diff store can register it as a table\nand build its parcel schema. Keyed by the time-ordered ``id``, which doubles\nas the recency signal the overlay's ``resolve`` uses.",
        ),
    ),
  }),
  cursor: zod.number(),
});

/**
 * Apply updates to the care state.

Accepts a dictionary of updates keyed by client-provided update IDs.
Returns a dictionary of replies indicating whether each update was
accepted or rejected.
 * @summary Update State
 */
export const updateStateParams = zod.object({
  user_id: zod.uuid(),
});

export const updateStateBodyUpdatesTypeDefault = "create";
export const updateStateBodyUpdatesTypeDefaultOne = "update";
export const updateStateBodyUpdatesTypeDefaultTwo = "delete";

export const updateStateBody = zod.object({
  updates: zod.record(
    zod.string(),
    zod.union([
      zod.object({
        type: zod.literal("create").default(updateStateBodyUpdatesTypeDefault),
        table: zod.string(),
        row: zod.record(zod.string(), zod.unknown()),
      }),
      zod.object({
        type: zod
          .literal("update")
          .default(updateStateBodyUpdatesTypeDefaultOne),
        table: zod.string(),
        id: zod.string(),
        new_value: zod.record(zod.string(), zod.unknown()),
        conditional_old_value: zod.union([
          zod.record(zod.string(), zod.unknown()),
          zod.null(),
        ]),
      }),
      zod.object({
        type: zod
          .literal("delete")
          .default(updateStateBodyUpdatesTypeDefaultTwo),
        table: zod.string(),
        id: zod.string(),
        conditional_old_value: zod.union([
          zod.record(zod.string(), zod.unknown()),
          zod.null(),
        ]),
      }),
    ]),
  ),
});

export const updateStateResponseRepliesTypeDefault = "acceptedUpdate";
export const updateStateResponseRepliesTypeDefaultOne = "rejectedUpdate";

export const updateStateResponse = zod.object({
  replies: zod.record(
    zod.string(),
    zod.union([
      zod.object({
        type: zod
          .literal("acceptedUpdate")
          .default(updateStateResponseRepliesTypeDefault),
        cursor: zod.number(),
      }),
      zod.object({
        type: zod
          .literal("rejectedUpdate")
          .default(updateStateResponseRepliesTypeDefaultOne),
        reason: zod.string(),
      }),
    ]),
  ),
});

/**
 * Stream care state events as they come down.

Returns ping events when no data is available, and a disconnect
event before closing.
 * @summary Stream State Events
 */
export const streamStateEventsParams = zod.object({
  user_id: zod.uuid(),
});

export const streamStateEventsQueryParams = zod.object({
  cursor: zod.number(),
});

/**
 * Fetch the patient-facing CareState snapshot for an arbitrary patient.

Same projection as `GET /me/care-state/snapshot`, but the target patient
is supplied by path parameter so the BrainDataView "Care Plan" tab can
inspect any patient's view.
 * @summary Fetch Patient Facing Snapshot
 */
export const fetchPatientFacingSnapshotParams = zod.object({
  user_id: zod.uuid(),
});

export const fetchPatientFacingSnapshotResponseSnapshotPrescriptionsItemIsUrgentDefault = false;
export const fetchPatientFacingSnapshotResponseSnapshotPrescriptionsItemIsRenewalDefault = false;
export const fetchPatientFacingSnapshotResponseSnapshotFocusAreasDefault = [];
export const fetchPatientFacingSnapshotResponseSnapshotFollowUpsItemResponseInstrumentFormDefinitionFieldsItemSuggestedSubmissionTypeDefault =
  "string";
export const fetchPatientFacingSnapshotResponseSnapshotFollowUpsItemResponseInstrumentFormDefinitionFieldsItemSuggestedSubmissionTypeDefaultOne =
  "int";
export const fetchPatientFacingSnapshotResponseSnapshotFollowUpsItemResponseInstrumentFormDefinitionFieldsItemSuggestedSubmissionTypeDefaultTwo =
  "simple_address";
export const fetchPatientFacingSnapshotResponseSnapshotFollowUpsItemResponseInstrumentFormDefinitionFieldsItemSuggestedSubmissionTypeDefaultThree =
  "list";
export const fetchPatientFacingSnapshotResponseSnapshotFollowUpsItemResponseInstrumentFormDefinitionFieldsItemSuggestedSubmissionValuesItemTypeDefault =
  "string";
export const fetchPatientFacingSnapshotResponseSnapshotFollowUpsItemResponseInstrumentFormDefinitionFieldsItemSuggestedSubmissionValuesItemTypeDefaultOne =
  "int";
export const fetchPatientFacingSnapshotResponseSnapshotFollowUpsItemResponseInstrumentFormDefinitionFieldsItemSuggestedSubmissionValuesItemTypeDefaultTwo =
  "simple_address";
export const fetchPatientFacingSnapshotResponseSnapshotFollowUpsItemResponseInstrumentFormDefinitionFieldsItemDefaultSubmissionTypeDefault =
  "string";
export const fetchPatientFacingSnapshotResponseSnapshotFollowUpsItemResponseInstrumentFormDefinitionFieldsItemDefaultSubmissionTypeDefaultOne =
  "int";
export const fetchPatientFacingSnapshotResponseSnapshotFollowUpsItemResponseInstrumentFormDefinitionFieldsItemDefaultSubmissionTypeDefaultTwo =
  "simple_address";
export const fetchPatientFacingSnapshotResponseSnapshotFollowUpsItemResponseInstrumentFormDefinitionFieldsItemDefaultSubmissionTypeDefaultThree =
  "list";
export const fetchPatientFacingSnapshotResponseSnapshotFollowUpsItemResponseInstrumentFormDefinitionFieldsItemDefaultSubmissionValuesItemTypeDefault =
  "string";
export const fetchPatientFacingSnapshotResponseSnapshotFollowUpsItemResponseInstrumentFormDefinitionFieldsItemDefaultSubmissionValuesItemTypeDefaultOne =
  "int";
export const fetchPatientFacingSnapshotResponseSnapshotFollowUpsItemResponseInstrumentFormDefinitionFieldsItemDefaultSubmissionValuesItemTypeDefaultTwo =
  "simple_address";
export const fetchPatientFacingSnapshotResponseSnapshotFollowUpsItemResponseInstrumentFormDefinitionFieldsItemValidatorTypeDefault =
  "non_empty_string";
export const fetchPatientFacingSnapshotResponseSnapshotFollowUpsItemResponseInstrumentFormDefinitionFieldsItemValidatorTypeDefaultOne =
  "date";
export const fetchPatientFacingSnapshotResponseSnapshotFollowUpsItemResponseInstrumentFormDefinitionFieldsItemValidatorTypeDefaultTwo =
  "coded_choice";
export const fetchPatientFacingSnapshotResponseSnapshotFollowUpsItemResponseInstrumentFormDefinitionFieldsItemValidatorTypeDefaultThree =
  "phone_number";
export const fetchPatientFacingSnapshotResponseSnapshotFollowUpsItemResponseInstrumentFormDefinitionFieldsItemValidatorTypeDefaultFour =
  "email";
export const fetchPatientFacingSnapshotResponseSnapshotFollowUpsItemResponseInstrumentFormDefinitionFieldsItemValidatorTypeDefaultFive =
  "city_state_zip";
export const fetchPatientFacingSnapshotResponseSnapshotFollowUpsItemResponseInstrumentFormDefinitionFieldsItemValidatorTypeDefaultSix =
  "optional";
export const fetchPatientFacingSnapshotResponseSnapshotFollowUpsItemResponseInstrumentFormDefinitionFieldsItemValidatorRawValidatorTypeDefault =
  "non_empty_string";
export const fetchPatientFacingSnapshotResponseSnapshotFollowUpsItemResponseInstrumentFormDefinitionFieldsItemValidatorRawValidatorTypeDefaultOne =
  "date";
export const fetchPatientFacingSnapshotResponseSnapshotFollowUpsItemResponseInstrumentFormDefinitionFieldsItemValidatorRawValidatorTypeDefaultTwo =
  "coded_choice";
export const fetchPatientFacingSnapshotResponseSnapshotFollowUpsItemResponseInstrumentFormDefinitionFieldsItemValidatorRawValidatorTypeDefaultThree =
  "phone_number";
export const fetchPatientFacingSnapshotResponseSnapshotFollowUpsItemResponseInstrumentFormDefinitionFieldsItemValidatorRawValidatorTypeDefaultFour =
  "email";
export const fetchPatientFacingSnapshotResponseSnapshotFollowUpsItemResponseInstrumentFormDefinitionFieldsItemValidatorRawValidatorTypeDefaultFive =
  "city_state_zip";
export const fetchPatientFacingSnapshotResponseSnapshotFollowUpsItemResponseInstrumentFormDefinitionFieldsItemValidatorRawValidatorTypeDefaultSix =
  "list";
export const fetchPatientFacingSnapshotResponseSnapshotFollowUpsItemResponseInstrumentFormDefinitionFieldsItemValidatorRawValidatorRawValidatorTypeDefault =
  "non_empty_string";
export const fetchPatientFacingSnapshotResponseSnapshotFollowUpsItemResponseInstrumentFormDefinitionFieldsItemValidatorRawValidatorRawValidatorTypeDefaultOne =
  "date";
export const fetchPatientFacingSnapshotResponseSnapshotFollowUpsItemResponseInstrumentFormDefinitionFieldsItemValidatorRawValidatorRawValidatorTypeDefaultTwo =
  "coded_choice";
export const fetchPatientFacingSnapshotResponseSnapshotFollowUpsItemResponseInstrumentFormDefinitionFieldsItemValidatorRawValidatorRawValidatorTypeDefaultThree =
  "phone_number";
export const fetchPatientFacingSnapshotResponseSnapshotFollowUpsItemResponseInstrumentFormDefinitionFieldsItemValidatorRawValidatorRawValidatorTypeDefaultFour =
  "email";
export const fetchPatientFacingSnapshotResponseSnapshotFollowUpsItemResponseInstrumentFormDefinitionFieldsItemValidatorRawValidatorRawValidatorTypeDefaultFive =
  "city_state_zip";
export const fetchPatientFacingSnapshotResponseSnapshotFollowUpsItemResponseInstrumentFormDefinitionFieldsItemValidatorTypeDefaultSeven =
  "list";
export const fetchPatientFacingSnapshotResponseSnapshotFollowUpsItemResponseInstrumentFormDefinitionFieldsItemValidatorRawValidatorTypeDefaultSeven =
  "non_empty_string";
export const fetchPatientFacingSnapshotResponseSnapshotFollowUpsItemResponseInstrumentFormDefinitionFieldsItemValidatorRawValidatorTypeDefaultEight =
  "date";
export const fetchPatientFacingSnapshotResponseSnapshotFollowUpsItemResponseInstrumentFormDefinitionFieldsItemValidatorRawValidatorTypeDefaultNine =
  "coded_choice";
export const fetchPatientFacingSnapshotResponseSnapshotFollowUpsItemResponseInstrumentFormDefinitionFieldsItemValidatorRawValidatorTypeDefaultOnezero =
  "phone_number";
export const fetchPatientFacingSnapshotResponseSnapshotFollowUpsItemResponseInstrumentFormDefinitionFieldsItemValidatorRawValidatorTypeDefaultOneone =
  "email";
export const fetchPatientFacingSnapshotResponseSnapshotFollowUpsItemResponseInstrumentFormDefinitionFieldsItemValidatorRawValidatorTypeDefaultOnetwo =
  "city_state_zip";
export const fetchPatientFacingSnapshotResponseSnapshotFollowUpsItemResponseInstrumentFormDefinitionFieldsItemValidatorRawValidatorTypeDefaultOnethree =
  "optional";
export const fetchPatientFacingSnapshotResponseSnapshotFollowUpsItemResponseInstrumentFormDefinitionFieldsItemValidatorRawValidatorRawValidatorTypeDefaultSix =
  "non_empty_string";
export const fetchPatientFacingSnapshotResponseSnapshotFollowUpsItemResponseInstrumentFormDefinitionFieldsItemValidatorRawValidatorRawValidatorTypeDefaultSeven =
  "date";
export const fetchPatientFacingSnapshotResponseSnapshotFollowUpsItemResponseInstrumentFormDefinitionFieldsItemValidatorRawValidatorRawValidatorTypeDefaultEight =
  "coded_choice";
export const fetchPatientFacingSnapshotResponseSnapshotFollowUpsItemResponseInstrumentFormDefinitionFieldsItemValidatorRawValidatorRawValidatorTypeDefaultNine =
  "phone_number";
export const fetchPatientFacingSnapshotResponseSnapshotFollowUpsItemResponseInstrumentFormDefinitionFieldsItemValidatorRawValidatorRawValidatorTypeDefaultOnezero =
  "email";
export const fetchPatientFacingSnapshotResponseSnapshotFollowUpsItemResponseInstrumentFormDefinitionFieldsItemValidatorRawValidatorRawValidatorTypeDefaultOneone =
  "city_state_zip";
export const fetchPatientFacingSnapshotResponseSnapshotFollowUpsItemResponseInstrumentSubmissionsSubmissionsTypeDefault =
  "string";
export const fetchPatientFacingSnapshotResponseSnapshotFollowUpsItemResponseInstrumentSubmissionsSubmissionsTypeDefaultOne =
  "int";
export const fetchPatientFacingSnapshotResponseSnapshotFollowUpsItemResponseInstrumentSubmissionsSubmissionsTypeDefaultTwo =
  "simple_address";
export const fetchPatientFacingSnapshotResponseSnapshotFollowUpsItemResponseInstrumentSubmissionsSubmissionsTypeDefaultThree =
  "list";
export const fetchPatientFacingSnapshotResponseSnapshotFollowUpsItemResponseInstrumentSubmissionsSubmissionsValuesItemTypeDefault =
  "string";
export const fetchPatientFacingSnapshotResponseSnapshotFollowUpsItemResponseInstrumentSubmissionsSubmissionsValuesItemTypeDefaultOne =
  "int";
export const fetchPatientFacingSnapshotResponseSnapshotFollowUpsItemResponseInstrumentSubmissionsSubmissionsValuesItemTypeDefaultTwo =
  "simple_address";
export const fetchPatientFacingSnapshotResponseSnapshotFollowUpsDefault = [];

export const fetchPatientFacingSnapshotResponse = zod.object({
  snapshot: zod
    .object({
      requests: zod.array(
        zod
          .object({
            id: zod.uuid(),
            title: zod.string(),
            category: zod.union([
              zod
                .enum(["refill", "rx_change", "prior_auth", "general"])
                .describe("Category derived from `CareStateRequestKindT`."),
              zod.string(),
            ]),
            status: zod.union([
              zod
                .enum(["in_progress", "waiting_on_you", "complete"])
                .describe(
                  "Status derived from `CareStateRequestStatusT`.\n\nOnly requests in non-terminal states (OPEN, PENDING_FOLLOW_UP) appear in\nthe snapshot; terminal-status requests are filtered out by the converter.",
                ),
              zod.string(),
            ]),
            urgency: zod.union([
              zod
                .enum(["routine", "urgent"])
                .describe("Urgency derived from `CareStateRequestUrgencyT`."),
              zod.string(),
            ]),
            createdAt: zod.iso.datetime({}),
          })
          .describe("A request, projected for patient consumption."),
      ),
      prescriptions: zod.array(
        zod
          .object({
            id: zod.uuid(),
            displayName: zod.string(),
            pharmacyId: zod.union([zod.number(), zod.null()]).optional(),
            status: zod.union([
              zod
                .enum([
                  "draft",
                  "sent_to_pharmacy",
                  "pharmacy_issue",
                  "cancelled",
                  "unknown",
                ])
                .describe(
                  "Patient-actionable lifecycle bucket derived from DoseSpot status fields.\n\nThe raw `PrescriptionStatusT` from DoseSpot is too granular (and uses\ninsider labels like `EpcsSigned`, `eRxSent`) to surface directly. We\ncollapse it into five patient-meaningful buckets; `Unknown` is a\nforward-compat catch-all for new DoseSpot statuses we haven't classified.",
                ),
              zod.string(),
            ]),
            statusCopy: zod.string(),
            directions: zod.union([zod.string(), zod.null()]).optional(),
            quantity: zod.union([zod.string(), zod.null()]).optional(),
            refills: zod.union([zod.string(), zod.null()]).optional(),
            daysSupply: zod.union([zod.number(), zod.null()]).optional(),
            writtenAt: zod.union([zod.iso.datetime({}), zod.null()]).optional(),
            effectiveAt: zod
              .union([zod.iso.datetime({}), zod.null()])
              .optional(),
            lastFillAt: zod
              .union([zod.iso.datetime({}), zod.null()])
              .optional(),
            isUrgent: zod.boolean().optional(),
            isRenewal: zod.boolean().optional(),
          })
          .describe(
            "A prescription, projected for patient consumption.\n\nBacked by `CareStatePrescriptionT.cached_info` (the cached DoseSpot\n`PrescriptionT` payload). Raw DoseSpot identifiers (PrescriptionId,\nPrescriberId, etc.) are intentionally omitted; the patient only sees\nclinically meaningful, stable fields. `status_copy` is rendered\nserver-side so clients don't have to know about DoseSpot's lifecycle.\n\n`pharmacy_id` is the one DoseSpot identifier we do surface: it's already\na client-facing concept (the `\/app\/me\/pharmacy\/\*` endpoints take and\nreturn raw DoseSpot pharmacy ids), and the client resolves it to display\ndetails lazily via `GET \/app\/me\/pharmacy\/{pharmacy_id}`. We deliberately\ndo not inline the pharmacy's name\/address here: that would force the\nsnapshot read path to make a DoseSpot call per prescription, coupling a\nhot, I\/O-free projection to DoseSpot availability.",
          ),
      ),
      labOrders: zod.array(
        zod
          .object({
            id: zod.uuid(),
            displayName: zod.string(),
            labName: zod.union([zod.string(), zod.null()]).optional(),
            collectionMethod: zod
              .union([
                zod.enum([
                  "testkit",
                  "walk_in_test",
                  "at_home_phlebotomy",
                  "on_site_collection",
                ]),
                zod.null(),
              ])
              .optional(),
            status: zod.union([
              zod
                .enum([
                  "ordered",
                  "in_progress",
                  "results_ready",
                  "cancelled",
                  "issue",
                  "unknown",
                ])
                .describe(
                  "Patient-actionable status derived from the Junction lifecycle.\n\nRequisition readiness changes the copy shown for top-level ``received``.\nLater top-level states are reshaped for patient framing (e.g.\n``CollectingSample`` and ``SampleWithLab`` both become ``InProgress``).\n``Unknown`` is the forward-compat catch-all for upstream values.",
                ),
              zod.string(),
            ]),
            statusCopy: zod.string(),
            interpretation: zod
              .union([
                zod.union([
                  zod
                    .enum(["normal", "abnormal", "critical"])
                    .describe(
                      "Patient-visible result interpretation.\n\nOnly surfaced once results are ready; `OrderInterpretationT.Unknown` is\nintentionally collapsed to `None` upstream so pre-result interpretation\nnoise never reaches the patient.",
                    ),
                  zod.string(),
                ]),
                zod.null(),
              ])
              .optional(),
            interpretationCopy: zod
              .union([zod.string(), zod.null()])
              .optional(),
            orderedAt: zod.iso.datetime({}),
            updatedAt: zod.iso.datetime({}),
          })
          .describe(
            "A lab order projected for patient consumption.\n\nBacked by `CareStateLabOrderT`. Provider-specific identifiers\n(`remote_id`, `provider`, `version`) and the bulky `order_data.metadata`\npayload are deliberately omitted; only stable, clinically-meaningful\nfields are surfaced. `status_copy` \/ `interpretation_copy` are rendered\nserver-side so clients don't duplicate the strings.",
          ),
      ),
      carePlan: zod
        .union([
          zod
            .object({
              title: zod.string(),
              goal: zod.string(),
              progressNote: zod.string(),
              progressHighlights: zod.array(zod.string()),
              nextSteps: zod.string(),
              lastUpdatedAt: zod.iso.datetime({}),
              mentionableId: zod.union([zod.uuid(), zod.null()]).optional(),
            })
            .describe(
              "A patient's living Care Plan, projected for patient consumption.\n\nField-for-field re-declaration of the patient-facing slice of\n`CareStateCarePlanT`. `CarePlanContentT` happens to declare the same\ncontent fields, but `CarePlanContentT` is the LLM structured-output\nschema; we intentionally do not inherit from it so changes there\ndon't silently change the iOS wire shape (and vice versa). New\npatient-facing fields are added here deliberately and plumbed\nthrough `convert_care_plan`.",
            ),
          zod.null(),
        ])
        .optional(),
      focusAreas: zod
        .array(
          zod.union([
            zod
              .enum([
                "weight",
                "stress",
                "mood",
                "sleep_and_fatigue",
                "energy",
                "nutrition",
                "movement",
                "hormonal",
                "cycle",
                "fertility",
                "pregnancy_and_postpartum",
                "menopause",
                "hair_and_skin",
                "heart_health",
                "overall_health",
              ])
              .describe(
                "A patient-selected health focus area.\n\nSurfaced in iOS as the chips a patient picks before\/alongside the Care\nPlan. Patient-authored: the librarian and care-plan agent only read it.\n\nWomen's Health:\nWhere the name overlaps ``HealthAreaT`` (``care.menus.explore_health``) the wire\nvalue deliberately matches, so the two surfaces agree on one spelling.\n\nRemoving or renaming a value is a breaking change: the enum is open on\nreads (old iOS clients round-trip unknown strings) and strict on writes.",
              ),
            zod.string(),
          ]),
        )
        .default(fetchPatientFacingSnapshotResponseSnapshotFocusAreasDefault),
      followUps: zod
        .array(
          zod
            .object({
              id: zod.uuid(),
              title: zod.string(),
              contentToTransmit: zod.string(),
              responseInstrument: zod
                .union([
                  zod
                    .object({
                      instrumentId: zod.string(),
                      formDefinition: zod.object({
                        fields: zod.array(
                          zod.object({
                            id: zod.string(),
                            profile: zod.object({
                              name: zod.string(),
                              description: zod
                                .union([zod.string(), zod.null()])
                                .optional(),
                            }),
                            suggested_submission: zod
                              .union([
                                zod.union([
                                  zod.object({
                                    type: zod
                                      .literal("string")
                                      .default(
                                        fetchPatientFacingSnapshotResponseSnapshotFollowUpsItemResponseInstrumentFormDefinitionFieldsItemSuggestedSubmissionTypeDefault,
                                      ),
                                    value: zod.string(),
                                  }),
                                  zod.object({
                                    type: zod
                                      .literal("int")
                                      .default(
                                        fetchPatientFacingSnapshotResponseSnapshotFollowUpsItemResponseInstrumentFormDefinitionFieldsItemSuggestedSubmissionTypeDefaultOne,
                                      ),
                                    value: zod.number(),
                                  }),
                                  zod.object({
                                    type: zod
                                      .literal("simple_address")
                                      .default(
                                        fetchPatientFacingSnapshotResponseSnapshotFollowUpsItemResponseInstrumentFormDefinitionFieldsItemSuggestedSubmissionTypeDefaultTwo,
                                      ),
                                    street_address: zod.string(),
                                    city_state_zip: zod.string(),
                                  }),
                                  zod.object({
                                    type: zod
                                      .literal("list")
                                      .default(
                                        fetchPatientFacingSnapshotResponseSnapshotFollowUpsItemResponseInstrumentFormDefinitionFieldsItemSuggestedSubmissionTypeDefaultThree,
                                      ),
                                    values: zod.array(
                                      zod.union([
                                        zod.object({
                                          type: zod
                                            .literal("string")
                                            .default(
                                              fetchPatientFacingSnapshotResponseSnapshotFollowUpsItemResponseInstrumentFormDefinitionFieldsItemSuggestedSubmissionValuesItemTypeDefault,
                                            ),
                                          value: zod.string(),
                                        }),
                                        zod.object({
                                          type: zod
                                            .literal("int")
                                            .default(
                                              fetchPatientFacingSnapshotResponseSnapshotFollowUpsItemResponseInstrumentFormDefinitionFieldsItemSuggestedSubmissionValuesItemTypeDefaultOne,
                                            ),
                                          value: zod.number(),
                                        }),
                                        zod.object({
                                          type: zod
                                            .literal("simple_address")
                                            .default(
                                              fetchPatientFacingSnapshotResponseSnapshotFollowUpsItemResponseInstrumentFormDefinitionFieldsItemSuggestedSubmissionValuesItemTypeDefaultTwo,
                                            ),
                                          street_address: zod.string(),
                                          city_state_zip: zod.string(),
                                        }),
                                        zod.unknown(),
                                      ]),
                                    ),
                                  }),
                                ]),
                                zod.null(),
                              ])
                              .optional(),
                            default_submission: zod
                              .union([
                                zod.union([
                                  zod.object({
                                    type: zod
                                      .literal("string")
                                      .default(
                                        fetchPatientFacingSnapshotResponseSnapshotFollowUpsItemResponseInstrumentFormDefinitionFieldsItemDefaultSubmissionTypeDefault,
                                      ),
                                    value: zod.string(),
                                  }),
                                  zod.object({
                                    type: zod
                                      .literal("int")
                                      .default(
                                        fetchPatientFacingSnapshotResponseSnapshotFollowUpsItemResponseInstrumentFormDefinitionFieldsItemDefaultSubmissionTypeDefaultOne,
                                      ),
                                    value: zod.number(),
                                  }),
                                  zod.object({
                                    type: zod
                                      .literal("simple_address")
                                      .default(
                                        fetchPatientFacingSnapshotResponseSnapshotFollowUpsItemResponseInstrumentFormDefinitionFieldsItemDefaultSubmissionTypeDefaultTwo,
                                      ),
                                    street_address: zod.string(),
                                    city_state_zip: zod.string(),
                                  }),
                                  zod.object({
                                    type: zod
                                      .literal("list")
                                      .default(
                                        fetchPatientFacingSnapshotResponseSnapshotFollowUpsItemResponseInstrumentFormDefinitionFieldsItemDefaultSubmissionTypeDefaultThree,
                                      ),
                                    values: zod.array(
                                      zod.union([
                                        zod.object({
                                          type: zod
                                            .literal("string")
                                            .default(
                                              fetchPatientFacingSnapshotResponseSnapshotFollowUpsItemResponseInstrumentFormDefinitionFieldsItemDefaultSubmissionValuesItemTypeDefault,
                                            ),
                                          value: zod.string(),
                                        }),
                                        zod.object({
                                          type: zod
                                            .literal("int")
                                            .default(
                                              fetchPatientFacingSnapshotResponseSnapshotFollowUpsItemResponseInstrumentFormDefinitionFieldsItemDefaultSubmissionValuesItemTypeDefaultOne,
                                            ),
                                          value: zod.number(),
                                        }),
                                        zod.object({
                                          type: zod
                                            .literal("simple_address")
                                            .default(
                                              fetchPatientFacingSnapshotResponseSnapshotFollowUpsItemResponseInstrumentFormDefinitionFieldsItemDefaultSubmissionValuesItemTypeDefaultTwo,
                                            ),
                                          street_address: zod.string(),
                                          city_state_zip: zod.string(),
                                        }),
                                        zod.unknown(),
                                      ]),
                                    ),
                                  }),
                                ]),
                                zod.null(),
                              ])
                              .optional(),
                            validator: zod.union([
                              zod
                                .object({
                                  type: zod
                                    .literal("non_empty_string")
                                    .default(
                                      fetchPatientFacingSnapshotResponseSnapshotFollowUpsItemResponseInstrumentFormDefinitionFieldsItemValidatorTypeDefault,
                                    ),
                                })
                                .describe(
                                  "Validator that accepts arbitrary non-empty strings.",
                                ),
                              zod
                                .object({
                                  type: zod
                                    .literal("date")
                                    .default(
                                      fetchPatientFacingSnapshotResponseSnapshotFollowUpsItemResponseInstrumentFormDefinitionFieldsItemValidatorTypeDefaultOne,
                                    ),
                                })
                                .describe(
                                  "Validator that accepts arbitrary dates.",
                                ),
                              zod
                                .object({
                                  type: zod
                                    .literal("coded_choice")
                                    .default(
                                      fetchPatientFacingSnapshotResponseSnapshotFollowUpsItemResponseInstrumentFormDefinitionFieldsItemValidatorTypeDefaultTwo,
                                    ),
                                  options: zod.array(
                                    zod
                                      .object({
                                        code: zod.string(),
                                        display: zod.string(),
                                      })
                                      .describe(
                                        "An option from a list of choices.",
                                      ),
                                  ),
                                })
                                .describe(
                                  "Validator that accepts any option from a list of choices.",
                                ),
                              zod
                                .object({
                                  type: zod
                                    .literal("phone_number")
                                    .default(
                                      fetchPatientFacingSnapshotResponseSnapshotFollowUpsItemResponseInstrumentFormDefinitionFieldsItemValidatorTypeDefaultThree,
                                    ),
                                })
                                .describe(
                                  "Validator that accepts arbitrary phone numbers.",
                                ),
                              zod
                                .object({
                                  type: zod
                                    .literal("email")
                                    .default(
                                      fetchPatientFacingSnapshotResponseSnapshotFollowUpsItemResponseInstrumentFormDefinitionFieldsItemValidatorTypeDefaultFour,
                                    ),
                                })
                                .describe(
                                  "Validator that accepts arbitrary emails.",
                                ),
                              zod
                                .object({
                                  type: zod
                                    .literal("city_state_zip")
                                    .default(
                                      fetchPatientFacingSnapshotResponseSnapshotFollowUpsItemResponseInstrumentFormDefinitionFieldsItemValidatorTypeDefaultFive,
                                    ),
                                })
                                .describe(
                                  "Validator that accepts city, state, and ZIP code combinations.",
                                ),
                              zod
                                .object({
                                  type: zod
                                    .literal("optional")
                                    .default(
                                      fetchPatientFacingSnapshotResponseSnapshotFollowUpsItemResponseInstrumentFormDefinitionFieldsItemValidatorTypeDefaultSix,
                                    ),
                                  raw_validator: zod.union([
                                    zod
                                      .object({
                                        type: zod
                                          .literal("non_empty_string")
                                          .default(
                                            fetchPatientFacingSnapshotResponseSnapshotFollowUpsItemResponseInstrumentFormDefinitionFieldsItemValidatorRawValidatorTypeDefault,
                                          ),
                                      })
                                      .describe(
                                        "Validator that accepts arbitrary non-empty strings.",
                                      ),
                                    zod
                                      .object({
                                        type: zod
                                          .literal("date")
                                          .default(
                                            fetchPatientFacingSnapshotResponseSnapshotFollowUpsItemResponseInstrumentFormDefinitionFieldsItemValidatorRawValidatorTypeDefaultOne,
                                          ),
                                      })
                                      .describe(
                                        "Validator that accepts arbitrary dates.",
                                      ),
                                    zod
                                      .object({
                                        type: zod
                                          .literal("coded_choice")
                                          .default(
                                            fetchPatientFacingSnapshotResponseSnapshotFollowUpsItemResponseInstrumentFormDefinitionFieldsItemValidatorRawValidatorTypeDefaultTwo,
                                          ),
                                        options: zod.array(
                                          zod
                                            .object({
                                              code: zod.string(),
                                              display: zod.string(),
                                            })
                                            .describe(
                                              "An option from a list of choices.",
                                            ),
                                        ),
                                      })
                                      .describe(
                                        "Validator that accepts any option from a list of choices.",
                                      ),
                                    zod
                                      .object({
                                        type: zod
                                          .literal("phone_number")
                                          .default(
                                            fetchPatientFacingSnapshotResponseSnapshotFollowUpsItemResponseInstrumentFormDefinitionFieldsItemValidatorRawValidatorTypeDefaultThree,
                                          ),
                                      })
                                      .describe(
                                        "Validator that accepts arbitrary phone numbers.",
                                      ),
                                    zod
                                      .object({
                                        type: zod
                                          .literal("email")
                                          .default(
                                            fetchPatientFacingSnapshotResponseSnapshotFollowUpsItemResponseInstrumentFormDefinitionFieldsItemValidatorRawValidatorTypeDefaultFour,
                                          ),
                                      })
                                      .describe(
                                        "Validator that accepts arbitrary emails.",
                                      ),
                                    zod
                                      .object({
                                        type: zod
                                          .literal("city_state_zip")
                                          .default(
                                            fetchPatientFacingSnapshotResponseSnapshotFollowUpsItemResponseInstrumentFormDefinitionFieldsItemValidatorRawValidatorTypeDefaultFive,
                                          ),
                                      })
                                      .describe(
                                        "Validator that accepts city, state, and ZIP code combinations.",
                                      ),
                                    zod.unknown(),
                                    zod
                                      .object({
                                        type: zod
                                          .literal("list")
                                          .default(
                                            fetchPatientFacingSnapshotResponseSnapshotFollowUpsItemResponseInstrumentFormDefinitionFieldsItemValidatorRawValidatorTypeDefaultSix,
                                          ),
                                        raw_validator: zod.union([
                                          zod
                                            .object({
                                              type: zod
                                                .literal("non_empty_string")
                                                .default(
                                                  fetchPatientFacingSnapshotResponseSnapshotFollowUpsItemResponseInstrumentFormDefinitionFieldsItemValidatorRawValidatorRawValidatorTypeDefault,
                                                ),
                                            })
                                            .describe(
                                              "Validator that accepts arbitrary non-empty strings.",
                                            ),
                                          zod
                                            .object({
                                              type: zod
                                                .literal("date")
                                                .default(
                                                  fetchPatientFacingSnapshotResponseSnapshotFollowUpsItemResponseInstrumentFormDefinitionFieldsItemValidatorRawValidatorRawValidatorTypeDefaultOne,
                                                ),
                                            })
                                            .describe(
                                              "Validator that accepts arbitrary dates.",
                                            ),
                                          zod
                                            .object({
                                              type: zod
                                                .literal("coded_choice")
                                                .default(
                                                  fetchPatientFacingSnapshotResponseSnapshotFollowUpsItemResponseInstrumentFormDefinitionFieldsItemValidatorRawValidatorRawValidatorTypeDefaultTwo,
                                                ),
                                              options: zod.array(
                                                zod
                                                  .object({
                                                    code: zod.string(),
                                                    display: zod.string(),
                                                  })
                                                  .describe(
                                                    "An option from a list of choices.",
                                                  ),
                                              ),
                                            })
                                            .describe(
                                              "Validator that accepts any option from a list of choices.",
                                            ),
                                          zod
                                            .object({
                                              type: zod
                                                .literal("phone_number")
                                                .default(
                                                  fetchPatientFacingSnapshotResponseSnapshotFollowUpsItemResponseInstrumentFormDefinitionFieldsItemValidatorRawValidatorRawValidatorTypeDefaultThree,
                                                ),
                                            })
                                            .describe(
                                              "Validator that accepts arbitrary phone numbers.",
                                            ),
                                          zod
                                            .object({
                                              type: zod
                                                .literal("email")
                                                .default(
                                                  fetchPatientFacingSnapshotResponseSnapshotFollowUpsItemResponseInstrumentFormDefinitionFieldsItemValidatorRawValidatorRawValidatorTypeDefaultFour,
                                                ),
                                            })
                                            .describe(
                                              "Validator that accepts arbitrary emails.",
                                            ),
                                          zod
                                            .object({
                                              type: zod
                                                .literal("city_state_zip")
                                                .default(
                                                  fetchPatientFacingSnapshotResponseSnapshotFollowUpsItemResponseInstrumentFormDefinitionFieldsItemValidatorRawValidatorRawValidatorTypeDefaultFive,
                                                ),
                                            })
                                            .describe(
                                              "Validator that accepts city, state, and ZIP code combinations.",
                                            ),
                                          zod.unknown(),
                                          zod.unknown(),
                                        ]),
                                      })
                                      .describe(
                                        "Validator that accepts lists of items.",
                                      ),
                                  ]),
                                })
                                .describe(
                                  "Validator that accepts optional fields.",
                                ),
                              zod
                                .object({
                                  type: zod
                                    .literal("list")
                                    .default(
                                      fetchPatientFacingSnapshotResponseSnapshotFollowUpsItemResponseInstrumentFormDefinitionFieldsItemValidatorTypeDefaultSeven,
                                    ),
                                  raw_validator: zod.union([
                                    zod
                                      .object({
                                        type: zod
                                          .literal("non_empty_string")
                                          .default(
                                            fetchPatientFacingSnapshotResponseSnapshotFollowUpsItemResponseInstrumentFormDefinitionFieldsItemValidatorRawValidatorTypeDefaultSeven,
                                          ),
                                      })
                                      .describe(
                                        "Validator that accepts arbitrary non-empty strings.",
                                      ),
                                    zod
                                      .object({
                                        type: zod
                                          .literal("date")
                                          .default(
                                            fetchPatientFacingSnapshotResponseSnapshotFollowUpsItemResponseInstrumentFormDefinitionFieldsItemValidatorRawValidatorTypeDefaultEight,
                                          ),
                                      })
                                      .describe(
                                        "Validator that accepts arbitrary dates.",
                                      ),
                                    zod
                                      .object({
                                        type: zod
                                          .literal("coded_choice")
                                          .default(
                                            fetchPatientFacingSnapshotResponseSnapshotFollowUpsItemResponseInstrumentFormDefinitionFieldsItemValidatorRawValidatorTypeDefaultNine,
                                          ),
                                        options: zod.array(
                                          zod
                                            .object({
                                              code: zod.string(),
                                              display: zod.string(),
                                            })
                                            .describe(
                                              "An option from a list of choices.",
                                            ),
                                        ),
                                      })
                                      .describe(
                                        "Validator that accepts any option from a list of choices.",
                                      ),
                                    zod
                                      .object({
                                        type: zod
                                          .literal("phone_number")
                                          .default(
                                            fetchPatientFacingSnapshotResponseSnapshotFollowUpsItemResponseInstrumentFormDefinitionFieldsItemValidatorRawValidatorTypeDefaultOnezero,
                                          ),
                                      })
                                      .describe(
                                        "Validator that accepts arbitrary phone numbers.",
                                      ),
                                    zod
                                      .object({
                                        type: zod
                                          .literal("email")
                                          .default(
                                            fetchPatientFacingSnapshotResponseSnapshotFollowUpsItemResponseInstrumentFormDefinitionFieldsItemValidatorRawValidatorTypeDefaultOneone,
                                          ),
                                      })
                                      .describe(
                                        "Validator that accepts arbitrary emails.",
                                      ),
                                    zod
                                      .object({
                                        type: zod
                                          .literal("city_state_zip")
                                          .default(
                                            fetchPatientFacingSnapshotResponseSnapshotFollowUpsItemResponseInstrumentFormDefinitionFieldsItemValidatorRawValidatorTypeDefaultOnetwo,
                                          ),
                                      })
                                      .describe(
                                        "Validator that accepts city, state, and ZIP code combinations.",
                                      ),
                                    zod
                                      .object({
                                        type: zod
                                          .literal("optional")
                                          .default(
                                            fetchPatientFacingSnapshotResponseSnapshotFollowUpsItemResponseInstrumentFormDefinitionFieldsItemValidatorRawValidatorTypeDefaultOnethree,
                                          ),
                                        raw_validator: zod.union([
                                          zod
                                            .object({
                                              type: zod
                                                .literal("non_empty_string")
                                                .default(
                                                  fetchPatientFacingSnapshotResponseSnapshotFollowUpsItemResponseInstrumentFormDefinitionFieldsItemValidatorRawValidatorRawValidatorTypeDefaultSix,
                                                ),
                                            })
                                            .describe(
                                              "Validator that accepts arbitrary non-empty strings.",
                                            ),
                                          zod
                                            .object({
                                              type: zod
                                                .literal("date")
                                                .default(
                                                  fetchPatientFacingSnapshotResponseSnapshotFollowUpsItemResponseInstrumentFormDefinitionFieldsItemValidatorRawValidatorRawValidatorTypeDefaultSeven,
                                                ),
                                            })
                                            .describe(
                                              "Validator that accepts arbitrary dates.",
                                            ),
                                          zod
                                            .object({
                                              type: zod
                                                .literal("coded_choice")
                                                .default(
                                                  fetchPatientFacingSnapshotResponseSnapshotFollowUpsItemResponseInstrumentFormDefinitionFieldsItemValidatorRawValidatorRawValidatorTypeDefaultEight,
                                                ),
                                              options: zod.array(
                                                zod
                                                  .object({
                                                    code: zod.string(),
                                                    display: zod.string(),
                                                  })
                                                  .describe(
                                                    "An option from a list of choices.",
                                                  ),
                                              ),
                                            })
                                            .describe(
                                              "Validator that accepts any option from a list of choices.",
                                            ),
                                          zod
                                            .object({
                                              type: zod
                                                .literal("phone_number")
                                                .default(
                                                  fetchPatientFacingSnapshotResponseSnapshotFollowUpsItemResponseInstrumentFormDefinitionFieldsItemValidatorRawValidatorRawValidatorTypeDefaultNine,
                                                ),
                                            })
                                            .describe(
                                              "Validator that accepts arbitrary phone numbers.",
                                            ),
                                          zod
                                            .object({
                                              type: zod
                                                .literal("email")
                                                .default(
                                                  fetchPatientFacingSnapshotResponseSnapshotFollowUpsItemResponseInstrumentFormDefinitionFieldsItemValidatorRawValidatorRawValidatorTypeDefaultOnezero,
                                                ),
                                            })
                                            .describe(
                                              "Validator that accepts arbitrary emails.",
                                            ),
                                          zod
                                            .object({
                                              type: zod
                                                .literal("city_state_zip")
                                                .default(
                                                  fetchPatientFacingSnapshotResponseSnapshotFollowUpsItemResponseInstrumentFormDefinitionFieldsItemValidatorRawValidatorRawValidatorTypeDefaultOneone,
                                                ),
                                            })
                                            .describe(
                                              "Validator that accepts city, state, and ZIP code combinations.",
                                            ),
                                          zod.unknown(),
                                          zod.unknown(),
                                        ]),
                                      })
                                      .describe(
                                        "Validator that accepts optional fields.",
                                      ),
                                    zod.unknown(),
                                  ]),
                                })
                                .describe(
                                  "Validator that accepts lists of items.",
                                ),
                            ]),
                          }),
                        ),
                      }),
                      submissions: zod.object({
                        submissions: zod.record(
                          zod.string(),
                          zod.union([
                            zod.object({
                              type: zod
                                .literal("string")
                                .default(
                                  fetchPatientFacingSnapshotResponseSnapshotFollowUpsItemResponseInstrumentSubmissionsSubmissionsTypeDefault,
                                ),
                              value: zod.string(),
                            }),
                            zod.object({
                              type: zod
                                .literal("int")
                                .default(
                                  fetchPatientFacingSnapshotResponseSnapshotFollowUpsItemResponseInstrumentSubmissionsSubmissionsTypeDefaultOne,
                                ),
                              value: zod.number(),
                            }),
                            zod.object({
                              type: zod
                                .literal("simple_address")
                                .default(
                                  fetchPatientFacingSnapshotResponseSnapshotFollowUpsItemResponseInstrumentSubmissionsSubmissionsTypeDefaultTwo,
                                ),
                              street_address: zod.string(),
                              city_state_zip: zod.string(),
                            }),
                            zod.object({
                              type: zod
                                .literal("list")
                                .default(
                                  fetchPatientFacingSnapshotResponseSnapshotFollowUpsItemResponseInstrumentSubmissionsSubmissionsTypeDefaultThree,
                                ),
                              values: zod.array(
                                zod.union([
                                  zod.object({
                                    type: zod
                                      .literal("string")
                                      .default(
                                        fetchPatientFacingSnapshotResponseSnapshotFollowUpsItemResponseInstrumentSubmissionsSubmissionsValuesItemTypeDefault,
                                      ),
                                    value: zod.string(),
                                  }),
                                  zod.object({
                                    type: zod
                                      .literal("int")
                                      .default(
                                        fetchPatientFacingSnapshotResponseSnapshotFollowUpsItemResponseInstrumentSubmissionsSubmissionsValuesItemTypeDefaultOne,
                                      ),
                                    value: zod.number(),
                                  }),
                                  zod.object({
                                    type: zod
                                      .literal("simple_address")
                                      .default(
                                        fetchPatientFacingSnapshotResponseSnapshotFollowUpsItemResponseInstrumentSubmissionsSubmissionsValuesItemTypeDefaultTwo,
                                      ),
                                    street_address: zod.string(),
                                    city_state_zip: zod.string(),
                                  }),
                                  zod.unknown(),
                                ]),
                              ),
                            }),
                          ]),
                        ),
                      }),
                      problems: zod.record(zod.string(), zod.string()),
                      interpretation: zod
                        .union([
                          zod.object({
                            type: zod.enum(["complete", "incomplete", "error"]),
                            text: zod.string(),
                          }),
                          zod.null(),
                        ])
                        .optional(),
                    })
                    .describe(
                      "Patient-facing instrument session snapshot.\n\nMirrors the fields iOS needs from `InstrumentSessionT` without forcing\nthe internal model's required-nullable schema into Apple OpenAPI.",
                    ),
                  zod.null(),
                ])
                .optional(),
              status: zod.enum([
                "Pending",
                "Awaiting Response from Patient",
                "Response Received from Patient",
              ]),
              mentionableId: zod.union([zod.uuid(), zod.null()]).optional(),
            })
            .describe("A follow-up request projected for patient consumption."),
        )
        .default(fetchPatientFacingSnapshotResponseSnapshotFollowUpsDefault),
    })
    .describe("Full patient-facing Care State snapshot for Phase 0."),
});

/**
 * Fetch the patient-facing CareState timeline for an arbitrary patient.

Same projection as `GET /me/care-state/timeline`. The viewing clinician
is used as the identity for the readonly fetch and as the scope for
batch-resolving identity display names.
 * @summary Fetch Patient Facing Timeline
 */
export const fetchPatientFacingTimelineParams = zod.object({
  user_id: zod.uuid(),
});

export const fetchPatientFacingTimelineQueryLimitDefault = 50;

export const fetchPatientFacingTimelineQueryParams = zod.object({
  limit: zod.number().default(fetchPatientFacingTimelineQueryLimitDefault),
  before_cursor: zod.union([zod.uuid(), zod.null()]).optional(),
  after_cursor: zod.union([zod.uuid(), zod.null()]).optional(),
});

export const fetchPatientFacingTimelineResponseEventsItemActorTypeDefault =
  "clinician";
export const fetchPatientFacingTimelineResponseEventsItemActorTypeDefaultOne =
  "lotus_ai";
export const fetchPatientFacingTimelineResponseEventsItemUniqueTypeDefault =
  "request_created";
export const fetchPatientFacingTimelineResponseEventsItemUniqueTypeDefaultOne =
  "request_sent_for_follow_up";
export const fetchPatientFacingTimelineResponseEventsItemUniqueTypeDefaultTwo =
  "request_awaiting_response_cleared";
export const fetchPatientFacingTimelineResponseEventsItemUniqueTypeDefaultThree =
  "request_resolved";
export const fetchPatientFacingTimelineResponseEventsItemUniqueTypeDefaultFour =
  "request_cancelled";
export const fetchPatientFacingTimelineResponseEventsItemUniqueTypeDefaultFive =
  "request_urgency_changed";
export const fetchPatientFacingTimelineResponseEventsItemUniqueTypeDefaultSix =
  "prior_auth_approved";
export const fetchPatientFacingTimelineResponseEventsItemUniqueTypeDefaultSeven =
  "prior_auth_denied";
export const fetchPatientFacingTimelineResponseEventsItemUniqueTypeDefaultEight =
  "prior_auth_sent_to_pharmacy";
export const fetchPatientFacingTimelineResponseEventsItemUniqueTypeDefaultNine =
  "prescription_created";
export const fetchPatientFacingTimelineResponseEventsItemUniqueTypeDefaultOnezero =
  "prescription_sent_to_pharmacy";
export const fetchPatientFacingTimelineResponseEventsItemUniqueTypeDefaultOneone =
  "prescription_issue";
export const fetchPatientFacingTimelineResponseEventsItemUniqueTypeDefaultOnetwo =
  "prescription_cancelled";
export const fetchPatientFacingTimelineResponseEventsItemUniqueTypeDefaultOnethree =
  "lab_order_ordered";
export const fetchPatientFacingTimelineResponseEventsItemUniqueTypeDefaultOnefour =
  "lab_order_in_progress";
export const fetchPatientFacingTimelineResponseEventsItemUniqueTypeDefaultOnefive =
  "lab_order_results_ready";
export const fetchPatientFacingTimelineResponseEventsItemUniqueTypeDefaultOnesix =
  "lab_order_critical_result";
export const fetchPatientFacingTimelineResponseEventsItemUniqueTypeDefaultOneseven =
  "lab_order_issue";
export const fetchPatientFacingTimelineResponseEventsItemUniqueTypeDefaultOneeight =
  "lab_order_cancelled";

export const fetchPatientFacingTimelineResponse = zod.object({
  events: zod.array(
    zod
      .object({
        id: zod.uuid(),
        when: zod.iso.datetime({}),
        actor: zod.union([
          zod.union([
            zod
              .object({
                type: zod
                  .literal("clinician")
                  .default(
                    fetchPatientFacingTimelineResponseEventsItemActorTypeDefault,
                  ),
                displayName: zod.string(),
              })
              .describe("A named clinician (display name surfaced)."),
            zod
              .object({
                type: zod
                  .literal("lotus_ai")
                  .default(
                    fetchPatientFacingTimelineResponseEventsItemActorTypeDefaultOne,
                  ),
              })
              .describe(
                "The Lotus AI \/ system actor (collapses Librarian, automations, etc.).",
              ),
          ]),
          zod.unknown(),
        ]),
        copy: zod.string(),
        unique: zod.union([
          zod.union([
            zod.object({
              type: zod
                .literal("request_created")
                .default(
                  fetchPatientFacingTimelineResponseEventsItemUniqueTypeDefault,
                ),
            }),
            zod.object({
              type: zod
                .literal("request_sent_for_follow_up")
                .default(
                  fetchPatientFacingTimelineResponseEventsItemUniqueTypeDefaultOne,
                ),
            }),
            zod.object({
              type: zod
                .literal("request_awaiting_response_cleared")
                .default(
                  fetchPatientFacingTimelineResponseEventsItemUniqueTypeDefaultTwo,
                ),
            }),
            zod.object({
              type: zod
                .literal("request_resolved")
                .default(
                  fetchPatientFacingTimelineResponseEventsItemUniqueTypeDefaultThree,
                ),
            }),
            zod.object({
              type: zod
                .literal("request_cancelled")
                .default(
                  fetchPatientFacingTimelineResponseEventsItemUniqueTypeDefaultFour,
                ),
            }),
            zod.object({
              type: zod
                .literal("request_urgency_changed")
                .default(
                  fetchPatientFacingTimelineResponseEventsItemUniqueTypeDefaultFive,
                ),
              newUrgency: zod.union([
                zod
                  .enum(["routine", "urgent"])
                  .describe("Urgency derived from `CareStateRequestUrgencyT`."),
                zod.string(),
              ]),
            }),
            zod.object({
              type: zod
                .literal("prior_auth_approved")
                .default(
                  fetchPatientFacingTimelineResponseEventsItemUniqueTypeDefaultSix,
                ),
            }),
            zod.object({
              type: zod
                .literal("prior_auth_denied")
                .default(
                  fetchPatientFacingTimelineResponseEventsItemUniqueTypeDefaultSeven,
                ),
              denialReason: zod.union([zod.string(), zod.null()]).optional(),
            }),
            zod.object({
              type: zod
                .literal("prior_auth_sent_to_pharmacy")
                .default(
                  fetchPatientFacingTimelineResponseEventsItemUniqueTypeDefaultEight,
                ),
            }),
            zod
              .object({
                type: zod
                  .literal("prescription_created")
                  .default(
                    fetchPatientFacingTimelineResponseEventsItemUniqueTypeDefaultNine,
                  ),
                prescriptionId: zod.uuid(),
              })
              .describe(
                "Fired the first time a prescription row gains a `cached_info` payload.\n\nCarries `prescription_id` (the Care State row id) so clients can deep-link\nback to the snapshot card.",
              ),
            zod.object({
              type: zod
                .literal("prescription_sent_to_pharmacy")
                .default(
                  fetchPatientFacingTimelineResponseEventsItemUniqueTypeDefaultOnezero,
                ),
              prescriptionId: zod.uuid(),
            }),
            zod.object({
              type: zod
                .literal("prescription_issue")
                .default(
                  fetchPatientFacingTimelineResponseEventsItemUniqueTypeDefaultOneone,
                ),
              prescriptionId: zod.uuid(),
            }),
            zod.object({
              type: zod
                .literal("prescription_cancelled")
                .default(
                  fetchPatientFacingTimelineResponseEventsItemUniqueTypeDefaultOnetwo,
                ),
              prescriptionId: zod.uuid(),
            }),
            zod
              .object({
                type: zod
                  .literal("lab_order_ordered")
                  .default(
                    fetchPatientFacingTimelineResponseEventsItemUniqueTypeDefaultOnethree,
                  ),
                labOrderId: zod.uuid(),
              })
              .describe(
                "Fired the first time a lab order row appears in the audit log.\n\nCarries `lab_order_id` (the Care State row id) so clients can deep-link\nback to the snapshot card.",
              ),
            zod.object({
              type: zod
                .literal("lab_order_in_progress")
                .default(
                  fetchPatientFacingTimelineResponseEventsItemUniqueTypeDefaultOnefour,
                ),
              labOrderId: zod.uuid(),
            }),
            zod.object({
              type: zod
                .literal("lab_order_results_ready")
                .default(
                  fetchPatientFacingTimelineResponseEventsItemUniqueTypeDefaultOnefive,
                ),
              labOrderId: zod.uuid(),
            }),
            zod
              .object({
                type: zod
                  .literal("lab_order_critical_result")
                  .default(
                    fetchPatientFacingTimelineResponseEventsItemUniqueTypeDefaultOnesix,
                  ),
                labOrderId: zod.uuid(),
              })
              .describe(
                "Fired when results are ready and interpretation transitions to Critical.\n\nDistinct from `LabOrderResultsReadyUniqueT`: both may fire on the same\nunderlying event if results land Critical on the very first read.",
              ),
            zod.object({
              type: zod
                .literal("lab_order_issue")
                .default(
                  fetchPatientFacingTimelineResponseEventsItemUniqueTypeDefaultOneseven,
                ),
              labOrderId: zod.uuid(),
            }),
            zod.object({
              type: zod
                .literal("lab_order_cancelled")
                .default(
                  fetchPatientFacingTimelineResponseEventsItemUniqueTypeDefaultOneeight,
                ),
              labOrderId: zod.uuid(),
            }),
          ]),
          zod.unknown(),
        ]),
      })
      .describe(
        "A single patient-facing timeline event.\n\nOne internal `InternalCareStateRowUpdatedEventT` may produce zero, one,\nor many of these (the recognizer decides). Multiple events sharing the\nsame `id` is allowed when a single internal event satisfies multiple\nrecognizers; clients differentiate them via `unique.type`.",
      ),
  ),
  beforeCursor: zod.union([zod.uuid(), zod.null()]).optional(),
  afterCursor: zod.union([zod.uuid(), zod.null()]).optional(),
});

/**
 * Fetch the care state timeline for a patient.

Returns a paginated list of human-readable timeline events describing
changes to the care state, such as "<identity> updated <row> in <table>".
 * @summary Fetch Timeline
 */
export const fetchTimelineParams = zod.object({
  user_id: zod.uuid(),
});

export const fetchTimelineQueryLimitDefault = 50;

export const fetchTimelineQueryParams = zod.object({
  limit: zod.number().default(fetchTimelineQueryLimitDefault),
  before_cursor: zod.union([zod.uuid(), zod.null()]).optional(),
  after_cursor: zod.union([zod.uuid(), zod.null()]).optional(),
});

export const fetchTimelineResponseEventsItemContextIdentityTypeDefault =
  "clinician";
export const fetchTimelineResponseEventsItemContextIdentityTypeDefaultOne =
  "system";

export const fetchTimelineResponse = zod.object({
  events: zod.array(
    zod
      .object({
        context: zod.object({
          identity: zod.union([
            zod.object({
              type: zod
                .literal("clinician")
                .default(
                  fetchTimelineResponseEventsItemContextIdentityTypeDefault,
                ),
              clinician_id: zod.string(),
            }),
            zod
              .object({
                type: zod
                  .literal("system")
                  .default(
                    fetchTimelineResponseEventsItemContextIdentityTypeDefaultOne,
                  ),
                source: zod.string(),
              })
              .describe(
                "Identity for system-initiated updates to the care state.\nUsed when automated processes (like clinician escalations) need to\nmodify the care state without a specific clinician acting.",
              ),
          ]),
          table: zod.string(),
          row: zod.string(),
        }),
        identity_display: zod.string(),
        when: zod.iso.datetime({}),
        message: zod.string(),
        structured_events: zod.object({}),
      })
      .describe(
        "A public timeline event representing, in some friendly format\n\nMultiple updates can be consolidated if they occur within an hour\nand share the same identity, row, and table.",
      ),
  ),
  beforeCursor: zod.union([zod.uuid(), zod.null()]),
  afterCursor: zod.union([zod.uuid(), zod.null()]),
});

/**
 * Fetch the caller's reviewable PHR rows, grouped by resource type.

``empty`` when the PHR is not built yet or holds nothing amendable; the
client treats both the same. Reads the caller's preferred PHR implementation
so the review matches what the rest of the app shows.
 * @summary Fetch My Phr Review
 */
export const fetchMyPhrReviewResponseReviewStatusDefault = "ready";

export const fetchMyPhrReviewResponseReviewStatusDefaultOne = "empty";

export const fetchMyPhrReviewResponse = zod.object({
  review: zod.union([
    zod
      .object({
        status: zod
          .literal("ready")
          .default(fetchMyPhrReviewResponseReviewStatusDefault),
        sections: zod
          .array(
            zod
              .object({
                resource_type: zod.union([
                  zod.enum(["medication", "condition", "allergy"]),
                  zod.string(),
                ]),
                display_title: zod.string(),
                rows: zod
                  .array(
                    zod
                      .object({
                        ref: zod
                          .object({
                            resource_type: zod.union([
                              zod.enum(["medication", "condition", "allergy"]),
                              zod.string(),
                            ]),
                            origin_ids: zod.array(zod.string()),
                            display_name: zod.string(),
                          })
                          .describe(
                            "A stable, submittable reference to a PHR row.\n\nThe overlay joins on ``(resource_type, origin_id)`` for every origin_id, so\none ref can match a row that was reconciled\/merged from several source FHIR\nresources. ``display_name`` is carried for audit\/display only and never\nparticipates in the join.",
                          ),
                        display_name: zod.string(),
                        options: zod.array(
                          zod.enum(["negate", "unsure", "affirm"]),
                        ),
                        selected: zod
                          .union([
                            zod.enum(["negate", "unsure", "affirm"]),
                            zod.null(),
                          ])
                          .optional(),
                      })
                      .describe(
                        "One reviewable PHR row: its identity, copy, offered intents, and the\nintent currently in effect.\n\n``ref`` is opaque to the client and echoed back verbatim on write.\n``selected`` is ``None`` when the row's current status maps to no offered\nintent (pristine \/ nothing highlighted); it defaults to ``None`` so the\nnullable field is emitted as an optional (not required-and-nullable, which\nswift-openapi-generator rejects). Rows without a stable write target are\nomitted upstream, so ``options`` is always non-empty here.",
                      ),
                  )
                  .min(1),
              })
              .describe(
                "The reviewable rows for a single resource type.\n\n``resource_type`` is the stable machine key (grouping \/ analytics);\n``display_title`` is the server-owned header copy so the client never\nhardcodes section labels.",
              ),
          )
          .min(1),
      })
      .describe(
        "The PHR has at least one reviewable row. ``sections`` is non-empty.",
      ),
    zod
      .object({
        status: zod
          .literal("empty")
          .default(fetchMyPhrReviewResponseReviewStatusDefaultOne),
      })
      .describe(
        "Nothing to review: either the PHR is not built yet or it holds no\namendable rows. Readiness is the caller's concern, so both collapse here.",
      ),
  ]),
});

/**
 * Record one tapped intent against a reviewed row.

The server stamps ``author="patient"`` and derives the clinical value from
``ref.resource_type`` + ``intent`` -- neither is accepted from the client. A
rejection (e.g. the row's EHR evidence changed) comes back as a ``rejected``
result, not an HTTP error, so the client can re-fetch and re-prompt.
 * @summary Submit My Phr Amendment
 */
export const submitMyPhrAmendmentBody = zod
  .object({
    ref: zod
      .object({
        resource_type: zod.union([
          zod.enum(["medication", "condition", "allergy"]),
          zod.string(),
        ]),
        origin_ids: zod.array(zod.string()),
        display_name: zod.string(),
      })
      .describe(
        "A stable, submittable reference to a PHR row.\n\nThe overlay joins on ``(resource_type, origin_id)`` for every origin_id, so\none ref can match a row that was reconciled\/merged from several source FHIR\nresources. ``display_name`` is carried for audit\/display only and never\nparticipates in the join.",
      ),
    intent: zod.enum(["negate", "unsure", "affirm"]),
  })
  .describe(
    'A single tap: amend the referenced row to the chosen intent.\n\nThe author is never accepted from the client (the server stamps\n``\"patient\"``), and the clinical value is derived server-side from\n``ref.resource_type`` + ``intent`` -- so neither appears here.',
  );

export const submitMyPhrAmendmentResponseResultOutcomeDefault = "recorded";
export const submitMyPhrAmendmentResponseResultOutcomeDefaultOne = "rejected";

export const submitMyPhrAmendmentResponse = zod.object({
  result: zod.union([
    zod.object({
      outcome: zod
        .literal("recorded")
        .default(submitMyPhrAmendmentResponseResultOutcomeDefault),
    }),
    zod
      .object({
        outcome: zod
          .literal("rejected")
          .default(submitMyPhrAmendmentResponseResultOutcomeDefaultOne),
        reason: zod.enum(["stale_basis", "actor_not_allowed"]),
      })
      .describe(
        "The amendment was not applied; ``reason`` says why (e.g. the referenced\nrow's EHR evidence changed, so the correction no longer has a live basis).",
      ),
  ]),
});

/**
 * Search for available lab tests.

Returns a list of lab tests that can be ordered based on the
provided search criteria. Results include AOE question schemas
when applicable.
 * @summary Search Lab Tests
 */
export const searchLabTestsBody = zod
  .object({
    name: zod.union([zod.string(), zod.null()]).optional(),
    sampleType: zod
      .union([
        zod.enum([
          "dried_blood_spot",
          "arm_collector",
          "serum",
          "saliva",
          "urine",
        ]),
        zod.null(),
      ])
      .optional(),
    method: zod
      .union([
        zod.enum([
          "testkit",
          "walk_in_test",
          "at_home_phlebotomy",
          "on_site_collection",
        ]),
        zod.null(),
      ])
      .optional(),
  })
  .describe("Request to search for available lab tests.");

export const searchLabTestsResponseLabTestsItemMarkersItemMetadataProviderDefault =
  "vital";
export const searchLabTestsResponseLabTestsItemMarkersItemMetadataALaCarteEnabledDefault = false;
export const searchLabTestsResponseLabTestsItemMetadataProviderDefault =
  "vital";

export const searchLabTestsResponse = zod
  .object({
    labTests: zod.array(
      zod.object({
        id: zod.string(),
        name: zod.string(),
        sample_type: zod.enum([
          "dried_blood_spot",
          "arm_collector",
          "serum",
          "saliva",
          "urine",
        ]),
        method: zod.enum([
          "testkit",
          "walk_in_test",
          "at_home_phlebotomy",
          "on_site_collection",
        ]),
        laboratory: zod.union([
          zod
            .object({
              name: zod.string(),
              formatted_address: zod.string(),
              collection_methods: zod.array(
                zod.enum([
                  "testkit",
                  "walk_in_test",
                  "at_home_phlebotomy",
                  "on_site_collection",
                ]),
              ),
              sample_types: zod.array(
                zod.enum([
                  "dried_blood_spot",
                  "arm_collector",
                  "serum",
                  "saliva",
                  "urine",
                ]),
              ),
              slug: zod.union([zod.string(), zod.null()]).optional(),
            })
            .describe("Information about a lab facility."),
          zod.null(),
        ]),
        markers: zod.array(
          zod.object({
            id: zod.string(),
            name: zod.string(),
            description: zod.union([zod.string(), zod.null()]),
            unit: zod.union([zod.string(), zod.null()]),
            metadata: zod
              .object({
                provider: zod
                  .literal("vital")
                  .default(
                    searchLabTestsResponseLabTestsItemMarkersItemMetadataProviderDefault,
                  ),
                slug: zod.string(),
                type: zod.union([zod.enum(["biomarker", "panel"]), zod.null()]),
                provider_id: zod.union([zod.string(), zod.null()]),
                price: zod.union([zod.string(), zod.null()]),
                a_la_carte_enabled: zod.boolean().optional(),
                questions: zod.array(
                  zod
                    .object({
                      marker_id: zod.string(),
                      question_id: zod.string(),
                      body: zod.object({
                        required: zod.boolean(),
                        code: zod.string(),
                        value: zod.string(),
                        constraint: zod.union([zod.string(), zod.null()]),
                        validator: zod.union([
                          zod.object({
                            type: zod.literal("choice"),
                            answers: zod.array(
                              zod.object({
                                code: zod.string(),
                                value: zod.string(),
                              }),
                            ),
                          }),
                          zod.object({
                            type: zod.literal("text"),
                          }),
                          zod.object({
                            type: zod.literal("numeric"),
                          }),
                          zod.object({
                            type: zod.literal("multi_choice"),
                            answers: zod.array(
                              zod.object({
                                code: zod.string(),
                                value: zod.string(),
                              }),
                            ),
                          }),
                        ]),
                        default: zod.union([zod.string(), zod.null()]),
                      }),
                    })
                    .describe("Vital-specific lab marker question."),
                ),
                lab_info: zod
                  .union([
                    zod
                      .object({
                        lab_id: zod.string(),
                        name: zod
                          .enum([
                            "MyUTI",
                            "Nexus",
                            "Precision Analytical",
                            "Boston Heart At-Home Kit",
                            "Quest",
                            "Labcorp",
                            "BioReference",
                            "IHD",
                            "SanoCardio",
                            "Ayumetrix",
                            "Diagnostic Solutions",
                            "Cell Science Systems",
                            "Genova Diagnostics",
                            "ZRT Laboratory",
                            "USSL",
                            "Spiriplex",
                            "US Biotek",
                          ])
                          .describe("Lab names from Vital."),
                      })
                      .describe(
                        "Short lab information containing ID and name.",
                      ),
                    zod.null(),
                  ])
                  .optional(),
                expected_results: zod
                  .array(
                    zod
                      .object({
                        id: zod.string(),
                        name: zod.string(),
                      })
                      .describe(
                        "A result Junction expects an orderable marker or panel to produce.",
                      ),
                  )
                  .optional(),
              })
              .describe("Vital-specific lab marker metadata."),
          }),
        ),
        metadata: zod
          .object({
            provider: zod
              .literal("vital")
              .default(
                searchLabTestsResponseLabTestsItemMetadataProviderDefault,
              ),
            slug: zod.string(),
            price: zod.number(),
            is_active: zod.boolean(),
            status: zod.enum([
              "active",
              "pending_approval",
              "inactive",
              "unknown",
            ]),
            fasting: zod.union([zod.boolean(), zod.null()]),
            auto_generated: zod.union([zod.boolean(), zod.null()]).optional(),
          })
          .describe("Vital-specific lab test metadata."),
        aoe_schema: zod
          .object({
            sections: zod.array(
              zod
                .object({
                  title: zod.string(),
                  description: zod.union([zod.string(), zod.null()]),
                  questions: zod.array(
                    zod
                      .object({
                        id: zod.string(),
                        body: zod.object({
                          required: zod.boolean(),
                          code: zod.string(),
                          value: zod.string(),
                          constraint: zod.union([zod.string(), zod.null()]),
                          validator: zod.union([
                            zod.object({
                              type: zod.literal("choice"),
                              answers: zod.array(
                                zod.object({
                                  code: zod.string(),
                                  value: zod.string(),
                                }),
                              ),
                            }),
                            zod.object({
                              type: zod.literal("text"),
                            }),
                            zod.object({
                              type: zod.literal("numeric"),
                            }),
                            zod.object({
                              type: zod.literal("multi_choice"),
                              answers: zod.array(
                                zod.object({
                                  code: zod.string(),
                                  value: zod.string(),
                                }),
                              ),
                            }),
                          ]),
                          default: zod.union([zod.string(), zod.null()]),
                        }),
                      })
                      .describe(
                        "A required question (AOE - Ask on Entry) for a lab marker.",
                      ),
                  ),
                })
                .describe(
                  "A section of AOE questions grouped by marker.\n\nEach section represents questions from a single marker\/biomarker,\nwith the marker's name and description as context for the questions.",
                ),
            ),
          })
          .describe(
            "Schema for AOE (Ask on Entry) questions organized by sections.\n\nEach section corresponds to a marker and contains all questions\nassociated with that marker.",
          ),
        clinician: zod
          .union([
            zod
              .object({
                first_name: zod.string(),
                last_name: zod.string(),
                dob: zod.iso.date(),
                address: zod
                  .object({
                    address1: zod.string(),
                    address2: zod.union([zod.string(), zod.null()]),
                    city: zod.string(),
                    state: zod.string(),
                    zip_code: zod.string(),
                  })
                  .describe("Clinician's address for lab order attribution."),
                npi: zod.string(),
                email: zod.union([zod.string(), zod.null()]),
                phone: zod.union([zod.string(), zod.null()]),
              })
              .describe(
                "Clinician information required for lab orders.\n\nThis information is extracted from DoseSpot clinician records\nand validated before allowing clinicians to submit lab orders\nor create lab tests.",
              ),
            zod.null(),
          ])
          .optional(),
      }),
    ),
  })
  .describe("Response containing available lab tests.");

/**
 * Submit a new lab order for a patient.

Creates an order for the specified lab test with the provided
AOE answers and order options. The order is submitted to the
lab testing provider (Vital) and persisted locally.
 * @summary Submit Lab Order
 */
export const submitLabOrderParams = zod.object({
  user_id: zod.uuid(),
});

export const submitLabOrderBodyAoeAnswersDefault = [];
export const submitLabOrderBodyPriorityDefault = false;

export const submitLabOrderBody = zod
  .object({
    labTestId: zod.string(),
    aoeAnswers: zod
      .array(
        zod
          .object({
            question_id: zod.string(),
            answer_code: zod.string(),
          })
          .describe("A user's answer to an AOE question."),
      )
      .default(submitLabOrderBodyAoeAnswersDefault),
    notes: zod.union([zod.string(), zod.null()]).optional(),
    priority: zod.boolean().optional(),
    icdCodes: zod.union([zod.array(zod.string()), zod.null()]).optional(),
  })
  .describe("Request to submit a lab order.");

export const submitLabOrderResponseOrderLabTestMarkersItemMetadataProviderDefault =
  "vital";
export const submitLabOrderResponseOrderLabTestMarkersItemMetadataALaCarteEnabledDefault = false;
export const submitLabOrderResponseOrderLabTestMetadataProviderDefault =
  "vital";
export const submitLabOrderResponseOrderMetadataProviderDefault = "vital";
export const submitLabOrderResponseOrderMetadataDetailsTypeDefault = "testkit";
export const submitLabOrderResponseOrderMetadataDetailsTypeDefaultOne =
  "walk_in_test";
export const submitLabOrderResponseOrderMetadataDetailsTypeDefaultTwo =
  "at_home_phlebotomy";
export const submitLabOrderResponseOrderMetadataDetailsTypeDefaultThree =
  "on_site_collection";
export const submitLabOrderResponseOrderMetadataPriorityDefault = false;
export const submitLabOrderResponseOrderMetadataEventsDefault = [];

export const submitLabOrderResponse = zod
  .object({
    order: zod.object({
      remote_id: zod.uuid(),
      user_id: zod.uuid(),
      created_at: zod.iso.datetime({}),
      updated_at: zod.iso.datetime({}),
      lab_test: zod.object({
        id: zod.string(),
        name: zod.string(),
        sample_type: zod.enum([
          "dried_blood_spot",
          "arm_collector",
          "serum",
          "saliva",
          "urine",
        ]),
        method: zod.enum([
          "testkit",
          "walk_in_test",
          "at_home_phlebotomy",
          "on_site_collection",
        ]),
        laboratory: zod.union([
          zod
            .object({
              name: zod.string(),
              formatted_address: zod.string(),
              collection_methods: zod.array(
                zod.enum([
                  "testkit",
                  "walk_in_test",
                  "at_home_phlebotomy",
                  "on_site_collection",
                ]),
              ),
              sample_types: zod.array(
                zod.enum([
                  "dried_blood_spot",
                  "arm_collector",
                  "serum",
                  "saliva",
                  "urine",
                ]),
              ),
              slug: zod.union([zod.string(), zod.null()]).optional(),
            })
            .describe("Information about a lab facility."),
          zod.null(),
        ]),
        markers: zod.array(
          zod.object({
            id: zod.string(),
            name: zod.string(),
            description: zod.union([zod.string(), zod.null()]),
            unit: zod.union([zod.string(), zod.null()]),
            metadata: zod
              .object({
                provider: zod
                  .literal("vital")
                  .default(
                    submitLabOrderResponseOrderLabTestMarkersItemMetadataProviderDefault,
                  ),
                slug: zod.string(),
                type: zod.union([zod.enum(["biomarker", "panel"]), zod.null()]),
                provider_id: zod.union([zod.string(), zod.null()]),
                price: zod.union([zod.string(), zod.null()]),
                a_la_carte_enabled: zod.boolean().optional(),
                questions: zod.array(
                  zod
                    .object({
                      marker_id: zod.string(),
                      question_id: zod.string(),
                      body: zod.object({
                        required: zod.boolean(),
                        code: zod.string(),
                        value: zod.string(),
                        constraint: zod.union([zod.string(), zod.null()]),
                        validator: zod.union([
                          zod.object({
                            type: zod.literal("choice"),
                            answers: zod.array(
                              zod.object({
                                code: zod.string(),
                                value: zod.string(),
                              }),
                            ),
                          }),
                          zod.object({
                            type: zod.literal("text"),
                          }),
                          zod.object({
                            type: zod.literal("numeric"),
                          }),
                          zod.object({
                            type: zod.literal("multi_choice"),
                            answers: zod.array(
                              zod.object({
                                code: zod.string(),
                                value: zod.string(),
                              }),
                            ),
                          }),
                        ]),
                        default: zod.union([zod.string(), zod.null()]),
                      }),
                    })
                    .describe("Vital-specific lab marker question."),
                ),
                lab_info: zod
                  .union([
                    zod
                      .object({
                        lab_id: zod.string(),
                        name: zod
                          .enum([
                            "MyUTI",
                            "Nexus",
                            "Precision Analytical",
                            "Boston Heart At-Home Kit",
                            "Quest",
                            "Labcorp",
                            "BioReference",
                            "IHD",
                            "SanoCardio",
                            "Ayumetrix",
                            "Diagnostic Solutions",
                            "Cell Science Systems",
                            "Genova Diagnostics",
                            "ZRT Laboratory",
                            "USSL",
                            "Spiriplex",
                            "US Biotek",
                          ])
                          .describe("Lab names from Vital."),
                      })
                      .describe(
                        "Short lab information containing ID and name.",
                      ),
                    zod.null(),
                  ])
                  .optional(),
                expected_results: zod
                  .array(
                    zod
                      .object({
                        id: zod.string(),
                        name: zod.string(),
                      })
                      .describe(
                        "A result Junction expects an orderable marker or panel to produce.",
                      ),
                  )
                  .optional(),
              })
              .describe("Vital-specific lab marker metadata."),
          }),
        ),
        metadata: zod
          .object({
            provider: zod
              .literal("vital")
              .default(
                submitLabOrderResponseOrderLabTestMetadataProviderDefault,
              ),
            slug: zod.string(),
            price: zod.number(),
            is_active: zod.boolean(),
            status: zod.enum([
              "active",
              "pending_approval",
              "inactive",
              "unknown",
            ]),
            fasting: zod.union([zod.boolean(), zod.null()]),
            auto_generated: zod.union([zod.boolean(), zod.null()]).optional(),
          })
          .describe("Vital-specific lab test metadata."),
        aoe_schema: zod
          .object({
            sections: zod.array(
              zod
                .object({
                  title: zod.string(),
                  description: zod.union([zod.string(), zod.null()]),
                  questions: zod.array(
                    zod
                      .object({
                        id: zod.string(),
                        body: zod.object({
                          required: zod.boolean(),
                          code: zod.string(),
                          value: zod.string(),
                          constraint: zod.union([zod.string(), zod.null()]),
                          validator: zod.union([
                            zod.object({
                              type: zod.literal("choice"),
                              answers: zod.array(
                                zod.object({
                                  code: zod.string(),
                                  value: zod.string(),
                                }),
                              ),
                            }),
                            zod.object({
                              type: zod.literal("text"),
                            }),
                            zod.object({
                              type: zod.literal("numeric"),
                            }),
                            zod.object({
                              type: zod.literal("multi_choice"),
                              answers: zod.array(
                                zod.object({
                                  code: zod.string(),
                                  value: zod.string(),
                                }),
                              ),
                            }),
                          ]),
                          default: zod.union([zod.string(), zod.null()]),
                        }),
                      })
                      .describe(
                        "A required question (AOE - Ask on Entry) for a lab marker.",
                      ),
                  ),
                })
                .describe(
                  "A section of AOE questions grouped by marker.\n\nEach section represents questions from a single marker\/biomarker,\nwith the marker's name and description as context for the questions.",
                ),
            ),
          })
          .describe(
            "Schema for AOE (Ask on Entry) questions organized by sections.\n\nEach section corresponds to a marker and contains all questions\nassociated with that marker.",
          ),
        clinician: zod
          .union([
            zod
              .object({
                first_name: zod.string(),
                last_name: zod.string(),
                dob: zod.iso.date(),
                address: zod
                  .object({
                    address1: zod.string(),
                    address2: zod.union([zod.string(), zod.null()]),
                    city: zod.string(),
                    state: zod.string(),
                    zip_code: zod.string(),
                  })
                  .describe("Clinician's address for lab order attribution."),
                npi: zod.string(),
                email: zod.union([zod.string(), zod.null()]),
                phone: zod.union([zod.string(), zod.null()]),
              })
              .describe(
                "Clinician information required for lab orders.\n\nThis information is extracted from DoseSpot clinician records\nand validated before allowing clinicians to submit lab orders\nor create lab tests.",
              ),
            zod.null(),
          ])
          .optional(),
      }),
      metadata: zod
        .object({
          provider: zod
            .literal("vital")
            .default(submitLabOrderResponseOrderMetadataProviderDefault),
          details: zod.union([
            zod
              .object({
                type: zod
                  .literal("testkit")
                  .default(
                    submitLabOrderResponseOrderMetadataDetailsTypeDefault,
                  ),
                id: zod.uuid(),
                shipment: zod.union([
                  zod
                    .object({
                      id: zod.uuid(),
                      outbound: zod.union([
                        zod
                          .object({
                            tracking_number: zod.union([
                              zod.string(),
                              zod.null(),
                            ]),
                            tracking_url: zod.union([zod.string(), zod.null()]),
                            courier: zod.union([zod.string(), zod.null()]),
                          })
                          .describe(
                            "Tracking information for a shipment direction (outbound or inbound).",
                          ),
                        zod.null(),
                      ]),
                      inbound: zod.union([
                        zod
                          .object({
                            tracking_number: zod.union([
                              zod.string(),
                              zod.null(),
                            ]),
                            tracking_url: zod.union([zod.string(), zod.null()]),
                            courier: zod.union([zod.string(), zod.null()]),
                          })
                          .describe(
                            "Tracking information for a shipment direction (outbound or inbound).",
                          ),
                        zod.null(),
                      ]),
                      notes: zod.union([zod.string(), zod.null()]),
                    })
                    .describe(
                      "Shipment tracking information for testkit orders.",
                    ),
                  zod.null(),
                ]),
                created_at: zod.iso.datetime({}),
                updated_at: zod.iso.datetime({}),
              })
              .describe("Details for testkit orders."),
            zod
              .object({
                type: zod
                  .literal("walk_in_test")
                  .default(
                    submitLabOrderResponseOrderMetadataDetailsTypeDefaultOne,
                  ),
                id: zod.uuid(),
                appointment_id: zod.union([zod.uuid(), zod.null()]),
                created_at: zod.iso.datetime({}),
                updated_at: zod.iso.datetime({}),
              })
              .describe("Details for walk-in test orders."),
            zod
              .object({
                type: zod
                  .literal("at_home_phlebotomy")
                  .default(
                    submitLabOrderResponseOrderMetadataDetailsTypeDefaultTwo,
                  ),
                id: zod.uuid(),
                appointment_id: zod.union([zod.uuid(), zod.null()]),
                created_at: zod.iso.datetime({}),
                updated_at: zod.iso.datetime({}),
              })
              .describe("Details for at-home phlebotomy orders."),
            zod
              .object({
                type: zod
                  .literal("on_site_collection")
                  .default(
                    submitLabOrderResponseOrderMetadataDetailsTypeDefaultThree,
                  ),
                id: zod.uuid(),
                created_at: zod.iso.datetime({}),
                updated_at: zod.iso.datetime({}),
              })
              .describe("Details for on-site collection orders."),
          ]),
          sample_id: zod.union([zod.string(), zod.null()]),
          notes: zod.union([zod.string(), zod.null()]),
          priority: zod.boolean().optional(),
          events: zod
            .array(
              zod
                .object({
                  remote_id: zod.number(),
                  created_at: zod.iso.datetime({}),
                  status: zod.union([
                    zod.enum([
                      "received.walk_in_test.ordered",
                      "received.walk_in_test.requisition_created",
                      "received.walk_in_test.requisition_bypassed",
                      "completed.walk_in_test.completed",
                      "sample_with_lab.walk_in_test.partial_results",
                      "failed.walk_in_test.sample_error",
                      "cancelled.walk_in_test.cancelled",
                      "collecting_sample.walk_in_test.appointment_pending",
                      "collecting_sample.walk_in_test.appointment_scheduled",
                      "collecting_sample.walk_in_test.appointment_cancelled",
                      "collecting_sample.walk_in_test.redraw_available",
                      "received.at_home_phlebotomy.ordered",
                      "received.at_home_phlebotomy.requisition_created",
                      "received.at_home_phlebotomy.requisition_bypassed",
                      "collecting_sample.at_home_phlebotomy.appointment_pending",
                      "collecting_sample.at_home_phlebotomy.appointment_scheduled",
                      "collecting_sample.at_home_phlebotomy.draw_completed",
                      "collecting_sample.at_home_phlebotomy.appointment_cancelled",
                      "completed.at_home_phlebotomy.completed",
                      "sample_with_lab.at_home_phlebotomy.partial_results",
                      "cancelled.at_home_phlebotomy.cancelled",
                      "failed.at_home_phlebotomy.sample_error",
                      "received.testkit.ordered",
                      "received.testkit.awaiting_registration",
                      "received.testkit.requisition_created",
                      "received.testkit.requisition_bypassed",
                      "received.testkit.registered",
                      "collecting_sample.testkit.transit_customer",
                      "collecting_sample.testkit.out_for_delivery",
                      "collecting_sample.testkit.with_customer",
                      "collecting_sample.testkit.transit_lab",
                      "sample_with_lab.testkit.delivered_to_lab",
                      "completed.testkit.completed",
                      "failed.testkit.failure_to_deliver_to_customer",
                      "failed.testkit.failure_to_deliver_to_lab",
                      "failed.testkit.sample_error",
                      "failed.testkit.lost",
                      "cancelled.testkit.cancelled",
                      "cancelled.testkit.do_not_process",
                      "collecting_sample.testkit.problem_in_transit_customer",
                      "collecting_sample.testkit.problem_in_transit_lab",
                      "received.on_site_collection.ordered",
                      "received.on_site_collection.requisition_created",
                      "received.on_site_collection.requisition_bypassed",
                      "sample_with_lab.on_site_collection.draw_completed",
                      "completed.on_site_collection.completed",
                      "cancelled.on_site_collection.cancelled",
                      "sample_with_lab.on_site_collection.partial_results",
                      "failed.on_site_collection.sample_error",
                    ]),
                    zod.string(),
                  ]),
                  status_detail: zod
                    .union([zod.string(), zod.null()])
                    .optional(),
                })
                .describe("An event in the lifecycle of an order."),
            )
            .default(submitLabOrderResponseOrderMetadataEventsDefault),
        })
        .describe("Vital-specific order metadata."),
      interpretation: zod.enum(["normal", "abnormal", "critical", "unknown"]),
      status: zod.enum([
        "received",
        "collecting_sample",
        "sample_with_lab",
        "completed",
        "cancelled",
        "failed",
        "unknown",
      ]),
    }),
    message: zod.union([zod.string(), zod.null()]).optional(),
  })
  .describe("Response after submitting a lab order.");

/**
 * Fetch lab orders for a patient.

Returns a paginated list of lab orders for the specified patient,
synced with the lab testing provider (Vital).
 * @summary Fetch Lab Orders
 */
export const fetchLabOrdersParams = zod.object({
  user_id: zod.uuid(),
});

export const fetchLabOrdersQueryPageDefault = 1;
export const fetchLabOrdersQuerySizeDefault = 50;

export const fetchLabOrdersQueryParams = zod.object({
  page: zod.number().default(fetchLabOrdersQueryPageDefault),
  size: zod.number().default(fetchLabOrdersQuerySizeDefault),
});

export const fetchLabOrdersResponseOrdersItemLabTestMarkersItemMetadataProviderDefault =
  "vital";
export const fetchLabOrdersResponseOrdersItemLabTestMarkersItemMetadataALaCarteEnabledDefault = false;
export const fetchLabOrdersResponseOrdersItemLabTestMetadataProviderDefault =
  "vital";
export const fetchLabOrdersResponseOrdersItemMetadataProviderDefault = "vital";
export const fetchLabOrdersResponseOrdersItemMetadataDetailsTypeDefault =
  "testkit";
export const fetchLabOrdersResponseOrdersItemMetadataDetailsTypeDefaultOne =
  "walk_in_test";
export const fetchLabOrdersResponseOrdersItemMetadataDetailsTypeDefaultTwo =
  "at_home_phlebotomy";
export const fetchLabOrdersResponseOrdersItemMetadataDetailsTypeDefaultThree =
  "on_site_collection";
export const fetchLabOrdersResponseOrdersItemMetadataPriorityDefault = false;
export const fetchLabOrdersResponseOrdersItemMetadataEventsDefault = [];

export const fetchLabOrdersResponse = zod
  .object({
    orders: zod.array(
      zod.object({
        remote_id: zod.uuid(),
        user_id: zod.uuid(),
        created_at: zod.iso.datetime({}),
        updated_at: zod.iso.datetime({}),
        lab_test: zod.object({
          id: zod.string(),
          name: zod.string(),
          sample_type: zod.enum([
            "dried_blood_spot",
            "arm_collector",
            "serum",
            "saliva",
            "urine",
          ]),
          method: zod.enum([
            "testkit",
            "walk_in_test",
            "at_home_phlebotomy",
            "on_site_collection",
          ]),
          laboratory: zod.union([
            zod
              .object({
                name: zod.string(),
                formatted_address: zod.string(),
                collection_methods: zod.array(
                  zod.enum([
                    "testkit",
                    "walk_in_test",
                    "at_home_phlebotomy",
                    "on_site_collection",
                  ]),
                ),
                sample_types: zod.array(
                  zod.enum([
                    "dried_blood_spot",
                    "arm_collector",
                    "serum",
                    "saliva",
                    "urine",
                  ]),
                ),
                slug: zod.union([zod.string(), zod.null()]).optional(),
              })
              .describe("Information about a lab facility."),
            zod.null(),
          ]),
          markers: zod.array(
            zod.object({
              id: zod.string(),
              name: zod.string(),
              description: zod.union([zod.string(), zod.null()]),
              unit: zod.union([zod.string(), zod.null()]),
              metadata: zod
                .object({
                  provider: zod
                    .literal("vital")
                    .default(
                      fetchLabOrdersResponseOrdersItemLabTestMarkersItemMetadataProviderDefault,
                    ),
                  slug: zod.string(),
                  type: zod.union([
                    zod.enum(["biomarker", "panel"]),
                    zod.null(),
                  ]),
                  provider_id: zod.union([zod.string(), zod.null()]),
                  price: zod.union([zod.string(), zod.null()]),
                  a_la_carte_enabled: zod.boolean().optional(),
                  questions: zod.array(
                    zod
                      .object({
                        marker_id: zod.string(),
                        question_id: zod.string(),
                        body: zod.object({
                          required: zod.boolean(),
                          code: zod.string(),
                          value: zod.string(),
                          constraint: zod.union([zod.string(), zod.null()]),
                          validator: zod.union([
                            zod.object({
                              type: zod.literal("choice"),
                              answers: zod.array(
                                zod.object({
                                  code: zod.string(),
                                  value: zod.string(),
                                }),
                              ),
                            }),
                            zod.object({
                              type: zod.literal("text"),
                            }),
                            zod.object({
                              type: zod.literal("numeric"),
                            }),
                            zod.object({
                              type: zod.literal("multi_choice"),
                              answers: zod.array(
                                zod.object({
                                  code: zod.string(),
                                  value: zod.string(),
                                }),
                              ),
                            }),
                          ]),
                          default: zod.union([zod.string(), zod.null()]),
                        }),
                      })
                      .describe("Vital-specific lab marker question."),
                  ),
                  lab_info: zod
                    .union([
                      zod
                        .object({
                          lab_id: zod.string(),
                          name: zod
                            .enum([
                              "MyUTI",
                              "Nexus",
                              "Precision Analytical",
                              "Boston Heart At-Home Kit",
                              "Quest",
                              "Labcorp",
                              "BioReference",
                              "IHD",
                              "SanoCardio",
                              "Ayumetrix",
                              "Diagnostic Solutions",
                              "Cell Science Systems",
                              "Genova Diagnostics",
                              "ZRT Laboratory",
                              "USSL",
                              "Spiriplex",
                              "US Biotek",
                            ])
                            .describe("Lab names from Vital."),
                        })
                        .describe(
                          "Short lab information containing ID and name.",
                        ),
                      zod.null(),
                    ])
                    .optional(),
                  expected_results: zod
                    .array(
                      zod
                        .object({
                          id: zod.string(),
                          name: zod.string(),
                        })
                        .describe(
                          "A result Junction expects an orderable marker or panel to produce.",
                        ),
                    )
                    .optional(),
                })
                .describe("Vital-specific lab marker metadata."),
            }),
          ),
          metadata: zod
            .object({
              provider: zod
                .literal("vital")
                .default(
                  fetchLabOrdersResponseOrdersItemLabTestMetadataProviderDefault,
                ),
              slug: zod.string(),
              price: zod.number(),
              is_active: zod.boolean(),
              status: zod.enum([
                "active",
                "pending_approval",
                "inactive",
                "unknown",
              ]),
              fasting: zod.union([zod.boolean(), zod.null()]),
              auto_generated: zod.union([zod.boolean(), zod.null()]).optional(),
            })
            .describe("Vital-specific lab test metadata."),
          aoe_schema: zod
            .object({
              sections: zod.array(
                zod
                  .object({
                    title: zod.string(),
                    description: zod.union([zod.string(), zod.null()]),
                    questions: zod.array(
                      zod
                        .object({
                          id: zod.string(),
                          body: zod.object({
                            required: zod.boolean(),
                            code: zod.string(),
                            value: zod.string(),
                            constraint: zod.union([zod.string(), zod.null()]),
                            validator: zod.union([
                              zod.object({
                                type: zod.literal("choice"),
                                answers: zod.array(
                                  zod.object({
                                    code: zod.string(),
                                    value: zod.string(),
                                  }),
                                ),
                              }),
                              zod.object({
                                type: zod.literal("text"),
                              }),
                              zod.object({
                                type: zod.literal("numeric"),
                              }),
                              zod.object({
                                type: zod.literal("multi_choice"),
                                answers: zod.array(
                                  zod.object({
                                    code: zod.string(),
                                    value: zod.string(),
                                  }),
                                ),
                              }),
                            ]),
                            default: zod.union([zod.string(), zod.null()]),
                          }),
                        })
                        .describe(
                          "A required question (AOE - Ask on Entry) for a lab marker.",
                        ),
                    ),
                  })
                  .describe(
                    "A section of AOE questions grouped by marker.\n\nEach section represents questions from a single marker\/biomarker,\nwith the marker's name and description as context for the questions.",
                  ),
              ),
            })
            .describe(
              "Schema for AOE (Ask on Entry) questions organized by sections.\n\nEach section corresponds to a marker and contains all questions\nassociated with that marker.",
            ),
          clinician: zod
            .union([
              zod
                .object({
                  first_name: zod.string(),
                  last_name: zod.string(),
                  dob: zod.iso.date(),
                  address: zod
                    .object({
                      address1: zod.string(),
                      address2: zod.union([zod.string(), zod.null()]),
                      city: zod.string(),
                      state: zod.string(),
                      zip_code: zod.string(),
                    })
                    .describe("Clinician's address for lab order attribution."),
                  npi: zod.string(),
                  email: zod.union([zod.string(), zod.null()]),
                  phone: zod.union([zod.string(), zod.null()]),
                })
                .describe(
                  "Clinician information required for lab orders.\n\nThis information is extracted from DoseSpot clinician records\nand validated before allowing clinicians to submit lab orders\nor create lab tests.",
                ),
              zod.null(),
            ])
            .optional(),
        }),
        metadata: zod
          .object({
            provider: zod
              .literal("vital")
              .default(fetchLabOrdersResponseOrdersItemMetadataProviderDefault),
            details: zod.union([
              zod
                .object({
                  type: zod
                    .literal("testkit")
                    .default(
                      fetchLabOrdersResponseOrdersItemMetadataDetailsTypeDefault,
                    ),
                  id: zod.uuid(),
                  shipment: zod.union([
                    zod
                      .object({
                        id: zod.uuid(),
                        outbound: zod.union([
                          zod
                            .object({
                              tracking_number: zod.union([
                                zod.string(),
                                zod.null(),
                              ]),
                              tracking_url: zod.union([
                                zod.string(),
                                zod.null(),
                              ]),
                              courier: zod.union([zod.string(), zod.null()]),
                            })
                            .describe(
                              "Tracking information for a shipment direction (outbound or inbound).",
                            ),
                          zod.null(),
                        ]),
                        inbound: zod.union([
                          zod
                            .object({
                              tracking_number: zod.union([
                                zod.string(),
                                zod.null(),
                              ]),
                              tracking_url: zod.union([
                                zod.string(),
                                zod.null(),
                              ]),
                              courier: zod.union([zod.string(), zod.null()]),
                            })
                            .describe(
                              "Tracking information for a shipment direction (outbound or inbound).",
                            ),
                          zod.null(),
                        ]),
                        notes: zod.union([zod.string(), zod.null()]),
                      })
                      .describe(
                        "Shipment tracking information for testkit orders.",
                      ),
                    zod.null(),
                  ]),
                  created_at: zod.iso.datetime({}),
                  updated_at: zod.iso.datetime({}),
                })
                .describe("Details for testkit orders."),
              zod
                .object({
                  type: zod
                    .literal("walk_in_test")
                    .default(
                      fetchLabOrdersResponseOrdersItemMetadataDetailsTypeDefaultOne,
                    ),
                  id: zod.uuid(),
                  appointment_id: zod.union([zod.uuid(), zod.null()]),
                  created_at: zod.iso.datetime({}),
                  updated_at: zod.iso.datetime({}),
                })
                .describe("Details for walk-in test orders."),
              zod
                .object({
                  type: zod
                    .literal("at_home_phlebotomy")
                    .default(
                      fetchLabOrdersResponseOrdersItemMetadataDetailsTypeDefaultTwo,
                    ),
                  id: zod.uuid(),
                  appointment_id: zod.union([zod.uuid(), zod.null()]),
                  created_at: zod.iso.datetime({}),
                  updated_at: zod.iso.datetime({}),
                })
                .describe("Details for at-home phlebotomy orders."),
              zod
                .object({
                  type: zod
                    .literal("on_site_collection")
                    .default(
                      fetchLabOrdersResponseOrdersItemMetadataDetailsTypeDefaultThree,
                    ),
                  id: zod.uuid(),
                  created_at: zod.iso.datetime({}),
                  updated_at: zod.iso.datetime({}),
                })
                .describe("Details for on-site collection orders."),
            ]),
            sample_id: zod.union([zod.string(), zod.null()]),
            notes: zod.union([zod.string(), zod.null()]),
            priority: zod.boolean().optional(),
            events: zod
              .array(
                zod
                  .object({
                    remote_id: zod.number(),
                    created_at: zod.iso.datetime({}),
                    status: zod.union([
                      zod.enum([
                        "received.walk_in_test.ordered",
                        "received.walk_in_test.requisition_created",
                        "received.walk_in_test.requisition_bypassed",
                        "completed.walk_in_test.completed",
                        "sample_with_lab.walk_in_test.partial_results",
                        "failed.walk_in_test.sample_error",
                        "cancelled.walk_in_test.cancelled",
                        "collecting_sample.walk_in_test.appointment_pending",
                        "collecting_sample.walk_in_test.appointment_scheduled",
                        "collecting_sample.walk_in_test.appointment_cancelled",
                        "collecting_sample.walk_in_test.redraw_available",
                        "received.at_home_phlebotomy.ordered",
                        "received.at_home_phlebotomy.requisition_created",
                        "received.at_home_phlebotomy.requisition_bypassed",
                        "collecting_sample.at_home_phlebotomy.appointment_pending",
                        "collecting_sample.at_home_phlebotomy.appointment_scheduled",
                        "collecting_sample.at_home_phlebotomy.draw_completed",
                        "collecting_sample.at_home_phlebotomy.appointment_cancelled",
                        "completed.at_home_phlebotomy.completed",
                        "sample_with_lab.at_home_phlebotomy.partial_results",
                        "cancelled.at_home_phlebotomy.cancelled",
                        "failed.at_home_phlebotomy.sample_error",
                        "received.testkit.ordered",
                        "received.testkit.awaiting_registration",
                        "received.testkit.requisition_created",
                        "received.testkit.requisition_bypassed",
                        "received.testkit.registered",
                        "collecting_sample.testkit.transit_customer",
                        "collecting_sample.testkit.out_for_delivery",
                        "collecting_sample.testkit.with_customer",
                        "collecting_sample.testkit.transit_lab",
                        "sample_with_lab.testkit.delivered_to_lab",
                        "completed.testkit.completed",
                        "failed.testkit.failure_to_deliver_to_customer",
                        "failed.testkit.failure_to_deliver_to_lab",
                        "failed.testkit.sample_error",
                        "failed.testkit.lost",
                        "cancelled.testkit.cancelled",
                        "cancelled.testkit.do_not_process",
                        "collecting_sample.testkit.problem_in_transit_customer",
                        "collecting_sample.testkit.problem_in_transit_lab",
                        "received.on_site_collection.ordered",
                        "received.on_site_collection.requisition_created",
                        "received.on_site_collection.requisition_bypassed",
                        "sample_with_lab.on_site_collection.draw_completed",
                        "completed.on_site_collection.completed",
                        "cancelled.on_site_collection.cancelled",
                        "sample_with_lab.on_site_collection.partial_results",
                        "failed.on_site_collection.sample_error",
                      ]),
                      zod.string(),
                    ]),
                    status_detail: zod
                      .union([zod.string(), zod.null()])
                      .optional(),
                  })
                  .describe("An event in the lifecycle of an order."),
              )
              .default(fetchLabOrdersResponseOrdersItemMetadataEventsDefault),
          })
          .describe("Vital-specific order metadata."),
        interpretation: zod.enum(["normal", "abnormal", "critical", "unknown"]),
        status: zod.enum([
          "received",
          "collecting_sample",
          "sample_with_lab",
          "completed",
          "cancelled",
          "failed",
          "unknown",
        ]),
      }),
    ),
  })
  .describe("Response containing lab orders.");

/**
 * Create a grouped custom lab test and submit one order for it.

This endpoint is the grouped execution path for proposed lab order sets:
callers send marker IDs that belong to one draw, and the backend creates
a single custom lab test before submitting a single order.
 * @summary Submit Lab Order Set
 */
export const submitLabOrderSetParams = zod.object({
  user_id: zod.uuid(),
});

export const submitLabOrderSetBodyAoeAnswersDefault = [];
export const submitLabOrderSetBodyPriorityDefault = false;

export const submitLabOrderSetBody = zod
  .object({
    name: zod.string(),
    description: zod.string(),
    collectionMethod: zod.enum([
      "testkit",
      "walk_in_test",
      "at_home_phlebotomy",
      "on_site_collection",
    ]),
    markerIds: zod.array(zod.string()),
    fasting: zod.union([zod.boolean(), zod.null()]).optional(),
    aoeAnswers: zod
      .array(
        zod
          .object({
            question_id: zod.string(),
            answer_code: zod.string(),
          })
          .describe("A user's answer to an AOE question."),
      )
      .default(submitLabOrderSetBodyAoeAnswersDefault),
    notes: zod.union([zod.string(), zod.null()]).optional(),
    priority: zod.boolean().optional(),
    icdCodes: zod.union([zod.array(zod.string()), zod.null()]).optional(),
  })
  .describe("Request to create and submit a grouped lab order set.");

export const submitLabOrderSetResponseLabTestMarkersItemMetadataProviderDefault =
  "vital";
export const submitLabOrderSetResponseLabTestMarkersItemMetadataALaCarteEnabledDefault = false;
export const submitLabOrderSetResponseLabTestMetadataProviderDefault = "vital";
export const submitLabOrderSetResponseOrderLabTestMarkersItemMetadataProviderDefault =
  "vital";
export const submitLabOrderSetResponseOrderLabTestMarkersItemMetadataALaCarteEnabledDefault = false;
export const submitLabOrderSetResponseOrderLabTestMetadataProviderDefault =
  "vital";
export const submitLabOrderSetResponseOrderMetadataProviderDefault = "vital";
export const submitLabOrderSetResponseOrderMetadataDetailsTypeDefault =
  "testkit";
export const submitLabOrderSetResponseOrderMetadataDetailsTypeDefaultOne =
  "walk_in_test";
export const submitLabOrderSetResponseOrderMetadataDetailsTypeDefaultTwo =
  "at_home_phlebotomy";
export const submitLabOrderSetResponseOrderMetadataDetailsTypeDefaultThree =
  "on_site_collection";
export const submitLabOrderSetResponseOrderMetadataPriorityDefault = false;
export const submitLabOrderSetResponseOrderMetadataEventsDefault = [];

export const submitLabOrderSetResponse = zod
  .object({
    labTest: zod.object({
      id: zod.string(),
      name: zod.string(),
      sample_type: zod.enum([
        "dried_blood_spot",
        "arm_collector",
        "serum",
        "saliva",
        "urine",
      ]),
      method: zod.enum([
        "testkit",
        "walk_in_test",
        "at_home_phlebotomy",
        "on_site_collection",
      ]),
      laboratory: zod.union([
        zod
          .object({
            name: zod.string(),
            formatted_address: zod.string(),
            collection_methods: zod.array(
              zod.enum([
                "testkit",
                "walk_in_test",
                "at_home_phlebotomy",
                "on_site_collection",
              ]),
            ),
            sample_types: zod.array(
              zod.enum([
                "dried_blood_spot",
                "arm_collector",
                "serum",
                "saliva",
                "urine",
              ]),
            ),
            slug: zod.union([zod.string(), zod.null()]).optional(),
          })
          .describe("Information about a lab facility."),
        zod.null(),
      ]),
      markers: zod.array(
        zod.object({
          id: zod.string(),
          name: zod.string(),
          description: zod.union([zod.string(), zod.null()]),
          unit: zod.union([zod.string(), zod.null()]),
          metadata: zod
            .object({
              provider: zod
                .literal("vital")
                .default(
                  submitLabOrderSetResponseLabTestMarkersItemMetadataProviderDefault,
                ),
              slug: zod.string(),
              type: zod.union([zod.enum(["biomarker", "panel"]), zod.null()]),
              provider_id: zod.union([zod.string(), zod.null()]),
              price: zod.union([zod.string(), zod.null()]),
              a_la_carte_enabled: zod.boolean().optional(),
              questions: zod.array(
                zod
                  .object({
                    marker_id: zod.string(),
                    question_id: zod.string(),
                    body: zod.object({
                      required: zod.boolean(),
                      code: zod.string(),
                      value: zod.string(),
                      constraint: zod.union([zod.string(), zod.null()]),
                      validator: zod.union([
                        zod.object({
                          type: zod.literal("choice"),
                          answers: zod.array(
                            zod.object({
                              code: zod.string(),
                              value: zod.string(),
                            }),
                          ),
                        }),
                        zod.object({
                          type: zod.literal("text"),
                        }),
                        zod.object({
                          type: zod.literal("numeric"),
                        }),
                        zod.object({
                          type: zod.literal("multi_choice"),
                          answers: zod.array(
                            zod.object({
                              code: zod.string(),
                              value: zod.string(),
                            }),
                          ),
                        }),
                      ]),
                      default: zod.union([zod.string(), zod.null()]),
                    }),
                  })
                  .describe("Vital-specific lab marker question."),
              ),
              lab_info: zod
                .union([
                  zod
                    .object({
                      lab_id: zod.string(),
                      name: zod
                        .enum([
                          "MyUTI",
                          "Nexus",
                          "Precision Analytical",
                          "Boston Heart At-Home Kit",
                          "Quest",
                          "Labcorp",
                          "BioReference",
                          "IHD",
                          "SanoCardio",
                          "Ayumetrix",
                          "Diagnostic Solutions",
                          "Cell Science Systems",
                          "Genova Diagnostics",
                          "ZRT Laboratory",
                          "USSL",
                          "Spiriplex",
                          "US Biotek",
                        ])
                        .describe("Lab names from Vital."),
                    })
                    .describe("Short lab information containing ID and name."),
                  zod.null(),
                ])
                .optional(),
              expected_results: zod
                .array(
                  zod
                    .object({
                      id: zod.string(),
                      name: zod.string(),
                    })
                    .describe(
                      "A result Junction expects an orderable marker or panel to produce.",
                    ),
                )
                .optional(),
            })
            .describe("Vital-specific lab marker metadata."),
        }),
      ),
      metadata: zod
        .object({
          provider: zod
            .literal("vital")
            .default(submitLabOrderSetResponseLabTestMetadataProviderDefault),
          slug: zod.string(),
          price: zod.number(),
          is_active: zod.boolean(),
          status: zod.enum([
            "active",
            "pending_approval",
            "inactive",
            "unknown",
          ]),
          fasting: zod.union([zod.boolean(), zod.null()]),
          auto_generated: zod.union([zod.boolean(), zod.null()]).optional(),
        })
        .describe("Vital-specific lab test metadata."),
      aoe_schema: zod
        .object({
          sections: zod.array(
            zod
              .object({
                title: zod.string(),
                description: zod.union([zod.string(), zod.null()]),
                questions: zod.array(
                  zod
                    .object({
                      id: zod.string(),
                      body: zod.object({
                        required: zod.boolean(),
                        code: zod.string(),
                        value: zod.string(),
                        constraint: zod.union([zod.string(), zod.null()]),
                        validator: zod.union([
                          zod.object({
                            type: zod.literal("choice"),
                            answers: zod.array(
                              zod.object({
                                code: zod.string(),
                                value: zod.string(),
                              }),
                            ),
                          }),
                          zod.object({
                            type: zod.literal("text"),
                          }),
                          zod.object({
                            type: zod.literal("numeric"),
                          }),
                          zod.object({
                            type: zod.literal("multi_choice"),
                            answers: zod.array(
                              zod.object({
                                code: zod.string(),
                                value: zod.string(),
                              }),
                            ),
                          }),
                        ]),
                        default: zod.union([zod.string(), zod.null()]),
                      }),
                    })
                    .describe(
                      "A required question (AOE - Ask on Entry) for a lab marker.",
                    ),
                ),
              })
              .describe(
                "A section of AOE questions grouped by marker.\n\nEach section represents questions from a single marker\/biomarker,\nwith the marker's name and description as context for the questions.",
              ),
          ),
        })
        .describe(
          "Schema for AOE (Ask on Entry) questions organized by sections.\n\nEach section corresponds to a marker and contains all questions\nassociated with that marker.",
        ),
      clinician: zod
        .union([
          zod
            .object({
              first_name: zod.string(),
              last_name: zod.string(),
              dob: zod.iso.date(),
              address: zod
                .object({
                  address1: zod.string(),
                  address2: zod.union([zod.string(), zod.null()]),
                  city: zod.string(),
                  state: zod.string(),
                  zip_code: zod.string(),
                })
                .describe("Clinician's address for lab order attribution."),
              npi: zod.string(),
              email: zod.union([zod.string(), zod.null()]),
              phone: zod.union([zod.string(), zod.null()]),
            })
            .describe(
              "Clinician information required for lab orders.\n\nThis information is extracted from DoseSpot clinician records\nand validated before allowing clinicians to submit lab orders\nor create lab tests.",
            ),
          zod.null(),
        ])
        .optional(),
    }),
    order: zod.object({
      remote_id: zod.uuid(),
      user_id: zod.uuid(),
      created_at: zod.iso.datetime({}),
      updated_at: zod.iso.datetime({}),
      lab_test: zod.object({
        id: zod.string(),
        name: zod.string(),
        sample_type: zod.enum([
          "dried_blood_spot",
          "arm_collector",
          "serum",
          "saliva",
          "urine",
        ]),
        method: zod.enum([
          "testkit",
          "walk_in_test",
          "at_home_phlebotomy",
          "on_site_collection",
        ]),
        laboratory: zod.union([
          zod
            .object({
              name: zod.string(),
              formatted_address: zod.string(),
              collection_methods: zod.array(
                zod.enum([
                  "testkit",
                  "walk_in_test",
                  "at_home_phlebotomy",
                  "on_site_collection",
                ]),
              ),
              sample_types: zod.array(
                zod.enum([
                  "dried_blood_spot",
                  "arm_collector",
                  "serum",
                  "saliva",
                  "urine",
                ]),
              ),
              slug: zod.union([zod.string(), zod.null()]).optional(),
            })
            .describe("Information about a lab facility."),
          zod.null(),
        ]),
        markers: zod.array(
          zod.object({
            id: zod.string(),
            name: zod.string(),
            description: zod.union([zod.string(), zod.null()]),
            unit: zod.union([zod.string(), zod.null()]),
            metadata: zod
              .object({
                provider: zod
                  .literal("vital")
                  .default(
                    submitLabOrderSetResponseOrderLabTestMarkersItemMetadataProviderDefault,
                  ),
                slug: zod.string(),
                type: zod.union([zod.enum(["biomarker", "panel"]), zod.null()]),
                provider_id: zod.union([zod.string(), zod.null()]),
                price: zod.union([zod.string(), zod.null()]),
                a_la_carte_enabled: zod.boolean().optional(),
                questions: zod.array(
                  zod
                    .object({
                      marker_id: zod.string(),
                      question_id: zod.string(),
                      body: zod.object({
                        required: zod.boolean(),
                        code: zod.string(),
                        value: zod.string(),
                        constraint: zod.union([zod.string(), zod.null()]),
                        validator: zod.union([
                          zod.object({
                            type: zod.literal("choice"),
                            answers: zod.array(
                              zod.object({
                                code: zod.string(),
                                value: zod.string(),
                              }),
                            ),
                          }),
                          zod.object({
                            type: zod.literal("text"),
                          }),
                          zod.object({
                            type: zod.literal("numeric"),
                          }),
                          zod.object({
                            type: zod.literal("multi_choice"),
                            answers: zod.array(
                              zod.object({
                                code: zod.string(),
                                value: zod.string(),
                              }),
                            ),
                          }),
                        ]),
                        default: zod.union([zod.string(), zod.null()]),
                      }),
                    })
                    .describe("Vital-specific lab marker question."),
                ),
                lab_info: zod
                  .union([
                    zod
                      .object({
                        lab_id: zod.string(),
                        name: zod
                          .enum([
                            "MyUTI",
                            "Nexus",
                            "Precision Analytical",
                            "Boston Heart At-Home Kit",
                            "Quest",
                            "Labcorp",
                            "BioReference",
                            "IHD",
                            "SanoCardio",
                            "Ayumetrix",
                            "Diagnostic Solutions",
                            "Cell Science Systems",
                            "Genova Diagnostics",
                            "ZRT Laboratory",
                            "USSL",
                            "Spiriplex",
                            "US Biotek",
                          ])
                          .describe("Lab names from Vital."),
                      })
                      .describe(
                        "Short lab information containing ID and name.",
                      ),
                    zod.null(),
                  ])
                  .optional(),
                expected_results: zod
                  .array(
                    zod
                      .object({
                        id: zod.string(),
                        name: zod.string(),
                      })
                      .describe(
                        "A result Junction expects an orderable marker or panel to produce.",
                      ),
                  )
                  .optional(),
              })
              .describe("Vital-specific lab marker metadata."),
          }),
        ),
        metadata: zod
          .object({
            provider: zod
              .literal("vital")
              .default(
                submitLabOrderSetResponseOrderLabTestMetadataProviderDefault,
              ),
            slug: zod.string(),
            price: zod.number(),
            is_active: zod.boolean(),
            status: zod.enum([
              "active",
              "pending_approval",
              "inactive",
              "unknown",
            ]),
            fasting: zod.union([zod.boolean(), zod.null()]),
            auto_generated: zod.union([zod.boolean(), zod.null()]).optional(),
          })
          .describe("Vital-specific lab test metadata."),
        aoe_schema: zod
          .object({
            sections: zod.array(
              zod
                .object({
                  title: zod.string(),
                  description: zod.union([zod.string(), zod.null()]),
                  questions: zod.array(
                    zod
                      .object({
                        id: zod.string(),
                        body: zod.object({
                          required: zod.boolean(),
                          code: zod.string(),
                          value: zod.string(),
                          constraint: zod.union([zod.string(), zod.null()]),
                          validator: zod.union([
                            zod.object({
                              type: zod.literal("choice"),
                              answers: zod.array(
                                zod.object({
                                  code: zod.string(),
                                  value: zod.string(),
                                }),
                              ),
                            }),
                            zod.object({
                              type: zod.literal("text"),
                            }),
                            zod.object({
                              type: zod.literal("numeric"),
                            }),
                            zod.object({
                              type: zod.literal("multi_choice"),
                              answers: zod.array(
                                zod.object({
                                  code: zod.string(),
                                  value: zod.string(),
                                }),
                              ),
                            }),
                          ]),
                          default: zod.union([zod.string(), zod.null()]),
                        }),
                      })
                      .describe(
                        "A required question (AOE - Ask on Entry) for a lab marker.",
                      ),
                  ),
                })
                .describe(
                  "A section of AOE questions grouped by marker.\n\nEach section represents questions from a single marker\/biomarker,\nwith the marker's name and description as context for the questions.",
                ),
            ),
          })
          .describe(
            "Schema for AOE (Ask on Entry) questions organized by sections.\n\nEach section corresponds to a marker and contains all questions\nassociated with that marker.",
          ),
        clinician: zod
          .union([
            zod
              .object({
                first_name: zod.string(),
                last_name: zod.string(),
                dob: zod.iso.date(),
                address: zod
                  .object({
                    address1: zod.string(),
                    address2: zod.union([zod.string(), zod.null()]),
                    city: zod.string(),
                    state: zod.string(),
                    zip_code: zod.string(),
                  })
                  .describe("Clinician's address for lab order attribution."),
                npi: zod.string(),
                email: zod.union([zod.string(), zod.null()]),
                phone: zod.union([zod.string(), zod.null()]),
              })
              .describe(
                "Clinician information required for lab orders.\n\nThis information is extracted from DoseSpot clinician records\nand validated before allowing clinicians to submit lab orders\nor create lab tests.",
              ),
            zod.null(),
          ])
          .optional(),
      }),
      metadata: zod
        .object({
          provider: zod
            .literal("vital")
            .default(submitLabOrderSetResponseOrderMetadataProviderDefault),
          details: zod.union([
            zod
              .object({
                type: zod
                  .literal("testkit")
                  .default(
                    submitLabOrderSetResponseOrderMetadataDetailsTypeDefault,
                  ),
                id: zod.uuid(),
                shipment: zod.union([
                  zod
                    .object({
                      id: zod.uuid(),
                      outbound: zod.union([
                        zod
                          .object({
                            tracking_number: zod.union([
                              zod.string(),
                              zod.null(),
                            ]),
                            tracking_url: zod.union([zod.string(), zod.null()]),
                            courier: zod.union([zod.string(), zod.null()]),
                          })
                          .describe(
                            "Tracking information for a shipment direction (outbound or inbound).",
                          ),
                        zod.null(),
                      ]),
                      inbound: zod.union([
                        zod
                          .object({
                            tracking_number: zod.union([
                              zod.string(),
                              zod.null(),
                            ]),
                            tracking_url: zod.union([zod.string(), zod.null()]),
                            courier: zod.union([zod.string(), zod.null()]),
                          })
                          .describe(
                            "Tracking information for a shipment direction (outbound or inbound).",
                          ),
                        zod.null(),
                      ]),
                      notes: zod.union([zod.string(), zod.null()]),
                    })
                    .describe(
                      "Shipment tracking information for testkit orders.",
                    ),
                  zod.null(),
                ]),
                created_at: zod.iso.datetime({}),
                updated_at: zod.iso.datetime({}),
              })
              .describe("Details for testkit orders."),
            zod
              .object({
                type: zod
                  .literal("walk_in_test")
                  .default(
                    submitLabOrderSetResponseOrderMetadataDetailsTypeDefaultOne,
                  ),
                id: zod.uuid(),
                appointment_id: zod.union([zod.uuid(), zod.null()]),
                created_at: zod.iso.datetime({}),
                updated_at: zod.iso.datetime({}),
              })
              .describe("Details for walk-in test orders."),
            zod
              .object({
                type: zod
                  .literal("at_home_phlebotomy")
                  .default(
                    submitLabOrderSetResponseOrderMetadataDetailsTypeDefaultTwo,
                  ),
                id: zod.uuid(),
                appointment_id: zod.union([zod.uuid(), zod.null()]),
                created_at: zod.iso.datetime({}),
                updated_at: zod.iso.datetime({}),
              })
              .describe("Details for at-home phlebotomy orders."),
            zod
              .object({
                type: zod
                  .literal("on_site_collection")
                  .default(
                    submitLabOrderSetResponseOrderMetadataDetailsTypeDefaultThree,
                  ),
                id: zod.uuid(),
                created_at: zod.iso.datetime({}),
                updated_at: zod.iso.datetime({}),
              })
              .describe("Details for on-site collection orders."),
          ]),
          sample_id: zod.union([zod.string(), zod.null()]),
          notes: zod.union([zod.string(), zod.null()]),
          priority: zod.boolean().optional(),
          events: zod
            .array(
              zod
                .object({
                  remote_id: zod.number(),
                  created_at: zod.iso.datetime({}),
                  status: zod.union([
                    zod.enum([
                      "received.walk_in_test.ordered",
                      "received.walk_in_test.requisition_created",
                      "received.walk_in_test.requisition_bypassed",
                      "completed.walk_in_test.completed",
                      "sample_with_lab.walk_in_test.partial_results",
                      "failed.walk_in_test.sample_error",
                      "cancelled.walk_in_test.cancelled",
                      "collecting_sample.walk_in_test.appointment_pending",
                      "collecting_sample.walk_in_test.appointment_scheduled",
                      "collecting_sample.walk_in_test.appointment_cancelled",
                      "collecting_sample.walk_in_test.redraw_available",
                      "received.at_home_phlebotomy.ordered",
                      "received.at_home_phlebotomy.requisition_created",
                      "received.at_home_phlebotomy.requisition_bypassed",
                      "collecting_sample.at_home_phlebotomy.appointment_pending",
                      "collecting_sample.at_home_phlebotomy.appointment_scheduled",
                      "collecting_sample.at_home_phlebotomy.draw_completed",
                      "collecting_sample.at_home_phlebotomy.appointment_cancelled",
                      "completed.at_home_phlebotomy.completed",
                      "sample_with_lab.at_home_phlebotomy.partial_results",
                      "cancelled.at_home_phlebotomy.cancelled",
                      "failed.at_home_phlebotomy.sample_error",
                      "received.testkit.ordered",
                      "received.testkit.awaiting_registration",
                      "received.testkit.requisition_created",
                      "received.testkit.requisition_bypassed",
                      "received.testkit.registered",
                      "collecting_sample.testkit.transit_customer",
                      "collecting_sample.testkit.out_for_delivery",
                      "collecting_sample.testkit.with_customer",
                      "collecting_sample.testkit.transit_lab",
                      "sample_with_lab.testkit.delivered_to_lab",
                      "completed.testkit.completed",
                      "failed.testkit.failure_to_deliver_to_customer",
                      "failed.testkit.failure_to_deliver_to_lab",
                      "failed.testkit.sample_error",
                      "failed.testkit.lost",
                      "cancelled.testkit.cancelled",
                      "cancelled.testkit.do_not_process",
                      "collecting_sample.testkit.problem_in_transit_customer",
                      "collecting_sample.testkit.problem_in_transit_lab",
                      "received.on_site_collection.ordered",
                      "received.on_site_collection.requisition_created",
                      "received.on_site_collection.requisition_bypassed",
                      "sample_with_lab.on_site_collection.draw_completed",
                      "completed.on_site_collection.completed",
                      "cancelled.on_site_collection.cancelled",
                      "sample_with_lab.on_site_collection.partial_results",
                      "failed.on_site_collection.sample_error",
                    ]),
                    zod.string(),
                  ]),
                  status_detail: zod
                    .union([zod.string(), zod.null()])
                    .optional(),
                })
                .describe("An event in the lifecycle of an order."),
            )
            .default(submitLabOrderSetResponseOrderMetadataEventsDefault),
        })
        .describe("Vital-specific order metadata."),
      interpretation: zod.enum(["normal", "abnormal", "critical", "unknown"]),
      status: zod.enum([
        "received",
        "collecting_sample",
        "sample_with_lab",
        "completed",
        "cancelled",
        "failed",
        "unknown",
      ]),
    }),
  })
  .describe("Response after creating and submitting a grouped lab order set.");

/**
 * Resolve a native order set and return its required AOE questions.
 * @summary Prepare Native Lab Order Set
 */
export const prepareNativeLabOrderSetBody = zod
  .object({
    labSlug: zod
      .enum(["quest"])
      .describe("Performing laboratories Lotus can intentionally order from."),
    collectionMethod: zod.enum([
      "testkit",
      "walk_in_test",
      "at_home_phlebotomy",
      "on_site_collection",
    ]),
    labTestIds: zod.array(zod.string()).optional(),
    markerIds: zod.array(zod.string()).optional(),
    labAccountId: zod.union([zod.string(), zod.null()]).optional(),
  })
  .describe("Selection to validate and expand as one native lab order set.");

export const prepareNativeLabOrderSetResponse = zod
  .object({
    labTestIds: zod.array(zod.string()),
    markerIds: zod.array(zod.string()),
    labTests: zod.array(
      zod
        .object({
          id: zod.string(),
          name: zod.string(),
          kind: zod.enum([
            "configured_test",
            "panel",
            "individual_test",
            "unknown",
          ]),
          components: zod.array(
            zod
              .object({
                id: zod.string(),
                name: zod.string(),
              })
              .describe(
                "One result included when an orderable item is a panel.",
              ),
          ),
        })
        .describe(
          "Clinician-facing identity for one selected orderable catalog item.",
        ),
    ),
    markers: zod.array(
      zod
        .object({
          id: zod.string(),
          name: zod.string(),
          kind: zod.enum([
            "configured_test",
            "panel",
            "individual_test",
            "unknown",
          ]),
          components: zod.array(
            zod
              .object({
                id: zod.string(),
                name: zod.string(),
              })
              .describe(
                "One result included when an orderable item is a panel.",
              ),
          ),
        })
        .describe(
          "Clinician-facing identity for one selected orderable catalog item.",
        ),
    ),
    aoeSchema: zod
      .object({
        sections: zod.array(
          zod
            .object({
              title: zod.string(),
              description: zod.union([zod.string(), zod.null()]),
              questions: zod.array(
                zod
                  .object({
                    id: zod.string(),
                    body: zod.object({
                      required: zod.boolean(),
                      code: zod.string(),
                      value: zod.string(),
                      constraint: zod.union([zod.string(), zod.null()]),
                      validator: zod.union([
                        zod.object({
                          type: zod.literal("choice"),
                          answers: zod.array(
                            zod.object({
                              code: zod.string(),
                              value: zod.string(),
                            }),
                          ),
                        }),
                        zod.object({
                          type: zod.literal("text"),
                        }),
                        zod.object({
                          type: zod.literal("numeric"),
                        }),
                        zod.object({
                          type: zod.literal("multi_choice"),
                          answers: zod.array(
                            zod.object({
                              code: zod.string(),
                              value: zod.string(),
                            }),
                          ),
                        }),
                      ]),
                      default: zod.union([zod.string(), zod.null()]),
                    }),
                  })
                  .describe(
                    "A required question (AOE - Ask on Entry) for a lab marker.",
                  ),
              ),
            })
            .describe(
              "A section of AOE questions grouped by marker.\n\nEach section represents questions from a single marker\/biomarker,\nwith the marker's name and description as context for the questions.",
            ),
        ),
      })
      .describe(
        "Schema for AOE (Ask on Entry) questions organized by sections.\n\nEach section corresponds to a marker and contains all questions\nassociated with that marker.",
      ),
  })
  .describe("Canonical native selection and its required AOE questions.");

/**
 * Submit one native lab order set for one compatible draw.
 * @summary Submit Native Lab Order Set
 */
export const submitNativeLabOrderSetParams = zod.object({
  user_id: zod.uuid(),
});

export const submitNativeLabOrderSetBodyNotesMaxOne = 120;

export const submitNativeLabOrderSetBodyPriorityDefault = false;

export const submitNativeLabOrderSetBody = zod
  .object({
    labSlug: zod
      .enum(["quest"])
      .describe("Performing laboratories Lotus can intentionally order from."),
    collectionMethod: zod.enum([
      "testkit",
      "walk_in_test",
      "at_home_phlebotomy",
      "on_site_collection",
    ]),
    labTestIds: zod.array(zod.string()).optional(),
    markerIds: zod.array(zod.string()).optional(),
    labAccountId: zod.union([zod.string(), zod.null()]).optional(),
    orderAttemptId: zod.uuid(),
    aoeAnswers: zod
      .array(
        zod
          .object({
            question_id: zod.string(),
            answer_code: zod.string(),
          })
          .describe("A user's answer to an AOE question."),
      )
      .optional(),
    notes: zod
      .union([
        zod.string().max(submitNativeLabOrderSetBodyNotesMaxOne),
        zod.null(),
      ])
      .optional()
      .describe("Quest clinical notes, limited to 120 characters."),
    priority: zod.boolean().optional(),
    icdCodes: zod.array(zod.string()).min(1),
    sourceActionId: zod.union([zod.uuid(), zod.null()]).optional(),
  })
  .describe("Request to submit one prepared native lab order set.");

export const submitNativeLabOrderSetResponseOrderLabTestMarkersItemMetadataProviderDefault =
  "vital";
export const submitNativeLabOrderSetResponseOrderLabTestMarkersItemMetadataALaCarteEnabledDefault = false;
export const submitNativeLabOrderSetResponseOrderLabTestMetadataProviderDefault =
  "vital";
export const submitNativeLabOrderSetResponseOrderMetadataProviderDefault =
  "vital";
export const submitNativeLabOrderSetResponseOrderMetadataDetailsTypeDefault =
  "testkit";
export const submitNativeLabOrderSetResponseOrderMetadataDetailsTypeDefaultOne =
  "walk_in_test";
export const submitNativeLabOrderSetResponseOrderMetadataDetailsTypeDefaultTwo =
  "at_home_phlebotomy";
export const submitNativeLabOrderSetResponseOrderMetadataDetailsTypeDefaultThree =
  "on_site_collection";
export const submitNativeLabOrderSetResponseOrderMetadataPriorityDefault = false;
export const submitNativeLabOrderSetResponseOrderMetadataEventsDefault = [];

export const submitNativeLabOrderSetResponse = zod.union([
  zod
    .object({
      type: zod.literal("success"),
      order: zod.object({
        remote_id: zod.uuid(),
        user_id: zod.uuid(),
        created_at: zod.iso.datetime({}),
        updated_at: zod.iso.datetime({}),
        lab_test: zod.object({
          id: zod.string(),
          name: zod.string(),
          sample_type: zod.enum([
            "dried_blood_spot",
            "arm_collector",
            "serum",
            "saliva",
            "urine",
          ]),
          method: zod.enum([
            "testkit",
            "walk_in_test",
            "at_home_phlebotomy",
            "on_site_collection",
          ]),
          laboratory: zod.union([
            zod
              .object({
                name: zod.string(),
                formatted_address: zod.string(),
                collection_methods: zod.array(
                  zod.enum([
                    "testkit",
                    "walk_in_test",
                    "at_home_phlebotomy",
                    "on_site_collection",
                  ]),
                ),
                sample_types: zod.array(
                  zod.enum([
                    "dried_blood_spot",
                    "arm_collector",
                    "serum",
                    "saliva",
                    "urine",
                  ]),
                ),
                slug: zod.union([zod.string(), zod.null()]).optional(),
              })
              .describe("Information about a lab facility."),
            zod.null(),
          ]),
          markers: zod.array(
            zod.object({
              id: zod.string(),
              name: zod.string(),
              description: zod.union([zod.string(), zod.null()]),
              unit: zod.union([zod.string(), zod.null()]),
              metadata: zod
                .object({
                  provider: zod
                    .literal("vital")
                    .default(
                      submitNativeLabOrderSetResponseOrderLabTestMarkersItemMetadataProviderDefault,
                    ),
                  slug: zod.string(),
                  type: zod.union([
                    zod.enum(["biomarker", "panel"]),
                    zod.null(),
                  ]),
                  provider_id: zod.union([zod.string(), zod.null()]),
                  price: zod.union([zod.string(), zod.null()]),
                  a_la_carte_enabled: zod.boolean().optional(),
                  questions: zod.array(
                    zod
                      .object({
                        marker_id: zod.string(),
                        question_id: zod.string(),
                        body: zod.object({
                          required: zod.boolean(),
                          code: zod.string(),
                          value: zod.string(),
                          constraint: zod.union([zod.string(), zod.null()]),
                          validator: zod.union([
                            zod.object({
                              type: zod.literal("choice"),
                              answers: zod.array(
                                zod.object({
                                  code: zod.string(),
                                  value: zod.string(),
                                }),
                              ),
                            }),
                            zod.object({
                              type: zod.literal("text"),
                            }),
                            zod.object({
                              type: zod.literal("numeric"),
                            }),
                            zod.object({
                              type: zod.literal("multi_choice"),
                              answers: zod.array(
                                zod.object({
                                  code: zod.string(),
                                  value: zod.string(),
                                }),
                              ),
                            }),
                          ]),
                          default: zod.union([zod.string(), zod.null()]),
                        }),
                      })
                      .describe("Vital-specific lab marker question."),
                  ),
                  lab_info: zod
                    .union([
                      zod
                        .object({
                          lab_id: zod.string(),
                          name: zod
                            .enum([
                              "MyUTI",
                              "Nexus",
                              "Precision Analytical",
                              "Boston Heart At-Home Kit",
                              "Quest",
                              "Labcorp",
                              "BioReference",
                              "IHD",
                              "SanoCardio",
                              "Ayumetrix",
                              "Diagnostic Solutions",
                              "Cell Science Systems",
                              "Genova Diagnostics",
                              "ZRT Laboratory",
                              "USSL",
                              "Spiriplex",
                              "US Biotek",
                            ])
                            .describe("Lab names from Vital."),
                        })
                        .describe(
                          "Short lab information containing ID and name.",
                        ),
                      zod.null(),
                    ])
                    .optional(),
                  expected_results: zod
                    .array(
                      zod
                        .object({
                          id: zod.string(),
                          name: zod.string(),
                        })
                        .describe(
                          "A result Junction expects an orderable marker or panel to produce.",
                        ),
                    )
                    .optional(),
                })
                .describe("Vital-specific lab marker metadata."),
            }),
          ),
          metadata: zod
            .object({
              provider: zod
                .literal("vital")
                .default(
                  submitNativeLabOrderSetResponseOrderLabTestMetadataProviderDefault,
                ),
              slug: zod.string(),
              price: zod.number(),
              is_active: zod.boolean(),
              status: zod.enum([
                "active",
                "pending_approval",
                "inactive",
                "unknown",
              ]),
              fasting: zod.union([zod.boolean(), zod.null()]),
              auto_generated: zod.union([zod.boolean(), zod.null()]).optional(),
            })
            .describe("Vital-specific lab test metadata."),
          aoe_schema: zod
            .object({
              sections: zod.array(
                zod
                  .object({
                    title: zod.string(),
                    description: zod.union([zod.string(), zod.null()]),
                    questions: zod.array(
                      zod
                        .object({
                          id: zod.string(),
                          body: zod.object({
                            required: zod.boolean(),
                            code: zod.string(),
                            value: zod.string(),
                            constraint: zod.union([zod.string(), zod.null()]),
                            validator: zod.union([
                              zod.object({
                                type: zod.literal("choice"),
                                answers: zod.array(
                                  zod.object({
                                    code: zod.string(),
                                    value: zod.string(),
                                  }),
                                ),
                              }),
                              zod.object({
                                type: zod.literal("text"),
                              }),
                              zod.object({
                                type: zod.literal("numeric"),
                              }),
                              zod.object({
                                type: zod.literal("multi_choice"),
                                answers: zod.array(
                                  zod.object({
                                    code: zod.string(),
                                    value: zod.string(),
                                  }),
                                ),
                              }),
                            ]),
                            default: zod.union([zod.string(), zod.null()]),
                          }),
                        })
                        .describe(
                          "A required question (AOE - Ask on Entry) for a lab marker.",
                        ),
                    ),
                  })
                  .describe(
                    "A section of AOE questions grouped by marker.\n\nEach section represents questions from a single marker\/biomarker,\nwith the marker's name and description as context for the questions.",
                  ),
              ),
            })
            .describe(
              "Schema for AOE (Ask on Entry) questions organized by sections.\n\nEach section corresponds to a marker and contains all questions\nassociated with that marker.",
            ),
          clinician: zod
            .union([
              zod
                .object({
                  first_name: zod.string(),
                  last_name: zod.string(),
                  dob: zod.iso.date(),
                  address: zod
                    .object({
                      address1: zod.string(),
                      address2: zod.union([zod.string(), zod.null()]),
                      city: zod.string(),
                      state: zod.string(),
                      zip_code: zod.string(),
                    })
                    .describe("Clinician's address for lab order attribution."),
                  npi: zod.string(),
                  email: zod.union([zod.string(), zod.null()]),
                  phone: zod.union([zod.string(), zod.null()]),
                })
                .describe(
                  "Clinician information required for lab orders.\n\nThis information is extracted from DoseSpot clinician records\nand validated before allowing clinicians to submit lab orders\nor create lab tests.",
                ),
              zod.null(),
            ])
            .optional(),
        }),
        metadata: zod
          .object({
            provider: zod
              .literal("vital")
              .default(
                submitNativeLabOrderSetResponseOrderMetadataProviderDefault,
              ),
            details: zod.union([
              zod
                .object({
                  type: zod
                    .literal("testkit")
                    .default(
                      submitNativeLabOrderSetResponseOrderMetadataDetailsTypeDefault,
                    ),
                  id: zod.uuid(),
                  shipment: zod.union([
                    zod
                      .object({
                        id: zod.uuid(),
                        outbound: zod.union([
                          zod
                            .object({
                              tracking_number: zod.union([
                                zod.string(),
                                zod.null(),
                              ]),
                              tracking_url: zod.union([
                                zod.string(),
                                zod.null(),
                              ]),
                              courier: zod.union([zod.string(), zod.null()]),
                            })
                            .describe(
                              "Tracking information for a shipment direction (outbound or inbound).",
                            ),
                          zod.null(),
                        ]),
                        inbound: zod.union([
                          zod
                            .object({
                              tracking_number: zod.union([
                                zod.string(),
                                zod.null(),
                              ]),
                              tracking_url: zod.union([
                                zod.string(),
                                zod.null(),
                              ]),
                              courier: zod.union([zod.string(), zod.null()]),
                            })
                            .describe(
                              "Tracking information for a shipment direction (outbound or inbound).",
                            ),
                          zod.null(),
                        ]),
                        notes: zod.union([zod.string(), zod.null()]),
                      })
                      .describe(
                        "Shipment tracking information for testkit orders.",
                      ),
                    zod.null(),
                  ]),
                  created_at: zod.iso.datetime({}),
                  updated_at: zod.iso.datetime({}),
                })
                .describe("Details for testkit orders."),
              zod
                .object({
                  type: zod
                    .literal("walk_in_test")
                    .default(
                      submitNativeLabOrderSetResponseOrderMetadataDetailsTypeDefaultOne,
                    ),
                  id: zod.uuid(),
                  appointment_id: zod.union([zod.uuid(), zod.null()]),
                  created_at: zod.iso.datetime({}),
                  updated_at: zod.iso.datetime({}),
                })
                .describe("Details for walk-in test orders."),
              zod
                .object({
                  type: zod
                    .literal("at_home_phlebotomy")
                    .default(
                      submitNativeLabOrderSetResponseOrderMetadataDetailsTypeDefaultTwo,
                    ),
                  id: zod.uuid(),
                  appointment_id: zod.union([zod.uuid(), zod.null()]),
                  created_at: zod.iso.datetime({}),
                  updated_at: zod.iso.datetime({}),
                })
                .describe("Details for at-home phlebotomy orders."),
              zod
                .object({
                  type: zod
                    .literal("on_site_collection")
                    .default(
                      submitNativeLabOrderSetResponseOrderMetadataDetailsTypeDefaultThree,
                    ),
                  id: zod.uuid(),
                  created_at: zod.iso.datetime({}),
                  updated_at: zod.iso.datetime({}),
                })
                .describe("Details for on-site collection orders."),
            ]),
            sample_id: zod.union([zod.string(), zod.null()]),
            notes: zod.union([zod.string(), zod.null()]),
            priority: zod.boolean().optional(),
            events: zod
              .array(
                zod
                  .object({
                    remote_id: zod.number(),
                    created_at: zod.iso.datetime({}),
                    status: zod.union([
                      zod.enum([
                        "received.walk_in_test.ordered",
                        "received.walk_in_test.requisition_created",
                        "received.walk_in_test.requisition_bypassed",
                        "completed.walk_in_test.completed",
                        "sample_with_lab.walk_in_test.partial_results",
                        "failed.walk_in_test.sample_error",
                        "cancelled.walk_in_test.cancelled",
                        "collecting_sample.walk_in_test.appointment_pending",
                        "collecting_sample.walk_in_test.appointment_scheduled",
                        "collecting_sample.walk_in_test.appointment_cancelled",
                        "collecting_sample.walk_in_test.redraw_available",
                        "received.at_home_phlebotomy.ordered",
                        "received.at_home_phlebotomy.requisition_created",
                        "received.at_home_phlebotomy.requisition_bypassed",
                        "collecting_sample.at_home_phlebotomy.appointment_pending",
                        "collecting_sample.at_home_phlebotomy.appointment_scheduled",
                        "collecting_sample.at_home_phlebotomy.draw_completed",
                        "collecting_sample.at_home_phlebotomy.appointment_cancelled",
                        "completed.at_home_phlebotomy.completed",
                        "sample_with_lab.at_home_phlebotomy.partial_results",
                        "cancelled.at_home_phlebotomy.cancelled",
                        "failed.at_home_phlebotomy.sample_error",
                        "received.testkit.ordered",
                        "received.testkit.awaiting_registration",
                        "received.testkit.requisition_created",
                        "received.testkit.requisition_bypassed",
                        "received.testkit.registered",
                        "collecting_sample.testkit.transit_customer",
                        "collecting_sample.testkit.out_for_delivery",
                        "collecting_sample.testkit.with_customer",
                        "collecting_sample.testkit.transit_lab",
                        "sample_with_lab.testkit.delivered_to_lab",
                        "completed.testkit.completed",
                        "failed.testkit.failure_to_deliver_to_customer",
                        "failed.testkit.failure_to_deliver_to_lab",
                        "failed.testkit.sample_error",
                        "failed.testkit.lost",
                        "cancelled.testkit.cancelled",
                        "cancelled.testkit.do_not_process",
                        "collecting_sample.testkit.problem_in_transit_customer",
                        "collecting_sample.testkit.problem_in_transit_lab",
                        "received.on_site_collection.ordered",
                        "received.on_site_collection.requisition_created",
                        "received.on_site_collection.requisition_bypassed",
                        "sample_with_lab.on_site_collection.draw_completed",
                        "completed.on_site_collection.completed",
                        "cancelled.on_site_collection.cancelled",
                        "sample_with_lab.on_site_collection.partial_results",
                        "failed.on_site_collection.sample_error",
                      ]),
                      zod.string(),
                    ]),
                    status_detail: zod
                      .union([zod.string(), zod.null()])
                      .optional(),
                  })
                  .describe("An event in the lifecycle of an order."),
              )
              .default(
                submitNativeLabOrderSetResponseOrderMetadataEventsDefault,
              ),
          })
          .describe("Vital-specific order metadata."),
        interpretation: zod.enum(["normal", "abnormal", "critical", "unknown"]),
        status: zod.enum([
          "received",
          "collecting_sample",
          "sample_with_lab",
          "completed",
          "cancelled",
          "failed",
          "unknown",
        ]),
      }),
    })
    .describe("A native lab order accepted by the performing lab."),
  zod
    .object({
      type: zod.literal("failure"),
      reason: zod
        .enum([
          "invalid_order",
          "clinician_information_missing",
          "patient_information_missing",
          "insurance_information_missing",
          "insurance_not_supported",
          "lab_not_in_network",
          "lab_network_unconfirmed",
          "multiple_possible_junction_codes",
          "lab_ordering_unavailable",
          "order_in_progress",
          "order_rejected",
          "order_recording_failed",
          "submission_status_unknown",
        ])
        .describe("Stable reasons a native order-set submission can fail."),
      details: zod.string(),
    })
    .describe("An expected native lab-order failure the caller can handle."),
]);

/**
 * Search for available biomarkers.

Returns a paginated list of biomarkers that can be used to create
custom lab tests. Supports filtering by name and lab ID.
 * @summary Search Biomarkers
 */
export const searchBiomarkersBodyPageDefault = 1;
export const searchBiomarkersBodySizeDefault = 50;

export const searchBiomarkersBody = zod
  .object({
    name: zod.union([zod.string(), zod.null()]).optional(),
    aLaCarteEnabled: zod.union([zod.boolean(), zod.null()]).optional(),
    page: zod.number().default(searchBiomarkersBodyPageDefault),
    size: zod.number().default(searchBiomarkersBodySizeDefault),
  })
  .describe("Request to search for biomarkers.");

export const searchBiomarkersResponseMarkersItemMetadataProviderDefault =
  "vital";
export const searchBiomarkersResponseMarkersItemMetadataALaCarteEnabledDefault = false;

export const searchBiomarkersResponse = zod
  .object({
    markers: zod.array(
      zod.object({
        id: zod.string(),
        name: zod.string(),
        description: zod.union([zod.string(), zod.null()]),
        unit: zod.union([zod.string(), zod.null()]),
        metadata: zod
          .object({
            provider: zod
              .literal("vital")
              .default(
                searchBiomarkersResponseMarkersItemMetadataProviderDefault,
              ),
            slug: zod.string(),
            type: zod.union([zod.enum(["biomarker", "panel"]), zod.null()]),
            provider_id: zod.union([zod.string(), zod.null()]),
            price: zod.union([zod.string(), zod.null()]),
            a_la_carte_enabled: zod.boolean().optional(),
            questions: zod.array(
              zod
                .object({
                  marker_id: zod.string(),
                  question_id: zod.string(),
                  body: zod.object({
                    required: zod.boolean(),
                    code: zod.string(),
                    value: zod.string(),
                    constraint: zod.union([zod.string(), zod.null()]),
                    validator: zod.union([
                      zod.object({
                        type: zod.literal("choice"),
                        answers: zod.array(
                          zod.object({
                            code: zod.string(),
                            value: zod.string(),
                          }),
                        ),
                      }),
                      zod.object({
                        type: zod.literal("text"),
                      }),
                      zod.object({
                        type: zod.literal("numeric"),
                      }),
                      zod.object({
                        type: zod.literal("multi_choice"),
                        answers: zod.array(
                          zod.object({
                            code: zod.string(),
                            value: zod.string(),
                          }),
                        ),
                      }),
                    ]),
                    default: zod.union([zod.string(), zod.null()]),
                  }),
                })
                .describe("Vital-specific lab marker question."),
            ),
            lab_info: zod
              .union([
                zod
                  .object({
                    lab_id: zod.string(),
                    name: zod
                      .enum([
                        "MyUTI",
                        "Nexus",
                        "Precision Analytical",
                        "Boston Heart At-Home Kit",
                        "Quest",
                        "Labcorp",
                        "BioReference",
                        "IHD",
                        "SanoCardio",
                        "Ayumetrix",
                        "Diagnostic Solutions",
                        "Cell Science Systems",
                        "Genova Diagnostics",
                        "ZRT Laboratory",
                        "USSL",
                        "Spiriplex",
                        "US Biotek",
                      ])
                      .describe("Lab names from Vital."),
                  })
                  .describe("Short lab information containing ID and name."),
                zod.null(),
              ])
              .optional(),
            expected_results: zod
              .array(
                zod
                  .object({
                    id: zod.string(),
                    name: zod.string(),
                  })
                  .describe(
                    "A result Junction expects an orderable marker or panel to produce.",
                  ),
              )
              .optional(),
          })
          .describe("Vital-specific lab marker metadata."),
      }),
    ),
    total: zod.union([zod.number(), zod.null()]),
    page: zod.union([zod.number(), zod.null()]),
    size: zod.union([zod.number(), zod.null()]),
    pages: zod.union([zod.number(), zod.null()]),
  })
  .describe("Response containing biomarkers.");

/**
 * Create a new custom lab test.

Creates a lab test with the specified biomarkers. The test can then
be ordered for patients. Only registered clinicians can create tests.
 * @summary Create Lab Test
 */
export const createLabTestBody = zod
  .object({
    name: zod.string(),
    description: zod.string(),
    method: zod.enum([
      "testkit",
      "walk_in_test",
      "at_home_phlebotomy",
      "on_site_collection",
    ]),
    markerIds: zod.array(zod.string()),
  })
  .describe("Request to create a new lab test.");

export const createLabTestResponseLabTestMarkersItemMetadataProviderDefault =
  "vital";
export const createLabTestResponseLabTestMarkersItemMetadataALaCarteEnabledDefault = false;
export const createLabTestResponseLabTestMetadataProviderDefault = "vital";

export const createLabTestResponse = zod
  .object({
    labTest: zod.object({
      id: zod.string(),
      name: zod.string(),
      sample_type: zod.enum([
        "dried_blood_spot",
        "arm_collector",
        "serum",
        "saliva",
        "urine",
      ]),
      method: zod.enum([
        "testkit",
        "walk_in_test",
        "at_home_phlebotomy",
        "on_site_collection",
      ]),
      laboratory: zod.union([
        zod
          .object({
            name: zod.string(),
            formatted_address: zod.string(),
            collection_methods: zod.array(
              zod.enum([
                "testkit",
                "walk_in_test",
                "at_home_phlebotomy",
                "on_site_collection",
              ]),
            ),
            sample_types: zod.array(
              zod.enum([
                "dried_blood_spot",
                "arm_collector",
                "serum",
                "saliva",
                "urine",
              ]),
            ),
            slug: zod.union([zod.string(), zod.null()]).optional(),
          })
          .describe("Information about a lab facility."),
        zod.null(),
      ]),
      markers: zod.array(
        zod.object({
          id: zod.string(),
          name: zod.string(),
          description: zod.union([zod.string(), zod.null()]),
          unit: zod.union([zod.string(), zod.null()]),
          metadata: zod
            .object({
              provider: zod
                .literal("vital")
                .default(
                  createLabTestResponseLabTestMarkersItemMetadataProviderDefault,
                ),
              slug: zod.string(),
              type: zod.union([zod.enum(["biomarker", "panel"]), zod.null()]),
              provider_id: zod.union([zod.string(), zod.null()]),
              price: zod.union([zod.string(), zod.null()]),
              a_la_carte_enabled: zod.boolean().optional(),
              questions: zod.array(
                zod
                  .object({
                    marker_id: zod.string(),
                    question_id: zod.string(),
                    body: zod.object({
                      required: zod.boolean(),
                      code: zod.string(),
                      value: zod.string(),
                      constraint: zod.union([zod.string(), zod.null()]),
                      validator: zod.union([
                        zod.object({
                          type: zod.literal("choice"),
                          answers: zod.array(
                            zod.object({
                              code: zod.string(),
                              value: zod.string(),
                            }),
                          ),
                        }),
                        zod.object({
                          type: zod.literal("text"),
                        }),
                        zod.object({
                          type: zod.literal("numeric"),
                        }),
                        zod.object({
                          type: zod.literal("multi_choice"),
                          answers: zod.array(
                            zod.object({
                              code: zod.string(),
                              value: zod.string(),
                            }),
                          ),
                        }),
                      ]),
                      default: zod.union([zod.string(), zod.null()]),
                    }),
                  })
                  .describe("Vital-specific lab marker question."),
              ),
              lab_info: zod
                .union([
                  zod
                    .object({
                      lab_id: zod.string(),
                      name: zod
                        .enum([
                          "MyUTI",
                          "Nexus",
                          "Precision Analytical",
                          "Boston Heart At-Home Kit",
                          "Quest",
                          "Labcorp",
                          "BioReference",
                          "IHD",
                          "SanoCardio",
                          "Ayumetrix",
                          "Diagnostic Solutions",
                          "Cell Science Systems",
                          "Genova Diagnostics",
                          "ZRT Laboratory",
                          "USSL",
                          "Spiriplex",
                          "US Biotek",
                        ])
                        .describe("Lab names from Vital."),
                    })
                    .describe("Short lab information containing ID and name."),
                  zod.null(),
                ])
                .optional(),
              expected_results: zod
                .array(
                  zod
                    .object({
                      id: zod.string(),
                      name: zod.string(),
                    })
                    .describe(
                      "A result Junction expects an orderable marker or panel to produce.",
                    ),
                )
                .optional(),
            })
            .describe("Vital-specific lab marker metadata."),
        }),
      ),
      metadata: zod
        .object({
          provider: zod
            .literal("vital")
            .default(createLabTestResponseLabTestMetadataProviderDefault),
          slug: zod.string(),
          price: zod.number(),
          is_active: zod.boolean(),
          status: zod.enum([
            "active",
            "pending_approval",
            "inactive",
            "unknown",
          ]),
          fasting: zod.union([zod.boolean(), zod.null()]),
          auto_generated: zod.union([zod.boolean(), zod.null()]).optional(),
        })
        .describe("Vital-specific lab test metadata."),
      aoe_schema: zod
        .object({
          sections: zod.array(
            zod
              .object({
                title: zod.string(),
                description: zod.union([zod.string(), zod.null()]),
                questions: zod.array(
                  zod
                    .object({
                      id: zod.string(),
                      body: zod.object({
                        required: zod.boolean(),
                        code: zod.string(),
                        value: zod.string(),
                        constraint: zod.union([zod.string(), zod.null()]),
                        validator: zod.union([
                          zod.object({
                            type: zod.literal("choice"),
                            answers: zod.array(
                              zod.object({
                                code: zod.string(),
                                value: zod.string(),
                              }),
                            ),
                          }),
                          zod.object({
                            type: zod.literal("text"),
                          }),
                          zod.object({
                            type: zod.literal("numeric"),
                          }),
                          zod.object({
                            type: zod.literal("multi_choice"),
                            answers: zod.array(
                              zod.object({
                                code: zod.string(),
                                value: zod.string(),
                              }),
                            ),
                          }),
                        ]),
                        default: zod.union([zod.string(), zod.null()]),
                      }),
                    })
                    .describe(
                      "A required question (AOE - Ask on Entry) for a lab marker.",
                    ),
                ),
              })
              .describe(
                "A section of AOE questions grouped by marker.\n\nEach section represents questions from a single marker\/biomarker,\nwith the marker's name and description as context for the questions.",
              ),
          ),
        })
        .describe(
          "Schema for AOE (Ask on Entry) questions organized by sections.\n\nEach section corresponds to a marker and contains all questions\nassociated with that marker.",
        ),
      clinician: zod
        .union([
          zod
            .object({
              first_name: zod.string(),
              last_name: zod.string(),
              dob: zod.iso.date(),
              address: zod
                .object({
                  address1: zod.string(),
                  address2: zod.union([zod.string(), zod.null()]),
                  city: zod.string(),
                  state: zod.string(),
                  zip_code: zod.string(),
                })
                .describe("Clinician's address for lab order attribution."),
              npi: zod.string(),
              email: zod.union([zod.string(), zod.null()]),
              phone: zod.union([zod.string(), zod.null()]),
            })
            .describe(
              "Clinician information required for lab orders.\n\nThis information is extracted from DoseSpot clinician records\nand validated before allowing clinicians to submit lab orders\nor create lab tests.",
            ),
          zod.null(),
        ])
        .optional(),
    }),
  })
  .describe("Response after creating a lab test.");

/**
 * Search ICD-10-CM codes by keyword (BM25) or semantic similarity (embedding).

Set `mode` to "bm25" for exact keyword matching (default) or "embedding"
for natural-language / synonym search (e.g. "heart attack" finds
"acute myocardial infarction").
 * @summary Search Icd10
 */
export const searchIcd10Body = zod
  .object({
    query: zod.string(),
    mode: zod
      .enum(["fulltextsearch", "embedding"])
      .describe("Which ranking strategy to use when searching ICD-10 codes."),
    topK: zod.number(),
  })
  .describe("Request to search ICD-10 codes.");

export const searchIcd10Response = zod
  .object({
    codes: zod.array(
      zod
        .object({
          code: zod.string(),
          description: zod.string(),
        })
        .describe("An ICD-10-CM diagnosis code with its description."),
    ),
  })
  .describe("Response containing matching ICD-10 codes.");

/**
 * Resolve specific ICD-10-CM codes by their code strings.

Given a list of ICD-10 codes (e.g. ["E11.9", "I10"]), returns
the full code objects with descriptions.  Returns 404 if any
requested code does not exist.
 * @summary Resolve Icd10
 */
export const resolveIcd10Body = zod
  .object({
    codes: zod.array(zod.string()),
  })
  .describe("Request to resolve specific ICD-10 codes.");

export const resolveIcd10Response = zod
  .object({
    codes: zod.array(
      zod
        .object({
          code: zod.string(),
          description: zod.string(),
        })
        .describe("An ICD-10-CM diagnosis code with its description."),
    ),
  })
  .describe("Response containing resolved ICD-10 codes.");

/**
 * Record a clinician diagnosis for a patient.

The description is resolved from ``icd10_code`` via the ICD-10 index (404 if
the code is unknown). Writes a ``CareStateDiagnosisT`` row (Care State owns
identity/linkage) keyed by the client-supplied ``diagnosis_id``, then
schedules ``on_healthdata_received`` so the reingested-FHIR pipeline emits a
FHIR ``Condition`` into the patient's PHR and submits it to Metriport.

The write is idempotent on ``diagnosis_id``: if the diagnosis already
exists (e.g. the client retried after ``on_healthdata_received`` timed out),
the existing row is returned instead of inserting a duplicate.
 * @summary Record Diagnosis
 */
export const recordDiagnosisParams = zod.object({
  user_id: zod.uuid(),
});

export const recordDiagnosisBody = zod
  .object({
    diagnosisId: zod.uuid(),
    icd10Code: zod.string().min(1),
    note: zod.string().min(1),
  })
  .describe(
    "Request to record a clinician diagnosis for a patient.\n\nOnly the ICD-10 code and a clinical note are supplied; the human-readable\ndescription is resolved authoritatively from the code via the ICD-10 index.\n\n``diagnosis_id`` is generated by the client (once per diagnosis) so retries\nare idempotent: replaying the same request never records a duplicate.",
  );

export const recordDiagnosisResponse = zod
  .object({
    diagnosisId: zod.uuid(),
    icd10Code: zod.string(),
  })
  .describe("Response after recording a diagnosis.");

/**
 * Render a Lotus-branded fax preview without persisting or sending it.
 * @summary Preview Patient Fax
 */
export const previewPatientFaxParams = zod.object({
  user_id: zod.uuid(),
});

export const previewPatientFaxBodyTitleDefault = "";
export const previewPatientFaxBodyTitleMax = 255;

export const previewPatientFaxBodyHeaderMarkdownMaxOne = 20000;

export const previewPatientFaxBodyRecipientNameDefault = "";
export const previewPatientFaxBodyRecipientNameMax = 255;

export const previewPatientFaxBodyRecipientFaxNumberDefault = "";
export const previewPatientFaxBodyRecipientFaxNumberMax = 32;

export const previewPatientFaxBodyRecipientOrganizationMaxOne = 255;

export const previewPatientFaxBodyAttachmentsMax = 20;

export const previewPatientFaxBodyBodyMarkdownMax = 200000;

export const previewPatientFaxBodyFilenameDefault = "fax.pdf";
export const previewPatientFaxBodyFilenameMax = 128;

export const previewPatientFaxBody = zod
  .object({
    title: zod.string().max(previewPatientFaxBodyTitleMax).optional(),
    header_markdown: zod
      .union([
        zod.string().max(previewPatientFaxBodyHeaderMarkdownMaxOne),
        zod.null(),
      ])
      .optional()
      .describe(
        "Optional editable Markdown header; omitted means no header content.",
      ),
    recipient: zod
      .object({
        name: zod
          .string()
          .max(previewPatientFaxBodyRecipientNameMax)
          .optional(),
        fax_number: zod
          .string()
          .max(previewPatientFaxBodyRecipientFaxNumberMax)
          .optional(),
        organization: zod
          .union([
            zod.string().max(previewPatientFaxBodyRecipientOrganizationMaxOne),
            zod.null(),
          ])
          .optional(),
      })
      .describe("The canonical destination used for fax delivery metadata."),
    attachments: zod
      .array(
        zod
          .object({
            attachment_id: zod.uuid(),
          })
          .describe(
            "An ordered, fax-specific reference to a confirmed file attachment.",
          ),
      )
      .max(previewPatientFaxBodyAttachmentsMax)
      .optional(),
    body_markdown: zod
      .string()
      .min(1)
      .max(previewPatientFaxBodyBodyMarkdownMax),
    fax_date: zod.iso.date().optional(),
    prepared_at: zod.iso.datetime({}).optional(),
    filename: zod
      .string()
      .min(1)
      .max(previewPatientFaxBodyFilenameMax)
      .default(previewPatientFaxBodyFilenameDefault),
  })
  .describe("Input shared by the editor preview and the final PDF action.");

export const previewPatientFaxResponse = zod.unknown();

/**
 * Create a confirmed patient-owned attachment for an eFax draft.
 * @summary Upload Patient Fax Attachment
 */
export const uploadPatientFaxAttachmentParams = zod.object({
  user_id: zod.uuid(),
});

export const uploadPatientFaxAttachmentBody = zod.object({
  file: zod.string(),
});

export const uploadPatientFaxAttachmentResponse = zod
  .object({
    attachment_id: zod.uuid(),
  })
  .describe(
    "An ordered, fax-specific reference to a confirmed file attachment.",
  );

/**
 * Build, persist, and submit one clinician-approved patient fax.
 * @summary Send Patient Fax
 */
export const sendPatientFaxParams = zod.object({
  user_id: zod.uuid(),
});

export const sendPatientFaxBodyTitleDefault = "";
export const sendPatientFaxBodyTitleMax = 255;

export const sendPatientFaxBodyHeaderMarkdownMaxOne = 20000;

export const sendPatientFaxBodyRecipientNameDefault = "";
export const sendPatientFaxBodyRecipientNameMax = 255;

export const sendPatientFaxBodyRecipientFaxNumberDefault = "";
export const sendPatientFaxBodyRecipientFaxNumberMax = 32;

export const sendPatientFaxBodyRecipientOrganizationMaxOne = 255;

export const sendPatientFaxBodyAttachmentsMax = 20;

export const sendPatientFaxBodyBodyMarkdownMax = 200000;

export const sendPatientFaxBodyFilenameDefault = "fax.pdf";
export const sendPatientFaxBodyFilenameMax = 128;

export const sendPatientFaxBody = zod
  .object({
    title: zod.string().max(sendPatientFaxBodyTitleMax).optional(),
    header_markdown: zod
      .union([
        zod.string().max(sendPatientFaxBodyHeaderMarkdownMaxOne),
        zod.null(),
      ])
      .optional()
      .describe(
        "Optional editable Markdown header; omitted means no header content.",
      ),
    recipient: zod
      .object({
        name: zod.string().max(sendPatientFaxBodyRecipientNameMax).optional(),
        fax_number: zod
          .string()
          .max(sendPatientFaxBodyRecipientFaxNumberMax)
          .optional(),
        organization: zod
          .union([
            zod.string().max(sendPatientFaxBodyRecipientOrganizationMaxOne),
            zod.null(),
          ])
          .optional(),
      })
      .describe("The canonical destination used for fax delivery metadata."),
    attachments: zod
      .array(
        zod
          .object({
            attachment_id: zod.uuid(),
          })
          .describe(
            "An ordered, fax-specific reference to a confirmed file attachment.",
          ),
      )
      .max(sendPatientFaxBodyAttachmentsMax)
      .optional(),
    body_markdown: zod.string().min(1).max(sendPatientFaxBodyBodyMarkdownMax),
    fax_date: zod.iso.date().optional(),
    prepared_at: zod.iso.datetime({}).optional(),
    filename: zod
      .string()
      .min(1)
      .max(sendPatientFaxBodyFilenameMax)
      .default(sendPatientFaxBodyFilenameDefault),
    send_id: zod.uuid(),
  })
  .describe("Final fax content plus the idempotency key for one send attempt.");

export const sendPatientFaxResponse = zod
  .object({
    id: zod.uuid(),
    patientId: zod.uuid(),
    destinationFaxNumber: zod.string(),
    status: zod.enum([
      "preparing",
      "queued",
      "submitted",
      "delivered",
      "failed",
      "canceled",
    ]),
    documentByteLength: zod.number(),
    documentSha256: zod.string(),
    documentUrl: zod.union([zod.string(), zod.null()]).optional(),
    providerFaxId: zod.union([zod.string(), zod.null()]),
    errorCode: zod.union([zod.string(), zod.null()]),
    errorMessage: zod.union([zod.string(), zod.null()]),
    submittedAt: zod.union([zod.iso.datetime({}), zod.null()]),
    completedAt: zod.union([zod.iso.datetime({}), zod.null()]),
    createdAt: zod.iso.datetime({}),
    updatedAt: zod.iso.datetime({}),
  })
  .describe("Clinician-safe metadata for one outbound fax.");

/**
 * @summary Fetch Patient Outbound Faxes
 */
export const fetchPatientOutboundFaxesParams = zod.object({
  user_id: zod.uuid(),
});

export const fetchPatientOutboundFaxesResponse = zod.object({
  faxes: zod.array(
    zod
      .object({
        id: zod.uuid(),
        patientId: zod.uuid(),
        destinationFaxNumber: zod.string(),
        status: zod.enum([
          "preparing",
          "queued",
          "submitted",
          "delivered",
          "failed",
          "canceled",
        ]),
        documentByteLength: zod.number(),
        documentSha256: zod.string(),
        documentUrl: zod.union([zod.string(), zod.null()]).optional(),
        providerFaxId: zod.union([zod.string(), zod.null()]),
        errorCode: zod.union([zod.string(), zod.null()]),
        errorMessage: zod.union([zod.string(), zod.null()]),
        submittedAt: zod.union([zod.iso.datetime({}), zod.null()]),
        completedAt: zod.union([zod.iso.datetime({}), zod.null()]),
        createdAt: zod.iso.datetime({}),
        updatedAt: zod.iso.datetime({}),
      })
      .describe("Clinician-safe metadata for one outbound fax."),
  ),
});

/**
 * @summary Fetch Patient Inbound Faxes
 */
export const fetchPatientInboundFaxesParams = zod.object({
  user_id: zod.uuid(),
});

export const fetchPatientInboundFaxesResponseFaxesItemLinkTypeDefault =
  "patient";
export const fetchPatientInboundFaxesResponseFaxesItemLinkTypeDefaultOne =
  "problem";
export const fetchPatientInboundFaxesResponseFaxesItemLinkTypeDefaultTwo =
  "request";
export const fetchPatientInboundFaxesResponseFaxesItemLinkTypeDefaultThree =
  "orphan";

export const fetchPatientInboundFaxesResponse = zod.object({
  faxes: zod.array(
    zod
      .object({
        id: zod.uuid(),
        patientId: zod.uuid(),
        providerFaxId: zod.string(),
        originatingFaxNumber: zod.union([zod.string(), zod.null()]),
        subject: zod.union([zod.string(), zod.null()]),
        status: zod.enum(["download_pending", "downloaded"]),
        documentByteLength: zod.union([zod.number(), zod.null()]),
        downloadedAt: zod.union([zod.iso.datetime({}), zod.null()]),
        documentUrl: zod.string(),
        link: zod.union([
          zod.object({
            type: zod
              .literal("patient")
              .default(
                fetchPatientInboundFaxesResponseFaxesItemLinkTypeDefault,
              ),
          }),
          zod.object({
            type: zod
              .literal("problem")
              .default(
                fetchPatientInboundFaxesResponseFaxesItemLinkTypeDefaultOne,
              ),
            id: zod.uuid(),
          }),
          zod.object({
            type: zod
              .literal("request")
              .default(
                fetchPatientInboundFaxesResponseFaxesItemLinkTypeDefaultTwo,
              ),
            id: zod.uuid(),
          }),
          zod.object({
            type: zod
              .literal("orphan")
              .default(
                fetchPatientInboundFaxesResponseFaxesItemLinkTypeDefaultThree,
              ),
          }),
        ]),
        reviewRequestId: zod.union([zod.uuid(), zod.null()]),
        createdAt: zod.iso.datetime({}),
        updatedAt: zod.iso.datetime({}),
      })
      .describe(
        "Clinician-safe metadata for an inbound fax linked to a patient.",
      ),
  ),
});

/**
 * @summary Fetch Patient Outbound Fax Document
 */
export const fetchPatientOutboundFaxDocumentParams = zod.object({
  user_id: zod.uuid(),
  fax_id: zod.uuid(),
});

export const fetchPatientOutboundFaxDocumentResponse = zod.unknown();

/**
 * @summary Fetch Patient Inbound Fax Document
 */
export const fetchPatientInboundFaxDocumentParams = zod.object({
  user_id: zod.uuid(),
  fax_id: zod.uuid(),
});

export const fetchPatientInboundFaxDocumentResponse = zod.unknown();

/**
 * @summary Shelf Store
 */
export const shelfStoreParams = zod.object({
  patient_id: zod.uuid(),
});

export const shelfStoreBodyKeyMax = 512;

export const shelfStoreBody = zod.object({
  key: zod.string().max(shelfStoreBodyKeyMax),
  value: zod.array(zod.record(zod.string(), zod.unknown())),
  metadata: zod.record(zod.string(), zod.unknown()).optional(),
});

export const shelfStoreResponse = zod.unknown();

/**
 * @summary Shelf Remove Item
 */
export const shelfRemoveItemParams = zod.object({
  patient_id: zod.uuid(),
});

export const shelfRemoveItemQueryParams = zod.object({
  key: zod.string(),
  item_id: zod.string(),
});

export const shelfRemoveItemResponse = zod.object({
  removed: zod.boolean(),
});

/**
 * @summary Shelf Load
 */
export const shelfLoadParams = zod.object({
  patient_id: zod.uuid(),
});

export const shelfLoadQueryParams = zod.object({
  key: zod.string(),
});

export const shelfLoadResponse = zod.object({
  key: zod.string(),
  value: zod.array(zod.record(zod.string(), zod.unknown())),
  metadata: zod.record(zod.string(), zod.unknown()),
});

/**
 * @summary Shelf List
 */
export const shelfListParams = zod.object({
  patient_id: zod.uuid(),
});

export const shelfListResponse = zod.object({
  entries: zod.array(
    zod.object({
      key: zod.string(),
      metadata: zod.record(zod.string(), zod.unknown()),
    }),
  ),
});

/**
 * Create an editable draft for a PA that requires an attachment.
 * @summary Draft Lmn
 */
export const draftLmnBody = zod.object({
  patient_user_id: zod
    .uuid()
    .describe("Patient currently open in the Cortex workspace."),
  prior_auth_record_id: zod
    .uuid()
    .describe(
      "Internal UUID of the DoseSpot prior auth record the LMN belongs to.",
    ),
  regeneration_hint: zod
    .union([zod.string(), zod.null()])
    .optional()
    .describe("Optional clinician instruction for revising the draft."),
});

export const draftLmnResponse = zod
  .object({
    prior_auth_record_id: zod.uuid(),
    case_number: zod.string(),
    markdown: zod.string(),
    summary: zod.string(),
    flagged_gaps: zod.array(zod.string()),
  })
  .describe("Editable LMN draft tied to the PA case it was created for.");

/**
 * Draft an LMN while streaming concise progress from real agent events.
 * @summary Stream Lmn Draft
 */
export const streamLmnDraftBody = zod.object({
  patient_user_id: zod
    .uuid()
    .describe("Patient currently open in the Cortex workspace."),
  prior_auth_record_id: zod
    .uuid()
    .describe(
      "Internal UUID of the DoseSpot prior auth record the LMN belongs to.",
    ),
  regeneration_hint: zod
    .union([zod.string(), zod.null()])
    .optional()
    .describe("Optional clinician instruction for revising the draft."),
});

/**
 * Check if the PA would accept an attachment.
 * @summary Check Would Pa Accept Attachment Lmn
 */
export const checkWouldPaAcceptAttachmentLmnBody = zod.object({
  patient_user_id: zod
    .uuid()
    .describe("Patient currently open in the Cortex workspace."),
  prior_auth_record_id: zod
    .uuid()
    .describe(
      "Internal UUID of the DoseSpot prior auth record the LMN belongs to.",
    ),
});

export const checkWouldPaAcceptAttachmentLmnResponse = zod.object({
  would_accept: zod.boolean(),
  message: zod.string(),
});

/**
 * Electronically sign as the authenticated requester and upload the PDF.
 * @summary Sign And Attach Lmn
 */

export const signAndAttachLmnBody = zod
  .object({
    patient_user_id: zod
      .uuid()
      .describe("Patient currently open in the Cortex workspace."),
    prior_auth_record_id: zod
      .uuid()
      .describe(
        "Internal UUID of the DoseSpot prior auth record the LMN belongs to.",
      ),
    markdown: zod
      .string()
      .min(1)
      .describe("Current LMN letter body in markdown."),
  })
  .describe("Body shared by both attach endpoints.");

export const signAndAttachLmnResponseCurrentCaseDosespotCaseAnsweredQuestionsItemAnswersDefault =
  [];
export const signAndAttachLmnResponseCurrentCaseDosespotCaseAnsweredQuestionsDefault =
  [];

export const signAndAttachLmnResponse = zod.object({
  outcome: zod.enum([
    "APPLIED",
    "REJECTED",
    "CONFIRMATION_PENDING",
    "APPLIED_LOCAL_SYNC_PENDING",
  ]),
  currentCase: zod
    .object({
      caseId: zod.string(),
      prescriptionRecordId: zod.string(),
      initiationState: zod.enum([
        "STARTING",
        "CONFIRMED",
        "RESULT_UNCLEAR",
        "FAILED",
      ]),
      workflowState: zod
        .enum([
          "INITIATING",
          "CONFIRMING_INITIATION",
          "INITIATION_FAILED",
          "QUESTION_REQUIRED",
          "ATTACHMENT_REQUIRED",
          "READY_TO_SUBMIT",
          "SUBMISSION_FAILED",
          "PAYER_REVIEW",
          "APPEAL_REVIEW",
          "CANCELLATION_REVIEW",
          "APPROVED_READY_TO_SEND",
          "NOT_REQUIRED_READY_TO_SEND",
          "PARTIAL_APPROVAL_DECISION",
          "DENIAL_DECISION",
          "PA_FAILED",
          "SENT",
          "CANCELED",
          "SUPERSEDED",
          "ENDED",
        ])
        .describe("What is happening in the PA workflow right now."),
      currentOwner: zod
        .enum(["LOTUS_AUTOMATION", "PAYER", "CLINICIAN", "NONE"])
        .describe("The person or system expected to take the next action."),
      prescriber: zod.string(),
      isCurrentClinicianPrescriber: zod.boolean(),
      allowedActions: zod.array(
        zod
          .enum([
            "ANSWER_QUESTION",
            "UPLOAD_ATTACHMENT",
            "CANCEL",
            "SUBMIT",
            "SEND_PRESCRIPTION",
            "APPEAL",
            "END_PLAN",
            "SELF_PAY",
          ])
          .describe(
            "An action the clinician may take in the current workflow state.",
          ),
      ),
      initiationFailureReason: zod.union([zod.string(), zod.null()]).optional(),
      dosespotCase: zod
        .union([
          zod
            .object({
              caseNumber: zod.string(),
              case: zod
                .object({
                  PriorAuthorizationCaseId: zod
                    .union([zod.number(), zod.null()])
                    .optional(),
                  PrescriptionId: zod
                    .union([zod.number(), zod.null()])
                    .optional(),
                  CaseAlias: zod.union([zod.string(), zod.null()]).optional(),
                  Note: zod.union([zod.string(), zod.null()]).optional(),
                  IsOffline: zod.union([zod.boolean(), zod.null()]).optional(),
                  InitializedDate: zod
                    .union([zod.iso.datetime({}), zod.null()])
                    .optional(),
                  NextResponseDeadline: zod
                    .union([zod.iso.datetime({}), zod.null()])
                    .optional(),
                  CurrentStatus: zod
                    .union([
                      zod
                        .enum([
                          "Unknown",
                          "Requested",
                          "NotRequired",
                          "Closed",
                          "Deferred",
                          "ActionRequired",
                          "Pending",
                          "Approved",
                          "Denied",
                          "AppealRequested",
                          "CancelRequested",
                          "Canceled",
                          "CancelDenied",
                          "Error",
                          "Deleted",
                          "PartiallyDenied",
                          "InProcess",
                        ])
                        .describe(
                          "Raw `PriorAuthorizationStatusType` values returned by DoseSpot.\n\nAll 17 values from the v2 `PriorAuthorizationStatusType` enum. We collapse\nthese (plus `ClosedReasonCodeId` on `Closed`) into a smaller internal\n`CareStatePriorAuthStatusT` in the poller; the raw string is still stored\non `DosespotPriorAuthRecord.current_status` for observability.",
                        ),
                      zod.null(),
                    ])
                    .optional(),
                  CurrentStatusDate: zod
                    .union([zod.iso.datetime({}), zod.null()])
                    .optional(),
                  ExpectedResponseDate: zod
                    .union([zod.iso.datetime({}), zod.null()])
                    .optional(),
                  AttachmentRequired: zod
                    .union([zod.boolean(), zod.null()])
                    .optional(),
                  NextQuestionId: zod
                    .union([zod.number(), zod.null()])
                    .optional(),
                  IsExpedited: zod
                    .union([zod.boolean(), zod.null()])
                    .optional(),
                  FinalStatus: zod
                    .union([
                      zod
                        .object({
                          PriorAuthorizationStatusType: zod
                            .union([
                              zod
                                .enum([
                                  "Unknown",
                                  "Requested",
                                  "NotRequired",
                                  "Closed",
                                  "Deferred",
                                  "ActionRequired",
                                  "Pending",
                                  "Approved",
                                  "Denied",
                                  "AppealRequested",
                                  "CancelRequested",
                                  "Canceled",
                                  "CancelDenied",
                                  "Error",
                                  "Deleted",
                                  "PartiallyDenied",
                                  "InProcess",
                                ])
                                .describe(
                                  "Raw `PriorAuthorizationStatusType` values returned by DoseSpot.\n\nAll 17 values from the v2 `PriorAuthorizationStatusType` enum. We collapse\nthese (plus `ClosedReasonCodeId` on `Closed`) into a smaller internal\n`CareStatePriorAuthStatusT` in the poller; the raw string is still stored\non `DosespotPriorAuthRecord.current_status` for observability.",
                                ),
                              zod.null(),
                            ])
                            .optional(),
                          ClosedReasonCodeId: zod
                            .union([
                              zod
                                .enum([
                                  "Unknown",
                                  "ElectronicPriorAuthNotSupported",
                                  "Other",
                                  "PriorAuthNotRequired",
                                  "CannotFindMatchingPatient",
                                  "PatientNotEligible",
                                  "PriorAuthDuplicateApproved",
                                  "PriorAuthDuplicateInProcess",
                                  "ClosedByPayer",
                                  "ClosedByProvider",
                                  "ClosedByMember",
                                  "AttachmentTypeNotSupported",
                                  "PrescriberNotAllowedToSubmitPARequest",
                                  "ResponseInconsistentWithQuestion",
                                  "ReceiverNotPAProcessorForThisPatient",
                                  "ReceiverNotPAProcessorForPatientMedicationCombo",
                                  "DuplicateDenied",
                                  "ProviderRespondedAfterDeadlineToReply",
                                  "ProductNotCoveredByThisPlanPriorAuthorizationNotAvailable",
                                  "PrescriptionWithinPrescribingLimitsPriorAuthorizationNotRequiredForPatientMedication",
                                  "CoverageLimitsMayExistForQuantityAndOrDaysSupply",
                                  "CoverageLimitsHaveBeenExceededExceptionNotAvailable",
                                  "ActivePAOnFile",
                                  "SubmittedProductCodeIsNotValid",
                                ])
                                .describe(
                                  "Raw `ClosedReasonCodeId` values on a `Closed` PA case.\n\nAll 25 values from the v2 `ClosedReasonCodeId` enum. Combined with the\n`Closed` super-status these disambiguate terminal outcomes (see\n`PRIOR_AUTH.md` for the mapping to our normalized status).",
                                ),
                              zod.null(),
                            ])
                            .optional(),
                          AuthorizationNumber: zod
                            .union([zod.string(), zod.null()])
                            .optional(),
                          AuthorizationPeriodStart: zod
                            .union([zod.iso.datetime({}), zod.null()])
                            .optional(),
                          AuthorizationPeriodEnd: zod
                            .union([zod.iso.datetime({}), zod.null()])
                            .optional(),
                          PharmacyType: zod
                            .union([
                              zod
                                .enum([
                                  "Unknown",
                                  "Retail",
                                  "MailOrder",
                                  "SpecialtyPharmacy",
                                  "LongTermCarePharmacy",
                                  "Any",
                                  "TwentyFourHourPharmacy",
                                  "FaxPharmacy",
                                  "EPCS",
                                  "InHouseDispensing",
                                  "Compounding",
                                  "DME",
                                  "Kiosk",
                                  "SupportsDigitalSignature",
                                  "FaxPharmacyExternal",
                                ])
                                .describe(
                                  "Raw `PharmacyType` values returned on `PAFinalStatus`.\n\nAll 15 values from the v2 `PharmacyType` enum. Carried through to\n`DosespotPriorAuthRecord.pharmacy_type` so downstream Rx routing can be\nconstrained to match the approved channel.",
                                ),
                              zod.null(),
                            ])
                            .optional(),
                          Quantity: zod
                            .union([zod.string(), zod.null()])
                            .optional(),
                          DaysSupply: zod
                            .union([zod.string(), zod.null()])
                            .optional(),
                          NumberOfCycles: zod
                            .union([zod.string(), zod.null()])
                            .optional(),
                          NumberOfRefills: zod
                            .union([zod.string(), zod.null()])
                            .optional(),
                          Note: zod
                            .union([zod.string(), zod.null()])
                            .optional(),
                          CanAppeal: zod
                            .union([zod.boolean(), zod.null()])
                            .optional(),
                        })
                        .describe(
                          "Terminal-state details on a closed PA case (`PAFinalStatus`).\n\n`PriorAuthorizationStatusType` holds the underlying DoseSpot status; for\ntruly closed cases `ClosedReasonCodeId` disambiguates approval vs. denial\nvs. not-required. `Quantity`, `DaysSupply`, `NumberOfCycles`, and\n`NumberOfRefills` are the payer's narrowed scope — all strings per the\nswagger — and drive downstream prescription-constraint enforcement.",
                        ),
                      zod.null(),
                    ])
                    .optional(),
                  AppealDetails: zod
                    .union([
                      zod
                        .object({
                          AppealCaseId: zod
                            .union([zod.string(), zod.null()])
                            .optional(),
                          NotesForAppeal: zod
                            .union([zod.string(), zod.null()])
                            .optional(),
                          AppealReason: zod
                            .union([zod.string(), zod.null()])
                            .optional(),
                        })
                        .describe(
                          "Appeal metadata for an appealed PA case (`PAAppealDetails`).",
                        ),
                      zod.null(),
                    ])
                    .optional(),
                  CancelDetails: zod
                    .union([
                      zod
                        .object({
                          CancelReason: zod
                            .union([zod.string(), zod.null()])
                            .optional(),
                        })
                        .describe(
                          "Cancellation metadata for a cancelled PA case (`PACancelDetails`).",
                        ),
                      zod.null(),
                    ])
                    .optional(),
                  Attachments: zod
                    .union([
                      zod.array(
                        zod
                          .object({
                            AttachmentId: zod
                              .union([zod.number(), zod.null()])
                              .optional(),
                            CreatedDateStamp: zod
                              .union([zod.iso.datetime({}), zod.null()])
                              .optional(),
                            FileName: zod
                              .union([zod.string(), zod.null()])
                              .optional(),
                            IsOutbound: zod
                              .union([zod.boolean(), zod.null()])
                              .optional(),
                          })
                          .describe(
                            "A single attachment on a PA case (`PAAttachment`).",
                          ),
                      ),
                      zod.null(),
                    ])
                    .optional(),
                })
                .describe(
                  "Full details of a PA case (`PriorAuthorizationCaseFullDetails`).\n\nReturned by `GET \/api\/priorAuths\/{id}` and list items under\n`GET \/api\/patients\/{patientId}\/priorAuths`. The whole payload is also\nstored verbatim on `DosespotPriorAuthRecord.cached_case` so downstream\nprocessing has access to every field (including `FinalStatus.Quantity` \/\n`DaysSupply` \/ `NumberOfCycles` \/ `NumberOfRefills`).",
                ),
              lastRefreshedAt: zod.union([zod.string(), zod.null()]).optional(),
              history: zod
                .union([
                  zod
                    .object({
                      FinalStatus: zod
                        .union([zod.string(), zod.null()])
                        .optional(),
                      AuthorizationNumber: zod
                        .union([zod.string(), zod.null()])
                        .optional(),
                      EffectiveDate: zod
                        .union([zod.iso.datetime({}), zod.null()])
                        .optional(),
                      ExpirationDate: zod
                        .union([zod.iso.datetime({}), zod.null()])
                        .optional(),
                      Note: zod.union([zod.string(), zod.null()]).optional(),
                      CanAppeal: zod
                        .union([zod.string(), zod.null()])
                        .optional(),
                      IsOffline: zod
                        .union([zod.boolean(), zod.null()])
                        .optional(),
                      Attachments: zod
                        .union([
                          zod.array(
                            zod
                              .object({
                                AttachmentId: zod
                                  .union([zod.number(), zod.null()])
                                  .optional(),
                                CreatedDateStamp: zod
                                  .union([zod.iso.datetime({}), zod.null()])
                                  .optional(),
                                FileName: zod
                                  .union([zod.string(), zod.null()])
                                  .optional(),
                                IsOutbound: zod
                                  .union([zod.boolean(), zod.null()])
                                  .optional(),
                              })
                              .describe(
                                "A single attachment on a PA case (`PAAttachment`).",
                              ),
                          ),
                          zod.null(),
                        ])
                        .optional(),
                      StatusLogs: zod
                        .union([
                          zod.array(
                            zod
                              .object({
                                Status: zod
                                  .union([zod.string(), zod.null()])
                                  .optional(),
                                AdditionalInfo: zod
                                  .union([zod.string(), zod.null()])
                                  .optional(),
                                AdditionalInfoAttachmentId: zod
                                  .union([zod.number(), zod.null()])
                                  .optional(),
                                CreatedDateStamp: zod
                                  .union([zod.iso.datetime({}), zod.null()])
                                  .optional(),
                                Attachment: zod
                                  .union([
                                    zod
                                      .object({
                                        AttachmentId: zod
                                          .union([zod.number(), zod.null()])
                                          .optional(),
                                        CreatedDateStamp: zod
                                          .union([
                                            zod.iso.datetime({}),
                                            zod.null(),
                                          ])
                                          .optional(),
                                        FileName: zod
                                          .union([zod.string(), zod.null()])
                                          .optional(),
                                        IsOutbound: zod
                                          .union([zod.boolean(), zod.null()])
                                          .optional(),
                                      })
                                      .describe(
                                        "A single attachment on a PA case (`PAAttachment`).",
                                      ),
                                    zod.null(),
                                  ])
                                  .optional(),
                              })
                              .describe(
                                "A single row in a PA status log.\n\nUnified shape covering both `PAStatusLog` (embedded in the history\nresponse — carries `AdditionalInfoAttachmentId`) and `PriorAuthStatusLogUI`\n(the `\/statusLog` endpoint — carries a fully-expanded `Attachment`). Only\none of the attachment fields is populated per row depending on the source.",
                              ),
                          ),
                          zod.null(),
                        ])
                        .optional(),
                      QuestionSets: zod
                        .union([
                          zod.array(
                            zod
                              .object({
                                PriorAuthorizationQuestionSetId: zod
                                  .union([zod.number(), zod.null()])
                                  .optional(),
                                QuestionSetAlias: zod
                                  .union([zod.string(), zod.null()])
                                  .optional(),
                                Title: zod
                                  .union([zod.string(), zod.null()])
                                  .optional(),
                                AnsweredQuestions: zod
                                  .union([
                                    zod.array(
                                      zod
                                        .object({
                                          Question: zod
                                            .union([zod.string(), zod.null()])
                                            .optional(),
                                          Answers: zod
                                            .union([
                                              zod.array(
                                                zod
                                                  .object({
                                                    Answer: zod
                                                      .union([
                                                        zod.string(),
                                                        zod.null(),
                                                      ])
                                                      .optional(),
                                                    AnswerDateTime: zod
                                                      .union([
                                                        zod.iso.datetime({}),
                                                        zod.null(),
                                                      ])
                                                      .optional(),
                                                    AnswerNumeric: zod
                                                      .union([
                                                        zod.number(),
                                                        zod.null(),
                                                      ])
                                                      .optional(),
                                                    AnswerFreeText: zod
                                                      .union([
                                                        zod.string(),
                                                        zod.null(),
                                                      ])
                                                      .optional(),
                                                  })
                                                  .describe(
                                                    "One captured answer in a PA question history (`PAAnswers`).\n\nOnly one of `AnswerDateTime` \/ `AnswerNumeric` \/ `AnswerFreeText` \/\n`Answer` is populated per row, determined by the question's\n`PriorAuthorizationAnswerTypeT`.",
                                                  ),
                                              ),
                                              zod.null(),
                                            ])
                                            .optional(),
                                        })
                                        .describe(
                                          "A question together with its answers (`PAAnsweredQuestions`).",
                                        ),
                                    ),
                                    zod.null(),
                                  ])
                                  .optional(),
                                Attachments: zod
                                  .union([
                                    zod.array(
                                      zod
                                        .object({
                                          AttachmentId: zod
                                            .union([zod.number(), zod.null()])
                                            .optional(),
                                          CreatedDateStamp: zod
                                            .union([
                                              zod.iso.datetime({}),
                                              zod.null(),
                                            ])
                                            .optional(),
                                          FileName: zod
                                            .union([zod.string(), zod.null()])
                                            .optional(),
                                          IsOutbound: zod
                                            .union([zod.boolean(), zod.null()])
                                            .optional(),
                                        })
                                        .describe(
                                          "A single attachment on a PA case (`PAAttachment`).",
                                        ),
                                    ),
                                    zod.null(),
                                  ])
                                  .optional(),
                              })
                              .describe(
                                "One question-set block inside a PA history (`PAHistoryQuestionSet`).",
                              ),
                          ),
                          zod.null(),
                        ])
                        .optional(),
                      Result: zod
                        .union([
                          zod
                            .object({
                              ResultCode: zod.string(),
                              ResultDescription: zod
                                .union([zod.string(), zod.null()])
                                .optional(),
                            })
                            .describe("Standard DoseSpot API result object."),
                          zod.null(),
                        ])
                        .optional(),
                    })
                    .describe(
                      "Full PA history payload (`PriorAuthorizationHistoryResponse`).\n\nStored verbatim on `DosespotPriorAuthRecord.cached_history` so the\nquestion\/answer trail and status log remain available for audit and\ncopilot context.",
                    ),
                  zod.null(),
                ])
                .optional(),
              statusLog: zod
                .union([
                  zod
                    .object({
                      StatusLog: zod
                        .union([
                          zod.array(
                            zod
                              .object({
                                Status: zod
                                  .union([zod.string(), zod.null()])
                                  .optional(),
                                AdditionalInfo: zod
                                  .union([zod.string(), zod.null()])
                                  .optional(),
                                AdditionalInfoAttachmentId: zod
                                  .union([zod.number(), zod.null()])
                                  .optional(),
                                CreatedDateStamp: zod
                                  .union([zod.iso.datetime({}), zod.null()])
                                  .optional(),
                                Attachment: zod
                                  .union([
                                    zod
                                      .object({
                                        AttachmentId: zod
                                          .union([zod.number(), zod.null()])
                                          .optional(),
                                        CreatedDateStamp: zod
                                          .union([
                                            zod.iso.datetime({}),
                                            zod.null(),
                                          ])
                                          .optional(),
                                        FileName: zod
                                          .union([zod.string(), zod.null()])
                                          .optional(),
                                        IsOutbound: zod
                                          .union([zod.boolean(), zod.null()])
                                          .optional(),
                                      })
                                      .describe(
                                        "A single attachment on a PA case (`PAAttachment`).",
                                      ),
                                    zod.null(),
                                  ])
                                  .optional(),
                              })
                              .describe(
                                "A single row in a PA status log.\n\nUnified shape covering both `PAStatusLog` (embedded in the history\nresponse — carries `AdditionalInfoAttachmentId`) and `PriorAuthStatusLogUI`\n(the `\/statusLog` endpoint — carries a fully-expanded `Attachment`). Only\none of the attachment fields is populated per row depending on the source.",
                              ),
                          ),
                          zod.null(),
                        ])
                        .optional(),
                      Result: zod
                        .union([
                          zod
                            .object({
                              ResultCode: zod.string(),
                              ResultDescription: zod
                                .union([zod.string(), zod.null()])
                                .optional(),
                            })
                            .describe("Standard DoseSpot API result object."),
                          zod.null(),
                        ])
                        .optional(),
                    })
                    .describe(
                      "UI-oriented status log response (`PriorAuthorizationStatusLogUIResponse`).",
                    ),
                  zod.null(),
                ])
                .optional(),
              pendingQuestion: zod
                .union([
                  zod
                    .object({
                      QuestionText: zod
                        .union([zod.string(), zod.null()])
                        .optional(),
                      AnswerType: zod
                        .union([
                          zod
                            .enum([
                              "Select",
                              "Multiselect",
                              "Date",
                              "DateTime",
                              "Numeric",
                              "FreeText",
                            ])
                            .describe(
                              "Kind of answer a PA question expects.\n\nDrives which form widget the clinician UI renders for each question and,\nconsequently, which field(s) of ``PriorAuthorizationAnswerRequestT`` must\nbe populated when submitting the answer.",
                            ),
                          zod.null(),
                        ])
                        .optional(),
                      AnswerChoices: zod
                        .union([
                          zod.array(
                            zod
                              .object({
                                QuestionChoiceId: zod
                                  .union([zod.number(), zod.null()])
                                  .optional(),
                                QuestionChoiceText: zod
                                  .union([zod.string(), zod.null()])
                                  .optional(),
                                AdditionalFreeTextRequired: zod
                                  .union([zod.boolean(), zod.null()])
                                  .optional(),
                                AdditionalFreeTextAllowed: zod
                                  .union([zod.boolean(), zod.null()])
                                  .optional(),
                              })
                              .describe(
                                "One selectable choice on a PA question (`PriorAuthorizationQuestionResponseChoice`).",
                              ),
                          ),
                          zod.null(),
                        ])
                        .optional(),
                      Result: zod
                        .union([
                          zod
                            .object({
                              ResultCode: zod.string(),
                              ResultDescription: zod
                                .union([zod.string(), zod.null()])
                                .optional(),
                            })
                            .describe("Standard DoseSpot API result object."),
                          zod.null(),
                        ])
                        .optional(),
                    })
                    .describe(
                      "Single PA question detail (`PriorAuthQuestionResponse`).",
                    ),
                  zod.null(),
                ])
                .optional(),
              pendingQuestionId: zod
                .union([zod.string(), zod.null()])
                .optional(),
              answeredQuestions: zod
                .array(
                  zod
                    .object({
                      questionId: zod.string(),
                      questionText: zod
                        .union([zod.string(), zod.null()])
                        .optional(),
                      question: zod
                        .union([
                          zod
                            .object({
                              QuestionText: zod
                                .union([zod.string(), zod.null()])
                                .optional(),
                              AnswerType: zod
                                .union([
                                  zod
                                    .enum([
                                      "Select",
                                      "Multiselect",
                                      "Date",
                                      "DateTime",
                                      "Numeric",
                                      "FreeText",
                                    ])
                                    .describe(
                                      "Kind of answer a PA question expects.\n\nDrives which form widget the clinician UI renders for each question and,\nconsequently, which field(s) of ``PriorAuthorizationAnswerRequestT`` must\nbe populated when submitting the answer.",
                                    ),
                                  zod.null(),
                                ])
                                .optional(),
                              AnswerChoices: zod
                                .union([
                                  zod.array(
                                    zod
                                      .object({
                                        QuestionChoiceId: zod
                                          .union([zod.number(), zod.null()])
                                          .optional(),
                                        QuestionChoiceText: zod
                                          .union([zod.string(), zod.null()])
                                          .optional(),
                                        AdditionalFreeTextRequired: zod
                                          .union([zod.boolean(), zod.null()])
                                          .optional(),
                                        AdditionalFreeTextAllowed: zod
                                          .union([zod.boolean(), zod.null()])
                                          .optional(),
                                      })
                                      .describe(
                                        "One selectable choice on a PA question (`PriorAuthorizationQuestionResponseChoice`).",
                                      ),
                                  ),
                                  zod.null(),
                                ])
                                .optional(),
                              Result: zod
                                .union([
                                  zod
                                    .object({
                                      ResultCode: zod.string(),
                                      ResultDescription: zod
                                        .union([zod.string(), zod.null()])
                                        .optional(),
                                    })
                                    .describe(
                                      "Standard DoseSpot API result object.",
                                    ),
                                  zod.null(),
                                ])
                                .optional(),
                            })
                            .describe(
                              "Single PA question detail (`PriorAuthQuestionResponse`).",
                            ),
                          zod.null(),
                        ])
                        .optional(),
                      answers: zod
                        .array(
                          zod
                            .object({
                              Answer: zod
                                .union([zod.string(), zod.null()])
                                .optional(),
                              AnswerDateTime: zod
                                .union([zod.iso.datetime({}), zod.null()])
                                .optional(),
                              AnswerNumeric: zod
                                .union([zod.number(), zod.null()])
                                .optional(),
                              AnswerFreeText: zod
                                .union([zod.string(), zod.null()])
                                .optional(),
                            })
                            .describe(
                              "One captured answer in a PA question history (`PAAnswers`).\n\nOnly one of `AnswerDateTime` \/ `AnswerNumeric` \/ `AnswerFreeText` \/\n`Answer` is populated per row, determined by the question's\n`PriorAuthorizationAnswerTypeT`.",
                            ),
                        )
                        .default(
                          signAndAttachLmnResponseCurrentCaseDosespotCaseAnsweredQuestionsItemAnswersDefault,
                        ),
                    })
                    .describe(
                      "A previously-answered PA question, resolved back to its DoseSpot id.\n\nDoseSpot's history payload lists answered questions by \*text\* only, so we\npair each recorded observed question (captured when the clinician answered\nit) with the question detail. Carrying the full ``question`` (answer type +\nchoices) lets the copilot re-render the exact same answer form so the\nclinician can revise their reply and POST a new answer to ``question_id`` —\nDoseSpot accepts a fresh answer to an already-answered question until the\ncase is submitted.",
                    ),
                )
                .default(
                  signAndAttachLmnResponseCurrentCaseDosespotCaseAnsweredQuestionsDefault,
                ),
            })
            .describe(
              "DoseSpot facts available after Lotus confirms the external case.\n\nWraps the three DoseSpot read-only payloads (case details, history,\nstatus log) alongside the payer's currently-pending question when there\nis one. The frontend renders the question form from\n``pending_question`` when ``case.NextQuestionId`` is populated and\nstatus is ``ACTION_REQUIRED``.\n\n``answered_questions`` carries the already-answered questions resolved\nback to their DoseSpot ids so the clinician can re-open one and revise\nthe answer before submitting.",
            ),
          zod.null(),
        ])
        .optional(),
    })
    .describe(
      "Current Lotus workflow state for one durable PA case.\n\nThis local view exists from the first initiation attempt through the final\noutcome. ``dosespot_case`` is populated only after Lotus has confirmed and\nread the external case, keeping DoseSpot-owned facts separate from the\nLotus-owned workflow state and allowed actions.",
    ),
  rejectionCode: zod
    .union([
      zod.enum([
        "ACTION_NOT_ALLOWED",
        "DOSESPOT_CASE_NOT_CONFIRMED",
        "DOSESPOT_REJECTED",
        "OPERATION_IN_PROGRESS",
        "PRESCRIBER_REQUIRED",
        "DECISION_NOT_ALLOWED",
        "ELIGIBILITY_REQUIRED",
        "PRESCRIPTION_READ_FAILED",
      ]),
      zod.null(),
    ])
    .optional(),
  rejectionDetail: zod.union([zod.string(), zod.null()]).optional(),
});

/**
 * Render ``markdown`` to a PDF and stream it with a
``Content-Disposition`` header so the browser triggers its native
Save dialog.
 * @summary Render Pdf
 */
export const renderPdfBodyTitleMax = 255;

export const renderPdfBodyFilenameMax = 128;

export const renderPdfBody = zod.object({
  title: zod
    .string()
    .min(1)
    .max(renderPdfBodyTitleMax)
    .describe("Set as the PDF document metadata title."),
  markdown: zod.string().min(1).describe("Markdown body to render."),
  filename: zod
    .string()
    .min(1)
    .max(renderPdfBodyFilenameMax)
    .describe(
      "Filename the browser will save the download as. Must end in '.pdf' and may not contain newlines, path separators, or '..' segments.",
    ),
});

export const renderPdfResponse = zod.unknown();

/**
 * Render ``markdown`` to a Word ``.docx`` and stream it with a
``Content-Disposition`` header so the browser triggers its native
Save dialog.
 * @summary Render Docx
 */
export const renderDocxBodyTitleMax = 255;

export const renderDocxBodyFilenameMax = 128;

export const renderDocxBody = zod.object({
  title: zod
    .string()
    .min(1)
    .max(renderDocxBodyTitleMax)
    .describe(
      "Set as the .docx core property 'title'; shows up in Word's recents-list and document properties pane.",
    ),
  markdown: zod.string().min(1).describe("Markdown body to render."),
  filename: zod
    .string()
    .min(1)
    .max(renderDocxBodyFilenameMax)
    .describe(
      "Filename the browser will save the download as. Must end in '.docx' and may not contain newlines, path separators, or '..' segments.",
    ),
});

export const renderDocxResponse = zod.unknown();

/**
 * Fetch all active viewers for a patient, excluding the requesting clinician.
 * @summary Fetch Viewers For Patient
 */
export const fetchViewersForPatientParams = zod.object({
  user_id: zod.uuid(),
});

export const fetchViewersForPatientResponse = zod.object({
  viewers: zod.array(
    zod.object({
      full_name: zod.string(),
      display_name: zod.string(),
    }),
  ),
});

/**
 * Check which clinical workflows are available for a patient.

Returns availability of lab ordering (requires insurance info) and
prescription writing (requires an existing DoseSpot patient record).
 * @summary Fetch Workflows Available
 */
export const fetchWorkflowsAvailableParams = zod.object({
  user_id: zod.string(),
});

export const fetchWorkflowsAvailableResponse = zod
  .object({
    canOrderLabs: zod.boolean(),
    canWritePrescription: zod.boolean(),
  })
  .describe(
    "Indicates which clinical workflows are currently available for a patient.",
  );

/**
 * Apply an ordered list of modifications to a patient's proposed actions.

Modifications can add, update, or remove (archive) actions. They are
applied sequentially so earlier mutations are visible to later ones.
 * @summary Apply Plan Modifications
 */
export const applyPlanModificationsParams = zod.object({
  user_id: zod.uuid(),
});

export const applyPlanModificationsBodyModificationsItemTypeDefault = "add";
export const applyPlanModificationsBodyModificationsItemLinkTypeDefault =
  "patient";
export const applyPlanModificationsBodyModificationsItemLinkTypeDefaultOne =
  "problem";
export const applyPlanModificationsBodyModificationsItemLinkTypeDefaultTwo =
  "request";
export const applyPlanModificationsBodyModificationsItemLinkTypeDefaultThree =
  "orphan";
export const applyPlanModificationsBodyModificationsItemAlternativesDefault =
  [];

export const applyPlanModificationsBodyModificationsItemDependsOnActionExternalIdsDefault =
  [];
export const applyPlanModificationsBodyModificationsItemTypeDefaultOne =
  "update";
export const applyPlanModificationsBodyModificationsItemFieldsLinkTypeDefault =
  "patient";
export const applyPlanModificationsBodyModificationsItemFieldsLinkTypeDefaultOne =
  "problem";
export const applyPlanModificationsBodyModificationsItemFieldsLinkTypeDefaultTwo =
  "request";
export const applyPlanModificationsBodyModificationsItemFieldsLinkTypeDefaultThree =
  "orphan";
export const applyPlanModificationsBodyModificationsItemTypeDefaultTwo =
  "remove";

export const applyPlanModificationsBody = zod.object({
  modifications: zod.array(
    zod.union([
      zod
        .object({
          type: zod
            .literal("add")
            .default(applyPlanModificationsBodyModificationsItemTypeDefault),
          external_id: zod.string(),
          link: zod.union([
            zod.object({
              type: zod
                .literal("patient")
                .default(
                  applyPlanModificationsBodyModificationsItemLinkTypeDefault,
                ),
            }),
            zod.object({
              type: zod
                .literal("problem")
                .default(
                  applyPlanModificationsBodyModificationsItemLinkTypeDefaultOne,
                ),
              id: zod.uuid(),
            }),
            zod.object({
              type: zod
                .literal("request")
                .default(
                  applyPlanModificationsBodyModificationsItemLinkTypeDefaultTwo,
                ),
              id: zod.uuid(),
            }),
            zod.object({
              type: zod
                .literal("orphan")
                .default(
                  applyPlanModificationsBodyModificationsItemLinkTypeDefaultThree,
                ),
            }),
          ]),
          title: zod.string(),
          payload: zod
            .object({
              payload_id: zod.string(),
              tool_name: zod.string(),
              tool_input: zod.record(zod.string(), zod.unknown()),
              justification: zod.string(),
            })
            .describe(
              "A frozen tool call: the exact invocation to execute when the action is run.\n\nThis type is shared between CareState rows and REST API modification\nrecords. It deliberately does NOT use ``APIVIEW_MODEL_CONFIG`` because\nCareState serialisation (``model_dump()``) must produce snake_case keys\nand the SDK type must match that runtime shape. The REST API input layer\nconverts camelCase payload fields to snake_case before Pydantic sees them.\n\nThe opaque ``tool_input`` dict keys are never converted — they preserve\nwhatever casing the LLM originally used (typically camelCase).",
            ),
          alternatives: zod
            .array(
              zod
                .object({
                  payload_id: zod.string(),
                  tool_name: zod.string(),
                  tool_input: zod.record(zod.string(), zod.unknown()),
                  justification: zod.string(),
                })
                .describe(
                  "A frozen tool call: the exact invocation to execute when the action is run.\n\nThis type is shared between CareState rows and REST API modification\nrecords. It deliberately does NOT use ``APIVIEW_MODEL_CONFIG`` because\nCareState serialisation (``model_dump()``) must produce snake_case keys\nand the SDK type must match that runtime shape. The REST API input layer\nconverts camelCase payload fields to snake_case before Pydantic sees them.\n\nThe opaque ``tool_input`` dict keys are never converted — they preserve\nwhatever casing the LLM originally used (typically camelCase).",
                ),
            )
            .default(
              applyPlanModificationsBodyModificationsItemAlternativesDefault,
            ),
          justification: zod.string(),
          request_title: zod
            .union([zod.string().min(1), zod.null()])
            .optional(),
          request_message: zod
            .union([zod.string().min(1), zod.null()])
            .optional(),
          request_urgency: zod
            .union([zod.enum(["Routine", "Urgent"]), zod.null()])
            .optional(),
          depends_on_action_external_ids: zod
            .array(zod.string())
            .default(
              applyPlanModificationsBodyModificationsItemDependsOnActionExternalIdsDefault,
            ),
          todo_status: zod.enum(["Open", "Done", "Archived"]).optional(),
          decision: zod
            .enum(["Pending", "Approved", "AutoApproved", "Rejected"])
            .optional(),
        })
        .describe(
          "Add a new proposed action to the plan.\n\nThe system generates the internal ``id``; callers only provide\n``external_id`` (and use it for dependency references).",
        ),
      zod
        .object({
          type: zod
            .literal("update")
            .default(applyPlanModificationsBodyModificationsItemTypeDefaultOne),
          external_id: zod.string(),
          fields: zod
            .object({
              title: zod.union([zod.string(), zod.null()]).optional(),
              link: zod
                .union([
                  zod.union([
                    zod.object({
                      type: zod
                        .literal("patient")
                        .default(
                          applyPlanModificationsBodyModificationsItemFieldsLinkTypeDefault,
                        ),
                    }),
                    zod.object({
                      type: zod
                        .literal("problem")
                        .default(
                          applyPlanModificationsBodyModificationsItemFieldsLinkTypeDefaultOne,
                        ),
                      id: zod.uuid(),
                    }),
                    zod.object({
                      type: zod
                        .literal("request")
                        .default(
                          applyPlanModificationsBodyModificationsItemFieldsLinkTypeDefaultTwo,
                        ),
                      id: zod.uuid(),
                    }),
                    zod.object({
                      type: zod
                        .literal("orphan")
                        .default(
                          applyPlanModificationsBodyModificationsItemFieldsLinkTypeDefaultThree,
                        ),
                    }),
                  ]),
                  zod.null(),
                ])
                .optional(),
              decision: zod
                .union([
                  zod.enum(["Pending", "Approved", "AutoApproved", "Rejected"]),
                  zod.null(),
                ])
                .optional(),
              payload: zod
                .union([
                  zod
                    .object({
                      payload_id: zod.string(),
                      tool_name: zod.string(),
                      tool_input: zod.record(zod.string(), zod.unknown()),
                      justification: zod.string(),
                    })
                    .describe(
                      "A frozen tool call: the exact invocation to execute when the action is run.\n\nThis type is shared between CareState rows and REST API modification\nrecords. It deliberately does NOT use ``APIVIEW_MODEL_CONFIG`` because\nCareState serialisation (``model_dump()``) must produce snake_case keys\nand the SDK type must match that runtime shape. The REST API input layer\nconverts camelCase payload fields to snake_case before Pydantic sees them.\n\nThe opaque ``tool_input`` dict keys are never converted — they preserve\nwhatever casing the LLM originally used (typically camelCase).",
                    ),
                  zod.null(),
                ])
                .optional(),
              alternatives: zod
                .union([
                  zod.array(
                    zod
                      .object({
                        payload_id: zod.string(),
                        tool_name: zod.string(),
                        tool_input: zod.record(zod.string(), zod.unknown()),
                        justification: zod.string(),
                      })
                      .describe(
                        "A frozen tool call: the exact invocation to execute when the action is run.\n\nThis type is shared between CareState rows and REST API modification\nrecords. It deliberately does NOT use ``APIVIEW_MODEL_CONFIG`` because\nCareState serialisation (``model_dump()``) must produce snake_case keys\nand the SDK type must match that runtime shape. The REST API input layer\nconverts camelCase payload fields to snake_case before Pydantic sees them.\n\nThe opaque ``tool_input`` dict keys are never converted — they preserve\nwhatever casing the LLM originally used (typically camelCase).",
                      ),
                  ),
                  zod.null(),
                ])
                .optional(),
              justification: zod.union([zod.string(), zod.null()]).optional(),
              depends_on_action_external_ids: zod
                .union([zod.array(zod.string()), zod.null()])
                .optional(),
            })
            .describe(
              "Partial update payload: only non-None fields are applied.\n\nCallers supply only the fields they want to change.",
            ),
        })
        .describe(
          "Update an existing proposed action (looked up by external_id).",
        ),
      zod
        .object({
          type: zod
            .literal("remove")
            .default(applyPlanModificationsBodyModificationsItemTypeDefaultTwo),
          external_id: zod.string(),
        })
        .describe(
          "Remove a proposed action (soft-delete: marks it as archived).",
        ),
    ]),
  ),
});

export const applyPlanModificationsResponse = zod.object({
  result: zod.object({
    applied_external_ids: zod.array(zod.string()),
    errors: zod.array(
      zod
        .object({
          index: zod.number(),
          message: zod.string(),
        })
        .describe("Error for a single modification that could not be applied."),
    ),
  }),
});

/**
 * Swap the current payload of a proposed action with one of its alternatives.

The previous payload is moved into the alternatives list.
 * @summary Switch To Alternative
 */
export const switchToAlternativeParams = zod.object({
  user_id: zod.uuid(),
});

export const switchToAlternativeBody = zod.object({
  externalId: zod.string(),
  alternativePayloadId: zod.string(),
});

export const switchToAlternativeResponse = zod.object({
  result: zod.object({
    success: zod.boolean(),
    error: zod.union([zod.string(), zod.null()]).optional(),
  }),
});

/**
 * Mark an approved proposed action as successfully executed.

Checks that all dependency actions have succeeded before allowing
execution. Creates a run record and sets todo_status to done.
 * @summary Mark Executed
 */
export const markExecutedParams = zod.object({
  user_id: zod.uuid(),
});

export const markExecutedBody = zod.object({
  externalId: zod.string(),
  toolOutput: zod
    .union([zod.record(zod.string(), zod.unknown()), zod.null()])
    .optional(),
});

export const markExecutedResponse = zod.object({
  result: zod.object({
    success: zod.boolean(),
    error: zod.union([zod.string(), zod.null()]).optional(),
    unmet_dependency_external_ids: zod
      .union([zod.array(zod.string()), zod.null()])
      .optional(),
    tool_output: zod
      .union([zod.record(zod.string(), zod.unknown()), zod.null()])
      .optional(),
  }),
});

/**
 * Reject the original proposed action but record that the clinician
executed a revised version (e.g. changed the prescription or lab order
before confirming).
 * @summary Reject With Revision
 */
export const rejectWithRevisionParams = zod.object({
  user_id: zod.uuid(),
});

export const rejectWithRevisionBody = zod.object({
  externalId: zod.string(),
  toolOutput: zod
    .union([zod.record(zod.string(), zod.unknown()), zod.null()])
    .optional(),
});

export const rejectWithRevisionResponse = zod.object({
  result: zod.object({
    success: zod.boolean(),
    error: zod.union([zod.string(), zod.null()]).optional(),
    unmet_dependency_external_ids: zod
      .union([zod.array(zod.string()), zod.null()])
      .optional(),
    tool_output: zod
      .union([zod.record(zod.string(), zod.unknown()), zod.null()])
      .optional(),
  }),
});

/**
 * Return karma points earned by the logged-in clinician.

If ``days`` is provided, only events within the last N days are counted.
Otherwise returns the all-time total.
 * @summary Get Karma Total
 */
export const getKarmaTotalQueryDaysMaxOne = 365;

export const getKarmaTotalQueryParams = zod.object({
  days: zod
    .union([zod.number().min(1).max(getKarmaTotalQueryDaysMaxOne), zod.null()])
    .optional(),
});

export const getKarmaTotalResponse = zod.object({
  balance: zod.number(),
  earnings: zod.number(),
  payouts: zod.number(),
});

/**
 * Return karma points grouped into time buckets for charting.
 * @summary Get Karma Chart
 */
export const getKarmaChartQueryDaysDefault = 30;
export const getKarmaChartQueryDaysMax = 365;

export const getKarmaChartQueryParams = zod.object({
  days: zod
    .number()
    .min(1)
    .max(getKarmaChartQueryDaysMax)
    .default(getKarmaChartQueryDaysDefault),
  granularity: zod.enum(["day", "week", "month"]).optional(),
});

export const getKarmaChartResponse = zod.object({
  buckets: zod.array(
    zod.object({
      periodStart: zod.iso.datetime({}),
      balance: zod.number(),
      earnings: zod.number(),
      payouts: zod.number(),
    }),
  ),
});

/**
 * Return recent clinician activity events (transactions) for the logged-in clinician.
 * @summary Get Clinician Activity Events
 */
export const getClinicianActivityEventsQueryLimitDefault = 100;
export const getClinicianActivityEventsQueryLimitMax = 500;

export const getClinicianActivityEventsQueryParams = zod.object({
  limit: zod
    .number()
    .min(1)
    .max(getClinicianActivityEventsQueryLimitMax)
    .default(getClinicianActivityEventsQueryLimitDefault),
});

export const getClinicianActivityEventsResponseEventsItemEventTypeDefault =
  "request_closed";
export const getClinicianActivityEventsResponseEventsItemEventTypeDefaultOne =
  "prescription_written";
export const getClinicianActivityEventsResponseEventsItemEventTypeDefaultTwo =
  "lab_ordered";
export const getClinicianActivityEventsResponseEventsItemEventTypeDefaultThree =
  "care_action_recorded";
export const getClinicianActivityEventsResponseEventsItemEventTypeDefaultFour =
  "karma_payout";
export const getClinicianActivityEventsResponseEventsItemEventTypeDefaultFive =
  "correction";

export const getClinicianActivityEventsResponse = zod.object({
  events: zod.array(
    zod.object({
      id: zod.uuid(),
      clinicianId: zod.uuid(),
      patientId: zod.uuid(),
      event: zod.union([
        zod.object({
          type: zod
            .literal("request_closed")
            .default(
              getClinicianActivityEventsResponseEventsItemEventTypeDefault,
            ),
          request_id: zod.string(),
          from_status: zod
            .union([
              zod.enum(["Open", "Pending Follow Up", "Resolved", "Cancelled"]),
              zod.null(),
            ])
            .optional(),
          to_status: zod.enum([
            "Open",
            "Pending Follow Up",
            "Resolved",
            "Cancelled",
          ]),
          cpt_code: zod
            .union([
              zod
                .enum(["99212", "99213", "99214", "99215"])
                .describe(
                  "E\/M office visit CPT codes used to classify request complexity by MDM level.",
                ),
              zod.null(),
            ])
            .optional(),
          urgency: zod
            .union([zod.enum(["Routine", "Urgent"]), zod.null()])
            .optional(),
        }),
        zod.object({
          type: zod
            .literal("prescription_written")
            .default(
              getClinicianActivityEventsResponseEventsItemEventTypeDefaultOne,
            ),
          prescription_record_id: zod.string(),
          dosespot_prescription_id: zod.string(),
          is_refill: zod.union([zod.boolean(), zod.null()]).optional(),
          care_request_id: zod.union([zod.string(), zod.null()]).optional(),
        }),
        zod.object({
          type: zod
            .literal("lab_ordered")
            .default(
              getClinicianActivityEventsResponseEventsItemEventTypeDefaultTwo,
            ),
          remote_id: zod.string(),
          care_request_id: zod.union([zod.string(), zod.null()]).optional(),
        }),
        zod
          .object({
            type: zod
              .literal("care_action_recorded")
              .default(
                getClinicianActivityEventsResponseEventsItemEventTypeDefaultThree,
              ),
            request_id: zod.union([zod.string(), zod.null()]).optional(),
            action_kind: zod
              .enum([
                "ask_follow_up_question",
                "conversation_with_cortex_ai",
                "update_note_or_documentation",
                "medication_refill",
                "update_care_plan",
                "order_new_medication",
                "order_laboratory_study",
              ])
              .describe(
                "Recognized clinical actions that accrue karma (see karma.py tables).",
              ),
          })
          .describe(
            "Structured care action for karma (documentation, follow-ups, escalations, etc.).",
          ),
        zod.object({
          type: zod
            .literal("karma_payout")
            .default(
              getClinicianActivityEventsResponseEventsItemEventTypeDefaultFour,
            ),
          pay_period: zod.string(),
          karma_points_paid: zod.number(),
          dollar_amount: zod.number(),
          mercury_request_id: zod.string(),
          idempotency_key: zod.string(),
        }),
        zod.object({
          type: zod
            .literal("correction")
            .default(
              getClinicianActivityEventsResponseEventsItemEventTypeDefaultFive,
            ),
        }),
      ]),
      karmaPoints: zod.number(),
      displayDescription: zod.string(),
      occurredAt: zod.iso.datetime({}),
    }),
  ),
});

/**
 * Return the current bank link status for the logged-in clinician.
 * @summary Get Bank Link
 */
export const getBankLinkResponse = zod.object({
  recipient_name: zod.string(),
  status: zod.enum(["active", "inactive", "broken"]),
});

/**
 * Register the clinician's bank account with Mercury and store the link.
 * @summary Link Bank Account
 */
export const linkBankAccountBody = zod.object({
  accountNumber: zod.string(),
  routingNumber: zod.string(),
  accountType: zod.enum([
    "businessChecking",
    "businessSavings",
    "personalChecking",
    "personalSavings",
  ]),
  accountHolderName: zod.string(),
  email: zod.string(),
});

export const linkBankAccountResponse = zod.object({
  recipient_name: zod.string(),
  status: zod.enum(["active", "inactive", "broken"]),
});

/**
 * Return all clinician bank links (admin view).
 * @summary List All Bank Links
 */
export const listAllBankLinksResponse = zod.object({
  links: zod.array(
    zod.object({
      clinicianId: zod.string(),
      mercuryRecipientId: zod.string(),
      recipientName: zod.string(),
      status: zod.enum(["active", "inactive", "broken"]),
    }),
  ),
});

/**
 * Assign or update a Mercury recipient ID for a clinician (admin).
 * @summary Assign Recipient Id
 */
export const assignRecipientIdParams = zod.object({
  clinician_id: zod.uuid(),
});

export const assignRecipientIdBody = zod.object({
  mercuryRecipientId: zod.string(),
  recipientName: zod.string(),
});

export const assignRecipientIdResponse = zod.object({
  clinicianId: zod.string(),
  mercuryRecipientId: zod.string(),
  recipientName: zod.string(),
  status: zod.enum(["active", "inactive", "broken"]),
});

/**
 * Return proposed and confirmed banking details for a clinician.
 * @summary Fetch Banking Details
 */
export const fetchBankingDetailsParams = zod.object({
  user_id: zod.uuid(),
});

export const fetchBankingDetailsResponse = zod.object({
  proposed: zod
    .union([
      zod.object({
        accountNumber: zod.string(),
        routingNumber: zod.string(),
        accountHolderName: zod.string(),
        accountType: zod.string(),
        certainty: zod.string(),
      }),
      zod.null(),
    ])
    .optional(),
  confirmed: zod
    .union([
      zod.object({
        accountNumber: zod.string(),
        routingNumber: zod.string(),
        accountHolderName: zod.string(),
        accountType: zod.string(),
        certainty: zod.string(),
      }),
      zod.null(),
    ])
    .optional(),
});

/**
 * Update the authenticated clinician's self-reported banking details.
 * @summary Update Banking Details
 */
export const updateBankingDetailsBody = zod.object({
  accountNumber: zod.string(),
  routingNumber: zod.string(),
  accountHolderName: zod.string(),
  accountType: zod.string(),
});

export const updateBankingDetailsResponse = zod.object({
  proposed: zod
    .union([
      zod.object({
        accountNumber: zod.string(),
        routingNumber: zod.string(),
        accountHolderName: zod.string(),
        accountType: zod.string(),
        certainty: zod.string(),
      }),
      zod.null(),
    ])
    .optional(),
  confirmed: zod
    .union([
      zod.object({
        accountNumber: zod.string(),
        routingNumber: zod.string(),
        accountHolderName: zod.string(),
        accountType: zod.string(),
        certainty: zod.string(),
      }),
      zod.null(),
    ])
    .optional(),
});

/**
 * Return one row per clinician for the admin payout dashboard.
 * @summary List Clinician Payout Dashboard
 */
export const listClinicianPayoutDashboardResponse = zod.object({
  rows: zod.array(
    zod
      .object({
        clinicianId: zod.uuid(),
        displayName: zod.union([zod.string(), zod.null()]),
        email: zod.union([zod.string(), zod.null()]),
        phoneNumber: zod.union([zod.string(), zod.null()]),
        npiNumber: zod.union([zod.string(), zod.null()]),
        licensedStates: zod.union([zod.array(zod.string()), zod.null()]),
        mailingAddressStreet: zod.union([zod.string(), zod.null()]),
        mailingAddressCity: zod.union([zod.string(), zod.null()]),
        mailingAddressState: zod.union([zod.string(), zod.null()]),
        mailingAddressZip: zod.union([zod.string(), zod.null()]),
        mercuryRecipientId: zod.union([zod.string(), zod.null()]),
        recipientName: zod.union([zod.string(), zod.null()]),
        bankLinkStatus: zod.union([
          zod.enum(["active", "inactive", "broken"]),
          zod.null(),
        ]),
        totalPaidOutDollars: zod.number(),
        totalPaidOutKarma: zod.number(),
        pendingKarma: zod.number(),
        pendingDollars: zod.number(),
        lastPayoutAt: zod.union([zod.string(), zod.null()]),
      })
      .describe(
        "A single row of the admin payout dashboard table.\n\nMerges the identity info collected during Cortex onboarding\n(``employee_records``) with the bank-link state and the payout totals\nderived from the karma activity log.",
      ),
  ),
});

/**
 * Return the full karma payout ledger for a single clinician.

Used by the "previous transactions" modal on the admin dashboard.
 * @summary List Clinician Payout History
 */
export const listClinicianPayoutHistoryParams = zod.object({
  clinician_id: zod.uuid(),
});

export const listClinicianPayoutHistoryResponse = zod.object({
  payouts: zod.array(
    zod
      .object({
        id: zod.uuid(),
        clinicianId: zod.uuid(),
        payPeriodStart: zod.iso.datetime({}),
        payPeriodEnd: zod.iso.datetime({}),
        karmaPoints: zod.number(),
        dollarAmount: zod.number(),
        status: zod.enum(["pending", "queued", "failed"]),
        mercuryRequestId: zod.union([zod.string(), zod.null()]),
        idempotencyKey: zod.string(),
        failureReason: zod.union([zod.string(), zod.null()]),
        createdAt: zod.iso.datetime({}),
      })
      .describe("Single row of the karma payouts ledger, returned to admins."),
  ),
});

/**
 * Return dossier-backed banking details for one clinician.

Resolves the best ``BankingDetailsDetailT`` the dossier has deduced
for the clinician -- preferring Mercury-confirmed clues over
self-reported proposals. The routing number, account type, holder
name and a masked last-4 of the account number are always returned.
The full account number is only returned when the caller passes
``?reveal=true`` so reveals are distinguishable in the audit log.
 * @summary Get Clinician Bank Details
 */
export const getClinicianBankDetailsParams = zod.object({
  clinician_id: zod.uuid(),
});

export const getClinicianBankDetailsQueryRevealDefault = false;

export const getClinicianBankDetailsQueryParams = zod.object({
  reveal: zod.boolean().optional(),
});

export const getClinicianBankDetailsResponse = zod
  .object({
    clinicianId: zod.uuid(),
    certainty: zod.string(),
    accountHolderName: zod.union([zod.string(), zod.null()]),
    accountType: zod.union([zod.string(), zod.null()]),
    routingNumber: zod.union([zod.string(), zod.null()]),
    accountNumberLast4: zod.union([zod.string(), zod.null()]),
    accountNumber: zod.union([zod.string(), zod.null()]),
  })
  .describe(
    "Banking details for one clinician, sourced from the dossier.\n\nReads :class:`~lotushealth.user_info.dossier.detail_types.banking.BankingDetailsDetailT`\n-- the canonical, high-security store for clinician ACH details --\nso all callers see the same confirmed-over-proposed view that the\ndossier system builds from self-reported + Mercury-verified clues.\n\n``account_number`` is populated only when the caller passed\n``reveal=true``; ``account_number_last4`` is always safe to show as a\nmasked display value.",
  );

/**
 * Trigger the karma payout sweep immediately.

Sums all karma up to today for each clinician, subtracts previous payout
debits, and pays out the remaining balance. Idempotent per
``(clinician, amount_cents)``: if the net balance hasn't changed since the
last run, Mercury rejects the duplicate idempotency key. Safe to retry.
 * @summary Run Payout Sweep
 */
export const runPayoutSweepResponseResultCliniciansSkippedDefault = 0;
export const runPayoutSweepResponseResultFailuresDefault = [];

export const runPayoutSweepResponse = zod.object({
  result: zod.object({
    cliniciansPaid: zod.number(),
    totalAmount: zod.number(),
    requestsQueued: zod.number(),
    payPeriodStart: zod.iso.datetime({}),
    payPeriodEnd: zod.iso.datetime({}),
    cliniciansSkipped: zod.number().optional(),
    failures: zod
      .array(
        zod.object({
          clinicianId: zod.uuid(),
          recipientName: zod.string(),
          dollarAmount: zod.number(),
          reason: zod.string(),
        }),
      )
      .default(runPayoutSweepResponseResultFailuresDefault),
  }),
});

/**
 * Fetch the current dossier for a specific user.

The dossier contains deductions about the user's identity and attributes,
along with logs showing how those deductions were made.

Args:
    user_id: The user ID to fetch the dossier for
    user: Authenticated admin user

Returns:
    FetchDossierResponseT with deductions and logs
 * @summary Fetch Dossier For User
 */
export const fetchDossierForUserParams = zod.object({
  user_id: zod.uuid(),
});

export const fetchDossierForUserResponse = zod
  .object({
    deductions: zod.array(
      zod
        .object({
          detailType: zod.string(),
          detail: zod.unknown(),
          attesters: zod.array(zod.string()),
          certainty: zod.string(),
        })
        .describe("Serializable representation of a dossier deduction."),
    ),
    logs: zod.array(zod.string()),
  })
  .describe("Response containing a user's dossier.");

/**
 * Trigger an investigate cycle for a user's dossier.

This will run all discovery plugins to update the user's dossier with
any new information from connected data sources.

Args:
    user_id: The user ID to investigate
    user: Authenticated admin user

Returns:
    FetchDossierResponseT with the updated dossier after investigation
 * @summary Investigate Dossier For User
 */
export const investigateDossierForUserParams = zod.object({
  user_id: zod.uuid(),
});

export const investigateDossierForUserResponse = zod
  .object({
    deductions: zod.array(
      zod
        .object({
          detailType: zod.string(),
          detail: zod.unknown(),
          attesters: zod.array(zod.string()),
          certainty: zod.string(),
        })
        .describe("Serializable representation of a dossier deduction."),
    ),
    logs: zod.array(zod.string()),
  })
  .describe("Response containing a user's dossier.");

/**
 * Debounced per-keystroke pharmacy search for the iOS picker.
 * @summary Search Patient Visible Pharmacies
 */
export const searchPatientVisiblePharmaciesBodyQueryMin = 3;

export const searchPatientVisiblePharmaciesBody = zod
  .object({
    query: zod.string().min(searchPatientVisiblePharmaciesBodyQueryMin),
    city: zod.union([zod.string(), zod.null()]).optional(),
    state: zod.union([zod.string(), zod.null()]).optional(),
    zipCode: zod.union([zod.string(), zod.null()]).optional(),
  })
  .describe(
    "Patient-facing pharmacy search filters.\n\niOS owns filter state (city\/state\/zip_code) and prefills it from the\ndemographics endpoint. The backend never injects implicit defaults.",
  );

export const searchPatientVisiblePharmaciesResponseResultsItemIsPrimaryDefault = false;

export const searchPatientVisiblePharmaciesResponse = zod.object({
  results: zod.array(
    zod.object({
      pharmacyId: zod.number(),
      name: zod.union([zod.string(), zod.null()]).optional(),
      address: zod.union([zod.string(), zod.null()]).optional(),
      city: zod.union([zod.string(), zod.null()]).optional(),
      state: zod.union([zod.string(), zod.null()]).optional(),
      zipCode: zod.union([zod.string(), zod.null()]).optional(),
      phone: zod.union([zod.string(), zod.null()]).optional(),
      isPrimary: zod.boolean().optional(),
    }),
  ),
});

/**
 * Return the patient's currently-selected primary pharmacy, if any.
 * @summary Fetch Primary Pharmacy
 */
export const fetchPrimaryPharmacyResponsePharmacyIsPrimaryDefault = false;

export const fetchPrimaryPharmacyResponse = zod.object({
  pharmacy: zod
    .union([
      zod.object({
        pharmacyId: zod.number(),
        name: zod.union([zod.string(), zod.null()]).optional(),
        address: zod.union([zod.string(), zod.null()]).optional(),
        city: zod.union([zod.string(), zod.null()]).optional(),
        state: zod.union([zod.string(), zod.null()]).optional(),
        zipCode: zod.union([zod.string(), zod.null()]).optional(),
        phone: zod.union([zod.string(), zod.null()]).optional(),
        isPrimary: zod.boolean().optional(),
      }),
      zod.null(),
    ])
    .optional(),
});

/**
 * Set the patient's primary pharmacy by DoseSpot pharmacy_id.

Idempotent. The server re-resolves the pharmacy against DoseSpot for
canonical fields, so iOS never sends structured pharmacy data.

Local-DB-only write by design. `patient_pharmacy_model` is the source of
truth; propagation to the DoseSpot patient record is handled lazily by
`PatientModel._sync_pharmacies_to_dosespot`, invoked from `sync_dosespot`
on every prescription operation. The LLM `manage_pharmacy_tool` follows
the same pattern.
 * @summary Set Primary Pharmacy
 */
export const setPrimaryPharmacyBody = zod.object({
  pharmacyId: zod.number(),
});

export const setPrimaryPharmacyResponsePharmacyIsPrimaryDefault = false;

export const setPrimaryPharmacyResponse = zod.object({
  pharmacy: zod.object({
    pharmacyId: zod.number(),
    name: zod.union([zod.string(), zod.null()]).optional(),
    address: zod.union([zod.string(), zod.null()]).optional(),
    city: zod.union([zod.string(), zod.null()]).optional(),
    state: zod.union([zod.string(), zod.null()]).optional(),
    zipCode: zod.union([zod.string(), zod.null()]).optional(),
    phone: zod.union([zod.string(), zod.null()]).optional(),
    isPrimary: zod.boolean().optional(),
  }),
});

/**
 * Resolve a DoseSpot pharmacy id to patient-displayable details.

The id typically comes from a prescription card
(`PatientFacingPrescriptionT.pharmacy_id`). If the patient already has
this pharmacy saved we answer from the local record and skip the DoseSpot
round-trip; otherwise we resolve it against DoseSpot. Unknown ids raise
`LotusNotFoundError` (404).
 * @summary Fetch Pharmacy By Id
 */
export const fetchPharmacyByIdParams = zod.object({
  pharmacy_id: zod.number(),
});

export const fetchPharmacyByIdResponsePharmacyIsPrimaryDefault = false;

export const fetchPharmacyByIdResponse = zod.object({
  pharmacy: zod.object({
    pharmacyId: zod.number(),
    name: zod.union([zod.string(), zod.null()]).optional(),
    address: zod.union([zod.string(), zod.null()]).optional(),
    city: zod.union([zod.string(), zod.null()]).optional(),
    state: zod.union([zod.string(), zod.null()]).optional(),
    zipCode: zod.union([zod.string(), zod.null()]).optional(),
    phone: zod.union([zod.string(), zod.null()]).optional(),
    isPrimary: zod.boolean().optional(),
  }),
});

/**
 * Fetch the user's full address book.

The book is a declarative, full-state view of the user's addresses. `entries` is a single list
where each entry is tagged `source`: `self_reported` (entered by the user) or `discovered`
(found in the dossier, e.g. identity verification). Discovered addresses are surfaced so a
verified address is visible without an explicit acceptance step; `source`/`id` are read-only and
a discovered entry is never primary while it remains discovered.

The opaque `version` ETag the client writes back against covers the `self_reported` subset only,
so a discovered address appearing or disappearing never trips `stale_version`.
 * @summary Fetch Address Book
 */
export const fetchAddressBookResponseEntriesItemCountryDefault = "US";
export const fetchAddressBookResponseEntriesItemIsPrimaryDefault = false;
export const fetchAddressBookResponseEntriesItemSourceDefault = "self_reported";

export const fetchAddressBookResponse = zod
  .object({
    entries: zod.array(
      zod
        .object({
          receiverName: zod.union([zod.string(), zod.null()]).optional(),
          streetAddress: zod.string(),
          streetAddressLine2: zod.union([zod.string(), zod.null()]).optional(),
          city: zod.string(),
          state: zod.string(),
          zipCode: zod.string(),
          country: zod
            .string()
            .default(fetchAddressBookResponseEntriesItemCountryDefault),
          isPrimary: zod.boolean().optional(),
          id: zod.string(),
          source: zod
            .enum(["self_reported", "discovered"])
            .default(fetchAddressBookResponseEntriesItemSourceDefault),
        })
        .describe(
          "A stored address in a read, identified by its content-addressed `id`.\n\n`source` tells the client where the address came from:\n- `self_reported`: the user entered it; it is writable and part of `version`.\n- `discovered`: it was found in the dossier (e.g. identity verification) and is surfaced so a\n  verified address is visible without an explicit acceptance step. A discovered entry is never\n  primary while it remains discovered, and `source`\/`id` are read-only. The client acts on it\n  through the normal full-state write: echo its fields back (as an `AddressBookEntryInputT`,\n  never its `id`) to accept it — or set `is_primary` to promote it — into the self-reported\n  set, or omit it to locally hide it (`verdict=False`, dossier record untouched).",
        ),
    ),
    version: zod.string(),
  })
  .describe(
    "The full read view: every stored address plus an opaque `version` to write back against.\n\n`entries` is a single list holding both `self_reported` and `discovered` addresses (see\n`AddressBookEntryT.source`), so the client renders one unified list. `version` covers the\n`self_reported` subset only, so writing the book back is unaffected by what is discovered.",
  );

/**
 * Apply a full-state, version-checked write of the user's address book.

The client sends the complete desired set of addresses (fields only -- no `id`/`source`) plus
the `version` it started from. Every written address is self-reported: keeping a previously
discovered address in the set accepts it (and, with `is_primary`, promotes it) into the
self-reported set, while omitting a previously surfaced address locally hides it (`verdict=False`,
dossier record untouched). Returns a typed success (carrying the freshly projected book) or a
typed failure (`stale_version` / `invalid_address` / `multiple_primaries` / `missing_primary`).
A failure leaves the stored addresses untouched -- writes are all-or-nothing, never partial.
 * @summary Update Address Book
 */
export const updateAddressBookBodyEntriesItemCountryDefault = "US";
export const updateAddressBookBodyEntriesItemIsPrimaryDefault = false;

export const updateAddressBookBody = zod
  .object({
    entries: zod.array(
      zod
        .object({
          receiverName: zod.union([zod.string(), zod.null()]).optional(),
          streetAddress: zod.string(),
          streetAddressLine2: zod.union([zod.string(), zod.null()]).optional(),
          city: zod.string(),
          state: zod.string(),
          zipCode: zod.string(),
          country: zod
            .string()
            .default(updateAddressBookBodyEntriesItemCountryDefault),
          isPrimary: zod.boolean().optional(),
        })
        .describe(
          "A desired address in a write. Identity is derived server-side, so there is no client `id`.",
        ),
    ),
    version: zod.string(),
  })
  .describe(
    "A full-state write: the complete desired set plus the `version` the client started from.",
  );

export const updateAddressBookResponseTypeDefault = "success";
export const updateAddressBookResponseAddressBookEntriesItemCountryDefault =
  "US";
export const updateAddressBookResponseAddressBookEntriesItemIsPrimaryDefault = false;
export const updateAddressBookResponseAddressBookEntriesItemSourceDefault =
  "self_reported";
export const updateAddressBookResponseTypeDefaultOne = "failure";

export const updateAddressBookResponse = zod.union([
  zod.object({
    type: zod.literal("success").default(updateAddressBookResponseTypeDefault),
    addressBook: zod
      .object({
        entries: zod.array(
          zod
            .object({
              receiverName: zod.union([zod.string(), zod.null()]).optional(),
              streetAddress: zod.string(),
              streetAddressLine2: zod
                .union([zod.string(), zod.null()])
                .optional(),
              city: zod.string(),
              state: zod.string(),
              zipCode: zod.string(),
              country: zod
                .string()
                .default(
                  updateAddressBookResponseAddressBookEntriesItemCountryDefault,
                ),
              isPrimary: zod.boolean().optional(),
              id: zod.string(),
              source: zod
                .enum(["self_reported", "discovered"])
                .default(
                  updateAddressBookResponseAddressBookEntriesItemSourceDefault,
                ),
            })
            .describe(
              "A stored address in a read, identified by its content-addressed `id`.\n\n`source` tells the client where the address came from:\n- `self_reported`: the user entered it; it is writable and part of `version`.\n- `discovered`: it was found in the dossier (e.g. identity verification) and is surfaced so a\n  verified address is visible without an explicit acceptance step. A discovered entry is never\n  primary while it remains discovered, and `source`\/`id` are read-only. The client acts on it\n  through the normal full-state write: echo its fields back (as an `AddressBookEntryInputT`,\n  never its `id`) to accept it — or set `is_primary` to promote it — into the self-reported\n  set, or omit it to locally hide it (`verdict=False`, dossier record untouched).",
            ),
        ),
        version: zod.string(),
      })
      .describe(
        "The full read view: every stored address plus an opaque `version` to write back against.\n\n`entries` is a single list holding both `self_reported` and `discovered` addresses (see\n`AddressBookEntryT.source`), so the client renders one unified list. `version` covers the\n`self_reported` subset only, so writing the book back is unaffected by what is discovered.",
      ),
  }),
  zod.object({
    type: zod
      .literal("failure")
      .default(updateAddressBookResponseTypeDefaultOne),
    reason: zod.enum([
      "stale_version",
      "invalid_address",
      "multiple_primaries",
      "missing_primary",
    ]),
    details: zod.string(),
  }),
]);

/**
 * Search for stock insurance payers whose names match *filter*.

Pass an empty *filter* with a ``null`` *limit* to retrieve all known
payers.  Pass a non-empty *filter* for real-time typeahead search.

Backed by a TurboPuffer store that is populated by the payer indexer
pipeline (Stedi → Junction resolution → BM25 index).
 * @summary Search Stock Payers
 */
export const searchStockPayersBody = zod.object({
  filter: zod.union([zod.string(), zod.null()]).optional(),
  limit: zod.union([zod.number(), zod.null()]).optional(),
});

export const searchStockPayersResponsePayersItemAltNamesDefault = [];

export const searchStockPayersResponse = zod.object({
  payers: zod.array(
    zod.object({
      type: zod.literal("stock"),
      code: zod
        .object({
          origin: zod.union([
            zod
              .enum(["pverify", "stedi", "junction", "flexpa"])
              .describe("Which system a payer code originates from."),
            zod.string(),
          ]),
          code: zod.string(),
          name: zod.string(),
        })
        .describe(
          "A payer identifier: origin system, code, and human-readable name.",
        ),
      displayName: zod.string(),
      imageUrl: zod.union([zod.string(), zod.null()]).optional(),
      altNames: zod
        .array(zod.string())
        .default(searchStockPayersResponsePayersItemAltNamesDefault),
    }),
  ),
});

/**
 * Fetch the user's current insurance submission.

The payer object is generated at fetch-time (the ``imageUrl`` may be
short-lived).  ``completed`` is False when we don't yet know what to
tell Junction about this user's insurance status.
 * @summary Fetch Insurance Submission
 */
export const fetchInsuranceSubmissionResponseSubmissionPayerValueAltNamesDefault =
  [];

export const fetchInsuranceSubmissionResponse = zod.object({
  completed: zod.boolean(),
  submission: zod.object({
    payer: zod
      .union([
        zod.object({
          value: zod
            .union([
              zod.object({
                type: zod.literal("stock"),
                code: zod
                  .object({
                    origin: zod.union([
                      zod
                        .enum(["pverify", "stedi", "junction", "flexpa"])
                        .describe("Which system a payer code originates from."),
                      zod.string(),
                    ]),
                    code: zod.string(),
                    name: zod.string(),
                  })
                  .describe(
                    "A payer identifier: origin system, code, and human-readable name.",
                  ),
                displayName: zod.string(),
                imageUrl: zod.union([zod.string(), zod.null()]).optional(),
                altNames: zod
                  .array(zod.string())
                  .default(
                    fetchInsuranceSubmissionResponseSubmissionPayerValueAltNamesDefault,
                  ),
              }),
              zod.null(),
            ])
            .optional(),
          complaints: zod.union([zod.string(), zod.null()]).optional(),
        }),
        zod.null(),
      ])
      .optional(),
    member_id: zod
      .union([
        zod.object({
          value: zod.union([zod.string(), zod.null()]).optional(),
          complaints: zod.union([zod.string(), zod.null()]).optional(),
        }),
        zod.null(),
      ])
      .optional(),
    group_id: zod
      .union([
        zod.object({
          value: zod.union([zod.string(), zod.null()]).optional(),
          complaints: zod.union([zod.string(), zod.null()]).optional(),
        }),
        zod.null(),
      ])
      .optional(),
  }),
});

/**
 * Update the user's insurance submission.

After this call either ``completed`` is True (we know what to tell
Junction) or the returned fields carry ``complaints`` explaining what
is missing or invalid.
 * @summary Update Insurance Submission
 */
export const updateInsuranceSubmissionBodySubmissionPayerValueAltNamesDefault =
  [];

export const updateInsuranceSubmissionBody = zod.object({
  submission: zod.object({
    payer: zod
      .union([
        zod.object({
          value: zod
            .union([
              zod.object({
                type: zod.literal("stock"),
                code: zod
                  .object({
                    origin: zod.union([
                      zod
                        .enum(["pverify", "stedi", "junction", "flexpa"])
                        .describe("Which system a payer code originates from."),
                      zod.string(),
                    ]),
                    code: zod.string(),
                    name: zod.string(),
                  })
                  .describe(
                    "A payer identifier: origin system, code, and human-readable name.",
                  ),
                displayName: zod.string(),
                imageUrl: zod.union([zod.string(), zod.null()]).optional(),
                altNames: zod
                  .array(zod.string())
                  .default(
                    updateInsuranceSubmissionBodySubmissionPayerValueAltNamesDefault,
                  ),
              }),
              zod.null(),
            ])
            .optional(),
          complaints: zod.union([zod.string(), zod.null()]).optional(),
        }),
        zod.null(),
      ])
      .optional(),
    member_id: zod
      .union([
        zod.object({
          value: zod.union([zod.string(), zod.null()]).optional(),
          complaints: zod.union([zod.string(), zod.null()]).optional(),
        }),
        zod.null(),
      ])
      .optional(),
    group_id: zod
      .union([
        zod.object({
          value: zod.union([zod.string(), zod.null()]).optional(),
          complaints: zod.union([zod.string(), zod.null()]).optional(),
        }),
        zod.null(),
      ])
      .optional(),
  }),
});

export const updateInsuranceSubmissionResponseSubmissionPayerValueAltNamesDefault =
  [];

export const updateInsuranceSubmissionResponse = zod.object({
  completed: zod.boolean(),
  submission: zod.object({
    payer: zod
      .union([
        zod.object({
          value: zod
            .union([
              zod.object({
                type: zod.literal("stock"),
                code: zod
                  .object({
                    origin: zod.union([
                      zod
                        .enum(["pverify", "stedi", "junction", "flexpa"])
                        .describe("Which system a payer code originates from."),
                      zod.string(),
                    ]),
                    code: zod.string(),
                    name: zod.string(),
                  })
                  .describe(
                    "A payer identifier: origin system, code, and human-readable name.",
                  ),
                displayName: zod.string(),
                imageUrl: zod.union([zod.string(), zod.null()]).optional(),
                altNames: zod
                  .array(zod.string())
                  .default(
                    updateInsuranceSubmissionResponseSubmissionPayerValueAltNamesDefault,
                  ),
              }),
              zod.null(),
            ])
            .optional(),
          complaints: zod.union([zod.string(), zod.null()]).optional(),
        }),
        zod.null(),
      ])
      .optional(),
    member_id: zod
      .union([
        zod.object({
          value: zod.union([zod.string(), zod.null()]).optional(),
          complaints: zod.union([zod.string(), zod.null()]).optional(),
        }),
        zod.null(),
      ])
      .optional(),
    group_id: zod
      .union([
        zod.object({
          value: zod.union([zod.string(), zod.null()]).optional(),
          complaints: zod.union([zod.string(), zod.null()]).optional(),
        }),
        zod.null(),
      ])
      .optional(),
  }),
});

/**
 * Clear the user's insurance submission, returning them to the blank
state as if they had never submitted anything.
 * @summary Clear Insurance Submission
 */
export const clearInsuranceSubmissionResponseSubmissionPayerValueAltNamesDefault =
  [];

export const clearInsuranceSubmissionResponse = zod.object({
  completed: zod.boolean(),
  submission: zod.object({
    payer: zod
      .union([
        zod.object({
          value: zod
            .union([
              zod.object({
                type: zod.literal("stock"),
                code: zod
                  .object({
                    origin: zod.union([
                      zod
                        .enum(["pverify", "stedi", "junction", "flexpa"])
                        .describe("Which system a payer code originates from."),
                      zod.string(),
                    ]),
                    code: zod.string(),
                    name: zod.string(),
                  })
                  .describe(
                    "A payer identifier: origin system, code, and human-readable name.",
                  ),
                displayName: zod.string(),
                imageUrl: zod.union([zod.string(), zod.null()]).optional(),
                altNames: zod
                  .array(zod.string())
                  .default(
                    clearInsuranceSubmissionResponseSubmissionPayerValueAltNamesDefault,
                  ),
              }),
              zod.null(),
            ])
            .optional(),
          complaints: zod.union([zod.string(), zod.null()]).optional(),
        }),
        zod.null(),
      ])
      .optional(),
    member_id: zod
      .union([
        zod.object({
          value: zod.union([zod.string(), zod.null()]).optional(),
          complaints: zod.union([zod.string(), zod.null()]).optional(),
        }),
        zod.null(),
      ])
      .optional(),
    group_id: zod
      .union([
        zod.object({
          value: zod.union([zod.string(), zod.null()]).optional(),
          complaints: zod.union([zod.string(), zod.null()]).optional(),
        }),
        zod.null(),
      ])
      .optional(),
  }),
});

/**
 * @summary List Surveys
 */
export const listSurveysResponseSurveysItemInstrumentSessionFormDefinitionFieldsItemSuggestedSubmissionTypeDefault =
  "string";
export const listSurveysResponseSurveysItemInstrumentSessionFormDefinitionFieldsItemSuggestedSubmissionTypeDefaultOne =
  "int";
export const listSurveysResponseSurveysItemInstrumentSessionFormDefinitionFieldsItemSuggestedSubmissionTypeDefaultTwo =
  "simple_address";
export const listSurveysResponseSurveysItemInstrumentSessionFormDefinitionFieldsItemSuggestedSubmissionTypeDefaultThree =
  "list";
export const listSurveysResponseSurveysItemInstrumentSessionFormDefinitionFieldsItemSuggestedSubmissionValuesItemTypeDefault =
  "string";
export const listSurveysResponseSurveysItemInstrumentSessionFormDefinitionFieldsItemSuggestedSubmissionValuesItemTypeDefaultOne =
  "int";
export const listSurveysResponseSurveysItemInstrumentSessionFormDefinitionFieldsItemSuggestedSubmissionValuesItemTypeDefaultTwo =
  "simple_address";
export const listSurveysResponseSurveysItemInstrumentSessionFormDefinitionFieldsItemDefaultSubmissionTypeDefault =
  "string";
export const listSurveysResponseSurveysItemInstrumentSessionFormDefinitionFieldsItemDefaultSubmissionTypeDefaultOne =
  "int";
export const listSurveysResponseSurveysItemInstrumentSessionFormDefinitionFieldsItemDefaultSubmissionTypeDefaultTwo =
  "simple_address";
export const listSurveysResponseSurveysItemInstrumentSessionFormDefinitionFieldsItemDefaultSubmissionTypeDefaultThree =
  "list";
export const listSurveysResponseSurveysItemInstrumentSessionFormDefinitionFieldsItemDefaultSubmissionValuesItemTypeDefault =
  "string";
export const listSurveysResponseSurveysItemInstrumentSessionFormDefinitionFieldsItemDefaultSubmissionValuesItemTypeDefaultOne =
  "int";
export const listSurveysResponseSurveysItemInstrumentSessionFormDefinitionFieldsItemDefaultSubmissionValuesItemTypeDefaultTwo =
  "simple_address";
export const listSurveysResponseSurveysItemInstrumentSessionFormDefinitionFieldsItemValidatorTypeDefault =
  "non_empty_string";
export const listSurveysResponseSurveysItemInstrumentSessionFormDefinitionFieldsItemValidatorTypeDefaultOne =
  "date";
export const listSurveysResponseSurveysItemInstrumentSessionFormDefinitionFieldsItemValidatorTypeDefaultTwo =
  "coded_choice";
export const listSurveysResponseSurveysItemInstrumentSessionFormDefinitionFieldsItemValidatorTypeDefaultThree =
  "phone_number";
export const listSurveysResponseSurveysItemInstrumentSessionFormDefinitionFieldsItemValidatorTypeDefaultFour =
  "email";
export const listSurveysResponseSurveysItemInstrumentSessionFormDefinitionFieldsItemValidatorTypeDefaultFive =
  "city_state_zip";
export const listSurveysResponseSurveysItemInstrumentSessionFormDefinitionFieldsItemValidatorTypeDefaultSix =
  "optional";
export const listSurveysResponseSurveysItemInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorTypeDefault =
  "non_empty_string";
export const listSurveysResponseSurveysItemInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorTypeDefaultOne =
  "date";
export const listSurveysResponseSurveysItemInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorTypeDefaultTwo =
  "coded_choice";
export const listSurveysResponseSurveysItemInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorTypeDefaultThree =
  "phone_number";
export const listSurveysResponseSurveysItemInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorTypeDefaultFour =
  "email";
export const listSurveysResponseSurveysItemInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorTypeDefaultFive =
  "city_state_zip";
export const listSurveysResponseSurveysItemInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorTypeDefaultSix =
  "list";
export const listSurveysResponseSurveysItemInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorRawValidatorTypeDefault =
  "non_empty_string";
export const listSurveysResponseSurveysItemInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorRawValidatorTypeDefaultOne =
  "date";
export const listSurveysResponseSurveysItemInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorRawValidatorTypeDefaultTwo =
  "coded_choice";
export const listSurveysResponseSurveysItemInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorRawValidatorTypeDefaultThree =
  "phone_number";
export const listSurveysResponseSurveysItemInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorRawValidatorTypeDefaultFour =
  "email";
export const listSurveysResponseSurveysItemInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorRawValidatorTypeDefaultFive =
  "city_state_zip";
export const listSurveysResponseSurveysItemInstrumentSessionFormDefinitionFieldsItemValidatorTypeDefaultSeven =
  "list";
export const listSurveysResponseSurveysItemInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorTypeDefaultSeven =
  "non_empty_string";
export const listSurveysResponseSurveysItemInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorTypeDefaultEight =
  "date";
export const listSurveysResponseSurveysItemInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorTypeDefaultNine =
  "coded_choice";
export const listSurveysResponseSurveysItemInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorTypeDefaultOnezero =
  "phone_number";
export const listSurveysResponseSurveysItemInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorTypeDefaultOneone =
  "email";
export const listSurveysResponseSurveysItemInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorTypeDefaultOnetwo =
  "city_state_zip";
export const listSurveysResponseSurveysItemInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorTypeDefaultOnethree =
  "optional";
export const listSurveysResponseSurveysItemInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorRawValidatorTypeDefaultSix =
  "non_empty_string";
export const listSurveysResponseSurveysItemInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorRawValidatorTypeDefaultSeven =
  "date";
export const listSurveysResponseSurveysItemInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorRawValidatorTypeDefaultEight =
  "coded_choice";
export const listSurveysResponseSurveysItemInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorRawValidatorTypeDefaultNine =
  "phone_number";
export const listSurveysResponseSurveysItemInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorRawValidatorTypeDefaultOnezero =
  "email";
export const listSurveysResponseSurveysItemInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorRawValidatorTypeDefaultOneone =
  "city_state_zip";
export const listSurveysResponseSurveysItemInstrumentSessionSubmissionsSubmissionsTypeDefault =
  "string";
export const listSurveysResponseSurveysItemInstrumentSessionSubmissionsSubmissionsTypeDefaultOne =
  "int";
export const listSurveysResponseSurveysItemInstrumentSessionSubmissionsSubmissionsTypeDefaultTwo =
  "simple_address";
export const listSurveysResponseSurveysItemInstrumentSessionSubmissionsSubmissionsTypeDefaultThree =
  "list";
export const listSurveysResponseSurveysItemInstrumentSessionSubmissionsSubmissionsValuesItemTypeDefault =
  "string";
export const listSurveysResponseSurveysItemInstrumentSessionSubmissionsSubmissionsValuesItemTypeDefaultOne =
  "int";
export const listSurveysResponseSurveysItemInstrumentSessionSubmissionsSubmissionsValuesItemTypeDefaultTwo =
  "simple_address";

export const listSurveysResponse = zod.object({
  surveys: zod.array(
    zod
      .object({
        survey_id: zod.uuid(),
        user_id: zod.uuid(),
        instrument_id: zod.string(),
        status: zod.enum(["open", "completed", "archived"]),
        instrument_params: zod.union([
          zod.record(zod.string(), zod.unknown()),
          zod.null(),
        ]),
        instrument_session: zod
          .object({
            instrument_id: zod.string(),
            form_definition: zod.object({
              fields: zod.array(
                zod.object({
                  id: zod.string(),
                  profile: zod.object({
                    name: zod.string(),
                    description: zod
                      .union([zod.string(), zod.null()])
                      .optional(),
                  }),
                  suggested_submission: zod
                    .union([
                      zod.union([
                        zod.object({
                          type: zod
                            .literal("string")
                            .default(
                              listSurveysResponseSurveysItemInstrumentSessionFormDefinitionFieldsItemSuggestedSubmissionTypeDefault,
                            ),
                          value: zod.string(),
                        }),
                        zod.object({
                          type: zod
                            .literal("int")
                            .default(
                              listSurveysResponseSurveysItemInstrumentSessionFormDefinitionFieldsItemSuggestedSubmissionTypeDefaultOne,
                            ),
                          value: zod.number(),
                        }),
                        zod.object({
                          type: zod
                            .literal("simple_address")
                            .default(
                              listSurveysResponseSurveysItemInstrumentSessionFormDefinitionFieldsItemSuggestedSubmissionTypeDefaultTwo,
                            ),
                          street_address: zod.string(),
                          city_state_zip: zod.string(),
                        }),
                        zod.object({
                          type: zod
                            .literal("list")
                            .default(
                              listSurveysResponseSurveysItemInstrumentSessionFormDefinitionFieldsItemSuggestedSubmissionTypeDefaultThree,
                            ),
                          values: zod.array(
                            zod.union([
                              zod.object({
                                type: zod
                                  .literal("string")
                                  .default(
                                    listSurveysResponseSurveysItemInstrumentSessionFormDefinitionFieldsItemSuggestedSubmissionValuesItemTypeDefault,
                                  ),
                                value: zod.string(),
                              }),
                              zod.object({
                                type: zod
                                  .literal("int")
                                  .default(
                                    listSurveysResponseSurveysItemInstrumentSessionFormDefinitionFieldsItemSuggestedSubmissionValuesItemTypeDefaultOne,
                                  ),
                                value: zod.number(),
                              }),
                              zod.object({
                                type: zod
                                  .literal("simple_address")
                                  .default(
                                    listSurveysResponseSurveysItemInstrumentSessionFormDefinitionFieldsItemSuggestedSubmissionValuesItemTypeDefaultTwo,
                                  ),
                                street_address: zod.string(),
                                city_state_zip: zod.string(),
                              }),
                              zod.unknown(),
                            ]),
                          ),
                        }),
                      ]),
                      zod.null(),
                    ])
                    .optional(),
                  default_submission: zod
                    .union([
                      zod.union([
                        zod.object({
                          type: zod
                            .literal("string")
                            .default(
                              listSurveysResponseSurveysItemInstrumentSessionFormDefinitionFieldsItemDefaultSubmissionTypeDefault,
                            ),
                          value: zod.string(),
                        }),
                        zod.object({
                          type: zod
                            .literal("int")
                            .default(
                              listSurveysResponseSurveysItemInstrumentSessionFormDefinitionFieldsItemDefaultSubmissionTypeDefaultOne,
                            ),
                          value: zod.number(),
                        }),
                        zod.object({
                          type: zod
                            .literal("simple_address")
                            .default(
                              listSurveysResponseSurveysItemInstrumentSessionFormDefinitionFieldsItemDefaultSubmissionTypeDefaultTwo,
                            ),
                          street_address: zod.string(),
                          city_state_zip: zod.string(),
                        }),
                        zod.object({
                          type: zod
                            .literal("list")
                            .default(
                              listSurveysResponseSurveysItemInstrumentSessionFormDefinitionFieldsItemDefaultSubmissionTypeDefaultThree,
                            ),
                          values: zod.array(
                            zod.union([
                              zod.object({
                                type: zod
                                  .literal("string")
                                  .default(
                                    listSurveysResponseSurveysItemInstrumentSessionFormDefinitionFieldsItemDefaultSubmissionValuesItemTypeDefault,
                                  ),
                                value: zod.string(),
                              }),
                              zod.object({
                                type: zod
                                  .literal("int")
                                  .default(
                                    listSurveysResponseSurveysItemInstrumentSessionFormDefinitionFieldsItemDefaultSubmissionValuesItemTypeDefaultOne,
                                  ),
                                value: zod.number(),
                              }),
                              zod.object({
                                type: zod
                                  .literal("simple_address")
                                  .default(
                                    listSurveysResponseSurveysItemInstrumentSessionFormDefinitionFieldsItemDefaultSubmissionValuesItemTypeDefaultTwo,
                                  ),
                                street_address: zod.string(),
                                city_state_zip: zod.string(),
                              }),
                              zod.unknown(),
                            ]),
                          ),
                        }),
                      ]),
                      zod.null(),
                    ])
                    .optional(),
                  validator: zod.union([
                    zod
                      .object({
                        type: zod
                          .literal("non_empty_string")
                          .default(
                            listSurveysResponseSurveysItemInstrumentSessionFormDefinitionFieldsItemValidatorTypeDefault,
                          ),
                      })
                      .describe(
                        "Validator that accepts arbitrary non-empty strings.",
                      ),
                    zod
                      .object({
                        type: zod
                          .literal("date")
                          .default(
                            listSurveysResponseSurveysItemInstrumentSessionFormDefinitionFieldsItemValidatorTypeDefaultOne,
                          ),
                      })
                      .describe("Validator that accepts arbitrary dates."),
                    zod
                      .object({
                        type: zod
                          .literal("coded_choice")
                          .default(
                            listSurveysResponseSurveysItemInstrumentSessionFormDefinitionFieldsItemValidatorTypeDefaultTwo,
                          ),
                        options: zod.array(
                          zod
                            .object({
                              code: zod.string(),
                              display: zod.string(),
                            })
                            .describe("An option from a list of choices."),
                        ),
                      })
                      .describe(
                        "Validator that accepts any option from a list of choices.",
                      ),
                    zod
                      .object({
                        type: zod
                          .literal("phone_number")
                          .default(
                            listSurveysResponseSurveysItemInstrumentSessionFormDefinitionFieldsItemValidatorTypeDefaultThree,
                          ),
                      })
                      .describe(
                        "Validator that accepts arbitrary phone numbers.",
                      ),
                    zod
                      .object({
                        type: zod
                          .literal("email")
                          .default(
                            listSurveysResponseSurveysItemInstrumentSessionFormDefinitionFieldsItemValidatorTypeDefaultFour,
                          ),
                      })
                      .describe("Validator that accepts arbitrary emails."),
                    zod
                      .object({
                        type: zod
                          .literal("city_state_zip")
                          .default(
                            listSurveysResponseSurveysItemInstrumentSessionFormDefinitionFieldsItemValidatorTypeDefaultFive,
                          ),
                      })
                      .describe(
                        "Validator that accepts city, state, and ZIP code combinations.",
                      ),
                    zod
                      .object({
                        type: zod
                          .literal("optional")
                          .default(
                            listSurveysResponseSurveysItemInstrumentSessionFormDefinitionFieldsItemValidatorTypeDefaultSix,
                          ),
                        raw_validator: zod.union([
                          zod
                            .object({
                              type: zod
                                .literal("non_empty_string")
                                .default(
                                  listSurveysResponseSurveysItemInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorTypeDefault,
                                ),
                            })
                            .describe(
                              "Validator that accepts arbitrary non-empty strings.",
                            ),
                          zod
                            .object({
                              type: zod
                                .literal("date")
                                .default(
                                  listSurveysResponseSurveysItemInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorTypeDefaultOne,
                                ),
                            })
                            .describe(
                              "Validator that accepts arbitrary dates.",
                            ),
                          zod
                            .object({
                              type: zod
                                .literal("coded_choice")
                                .default(
                                  listSurveysResponseSurveysItemInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorTypeDefaultTwo,
                                ),
                              options: zod.array(
                                zod
                                  .object({
                                    code: zod.string(),
                                    display: zod.string(),
                                  })
                                  .describe(
                                    "An option from a list of choices.",
                                  ),
                              ),
                            })
                            .describe(
                              "Validator that accepts any option from a list of choices.",
                            ),
                          zod
                            .object({
                              type: zod
                                .literal("phone_number")
                                .default(
                                  listSurveysResponseSurveysItemInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorTypeDefaultThree,
                                ),
                            })
                            .describe(
                              "Validator that accepts arbitrary phone numbers.",
                            ),
                          zod
                            .object({
                              type: zod
                                .literal("email")
                                .default(
                                  listSurveysResponseSurveysItemInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorTypeDefaultFour,
                                ),
                            })
                            .describe(
                              "Validator that accepts arbitrary emails.",
                            ),
                          zod
                            .object({
                              type: zod
                                .literal("city_state_zip")
                                .default(
                                  listSurveysResponseSurveysItemInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorTypeDefaultFive,
                                ),
                            })
                            .describe(
                              "Validator that accepts city, state, and ZIP code combinations.",
                            ),
                          zod.unknown(),
                          zod
                            .object({
                              type: zod
                                .literal("list")
                                .default(
                                  listSurveysResponseSurveysItemInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorTypeDefaultSix,
                                ),
                              raw_validator: zod.union([
                                zod
                                  .object({
                                    type: zod
                                      .literal("non_empty_string")
                                      .default(
                                        listSurveysResponseSurveysItemInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorRawValidatorTypeDefault,
                                      ),
                                  })
                                  .describe(
                                    "Validator that accepts arbitrary non-empty strings.",
                                  ),
                                zod
                                  .object({
                                    type: zod
                                      .literal("date")
                                      .default(
                                        listSurveysResponseSurveysItemInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorRawValidatorTypeDefaultOne,
                                      ),
                                  })
                                  .describe(
                                    "Validator that accepts arbitrary dates.",
                                  ),
                                zod
                                  .object({
                                    type: zod
                                      .literal("coded_choice")
                                      .default(
                                        listSurveysResponseSurveysItemInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorRawValidatorTypeDefaultTwo,
                                      ),
                                    options: zod.array(
                                      zod
                                        .object({
                                          code: zod.string(),
                                          display: zod.string(),
                                        })
                                        .describe(
                                          "An option from a list of choices.",
                                        ),
                                    ),
                                  })
                                  .describe(
                                    "Validator that accepts any option from a list of choices.",
                                  ),
                                zod
                                  .object({
                                    type: zod
                                      .literal("phone_number")
                                      .default(
                                        listSurveysResponseSurveysItemInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorRawValidatorTypeDefaultThree,
                                      ),
                                  })
                                  .describe(
                                    "Validator that accepts arbitrary phone numbers.",
                                  ),
                                zod
                                  .object({
                                    type: zod
                                      .literal("email")
                                      .default(
                                        listSurveysResponseSurveysItemInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorRawValidatorTypeDefaultFour,
                                      ),
                                  })
                                  .describe(
                                    "Validator that accepts arbitrary emails.",
                                  ),
                                zod
                                  .object({
                                    type: zod
                                      .literal("city_state_zip")
                                      .default(
                                        listSurveysResponseSurveysItemInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorRawValidatorTypeDefaultFive,
                                      ),
                                  })
                                  .describe(
                                    "Validator that accepts city, state, and ZIP code combinations.",
                                  ),
                                zod.unknown(),
                                zod.unknown(),
                              ]),
                            })
                            .describe("Validator that accepts lists of items."),
                        ]),
                      })
                      .describe("Validator that accepts optional fields."),
                    zod
                      .object({
                        type: zod
                          .literal("list")
                          .default(
                            listSurveysResponseSurveysItemInstrumentSessionFormDefinitionFieldsItemValidatorTypeDefaultSeven,
                          ),
                        raw_validator: zod.union([
                          zod
                            .object({
                              type: zod
                                .literal("non_empty_string")
                                .default(
                                  listSurveysResponseSurveysItemInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorTypeDefaultSeven,
                                ),
                            })
                            .describe(
                              "Validator that accepts arbitrary non-empty strings.",
                            ),
                          zod
                            .object({
                              type: zod
                                .literal("date")
                                .default(
                                  listSurveysResponseSurveysItemInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorTypeDefaultEight,
                                ),
                            })
                            .describe(
                              "Validator that accepts arbitrary dates.",
                            ),
                          zod
                            .object({
                              type: zod
                                .literal("coded_choice")
                                .default(
                                  listSurveysResponseSurveysItemInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorTypeDefaultNine,
                                ),
                              options: zod.array(
                                zod
                                  .object({
                                    code: zod.string(),
                                    display: zod.string(),
                                  })
                                  .describe(
                                    "An option from a list of choices.",
                                  ),
                              ),
                            })
                            .describe(
                              "Validator that accepts any option from a list of choices.",
                            ),
                          zod
                            .object({
                              type: zod
                                .literal("phone_number")
                                .default(
                                  listSurveysResponseSurveysItemInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorTypeDefaultOnezero,
                                ),
                            })
                            .describe(
                              "Validator that accepts arbitrary phone numbers.",
                            ),
                          zod
                            .object({
                              type: zod
                                .literal("email")
                                .default(
                                  listSurveysResponseSurveysItemInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorTypeDefaultOneone,
                                ),
                            })
                            .describe(
                              "Validator that accepts arbitrary emails.",
                            ),
                          zod
                            .object({
                              type: zod
                                .literal("city_state_zip")
                                .default(
                                  listSurveysResponseSurveysItemInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorTypeDefaultOnetwo,
                                ),
                            })
                            .describe(
                              "Validator that accepts city, state, and ZIP code combinations.",
                            ),
                          zod
                            .object({
                              type: zod
                                .literal("optional")
                                .default(
                                  listSurveysResponseSurveysItemInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorTypeDefaultOnethree,
                                ),
                              raw_validator: zod.union([
                                zod
                                  .object({
                                    type: zod
                                      .literal("non_empty_string")
                                      .default(
                                        listSurveysResponseSurveysItemInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorRawValidatorTypeDefaultSix,
                                      ),
                                  })
                                  .describe(
                                    "Validator that accepts arbitrary non-empty strings.",
                                  ),
                                zod
                                  .object({
                                    type: zod
                                      .literal("date")
                                      .default(
                                        listSurveysResponseSurveysItemInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorRawValidatorTypeDefaultSeven,
                                      ),
                                  })
                                  .describe(
                                    "Validator that accepts arbitrary dates.",
                                  ),
                                zod
                                  .object({
                                    type: zod
                                      .literal("coded_choice")
                                      .default(
                                        listSurveysResponseSurveysItemInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorRawValidatorTypeDefaultEight,
                                      ),
                                    options: zod.array(
                                      zod
                                        .object({
                                          code: zod.string(),
                                          display: zod.string(),
                                        })
                                        .describe(
                                          "An option from a list of choices.",
                                        ),
                                    ),
                                  })
                                  .describe(
                                    "Validator that accepts any option from a list of choices.",
                                  ),
                                zod
                                  .object({
                                    type: zod
                                      .literal("phone_number")
                                      .default(
                                        listSurveysResponseSurveysItemInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorRawValidatorTypeDefaultNine,
                                      ),
                                  })
                                  .describe(
                                    "Validator that accepts arbitrary phone numbers.",
                                  ),
                                zod
                                  .object({
                                    type: zod
                                      .literal("email")
                                      .default(
                                        listSurveysResponseSurveysItemInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorRawValidatorTypeDefaultOnezero,
                                      ),
                                  })
                                  .describe(
                                    "Validator that accepts arbitrary emails.",
                                  ),
                                zod
                                  .object({
                                    type: zod
                                      .literal("city_state_zip")
                                      .default(
                                        listSurveysResponseSurveysItemInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorRawValidatorTypeDefaultOneone,
                                      ),
                                  })
                                  .describe(
                                    "Validator that accepts city, state, and ZIP code combinations.",
                                  ),
                                zod.unknown(),
                                zod.unknown(),
                              ]),
                            })
                            .describe(
                              "Validator that accepts optional fields.",
                            ),
                          zod.unknown(),
                        ]),
                      })
                      .describe("Validator that accepts lists of items."),
                  ]),
                }),
              ),
            }),
            submissions: zod.object({
              submissions: zod.record(
                zod.string(),
                zod.union([
                  zod.object({
                    type: zod
                      .literal("string")
                      .default(
                        listSurveysResponseSurveysItemInstrumentSessionSubmissionsSubmissionsTypeDefault,
                      ),
                    value: zod.string(),
                  }),
                  zod.object({
                    type: zod
                      .literal("int")
                      .default(
                        listSurveysResponseSurveysItemInstrumentSessionSubmissionsSubmissionsTypeDefaultOne,
                      ),
                    value: zod.number(),
                  }),
                  zod.object({
                    type: zod
                      .literal("simple_address")
                      .default(
                        listSurveysResponseSurveysItemInstrumentSessionSubmissionsSubmissionsTypeDefaultTwo,
                      ),
                    street_address: zod.string(),
                    city_state_zip: zod.string(),
                  }),
                  zod.object({
                    type: zod
                      .literal("list")
                      .default(
                        listSurveysResponseSurveysItemInstrumentSessionSubmissionsSubmissionsTypeDefaultThree,
                      ),
                    values: zod.array(
                      zod.union([
                        zod.object({
                          type: zod
                            .literal("string")
                            .default(
                              listSurveysResponseSurveysItemInstrumentSessionSubmissionsSubmissionsValuesItemTypeDefault,
                            ),
                          value: zod.string(),
                        }),
                        zod.object({
                          type: zod
                            .literal("int")
                            .default(
                              listSurveysResponseSurveysItemInstrumentSessionSubmissionsSubmissionsValuesItemTypeDefaultOne,
                            ),
                          value: zod.number(),
                        }),
                        zod.object({
                          type: zod
                            .literal("simple_address")
                            .default(
                              listSurveysResponseSurveysItemInstrumentSessionSubmissionsSubmissionsValuesItemTypeDefaultTwo,
                            ),
                          street_address: zod.string(),
                          city_state_zip: zod.string(),
                        }),
                        zod.unknown(),
                      ]),
                    ),
                  }),
                ]),
              ),
            }),
            problems: zod.record(zod.string(), zod.string()),
            interpretation: zod.union([
              zod.object({
                type: zod.enum(["complete", "incomplete", "error"]),
                text: zod.string(),
              }),
              zod.null(),
            ]),
          })
          .describe(
            'An \"instrument session\" links the immediate state of a form with an instrumnet,\nwhich\n\nThis captures the instrument type, its form definition, and the user\'s\ncurrent submissions so that follow-ups can be processed without needing\nto look up the instrument again.',
          ),
        created_at: zod.iso.datetime({}),
        updated_at: zod.iso.datetime({}),
        completed_at: zod.union([zod.iso.datetime({}), zod.null()]),
      })
      .describe(
        "Persisted instrument survey record.\n\nEach row represents one survey instance for one patient. The embedded\n``instrument_session`` carries the form definition, submissions, and\ninterpretation. Instrument-specific construction data (e.g. review\nrows for PHR data quality) lives in ``instrument_params`` so the\ninstrument can be reconstructed without the global registry.",
      ),
  ),
});

/**
 * @summary Get Survey
 */
export const getSurveyParams = zod.object({
  survey_id: zod.uuid(),
});

export const getSurveyResponseTypeDefault = "success";
export const getSurveyResponseSurveyInstrumentSessionFormDefinitionFieldsItemSuggestedSubmissionTypeDefault =
  "string";
export const getSurveyResponseSurveyInstrumentSessionFormDefinitionFieldsItemSuggestedSubmissionTypeDefaultOne =
  "int";
export const getSurveyResponseSurveyInstrumentSessionFormDefinitionFieldsItemSuggestedSubmissionTypeDefaultTwo =
  "simple_address";
export const getSurveyResponseSurveyInstrumentSessionFormDefinitionFieldsItemSuggestedSubmissionTypeDefaultThree =
  "list";
export const getSurveyResponseSurveyInstrumentSessionFormDefinitionFieldsItemSuggestedSubmissionValuesItemTypeDefault =
  "string";
export const getSurveyResponseSurveyInstrumentSessionFormDefinitionFieldsItemSuggestedSubmissionValuesItemTypeDefaultOne =
  "int";
export const getSurveyResponseSurveyInstrumentSessionFormDefinitionFieldsItemSuggestedSubmissionValuesItemTypeDefaultTwo =
  "simple_address";
export const getSurveyResponseSurveyInstrumentSessionFormDefinitionFieldsItemDefaultSubmissionTypeDefault =
  "string";
export const getSurveyResponseSurveyInstrumentSessionFormDefinitionFieldsItemDefaultSubmissionTypeDefaultOne =
  "int";
export const getSurveyResponseSurveyInstrumentSessionFormDefinitionFieldsItemDefaultSubmissionTypeDefaultTwo =
  "simple_address";
export const getSurveyResponseSurveyInstrumentSessionFormDefinitionFieldsItemDefaultSubmissionTypeDefaultThree =
  "list";
export const getSurveyResponseSurveyInstrumentSessionFormDefinitionFieldsItemDefaultSubmissionValuesItemTypeDefault =
  "string";
export const getSurveyResponseSurveyInstrumentSessionFormDefinitionFieldsItemDefaultSubmissionValuesItemTypeDefaultOne =
  "int";
export const getSurveyResponseSurveyInstrumentSessionFormDefinitionFieldsItemDefaultSubmissionValuesItemTypeDefaultTwo =
  "simple_address";
export const getSurveyResponseSurveyInstrumentSessionFormDefinitionFieldsItemValidatorTypeDefault =
  "non_empty_string";
export const getSurveyResponseSurveyInstrumentSessionFormDefinitionFieldsItemValidatorTypeDefaultOne =
  "date";
export const getSurveyResponseSurveyInstrumentSessionFormDefinitionFieldsItemValidatorTypeDefaultTwo =
  "coded_choice";
export const getSurveyResponseSurveyInstrumentSessionFormDefinitionFieldsItemValidatorTypeDefaultThree =
  "phone_number";
export const getSurveyResponseSurveyInstrumentSessionFormDefinitionFieldsItemValidatorTypeDefaultFour =
  "email";
export const getSurveyResponseSurveyInstrumentSessionFormDefinitionFieldsItemValidatorTypeDefaultFive =
  "city_state_zip";
export const getSurveyResponseSurveyInstrumentSessionFormDefinitionFieldsItemValidatorTypeDefaultSix =
  "optional";
export const getSurveyResponseSurveyInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorTypeDefault =
  "non_empty_string";
export const getSurveyResponseSurveyInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorTypeDefaultOne =
  "date";
export const getSurveyResponseSurveyInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorTypeDefaultTwo =
  "coded_choice";
export const getSurveyResponseSurveyInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorTypeDefaultThree =
  "phone_number";
export const getSurveyResponseSurveyInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorTypeDefaultFour =
  "email";
export const getSurveyResponseSurveyInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorTypeDefaultFive =
  "city_state_zip";
export const getSurveyResponseSurveyInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorTypeDefaultSix =
  "list";
export const getSurveyResponseSurveyInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorRawValidatorTypeDefault =
  "non_empty_string";
export const getSurveyResponseSurveyInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorRawValidatorTypeDefaultOne =
  "date";
export const getSurveyResponseSurveyInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorRawValidatorTypeDefaultTwo =
  "coded_choice";
export const getSurveyResponseSurveyInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorRawValidatorTypeDefaultThree =
  "phone_number";
export const getSurveyResponseSurveyInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorRawValidatorTypeDefaultFour =
  "email";
export const getSurveyResponseSurveyInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorRawValidatorTypeDefaultFive =
  "city_state_zip";
export const getSurveyResponseSurveyInstrumentSessionFormDefinitionFieldsItemValidatorTypeDefaultSeven =
  "list";
export const getSurveyResponseSurveyInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorTypeDefaultSeven =
  "non_empty_string";
export const getSurveyResponseSurveyInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorTypeDefaultEight =
  "date";
export const getSurveyResponseSurveyInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorTypeDefaultNine =
  "coded_choice";
export const getSurveyResponseSurveyInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorTypeDefaultOnezero =
  "phone_number";
export const getSurveyResponseSurveyInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorTypeDefaultOneone =
  "email";
export const getSurveyResponseSurveyInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorTypeDefaultOnetwo =
  "city_state_zip";
export const getSurveyResponseSurveyInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorTypeDefaultOnethree =
  "optional";
export const getSurveyResponseSurveyInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorRawValidatorTypeDefaultSix =
  "non_empty_string";
export const getSurveyResponseSurveyInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorRawValidatorTypeDefaultSeven =
  "date";
export const getSurveyResponseSurveyInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorRawValidatorTypeDefaultEight =
  "coded_choice";
export const getSurveyResponseSurveyInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorRawValidatorTypeDefaultNine =
  "phone_number";
export const getSurveyResponseSurveyInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorRawValidatorTypeDefaultOnezero =
  "email";
export const getSurveyResponseSurveyInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorRawValidatorTypeDefaultOneone =
  "city_state_zip";
export const getSurveyResponseSurveyInstrumentSessionSubmissionsSubmissionsTypeDefault =
  "string";
export const getSurveyResponseSurveyInstrumentSessionSubmissionsSubmissionsTypeDefaultOne =
  "int";
export const getSurveyResponseSurveyInstrumentSessionSubmissionsSubmissionsTypeDefaultTwo =
  "simple_address";
export const getSurveyResponseSurveyInstrumentSessionSubmissionsSubmissionsTypeDefaultThree =
  "list";
export const getSurveyResponseSurveyInstrumentSessionSubmissionsSubmissionsValuesItemTypeDefault =
  "string";
export const getSurveyResponseSurveyInstrumentSessionSubmissionsSubmissionsValuesItemTypeDefaultOne =
  "int";
export const getSurveyResponseSurveyInstrumentSessionSubmissionsSubmissionsValuesItemTypeDefaultTwo =
  "simple_address";
export const getSurveyResponseTypeDefaultOne = "not_found";

export const getSurveyResponse = zod.union([
  zod.object({
    type: zod.literal("success").default(getSurveyResponseTypeDefault),
    survey: zod
      .object({
        survey_id: zod.uuid(),
        user_id: zod.uuid(),
        instrument_id: zod.string(),
        status: zod.enum(["open", "completed", "archived"]),
        instrument_params: zod.union([
          zod.record(zod.string(), zod.unknown()),
          zod.null(),
        ]),
        instrument_session: zod
          .object({
            instrument_id: zod.string(),
            form_definition: zod.object({
              fields: zod.array(
                zod.object({
                  id: zod.string(),
                  profile: zod.object({
                    name: zod.string(),
                    description: zod
                      .union([zod.string(), zod.null()])
                      .optional(),
                  }),
                  suggested_submission: zod
                    .union([
                      zod.union([
                        zod.object({
                          type: zod
                            .literal("string")
                            .default(
                              getSurveyResponseSurveyInstrumentSessionFormDefinitionFieldsItemSuggestedSubmissionTypeDefault,
                            ),
                          value: zod.string(),
                        }),
                        zod.object({
                          type: zod
                            .literal("int")
                            .default(
                              getSurveyResponseSurveyInstrumentSessionFormDefinitionFieldsItemSuggestedSubmissionTypeDefaultOne,
                            ),
                          value: zod.number(),
                        }),
                        zod.object({
                          type: zod
                            .literal("simple_address")
                            .default(
                              getSurveyResponseSurveyInstrumentSessionFormDefinitionFieldsItemSuggestedSubmissionTypeDefaultTwo,
                            ),
                          street_address: zod.string(),
                          city_state_zip: zod.string(),
                        }),
                        zod.object({
                          type: zod
                            .literal("list")
                            .default(
                              getSurveyResponseSurveyInstrumentSessionFormDefinitionFieldsItemSuggestedSubmissionTypeDefaultThree,
                            ),
                          values: zod.array(
                            zod.union([
                              zod.object({
                                type: zod
                                  .literal("string")
                                  .default(
                                    getSurveyResponseSurveyInstrumentSessionFormDefinitionFieldsItemSuggestedSubmissionValuesItemTypeDefault,
                                  ),
                                value: zod.string(),
                              }),
                              zod.object({
                                type: zod
                                  .literal("int")
                                  .default(
                                    getSurveyResponseSurveyInstrumentSessionFormDefinitionFieldsItemSuggestedSubmissionValuesItemTypeDefaultOne,
                                  ),
                                value: zod.number(),
                              }),
                              zod.object({
                                type: zod
                                  .literal("simple_address")
                                  .default(
                                    getSurveyResponseSurveyInstrumentSessionFormDefinitionFieldsItemSuggestedSubmissionValuesItemTypeDefaultTwo,
                                  ),
                                street_address: zod.string(),
                                city_state_zip: zod.string(),
                              }),
                              zod.unknown(),
                            ]),
                          ),
                        }),
                      ]),
                      zod.null(),
                    ])
                    .optional(),
                  default_submission: zod
                    .union([
                      zod.union([
                        zod.object({
                          type: zod
                            .literal("string")
                            .default(
                              getSurveyResponseSurveyInstrumentSessionFormDefinitionFieldsItemDefaultSubmissionTypeDefault,
                            ),
                          value: zod.string(),
                        }),
                        zod.object({
                          type: zod
                            .literal("int")
                            .default(
                              getSurveyResponseSurveyInstrumentSessionFormDefinitionFieldsItemDefaultSubmissionTypeDefaultOne,
                            ),
                          value: zod.number(),
                        }),
                        zod.object({
                          type: zod
                            .literal("simple_address")
                            .default(
                              getSurveyResponseSurveyInstrumentSessionFormDefinitionFieldsItemDefaultSubmissionTypeDefaultTwo,
                            ),
                          street_address: zod.string(),
                          city_state_zip: zod.string(),
                        }),
                        zod.object({
                          type: zod
                            .literal("list")
                            .default(
                              getSurveyResponseSurveyInstrumentSessionFormDefinitionFieldsItemDefaultSubmissionTypeDefaultThree,
                            ),
                          values: zod.array(
                            zod.union([
                              zod.object({
                                type: zod
                                  .literal("string")
                                  .default(
                                    getSurveyResponseSurveyInstrumentSessionFormDefinitionFieldsItemDefaultSubmissionValuesItemTypeDefault,
                                  ),
                                value: zod.string(),
                              }),
                              zod.object({
                                type: zod
                                  .literal("int")
                                  .default(
                                    getSurveyResponseSurveyInstrumentSessionFormDefinitionFieldsItemDefaultSubmissionValuesItemTypeDefaultOne,
                                  ),
                                value: zod.number(),
                              }),
                              zod.object({
                                type: zod
                                  .literal("simple_address")
                                  .default(
                                    getSurveyResponseSurveyInstrumentSessionFormDefinitionFieldsItemDefaultSubmissionValuesItemTypeDefaultTwo,
                                  ),
                                street_address: zod.string(),
                                city_state_zip: zod.string(),
                              }),
                              zod.unknown(),
                            ]),
                          ),
                        }),
                      ]),
                      zod.null(),
                    ])
                    .optional(),
                  validator: zod.union([
                    zod
                      .object({
                        type: zod
                          .literal("non_empty_string")
                          .default(
                            getSurveyResponseSurveyInstrumentSessionFormDefinitionFieldsItemValidatorTypeDefault,
                          ),
                      })
                      .describe(
                        "Validator that accepts arbitrary non-empty strings.",
                      ),
                    zod
                      .object({
                        type: zod
                          .literal("date")
                          .default(
                            getSurveyResponseSurveyInstrumentSessionFormDefinitionFieldsItemValidatorTypeDefaultOne,
                          ),
                      })
                      .describe("Validator that accepts arbitrary dates."),
                    zod
                      .object({
                        type: zod
                          .literal("coded_choice")
                          .default(
                            getSurveyResponseSurveyInstrumentSessionFormDefinitionFieldsItemValidatorTypeDefaultTwo,
                          ),
                        options: zod.array(
                          zod
                            .object({
                              code: zod.string(),
                              display: zod.string(),
                            })
                            .describe("An option from a list of choices."),
                        ),
                      })
                      .describe(
                        "Validator that accepts any option from a list of choices.",
                      ),
                    zod
                      .object({
                        type: zod
                          .literal("phone_number")
                          .default(
                            getSurveyResponseSurveyInstrumentSessionFormDefinitionFieldsItemValidatorTypeDefaultThree,
                          ),
                      })
                      .describe(
                        "Validator that accepts arbitrary phone numbers.",
                      ),
                    zod
                      .object({
                        type: zod
                          .literal("email")
                          .default(
                            getSurveyResponseSurveyInstrumentSessionFormDefinitionFieldsItemValidatorTypeDefaultFour,
                          ),
                      })
                      .describe("Validator that accepts arbitrary emails."),
                    zod
                      .object({
                        type: zod
                          .literal("city_state_zip")
                          .default(
                            getSurveyResponseSurveyInstrumentSessionFormDefinitionFieldsItemValidatorTypeDefaultFive,
                          ),
                      })
                      .describe(
                        "Validator that accepts city, state, and ZIP code combinations.",
                      ),
                    zod
                      .object({
                        type: zod
                          .literal("optional")
                          .default(
                            getSurveyResponseSurveyInstrumentSessionFormDefinitionFieldsItemValidatorTypeDefaultSix,
                          ),
                        raw_validator: zod.union([
                          zod
                            .object({
                              type: zod
                                .literal("non_empty_string")
                                .default(
                                  getSurveyResponseSurveyInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorTypeDefault,
                                ),
                            })
                            .describe(
                              "Validator that accepts arbitrary non-empty strings.",
                            ),
                          zod
                            .object({
                              type: zod
                                .literal("date")
                                .default(
                                  getSurveyResponseSurveyInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorTypeDefaultOne,
                                ),
                            })
                            .describe(
                              "Validator that accepts arbitrary dates.",
                            ),
                          zod
                            .object({
                              type: zod
                                .literal("coded_choice")
                                .default(
                                  getSurveyResponseSurveyInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorTypeDefaultTwo,
                                ),
                              options: zod.array(
                                zod
                                  .object({
                                    code: zod.string(),
                                    display: zod.string(),
                                  })
                                  .describe(
                                    "An option from a list of choices.",
                                  ),
                              ),
                            })
                            .describe(
                              "Validator that accepts any option from a list of choices.",
                            ),
                          zod
                            .object({
                              type: zod
                                .literal("phone_number")
                                .default(
                                  getSurveyResponseSurveyInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorTypeDefaultThree,
                                ),
                            })
                            .describe(
                              "Validator that accepts arbitrary phone numbers.",
                            ),
                          zod
                            .object({
                              type: zod
                                .literal("email")
                                .default(
                                  getSurveyResponseSurveyInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorTypeDefaultFour,
                                ),
                            })
                            .describe(
                              "Validator that accepts arbitrary emails.",
                            ),
                          zod
                            .object({
                              type: zod
                                .literal("city_state_zip")
                                .default(
                                  getSurveyResponseSurveyInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorTypeDefaultFive,
                                ),
                            })
                            .describe(
                              "Validator that accepts city, state, and ZIP code combinations.",
                            ),
                          zod.unknown(),
                          zod
                            .object({
                              type: zod
                                .literal("list")
                                .default(
                                  getSurveyResponseSurveyInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorTypeDefaultSix,
                                ),
                              raw_validator: zod.union([
                                zod
                                  .object({
                                    type: zod
                                      .literal("non_empty_string")
                                      .default(
                                        getSurveyResponseSurveyInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorRawValidatorTypeDefault,
                                      ),
                                  })
                                  .describe(
                                    "Validator that accepts arbitrary non-empty strings.",
                                  ),
                                zod
                                  .object({
                                    type: zod
                                      .literal("date")
                                      .default(
                                        getSurveyResponseSurveyInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorRawValidatorTypeDefaultOne,
                                      ),
                                  })
                                  .describe(
                                    "Validator that accepts arbitrary dates.",
                                  ),
                                zod
                                  .object({
                                    type: zod
                                      .literal("coded_choice")
                                      .default(
                                        getSurveyResponseSurveyInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorRawValidatorTypeDefaultTwo,
                                      ),
                                    options: zod.array(
                                      zod
                                        .object({
                                          code: zod.string(),
                                          display: zod.string(),
                                        })
                                        .describe(
                                          "An option from a list of choices.",
                                        ),
                                    ),
                                  })
                                  .describe(
                                    "Validator that accepts any option from a list of choices.",
                                  ),
                                zod
                                  .object({
                                    type: zod
                                      .literal("phone_number")
                                      .default(
                                        getSurveyResponseSurveyInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorRawValidatorTypeDefaultThree,
                                      ),
                                  })
                                  .describe(
                                    "Validator that accepts arbitrary phone numbers.",
                                  ),
                                zod
                                  .object({
                                    type: zod
                                      .literal("email")
                                      .default(
                                        getSurveyResponseSurveyInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorRawValidatorTypeDefaultFour,
                                      ),
                                  })
                                  .describe(
                                    "Validator that accepts arbitrary emails.",
                                  ),
                                zod
                                  .object({
                                    type: zod
                                      .literal("city_state_zip")
                                      .default(
                                        getSurveyResponseSurveyInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorRawValidatorTypeDefaultFive,
                                      ),
                                  })
                                  .describe(
                                    "Validator that accepts city, state, and ZIP code combinations.",
                                  ),
                                zod.unknown(),
                                zod.unknown(),
                              ]),
                            })
                            .describe("Validator that accepts lists of items."),
                        ]),
                      })
                      .describe("Validator that accepts optional fields."),
                    zod
                      .object({
                        type: zod
                          .literal("list")
                          .default(
                            getSurveyResponseSurveyInstrumentSessionFormDefinitionFieldsItemValidatorTypeDefaultSeven,
                          ),
                        raw_validator: zod.union([
                          zod
                            .object({
                              type: zod
                                .literal("non_empty_string")
                                .default(
                                  getSurveyResponseSurveyInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorTypeDefaultSeven,
                                ),
                            })
                            .describe(
                              "Validator that accepts arbitrary non-empty strings.",
                            ),
                          zod
                            .object({
                              type: zod
                                .literal("date")
                                .default(
                                  getSurveyResponseSurveyInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorTypeDefaultEight,
                                ),
                            })
                            .describe(
                              "Validator that accepts arbitrary dates.",
                            ),
                          zod
                            .object({
                              type: zod
                                .literal("coded_choice")
                                .default(
                                  getSurveyResponseSurveyInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorTypeDefaultNine,
                                ),
                              options: zod.array(
                                zod
                                  .object({
                                    code: zod.string(),
                                    display: zod.string(),
                                  })
                                  .describe(
                                    "An option from a list of choices.",
                                  ),
                              ),
                            })
                            .describe(
                              "Validator that accepts any option from a list of choices.",
                            ),
                          zod
                            .object({
                              type: zod
                                .literal("phone_number")
                                .default(
                                  getSurveyResponseSurveyInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorTypeDefaultOnezero,
                                ),
                            })
                            .describe(
                              "Validator that accepts arbitrary phone numbers.",
                            ),
                          zod
                            .object({
                              type: zod
                                .literal("email")
                                .default(
                                  getSurveyResponseSurveyInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorTypeDefaultOneone,
                                ),
                            })
                            .describe(
                              "Validator that accepts arbitrary emails.",
                            ),
                          zod
                            .object({
                              type: zod
                                .literal("city_state_zip")
                                .default(
                                  getSurveyResponseSurveyInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorTypeDefaultOnetwo,
                                ),
                            })
                            .describe(
                              "Validator that accepts city, state, and ZIP code combinations.",
                            ),
                          zod
                            .object({
                              type: zod
                                .literal("optional")
                                .default(
                                  getSurveyResponseSurveyInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorTypeDefaultOnethree,
                                ),
                              raw_validator: zod.union([
                                zod
                                  .object({
                                    type: zod
                                      .literal("non_empty_string")
                                      .default(
                                        getSurveyResponseSurveyInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorRawValidatorTypeDefaultSix,
                                      ),
                                  })
                                  .describe(
                                    "Validator that accepts arbitrary non-empty strings.",
                                  ),
                                zod
                                  .object({
                                    type: zod
                                      .literal("date")
                                      .default(
                                        getSurveyResponseSurveyInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorRawValidatorTypeDefaultSeven,
                                      ),
                                  })
                                  .describe(
                                    "Validator that accepts arbitrary dates.",
                                  ),
                                zod
                                  .object({
                                    type: zod
                                      .literal("coded_choice")
                                      .default(
                                        getSurveyResponseSurveyInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorRawValidatorTypeDefaultEight,
                                      ),
                                    options: zod.array(
                                      zod
                                        .object({
                                          code: zod.string(),
                                          display: zod.string(),
                                        })
                                        .describe(
                                          "An option from a list of choices.",
                                        ),
                                    ),
                                  })
                                  .describe(
                                    "Validator that accepts any option from a list of choices.",
                                  ),
                                zod
                                  .object({
                                    type: zod
                                      .literal("phone_number")
                                      .default(
                                        getSurveyResponseSurveyInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorRawValidatorTypeDefaultNine,
                                      ),
                                  })
                                  .describe(
                                    "Validator that accepts arbitrary phone numbers.",
                                  ),
                                zod
                                  .object({
                                    type: zod
                                      .literal("email")
                                      .default(
                                        getSurveyResponseSurveyInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorRawValidatorTypeDefaultOnezero,
                                      ),
                                  })
                                  .describe(
                                    "Validator that accepts arbitrary emails.",
                                  ),
                                zod
                                  .object({
                                    type: zod
                                      .literal("city_state_zip")
                                      .default(
                                        getSurveyResponseSurveyInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorRawValidatorTypeDefaultOneone,
                                      ),
                                  })
                                  .describe(
                                    "Validator that accepts city, state, and ZIP code combinations.",
                                  ),
                                zod.unknown(),
                                zod.unknown(),
                              ]),
                            })
                            .describe(
                              "Validator that accepts optional fields.",
                            ),
                          zod.unknown(),
                        ]),
                      })
                      .describe("Validator that accepts lists of items."),
                  ]),
                }),
              ),
            }),
            submissions: zod.object({
              submissions: zod.record(
                zod.string(),
                zod.union([
                  zod.object({
                    type: zod
                      .literal("string")
                      .default(
                        getSurveyResponseSurveyInstrumentSessionSubmissionsSubmissionsTypeDefault,
                      ),
                    value: zod.string(),
                  }),
                  zod.object({
                    type: zod
                      .literal("int")
                      .default(
                        getSurveyResponseSurveyInstrumentSessionSubmissionsSubmissionsTypeDefaultOne,
                      ),
                    value: zod.number(),
                  }),
                  zod.object({
                    type: zod
                      .literal("simple_address")
                      .default(
                        getSurveyResponseSurveyInstrumentSessionSubmissionsSubmissionsTypeDefaultTwo,
                      ),
                    street_address: zod.string(),
                    city_state_zip: zod.string(),
                  }),
                  zod.object({
                    type: zod
                      .literal("list")
                      .default(
                        getSurveyResponseSurveyInstrumentSessionSubmissionsSubmissionsTypeDefaultThree,
                      ),
                    values: zod.array(
                      zod.union([
                        zod.object({
                          type: zod
                            .literal("string")
                            .default(
                              getSurveyResponseSurveyInstrumentSessionSubmissionsSubmissionsValuesItemTypeDefault,
                            ),
                          value: zod.string(),
                        }),
                        zod.object({
                          type: zod
                            .literal("int")
                            .default(
                              getSurveyResponseSurveyInstrumentSessionSubmissionsSubmissionsValuesItemTypeDefaultOne,
                            ),
                          value: zod.number(),
                        }),
                        zod.object({
                          type: zod
                            .literal("simple_address")
                            .default(
                              getSurveyResponseSurveyInstrumentSessionSubmissionsSubmissionsValuesItemTypeDefaultTwo,
                            ),
                          street_address: zod.string(),
                          city_state_zip: zod.string(),
                        }),
                        zod.unknown(),
                      ]),
                    ),
                  }),
                ]),
              ),
            }),
            problems: zod.record(zod.string(), zod.string()),
            interpretation: zod.union([
              zod.object({
                type: zod.enum(["complete", "incomplete", "error"]),
                text: zod.string(),
              }),
              zod.null(),
            ]),
          })
          .describe(
            'An \"instrument session\" links the immediate state of a form with an instrumnet,\nwhich\n\nThis captures the instrument type, its form definition, and the user\'s\ncurrent submissions so that follow-ups can be processed without needing\nto look up the instrument again.',
          ),
        created_at: zod.iso.datetime({}),
        updated_at: zod.iso.datetime({}),
        completed_at: zod.union([zod.iso.datetime({}), zod.null()]),
      })
      .describe(
        "Persisted instrument survey record.\n\nEach row represents one survey instance for one patient. The embedded\n``instrument_session`` carries the form definition, submissions, and\ninterpretation. Instrument-specific construction data (e.g. review\nrows for PHR data quality) lives in ``instrument_params`` so the\ninstrument can be reconstructed without the global registry.",
      ),
  }),
  zod.object({
    type: zod.literal("not_found").default(getSurveyResponseTypeDefaultOne),
  }),
]);

/**
 * @summary Submit Answers
 */
export const submitAnswersParams = zod.object({
  survey_id: zod.uuid(),
});

export const submitAnswersBodySubmissionsSubmissionsTypeDefault = "string";
export const submitAnswersBodySubmissionsSubmissionsTypeDefaultOne = "int";
export const submitAnswersBodySubmissionsSubmissionsTypeDefaultTwo =
  "simple_address";
export const submitAnswersBodySubmissionsSubmissionsTypeDefaultThree = "list";
export const submitAnswersBodySubmissionsSubmissionsValuesItemTypeDefault =
  "string";
export const submitAnswersBodySubmissionsSubmissionsValuesItemTypeDefaultOne =
  "int";
export const submitAnswersBodySubmissionsSubmissionsValuesItemTypeDefaultTwo =
  "simple_address";

export const submitAnswersBody = zod.object({
  submissions: zod.object({
    submissions: zod.record(
      zod.string(),
      zod.union([
        zod.object({
          type: zod
            .literal("string")
            .default(submitAnswersBodySubmissionsSubmissionsTypeDefault),
          value: zod.string(),
        }),
        zod.object({
          type: zod
            .literal("int")
            .default(submitAnswersBodySubmissionsSubmissionsTypeDefaultOne),
          value: zod.number(),
        }),
        zod.object({
          type: zod
            .literal("simple_address")
            .default(submitAnswersBodySubmissionsSubmissionsTypeDefaultTwo),
          street_address: zod.string(),
          city_state_zip: zod.string(),
        }),
        zod.object({
          type: zod
            .literal("list")
            .default(submitAnswersBodySubmissionsSubmissionsTypeDefaultThree),
          values: zod.array(
            zod.union([
              zod.object({
                type: zod
                  .literal("string")
                  .default(
                    submitAnswersBodySubmissionsSubmissionsValuesItemTypeDefault,
                  ),
                value: zod.string(),
              }),
              zod.object({
                type: zod
                  .literal("int")
                  .default(
                    submitAnswersBodySubmissionsSubmissionsValuesItemTypeDefaultOne,
                  ),
                value: zod.number(),
              }),
              zod.object({
                type: zod
                  .literal("simple_address")
                  .default(
                    submitAnswersBodySubmissionsSubmissionsValuesItemTypeDefaultTwo,
                  ),
                street_address: zod.string(),
                city_state_zip: zod.string(),
              }),
              zod.unknown(),
            ]),
          ),
        }),
      ]),
    ),
  }),
});

export const submitAnswersResponseTypeDefault = "success";
export const submitAnswersResponseSurveyInstrumentSessionFormDefinitionFieldsItemSuggestedSubmissionTypeDefault =
  "string";
export const submitAnswersResponseSurveyInstrumentSessionFormDefinitionFieldsItemSuggestedSubmissionTypeDefaultOne =
  "int";
export const submitAnswersResponseSurveyInstrumentSessionFormDefinitionFieldsItemSuggestedSubmissionTypeDefaultTwo =
  "simple_address";
export const submitAnswersResponseSurveyInstrumentSessionFormDefinitionFieldsItemSuggestedSubmissionTypeDefaultThree =
  "list";
export const submitAnswersResponseSurveyInstrumentSessionFormDefinitionFieldsItemSuggestedSubmissionValuesItemTypeDefault =
  "string";
export const submitAnswersResponseSurveyInstrumentSessionFormDefinitionFieldsItemSuggestedSubmissionValuesItemTypeDefaultOne =
  "int";
export const submitAnswersResponseSurveyInstrumentSessionFormDefinitionFieldsItemSuggestedSubmissionValuesItemTypeDefaultTwo =
  "simple_address";
export const submitAnswersResponseSurveyInstrumentSessionFormDefinitionFieldsItemDefaultSubmissionTypeDefault =
  "string";
export const submitAnswersResponseSurveyInstrumentSessionFormDefinitionFieldsItemDefaultSubmissionTypeDefaultOne =
  "int";
export const submitAnswersResponseSurveyInstrumentSessionFormDefinitionFieldsItemDefaultSubmissionTypeDefaultTwo =
  "simple_address";
export const submitAnswersResponseSurveyInstrumentSessionFormDefinitionFieldsItemDefaultSubmissionTypeDefaultThree =
  "list";
export const submitAnswersResponseSurveyInstrumentSessionFormDefinitionFieldsItemDefaultSubmissionValuesItemTypeDefault =
  "string";
export const submitAnswersResponseSurveyInstrumentSessionFormDefinitionFieldsItemDefaultSubmissionValuesItemTypeDefaultOne =
  "int";
export const submitAnswersResponseSurveyInstrumentSessionFormDefinitionFieldsItemDefaultSubmissionValuesItemTypeDefaultTwo =
  "simple_address";
export const submitAnswersResponseSurveyInstrumentSessionFormDefinitionFieldsItemValidatorTypeDefault =
  "non_empty_string";
export const submitAnswersResponseSurveyInstrumentSessionFormDefinitionFieldsItemValidatorTypeDefaultOne =
  "date";
export const submitAnswersResponseSurveyInstrumentSessionFormDefinitionFieldsItemValidatorTypeDefaultTwo =
  "coded_choice";
export const submitAnswersResponseSurveyInstrumentSessionFormDefinitionFieldsItemValidatorTypeDefaultThree =
  "phone_number";
export const submitAnswersResponseSurveyInstrumentSessionFormDefinitionFieldsItemValidatorTypeDefaultFour =
  "email";
export const submitAnswersResponseSurveyInstrumentSessionFormDefinitionFieldsItemValidatorTypeDefaultFive =
  "city_state_zip";
export const submitAnswersResponseSurveyInstrumentSessionFormDefinitionFieldsItemValidatorTypeDefaultSix =
  "optional";
export const submitAnswersResponseSurveyInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorTypeDefault =
  "non_empty_string";
export const submitAnswersResponseSurveyInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorTypeDefaultOne =
  "date";
export const submitAnswersResponseSurveyInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorTypeDefaultTwo =
  "coded_choice";
export const submitAnswersResponseSurveyInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorTypeDefaultThree =
  "phone_number";
export const submitAnswersResponseSurveyInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorTypeDefaultFour =
  "email";
export const submitAnswersResponseSurveyInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorTypeDefaultFive =
  "city_state_zip";
export const submitAnswersResponseSurveyInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorTypeDefaultSix =
  "list";
export const submitAnswersResponseSurveyInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorRawValidatorTypeDefault =
  "non_empty_string";
export const submitAnswersResponseSurveyInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorRawValidatorTypeDefaultOne =
  "date";
export const submitAnswersResponseSurveyInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorRawValidatorTypeDefaultTwo =
  "coded_choice";
export const submitAnswersResponseSurveyInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorRawValidatorTypeDefaultThree =
  "phone_number";
export const submitAnswersResponseSurveyInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorRawValidatorTypeDefaultFour =
  "email";
export const submitAnswersResponseSurveyInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorRawValidatorTypeDefaultFive =
  "city_state_zip";
export const submitAnswersResponseSurveyInstrumentSessionFormDefinitionFieldsItemValidatorTypeDefaultSeven =
  "list";
export const submitAnswersResponseSurveyInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorTypeDefaultSeven =
  "non_empty_string";
export const submitAnswersResponseSurveyInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorTypeDefaultEight =
  "date";
export const submitAnswersResponseSurveyInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorTypeDefaultNine =
  "coded_choice";
export const submitAnswersResponseSurveyInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorTypeDefaultOnezero =
  "phone_number";
export const submitAnswersResponseSurveyInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorTypeDefaultOneone =
  "email";
export const submitAnswersResponseSurveyInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorTypeDefaultOnetwo =
  "city_state_zip";
export const submitAnswersResponseSurveyInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorTypeDefaultOnethree =
  "optional";
export const submitAnswersResponseSurveyInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorRawValidatorTypeDefaultSix =
  "non_empty_string";
export const submitAnswersResponseSurveyInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorRawValidatorTypeDefaultSeven =
  "date";
export const submitAnswersResponseSurveyInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorRawValidatorTypeDefaultEight =
  "coded_choice";
export const submitAnswersResponseSurveyInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorRawValidatorTypeDefaultNine =
  "phone_number";
export const submitAnswersResponseSurveyInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorRawValidatorTypeDefaultOnezero =
  "email";
export const submitAnswersResponseSurveyInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorRawValidatorTypeDefaultOneone =
  "city_state_zip";
export const submitAnswersResponseSurveyInstrumentSessionSubmissionsSubmissionsTypeDefault =
  "string";
export const submitAnswersResponseSurveyInstrumentSessionSubmissionsSubmissionsTypeDefaultOne =
  "int";
export const submitAnswersResponseSurveyInstrumentSessionSubmissionsSubmissionsTypeDefaultTwo =
  "simple_address";
export const submitAnswersResponseSurveyInstrumentSessionSubmissionsSubmissionsTypeDefaultThree =
  "list";
export const submitAnswersResponseSurveyInstrumentSessionSubmissionsSubmissionsValuesItemTypeDefault =
  "string";
export const submitAnswersResponseSurveyInstrumentSessionSubmissionsSubmissionsValuesItemTypeDefaultOne =
  "int";
export const submitAnswersResponseSurveyInstrumentSessionSubmissionsSubmissionsValuesItemTypeDefaultTwo =
  "simple_address";
export const submitAnswersResponseTypeDefaultOne = "not_found";
export const submitAnswersResponseTypeDefaultTwo = "bad_status";

export const submitAnswersResponse = zod.union([
  zod.object({
    type: zod.literal("success").default(submitAnswersResponseTypeDefault),
    survey: zod
      .object({
        survey_id: zod.uuid(),
        user_id: zod.uuid(),
        instrument_id: zod.string(),
        status: zod.enum(["open", "completed", "archived"]),
        instrument_params: zod.union([
          zod.record(zod.string(), zod.unknown()),
          zod.null(),
        ]),
        instrument_session: zod
          .object({
            instrument_id: zod.string(),
            form_definition: zod.object({
              fields: zod.array(
                zod.object({
                  id: zod.string(),
                  profile: zod.object({
                    name: zod.string(),
                    description: zod
                      .union([zod.string(), zod.null()])
                      .optional(),
                  }),
                  suggested_submission: zod
                    .union([
                      zod.union([
                        zod.object({
                          type: zod
                            .literal("string")
                            .default(
                              submitAnswersResponseSurveyInstrumentSessionFormDefinitionFieldsItemSuggestedSubmissionTypeDefault,
                            ),
                          value: zod.string(),
                        }),
                        zod.object({
                          type: zod
                            .literal("int")
                            .default(
                              submitAnswersResponseSurveyInstrumentSessionFormDefinitionFieldsItemSuggestedSubmissionTypeDefaultOne,
                            ),
                          value: zod.number(),
                        }),
                        zod.object({
                          type: zod
                            .literal("simple_address")
                            .default(
                              submitAnswersResponseSurveyInstrumentSessionFormDefinitionFieldsItemSuggestedSubmissionTypeDefaultTwo,
                            ),
                          street_address: zod.string(),
                          city_state_zip: zod.string(),
                        }),
                        zod.object({
                          type: zod
                            .literal("list")
                            .default(
                              submitAnswersResponseSurveyInstrumentSessionFormDefinitionFieldsItemSuggestedSubmissionTypeDefaultThree,
                            ),
                          values: zod.array(
                            zod.union([
                              zod.object({
                                type: zod
                                  .literal("string")
                                  .default(
                                    submitAnswersResponseSurveyInstrumentSessionFormDefinitionFieldsItemSuggestedSubmissionValuesItemTypeDefault,
                                  ),
                                value: zod.string(),
                              }),
                              zod.object({
                                type: zod
                                  .literal("int")
                                  .default(
                                    submitAnswersResponseSurveyInstrumentSessionFormDefinitionFieldsItemSuggestedSubmissionValuesItemTypeDefaultOne,
                                  ),
                                value: zod.number(),
                              }),
                              zod.object({
                                type: zod
                                  .literal("simple_address")
                                  .default(
                                    submitAnswersResponseSurveyInstrumentSessionFormDefinitionFieldsItemSuggestedSubmissionValuesItemTypeDefaultTwo,
                                  ),
                                street_address: zod.string(),
                                city_state_zip: zod.string(),
                              }),
                              zod.unknown(),
                            ]),
                          ),
                        }),
                      ]),
                      zod.null(),
                    ])
                    .optional(),
                  default_submission: zod
                    .union([
                      zod.union([
                        zod.object({
                          type: zod
                            .literal("string")
                            .default(
                              submitAnswersResponseSurveyInstrumentSessionFormDefinitionFieldsItemDefaultSubmissionTypeDefault,
                            ),
                          value: zod.string(),
                        }),
                        zod.object({
                          type: zod
                            .literal("int")
                            .default(
                              submitAnswersResponseSurveyInstrumentSessionFormDefinitionFieldsItemDefaultSubmissionTypeDefaultOne,
                            ),
                          value: zod.number(),
                        }),
                        zod.object({
                          type: zod
                            .literal("simple_address")
                            .default(
                              submitAnswersResponseSurveyInstrumentSessionFormDefinitionFieldsItemDefaultSubmissionTypeDefaultTwo,
                            ),
                          street_address: zod.string(),
                          city_state_zip: zod.string(),
                        }),
                        zod.object({
                          type: zod
                            .literal("list")
                            .default(
                              submitAnswersResponseSurveyInstrumentSessionFormDefinitionFieldsItemDefaultSubmissionTypeDefaultThree,
                            ),
                          values: zod.array(
                            zod.union([
                              zod.object({
                                type: zod
                                  .literal("string")
                                  .default(
                                    submitAnswersResponseSurveyInstrumentSessionFormDefinitionFieldsItemDefaultSubmissionValuesItemTypeDefault,
                                  ),
                                value: zod.string(),
                              }),
                              zod.object({
                                type: zod
                                  .literal("int")
                                  .default(
                                    submitAnswersResponseSurveyInstrumentSessionFormDefinitionFieldsItemDefaultSubmissionValuesItemTypeDefaultOne,
                                  ),
                                value: zod.number(),
                              }),
                              zod.object({
                                type: zod
                                  .literal("simple_address")
                                  .default(
                                    submitAnswersResponseSurveyInstrumentSessionFormDefinitionFieldsItemDefaultSubmissionValuesItemTypeDefaultTwo,
                                  ),
                                street_address: zod.string(),
                                city_state_zip: zod.string(),
                              }),
                              zod.unknown(),
                            ]),
                          ),
                        }),
                      ]),
                      zod.null(),
                    ])
                    .optional(),
                  validator: zod.union([
                    zod
                      .object({
                        type: zod
                          .literal("non_empty_string")
                          .default(
                            submitAnswersResponseSurveyInstrumentSessionFormDefinitionFieldsItemValidatorTypeDefault,
                          ),
                      })
                      .describe(
                        "Validator that accepts arbitrary non-empty strings.",
                      ),
                    zod
                      .object({
                        type: zod
                          .literal("date")
                          .default(
                            submitAnswersResponseSurveyInstrumentSessionFormDefinitionFieldsItemValidatorTypeDefaultOne,
                          ),
                      })
                      .describe("Validator that accepts arbitrary dates."),
                    zod
                      .object({
                        type: zod
                          .literal("coded_choice")
                          .default(
                            submitAnswersResponseSurveyInstrumentSessionFormDefinitionFieldsItemValidatorTypeDefaultTwo,
                          ),
                        options: zod.array(
                          zod
                            .object({
                              code: zod.string(),
                              display: zod.string(),
                            })
                            .describe("An option from a list of choices."),
                        ),
                      })
                      .describe(
                        "Validator that accepts any option from a list of choices.",
                      ),
                    zod
                      .object({
                        type: zod
                          .literal("phone_number")
                          .default(
                            submitAnswersResponseSurveyInstrumentSessionFormDefinitionFieldsItemValidatorTypeDefaultThree,
                          ),
                      })
                      .describe(
                        "Validator that accepts arbitrary phone numbers.",
                      ),
                    zod
                      .object({
                        type: zod
                          .literal("email")
                          .default(
                            submitAnswersResponseSurveyInstrumentSessionFormDefinitionFieldsItemValidatorTypeDefaultFour,
                          ),
                      })
                      .describe("Validator that accepts arbitrary emails."),
                    zod
                      .object({
                        type: zod
                          .literal("city_state_zip")
                          .default(
                            submitAnswersResponseSurveyInstrumentSessionFormDefinitionFieldsItemValidatorTypeDefaultFive,
                          ),
                      })
                      .describe(
                        "Validator that accepts city, state, and ZIP code combinations.",
                      ),
                    zod
                      .object({
                        type: zod
                          .literal("optional")
                          .default(
                            submitAnswersResponseSurveyInstrumentSessionFormDefinitionFieldsItemValidatorTypeDefaultSix,
                          ),
                        raw_validator: zod.union([
                          zod
                            .object({
                              type: zod
                                .literal("non_empty_string")
                                .default(
                                  submitAnswersResponseSurveyInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorTypeDefault,
                                ),
                            })
                            .describe(
                              "Validator that accepts arbitrary non-empty strings.",
                            ),
                          zod
                            .object({
                              type: zod
                                .literal("date")
                                .default(
                                  submitAnswersResponseSurveyInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorTypeDefaultOne,
                                ),
                            })
                            .describe(
                              "Validator that accepts arbitrary dates.",
                            ),
                          zod
                            .object({
                              type: zod
                                .literal("coded_choice")
                                .default(
                                  submitAnswersResponseSurveyInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorTypeDefaultTwo,
                                ),
                              options: zod.array(
                                zod
                                  .object({
                                    code: zod.string(),
                                    display: zod.string(),
                                  })
                                  .describe(
                                    "An option from a list of choices.",
                                  ),
                              ),
                            })
                            .describe(
                              "Validator that accepts any option from a list of choices.",
                            ),
                          zod
                            .object({
                              type: zod
                                .literal("phone_number")
                                .default(
                                  submitAnswersResponseSurveyInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorTypeDefaultThree,
                                ),
                            })
                            .describe(
                              "Validator that accepts arbitrary phone numbers.",
                            ),
                          zod
                            .object({
                              type: zod
                                .literal("email")
                                .default(
                                  submitAnswersResponseSurveyInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorTypeDefaultFour,
                                ),
                            })
                            .describe(
                              "Validator that accepts arbitrary emails.",
                            ),
                          zod
                            .object({
                              type: zod
                                .literal("city_state_zip")
                                .default(
                                  submitAnswersResponseSurveyInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorTypeDefaultFive,
                                ),
                            })
                            .describe(
                              "Validator that accepts city, state, and ZIP code combinations.",
                            ),
                          zod.unknown(),
                          zod
                            .object({
                              type: zod
                                .literal("list")
                                .default(
                                  submitAnswersResponseSurveyInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorTypeDefaultSix,
                                ),
                              raw_validator: zod.union([
                                zod
                                  .object({
                                    type: zod
                                      .literal("non_empty_string")
                                      .default(
                                        submitAnswersResponseSurveyInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorRawValidatorTypeDefault,
                                      ),
                                  })
                                  .describe(
                                    "Validator that accepts arbitrary non-empty strings.",
                                  ),
                                zod
                                  .object({
                                    type: zod
                                      .literal("date")
                                      .default(
                                        submitAnswersResponseSurveyInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorRawValidatorTypeDefaultOne,
                                      ),
                                  })
                                  .describe(
                                    "Validator that accepts arbitrary dates.",
                                  ),
                                zod
                                  .object({
                                    type: zod
                                      .literal("coded_choice")
                                      .default(
                                        submitAnswersResponseSurveyInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorRawValidatorTypeDefaultTwo,
                                      ),
                                    options: zod.array(
                                      zod
                                        .object({
                                          code: zod.string(),
                                          display: zod.string(),
                                        })
                                        .describe(
                                          "An option from a list of choices.",
                                        ),
                                    ),
                                  })
                                  .describe(
                                    "Validator that accepts any option from a list of choices.",
                                  ),
                                zod
                                  .object({
                                    type: zod
                                      .literal("phone_number")
                                      .default(
                                        submitAnswersResponseSurveyInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorRawValidatorTypeDefaultThree,
                                      ),
                                  })
                                  .describe(
                                    "Validator that accepts arbitrary phone numbers.",
                                  ),
                                zod
                                  .object({
                                    type: zod
                                      .literal("email")
                                      .default(
                                        submitAnswersResponseSurveyInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorRawValidatorTypeDefaultFour,
                                      ),
                                  })
                                  .describe(
                                    "Validator that accepts arbitrary emails.",
                                  ),
                                zod
                                  .object({
                                    type: zod
                                      .literal("city_state_zip")
                                      .default(
                                        submitAnswersResponseSurveyInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorRawValidatorTypeDefaultFive,
                                      ),
                                  })
                                  .describe(
                                    "Validator that accepts city, state, and ZIP code combinations.",
                                  ),
                                zod.unknown(),
                                zod.unknown(),
                              ]),
                            })
                            .describe("Validator that accepts lists of items."),
                        ]),
                      })
                      .describe("Validator that accepts optional fields."),
                    zod
                      .object({
                        type: zod
                          .literal("list")
                          .default(
                            submitAnswersResponseSurveyInstrumentSessionFormDefinitionFieldsItemValidatorTypeDefaultSeven,
                          ),
                        raw_validator: zod.union([
                          zod
                            .object({
                              type: zod
                                .literal("non_empty_string")
                                .default(
                                  submitAnswersResponseSurveyInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorTypeDefaultSeven,
                                ),
                            })
                            .describe(
                              "Validator that accepts arbitrary non-empty strings.",
                            ),
                          zod
                            .object({
                              type: zod
                                .literal("date")
                                .default(
                                  submitAnswersResponseSurveyInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorTypeDefaultEight,
                                ),
                            })
                            .describe(
                              "Validator that accepts arbitrary dates.",
                            ),
                          zod
                            .object({
                              type: zod
                                .literal("coded_choice")
                                .default(
                                  submitAnswersResponseSurveyInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorTypeDefaultNine,
                                ),
                              options: zod.array(
                                zod
                                  .object({
                                    code: zod.string(),
                                    display: zod.string(),
                                  })
                                  .describe(
                                    "An option from a list of choices.",
                                  ),
                              ),
                            })
                            .describe(
                              "Validator that accepts any option from a list of choices.",
                            ),
                          zod
                            .object({
                              type: zod
                                .literal("phone_number")
                                .default(
                                  submitAnswersResponseSurveyInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorTypeDefaultOnezero,
                                ),
                            })
                            .describe(
                              "Validator that accepts arbitrary phone numbers.",
                            ),
                          zod
                            .object({
                              type: zod
                                .literal("email")
                                .default(
                                  submitAnswersResponseSurveyInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorTypeDefaultOneone,
                                ),
                            })
                            .describe(
                              "Validator that accepts arbitrary emails.",
                            ),
                          zod
                            .object({
                              type: zod
                                .literal("city_state_zip")
                                .default(
                                  submitAnswersResponseSurveyInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorTypeDefaultOnetwo,
                                ),
                            })
                            .describe(
                              "Validator that accepts city, state, and ZIP code combinations.",
                            ),
                          zod
                            .object({
                              type: zod
                                .literal("optional")
                                .default(
                                  submitAnswersResponseSurveyInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorTypeDefaultOnethree,
                                ),
                              raw_validator: zod.union([
                                zod
                                  .object({
                                    type: zod
                                      .literal("non_empty_string")
                                      .default(
                                        submitAnswersResponseSurveyInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorRawValidatorTypeDefaultSix,
                                      ),
                                  })
                                  .describe(
                                    "Validator that accepts arbitrary non-empty strings.",
                                  ),
                                zod
                                  .object({
                                    type: zod
                                      .literal("date")
                                      .default(
                                        submitAnswersResponseSurveyInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorRawValidatorTypeDefaultSeven,
                                      ),
                                  })
                                  .describe(
                                    "Validator that accepts arbitrary dates.",
                                  ),
                                zod
                                  .object({
                                    type: zod
                                      .literal("coded_choice")
                                      .default(
                                        submitAnswersResponseSurveyInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorRawValidatorTypeDefaultEight,
                                      ),
                                    options: zod.array(
                                      zod
                                        .object({
                                          code: zod.string(),
                                          display: zod.string(),
                                        })
                                        .describe(
                                          "An option from a list of choices.",
                                        ),
                                    ),
                                  })
                                  .describe(
                                    "Validator that accepts any option from a list of choices.",
                                  ),
                                zod
                                  .object({
                                    type: zod
                                      .literal("phone_number")
                                      .default(
                                        submitAnswersResponseSurveyInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorRawValidatorTypeDefaultNine,
                                      ),
                                  })
                                  .describe(
                                    "Validator that accepts arbitrary phone numbers.",
                                  ),
                                zod
                                  .object({
                                    type: zod
                                      .literal("email")
                                      .default(
                                        submitAnswersResponseSurveyInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorRawValidatorTypeDefaultOnezero,
                                      ),
                                  })
                                  .describe(
                                    "Validator that accepts arbitrary emails.",
                                  ),
                                zod
                                  .object({
                                    type: zod
                                      .literal("city_state_zip")
                                      .default(
                                        submitAnswersResponseSurveyInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorRawValidatorTypeDefaultOneone,
                                      ),
                                  })
                                  .describe(
                                    "Validator that accepts city, state, and ZIP code combinations.",
                                  ),
                                zod.unknown(),
                                zod.unknown(),
                              ]),
                            })
                            .describe(
                              "Validator that accepts optional fields.",
                            ),
                          zod.unknown(),
                        ]),
                      })
                      .describe("Validator that accepts lists of items."),
                  ]),
                }),
              ),
            }),
            submissions: zod.object({
              submissions: zod.record(
                zod.string(),
                zod.union([
                  zod.object({
                    type: zod
                      .literal("string")
                      .default(
                        submitAnswersResponseSurveyInstrumentSessionSubmissionsSubmissionsTypeDefault,
                      ),
                    value: zod.string(),
                  }),
                  zod.object({
                    type: zod
                      .literal("int")
                      .default(
                        submitAnswersResponseSurveyInstrumentSessionSubmissionsSubmissionsTypeDefaultOne,
                      ),
                    value: zod.number(),
                  }),
                  zod.object({
                    type: zod
                      .literal("simple_address")
                      .default(
                        submitAnswersResponseSurveyInstrumentSessionSubmissionsSubmissionsTypeDefaultTwo,
                      ),
                    street_address: zod.string(),
                    city_state_zip: zod.string(),
                  }),
                  zod.object({
                    type: zod
                      .literal("list")
                      .default(
                        submitAnswersResponseSurveyInstrumentSessionSubmissionsSubmissionsTypeDefaultThree,
                      ),
                    values: zod.array(
                      zod.union([
                        zod.object({
                          type: zod
                            .literal("string")
                            .default(
                              submitAnswersResponseSurveyInstrumentSessionSubmissionsSubmissionsValuesItemTypeDefault,
                            ),
                          value: zod.string(),
                        }),
                        zod.object({
                          type: zod
                            .literal("int")
                            .default(
                              submitAnswersResponseSurveyInstrumentSessionSubmissionsSubmissionsValuesItemTypeDefaultOne,
                            ),
                          value: zod.number(),
                        }),
                        zod.object({
                          type: zod
                            .literal("simple_address")
                            .default(
                              submitAnswersResponseSurveyInstrumentSessionSubmissionsSubmissionsValuesItemTypeDefaultTwo,
                            ),
                          street_address: zod.string(),
                          city_state_zip: zod.string(),
                        }),
                        zod.unknown(),
                      ]),
                    ),
                  }),
                ]),
              ),
            }),
            problems: zod.record(zod.string(), zod.string()),
            interpretation: zod.union([
              zod.object({
                type: zod.enum(["complete", "incomplete", "error"]),
                text: zod.string(),
              }),
              zod.null(),
            ]),
          })
          .describe(
            'An \"instrument session\" links the immediate state of a form with an instrumnet,\nwhich\n\nThis captures the instrument type, its form definition, and the user\'s\ncurrent submissions so that follow-ups can be processed without needing\nto look up the instrument again.',
          ),
        created_at: zod.iso.datetime({}),
        updated_at: zod.iso.datetime({}),
        completed_at: zod.union([zod.iso.datetime({}), zod.null()]),
      })
      .describe(
        "Persisted instrument survey record.\n\nEach row represents one survey instance for one patient. The embedded\n``instrument_session`` carries the form definition, submissions, and\ninterpretation. Instrument-specific construction data (e.g. review\nrows for PHR data quality) lives in ``instrument_params`` so the\ninstrument can be reconstructed without the global registry.",
      ),
  }),
  zod.object({
    type: zod.literal("not_found").default(submitAnswersResponseTypeDefaultOne),
  }),
  zod.object({
    type: zod
      .literal("bad_status")
      .default(submitAnswersResponseTypeDefaultTwo),
    current_status: zod.enum(["open", "completed", "archived"]),
    details: zod.string(),
  }),
]);

/**
 * @summary Archive Survey
 */
export const archiveSurveyParams = zod.object({
  survey_id: zod.uuid(),
});

export const archiveSurveyResponseTypeDefault = "success";
export const archiveSurveyResponseTypeDefaultOne = "not_found";
export const archiveSurveyResponseTypeDefaultTwo = "bad_status";

export const archiveSurveyResponse = zod.union([
  zod.object({
    type: zod.literal("success").default(archiveSurveyResponseTypeDefault),
  }),
  zod.object({
    type: zod.literal("not_found").default(archiveSurveyResponseTypeDefaultOne),
  }),
  zod.object({
    type: zod
      .literal("bad_status")
      .default(archiveSurveyResponseTypeDefaultTwo),
    current_status: zod.enum(["open", "completed", "archived"]),
    details: zod.string(),
  }),
]);

/**
 * @summary Create Own Phr Survey
 */
export const createOwnPhrSurveyResponseTypeDefault = "success";
export const createOwnPhrSurveyResponseSurveyInstrumentSessionFormDefinitionFieldsItemSuggestedSubmissionTypeDefault =
  "string";
export const createOwnPhrSurveyResponseSurveyInstrumentSessionFormDefinitionFieldsItemSuggestedSubmissionTypeDefaultOne =
  "int";
export const createOwnPhrSurveyResponseSurveyInstrumentSessionFormDefinitionFieldsItemSuggestedSubmissionTypeDefaultTwo =
  "simple_address";
export const createOwnPhrSurveyResponseSurveyInstrumentSessionFormDefinitionFieldsItemSuggestedSubmissionTypeDefaultThree =
  "list";
export const createOwnPhrSurveyResponseSurveyInstrumentSessionFormDefinitionFieldsItemSuggestedSubmissionValuesItemTypeDefault =
  "string";
export const createOwnPhrSurveyResponseSurveyInstrumentSessionFormDefinitionFieldsItemSuggestedSubmissionValuesItemTypeDefaultOne =
  "int";
export const createOwnPhrSurveyResponseSurveyInstrumentSessionFormDefinitionFieldsItemSuggestedSubmissionValuesItemTypeDefaultTwo =
  "simple_address";
export const createOwnPhrSurveyResponseSurveyInstrumentSessionFormDefinitionFieldsItemDefaultSubmissionTypeDefault =
  "string";
export const createOwnPhrSurveyResponseSurveyInstrumentSessionFormDefinitionFieldsItemDefaultSubmissionTypeDefaultOne =
  "int";
export const createOwnPhrSurveyResponseSurveyInstrumentSessionFormDefinitionFieldsItemDefaultSubmissionTypeDefaultTwo =
  "simple_address";
export const createOwnPhrSurveyResponseSurveyInstrumentSessionFormDefinitionFieldsItemDefaultSubmissionTypeDefaultThree =
  "list";
export const createOwnPhrSurveyResponseSurveyInstrumentSessionFormDefinitionFieldsItemDefaultSubmissionValuesItemTypeDefault =
  "string";
export const createOwnPhrSurveyResponseSurveyInstrumentSessionFormDefinitionFieldsItemDefaultSubmissionValuesItemTypeDefaultOne =
  "int";
export const createOwnPhrSurveyResponseSurveyInstrumentSessionFormDefinitionFieldsItemDefaultSubmissionValuesItemTypeDefaultTwo =
  "simple_address";
export const createOwnPhrSurveyResponseSurveyInstrumentSessionFormDefinitionFieldsItemValidatorTypeDefault =
  "non_empty_string";
export const createOwnPhrSurveyResponseSurveyInstrumentSessionFormDefinitionFieldsItemValidatorTypeDefaultOne =
  "date";
export const createOwnPhrSurveyResponseSurveyInstrumentSessionFormDefinitionFieldsItemValidatorTypeDefaultTwo =
  "coded_choice";
export const createOwnPhrSurveyResponseSurveyInstrumentSessionFormDefinitionFieldsItemValidatorTypeDefaultThree =
  "phone_number";
export const createOwnPhrSurveyResponseSurveyInstrumentSessionFormDefinitionFieldsItemValidatorTypeDefaultFour =
  "email";
export const createOwnPhrSurveyResponseSurveyInstrumentSessionFormDefinitionFieldsItemValidatorTypeDefaultFive =
  "city_state_zip";
export const createOwnPhrSurveyResponseSurveyInstrumentSessionFormDefinitionFieldsItemValidatorTypeDefaultSix =
  "optional";
export const createOwnPhrSurveyResponseSurveyInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorTypeDefault =
  "non_empty_string";
export const createOwnPhrSurveyResponseSurveyInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorTypeDefaultOne =
  "date";
export const createOwnPhrSurveyResponseSurveyInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorTypeDefaultTwo =
  "coded_choice";
export const createOwnPhrSurveyResponseSurveyInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorTypeDefaultThree =
  "phone_number";
export const createOwnPhrSurveyResponseSurveyInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorTypeDefaultFour =
  "email";
export const createOwnPhrSurveyResponseSurveyInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorTypeDefaultFive =
  "city_state_zip";
export const createOwnPhrSurveyResponseSurveyInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorTypeDefaultSix =
  "list";
export const createOwnPhrSurveyResponseSurveyInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorRawValidatorTypeDefault =
  "non_empty_string";
export const createOwnPhrSurveyResponseSurveyInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorRawValidatorTypeDefaultOne =
  "date";
export const createOwnPhrSurveyResponseSurveyInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorRawValidatorTypeDefaultTwo =
  "coded_choice";
export const createOwnPhrSurveyResponseSurveyInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorRawValidatorTypeDefaultThree =
  "phone_number";
export const createOwnPhrSurveyResponseSurveyInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorRawValidatorTypeDefaultFour =
  "email";
export const createOwnPhrSurveyResponseSurveyInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorRawValidatorTypeDefaultFive =
  "city_state_zip";
export const createOwnPhrSurveyResponseSurveyInstrumentSessionFormDefinitionFieldsItemValidatorTypeDefaultSeven =
  "list";
export const createOwnPhrSurveyResponseSurveyInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorTypeDefaultSeven =
  "non_empty_string";
export const createOwnPhrSurveyResponseSurveyInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorTypeDefaultEight =
  "date";
export const createOwnPhrSurveyResponseSurveyInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorTypeDefaultNine =
  "coded_choice";
export const createOwnPhrSurveyResponseSurveyInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorTypeDefaultOnezero =
  "phone_number";
export const createOwnPhrSurveyResponseSurveyInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorTypeDefaultOneone =
  "email";
export const createOwnPhrSurveyResponseSurveyInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorTypeDefaultOnetwo =
  "city_state_zip";
export const createOwnPhrSurveyResponseSurveyInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorTypeDefaultOnethree =
  "optional";
export const createOwnPhrSurveyResponseSurveyInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorRawValidatorTypeDefaultSix =
  "non_empty_string";
export const createOwnPhrSurveyResponseSurveyInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorRawValidatorTypeDefaultSeven =
  "date";
export const createOwnPhrSurveyResponseSurveyInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorRawValidatorTypeDefaultEight =
  "coded_choice";
export const createOwnPhrSurveyResponseSurveyInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorRawValidatorTypeDefaultNine =
  "phone_number";
export const createOwnPhrSurveyResponseSurveyInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorRawValidatorTypeDefaultOnezero =
  "email";
export const createOwnPhrSurveyResponseSurveyInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorRawValidatorTypeDefaultOneone =
  "city_state_zip";
export const createOwnPhrSurveyResponseSurveyInstrumentSessionSubmissionsSubmissionsTypeDefault =
  "string";
export const createOwnPhrSurveyResponseSurveyInstrumentSessionSubmissionsSubmissionsTypeDefaultOne =
  "int";
export const createOwnPhrSurveyResponseSurveyInstrumentSessionSubmissionsSubmissionsTypeDefaultTwo =
  "simple_address";
export const createOwnPhrSurveyResponseSurveyInstrumentSessionSubmissionsSubmissionsTypeDefaultThree =
  "list";
export const createOwnPhrSurveyResponseSurveyInstrumentSessionSubmissionsSubmissionsValuesItemTypeDefault =
  "string";
export const createOwnPhrSurveyResponseSurveyInstrumentSessionSubmissionsSubmissionsValuesItemTypeDefaultOne =
  "int";
export const createOwnPhrSurveyResponseSurveyInstrumentSessionSubmissionsSubmissionsValuesItemTypeDefaultTwo =
  "simple_address";
export const createOwnPhrSurveyResponseTypeDefaultOne = "bad_instrument";
export const createOwnPhrSurveyResponseTypeDefaultTwo = "no_data";

export const createOwnPhrSurveyResponse = zod.union([
  zod.object({
    type: zod.literal("success").default(createOwnPhrSurveyResponseTypeDefault),
    survey: zod
      .object({
        survey_id: zod.uuid(),
        user_id: zod.uuid(),
        instrument_id: zod.string(),
        status: zod.enum(["open", "completed", "archived"]),
        instrument_params: zod.union([
          zod.record(zod.string(), zod.unknown()),
          zod.null(),
        ]),
        instrument_session: zod
          .object({
            instrument_id: zod.string(),
            form_definition: zod.object({
              fields: zod.array(
                zod.object({
                  id: zod.string(),
                  profile: zod.object({
                    name: zod.string(),
                    description: zod
                      .union([zod.string(), zod.null()])
                      .optional(),
                  }),
                  suggested_submission: zod
                    .union([
                      zod.union([
                        zod.object({
                          type: zod
                            .literal("string")
                            .default(
                              createOwnPhrSurveyResponseSurveyInstrumentSessionFormDefinitionFieldsItemSuggestedSubmissionTypeDefault,
                            ),
                          value: zod.string(),
                        }),
                        zod.object({
                          type: zod
                            .literal("int")
                            .default(
                              createOwnPhrSurveyResponseSurveyInstrumentSessionFormDefinitionFieldsItemSuggestedSubmissionTypeDefaultOne,
                            ),
                          value: zod.number(),
                        }),
                        zod.object({
                          type: zod
                            .literal("simple_address")
                            .default(
                              createOwnPhrSurveyResponseSurveyInstrumentSessionFormDefinitionFieldsItemSuggestedSubmissionTypeDefaultTwo,
                            ),
                          street_address: zod.string(),
                          city_state_zip: zod.string(),
                        }),
                        zod.object({
                          type: zod
                            .literal("list")
                            .default(
                              createOwnPhrSurveyResponseSurveyInstrumentSessionFormDefinitionFieldsItemSuggestedSubmissionTypeDefaultThree,
                            ),
                          values: zod.array(
                            zod.union([
                              zod.object({
                                type: zod
                                  .literal("string")
                                  .default(
                                    createOwnPhrSurveyResponseSurveyInstrumentSessionFormDefinitionFieldsItemSuggestedSubmissionValuesItemTypeDefault,
                                  ),
                                value: zod.string(),
                              }),
                              zod.object({
                                type: zod
                                  .literal("int")
                                  .default(
                                    createOwnPhrSurveyResponseSurveyInstrumentSessionFormDefinitionFieldsItemSuggestedSubmissionValuesItemTypeDefaultOne,
                                  ),
                                value: zod.number(),
                              }),
                              zod.object({
                                type: zod
                                  .literal("simple_address")
                                  .default(
                                    createOwnPhrSurveyResponseSurveyInstrumentSessionFormDefinitionFieldsItemSuggestedSubmissionValuesItemTypeDefaultTwo,
                                  ),
                                street_address: zod.string(),
                                city_state_zip: zod.string(),
                              }),
                              zod.unknown(),
                            ]),
                          ),
                        }),
                      ]),
                      zod.null(),
                    ])
                    .optional(),
                  default_submission: zod
                    .union([
                      zod.union([
                        zod.object({
                          type: zod
                            .literal("string")
                            .default(
                              createOwnPhrSurveyResponseSurveyInstrumentSessionFormDefinitionFieldsItemDefaultSubmissionTypeDefault,
                            ),
                          value: zod.string(),
                        }),
                        zod.object({
                          type: zod
                            .literal("int")
                            .default(
                              createOwnPhrSurveyResponseSurveyInstrumentSessionFormDefinitionFieldsItemDefaultSubmissionTypeDefaultOne,
                            ),
                          value: zod.number(),
                        }),
                        zod.object({
                          type: zod
                            .literal("simple_address")
                            .default(
                              createOwnPhrSurveyResponseSurveyInstrumentSessionFormDefinitionFieldsItemDefaultSubmissionTypeDefaultTwo,
                            ),
                          street_address: zod.string(),
                          city_state_zip: zod.string(),
                        }),
                        zod.object({
                          type: zod
                            .literal("list")
                            .default(
                              createOwnPhrSurveyResponseSurveyInstrumentSessionFormDefinitionFieldsItemDefaultSubmissionTypeDefaultThree,
                            ),
                          values: zod.array(
                            zod.union([
                              zod.object({
                                type: zod
                                  .literal("string")
                                  .default(
                                    createOwnPhrSurveyResponseSurveyInstrumentSessionFormDefinitionFieldsItemDefaultSubmissionValuesItemTypeDefault,
                                  ),
                                value: zod.string(),
                              }),
                              zod.object({
                                type: zod
                                  .literal("int")
                                  .default(
                                    createOwnPhrSurveyResponseSurveyInstrumentSessionFormDefinitionFieldsItemDefaultSubmissionValuesItemTypeDefaultOne,
                                  ),
                                value: zod.number(),
                              }),
                              zod.object({
                                type: zod
                                  .literal("simple_address")
                                  .default(
                                    createOwnPhrSurveyResponseSurveyInstrumentSessionFormDefinitionFieldsItemDefaultSubmissionValuesItemTypeDefaultTwo,
                                  ),
                                street_address: zod.string(),
                                city_state_zip: zod.string(),
                              }),
                              zod.unknown(),
                            ]),
                          ),
                        }),
                      ]),
                      zod.null(),
                    ])
                    .optional(),
                  validator: zod.union([
                    zod
                      .object({
                        type: zod
                          .literal("non_empty_string")
                          .default(
                            createOwnPhrSurveyResponseSurveyInstrumentSessionFormDefinitionFieldsItemValidatorTypeDefault,
                          ),
                      })
                      .describe(
                        "Validator that accepts arbitrary non-empty strings.",
                      ),
                    zod
                      .object({
                        type: zod
                          .literal("date")
                          .default(
                            createOwnPhrSurveyResponseSurveyInstrumentSessionFormDefinitionFieldsItemValidatorTypeDefaultOne,
                          ),
                      })
                      .describe("Validator that accepts arbitrary dates."),
                    zod
                      .object({
                        type: zod
                          .literal("coded_choice")
                          .default(
                            createOwnPhrSurveyResponseSurveyInstrumentSessionFormDefinitionFieldsItemValidatorTypeDefaultTwo,
                          ),
                        options: zod.array(
                          zod
                            .object({
                              code: zod.string(),
                              display: zod.string(),
                            })
                            .describe("An option from a list of choices."),
                        ),
                      })
                      .describe(
                        "Validator that accepts any option from a list of choices.",
                      ),
                    zod
                      .object({
                        type: zod
                          .literal("phone_number")
                          .default(
                            createOwnPhrSurveyResponseSurveyInstrumentSessionFormDefinitionFieldsItemValidatorTypeDefaultThree,
                          ),
                      })
                      .describe(
                        "Validator that accepts arbitrary phone numbers.",
                      ),
                    zod
                      .object({
                        type: zod
                          .literal("email")
                          .default(
                            createOwnPhrSurveyResponseSurveyInstrumentSessionFormDefinitionFieldsItemValidatorTypeDefaultFour,
                          ),
                      })
                      .describe("Validator that accepts arbitrary emails."),
                    zod
                      .object({
                        type: zod
                          .literal("city_state_zip")
                          .default(
                            createOwnPhrSurveyResponseSurveyInstrumentSessionFormDefinitionFieldsItemValidatorTypeDefaultFive,
                          ),
                      })
                      .describe(
                        "Validator that accepts city, state, and ZIP code combinations.",
                      ),
                    zod
                      .object({
                        type: zod
                          .literal("optional")
                          .default(
                            createOwnPhrSurveyResponseSurveyInstrumentSessionFormDefinitionFieldsItemValidatorTypeDefaultSix,
                          ),
                        raw_validator: zod.union([
                          zod
                            .object({
                              type: zod
                                .literal("non_empty_string")
                                .default(
                                  createOwnPhrSurveyResponseSurveyInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorTypeDefault,
                                ),
                            })
                            .describe(
                              "Validator that accepts arbitrary non-empty strings.",
                            ),
                          zod
                            .object({
                              type: zod
                                .literal("date")
                                .default(
                                  createOwnPhrSurveyResponseSurveyInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorTypeDefaultOne,
                                ),
                            })
                            .describe(
                              "Validator that accepts arbitrary dates.",
                            ),
                          zod
                            .object({
                              type: zod
                                .literal("coded_choice")
                                .default(
                                  createOwnPhrSurveyResponseSurveyInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorTypeDefaultTwo,
                                ),
                              options: zod.array(
                                zod
                                  .object({
                                    code: zod.string(),
                                    display: zod.string(),
                                  })
                                  .describe(
                                    "An option from a list of choices.",
                                  ),
                              ),
                            })
                            .describe(
                              "Validator that accepts any option from a list of choices.",
                            ),
                          zod
                            .object({
                              type: zod
                                .literal("phone_number")
                                .default(
                                  createOwnPhrSurveyResponseSurveyInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorTypeDefaultThree,
                                ),
                            })
                            .describe(
                              "Validator that accepts arbitrary phone numbers.",
                            ),
                          zod
                            .object({
                              type: zod
                                .literal("email")
                                .default(
                                  createOwnPhrSurveyResponseSurveyInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorTypeDefaultFour,
                                ),
                            })
                            .describe(
                              "Validator that accepts arbitrary emails.",
                            ),
                          zod
                            .object({
                              type: zod
                                .literal("city_state_zip")
                                .default(
                                  createOwnPhrSurveyResponseSurveyInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorTypeDefaultFive,
                                ),
                            })
                            .describe(
                              "Validator that accepts city, state, and ZIP code combinations.",
                            ),
                          zod.unknown(),
                          zod
                            .object({
                              type: zod
                                .literal("list")
                                .default(
                                  createOwnPhrSurveyResponseSurveyInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorTypeDefaultSix,
                                ),
                              raw_validator: zod.union([
                                zod
                                  .object({
                                    type: zod
                                      .literal("non_empty_string")
                                      .default(
                                        createOwnPhrSurveyResponseSurveyInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorRawValidatorTypeDefault,
                                      ),
                                  })
                                  .describe(
                                    "Validator that accepts arbitrary non-empty strings.",
                                  ),
                                zod
                                  .object({
                                    type: zod
                                      .literal("date")
                                      .default(
                                        createOwnPhrSurveyResponseSurveyInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorRawValidatorTypeDefaultOne,
                                      ),
                                  })
                                  .describe(
                                    "Validator that accepts arbitrary dates.",
                                  ),
                                zod
                                  .object({
                                    type: zod
                                      .literal("coded_choice")
                                      .default(
                                        createOwnPhrSurveyResponseSurveyInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorRawValidatorTypeDefaultTwo,
                                      ),
                                    options: zod.array(
                                      zod
                                        .object({
                                          code: zod.string(),
                                          display: zod.string(),
                                        })
                                        .describe(
                                          "An option from a list of choices.",
                                        ),
                                    ),
                                  })
                                  .describe(
                                    "Validator that accepts any option from a list of choices.",
                                  ),
                                zod
                                  .object({
                                    type: zod
                                      .literal("phone_number")
                                      .default(
                                        createOwnPhrSurveyResponseSurveyInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorRawValidatorTypeDefaultThree,
                                      ),
                                  })
                                  .describe(
                                    "Validator that accepts arbitrary phone numbers.",
                                  ),
                                zod
                                  .object({
                                    type: zod
                                      .literal("email")
                                      .default(
                                        createOwnPhrSurveyResponseSurveyInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorRawValidatorTypeDefaultFour,
                                      ),
                                  })
                                  .describe(
                                    "Validator that accepts arbitrary emails.",
                                  ),
                                zod
                                  .object({
                                    type: zod
                                      .literal("city_state_zip")
                                      .default(
                                        createOwnPhrSurveyResponseSurveyInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorRawValidatorTypeDefaultFive,
                                      ),
                                  })
                                  .describe(
                                    "Validator that accepts city, state, and ZIP code combinations.",
                                  ),
                                zod.unknown(),
                                zod.unknown(),
                              ]),
                            })
                            .describe("Validator that accepts lists of items."),
                        ]),
                      })
                      .describe("Validator that accepts optional fields."),
                    zod
                      .object({
                        type: zod
                          .literal("list")
                          .default(
                            createOwnPhrSurveyResponseSurveyInstrumentSessionFormDefinitionFieldsItemValidatorTypeDefaultSeven,
                          ),
                        raw_validator: zod.union([
                          zod
                            .object({
                              type: zod
                                .literal("non_empty_string")
                                .default(
                                  createOwnPhrSurveyResponseSurveyInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorTypeDefaultSeven,
                                ),
                            })
                            .describe(
                              "Validator that accepts arbitrary non-empty strings.",
                            ),
                          zod
                            .object({
                              type: zod
                                .literal("date")
                                .default(
                                  createOwnPhrSurveyResponseSurveyInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorTypeDefaultEight,
                                ),
                            })
                            .describe(
                              "Validator that accepts arbitrary dates.",
                            ),
                          zod
                            .object({
                              type: zod
                                .literal("coded_choice")
                                .default(
                                  createOwnPhrSurveyResponseSurveyInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorTypeDefaultNine,
                                ),
                              options: zod.array(
                                zod
                                  .object({
                                    code: zod.string(),
                                    display: zod.string(),
                                  })
                                  .describe(
                                    "An option from a list of choices.",
                                  ),
                              ),
                            })
                            .describe(
                              "Validator that accepts any option from a list of choices.",
                            ),
                          zod
                            .object({
                              type: zod
                                .literal("phone_number")
                                .default(
                                  createOwnPhrSurveyResponseSurveyInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorTypeDefaultOnezero,
                                ),
                            })
                            .describe(
                              "Validator that accepts arbitrary phone numbers.",
                            ),
                          zod
                            .object({
                              type: zod
                                .literal("email")
                                .default(
                                  createOwnPhrSurveyResponseSurveyInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorTypeDefaultOneone,
                                ),
                            })
                            .describe(
                              "Validator that accepts arbitrary emails.",
                            ),
                          zod
                            .object({
                              type: zod
                                .literal("city_state_zip")
                                .default(
                                  createOwnPhrSurveyResponseSurveyInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorTypeDefaultOnetwo,
                                ),
                            })
                            .describe(
                              "Validator that accepts city, state, and ZIP code combinations.",
                            ),
                          zod
                            .object({
                              type: zod
                                .literal("optional")
                                .default(
                                  createOwnPhrSurveyResponseSurveyInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorTypeDefaultOnethree,
                                ),
                              raw_validator: zod.union([
                                zod
                                  .object({
                                    type: zod
                                      .literal("non_empty_string")
                                      .default(
                                        createOwnPhrSurveyResponseSurveyInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorRawValidatorTypeDefaultSix,
                                      ),
                                  })
                                  .describe(
                                    "Validator that accepts arbitrary non-empty strings.",
                                  ),
                                zod
                                  .object({
                                    type: zod
                                      .literal("date")
                                      .default(
                                        createOwnPhrSurveyResponseSurveyInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorRawValidatorTypeDefaultSeven,
                                      ),
                                  })
                                  .describe(
                                    "Validator that accepts arbitrary dates.",
                                  ),
                                zod
                                  .object({
                                    type: zod
                                      .literal("coded_choice")
                                      .default(
                                        createOwnPhrSurveyResponseSurveyInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorRawValidatorTypeDefaultEight,
                                      ),
                                    options: zod.array(
                                      zod
                                        .object({
                                          code: zod.string(),
                                          display: zod.string(),
                                        })
                                        .describe(
                                          "An option from a list of choices.",
                                        ),
                                    ),
                                  })
                                  .describe(
                                    "Validator that accepts any option from a list of choices.",
                                  ),
                                zod
                                  .object({
                                    type: zod
                                      .literal("phone_number")
                                      .default(
                                        createOwnPhrSurveyResponseSurveyInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorRawValidatorTypeDefaultNine,
                                      ),
                                  })
                                  .describe(
                                    "Validator that accepts arbitrary phone numbers.",
                                  ),
                                zod
                                  .object({
                                    type: zod
                                      .literal("email")
                                      .default(
                                        createOwnPhrSurveyResponseSurveyInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorRawValidatorTypeDefaultOnezero,
                                      ),
                                  })
                                  .describe(
                                    "Validator that accepts arbitrary emails.",
                                  ),
                                zod
                                  .object({
                                    type: zod
                                      .literal("city_state_zip")
                                      .default(
                                        createOwnPhrSurveyResponseSurveyInstrumentSessionFormDefinitionFieldsItemValidatorRawValidatorRawValidatorTypeDefaultOneone,
                                      ),
                                  })
                                  .describe(
                                    "Validator that accepts city, state, and ZIP code combinations.",
                                  ),
                                zod.unknown(),
                                zod.unknown(),
                              ]),
                            })
                            .describe(
                              "Validator that accepts optional fields.",
                            ),
                          zod.unknown(),
                        ]),
                      })
                      .describe("Validator that accepts lists of items."),
                  ]),
                }),
              ),
            }),
            submissions: zod.object({
              submissions: zod.record(
                zod.string(),
                zod.union([
                  zod.object({
                    type: zod
                      .literal("string")
                      .default(
                        createOwnPhrSurveyResponseSurveyInstrumentSessionSubmissionsSubmissionsTypeDefault,
                      ),
                    value: zod.string(),
                  }),
                  zod.object({
                    type: zod
                      .literal("int")
                      .default(
                        createOwnPhrSurveyResponseSurveyInstrumentSessionSubmissionsSubmissionsTypeDefaultOne,
                      ),
                    value: zod.number(),
                  }),
                  zod.object({
                    type: zod
                      .literal("simple_address")
                      .default(
                        createOwnPhrSurveyResponseSurveyInstrumentSessionSubmissionsSubmissionsTypeDefaultTwo,
                      ),
                    street_address: zod.string(),
                    city_state_zip: zod.string(),
                  }),
                  zod.object({
                    type: zod
                      .literal("list")
                      .default(
                        createOwnPhrSurveyResponseSurveyInstrumentSessionSubmissionsSubmissionsTypeDefaultThree,
                      ),
                    values: zod.array(
                      zod.union([
                        zod.object({
                          type: zod
                            .literal("string")
                            .default(
                              createOwnPhrSurveyResponseSurveyInstrumentSessionSubmissionsSubmissionsValuesItemTypeDefault,
                            ),
                          value: zod.string(),
                        }),
                        zod.object({
                          type: zod
                            .literal("int")
                            .default(
                              createOwnPhrSurveyResponseSurveyInstrumentSessionSubmissionsSubmissionsValuesItemTypeDefaultOne,
                            ),
                          value: zod.number(),
                        }),
                        zod.object({
                          type: zod
                            .literal("simple_address")
                            .default(
                              createOwnPhrSurveyResponseSurveyInstrumentSessionSubmissionsSubmissionsValuesItemTypeDefaultTwo,
                            ),
                          street_address: zod.string(),
                          city_state_zip: zod.string(),
                        }),
                        zod.unknown(),
                      ]),
                    ),
                  }),
                ]),
              ),
            }),
            problems: zod.record(zod.string(), zod.string()),
            interpretation: zod.union([
              zod.object({
                type: zod.enum(["complete", "incomplete", "error"]),
                text: zod.string(),
              }),
              zod.null(),
            ]),
          })
          .describe(
            'An \"instrument session\" links the immediate state of a form with an instrumnet,\nwhich\n\nThis captures the instrument type, its form definition, and the user\'s\ncurrent submissions so that follow-ups can be processed without needing\nto look up the instrument again.',
          ),
        created_at: zod.iso.datetime({}),
        updated_at: zod.iso.datetime({}),
        completed_at: zod.union([zod.iso.datetime({}), zod.null()]),
      })
      .describe(
        "Persisted instrument survey record.\n\nEach row represents one survey instance for one patient. The embedded\n``instrument_session`` carries the form definition, submissions, and\ninterpretation. Instrument-specific construction data (e.g. review\nrows for PHR data quality) lives in ``instrument_params`` so the\ninstrument can be reconstructed without the global registry.",
      ),
    replaced_survey_id: zod.union([zod.uuid(), zod.null()]),
  }),
  zod.object({
    type: zod
      .literal("bad_instrument")
      .default(createOwnPhrSurveyResponseTypeDefaultOne),
    instrument_id: zod.string(),
  }),
  zod.object({
    type: zod
      .literal("no_data")
      .default(createOwnPhrSurveyResponseTypeDefaultTwo),
  }),
]);

/**
 * Fetch all available search sources for testing.
 * @summary Fetch Available Sources
 */
export const fetchAvailableSourcesResponse = zod
  .object({
    sources: zod.array(
      zod
        .object({
          id: zod.string(),
          name: zod.string(),
          description: zod.string(),
        })
        .describe("Information about an available search source."),
    ),
  })
  .describe("Response containing available search sources.");

/**
 * Perform a search across selected sources.
 * @summary Perform Search
 */
export const performSearchBody = zod
  .object({
    query: zod.string(),
    sources: zod.array(zod.string()),
    topK: zod.number(),
  })
  .describe("Request to perform a unified search.");

export const performSearchResponse = zod
  .object({
    query: zod.string(),
    items: zod.array(
      zod
        .object({
          source: zod.string(),
          title: zod.string(),
          subtitle: zod.union([zod.string(), zod.null()]),
          content: zod.string(),
          url: zod.string(),
          lastUpdatedAt: zod.union([zod.iso.datetime({}), zod.null()]),
        })
        .describe("A single search result item."),
    ),
    sourcesSearched: zod.array(zod.string()),
    totalResults: zod.number(),
  })
  .describe("Response from a unified search.");
